/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type SaveRecordBriefingResponse = {
  __typename: "SaveRecordBriefingResponse",
  success: boolean,
  recordBriefingId: string,
  publishedAt?: string | null,
  error?: string | null,
};

export type ResetRecordBriefingResponse = {
  __typename: "ResetRecordBriefingResponse",
  success: boolean,
  recordBriefingId: string,
  error?: string | null,
};

export type BatchUpdateRecordBriefingMappingsResponse = {
  __typename: "BatchUpdateRecordBriefingMappingsResponse",
  success: boolean,
  error?: string | null,
  succeededIds: Array< string >,
  failedIds: Array< string >,
};

export type CreateAppointmentFileReferenceInput = {
  id?: string | null,
  appointmentID: string,
  uploadedFileID: string,
  status?: AppointmentFileReferenceStatus | null,
};

export enum AppointmentFileReferenceStatus {
  ORIGINAL = "ORIGINAL",
  INHERITED_READ_ONLY = "INHERITED_READ_ONLY",
  INHERITED_WRITEABLE = "INHERITED_WRITEABLE",
}


export type ModelAppointmentFileReferenceConditionInput = {
  appointmentID?: ModelIDInput | null,
  uploadedFileID?: ModelIDInput | null,
  status?: ModelAppointmentFileReferenceStatusInput | null,
  and?: Array< ModelAppointmentFileReferenceConditionInput | null > | null,
  or?: Array< ModelAppointmentFileReferenceConditionInput | null > | null,
  not?: ModelAppointmentFileReferenceConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelAppointmentFileReferenceStatusInput = {
  eq?: AppointmentFileReferenceStatus | null,
  ne?: AppointmentFileReferenceStatus | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type AppointmentFileReference = {
  __typename: "AppointmentFileReference",
  id: string,
  appointmentID: string,
  uploadedFileID: string,
  status?: AppointmentFileReferenceStatus | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateAppointmentFileReferenceInput = {
  id: string,
  appointmentID?: string | null,
  uploadedFileID?: string | null,
  status?: AppointmentFileReferenceStatus | null,
};

export type DeleteAppointmentFileReferenceInput = {
  id: string,
};

export type CreateUploadedFileInput = {
  id?: string | null,
  key?: string | null,
  fileName?: string | null,
  type?: FileType | null,
  provider?: FileProvider | null,
  uploadedBy?: string | null,
  uploadedAt?: string | null,
  fileSizeBytes?: number | null,
  fileSetID?: string | null,
  sourceAppointmentID?: string | null,
};

export enum FileType {
  QME_NOTIFICATION_FORM = "QME_NOTIFICATION_FORM",
  PANEL_LIST = "PANEL_LIST",
  COVER_LETTER = "COVER_LETTER",
  COVER_LETTER_MISC = "COVER_LETTER_MISC",
  COVER_LETTER_RAW = "COVER_LETTER_RAW",
  MEDICAL_RECORD = "MEDICAL_RECORD",
  DICTATION = "DICTATION",
  DICTATION_TRANSCRIPT = "DICTATION_TRANSCRIPT",
  HISTORY_RECORDING = "HISTORY_RECORDING",
  HISTORY_TRANSCRIPT = "HISTORY_TRANSCRIPT",
  PATIENT_VISIT_FORM = "PATIENT_VISIT_FORM",
  SUB_ROSA = "SUB_ROSA",
  UNDETERMINED = "UNDETERMINED",
  CASE_INTAKE = "CASE_INTAKE",
  BILLING_RECEIPT = "BILLING_RECEIPT",
  DEMOGRAPHICS = "DEMOGRAPHICS",
  FINAL_REPORT = "FINAL_REPORT",
  DEU_100 = "DEU_100",
  DEU_101 = "DEU_101",
  PRESCRIPTION = "PRESCRIPTION",
  APPOINTMENT_NOTICE = "APPOINTMENT_NOTICE",
  RTW_VOUCHER = "RTW_VOUCHER",
  DECLARATION = "DECLARATION",
  REPORT_PACKAGE = "REPORT_PACKAGE",
  AUTHORIZATION_LETTER = "AUTHORIZATION_LETTER",
  JOB_DESCRIPTION = "JOB_DESCRIPTION",
  LATE_CANCEL_NOTICE = "LATE_CANCEL_NOTICE",
  LATE_RESCHEDULE_NOTICE = "LATE_RESCHEDULE_NOTICE",
  DEPOSITION_TRANSCRIPT = "DEPOSITION_TRANSCRIPT",
  PREVIOUS_REPORTS = "PREVIOUS_REPORTS",
}


export enum FileProvider {
  ADJUSTER = "ADJUSTER",
  APPLICANT_ATTORNEY = "APPLICANT_ATTORNEY",
  DEFENSE_ATTORNEY = "DEFENSE_ATTORNEY",
  PATIENT = "PATIENT",
  UNSPECIFIED = "UNSPECIFIED",
}


export type ModelUploadedFileConditionInput = {
  key?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  type?: ModelFileTypeInput | null,
  provider?: ModelFileProviderInput | null,
  uploadedBy?: ModelStringInput | null,
  uploadedAt?: ModelStringInput | null,
  fileSizeBytes?: ModelFloatInput | null,
  fileSetID?: ModelIDInput | null,
  sourceAppointmentID?: ModelIDInput | null,
  and?: Array< ModelUploadedFileConditionInput | null > | null,
  or?: Array< ModelUploadedFileConditionInput | null > | null,
  not?: ModelUploadedFileConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelFileTypeInput = {
  eq?: FileType | null,
  ne?: FileType | null,
};

export type ModelFileProviderInput = {
  eq?: FileProvider | null,
  ne?: FileProvider | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type UploadedFile = {
  __typename: "UploadedFile",
  id: string,
  key?: string | null,
  fileName?: string | null,
  type?: FileType | null,
  provider?: FileProvider | null,
  uploadedBy?: string | null,
  uploadedAt?: string | null,
  fileSizeBytes?: number | null,
  fileSet?: UploadedFileSet | null,
  fileSetID?: string | null,
  sourceAppointmentID?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UploadedFileSet = {
  __typename: "UploadedFileSet",
  id: string,
  appointments?: ModelAppointmentRecordConnection | null,
  uploadedFiles?: ModelUploadedFileConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelAppointmentRecordConnection = {
  __typename: "ModelAppointmentRecordConnection",
  items:  Array<AppointmentRecord | null >,
  nextToken?: string | null,
};

export type AppointmentRecord = {
  __typename: "AppointmentRecord",
  id: string,
  doctorOwnerCognitoId?: string | null,
  assistantCognitoIds?: Array< string > | null,
  globalPartitionKey: string,
  originalAppointmentID: string,
  supplementalAppointmentIDs?: Array< string | null > | null,
  supplementalSourceAppointmentIDs?: Array< string | null > | null,
  depositionAppointmentIDs?: Array< string | null > | null,
  depositionSourceAppointmentIDs?: Array< string | null > | null,
  rescheduledFromAppointmentID?: string | null,
  rescheduledToAppointmentID?: string | null,
  date?: string | null,
  yearMonth?: string | null,
  doctorYearMonth?: string | null,
  time?: string | null,
  bookedInFlexibleTime?: boolean | null,
  inquiryDate: string,
  inquiryYearMonth: string,
  type?: AppointmentType | null,
  doctorID?: string | null,
  doctor?: Doctor | null,
  locationID?: string | null,
  location?: Location | null,
  visitForm?: string | null,
  jotformSubmissions?:  Array<JotformSubmission | null > | null,
  historyTranscriptPopulations?:  Array<HistoryTranscriptPopulation | null > | null,
  active?: boolean | null,
  durationMinutes?: number | null,
  reportDue?: string | null,
  reportSubmitted?: string | null,
  status?: AppointmentStatus | null,
  reportStatus?: ReportStatus | null,
  paymentStatus?: PaymentStatus | null,
  billingStatus?: BillingStatus | null,
  difficultyLevel?: number | null,
  scheduler?: ContactPersonInfo | null,
  medicalAssistant?: MedicalAssistant | null,
  schedulingAssistant?: MedicalAssistant | null,
  onSiteOp?: MedicalAssistant | null,
  reportOp?: MedicalAssistant | null,
  billingOp?: MedicalAssistant | null,
  preVisitReviewer?: MedicalAssistant | null,
  inquirerInfo?: InquirerInfo | null,
  notes?: ModelNotesConnection | null,
  huddleNote?: HuddleNote | null,
  patientCases?: ModelAppointmentRecordPatientCaseConnection | null,
  employments?:  Array<EmploymentRecord | null > | null,
  employmentGaps?:  Array<EmploymentGapRecord | null > | null,
  patientDescribedInjuries?: Array< BodyPart | null > | null,
  uploadedFilesSet?: UploadedFileSet | null,
  uploadedFilesSetID?: string | null,
  referredBy?: string | null,
  s3FileKey?: string | null,
  medicalRecordsReceived?: boolean | null,
  medicalRecordsBriefingFileID?: string | null,
  medicalRecordsBriefingExecutionArn?: string | null,
  medicalRecordsTotalPagesProcessed?: number | null,
  reportGenerationFileID?: string | null,
  reportGenerationExecutionArn?: string | null,
  reportGenerationGeneratedAt?: string | null,
  historyOfInjuryFileID?: string | null,
  historyOfInjuryGeneratedAt?: string | null,
  evaluationFileID?: string | null,
  assessmentFileID?: string | null,
  depositionPreparationFileID?: string | null,
  documentStatus?: DocumentStatus | null,
  cancellationReason?: CancellationReason | null,
  cancellationRequestedBy?: ParticipantType | null,
  cancellationRequestedInternally?: boolean | null,
  cancellationNote?: string | null,
  cancellationDate?: string | null,
  inquiryClosingReason?: InquiryClosingReason | null,
  inquiryClosingNote?: string | null,
  inquiryClosingDate?: string | null,
  noShowReason?: NoShowReason | null,
  noShowNote?: string | null,
  reschedulingReason?: ReschedulingReason | null,
  reschedulingOthersReason?: string | null,
  reschedulingRequestedBy?: ParticipantType | null,
  reschedulingRequestedInternally?: boolean | null,
  reschedulingNote?: string | null,
  reschedulingDate?: string | null,
  interpreter?: InterpreterInfo | null,
  historyOfInjuryNotes?: Notes | null,
  currentComplaintNotes?: Notes | null,
  historyCallDate?: string | null,
  historyCallTime?: string | null,
  historyCallAssistant?: MedicalAssistant | null,
  historyCallCompleted?: boolean | null,
  historyCallCompletedWithoutRecords?: boolean | null,
  historyCallCompletedOnSite?: boolean | null,
  historyCallNoShow?: boolean | null,
  historyCallCalendarEventID?: string | null,
  historyCallCalendarLink?: string | null,
  billingInfo?: BillingInfo | null,
  caseInfo?: CaseInfo | null,
  isProd?: boolean | null,
  isDemo?: boolean | null,
  primaryPatientCaseID?: string | null,
  calendarEventID?: string | null,
  reportConfiguration?: ReportConfiguration | null,
  workflowExecutions?: ModelWorkflowExecutionConnection | null,
  historyOfInjuryInsights?: HistoryOfInjuryInsights | null,
  reviewOfMedicalRecordsInsights?: ReviewOfMedicalRecordsInsights | null,
  physicalExamInsights?: PhysicalExamInsights | null,
  pastInjuryMatrix?: PastInjuryMatrix | null,
  briefing?: RecordBriefing | null,
  introParagraph?: IntroParagraph | null,
  impairmentRatingResults?:  Array<ImpairmentRatingResult | null > | null,
  defenseAttorneyPagesDeclaration?: number | null,
  applicantAttorneyPagesDeclaration?: number | null,
  fieldTemplateRef?: FieldTemplateRef | null,
  dataFieldValuesMappings?:  Array<DataFieldValueMapping | null > | null,
  physicalEvalTemplateRef?: FieldTemplateRef | null,
  physicalExamValues?:  Array<PhysicalExamValue | null > | null,
  physicalExamOtherFindings?:  Array<PhysicalExamOtherFinding | null > | null,
  assessment?: Assessment | null,
  assessmentValidation?: Validation | null,
  opinionRecap?: OpinionRecap | null,
  tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
  featureFlags?:  Array<AppointmentFeatureConfig | null > | null,
  opsChecklist?: OpsChecklist | null,
  panelUnavailable?: boolean | null,
  panelSpecialty?: SpecialtyType | null,
  defenseAttorneyNotPresent?: boolean | null,
  applicantAttorneyNotPresent?: boolean | null,
  contactUnavailability?: ParticipantContactUnavailability | null,
  historyValidation?: HistoryValidation | null,
  patientHistoryValidation?: Validation | null,
  videoCallLink?: string | null,
  additionalTimeslots?:  Array<AdditionalTimeslot | null > | null,
  mrrValidation?: Validation | null,
  historyMrrCrossValidation?: Validation | null,
  caseID?: string | null,
  briefingModelVersion?: BriefingModelVersion | null,
  briefingGdocExportLink?: string | null,
  briefingGdocExportedAt?: string | null,
  createdAt: string,
  updatedAt: string,
  appointmentRecordMedicalAssistantId?: string | null,
  appointmentRecordSchedulingAssistantId?: string | null,
  appointmentRecordOnSiteOpId?: string | null,
  appointmentRecordReportOpId?: string | null,
  appointmentRecordBillingOpId?: string | null,
  appointmentRecordPreVisitReviewerId?: string | null,
  appointmentRecordHuddleNoteId?: string | null,
  appointmentRecordHistoryOfInjuryNotesId?: string | null,
  appointmentRecordCurrentComplaintNotesId?: string | null,
  appointmentRecordHistoryCallAssistantId?: string | null,
  appointmentRecordHistoryOfInjuryInsightsId?: string | null,
  appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
  appointmentRecordPhysicalExamInsightsId?: string | null,
  appointmentRecordPastInjuryMatrixId?: string | null,
  appointmentRecordBriefingId?: string | null,
  appointmentRecordIntroParagraphId?: string | null,
  appointmentRecordAssessmentId?: string | null,
  appointmentRecordAssessmentValidationId?: string | null,
  appointmentRecordOpinionRecapId?: string | null,
  appointmentRecordHistoryValidationId?: string | null,
  appointmentRecordPatientHistoryValidationId?: string | null,
  appointmentRecordMrrValidationId?: string | null,
  appointmentRecordHistoryMrrCrossValidationId?: string | null,
};

export enum AppointmentType {
  QME = "QME",
  QME_REEVALUATION = "QME_REEVALUATION",
  AME = "AME",
  AME_REEVALUATION = "AME_REEVALUATION",
  SUPPLEMENTAL = "SUPPLEMENTAL",
  DEPOSITION = "DEPOSITION",
  BRIEFING = "BRIEFING",
  SIBTF = "SIBTF",
  SIBTF_REEVALUATION = "SIBTF_REEVALUATION",
  IME = "IME",
  IME_REEVALUATION = "IME_REEVALUATION",
  IME_ADR = "IME_ADR",
  IME_ADR_REEVALUATION = "IME_ADR_REEVALUATION",
  RECORD_REVIEW = "RECORD_REVIEW",
}


export type Doctor = {
  __typename: "Doctor",
  id: string,
  ownerCognitoId?: string | null,
  firstName?: string | null,
  middleName?: string | null,
  lastName?: string | null,
  name?: string | null,
  signatureName?: string | null,
  status?: DoctorStatus | null,
  ramped?: boolean | null,
  title?: string | null,
  titleExtension?: TitleExtension | null,
  contact?: ContactInfo | null,
  officePhone?: string | null,
  cellPhone?: string | null,
  clinicPhone?: string | null,
  workCity?: string | null,
  workState?: string | null,
  collectionRate?: number | null,
  licenseNumber?: string | null,
  licenseRenewalDate?: string | null,
  qmeLicense?: QmeLicense | null,
  locations?: ModelDoctorLocationConnection | null,
  specialties?: Array< SpecialtyType | null > | null,
  npi?: string | null,
  bankingInfo?: BankingInfo | null,
  appointments?: ModelAppointmentRecordConnection | null,
  availabilities?: Availabilities | null,
  availabilitiesNote?: string | null,
  emails?: Array< string | null > | null,
  profileImages?:  Array<DoctorProfileImage | null > | null,
  qmeReportConfigs?: DoctorQMEReportConfigs | null,
  physicalEvalConfigs?: DoctorPhysicalEvalConfigs | null,
  signatureDepartment?: string | null,
  profileAssetS3Prefix?: string | null,
  calendarPreference?: CalendarPreference | null,
  homeOffice?: HomeOffice | null,
  reportFormatPreferences?: ReportFormatPreferences | null,
  evaluationInputPreferences?: EvaluationInputPreferences | null,
  preferredAssessmentMode?: AssessmentMode | null,
  caseSummaryFields?: ModelDoctorCaseSummaryFieldConnection | null,
  briefingFields?: ModelDoctorBriefingFieldConnection | null,
  user?: User | null,
  isDemo?: boolean | null,
  fieldTemplateId?: string | null,
  templateFolderLink?: string | null,
  physicianPartner?: MedicalAssistant | null,
  defaultPrimaryOnsiteOps?: MedicalAssistant | null,
  defaultSecondaryOnsiteOps?: MedicalAssistant | null,
  defaultScheduler?: MedicalAssistant | null,
  defaultReportOps?: MedicalAssistant | null,
  defaultPreVisitReviewer?: MedicalAssistant | null,
  defaultBillingOps?: MedicalAssistant | null,
  defaultSupplementalReportOps?: MedicalAssistant | null,
  supplementalReportOpsAssignments?:  Array<SupplementalReportOpsAssignment | null > | null,
  supportingMAs?: ModelDoctorSupportingMAConnection | null,
  defaultAppointmentDurationMinutes?: DefaultAppointmentDurationMinutes | null,
  defaultEarlyArrivalTimeMinutes?: DefaultEarlyArrivalTimeMinutes | null,
  assessmentTreatmentOptions?: Array< string | null > | null,
  dismissedProTips?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
  doctorPhysicianPartnerId?: string | null,
  doctorDefaultPrimaryOnsiteOpsId?: string | null,
  doctorDefaultSecondaryOnsiteOpsId?: string | null,
  doctorDefaultSchedulerId?: string | null,
  doctorDefaultReportOpsId?: string | null,
  doctorDefaultPreVisitReviewerId?: string | null,
  doctorDefaultBillingOpsId?: string | null,
  doctorDefaultSupplementalReportOpsId?: string | null,
  doctorUserId?: string | null,
};

export enum DoctorStatus {
  PRE_ACTIVATING = "PRE_ACTIVATING",
  ACTIVATING = "ACTIVATING",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}


export enum TitleExtension {
  MD = "MD",
  DPM = "DPM",
  DDS = "DDS",
  DO = "DO",
}


export type ContactInfo = {
  __typename: "ContactInfo",
  phone?: string | null,
  phoneExtension?: string | null,
  email?: string | null,
  address?: Address | null,
  fax?: string | null,
  homePhoneNumber?: string | null,
};

export type Address = {
  __typename: "Address",
  street?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
  county?: string | null,
};

export type QmeLicense = {
  __typename: "QmeLicense",
  licenseNumber?: string | null,
  approvalDate?: string | null,
  renewalDate?: string | null,
};

export type ModelDoctorLocationConnection = {
  __typename: "ModelDoctorLocationConnection",
  items:  Array<DoctorLocation | null >,
  nextToken?: string | null,
};

export type DoctorLocation = {
  __typename: "DoctorLocation",
  id: string,
  doctorId: string,
  locationId: string,
  doctor: Doctor,
  location: Location,
  createdAt: string,
  updatedAt: string,
  ownerCognitoId?: string | null,
};

export type Location = {
  __typename: "Location",
  id: string,
  name?: string | null,
  abbreviation?: string | null,
  status?: LocationStatus | null,
  region?: Region | null,
  address?: Address | null,
  indigoOfficePhoneNumber?: string | null,
  isWaitingArea?: boolean | null,
  additionalRoomsNumber?: number | null,
  landlordContactInfo?: LocationLandlordContactInfo | null,
  calendarCcEmails?: Array< string | null > | null,
  isParkingFree?: boolean | null,
  parkingRate?: number | null,
  isFrontDoorLocked?: boolean | null,
  frontDoorCode?: string | null,
  backDoor?: BackDoorStatus | null,
  backDoorCode?: string | null,
  securityUnlockingProcess?: string | null,
  securityLockingProcess?: string | null,
  maleBathroomCode?: string | null,
  femaleBathroomCode?: string | null,
  wifiName?: string | null,
  wifiPassword?: string | null,
  defaultOnsiteOps?: MedicalAssistant | null,
  secondaryOnsiteOps?: MedicalAssistant | null,
  locationInstructionsForVisitor?: string | null,
  additionalNote?: string | null,
  doctors?: ModelDoctorLocationConnection | null,
  appointments?: ModelAppointmentRecordConnection | null,
  createdAt: string,
  updatedAt: string,
  locationDefaultOnsiteOpsId?: string | null,
  locationSecondaryOnsiteOpsId?: string | null,
};

export enum LocationStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}


export enum Region {
  SF_BAY_AREA = "SF_BAY_AREA",
  LOS_ANGELES = "LOS_ANGELES",
  SAN_DIEGO = "SAN_DIEGO",
}


export type LocationLandlordContactInfo = {
  __typename: "LocationLandlordContactInfo",
  name?: string | null,
  phone?: string | null,
  email?: string | null,
};

export enum BackDoorStatus {
  LOCKED = "LOCKED",
  UNLOCKED = "UNLOCKED",
  NO_BACK_DOOR = "NO_BACK_DOOR",
}


export type MedicalAssistant = {
  __typename: "MedicalAssistant",
  id: string,
  name?: string | null,
  email?: string | null,
  preVisitCallScheduleLink?: string | null,
  user?: User | null,
  enableCalendarNotify?: boolean | null,
  inactive?: boolean | null,
  languages?: Array< Language > | null,
  assignmentCriteria?: MedicalAssistantAppointmentAssignmentCriteria | null,
  isDemo?: boolean | null,
  dismissedProTips?: Array< string | null > | null,
  phoneNumber?: string | null,
  joinedDate?: string | null,
  level?: number | null,
  capacityPercent?: number | null,
  supportedDoctors?: ModelDoctorSupportingMAConnection | null,
  supportedSpecialtyCategories?: ModelMedicalAssistantSpecialtyCategoryConnection | null,
  availabilityExceptions?:  Array<AvailabilityException | null > | null,
  roles?: Array< OpsRole > | null,
  createdAt: string,
  updatedAt: string,
  medicalAssistantUserId?: string | null,
};

export type User = {
  __typename: "User",
  id: string,
  cognitoUserId: string,
  avatarUrl?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  doctor?: Doctor | null,
  assistant?: MedicalAssistant | null,
  appointmentFilterPreset?: ModelUserAppointmentFilterPresetConnection | null,
  onboardingDismissals?:  Array<OnboardingDismissal | null > | null,
  settings?: UserSettings | null,
  createdAt: string,
  updatedAt: string,
  userDoctorId?: string | null,
  userAssistantId?: string | null,
};

export type ModelUserAppointmentFilterPresetConnection = {
  __typename: "ModelUserAppointmentFilterPresetConnection",
  items:  Array<UserAppointmentFilterPreset | null >,
  nextToken?: string | null,
};

export type UserAppointmentFilterPreset = {
  __typename: "UserAppointmentFilterPreset",
  id: string,
  userId: string,
  appointmentFilterPresetId: string,
  user: User,
  appointmentFilterPreset: AppointmentFilterPreset,
  createdAt: string,
  updatedAt: string,
};

export type AppointmentFilterPreset = {
  __typename: "AppointmentFilterPreset",
  id: string,
  name: string,
  filters:  Array<FilterEntry >,
  appliesTo: UserGroup,
  view?: AppointmentsView | null,
  users?: ModelUserAppointmentFilterPresetConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type FilterEntry = {
  __typename: "FilterEntry",
  type: FilterType,
  values: Array< string >,
};

export enum FilterType {
  APPOINTMENT_TYPE = "APPOINTMENT_TYPE",
  LOCATION = "LOCATION",
  REGION = "REGION",
  CASE_STATUS = "CASE_STATUS",
  PHYSICIAN = "PHYSICIAN",
  LANGUAGE = "LANGUAGE",
  MEDICAL_ASSISTANT = "MEDICAL_ASSISTANT",
  SCHEDULER = "SCHEDULER",
  DATE_RANGE = "DATE_RANGE",
  INQUIRY_DATE_RANGE = "INQUIRY_DATE_RANGE",
  ON_SITE_OP = "ON_SITE_OP",
  REPORT_OPS = "REPORT_OPS",
  REQUESTING_PARTY = "REQUESTING_PARTY",
  DIFFICULTY_LEVEL = "DIFFICULTY_LEVEL",
  PANEL_SPECIALTY = "PANEL_SPECIALTY",
  DUE_DATE = "DUE_DATE",
  DUE_DATE_RANGE = "DUE_DATE_RANGE",
  CHECKLIST_CONTACT_INFO = "CHECKLIST_CONTACT_INFO",
  CHECKLIST_CONTACTS = "CHECKLIST_CONTACTS",
  CHECKLIST_COVER_LETTER = "CHECKLIST_COVER_LETTER",
  CHECKLIST_DEU = "CHECKLIST_DEU",
  CHECKLIST_HISTORY_CALL = "CHECKLIST_HISTORY_CALL",
  CHECKLIST_HOI = "CHECKLIST_HOI",
  CHECKLIST_INTERPRETER = "CHECKLIST_INTERPRETER",
  CHECKLIST_N110 = "CHECKLIST_N110",
  CHECKLIST_PANEL = "CHECKLIST_PANEL",
  CHECKLIST_PARTIES = "CHECKLIST_PARTIES",
  CHECKLIST_RECORD = "CHECKLIST_RECORD",
  CHECKLIST_ASSESSMENT_STATUS = "CHECKLIST_ASSESSMENT_STATUS",
  BILLING_OPS = "BILLING_OPS",
  PRE_VISIT_REVIEWER = "PRE_VISIT_REVIEWER",
}


export enum UserGroup {
  ADMIN = "ADMIN",
  DOCTOR = "DOCTOR",
  MEDICAL_ASSISTANT = "MEDICAL_ASSISTANT",
  HISTORIAN = "HISTORIAN",
  UNAUTHORIZED = "UNAUTHORIZED",
}


export enum AppointmentsView {
  APPOINTMENTS = "APPOINTMENTS",
  ACTIVE_VISITS = "ACTIVE_VISITS",
  ACTIVE_CASES = "ACTIVE_CASES",
  PAST_CASES = "PAST_CASES",
  UPCOMING_APPOINTMENTS = "UPCOMING_APPOINTMENTS",
  PREVISIT_APPOINTMENTS = "PREVISIT_APPOINTMENTS",
  BILLING_AND_COLLECTION = "BILLING_AND_COLLECTION",
  TODAY_VISITS = "TODAY_VISITS",
  DEPOSITIONS = "DEPOSITIONS",
  SUPPLEMENTALS = "SUPPLEMENTALS",
}


export type OnboardingDismissal = {
  __typename: "OnboardingDismissal",
  itemId: string,
  dismissedAt: string,
};

export type UserSettings = {
  __typename: "UserSettings",
  opsChecklistDefaultExpanded?: boolean | null,
};

export enum Language {
  ENGLISH = "ENGLISH",
  SPANISH = "SPANISH",
  CANTONESE = "CANTONESE",
  MANDARIN = "MANDARIN",
  ARABIC = "ARABIC",
  BENGALI = "BENGALI",
  VIETNAMESE = "VIETNAMESE",
  FARSI = "FARSI",
  TAGALOG = "TAGALOG",
  BURMESE = "BURMESE",
  NORTH_AZERI = "NORTH_AZERI",
  PUNJABI = "PUNJABI",
  ASL = "ASL",
  MAM = "MAM",
  ITALIAN = "ITALIAN",
  TIGRINYA = "TIGRINYA",
  TURKISH = "TURKISH",
  FRENCH = "FRENCH",
  PORTUGUESE = "PORTUGUESE",
  OTHER = "OTHER",
}


export type MedicalAssistantAppointmentAssignmentCriteria = {
  __typename: "MedicalAssistantAppointmentAssignmentCriteria",
  languageWeights:  Array<LanguageWeight >,
};

export type LanguageWeight = {
  __typename: "LanguageWeight",
  language: Language,
  weight: number,
  doctorSpecialty?: SpecialtyType | null,
};

export enum SpecialtyType {
  MAI = "MAI",
  MAA = "MAA",
  MDE = "MDE",
  MEM = "MEM",
  MFP = "MFP",
  MPM = "MPM",
  MHH = "MHH",
  MMM = "MMM",
  MMV = "MMV",
  MME = "MME",
  MMG = "MMG",
  MMH = "MMH",
  MNB = "MNB",
  MMO = "MMO",
  MMN = "MMN",
  MMP = "MMP",
  MMR = "MMR",
  MPN = "MPN",
  MNS = "MNS",
  MOG = "MOG",
  MPO = "MPO",
  MOP = "MOP",
  MOS = "MOS",
  MTO = "MTO",
  MPA = "MPA",
  MHA = "MHA",
  MPR = "MPR",
  MPD = "MPD",
  MSY = "MSY",
  MSG = "MSG",
  MTS = "MTS",
  MTT = "MTT",
  MUU = "MUU",
  ACA = "ACA",
  DCH = "DCH",
  DEN = "DEN",
  POD = "POD",
  PHY = "PHY",
}


export type ModelDoctorSupportingMAConnection = {
  __typename: "ModelDoctorSupportingMAConnection",
  items:  Array<DoctorSupportingMA | null >,
  nextToken?: string | null,
};

export type DoctorSupportingMA = {
  __typename: "DoctorSupportingMA",
  id: string,
  medicalAssistantId: string,
  doctorId: string,
  medicalAssistant: MedicalAssistant,
  doctor: Doctor,
  createdAt: string,
  updatedAt: string,
  ownerCognitoId?: string | null,
};

export type ModelMedicalAssistantSpecialtyCategoryConnection = {
  __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
  items:  Array<MedicalAssistantSpecialtyCategory | null >,
  nextToken?: string | null,
};

export type MedicalAssistantSpecialtyCategory = {
  __typename: "MedicalAssistantSpecialtyCategory",
  id: string,
  medicalAssistantId: string,
  specialtyCategoryId: string,
  medicalAssistant: MedicalAssistant,
  specialtyCategory: SpecialtyCategory,
  createdAt: string,
  updatedAt: string,
};

export type SpecialtyCategory = {
  __typename: "SpecialtyCategory",
  id: string,
  name: string,
  specialties?: Array< SpecialtyType > | null,
  fallbackMA?: MedicalAssistant | null,
  medicalAssistants?: ModelMedicalAssistantSpecialtyCategoryConnection | null,
  createdAt: string,
  updatedAt: string,
  specialtyCategoryFallbackMAId?: string | null,
};

export type AvailabilityException = {
  __typename: "AvailabilityException",
  type: AvailabilityExceptionType,
  during?: DateRange | null,
  startTime?: string | null,
  endTime?: string | null,
  allDay?: boolean | null,
};

export enum AvailabilityExceptionType {
  OOO = "OOO",
  SICK_LEAVE = "SICK_LEAVE",
  PARENTAL_LEAVE = "PARENTAL_LEAVE",
}


export type DateRange = {
  __typename: "DateRange",
  start?: string | null,
  end?: string | null,
};

export enum OpsRole {
  SCHEDULER = "SCHEDULER",
  MEDICAL_ASSISTANT = "MEDICAL_ASSISTANT",
  ON_SITE_OPS = "ON_SITE_OPS",
  REPORT_OPS = "REPORT_OPS",
  BILLING_OPS = "BILLING_OPS",
  PRE_VISIT_REVIEWER = "PRE_VISIT_REVIEWER",
}


export type BankingInfo = {
  __typename: "BankingInfo",
  bankEntityName?: string | null,
  accountNumber?: string | null,
  routingNumber?: string | null,
};

export type Availabilities = {
  __typename: "Availabilities",
  generalAvailabilities?:  Array<GeneralAvailability | null > | null,
  additionalAvailabilities?:  Array<AdditionalAvailability | null > | null,
  blackoutDates?:  Array<BlackoutDate | null > | null,
};

export type GeneralAvailability = {
  __typename: "GeneralAvailability",
  during?: DateRange | null,
  recurrence?: RecurrenceType | null,
  dayOfWeek?: DayOfWeek | null,
  dayOfMonth?: number | null,
  weekOfMonth?: WeekOfMonth | null,
  monthInterval?: number | null,
  startTime?: string | null,
  endTime?: string | null,
  flexibleTimeBefore?: FlexibleTimeWindow | null,
  flexibleTimeAfter?: FlexibleTimeWindow | null,
  locationIDs?: Array< string | null > | null,
  isAllLocations?: boolean | null,
};

export enum RecurrenceType {
  WEEKLY = "WEEKLY",
  BIWEEKLY = "BIWEEKLY",
  QUADWEEKLY = "QUADWEEKLY",
  MONTHLY = "MONTHLY",
}


export enum DayOfWeek {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
}


export enum WeekOfMonth {
  FIRST = "FIRST",
  SECOND = "SECOND",
  THIRD = "THIRD",
  FOURTH = "FOURTH",
  FIFTH = "FIFTH",
  LAST = "LAST",
}


export type FlexibleTimeWindow = {
  __typename: "FlexibleTimeWindow",
  startTime?: string | null,
  endTime?: string | null,
};

export type AdditionalAvailability = {
  __typename: "AdditionalAvailability",
  during?: DateRange | null,
  startTime?: string | null,
  endTime?: string | null,
  flexibleTimeBefore?: FlexibleTimeWindow | null,
  flexibleTimeAfter?: FlexibleTimeWindow | null,
  locationIDs?: Array< string | null > | null,
  isAllLocations?: boolean | null,
};

export type BlackoutDate = {
  __typename: "BlackoutDate",
  during?: DateRange | null,
  startTime?: string | null,
  endTime?: string | null,
  allDay?: boolean | null,
};

export type DoctorProfileImage = {
  __typename: "DoctorProfileImage",
  type?: DoctorProfileImageType | null,
  name?: string | null,
  order?: number | null,
  s3Prefix?: string | null,
  widthInInches?: number | null,
  heightInInches?: number | null,
};

export enum DoctorProfileImageType {
  HEADER = "HEADER",
  SIGNATURE = "SIGNATURE",
}


export type DoctorQMEReportConfigs = {
  __typename: "DoctorQMEReportConfigs",
  hasIntroTitle?: boolean | null,
  introTemplate?: string | null,
};

export type DoctorPhysicalEvalConfigs = {
  __typename: "DoctorPhysicalEvalConfigs",
  templates?: Array< PhysicalEvalTemplateTag | null > | null,
};

export enum PhysicalEvalTemplateTag {
  CERVICAL_SPINE = "CERVICAL_SPINE",
  SHOULDER = "SHOULDER",
  THORACOLUMBAR_SPINE = "THORACOLUMBAR_SPINE",
  THORACIC_SPINE = "THORACIC_SPINE",
  UPPER_EXTREMITY = "UPPER_EXTREMITY",
  LOWER_EXTREMITY = "LOWER_EXTREMITY",
  LOWER_EXTREMITY_AND_LUMBAR = "LOWER_EXTREMITY_AND_LUMBAR",
}


export type CalendarPreference = {
  __typename: "CalendarPreference",
  mailingList?: Array< string | null > | null,
  showPatientFullName?: boolean | null,
  showPatientAddress?: boolean | null,
  showPatientDOB?: boolean | null,
  showPortalLink?: boolean | null,
};

export type HomeOffice = {
  __typename: "HomeOffice",
  county?: string | null,
  state?: string | null,
};

export type ReportFormatPreferences = {
  __typename: "ReportFormatPreferences",
  evaluationReport: FormatPreferences,
  reEvaluationReport: FormatPreferences,
  supplementalReport: FormatPreferences,
};

export type FormatPreferences = {
  __typename: "FormatPreferences",
  sections: Array< ReportSection >,
  assessmentSubSections: Array< ReportAssessmentSubSection >,
};

export enum ReportSection {
  IDENTIFICATION_AND_WORK_HISTORY = "IDENTIFICATION_AND_WORK_HISTORY",
  PAST_MEDICAL_HISTORY = "PAST_MEDICAL_HISTORY",
  HISTORY = "HISTORY",
  CURRENT_COMPLAINT = "CURRENT_COMPLAINT",
  ADL = "ADL",
  MEDICAL_RECORD_REVIEW = "MEDICAL_RECORD_REVIEW",
  UPDATED_WORK_HISTORY = "UPDATED_WORK_HISTORY",
  UPDATED_MEDICAL_HISTORY = "UPDATED_MEDICAL_HISTORY",
  UPDATED_HISTORY = "UPDATED_HISTORY",
  PREVIOUS_REPORT_RECAP = "PREVIOUS_REPORT_RECAP",
  ASSESSMENT = "ASSESSMENT",
}


export enum ReportAssessmentSubSection {
  DISCUSSION = "DISCUSSION",
  DIAGNOSIS = "DIAGNOSIS",
  CAUSATION = "CAUSATION",
  P_AND_S_MMI_AND_FUTURE_MEDICAL_TREATMENT = "P_AND_S_MMI_AND_FUTURE_MEDICAL_TREATMENT",
  APPORTIONMENT = "APPORTIONMENT",
  WORK_STATUS = "WORK_STATUS",
}


export type EvaluationInputPreferences = {
  __typename: "EvaluationInputPreferences",
  evaluationReport: ReportInputPreferences,
  reEvaluationReport: ReportInputPreferences,
  supplementalReport: SupplementalReportInputPreferences,
};

export type ReportInputPreferences = {
  __typename: "ReportInputPreferences",
  history: ReportSource,
  physicalExamination: ReportSource,
  assessment: ReportSource,
};

export enum ReportSource {
  DICTATE = "DICTATE",
  WRITE = "WRITE",
}


export type SupplementalReportInputPreferences = {
  __typename: "SupplementalReportInputPreferences",
  assessment: ReportSource,
};

export enum AssessmentMode {
  STRUCTURED = "STRUCTURED",
  FREEFORM = "FREEFORM",
  GOOGLE_DOC = "GOOGLE_DOC",
}


export type ModelDoctorCaseSummaryFieldConnection = {
  __typename: "ModelDoctorCaseSummaryFieldConnection",
  items:  Array<DoctorCaseSummaryField | null >,
  nextToken?: string | null,
};

export type DoctorCaseSummaryField = {
  __typename: "DoctorCaseSummaryField",
  id: string,
  doctorId: string,
  caseSummaryFieldId: string,
  doctor: Doctor,
  caseSummaryField: CaseSummaryField,
  createdAt: string,
  updatedAt: string,
  ownerCognitoId?: string | null,
};

export type CaseSummaryField = {
  __typename: "CaseSummaryField",
  id: string,
  name: string,
  default: boolean,
  description?: string | null,
  summaryPrompt?: string | null,
  doctors?: ModelDoctorCaseSummaryFieldConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelDoctorBriefingFieldConnection = {
  __typename: "ModelDoctorBriefingFieldConnection",
  items:  Array<DoctorBriefingField | null >,
  nextToken?: string | null,
};

export type DoctorBriefingField = {
  __typename: "DoctorBriefingField",
  id: string,
  doctorId: string,
  briefingFieldId: string,
  doctor: Doctor,
  briefingField: BriefingField,
  createdAt: string,
  updatedAt: string,
  ownerCognitoId?: string | null,
};

export type BriefingField = {
  __typename: "BriefingField",
  id: string,
  name: string,
  default: boolean,
  description?: string | null,
  briefingPrompt?: string | null,
  doctors?: ModelDoctorBriefingFieldConnection | null,
  briefingRecordTypeID: string,
  recordType: BriefingRecordType,
  createdAt: string,
  updatedAt: string,
};

export type BriefingRecordType = {
  __typename: "BriefingRecordType",
  id: string,
  name: string,
  recordType: RecordType,
  description?: string | null,
  default: boolean,
  classificationPrompt?: string | null,
  recordBasePrompt?: string | null,
  briefingFields?: ModelBriefingFieldConnection | null,
  createdAt: string,
  updatedAt: string,
};

export enum RecordType {
  OFFICE_VISIT = "OFFICE_VISIT",
  QME_REPORT = "QME_REPORT",
  AME_REPORT = "AME_REPORT",
  PR4_REPORT = "PR4_REPORT",
  PERMANENT_AND_STATIONARY = "PERMANENT_AND_STATIONARY",
  DIAGNOSTIC_REPORT = "DIAGNOSTIC_REPORT",
  OPERATIVE_REPORT = "OPERATIVE_REPORT",
  THERAPY_REPORT = "THERAPY_REPORT",
  DEPOSITION_REPORT = "DEPOSITION_REPORT",
  DOCTORS_VISIT_REPORT = "DOCTORS_VISIT_REPORT",
  OTHERS = "OTHERS",
  UNKNOWN = "UNKNOWN",
  CASE_LAW = "CASE_LAW",
  SPECIALTY_REPORT = "SPECIALTY_REPORT",
  FIRST_VISIT_REPORT = "FIRST_VISIT_REPORT",
  SUB_ROSA = "SUB_ROSA",
}


export type ModelBriefingFieldConnection = {
  __typename: "ModelBriefingFieldConnection",
  items:  Array<BriefingField | null >,
  nextToken?: string | null,
};

export type SupplementalReportOpsAssignment = {
  __typename: "SupplementalReportOpsAssignment",
  medicalAssistantID: string,
  weightPercentage: number,
};

export type DefaultAppointmentDurationMinutes = {
  __typename: "DefaultAppointmentDurationMinutes",
  qme?: number | null,
  qmeReevaluation?: number | null,
  ime?: number | null,
  deposition?: number | null,
};

export type DefaultEarlyArrivalTimeMinutes = {
  __typename: "DefaultEarlyArrivalTimeMinutes",
  workersComp?: number | null,
  ime?: number | null,
  deposition?: number | null,
};

export type JotformSubmission = {
  __typename: "JotformSubmission",
  id: string,
  receivedAt: string,
  populatedAt?: string | null,
};

export type HistoryTranscriptPopulation = {
  __typename: "HistoryTranscriptPopulation",
  uploadedFileID: string,
  populatedAt: string,
};

export enum AppointmentStatus {
  SCHEDULED = "SCHEDULED",
  RECORDS_READY = "RECORDS_READY",
  CONFIRMED = "CONFIRMED",
  INQUIRY = "INQUIRY",
  INQUIRY_CLOSED = "INQUIRY_CLOSED",
  CANCELLED = "CANCELLED",
  LATE_CANCELLED = "LATE_CANCELLED",
  NO_SHOW = "NO_SHOW",
  RESCHEDULED = "RESCHEDULED",
  LATE_RESCHEDULED = "LATE_RESCHEDULED",
  RESCHEDULING_HOLD = "RESCHEDULING_HOLD",
  LATE_RESCHEDULING_HOLD = "LATE_RESCHEDULING_HOLD",
  RESCHEDULING_IN_PROGRESS = "RESCHEDULING_IN_PROGRESS",
  LATE_RESCHEDULING_IN_PROGRESS = "LATE_RESCHEDULING_IN_PROGRESS",
  DEPOSITION_HOLD = "DEPOSITION_HOLD",
  REEVAL_HOLD = "REEVAL_HOLD",
}


export enum ReportStatus {
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
  PENDING = "PENDING",
  SUBMITTED = "SUBMITTED",
  APPROVED = "APPROVED",
  READY_TO_SUBMIT = "READY_TO_SUBMIT",
}


export enum PaymentStatus {
  PAYMENT_RECEIVED = "PAYMENT_RECEIVED",
  PAYMENT_DISPUTED = "PAYMENT_DISPUTED",
  PAYMENT_PENDING = "PAYMENT_PENDING",
}


export enum BillingStatus {
  PENDING = "PENDING",
  BILLED = "BILLED",
  PAYMENT_DISPUTED = "PAYMENT_DISPUTED",
  PAYMENT_RECEIVED = "PAYMENT_RECEIVED",
  CORRECTING_PAYMENTS = "CORRECTING_PAYMENTS",
  PHYSICIAN_PAID = "PHYSICIAN_PAID",
}


export type ContactPersonInfo = {
  __typename: "ContactPersonInfo",
  name?: string | null,
  organizationName?: string | null,
  contact?: ContactInfo | null,
};

export type InquirerInfo = {
  __typename: "InquirerInfo",
  contact?: ContactInfo | null,
  inquiringParty?: InquiringParty | null,
  name?: string | null,
  inquiryDate?: string | null,
  notification_110_required?: boolean | null,
};

export enum InquiringParty {
  ADJUSTER = "ADJUSTER",
  APPLICANT_ATTORNEY = "APPLICANT_ATTORNEY",
  DEFENSE_ATTORNEY = "DEFENSE_ATTORNEY",
  PATIENT = "PATIENT",
}


export type ModelNotesConnection = {
  __typename: "ModelNotesConnection",
  items:  Array<Notes | null >,
  nextToken?: string | null,
};

export type Notes = {
  __typename: "Notes",
  id: string,
  content?: string | null,
  author?: User | null,
  type?: NotesType | null,
  timeStamp?: number | null,
  appointmentrecordID: string,
  createdAt: string,
  updatedAt: string,
  notesAuthorId?: string | null,
};

export enum NotesType {
  HISTORY_OF_INJURY = "HISTORY_OF_INJURY",
  CURRENT_COMPLAINT = "CURRENT_COMPLAINT",
  GENERAL_MA_NOTES = "GENERAL_MA_NOTES",
}


export type HuddleNote = {
  __typename: "HuddleNote",
  id: string,
  appointmentRecordID: string,
  contentMarkdown?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelAppointmentRecordPatientCaseConnection = {
  __typename: "ModelAppointmentRecordPatientCaseConnection",
  items:  Array<AppointmentRecordPatientCase | null >,
  nextToken?: string | null,
};

export type AppointmentRecordPatientCase = {
  __typename: "AppointmentRecordPatientCase",
  id: string,
  appointmentRecordId: string,
  patientCaseId: string,
  appointmentRecord: AppointmentRecord,
  patientCase: PatientCase,
  createdAt: string,
  updatedAt: string,
  doctorOwnerCognitoId?: string | null,
  assistantCognitoIds?: string | null,
};

export type PatientCase = {
  __typename: "PatientCase",
  id: string,
  patientID: string,
  patient?: Patient | null,
  claimNumber: string,
  qmePanelNumber?: string | null,
  contact?: ContactInfo | null,
  injuryInfo?: InjuryInfo | null,
  workersCompInsurance?: WorkersCompInsuranceInfo | null,
  insuranceCarrierID?: string | null,
  insuranceCarrier?: InsuranceCarrier | null,
  insuranceCarrierAddressID?: string | null,
  insuranceCarrierAddress?: StoredAddress | null,
  insuranceCarrierFaxNumberID?: string | null,
  insuranceCarrierFaxNumber?: StoredFaxNumber | null,
  insuranceCarrierPhoneNumberID?: string | null,
  insuranceCarrierPhoneNumber?: StoredPhoneNumber | null,
  appointments?: ModelAppointmentRecordPatientCaseConnection | null,
  applicantAttorney?: AttorneyInfo | null,
  applicantAttorneyLawFirmID?: string | null,
  applicantAttorneyLawFirm?: LawFirm | null,
  applicantAttorneyAddressID?: string | null,
  applicantAttorneyAddress?: StoredAddress | null,
  applicantAttorneyFaxNumberID?: string | null,
  applicantAttorneyFaxNumber?: StoredFaxNumber | null,
  applicantAttorneyPhoneNumberID?: string | null,
  applicantAttorneyPhoneNumber?: StoredPhoneNumber | null,
  defenseAttorney?: AttorneyInfo | null,
  defenseAttorneyLawFirmID?: string | null,
  defenseAttorneyLawFirm?: LawFirm | null,
  defenseAttorneyAddressID?: string | null,
  defenseAttorneyAddress?: StoredAddress | null,
  defenseAttorneyFaxNumberID?: string | null,
  defenseAttorneyFaxNumber?: StoredFaxNumber | null,
  defenseAttorneyPhoneNumberID?: string | null,
  defenseAttorneyPhoneNumber?: StoredPhoneNumber | null,
  nurseCaseManager?: ContactPersonInfo | null,
  ccPerson?: ContactPersonInfo | null,
  applicantAttorneyCcEmails?: Array< string | null > | null,
  defenseAttorneyCcEmails?: Array< string | null > | null,
  adjusterCcEmails?: Array< string | null > | null,
  scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
  employmentAtInjury?: EmploymentRecord | null,
  WCAB?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type Patient = {
  __typename: "Patient",
  id: string,
  name?: string | null,
  dateOfBirth?: string | null,
  SSN?: string | null,
  language?: Language | null,
  dominantHand?: DominantHand | null,
  cases?: ModelPatientCaseConnection | null,
  contact?: ContactInfo | null,
  occupation?: string | null,
  sex?: Sex | null,
  weightLb?: number | null,
  height?: Height | null,
  createdAt: string,
  updatedAt: string,
};

export enum DominantHand {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
  AMBIDEXTROUS = "AMBIDEXTROUS",
}


export type ModelPatientCaseConnection = {
  __typename: "ModelPatientCaseConnection",
  items:  Array<PatientCase | null >,
  nextToken?: string | null,
};

export enum Sex {
  MALE = "MALE",
  FEMALE = "FEMALE",
}


export type Height = {
  __typename: "Height",
  feet?: number | null,
  inches?: number | null,
};

export type InjuryInfo = {
  __typename: "InjuryInfo",
  injuryType?: InjuryType | null,
  injuredBodyParts?: Array< BodyPart | null > | null,
  claimedBodyParts?: Array< BodyPart | null > | null,
  description?: string | null,
  dateOfInjury?: string | null,
  dateOfInjuryFlexible?: FlexibleDate | null,
  startDateOfInjury?: string | null,
  startDateOfInjuryFlexible?: FlexibleDate | null,
};

export enum InjuryType {
  SPECIFIC_TRAUMA = "SPECIFIC_TRAUMA",
  CUMULATIVE_TRAUMA = "CUMULATIVE_TRAUMA",
}


export enum BodyPart {
  RIGHT_UPPER_EXTREMITY = "RIGHT_UPPER_EXTREMITY",
  LEFT_UPPER_EXTREMITY = "LEFT_UPPER_EXTREMITY",
  RIGHT_FOOT = "RIGHT_FOOT",
  LEFT_FOOT = "LEFT_FOOT",
  RIGHT_KNEE = "RIGHT_KNEE",
  LEFT_KNEE = "LEFT_KNEE",
  RIGHT_LEG = "RIGHT_LEG",
  LEFT_LEG = "LEFT_LEG",
  RIGHT_LOWER_LEG = "RIGHT_LOWER_LEG",
  LEFT_LOWER_LEG = "LEFT_LOWER_LEG",
  RIGHT_ANKLE = "RIGHT_ANKLE",
  LEFT_ANKLE = "LEFT_ANKLE",
  RIGHT_SHOULDER = "RIGHT_SHOULDER",
  LEFT_SHOULDER = "LEFT_SHOULDER",
  RIGHT_WRIST = "RIGHT_WRIST",
  LEFT_WRIST = "LEFT_WRIST",
  RIGHT_FOREARM = "RIGHT_FOREARM",
  LEFT_FOREARM = "LEFT_FOREARM",
  RIGHT_ARM = "RIGHT_ARM",
  LEFT_ARM = "LEFT_ARM",
  RIGHT_ELBOW = "RIGHT_ELBOW",
  LEFT_ELBOW = "LEFT_ELBOW",
  RIGHT_THUMB = "RIGHT_THUMB",
  LEFT_THUMB = "LEFT_THUMB",
  RIGHT_INDEX_FINGER = "RIGHT_INDEX_FINGER",
  LEFT_INDEX_FINGER = "LEFT_INDEX_FINGER",
  RIGHT_MIDDLE_FINGER = "RIGHT_MIDDLE_FINGER",
  LEFT_MIDDLE_FINGER = "LEFT_MIDDLE_FINGER",
  RIGHT_RING_FINGER = "RIGHT_RING_FINGER",
  LEFT_RING_FINGER = "LEFT_RING_FINGER",
  RIGHT_LITTLE_FINGER = "RIGHT_LITTLE_FINGER",
  LEFT_LITTLE_FINGER = "LEFT_LITTLE_FINGER",
  RIGHT_HAND = "RIGHT_HAND",
  LEFT_HAND = "LEFT_HAND",
  NERVE_SYSTEM = "NERVE_SYSTEM",
  HEAD = "HEAD",
  ABDOMEN = "ABDOMEN",
  CERVICAL_SPINE = "CERVICAL_SPINE",
  LUMBAR_SPINE = "LUMBAR_SPINE",
  THORACIC_SPINE = "THORACIC_SPINE",
  RIGHT_LOWER_EXTREMITY = "RIGHT_LOWER_EXTREMITY",
  LEFT_LOWER_EXTREMITY = "LEFT_LOWER_EXTREMITY",
  LEFT_HIP = "LEFT_HIP",
  RIGHT_HIP = "RIGHT_HIP",
  PELVIS = "PELVIS",
  SACRUM = "SACRUM",
  COCCYX = "COCCYX",
  CHEST = "CHEST",
  TEETH = "TEETH",
  FACE = "FACE",
  JAW = "JAW",
  MOUTH = "MOUTH",
  NOSE = "NOSE",
  EAR = "EAR",
  DIGESTIVE_SYSTEM = "DIGESTIVE_SYSTEM",
  CIRCULATORY_SYSTEM = "CIRCULATORY_SYSTEM",
  RESPIRATORY_SYSTEM = "RESPIRATORY_SYSTEM",
  REPRODUCTIVE_SYSTEM = "REPRODUCTIVE_SYSTEM",
  EXCRETORY_SYSTEM = "EXCRETORY_SYSTEM",
  EYE = "EYE",
  ENDOCRINE_SYSTEM = "ENDOCRINE_SYSTEM",
  SKIN = "SKIN",
  STRESS = "STRESS",
  PSYCH = "PSYCH",
}


export type FlexibleDate = {
  __typename: "FlexibleDate",
  value?: string | null,
  precision: DatePrecision,
};

export enum DatePrecision {
  YEAR = "YEAR",
  MONTH = "MONTH",
  DAY = "DAY",
  PRESENT = "PRESENT",
}


export type WorkersCompInsuranceInfo = {
  __typename: "WorkersCompInsuranceInfo",
  insuranceCarrier?: string | null,
  adjuster?: string | null,
  contact?: ContactInfo | null,
};

export type InsuranceCarrier = {
  __typename: "InsuranceCarrier",
  id: string,
  name: string,
  defaultAddressID?: string | null,
  defaultAddress?: StoredAddress | null,
  addresses?: ModelStoredAddressConnection | null,
  defaultFaxNumberID?: string | null,
  defaultFaxNumber?: StoredFaxNumber | null,
  faxNumbers?: ModelStoredFaxNumberConnection | null,
  defaultPhoneNumberID?: string | null,
  defaultPhoneNumber?: StoredPhoneNumber | null,
  phoneNumbers?: ModelStoredPhoneNumberConnection | null,
  defaultEmail?: string | null,
  supportedDomains?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type StoredAddress = {
  __typename: "StoredAddress",
  id: string,
  street?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
  insuranceCarrierID?: string | null,
  lawFirmID?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelStoredAddressConnection = {
  __typename: "ModelStoredAddressConnection",
  items:  Array<StoredAddress | null >,
  nextToken?: string | null,
};

export type StoredFaxNumber = {
  __typename: "StoredFaxNumber",
  id: string,
  faxNumber?: string | null,
  insuranceCarrierID?: string | null,
  lawFirmID?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelStoredFaxNumberConnection = {
  __typename: "ModelStoredFaxNumberConnection",
  items:  Array<StoredFaxNumber | null >,
  nextToken?: string | null,
};

export type StoredPhoneNumber = {
  __typename: "StoredPhoneNumber",
  id: string,
  phoneNumber?: string | null,
  extension?: string | null,
  insuranceCarrierID?: string | null,
  lawFirmID?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelStoredPhoneNumberConnection = {
  __typename: "ModelStoredPhoneNumberConnection",
  items:  Array<StoredPhoneNumber | null >,
  nextToken?: string | null,
};

export type AttorneyInfo = {
  __typename: "AttorneyInfo",
  name?: string | null,
  lawFirmName?: string | null,
  contact?: ContactInfo | null,
};

export type LawFirm = {
  __typename: "LawFirm",
  id: string,
  name: string,
  type: LawFirmType,
  defaultAddressID?: string | null,
  defaultAddress?: StoredAddress | null,
  addresses?: ModelStoredAddressConnection | null,
  defaultFaxNumberID?: string | null,
  defaultFaxNumber?: StoredFaxNumber | null,
  faxNumbers?: ModelStoredFaxNumberConnection | null,
  defaultPhoneNumberID?: string | null,
  defaultPhoneNumber?: StoredPhoneNumber | null,
  phoneNumbers?: ModelStoredPhoneNumberConnection | null,
  defaultEmail?: string | null,
  supportedDomains?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
};

export enum LawFirmType {
  APPLICANT_ATTORNEY = "APPLICANT_ATTORNEY",
  DEFENSE_ATTORNEY = "DEFENSE_ATTORNEY",
}


export type EmploymentRecord = {
  __typename: "EmploymentRecord",
  employerName?: string | null,
  jobTitle?: string | null,
  contact?: ContactInfo | null,
  dateOfHire?: string | null,
  dateOfHireFlexible?: FlexibleDate | null,
  hoursPerWeek?: string | null,
  jobDuties?: string | null,
  dateOfTermination?: string | null,
  dateOfTerminationFlexible?: FlexibleDate | null,
  notes?: string | null,
  stillWorkingHere?: boolean | null,
  type?: EmploymentType | null,
  currentWorkRestrictions?: string | null,
  workStatus?: string | null,
  departureReason?: string | null,
};

export enum EmploymentType {
  CURRENT = "CURRENT",
  POST_INJURY = "POST_INJURY",
  PREVIOUS = "PREVIOUS",
}


export type EmploymentGapRecord = {
  __typename: "EmploymentGapRecord",
  type?: EmploymentGapType | null,
  startDate?: FlexibleDate | null,
  endDate?: FlexibleDate | null,
  notes?: string | null,
};

export enum EmploymentGapType {
  PRE_INJURY = "PRE_INJURY",
  POST_INJURY = "POST_INJURY",
}


export type DocumentStatus = {
  __typename: "DocumentStatus",
  evaluationPublished?: boolean | null,
  assessmentPublished?: boolean | null,
  historyInProgress?: boolean | null,
  historyPublished?: boolean | null,
  historyCleaned?: boolean | null,
  reportPublished?: boolean | null,
  briefingInProgress?: boolean | null,
  briefingPublished?: boolean | null,
  briefingCleaned?: boolean | null,
};

export enum CancellationReason {
  MORE_TREATMENT_NEEDED = "MORE_TREATMENT_NEEDED",
  LOCATION_TOO_FAR = "LOCATION_TOO_FAR",
  DIFFERENT_DOCTOR_CHOSEN = "DIFFERENT_DOCTOR_CHOSEN",
  PANEL_DISPUTED = "PANEL_DISPUTED",
  PATIENT_TRAVELING = "PATIENT_TRAVELING",
  CLAIM_SETTLED = "CLAIM_SETTLED",
  DUPLICATED_APPOINTMENT_SCHEDULED = "DUPLICATED_APPOINTMENT_SCHEDULED",
  OTHER = "OTHER",
}


export enum ParticipantType {
  PATIENT = "PATIENT",
  ADJUSTER = "ADJUSTER",
  APPLICANT_ATTORNEY = "APPLICANT_ATTORNEY",
  DEFENSE_ATTORNEY = "DEFENSE_ATTORNEY",
}


export enum InquiryClosingReason {
  NO_RESPONSE = "NO_RESPONSE",
  OTHER_DOCTOR_SELECTED = "OTHER_DOCTOR_SELECTED",
  FOR_AVAILABILITY_ONLY = "FOR_AVAILABILITY_ONLY",
  OTHER = "OTHER",
}


export enum NoShowReason {
  PATIENT_DID_NOT_ATTEND = "PATIENT_DID_NOT_ATTEND",
  INTERPRETER_DID_NOT_ATTEND = "INTERPRETER_DID_NOT_ATTEND",
}


export enum ReschedulingReason {
  MORE_TREATMENT_NEEDED = "MORE_TREATMENT_NEEDED",
  PATIENT_TRAVELING = "PATIENT_TRAVELING",
  ADDITIONAL_DISCOVERY_NEEDED = "ADDITIONAL_DISCOVERY_NEEDED",
  OTHER = "OTHER",
}


export type InterpreterInfo = {
  __typename: "InterpreterInfo",
  certificateId?: string | null,
  name?: string | null,
  companyName?: string | null,
  phoneNumber?: string | null,
  phoneExtension?: string | null,
  note?: string | null,
  confirmed?: boolean | null,
};

export type BillingInfo = {
  __typename: "BillingInfo",
  diagnosisMappings?:  Array<DiagnosisMapping | null > | null,
  serviceDetails?:  Array<ServiceDetail | null > | null,
  totalCharge?: number | null,
  amountPaid?: number | null,
  billingCounter?: number | null,
  billedDate?: string | null,
  paidDate?: string | null,
  correctionDate?: string | null,
};

export type DiagnosisMapping = {
  __typename: "DiagnosisMapping",
  code?: string | null,
  pointer?: string | null,
  description?: string | null,
};

export type ServiceDetail = {
  __typename: "ServiceDetail",
  dateOfStart?: string | null,
  dateOfEnd?: string | null,
  place?: number | null,
  emergencyIndicator?: boolean | null,
  serviceType?: ServiceType | null,
  modifiers?: Array< ServiceModifier | null > | null,
  diagnosisPointers?: Array< string | null > | null,
  chargedAmount?: number | null,
  quantity?: number | null,
  amountPaid?: number | null,
  renderingProviderId?: string | null,
};

export enum ServiceType {
  ML200 = "ML200",
  ML201 = "ML201",
  ML202 = "ML202",
  ML203 = "ML203",
  ML205 = "ML205",
  MLPRR = "MLPRR",
  ML204 = "ML204",
}


export enum ServiceModifier {
  QME = "QME",
  INTERPRETER = "INTERPRETER",
  AME = "AME",
  PSYCH = "PSYCH",
}


export type CaseInfo = {
  __typename: "CaseInfo",
  confirmationEmailStatuses?: ParticipantEmailStatuses | null,
  recordsFollowupEmailStatuses?: ParticipantEmailStatuses | null,
  attendanceEmailStatuses?: ParticipantEmailStatuses | null,
};

export type ParticipantEmailStatuses = {
  __typename: "ParticipantEmailStatuses",
  patient?: boolean | null,
  adjuster?: boolean | null,
  applicantAttorney?: boolean | null,
  defenseAttorney?: boolean | null,
  patientSentAt?: string | null,
  adjusterSentAt?: string | null,
  applicantAttorneySentAt?: string | null,
  defenseAttorneySentAt?: string | null,
};

export type ReportConfiguration = {
  __typename: "ReportConfiguration",
  history?: ReportSource | null,
  physicalExamination?: ReportSource | null,
  assessment?: ReportSource | null,
};

export type ModelWorkflowExecutionConnection = {
  __typename: "ModelWorkflowExecutionConnection",
  items:  Array<WorkflowExecution | null >,
  nextToken?: string | null,
};

export type WorkflowExecution = {
  __typename: "WorkflowExecution",
  executionArn: string,
  appointmentRecordID: string,
  type?: WorkflowExecutionType | null,
  status?: WorkflowExecutionStatus | null,
  errorMessage?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum WorkflowExecutionType {
  MEDICAL_RECORDS_BRIEFING = "MEDICAL_RECORDS_BRIEFING",
  REPORT_GENERATION = "REPORT_GENERATION",
}


export enum WorkflowExecutionStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  ABORTED = "ABORTED",
}


export type HistoryOfInjuryInsights = {
  __typename: "HistoryOfInjuryInsights",
  id: string,
  appointmentRecordID: string,
  mechanismOfInjury?: string | null,
  employerJobDescription?: string | null,
  injuryCausations?:  Array<InjuryCausationInfo | null > | null,
  currentSymptoms?:  Array<Symptom | null > | null,
  priorSymptomsBeforeCurrentInjury?:  Array<Symptom | null > | null,
  previousSurgeries?:  Array<SurgeryHistoryInfo | null > | null,
  previousWorkInjuries?:  Array<InjuryHistoryInfo | null > | null,
  previousInjuries?:  Array<InjuryHistoryInfo | null > | null,
  injuryEmploymentStatus?: string | null,
  currentWorkRestrictionsFromPatient?: string | null,
  activitiesOfDailyLiving?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type InjuryCausationInfo = {
  __typename: "InjuryCausationInfo",
  injuryType?: InjuryType | null,
  dateOfInjury?: string | null,
  dateOfInjuryEnd?: string | null,
  bodyParts?: Array< BodyPart | null > | null,
  mechanismOfInjury?: string | null,
  employerJobDescription?: string | null,
};

export type Symptom = {
  __typename: "Symptom",
  bodyParts?: Array< string | null > | null,
  description?: string | null,
};

export type SurgeryHistoryInfo = {
  __typename: "SurgeryHistoryInfo",
  date?: string | null,
  bodyParts?: Array< string | null > | null,
  type?: string | null,
};

export type InjuryHistoryInfo = {
  __typename: "InjuryHistoryInfo",
  date?: string | null,
  bodyParts?: Array< string | null > | null,
  description?: string | null,
};

export type ReviewOfMedicalRecordsInsights = {
  __typename: "ReviewOfMedicalRecordsInsights",
  id: string,
  appointmentRecordID: string,
  latestDiagnosis?:  Array<BodyPartDiagnosis | null > | null,
  diagnosticStudies?:  Array<DiagnosticStudy | null > | null,
  treatments?:  Array<TreatmentWrapper | null > | null,
  currentWorkRestrictionsFromMedicalRecords?: string | null,
  previousReports?:  Array<PreviousReport | null > | null,
  durableMedicalEquipment?:  Array<DurableMedicalEquipment | null > | null,
  derivedFromDocumentInsightIDs?: Array< string | null > | null,
  derivedAt?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type BodyPartDiagnosis = {
  __typename: "BodyPartDiagnosis",
  bodyPart?: string | null,
  date?: string | null,
  descriptions?: Array< string | null > | null,
};

export type DiagnosticStudy = {
  __typename: "DiagnosticStudy",
  date?: string | null,
  typeOfStudy?: DiagnosticStudyType | null,
  bodyPart?: string | null,
  impression?: string | null,
  source?: DiagnosticStudySource | null,
};

export enum DiagnosticStudyType {
  X_RAY = "X_RAY",
  MRI = "MRI",
  CT = "CT",
  EMG_NCS = "EMG_NCS",
  ELECTRODIAGNOSTIC_STUDY = "ELECTRODIAGNOSTIC_STUDY",
  OTHER = "OTHER",
}


export enum DiagnosticStudySource {
  ACTUAL_STUDY = "ACTUAL_STUDY",
  FROM_NOTE = "FROM_NOTE",
  OTHER = "OTHER",
}


export type TreatmentWrapper = {
  __typename: "TreatmentWrapper",
  discreteTreatment?: DiscreteTreatment | null,
  recurringTreatment?: RecurringTreatment | null,
};

export type DiscreteTreatment = {
  __typename: "DiscreteTreatment",
  date?: string | null,
  treatmentType?: DiscreteTreatmentType | null,
  bodyPart?: string | null,
  description?: string | null,
};

export enum DiscreteTreatmentType {
  OPERATIVE_REPORT = "OPERATIVE_REPORT",
  OPERATIVE_NOTE = "OPERATIVE_NOTE",
  STEROID_CORTISONE_INJECTION = "STEROID_CORTISONE_INJECTION",
  PRP_INJECTION = "PRP_INJECTION",
  OTHER = "OTHER",
}


export type RecurringTreatment = {
  __typename: "RecurringTreatment",
  year?: string | null,
  treatmentType?: RecurringTreatmentType | null,
  frequency?: string | null,
  description?: string | null,
};

export enum RecurringTreatmentType {
  PHYSICAL_THERAPY = "PHYSICAL_THERAPY",
  OCCUPATIONAL_THERAPY = "OCCUPATIONAL_THERAPY",
  CHIROPRACTIC = "CHIROPRACTIC",
  ACUPUNCTURE = "ACUPUNCTURE",
  OTHER = "OTHER",
}


export type PreviousReport = {
  __typename: "PreviousReport",
  date?: string | null,
  reportType?: string | null,
  reportContent?: string | null,
};

export type DurableMedicalEquipment = {
  __typename: "DurableMedicalEquipment",
  startDate?: string | null,
  endDate?: string | null,
  bodyParts?: Array< string | null > | null,
  equipmentType?: string | null,
  description?: string | null,
};

export type PhysicalExamInsights = {
  __typename: "PhysicalExamInsights",
  id: string,
  appointmentRecordID: string,
  physicalExaminationInfo?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type PastInjuryMatrix = {
  __typename: "PastInjuryMatrix",
  id: string,
  appointmentRecordID: string,
  preExistingConditions: Array< string >,
  familyHistory: Array< string >,
  injuryMatrix:  Array<InjuryMatrixEntry >,
  createdAt: string,
  updatedAt: string,
};

export type InjuryMatrixEntry = {
  __typename: "InjuryMatrixEntry",
  date: string,
  bodyPart: BodyPart,
  status: InjuryStatus,
};

export enum InjuryStatus {
  NO_INJURY = "NO_INJURY",
  INJURED = "INJURED",
  RESOLVED = "RESOLVED",
}


export type RecordBriefing = {
  __typename: "RecordBriefing",
  id: string,
  logicalBriefingID: string,
  segmentMappings?: ModelRecordBriefingSegmentMappingConnection | null,
  generatedAt?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
  googleDocExportLink?: string | null,
  googleDocExportedAt?: string | null,
  suggestionGeneration?: SuggestionGenerationJob | null,
  editingPresence?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelRecordBriefingSegmentMappingConnection = {
  __typename: "ModelRecordBriefingSegmentMappingConnection",
  items:  Array<RecordBriefingSegmentMapping | null >,
  nextToken?: string | null,
};

export type RecordBriefingSegmentMapping = {
  __typename: "RecordBriefingSegmentMapping",
  id: string,
  briefingID: string,
  logicalSegmentID: string,
  publishedSegmentID?: string | null,
  draftSegmentID?: string | null,
  markedForDeletion?: boolean | null,
  markedForCreation?: boolean | null,
  publishedSegment?: RecordBriefingSegment | null,
  draftSegment?: RecordBriefingSegment | null,
  createdAt: string,
  updatedAt: string,
};

export type RecordBriefingSegment = {
  __typename: "RecordBriefingSegment",
  id: string,
  logicalSegmentID: string,
  title?: string | null,
  text?: string | null,
  bodyParts?: Array< BodyPart | null > | null,
  injuredBodyParts?: Array< BodyPart | null > | null,
  editedBy?: string | null,
  pdfFileName: string,
  sourceTag?: string | null,
  segmentNumber?: number | null,
  sourcePdfS3Key: string,
  startPageNumber: number,
  endPageNumber: number,
  recordType: RecordType,
  extractedDate?: string | null,
  doctorName?: string | null,
  processingModel?: string | null,
  classificationConfidence?: number | null,
  hasDate?: boolean | null,
  potentialDuplicateID?: string | null,
  needsReview?: boolean | null,
  status?: SegmentStatus | null,
  documentID?: string | null,
  videoStartTime?: string | null,
  videoEndTime?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum SegmentStatus {
  NEEDS_REVIEW = "NEEDS_REVIEW",
  HIDDEN = "HIDDEN",
  VERIFIED = "VERIFIED",
}


export type SuggestionGenerationJob = {
  __typename: "SuggestionGenerationJob",
  status?: SuggestionGenerationStatus | null,
  jobId?: string | null,
  startedAt?: string | null,
  completedAt?: string | null,
  error?: string | null,
};

export enum SuggestionGenerationStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}


export type IntroParagraph = {
  __typename: "IntroParagraph",
  id: string,
  appointmentRecordID: string,
  introParagraphText?: string | null,
  sourceRecaps?:  Array<CoverLetterRecapSnapshot | null > | null,
  status: IntroParagraphStatus,
  errorMessage?: string | null,
  generatedAt?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type CoverLetterRecapSnapshot = {
  __typename: "CoverLetterRecapSnapshot",
  coverLetterRecapID: string,
  uploadedFileID: string,
  recapText: string,
  generatedAt?: string | null,
};

export enum IntroParagraphStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}


export type ImpairmentRatingResult = {
  __typename: "ImpairmentRatingResult",
  ts?: number | null,
  bodyParts?: Array< string | null > | null,
  enabledStrictRating?: boolean | null,
  enabledPainRating?: boolean | null,
  enabledAG?: boolean | null,
  enabledStrengthRating?: boolean | null,
  enabledDBE?: boolean | null,
  autoMode?: boolean | null,
  result?: string | null,
  resultFeedback?: ImpairmentRatingResultFeedback | null,
};

export type ImpairmentRatingResultFeedback = {
  __typename: "ImpairmentRatingResultFeedback",
  exists?: boolean | null,
  isGood?: boolean | null,
  notes?: string | null,
};

export type FieldTemplateRef = {
  __typename: "FieldTemplateRef",
  id: string,
  version: number,
};

export type DataFieldValueMapping = {
  __typename: "DataFieldValueMapping",
  dataFieldID?: string | null,
  value?: string | null,
};

export type PhysicalExamValue = {
  __typename: "PhysicalExamValue",
  sectionID: string,
  questionID: string,
  side?: PhysicalExamSide | null,
  value?: string | null,
  note?: string | null,
  excluded?: boolean | null,
};

export enum PhysicalExamSide {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
  NONE = "NONE",
}


export type PhysicalExamOtherFinding = {
  __typename: "PhysicalExamOtherFinding",
  sectionID: string,
  text?: string | null,
};

export type Assessment = {
  __typename: "Assessment",
  id: string,
  injuries?:  Array<AssessmentInjury | null > | null,
  discussedBodyParts?: Array< BodyPart | null > | null,
  bodyPartsNotDiscussedReason?: string | null,
  discussions?: string | null,
  diagnoses?:  Array<AssessmentDiagnosis | null > | null,
  bodyPartMMIStatus?: AssessmentBodyPartMMIStatus | null,
  workStatus?: string | null,
  markedAsDone?: boolean | null,
  discussDiagnosesFreeForm?: boolean | null,
  diagnosesFreeform?: string | null,
  discussCausationFreeForm?: boolean | null,
  causationFreeForm?: string | null,
  discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
  hasPatientReachedMMIFreeForm?: string | null,
  discussMMIByBodyPartFreeForm?: string | null,
  impairmentRatingByBodyPartFreeForm?: string | null,
  apportionmentByBodyPartFreeForm?: string | null,
  impairmentRatingOtherComments?: string | null,
  apportionmentOtherComments?: string | null,
  assessmentMode?: AssessmentMode | null,
  assessmentFreeForm?: AssessmentFreeForm | null,
  createdAt: string,
  updatedAt: string,
};

export type AssessmentInjury = {
  __typename: "AssessmentInjury",
  injuryType?: InjuryType | null,
  dateOfInjury?: string | null,
  dateOfInjuryFlexible?: FlexibleDate | null,
  dateOfInjuryEnd?: string | null,
  dateOfInjuryEndFlexible?: FlexibleDate | null,
  bodyParts?: Array< BodyPart | null > | null,
  causeOfInjury?: string | null,
  causedByWork?: AssessmentCausationOption | null,
  causedByWorkExplanation?: string | null,
};

export enum AssessmentCausationOption {
  YES = "YES",
  NO = "NO",
  CANNOT_DETERMINE = "CANNOT_DETERMINE",
}


export type AssessmentDiagnosis = {
  __typename: "AssessmentDiagnosis",
  diagnosis?: string | null,
  icdCode?: string | null,
  evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
  evidence?: string | null,
};

export enum AssessmentEvidenceSource {
  MEDICAL_RECORDS = "MEDICAL_RECORDS",
  HISTORY_OF_INJURY = "HISTORY_OF_INJURY",
  PHYSICAL_EXAMINATION = "PHYSICAL_EXAMINATION",
}


export type AssessmentBodyPartMMIStatus = {
  __typename: "AssessmentBodyPartMMIStatus",
  discussByBodyPart?: boolean | null,
  allBodyPartsMMI?: AssessmentBodyPartEvaluation | null,
  bodyPartMMIStatuses?:  Array<AssessmentBodyPart | null > | null,
};

export type AssessmentBodyPartEvaluation = {
  __typename: "AssessmentBodyPartEvaluation",
  mmi?: boolean | null,
  mmiReason?: string | null,
  expectedMMITimeRange?: AssessmentMmiTimeRange | null,
  expectedMMITimeRangeExplanation?: string | null,
  treatments?: Array< string | null > | null,
  treatmentsExplanation?: string | null,
  discussions?: string | null,
  impairmentRating?: string | null,
  impairmentRatingNotApplicable?: boolean | null,
  deferImpairmentRating?: boolean | null,
  deferImpairmentRatingReason?: string | null,
  apportionment?: string | null,
  apportionmentNotApplicable?: boolean | null,
  deferApportionment?: boolean | null,
  deferApportionmentReason?: string | null,
};

export enum AssessmentMmiTimeRange {
  LESS_THAN_3_MONTHS = "LESS_THAN_3_MONTHS",
  FROM_3_TO_6_MONTHS = "FROM_3_TO_6_MONTHS",
  FROM_6_TO_9_MONTHS = "FROM_6_TO_9_MONTHS",
  FROM_9_TO_12_MONTHS = "FROM_9_TO_12_MONTHS",
  MORE_THAN_12_MONTHS = "MORE_THAN_12_MONTHS",
  OTHER = "OTHER",
}


export type AssessmentBodyPart = {
  __typename: "AssessmentBodyPart",
  bodyPart?: BodyPart | null,
  evaluation?: AssessmentBodyPartEvaluation | null,
};

export type AssessmentFreeForm = {
  __typename: "AssessmentFreeForm",
  injuries?:  Array<AssessmentInjury | null > | null,
  discussions?: string | null,
  diagnosesAndEvidence?: string | null,
  causation?: string | null,
  hasPatientReachedMMI?: string | null,
  discussMMIByBodyPart?: string | null,
  impairmentRatingByBodyPart?: string | null,
  apportionmentByBodyPart?: string | null,
  workStatus?: string | null,
};

export type Validation = {
  __typename: "Validation",
  id: string,
  issueGroups: Array< string | null >,
  issues?: ModelValidationIssueConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelValidationIssueConnection = {
  __typename: "ModelValidationIssueConnection",
  items:  Array<ValidationIssue | null >,
  nextToken?: string | null,
};

export type ValidationIssue = {
  __typename: "ValidationIssue",
  id: string,
  validationID: string,
  validationCheckID: string,
  title?: string | null,
  issue: string,
  status: ValidationStatus,
  resourceURI: string,
  issueGroup: string,
  issueType?: ValidationIssueType | null,
  createdAt: string,
  updatedAt: string,
};

export enum ValidationStatus {
  IN_PROGRESS = "IN_PROGRESS",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  RESOLVED = "RESOLVED",
}


export enum ValidationIssueType {
  ERROR = "ERROR",
  WARNING = "WARNING",
}


export type OpinionRecap = {
  __typename: "OpinionRecap",
  id: string,
  appointmentRecordID: string,
  causation?: string | null,
  diagnosis?: string | null,
  mmiFutureMedicalTreatment?: string | null,
  impairmentRating?: string | null,
  apportionment?: string | null,
  workStatus?: string | null,
  sourceReportFileID?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type AppointmentFeatureConfig = {
  __typename: "AppointmentFeatureConfig",
  featureFlagKey: string,
  enabled: boolean,
};

export type OpsChecklist = {
  __typename: "OpsChecklist",
  panel?: OpsChecklistItemStatus | null,
  contact_info?: OpsChecklistItemStatus | null,
  all_parties?: OpsChecklistItemStatus | null,
  notice_110?: OpsChecklistItemStatus | null,
  cover_letter?: OpsChecklistItemStatus | null,
  record_review?: OpsChecklistItemStatus | null,
  history_call?: OpsChecklistItemStatus | null,
  history_of_injury?: OpsChecklistItemStatus | null,
  interpreter_info?: OpsChecklistItemStatus | null,
  jotform?: OpsChecklistItemStatus | null,
  deu_100?: OpsChecklistItemStatus | null,
  final_report?: OpsChecklistItemStatus | null,
};

export enum OpsChecklistItemStatus {
  MISSING = "MISSING",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  PARTIAL = "PARTIAL",
  UPLOADED = "UPLOADED",
  GENERATING = "GENERATING",
  GENERATED = "GENERATED",
  IN_PROGRESS = "IN_PROGRESS",
  CLEANED = "CLEANED",
  PUBLISHED = "PUBLISHED",
  SCHEDULED = "SCHEDULED",
  CONFIRMED = "CONFIRMED",
  SCHEDULED_CALL = "SCHEDULED_CALL",
  SCHEDULED_PARTY = "SCHEDULED_PARTY",
  COMPLETED = "COMPLETED",
  COMPLETED_WITHOUT_RECORDS = "COMPLETED_WITHOUT_RECORDS",
  COMPLETED_ON_SITE = "COMPLETED_ON_SITE",
  NO_SHOW = "NO_SHOW",
  READY = "READY",
  INCOMPLETE = "INCOMPLETE",
}


export type ParticipantContactUnavailability = {
  __typename: "ParticipantContactUnavailability",
  patient?: ContactUnavailability | null,
  adjuster?: ContactUnavailability | null,
  applicantAttorney?: ContactUnavailability | null,
  defenseAttorney?: ContactUnavailability | null,
};

export type ContactUnavailability = {
  __typename: "ContactUnavailability",
  emailUnavailable?: boolean | null,
  phoneUnavailable?: boolean | null,
};

export type HistoryValidation = {
  __typename: "HistoryValidation",
  id: string,
  appointmentRecordID: string,
  status: HistoryValidationStatus,
  groups:  Array<HistoryValidationGroup | null >,
  validatedAt?: string | null,
  errorMessage?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum HistoryValidationStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}


export type HistoryValidationGroup = {
  __typename: "HistoryValidationGroup",
  id: string,
  title: string,
  status: HistoryValidationGroupStatus,
  issues:  Array<HistoryValidationIssue | null >,
};

export enum HistoryValidationGroupStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
}


export type HistoryValidationIssue = {
  __typename: "HistoryValidationIssue",
  id: string,
  title: string,
  description?: string | null,
  patientInfoSection?: PatientInfoSection | null,
  issueType?: ValidationIssueType | null,
};

export enum PatientInfoSection {
  RECAP_OF_COVER_LETTERS = "RECAP_OF_COVER_LETTERS",
  IDENTIFICATION = "IDENTIFICATION",
  EMPLOYER_AT_INJURY = "EMPLOYER_AT_INJURY",
  POST_INJURY_JOBS = "POST_INJURY_JOBS",
  PREVIOUS_EMPLOYERS = "PREVIOUS_EMPLOYERS",
  MEDICAL_HISTORY = "MEDICAL_HISTORY",
  HISTORY_OF_INJURY = "HISTORY_OF_INJURY",
  CURRENT_COMPLAINT = "CURRENT_COMPLAINT",
  SELF_CARE = "SELF_CARE",
  COMMUNICATION = "COMMUNICATION",
  PHYSICAL_ACTIVITIES = "PHYSICAL_ACTIVITIES",
  SENSORY_FUNCTIONS = "SENSORY_FUNCTIONS",
  TRAVEL = "TRAVEL",
  SLEEP_AND_OTHER = "SLEEP_AND_OTHER",
}


export type AdditionalTimeslot = {
  __typename: "AdditionalTimeslot",
  date: string,
  time: string,
  locationID?: string | null,
};

export enum BriefingModelVersion {
  V1 = "V1",
  V2 = "V2",
}


export type ModelUploadedFileConnection = {
  __typename: "ModelUploadedFileConnection",
  items:  Array<UploadedFile | null >,
  nextToken?: string | null,
};

export type UpdateUploadedFileInput = {
  id: string,
  key?: string | null,
  fileName?: string | null,
  type?: FileType | null,
  provider?: FileProvider | null,
  uploadedBy?: string | null,
  uploadedAt?: string | null,
  fileSizeBytes?: number | null,
  fileSetID?: string | null,
  sourceAppointmentID?: string | null,
};

export type DeleteUploadedFileInput = {
  id: string,
};

export type CreateDocumentInput = {
  id?: string | null,
  uploadedFileID: string,
  providerTag?: string | null,
  pageCount: number,
  executionArn: string,
  recordBriefingId?: string | null,
  segmentSplits?: Array< number | null > | null,
  segmentIntervals?: Array< SegmentIntervalInput | null > | null,
  preview?: S3BlobInput | null,
  hasUnresolvedSplits?: boolean | null,
  videoDurationSeconds?: number | null,
  documentMrrValidationId?: string | null,
};

export type SegmentIntervalInput = {
  startPageNumber: number,
  endPageNumber: number,
  startLineNumber?: number | null,
  endLineNumber?: number | null,
  confidence?: number | null,
  confidenceReasoning?: string | null,
  edited?: boolean | null,
  needsReSummary?: boolean | null,
};

export type S3BlobInput = {
  bucket: string,
  key: string,
};

export type ModelDocumentConditionInput = {
  uploadedFileID?: ModelIDInput | null,
  providerTag?: ModelStringInput | null,
  pageCount?: ModelIntInput | null,
  executionArn?: ModelStringInput | null,
  recordBriefingId?: ModelIDInput | null,
  segmentSplits?: ModelIntInput | null,
  hasUnresolvedSplits?: ModelBooleanInput | null,
  videoDurationSeconds?: ModelFloatInput | null,
  and?: Array< ModelDocumentConditionInput | null > | null,
  or?: Array< ModelDocumentConditionInput | null > | null,
  not?: ModelDocumentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  documentMrrValidationId?: ModelIDInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type Document = {
  __typename: "Document",
  id: string,
  uploadedFileID: string,
  providerTag?: string | null,
  pageCount: number,
  executionArn: string,
  recordBriefingId?: string | null,
  segmentSplits?: Array< number | null > | null,
  segmentIntervals?:  Array<SegmentInterval | null > | null,
  segmentIntervalRows?: ModelDocumentSegmentIntervalConnection | null,
  pages?: ModelDocumentPageConnection | null,
  preview?: S3Blob | null,
  hasUnresolvedSplits?: boolean | null,
  videoDurationSeconds?: number | null,
  ingestionSteps?: ModelDocumentIngestionStepConnection | null,
  mrrValidation?: Validation | null,
  createdAt: string,
  updatedAt: string,
  documentMrrValidationId?: string | null,
};

export type SegmentInterval = {
  __typename: "SegmentInterval",
  startPageNumber: number,
  endPageNumber: number,
  startLineNumber?: number | null,
  endLineNumber?: number | null,
  confidence?: number | null,
  confidenceReasoning?: string | null,
  edited?: boolean | null,
  needsReSummary?: boolean | null,
};

export type ModelDocumentSegmentIntervalConnection = {
  __typename: "ModelDocumentSegmentIntervalConnection",
  items:  Array<DocumentSegmentInterval | null >,
  nextToken?: string | null,
};

export type DocumentSegmentInterval = {
  __typename: "DocumentSegmentInterval",
  id: string,
  documentID: string,
  startPageNumber: number,
  endPageNumber: number,
  startLineNumber?: number | null,
  endLineNumber?: number | null,
  confidence?: number | null,
  confidenceReasoning?: string | null,
  edited?: boolean | null,
  needsReSummary?: boolean | null,
  archived?: boolean | null,
  parentIntervals?: Array< string > | null,
  lastEditAction?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelDocumentPageConnection = {
  __typename: "ModelDocumentPageConnection",
  items:  Array<DocumentPage | null >,
  nextToken?: string | null,
};

export type DocumentPage = {
  __typename: "DocumentPage",
  id: string,
  documentID: string,
  pageNumber: number,
  imageS3Key?: string | null,
  text?: string | null,
  isBlank?: boolean | null,
  citations?: ModelCitationConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelCitationConnection = {
  __typename: "ModelCitationConnection",
  items:  Array<Citation | null >,
  nextToken?: string | null,
};

export type Citation = {
  __typename: "Citation",
  id: string,
  documentPageID: string,
  documentID: string,
  pageNumber: number,
  blockIndex: number,
  text: string,
  bbox: BoundingBox,
  createdAt: string,
  updatedAt: string,
};

export type BoundingBox = {
  __typename: "BoundingBox",
  yMin: number,
  xMin: number,
  yMax: number,
  xMax: number,
};

export type S3Blob = {
  __typename: "S3Blob",
  bucket: string,
  key: string,
};

export type ModelDocumentIngestionStepConnection = {
  __typename: "ModelDocumentIngestionStepConnection",
  items:  Array<DocumentIngestionStep | null >,
  nextToken?: string | null,
};

export type DocumentIngestionStep = {
  __typename: "DocumentIngestionStep",
  id: string,
  documentID: string,
  name: string,
  status: IngestionStepStatus,
  startedAt: string,
  endedAt?: string | null,
  errorMessage?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum IngestionStepStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  SKIPPED = "SKIPPED",
}


export type UpdateDocumentInput = {
  id: string,
  uploadedFileID?: string | null,
  providerTag?: string | null,
  pageCount?: number | null,
  executionArn?: string | null,
  recordBriefingId?: string | null,
  segmentSplits?: Array< number | null > | null,
  segmentIntervals?: Array< SegmentIntervalInput | null > | null,
  preview?: S3BlobInput | null,
  hasUnresolvedSplits?: boolean | null,
  videoDurationSeconds?: number | null,
  documentMrrValidationId?: string | null,
};

export type DeleteDocumentInput = {
  id: string,
};

export type CreateDocumentIngestionStepInput = {
  id?: string | null,
  documentID: string,
  name: string,
  status: IngestionStepStatus,
  startedAt: string,
  endedAt?: string | null,
  errorMessage?: string | null,
};

export type ModelDocumentIngestionStepConditionInput = {
  documentID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelIngestionStepStatusInput | null,
  startedAt?: ModelStringInput | null,
  endedAt?: ModelStringInput | null,
  errorMessage?: ModelStringInput | null,
  and?: Array< ModelDocumentIngestionStepConditionInput | null > | null,
  or?: Array< ModelDocumentIngestionStepConditionInput | null > | null,
  not?: ModelDocumentIngestionStepConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelIngestionStepStatusInput = {
  eq?: IngestionStepStatus | null,
  ne?: IngestionStepStatus | null,
};

export type UpdateDocumentIngestionStepInput = {
  id: string,
  documentID?: string | null,
  name?: string | null,
  status?: IngestionStepStatus | null,
  startedAt?: string | null,
  endedAt?: string | null,
  errorMessage?: string | null,
};

export type DeleteDocumentIngestionStepInput = {
  id: string,
};

export type CreateOperationStatusInput = {
  id?: string | null,
  scope: string,
  operation: string,
  name: string,
  status: OperationState,
  startedAt: string,
  heartbeatAt?: string | null,
  endedAt?: string | null,
  attempt?: number | null,
  errorMessage?: string | null,
  correlationId?: string | null,
  metadata?: string | null,
  expiresAt?: number | null,
};

export enum OperationState {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  SKIPPED = "SKIPPED",
}


export type ModelOperationStatusConditionInput = {
  scope?: ModelStringInput | null,
  operation?: ModelStringInput | null,
  name?: ModelStringInput | null,
  status?: ModelOperationStateInput | null,
  startedAt?: ModelStringInput | null,
  heartbeatAt?: ModelStringInput | null,
  endedAt?: ModelStringInput | null,
  attempt?: ModelIntInput | null,
  errorMessage?: ModelStringInput | null,
  correlationId?: ModelStringInput | null,
  metadata?: ModelStringInput | null,
  expiresAt?: ModelIntInput | null,
  and?: Array< ModelOperationStatusConditionInput | null > | null,
  or?: Array< ModelOperationStatusConditionInput | null > | null,
  not?: ModelOperationStatusConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelOperationStateInput = {
  eq?: OperationState | null,
  ne?: OperationState | null,
};

export type OperationStatus = {
  __typename: "OperationStatus",
  id: string,
  scope: string,
  operation: string,
  name: string,
  status: OperationState,
  startedAt: string,
  heartbeatAt?: string | null,
  endedAt?: string | null,
  attempt?: number | null,
  errorMessage?: string | null,
  correlationId?: string | null,
  metadata?: string | null,
  expiresAt?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateOperationStatusInput = {
  id: string,
  scope?: string | null,
  operation?: string | null,
  name?: string | null,
  status?: OperationState | null,
  startedAt?: string | null,
  heartbeatAt?: string | null,
  endedAt?: string | null,
  attempt?: number | null,
  errorMessage?: string | null,
  correlationId?: string | null,
  metadata?: string | null,
  expiresAt?: number | null,
};

export type DeleteOperationStatusInput = {
  id: string,
};

export type CreateDocumentPageInput = {
  id?: string | null,
  documentID: string,
  pageNumber: number,
  imageS3Key?: string | null,
  text?: string | null,
  isBlank?: boolean | null,
};

export type ModelDocumentPageConditionInput = {
  documentID?: ModelIDInput | null,
  pageNumber?: ModelIntInput | null,
  imageS3Key?: ModelStringInput | null,
  text?: ModelStringInput | null,
  isBlank?: ModelBooleanInput | null,
  and?: Array< ModelDocumentPageConditionInput | null > | null,
  or?: Array< ModelDocumentPageConditionInput | null > | null,
  not?: ModelDocumentPageConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateDocumentPageInput = {
  id: string,
  documentID?: string | null,
  pageNumber?: number | null,
  imageS3Key?: string | null,
  text?: string | null,
  isBlank?: boolean | null,
};

export type DeleteDocumentPageInput = {
  id: string,
};

export type CreateDocumentSegmentIntervalInput = {
  id?: string | null,
  documentID: string,
  startPageNumber: number,
  endPageNumber: number,
  startLineNumber?: number | null,
  endLineNumber?: number | null,
  confidence?: number | null,
  confidenceReasoning?: string | null,
  edited?: boolean | null,
  needsReSummary?: boolean | null,
  archived?: boolean | null,
  parentIntervals?: Array< string > | null,
  lastEditAction?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
};

export type ModelDocumentSegmentIntervalConditionInput = {
  documentID?: ModelIDInput | null,
  startPageNumber?: ModelIntInput | null,
  endPageNumber?: ModelIntInput | null,
  startLineNumber?: ModelIntInput | null,
  endLineNumber?: ModelIntInput | null,
  confidence?: ModelFloatInput | null,
  confidenceReasoning?: ModelStringInput | null,
  edited?: ModelBooleanInput | null,
  needsReSummary?: ModelBooleanInput | null,
  archived?: ModelBooleanInput | null,
  parentIntervals?: ModelIDInput | null,
  lastEditAction?: ModelStringInput | null,
  lastEditedAt?: ModelStringInput | null,
  lastEditedBy?: ModelStringInput | null,
  and?: Array< ModelDocumentSegmentIntervalConditionInput | null > | null,
  or?: Array< ModelDocumentSegmentIntervalConditionInput | null > | null,
  not?: ModelDocumentSegmentIntervalConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateDocumentSegmentIntervalInput = {
  id: string,
  documentID?: string | null,
  startPageNumber?: number | null,
  endPageNumber?: number | null,
  startLineNumber?: number | null,
  endLineNumber?: number | null,
  confidence?: number | null,
  confidenceReasoning?: string | null,
  edited?: boolean | null,
  needsReSummary?: boolean | null,
  archived?: boolean | null,
  parentIntervals?: Array< string > | null,
  lastEditAction?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
};

export type DeleteDocumentSegmentIntervalInput = {
  id: string,
};

export type CreateAudioInput = {
  id?: string | null,
  uploadedFileID: string,
  executionArn?: string | null,
  fileFormat: string,
  durationSeconds?: number | null,
  transcript?: S3BlobInput | null,
  transcriptWordCount?: number | null,
  transcriptGrammarCorrected?: S3BlobInput | null,
  transcriptGrammarCorrectedWordCount?: number | null,
  transcriptPreview?: S3BlobInput | null,
  detectedLanguages?: Array< Language | null > | null,
};

export type ModelAudioConditionInput = {
  uploadedFileID?: ModelIDInput | null,
  executionArn?: ModelStringInput | null,
  fileFormat?: ModelStringInput | null,
  durationSeconds?: ModelFloatInput | null,
  transcriptWordCount?: ModelIntInput | null,
  transcriptGrammarCorrectedWordCount?: ModelIntInput | null,
  detectedLanguages?: ModelLanguageListInput | null,
  and?: Array< ModelAudioConditionInput | null > | null,
  or?: Array< ModelAudioConditionInput | null > | null,
  not?: ModelAudioConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLanguageListInput = {
  eq?: Array< Language | null > | null,
  ne?: Array< Language | null > | null,
  contains?: Language | null,
  notContains?: Language | null,
};

export type Audio = {
  __typename: "Audio",
  id: string,
  uploadedFileID: string,
  executionArn?: string | null,
  fileFormat: string,
  durationSeconds?: number | null,
  transcript?: S3Blob | null,
  transcriptWordCount?: number | null,
  transcriptGrammarCorrected?: S3Blob | null,
  transcriptGrammarCorrectedWordCount?: number | null,
  transcriptPreview?: S3Blob | null,
  detectedLanguages?: Array< Language | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateAudioInput = {
  id: string,
  uploadedFileID?: string | null,
  executionArn?: string | null,
  fileFormat?: string | null,
  durationSeconds?: number | null,
  transcript?: S3BlobInput | null,
  transcriptWordCount?: number | null,
  transcriptGrammarCorrected?: S3BlobInput | null,
  transcriptGrammarCorrectedWordCount?: number | null,
  transcriptPreview?: S3BlobInput | null,
  detectedLanguages?: Array< Language | null > | null,
};

export type DeleteAudioInput = {
  id: string,
};

export type CreateHistoryTranscriptInput = {
  id?: string | null,
  uploadedFileID: string,
  callId?: string | null,
  recordingId?: string | null,
  callStartTime?: string | null,
  callDurationSeconds?: number | null,
};

export type ModelHistoryTranscriptConditionInput = {
  uploadedFileID?: ModelIDInput | null,
  callId?: ModelStringInput | null,
  recordingId?: ModelStringInput | null,
  callStartTime?: ModelStringInput | null,
  callDurationSeconds?: ModelIntInput | null,
  and?: Array< ModelHistoryTranscriptConditionInput | null > | null,
  or?: Array< ModelHistoryTranscriptConditionInput | null > | null,
  not?: ModelHistoryTranscriptConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type HistoryTranscript = {
  __typename: "HistoryTranscript",
  id: string,
  uploadedFileID: string,
  callId?: string | null,
  recordingId?: string | null,
  callStartTime?: string | null,
  callDurationSeconds?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateHistoryTranscriptInput = {
  id: string,
  uploadedFileID?: string | null,
  callId?: string | null,
  recordingId?: string | null,
  callStartTime?: string | null,
  callDurationSeconds?: number | null,
};

export type DeleteHistoryTranscriptInput = {
  id: string,
};

export type CreatePanelFileInput = {
  id?: string | null,
  uploadedFileID: string,
  sourceAppointmentID?: string | null,
  correlationId?: string | null,
  panelNumber?: string | null,
  panelIssueDate?: string | null,
  numberOfRequests?: number | null,
  requestingParty?: ParticipantType | null,
  claim?: PanelClaimInfoInput | null,
  patient?: PanelPatientInfoInput | null,
  employer?: PanelEmployerInfoInput | null,
  adjuster?: PanelPartyInfoInput | null,
  applicantAttorney?: PanelPartyInfoInput | null,
  defenseAttorney?: PanelPartyInfoInput | null,
  physicians?: Array< PanelPhysicianInput | null > | null,
};

export type PanelClaimInfoInput = {
  claimNumber?: string | null,
  dateOfInjury?: string | null,
};

export type PanelPatientInfoInput = {
  name?: string | null,
  address?: PanelAddressInput | null,
};

export type PanelAddressInput = {
  street?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
};

export type PanelEmployerInfoInput = {
  name?: string | null,
  address?: PanelAddressInput | null,
};

export type PanelPartyInfoInput = {
  name?: string | null,
  company?: string | null,
  address?: PanelAddressInput | null,
};

export type PanelPhysicianInput = {
  name?: string | null,
  specialty?: string | null,
  address?: PanelAddressInput | null,
  yearsInPractice?: number | null,
  education?: string | null,
  phoneNumber?: string | null,
  isStruck?: boolean | null,
  strikeDate?: string | null,
  strikeParty?: ParticipantType | null,
};

export type ModelPanelFileConditionInput = {
  uploadedFileID?: ModelIDInput | null,
  sourceAppointmentID?: ModelIDInput | null,
  correlationId?: ModelStringInput | null,
  panelNumber?: ModelStringInput | null,
  panelIssueDate?: ModelStringInput | null,
  numberOfRequests?: ModelIntInput | null,
  requestingParty?: ModelParticipantTypeInput | null,
  and?: Array< ModelPanelFileConditionInput | null > | null,
  or?: Array< ModelPanelFileConditionInput | null > | null,
  not?: ModelPanelFileConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelParticipantTypeInput = {
  eq?: ParticipantType | null,
  ne?: ParticipantType | null,
};

export type PanelFile = {
  __typename: "PanelFile",
  id: string,
  uploadedFileID: string,
  sourceAppointmentID?: string | null,
  correlationId?: string | null,
  panelNumber?: string | null,
  panelIssueDate?: string | null,
  numberOfRequests?: number | null,
  requestingParty?: ParticipantType | null,
  claim?: PanelClaimInfo | null,
  patient?: PanelPatientInfo | null,
  employer?: PanelEmployerInfo | null,
  adjuster?: PanelPartyInfo | null,
  applicantAttorney?: PanelPartyInfo | null,
  defenseAttorney?: PanelPartyInfo | null,
  physicians?:  Array<PanelPhysician | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type PanelClaimInfo = {
  __typename: "PanelClaimInfo",
  claimNumber?: string | null,
  dateOfInjury?: string | null,
};

export type PanelPatientInfo = {
  __typename: "PanelPatientInfo",
  name?: string | null,
  address?: PanelAddress | null,
};

export type PanelAddress = {
  __typename: "PanelAddress",
  street?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
};

export type PanelEmployerInfo = {
  __typename: "PanelEmployerInfo",
  name?: string | null,
  address?: PanelAddress | null,
};

export type PanelPartyInfo = {
  __typename: "PanelPartyInfo",
  name?: string | null,
  company?: string | null,
  address?: PanelAddress | null,
};

export type PanelPhysician = {
  __typename: "PanelPhysician",
  name?: string | null,
  specialty?: string | null,
  address?: PanelAddress | null,
  yearsInPractice?: number | null,
  education?: string | null,
  phoneNumber?: string | null,
  isStruck?: boolean | null,
  strikeDate?: string | null,
  strikeParty?: ParticipantType | null,
};

export type UpdatePanelFileInput = {
  id: string,
  uploadedFileID?: string | null,
  sourceAppointmentID?: string | null,
  correlationId?: string | null,
  panelNumber?: string | null,
  panelIssueDate?: string | null,
  numberOfRequests?: number | null,
  requestingParty?: ParticipantType | null,
  claim?: PanelClaimInfoInput | null,
  patient?: PanelPatientInfoInput | null,
  employer?: PanelEmployerInfoInput | null,
  adjuster?: PanelPartyInfoInput | null,
  applicantAttorney?: PanelPartyInfoInput | null,
  defenseAttorney?: PanelPartyInfoInput | null,
  physicians?: Array< PanelPhysicianInput | null > | null,
};

export type DeletePanelFileInput = {
  id: string,
};

export type CreateNotesInput = {
  id?: string | null,
  content?: string | null,
  type?: NotesType | null,
  timeStamp?: number | null,
  appointmentrecordID: string,
  notesAuthorId?: string | null,
};

export type ModelNotesConditionInput = {
  content?: ModelStringInput | null,
  type?: ModelNotesTypeInput | null,
  timeStamp?: ModelIntInput | null,
  appointmentrecordID?: ModelIDInput | null,
  and?: Array< ModelNotesConditionInput | null > | null,
  or?: Array< ModelNotesConditionInput | null > | null,
  not?: ModelNotesConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  notesAuthorId?: ModelIDInput | null,
};

export type ModelNotesTypeInput = {
  eq?: NotesType | null,
  ne?: NotesType | null,
};

export type UpdateNotesInput = {
  id: string,
  content?: string | null,
  type?: NotesType | null,
  timeStamp?: number | null,
  appointmentrecordID?: string | null,
  notesAuthorId?: string | null,
};

export type DeleteNotesInput = {
  id: string,
};

export type CreateHuddleNoteInput = {
  id?: string | null,
  appointmentRecordID: string,
  contentMarkdown?: string | null,
};

export type ModelHuddleNoteConditionInput = {
  appointmentRecordID?: ModelIDInput | null,
  contentMarkdown?: ModelStringInput | null,
  and?: Array< ModelHuddleNoteConditionInput | null > | null,
  or?: Array< ModelHuddleNoteConditionInput | null > | null,
  not?: ModelHuddleNoteConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateHuddleNoteInput = {
  id: string,
  appointmentRecordID?: string | null,
  contentMarkdown?: string | null,
};

export type DeleteHuddleNoteInput = {
  id: string,
};

export type CreateMedicalAssistantInput = {
  id?: string | null,
  name?: string | null,
  email?: string | null,
  preVisitCallScheduleLink?: string | null,
  enableCalendarNotify?: boolean | null,
  inactive?: boolean | null,
  languages?: Array< Language > | null,
  assignmentCriteria?: MedicalAssistantAppointmentAssignmentCriteriaInput | null,
  isDemo?: boolean | null,
  dismissedProTips?: Array< string | null > | null,
  phoneNumber?: string | null,
  joinedDate?: string | null,
  level?: number | null,
  capacityPercent?: number | null,
  availabilityExceptions?: Array< AvailabilityExceptionInput | null > | null,
  roles?: Array< OpsRole > | null,
  medicalAssistantUserId?: string | null,
};

export type MedicalAssistantAppointmentAssignmentCriteriaInput = {
  languageWeights: Array< LanguageWeightInput >,
};

export type LanguageWeightInput = {
  language: Language,
  weight: number,
  doctorSpecialty?: SpecialtyType | null,
};

export type AvailabilityExceptionInput = {
  type: AvailabilityExceptionType,
  during?: DateRangeInput | null,
  startTime?: string | null,
  endTime?: string | null,
  allDay?: boolean | null,
};

export type DateRangeInput = {
  start?: string | null,
  end?: string | null,
};

export type ModelMedicalAssistantConditionInput = {
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  preVisitCallScheduleLink?: ModelStringInput | null,
  enableCalendarNotify?: ModelBooleanInput | null,
  inactive?: ModelBooleanInput | null,
  languages?: ModelLanguageListInput | null,
  isDemo?: ModelBooleanInput | null,
  dismissedProTips?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  joinedDate?: ModelStringInput | null,
  level?: ModelIntInput | null,
  capacityPercent?: ModelIntInput | null,
  roles?: ModelOpsRoleListInput | null,
  and?: Array< ModelMedicalAssistantConditionInput | null > | null,
  or?: Array< ModelMedicalAssistantConditionInput | null > | null,
  not?: ModelMedicalAssistantConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  medicalAssistantUserId?: ModelIDInput | null,
};

export type ModelOpsRoleListInput = {
  eq?: Array< OpsRole | null > | null,
  ne?: Array< OpsRole | null > | null,
  contains?: OpsRole | null,
  notContains?: OpsRole | null,
};

export type UpdateMedicalAssistantInput = {
  id: string,
  name?: string | null,
  email?: string | null,
  preVisitCallScheduleLink?: string | null,
  enableCalendarNotify?: boolean | null,
  inactive?: boolean | null,
  languages?: Array< Language > | null,
  assignmentCriteria?: MedicalAssistantAppointmentAssignmentCriteriaInput | null,
  isDemo?: boolean | null,
  dismissedProTips?: Array< string | null > | null,
  phoneNumber?: string | null,
  joinedDate?: string | null,
  level?: number | null,
  capacityPercent?: number | null,
  availabilityExceptions?: Array< AvailabilityExceptionInput | null > | null,
  roles?: Array< OpsRole > | null,
  medicalAssistantUserId?: string | null,
};

export type DeleteMedicalAssistantInput = {
  id: string,
};

export type CreateUserInput = {
  id?: string | null,
  cognitoUserId: string,
  avatarUrl?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  onboardingDismissals?: Array< OnboardingDismissalInput | null > | null,
  settings?: UserSettingsInput | null,
  userDoctorId?: string | null,
  userAssistantId?: string | null,
};

export type OnboardingDismissalInput = {
  itemId: string,
  dismissedAt: string,
};

export type UserSettingsInput = {
  opsChecklistDefaultExpanded?: boolean | null,
};

export type ModelUserConditionInput = {
  cognitoUserId?: ModelIDInput | null,
  avatarUrl?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userDoctorId?: ModelIDInput | null,
  userAssistantId?: ModelIDInput | null,
};

export type UpdateUserInput = {
  id: string,
  cognitoUserId?: string | null,
  avatarUrl?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  onboardingDismissals?: Array< OnboardingDismissalInput | null > | null,
  settings?: UserSettingsInput | null,
  userDoctorId?: string | null,
  userAssistantId?: string | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreateStoredAddressInput = {
  id?: string | null,
  street?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
  insuranceCarrierID?: string | null,
  lawFirmID?: string | null,
};

export type ModelStoredAddressConditionInput = {
  street?: ModelStringInput | null,
  city?: ModelStringInput | null,
  state?: ModelStringInput | null,
  zip?: ModelStringInput | null,
  insuranceCarrierID?: ModelIDInput | null,
  lawFirmID?: ModelIDInput | null,
  and?: Array< ModelStoredAddressConditionInput | null > | null,
  or?: Array< ModelStoredAddressConditionInput | null > | null,
  not?: ModelStoredAddressConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateStoredAddressInput = {
  id: string,
  street?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
  insuranceCarrierID?: string | null,
  lawFirmID?: string | null,
};

export type DeleteStoredAddressInput = {
  id: string,
};

export type CreateStoredFaxNumberInput = {
  id?: string | null,
  faxNumber?: string | null,
  insuranceCarrierID?: string | null,
  lawFirmID?: string | null,
};

export type ModelStoredFaxNumberConditionInput = {
  faxNumber?: ModelStringInput | null,
  insuranceCarrierID?: ModelIDInput | null,
  lawFirmID?: ModelIDInput | null,
  and?: Array< ModelStoredFaxNumberConditionInput | null > | null,
  or?: Array< ModelStoredFaxNumberConditionInput | null > | null,
  not?: ModelStoredFaxNumberConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateStoredFaxNumberInput = {
  id: string,
  faxNumber?: string | null,
  insuranceCarrierID?: string | null,
  lawFirmID?: string | null,
};

export type DeleteStoredFaxNumberInput = {
  id: string,
};

export type CreateStoredPhoneNumberInput = {
  id?: string | null,
  phoneNumber?: string | null,
  extension?: string | null,
  insuranceCarrierID?: string | null,
  lawFirmID?: string | null,
};

export type ModelStoredPhoneNumberConditionInput = {
  phoneNumber?: ModelStringInput | null,
  extension?: ModelStringInput | null,
  insuranceCarrierID?: ModelIDInput | null,
  lawFirmID?: ModelIDInput | null,
  and?: Array< ModelStoredPhoneNumberConditionInput | null > | null,
  or?: Array< ModelStoredPhoneNumberConditionInput | null > | null,
  not?: ModelStoredPhoneNumberConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateStoredPhoneNumberInput = {
  id: string,
  phoneNumber?: string | null,
  extension?: string | null,
  insuranceCarrierID?: string | null,
  lawFirmID?: string | null,
};

export type DeleteStoredPhoneNumberInput = {
  id: string,
};

export type CreateFaxJobInput = {
  id?: string | null,
  appointmentID: string,
  uploadedFileID: string,
  recipientParty: FaxRecipientParty,
  recipientEntityID?: string | null,
  faxNumber: string,
  iFaxJobId?: string | null,
  status: FaxJobStatus,
  failureCode?: string | null,
  failureMessage?: string | null,
  submittedAt: string,
  completedAt?: string | null,
  submittedByUserID: string,
};

export enum FaxRecipientParty {
  ADJUSTER = "ADJUSTER",
  APPLICANT_ATTORNEY = "APPLICANT_ATTORNEY",
  DEFENSE_ATTORNEY = "DEFENSE_ATTORNEY",
  ONE_TIME = "ONE_TIME",
}


export enum FaxJobStatus {
  SENDING = "SENDING",
  DELIVERED = "DELIVERED",
  FAILED = "FAILED",
}


export type ModelFaxJobConditionInput = {
  appointmentID?: ModelIDInput | null,
  uploadedFileID?: ModelIDInput | null,
  recipientParty?: ModelFaxRecipientPartyInput | null,
  recipientEntityID?: ModelIDInput | null,
  faxNumber?: ModelStringInput | null,
  iFaxJobId?: ModelStringInput | null,
  status?: ModelFaxJobStatusInput | null,
  failureCode?: ModelStringInput | null,
  failureMessage?: ModelStringInput | null,
  submittedAt?: ModelStringInput | null,
  completedAt?: ModelStringInput | null,
  submittedByUserID?: ModelIDInput | null,
  and?: Array< ModelFaxJobConditionInput | null > | null,
  or?: Array< ModelFaxJobConditionInput | null > | null,
  not?: ModelFaxJobConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelFaxRecipientPartyInput = {
  eq?: FaxRecipientParty | null,
  ne?: FaxRecipientParty | null,
};

export type ModelFaxJobStatusInput = {
  eq?: FaxJobStatus | null,
  ne?: FaxJobStatus | null,
};

export type FaxJob = {
  __typename: "FaxJob",
  id: string,
  appointmentID: string,
  uploadedFileID: string,
  recipientParty: FaxRecipientParty,
  recipientEntityID?: string | null,
  faxNumber: string,
  iFaxJobId?: string | null,
  status: FaxJobStatus,
  failureCode?: string | null,
  failureMessage?: string | null,
  submittedAt: string,
  completedAt?: string | null,
  submittedByUserID: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateFaxJobInput = {
  id: string,
  appointmentID?: string | null,
  uploadedFileID?: string | null,
  recipientParty?: FaxRecipientParty | null,
  recipientEntityID?: string | null,
  faxNumber?: string | null,
  iFaxJobId?: string | null,
  status?: FaxJobStatus | null,
  failureCode?: string | null,
  failureMessage?: string | null,
  submittedAt?: string | null,
  completedAt?: string | null,
  submittedByUserID?: string | null,
};

export type DeleteFaxJobInput = {
  id: string,
};

export type CreateN110PartyDeliveryInput = {
  id?: string | null,
  appointmentID: string,
  uploadedFileID?: string | null,
  party: N110ServiceParty,
  status: N110UploadStatus,
  reason: N110MailReason,
  driveFileID?: string | null,
  uploadedAt?: string | null,
  submittedByUserID: string,
  createdAt?: string | null,
};

export enum N110ServiceParty {
  PATIENT = "PATIENT",
  ADJUSTER = "ADJUSTER",
  APPLICANT_ATTORNEY = "APPLICANT_ATTORNEY",
  DEFENSE_ATTORNEY = "DEFENSE_ATTORNEY",
}


export enum N110UploadStatus {
  UPLOAD_PENDING = "UPLOAD_PENDING",
  UPLOADED = "UPLOADED",
  UPLOAD_FAILED = "UPLOAD_FAILED",
}


export enum N110MailReason {
  MAIL_ONLY = "MAIL_ONLY",
  FAX_FALLBACK = "FAX_FALLBACK",
}


export type ModelN110PartyDeliveryConditionInput = {
  appointmentID?: ModelIDInput | null,
  uploadedFileID?: ModelIDInput | null,
  party?: ModelN110ServicePartyInput | null,
  status?: ModelN110UploadStatusInput | null,
  reason?: ModelN110MailReasonInput | null,
  driveFileID?: ModelStringInput | null,
  uploadedAt?: ModelStringInput | null,
  submittedByUserID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelN110PartyDeliveryConditionInput | null > | null,
  or?: Array< ModelN110PartyDeliveryConditionInput | null > | null,
  not?: ModelN110PartyDeliveryConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelN110ServicePartyInput = {
  eq?: N110ServiceParty | null,
  ne?: N110ServiceParty | null,
};

export type ModelN110UploadStatusInput = {
  eq?: N110UploadStatus | null,
  ne?: N110UploadStatus | null,
};

export type ModelN110MailReasonInput = {
  eq?: N110MailReason | null,
  ne?: N110MailReason | null,
};

export type N110PartyDelivery = {
  __typename: "N110PartyDelivery",
  id: string,
  appointmentID: string,
  uploadedFileID?: string | null,
  party: N110ServiceParty,
  status: N110UploadStatus,
  reason: N110MailReason,
  driveFileID?: string | null,
  uploadedAt?: string | null,
  submittedByUserID: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateN110PartyDeliveryInput = {
  id: string,
  appointmentID?: string | null,
  uploadedFileID?: string | null,
  party?: N110ServiceParty | null,
  status?: N110UploadStatus | null,
  reason?: N110MailReason | null,
  driveFileID?: string | null,
  uploadedAt?: string | null,
  submittedByUserID?: string | null,
  createdAt?: string | null,
};

export type DeleteN110PartyDeliveryInput = {
  id: string,
};

export type CreateInsuranceCarrierInput = {
  id?: string | null,
  name: string,
  defaultAddressID?: string | null,
  defaultFaxNumberID?: string | null,
  defaultPhoneNumberID?: string | null,
  defaultEmail?: string | null,
  supportedDomains?: Array< string | null > | null,
};

export type ModelInsuranceCarrierConditionInput = {
  name?: ModelStringInput | null,
  defaultAddressID?: ModelIDInput | null,
  defaultFaxNumberID?: ModelIDInput | null,
  defaultPhoneNumberID?: ModelIDInput | null,
  defaultEmail?: ModelStringInput | null,
  supportedDomains?: ModelStringInput | null,
  and?: Array< ModelInsuranceCarrierConditionInput | null > | null,
  or?: Array< ModelInsuranceCarrierConditionInput | null > | null,
  not?: ModelInsuranceCarrierConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateInsuranceCarrierInput = {
  id: string,
  name?: string | null,
  defaultAddressID?: string | null,
  defaultFaxNumberID?: string | null,
  defaultPhoneNumberID?: string | null,
  defaultEmail?: string | null,
  supportedDomains?: Array< string | null > | null,
};

export type DeleteInsuranceCarrierInput = {
  id: string,
};

export type CreateLawFirmInput = {
  id?: string | null,
  name: string,
  type: LawFirmType,
  defaultAddressID?: string | null,
  defaultFaxNumberID?: string | null,
  defaultPhoneNumberID?: string | null,
  defaultEmail?: string | null,
  supportedDomains?: Array< string | null > | null,
};

export type ModelLawFirmConditionInput = {
  name?: ModelStringInput | null,
  type?: ModelLawFirmTypeInput | null,
  defaultAddressID?: ModelIDInput | null,
  defaultFaxNumberID?: ModelIDInput | null,
  defaultPhoneNumberID?: ModelIDInput | null,
  defaultEmail?: ModelStringInput | null,
  supportedDomains?: ModelStringInput | null,
  and?: Array< ModelLawFirmConditionInput | null > | null,
  or?: Array< ModelLawFirmConditionInput | null > | null,
  not?: ModelLawFirmConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLawFirmTypeInput = {
  eq?: LawFirmType | null,
  ne?: LawFirmType | null,
};

export type UpdateLawFirmInput = {
  id: string,
  name?: string | null,
  type?: LawFirmType | null,
  defaultAddressID?: string | null,
  defaultFaxNumberID?: string | null,
  defaultPhoneNumberID?: string | null,
  defaultEmail?: string | null,
  supportedDomains?: Array< string | null > | null,
};

export type DeleteLawFirmInput = {
  id: string,
};

export type CreateCaseRecordInput = {
  id?: string | null,
  state?: CaseState | null,
};

export enum CaseState {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
}


export type ModelCaseRecordConditionInput = {
  state?: ModelCaseStateInput | null,
  and?: Array< ModelCaseRecordConditionInput | null > | null,
  or?: Array< ModelCaseRecordConditionInput | null > | null,
  not?: ModelCaseRecordConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelCaseStateInput = {
  eq?: CaseState | null,
  ne?: CaseState | null,
};

export type CaseRecord = {
  __typename: "CaseRecord",
  id: string,
  state?: CaseState | null,
  appointments?: ModelAppointmentRecordConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateCaseRecordInput = {
  id: string,
  state?: CaseState | null,
};

export type DeleteCaseRecordInput = {
  id: string,
};

export type CreateAppointmentRecordInput = {
  id?: string | null,
  doctorOwnerCognitoId?: string | null,
  assistantCognitoIds?: Array< string > | null,
  globalPartitionKey: string,
  originalAppointmentID: string,
  supplementalAppointmentIDs?: Array< string | null > | null,
  supplementalSourceAppointmentIDs?: Array< string | null > | null,
  depositionAppointmentIDs?: Array< string | null > | null,
  depositionSourceAppointmentIDs?: Array< string | null > | null,
  rescheduledFromAppointmentID?: string | null,
  rescheduledToAppointmentID?: string | null,
  date?: string | null,
  yearMonth?: string | null,
  doctorYearMonth?: string | null,
  time?: string | null,
  bookedInFlexibleTime?: boolean | null,
  inquiryDate: string,
  inquiryYearMonth: string,
  type?: AppointmentType | null,
  doctorID?: string | null,
  locationID?: string | null,
  visitForm?: string | null,
  jotformSubmissions?: Array< JotformSubmissionInput | null > | null,
  historyTranscriptPopulations?: Array< HistoryTranscriptPopulationInput | null > | null,
  active?: boolean | null,
  durationMinutes?: number | null,
  reportDue?: string | null,
  reportSubmitted?: string | null,
  status?: AppointmentStatus | null,
  reportStatus?: ReportStatus | null,
  paymentStatus?: PaymentStatus | null,
  billingStatus?: BillingStatus | null,
  difficultyLevel?: number | null,
  scheduler?: ContactPersonInfoInput | null,
  inquirerInfo?: InquirerInfoInput | null,
  employments?: Array< EmploymentRecordInput | null > | null,
  employmentGaps?: Array< EmploymentGapRecordInput | null > | null,
  patientDescribedInjuries?: Array< BodyPart | null > | null,
  uploadedFilesSetID?: string | null,
  referredBy?: string | null,
  s3FileKey?: string | null,
  medicalRecordsReceived?: boolean | null,
  medicalRecordsBriefingFileID?: string | null,
  medicalRecordsBriefingExecutionArn?: string | null,
  medicalRecordsTotalPagesProcessed?: number | null,
  reportGenerationFileID?: string | null,
  reportGenerationExecutionArn?: string | null,
  reportGenerationGeneratedAt?: string | null,
  historyOfInjuryFileID?: string | null,
  historyOfInjuryGeneratedAt?: string | null,
  evaluationFileID?: string | null,
  assessmentFileID?: string | null,
  depositionPreparationFileID?: string | null,
  documentStatus?: DocumentStatusInput | null,
  cancellationReason?: CancellationReason | null,
  cancellationRequestedBy?: ParticipantType | null,
  cancellationRequestedInternally?: boolean | null,
  cancellationNote?: string | null,
  cancellationDate?: string | null,
  inquiryClosingReason?: InquiryClosingReason | null,
  inquiryClosingNote?: string | null,
  inquiryClosingDate?: string | null,
  noShowReason?: NoShowReason | null,
  noShowNote?: string | null,
  reschedulingReason?: ReschedulingReason | null,
  reschedulingOthersReason?: string | null,
  reschedulingRequestedBy?: ParticipantType | null,
  reschedulingRequestedInternally?: boolean | null,
  reschedulingNote?: string | null,
  reschedulingDate?: string | null,
  interpreter?: InterpreterInfoInput | null,
  historyCallDate?: string | null,
  historyCallTime?: string | null,
  historyCallCompleted?: boolean | null,
  historyCallCompletedWithoutRecords?: boolean | null,
  historyCallCompletedOnSite?: boolean | null,
  historyCallNoShow?: boolean | null,
  historyCallCalendarEventID?: string | null,
  historyCallCalendarLink?: string | null,
  billingInfo?: BillingInfoInput | null,
  caseInfo?: CaseInfoInput | null,
  isProd?: boolean | null,
  isDemo?: boolean | null,
  primaryPatientCaseID?: string | null,
  calendarEventID?: string | null,
  reportConfiguration?: ReportConfigurationInput | null,
  impairmentRatingResults?: Array< ImpairmentRatingResultInput | null > | null,
  defenseAttorneyPagesDeclaration?: number | null,
  applicantAttorneyPagesDeclaration?: number | null,
  fieldTemplateRef?: FieldTemplateRefInput | null,
  dataFieldValuesMappings?: Array< DataFieldValueMappingInput | null > | null,
  physicalEvalTemplateRef?: FieldTemplateRefInput | null,
  physicalExamValues?: Array< PhysicalExamValueInput | null > | null,
  physicalExamOtherFindings?: Array< PhysicalExamOtherFindingInput | null > | null,
  tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
  featureFlags?: Array< AppointmentFeatureConfigInput | null > | null,
  opsChecklist?: OpsChecklistInput | null,
  panelUnavailable?: boolean | null,
  panelSpecialty?: SpecialtyType | null,
  defenseAttorneyNotPresent?: boolean | null,
  applicantAttorneyNotPresent?: boolean | null,
  contactUnavailability?: ParticipantContactUnavailabilityInput | null,
  videoCallLink?: string | null,
  additionalTimeslots?: Array< AdditionalTimeslotInput | null > | null,
  caseID?: string | null,
  briefingModelVersion?: BriefingModelVersion | null,
  briefingGdocExportLink?: string | null,
  briefingGdocExportedAt?: string | null,
  appointmentRecordMedicalAssistantId?: string | null,
  appointmentRecordSchedulingAssistantId?: string | null,
  appointmentRecordOnSiteOpId?: string | null,
  appointmentRecordReportOpId?: string | null,
  appointmentRecordBillingOpId?: string | null,
  appointmentRecordPreVisitReviewerId?: string | null,
  appointmentRecordHuddleNoteId?: string | null,
  appointmentRecordHistoryOfInjuryNotesId?: string | null,
  appointmentRecordCurrentComplaintNotesId?: string | null,
  appointmentRecordHistoryCallAssistantId?: string | null,
  appointmentRecordHistoryOfInjuryInsightsId?: string | null,
  appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
  appointmentRecordPhysicalExamInsightsId?: string | null,
  appointmentRecordPastInjuryMatrixId?: string | null,
  appointmentRecordBriefingId?: string | null,
  appointmentRecordIntroParagraphId?: string | null,
  appointmentRecordAssessmentId?: string | null,
  appointmentRecordAssessmentValidationId?: string | null,
  appointmentRecordOpinionRecapId?: string | null,
  appointmentRecordHistoryValidationId?: string | null,
  appointmentRecordPatientHistoryValidationId?: string | null,
  appointmentRecordMrrValidationId?: string | null,
  appointmentRecordHistoryMrrCrossValidationId?: string | null,
};

export type JotformSubmissionInput = {
  id: string,
  receivedAt: string,
  populatedAt?: string | null,
};

export type HistoryTranscriptPopulationInput = {
  uploadedFileID: string,
  populatedAt: string,
};

export type ContactPersonInfoInput = {
  name?: string | null,
  organizationName?: string | null,
  contact?: ContactInfoInput | null,
};

export type ContactInfoInput = {
  phone?: string | null,
  phoneExtension?: string | null,
  email?: string | null,
  address?: AddressInput | null,
  fax?: string | null,
  homePhoneNumber?: string | null,
};

export type AddressInput = {
  street?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
  county?: string | null,
};

export type InquirerInfoInput = {
  contact?: ContactInfoInput | null,
  inquiringParty?: InquiringParty | null,
  name?: string | null,
  inquiryDate?: string | null,
  notification_110_required?: boolean | null,
};

export type EmploymentRecordInput = {
  employerName?: string | null,
  jobTitle?: string | null,
  contact?: ContactInfoInput | null,
  dateOfHire?: string | null,
  dateOfHireFlexible?: FlexibleDateInput | null,
  hoursPerWeek?: string | null,
  jobDuties?: string | null,
  dateOfTermination?: string | null,
  dateOfTerminationFlexible?: FlexibleDateInput | null,
  notes?: string | null,
  stillWorkingHere?: boolean | null,
  type?: EmploymentType | null,
  currentWorkRestrictions?: string | null,
  workStatus?: string | null,
  departureReason?: string | null,
};

export type FlexibleDateInput = {
  value?: string | null,
  precision: DatePrecision,
};

export type EmploymentGapRecordInput = {
  type?: EmploymentGapType | null,
  startDate?: FlexibleDateInput | null,
  endDate?: FlexibleDateInput | null,
  notes?: string | null,
};

export type DocumentStatusInput = {
  evaluationPublished?: boolean | null,
  assessmentPublished?: boolean | null,
  historyInProgress?: boolean | null,
  historyPublished?: boolean | null,
  historyCleaned?: boolean | null,
  reportPublished?: boolean | null,
  briefingInProgress?: boolean | null,
  briefingPublished?: boolean | null,
  briefingCleaned?: boolean | null,
};

export type InterpreterInfoInput = {
  certificateId?: string | null,
  name?: string | null,
  companyName?: string | null,
  phoneNumber?: string | null,
  phoneExtension?: string | null,
  note?: string | null,
  confirmed?: boolean | null,
};

export type BillingInfoInput = {
  diagnosisMappings?: Array< DiagnosisMappingInput | null > | null,
  serviceDetails?: Array< ServiceDetailInput | null > | null,
  totalCharge?: number | null,
  amountPaid?: number | null,
  billingCounter?: number | null,
  billedDate?: string | null,
  paidDate?: string | null,
  correctionDate?: string | null,
};

export type DiagnosisMappingInput = {
  code?: string | null,
  pointer?: string | null,
  description?: string | null,
};

export type ServiceDetailInput = {
  dateOfStart?: string | null,
  dateOfEnd?: string | null,
  place?: number | null,
  emergencyIndicator?: boolean | null,
  serviceType?: ServiceType | null,
  modifiers?: Array< ServiceModifier | null > | null,
  diagnosisPointers?: Array< string | null > | null,
  chargedAmount?: number | null,
  quantity?: number | null,
  amountPaid?: number | null,
  renderingProviderId?: string | null,
};

export type CaseInfoInput = {
  confirmationEmailStatuses?: ParticipantEmailStatusesInput | null,
  recordsFollowupEmailStatuses?: ParticipantEmailStatusesInput | null,
  attendanceEmailStatuses?: ParticipantEmailStatusesInput | null,
};

export type ParticipantEmailStatusesInput = {
  patient?: boolean | null,
  adjuster?: boolean | null,
  applicantAttorney?: boolean | null,
  defenseAttorney?: boolean | null,
  patientSentAt?: string | null,
  adjusterSentAt?: string | null,
  applicantAttorneySentAt?: string | null,
  defenseAttorneySentAt?: string | null,
};

export type ReportConfigurationInput = {
  history?: ReportSource | null,
  physicalExamination?: ReportSource | null,
  assessment?: ReportSource | null,
};

export type ImpairmentRatingResultInput = {
  ts?: number | null,
  bodyParts?: Array< string | null > | null,
  enabledStrictRating?: boolean | null,
  enabledPainRating?: boolean | null,
  enabledAG?: boolean | null,
  enabledStrengthRating?: boolean | null,
  enabledDBE?: boolean | null,
  autoMode?: boolean | null,
  result?: string | null,
  resultFeedback?: ImpairmentRatingResultFeedbackInput | null,
};

export type ImpairmentRatingResultFeedbackInput = {
  exists?: boolean | null,
  isGood?: boolean | null,
  notes?: string | null,
};

export type FieldTemplateRefInput = {
  id: string,
  version: number,
};

export type DataFieldValueMappingInput = {
  dataFieldID?: string | null,
  value?: string | null,
};

export type PhysicalExamValueInput = {
  sectionID: string,
  questionID: string,
  side?: PhysicalExamSide | null,
  value?: string | null,
  note?: string | null,
  excluded?: boolean | null,
};

export type PhysicalExamOtherFindingInput = {
  sectionID: string,
  text?: string | null,
};

export type AppointmentFeatureConfigInput = {
  featureFlagKey: string,
  enabled: boolean,
};

export type OpsChecklistInput = {
  panel?: OpsChecklistItemStatus | null,
  contact_info?: OpsChecklistItemStatus | null,
  all_parties?: OpsChecklistItemStatus | null,
  notice_110?: OpsChecklistItemStatus | null,
  cover_letter?: OpsChecklistItemStatus | null,
  record_review?: OpsChecklistItemStatus | null,
  history_call?: OpsChecklistItemStatus | null,
  history_of_injury?: OpsChecklistItemStatus | null,
  interpreter_info?: OpsChecklistItemStatus | null,
  jotform?: OpsChecklistItemStatus | null,
  deu_100?: OpsChecklistItemStatus | null,
  final_report?: OpsChecklistItemStatus | null,
};

export type ParticipantContactUnavailabilityInput = {
  patient?: ContactUnavailabilityInput | null,
  adjuster?: ContactUnavailabilityInput | null,
  applicantAttorney?: ContactUnavailabilityInput | null,
  defenseAttorney?: ContactUnavailabilityInput | null,
};

export type ContactUnavailabilityInput = {
  emailUnavailable?: boolean | null,
  phoneUnavailable?: boolean | null,
};

export type AdditionalTimeslotInput = {
  date: string,
  time: string,
  locationID?: string | null,
};

export type ModelAppointmentRecordConditionInput = {
  doctorOwnerCognitoId?: ModelIDInput | null,
  assistantCognitoIds?: ModelIDInput | null,
  globalPartitionKey?: ModelStringInput | null,
  originalAppointmentID?: ModelIDInput | null,
  supplementalAppointmentIDs?: ModelIDInput | null,
  supplementalSourceAppointmentIDs?: ModelIDInput | null,
  depositionAppointmentIDs?: ModelIDInput | null,
  depositionSourceAppointmentIDs?: ModelIDInput | null,
  rescheduledFromAppointmentID?: ModelIDInput | null,
  rescheduledToAppointmentID?: ModelIDInput | null,
  date?: ModelStringInput | null,
  yearMonth?: ModelStringInput | null,
  doctorYearMonth?: ModelStringInput | null,
  time?: ModelStringInput | null,
  bookedInFlexibleTime?: ModelBooleanInput | null,
  inquiryDate?: ModelStringInput | null,
  inquiryYearMonth?: ModelStringInput | null,
  type?: ModelAppointmentTypeInput | null,
  doctorID?: ModelIDInput | null,
  locationID?: ModelIDInput | null,
  visitForm?: ModelStringInput | null,
  active?: ModelBooleanInput | null,
  durationMinutes?: ModelIntInput | null,
  reportDue?: ModelStringInput | null,
  reportSubmitted?: ModelStringInput | null,
  status?: ModelAppointmentStatusInput | null,
  reportStatus?: ModelReportStatusInput | null,
  paymentStatus?: ModelPaymentStatusInput | null,
  billingStatus?: ModelBillingStatusInput | null,
  difficultyLevel?: ModelIntInput | null,
  patientDescribedInjuries?: ModelBodyPartListInput | null,
  uploadedFilesSetID?: ModelIDInput | null,
  referredBy?: ModelStringInput | null,
  s3FileKey?: ModelStringInput | null,
  medicalRecordsReceived?: ModelBooleanInput | null,
  medicalRecordsBriefingFileID?: ModelStringInput | null,
  medicalRecordsBriefingExecutionArn?: ModelStringInput | null,
  medicalRecordsTotalPagesProcessed?: ModelIntInput | null,
  reportGenerationFileID?: ModelStringInput | null,
  reportGenerationExecutionArn?: ModelStringInput | null,
  reportGenerationGeneratedAt?: ModelStringInput | null,
  historyOfInjuryFileID?: ModelStringInput | null,
  historyOfInjuryGeneratedAt?: ModelStringInput | null,
  evaluationFileID?: ModelStringInput | null,
  assessmentFileID?: ModelStringInput | null,
  depositionPreparationFileID?: ModelStringInput | null,
  cancellationReason?: ModelCancellationReasonInput | null,
  cancellationRequestedBy?: ModelParticipantTypeInput | null,
  cancellationRequestedInternally?: ModelBooleanInput | null,
  cancellationNote?: ModelStringInput | null,
  cancellationDate?: ModelStringInput | null,
  inquiryClosingReason?: ModelInquiryClosingReasonInput | null,
  inquiryClosingNote?: ModelStringInput | null,
  inquiryClosingDate?: ModelStringInput | null,
  noShowReason?: ModelNoShowReasonInput | null,
  noShowNote?: ModelStringInput | null,
  reschedulingReason?: ModelReschedulingReasonInput | null,
  reschedulingOthersReason?: ModelStringInput | null,
  reschedulingRequestedBy?: ModelParticipantTypeInput | null,
  reschedulingRequestedInternally?: ModelBooleanInput | null,
  reschedulingNote?: ModelStringInput | null,
  reschedulingDate?: ModelStringInput | null,
  historyCallDate?: ModelStringInput | null,
  historyCallTime?: ModelStringInput | null,
  historyCallCompleted?: ModelBooleanInput | null,
  historyCallCompletedWithoutRecords?: ModelBooleanInput | null,
  historyCallCompletedOnSite?: ModelBooleanInput | null,
  historyCallNoShow?: ModelBooleanInput | null,
  historyCallCalendarEventID?: ModelIDInput | null,
  historyCallCalendarLink?: ModelStringInput | null,
  isProd?: ModelBooleanInput | null,
  isDemo?: ModelBooleanInput | null,
  primaryPatientCaseID?: ModelIDInput | null,
  calendarEventID?: ModelIDInput | null,
  defenseAttorneyPagesDeclaration?: ModelIntInput | null,
  applicantAttorneyPagesDeclaration?: ModelIntInput | null,
  tempUploadedIntakeFormS3Keys?: ModelStringInput | null,
  panelUnavailable?: ModelBooleanInput | null,
  panelSpecialty?: ModelSpecialtyTypeInput | null,
  defenseAttorneyNotPresent?: ModelBooleanInput | null,
  applicantAttorneyNotPresent?: ModelBooleanInput | null,
  videoCallLink?: ModelStringInput | null,
  caseID?: ModelIDInput | null,
  briefingModelVersion?: ModelBriefingModelVersionInput | null,
  briefingGdocExportLink?: ModelStringInput | null,
  briefingGdocExportedAt?: ModelStringInput | null,
  and?: Array< ModelAppointmentRecordConditionInput | null > | null,
  or?: Array< ModelAppointmentRecordConditionInput | null > | null,
  not?: ModelAppointmentRecordConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  appointmentRecordMedicalAssistantId?: ModelIDInput | null,
  appointmentRecordSchedulingAssistantId?: ModelIDInput | null,
  appointmentRecordOnSiteOpId?: ModelIDInput | null,
  appointmentRecordReportOpId?: ModelIDInput | null,
  appointmentRecordBillingOpId?: ModelIDInput | null,
  appointmentRecordPreVisitReviewerId?: ModelIDInput | null,
  appointmentRecordHuddleNoteId?: ModelIDInput | null,
  appointmentRecordHistoryOfInjuryNotesId?: ModelIDInput | null,
  appointmentRecordCurrentComplaintNotesId?: ModelIDInput | null,
  appointmentRecordHistoryCallAssistantId?: ModelIDInput | null,
  appointmentRecordHistoryOfInjuryInsightsId?: ModelIDInput | null,
  appointmentRecordReviewOfMedicalRecordsInsightsId?: ModelIDInput | null,
  appointmentRecordPhysicalExamInsightsId?: ModelIDInput | null,
  appointmentRecordPastInjuryMatrixId?: ModelIDInput | null,
  appointmentRecordBriefingId?: ModelIDInput | null,
  appointmentRecordIntroParagraphId?: ModelIDInput | null,
  appointmentRecordAssessmentId?: ModelIDInput | null,
  appointmentRecordAssessmentValidationId?: ModelIDInput | null,
  appointmentRecordOpinionRecapId?: ModelIDInput | null,
  appointmentRecordHistoryValidationId?: ModelIDInput | null,
  appointmentRecordPatientHistoryValidationId?: ModelIDInput | null,
  appointmentRecordMrrValidationId?: ModelIDInput | null,
  appointmentRecordHistoryMrrCrossValidationId?: ModelIDInput | null,
};

export type ModelAppointmentTypeInput = {
  eq?: AppointmentType | null,
  ne?: AppointmentType | null,
};

export type ModelAppointmentStatusInput = {
  eq?: AppointmentStatus | null,
  ne?: AppointmentStatus | null,
};

export type ModelReportStatusInput = {
  eq?: ReportStatus | null,
  ne?: ReportStatus | null,
};

export type ModelPaymentStatusInput = {
  eq?: PaymentStatus | null,
  ne?: PaymentStatus | null,
};

export type ModelBillingStatusInput = {
  eq?: BillingStatus | null,
  ne?: BillingStatus | null,
};

export type ModelBodyPartListInput = {
  eq?: Array< BodyPart | null > | null,
  ne?: Array< BodyPart | null > | null,
  contains?: BodyPart | null,
  notContains?: BodyPart | null,
};

export type ModelCancellationReasonInput = {
  eq?: CancellationReason | null,
  ne?: CancellationReason | null,
};

export type ModelInquiryClosingReasonInput = {
  eq?: InquiryClosingReason | null,
  ne?: InquiryClosingReason | null,
};

export type ModelNoShowReasonInput = {
  eq?: NoShowReason | null,
  ne?: NoShowReason | null,
};

export type ModelReschedulingReasonInput = {
  eq?: ReschedulingReason | null,
  ne?: ReschedulingReason | null,
};

export type ModelSpecialtyTypeInput = {
  eq?: SpecialtyType | null,
  ne?: SpecialtyType | null,
};

export type ModelBriefingModelVersionInput = {
  eq?: BriefingModelVersion | null,
  ne?: BriefingModelVersion | null,
};

export type UpdateAppointmentRecordInput = {
  id: string,
  doctorOwnerCognitoId?: string | null,
  assistantCognitoIds?: Array< string > | null,
  globalPartitionKey?: string | null,
  originalAppointmentID?: string | null,
  supplementalAppointmentIDs?: Array< string | null > | null,
  supplementalSourceAppointmentIDs?: Array< string | null > | null,
  depositionAppointmentIDs?: Array< string | null > | null,
  depositionSourceAppointmentIDs?: Array< string | null > | null,
  rescheduledFromAppointmentID?: string | null,
  rescheduledToAppointmentID?: string | null,
  date?: string | null,
  yearMonth?: string | null,
  doctorYearMonth?: string | null,
  time?: string | null,
  bookedInFlexibleTime?: boolean | null,
  inquiryDate?: string | null,
  inquiryYearMonth?: string | null,
  type?: AppointmentType | null,
  doctorID?: string | null,
  locationID?: string | null,
  visitForm?: string | null,
  jotformSubmissions?: Array< JotformSubmissionInput | null > | null,
  historyTranscriptPopulations?: Array< HistoryTranscriptPopulationInput | null > | null,
  active?: boolean | null,
  durationMinutes?: number | null,
  reportDue?: string | null,
  reportSubmitted?: string | null,
  status?: AppointmentStatus | null,
  reportStatus?: ReportStatus | null,
  paymentStatus?: PaymentStatus | null,
  billingStatus?: BillingStatus | null,
  difficultyLevel?: number | null,
  scheduler?: ContactPersonInfoInput | null,
  inquirerInfo?: InquirerInfoInput | null,
  employments?: Array< EmploymentRecordInput | null > | null,
  employmentGaps?: Array< EmploymentGapRecordInput | null > | null,
  patientDescribedInjuries?: Array< BodyPart | null > | null,
  uploadedFilesSetID?: string | null,
  referredBy?: string | null,
  s3FileKey?: string | null,
  medicalRecordsReceived?: boolean | null,
  medicalRecordsBriefingFileID?: string | null,
  medicalRecordsBriefingExecutionArn?: string | null,
  medicalRecordsTotalPagesProcessed?: number | null,
  reportGenerationFileID?: string | null,
  reportGenerationExecutionArn?: string | null,
  reportGenerationGeneratedAt?: string | null,
  historyOfInjuryFileID?: string | null,
  historyOfInjuryGeneratedAt?: string | null,
  evaluationFileID?: string | null,
  assessmentFileID?: string | null,
  depositionPreparationFileID?: string | null,
  documentStatus?: DocumentStatusInput | null,
  cancellationReason?: CancellationReason | null,
  cancellationRequestedBy?: ParticipantType | null,
  cancellationRequestedInternally?: boolean | null,
  cancellationNote?: string | null,
  cancellationDate?: string | null,
  inquiryClosingReason?: InquiryClosingReason | null,
  inquiryClosingNote?: string | null,
  inquiryClosingDate?: string | null,
  noShowReason?: NoShowReason | null,
  noShowNote?: string | null,
  reschedulingReason?: ReschedulingReason | null,
  reschedulingOthersReason?: string | null,
  reschedulingRequestedBy?: ParticipantType | null,
  reschedulingRequestedInternally?: boolean | null,
  reschedulingNote?: string | null,
  reschedulingDate?: string | null,
  interpreter?: InterpreterInfoInput | null,
  historyCallDate?: string | null,
  historyCallTime?: string | null,
  historyCallCompleted?: boolean | null,
  historyCallCompletedWithoutRecords?: boolean | null,
  historyCallCompletedOnSite?: boolean | null,
  historyCallNoShow?: boolean | null,
  historyCallCalendarEventID?: string | null,
  historyCallCalendarLink?: string | null,
  billingInfo?: BillingInfoInput | null,
  caseInfo?: CaseInfoInput | null,
  isProd?: boolean | null,
  isDemo?: boolean | null,
  primaryPatientCaseID?: string | null,
  calendarEventID?: string | null,
  reportConfiguration?: ReportConfigurationInput | null,
  impairmentRatingResults?: Array< ImpairmentRatingResultInput | null > | null,
  defenseAttorneyPagesDeclaration?: number | null,
  applicantAttorneyPagesDeclaration?: number | null,
  fieldTemplateRef?: FieldTemplateRefInput | null,
  dataFieldValuesMappings?: Array< DataFieldValueMappingInput | null > | null,
  physicalEvalTemplateRef?: FieldTemplateRefInput | null,
  physicalExamValues?: Array< PhysicalExamValueInput | null > | null,
  physicalExamOtherFindings?: Array< PhysicalExamOtherFindingInput | null > | null,
  tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
  featureFlags?: Array< AppointmentFeatureConfigInput | null > | null,
  opsChecklist?: OpsChecklistInput | null,
  panelUnavailable?: boolean | null,
  panelSpecialty?: SpecialtyType | null,
  defenseAttorneyNotPresent?: boolean | null,
  applicantAttorneyNotPresent?: boolean | null,
  contactUnavailability?: ParticipantContactUnavailabilityInput | null,
  videoCallLink?: string | null,
  additionalTimeslots?: Array< AdditionalTimeslotInput | null > | null,
  caseID?: string | null,
  briefingModelVersion?: BriefingModelVersion | null,
  briefingGdocExportLink?: string | null,
  briefingGdocExportedAt?: string | null,
  appointmentRecordMedicalAssistantId?: string | null,
  appointmentRecordSchedulingAssistantId?: string | null,
  appointmentRecordOnSiteOpId?: string | null,
  appointmentRecordReportOpId?: string | null,
  appointmentRecordBillingOpId?: string | null,
  appointmentRecordPreVisitReviewerId?: string | null,
  appointmentRecordHuddleNoteId?: string | null,
  appointmentRecordHistoryOfInjuryNotesId?: string | null,
  appointmentRecordCurrentComplaintNotesId?: string | null,
  appointmentRecordHistoryCallAssistantId?: string | null,
  appointmentRecordHistoryOfInjuryInsightsId?: string | null,
  appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
  appointmentRecordPhysicalExamInsightsId?: string | null,
  appointmentRecordPastInjuryMatrixId?: string | null,
  appointmentRecordBriefingId?: string | null,
  appointmentRecordIntroParagraphId?: string | null,
  appointmentRecordAssessmentId?: string | null,
  appointmentRecordAssessmentValidationId?: string | null,
  appointmentRecordOpinionRecapId?: string | null,
  appointmentRecordHistoryValidationId?: string | null,
  appointmentRecordPatientHistoryValidationId?: string | null,
  appointmentRecordMrrValidationId?: string | null,
  appointmentRecordHistoryMrrCrossValidationId?: string | null,
};

export type DeleteAppointmentRecordInput = {
  id: string,
};

export type CreatePatientInput = {
  id?: string | null,
  name?: string | null,
  dateOfBirth?: string | null,
  SSN?: string | null,
  language?: Language | null,
  dominantHand?: DominantHand | null,
  contact?: ContactInfoInput | null,
  occupation?: string | null,
  sex?: Sex | null,
  weightLb?: number | null,
  height?: HeightInput | null,
};

export type HeightInput = {
  feet?: number | null,
  inches?: number | null,
};

export type ModelPatientConditionInput = {
  name?: ModelStringInput | null,
  dateOfBirth?: ModelStringInput | null,
  SSN?: ModelStringInput | null,
  language?: ModelLanguageInput | null,
  dominantHand?: ModelDominantHandInput | null,
  occupation?: ModelStringInput | null,
  sex?: ModelSexInput | null,
  weightLb?: ModelFloatInput | null,
  and?: Array< ModelPatientConditionInput | null > | null,
  or?: Array< ModelPatientConditionInput | null > | null,
  not?: ModelPatientConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLanguageInput = {
  eq?: Language | null,
  ne?: Language | null,
};

export type ModelDominantHandInput = {
  eq?: DominantHand | null,
  ne?: DominantHand | null,
};

export type ModelSexInput = {
  eq?: Sex | null,
  ne?: Sex | null,
};

export type UpdatePatientInput = {
  id: string,
  name?: string | null,
  dateOfBirth?: string | null,
  SSN?: string | null,
  language?: Language | null,
  dominantHand?: DominantHand | null,
  contact?: ContactInfoInput | null,
  occupation?: string | null,
  sex?: Sex | null,
  weightLb?: number | null,
  height?: HeightInput | null,
};

export type DeletePatientInput = {
  id: string,
};

export type CreatePatientCaseInput = {
  id?: string | null,
  patientID: string,
  claimNumber: string,
  qmePanelNumber?: string | null,
  contact?: ContactInfoInput | null,
  injuryInfo?: InjuryInfoInput | null,
  workersCompInsurance?: WorkersCompInsuranceInfoInput | null,
  insuranceCarrierID?: string | null,
  insuranceCarrierAddressID?: string | null,
  insuranceCarrierFaxNumberID?: string | null,
  insuranceCarrierPhoneNumberID?: string | null,
  applicantAttorney?: AttorneyInfoInput | null,
  applicantAttorneyLawFirmID?: string | null,
  applicantAttorneyAddressID?: string | null,
  applicantAttorneyFaxNumberID?: string | null,
  applicantAttorneyPhoneNumberID?: string | null,
  defenseAttorney?: AttorneyInfoInput | null,
  defenseAttorneyLawFirmID?: string | null,
  defenseAttorneyAddressID?: string | null,
  defenseAttorneyFaxNumberID?: string | null,
  defenseAttorneyPhoneNumberID?: string | null,
  nurseCaseManager?: ContactPersonInfoInput | null,
  ccPerson?: ContactPersonInfoInput | null,
  applicantAttorneyCcEmails?: Array< string | null > | null,
  defenseAttorneyCcEmails?: Array< string | null > | null,
  adjusterCcEmails?: Array< string | null > | null,
  scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
  employmentAtInjury?: EmploymentRecordInput | null,
  WCAB?: string | null,
};

export type InjuryInfoInput = {
  injuryType?: InjuryType | null,
  injuredBodyParts?: Array< BodyPart | null > | null,
  claimedBodyParts?: Array< BodyPart | null > | null,
  description?: string | null,
  dateOfInjury?: string | null,
  dateOfInjuryFlexible?: FlexibleDateInput | null,
  startDateOfInjury?: string | null,
  startDateOfInjuryFlexible?: FlexibleDateInput | null,
};

export type WorkersCompInsuranceInfoInput = {
  insuranceCarrier?: string | null,
  adjuster?: string | null,
  contact?: ContactInfoInput | null,
};

export type AttorneyInfoInput = {
  name?: string | null,
  lawFirmName?: string | null,
  contact?: ContactInfoInput | null,
};

export type ModelPatientCaseConditionInput = {
  patientID?: ModelIDInput | null,
  claimNumber?: ModelStringInput | null,
  qmePanelNumber?: ModelStringInput | null,
  insuranceCarrierID?: ModelIDInput | null,
  insuranceCarrierAddressID?: ModelIDInput | null,
  insuranceCarrierFaxNumberID?: ModelIDInput | null,
  insuranceCarrierPhoneNumberID?: ModelIDInput | null,
  applicantAttorneyLawFirmID?: ModelIDInput | null,
  applicantAttorneyAddressID?: ModelIDInput | null,
  applicantAttorneyFaxNumberID?: ModelIDInput | null,
  applicantAttorneyPhoneNumberID?: ModelIDInput | null,
  defenseAttorneyLawFirmID?: ModelIDInput | null,
  defenseAttorneyAddressID?: ModelIDInput | null,
  defenseAttorneyFaxNumberID?: ModelIDInput | null,
  defenseAttorneyPhoneNumberID?: ModelIDInput | null,
  applicantAttorneyCcEmails?: ModelStringInput | null,
  defenseAttorneyCcEmails?: ModelStringInput | null,
  adjusterCcEmails?: ModelStringInput | null,
  scheduledCommsSuppressedParties?: ModelInquiringPartyListInput | null,
  WCAB?: ModelStringInput | null,
  and?: Array< ModelPatientCaseConditionInput | null > | null,
  or?: Array< ModelPatientCaseConditionInput | null > | null,
  not?: ModelPatientCaseConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelInquiringPartyListInput = {
  eq?: Array< InquiringParty | null > | null,
  ne?: Array< InquiringParty | null > | null,
  contains?: InquiringParty | null,
  notContains?: InquiringParty | null,
};

export type UpdatePatientCaseInput = {
  id: string,
  patientID?: string | null,
  claimNumber?: string | null,
  qmePanelNumber?: string | null,
  contact?: ContactInfoInput | null,
  injuryInfo?: InjuryInfoInput | null,
  workersCompInsurance?: WorkersCompInsuranceInfoInput | null,
  insuranceCarrierID?: string | null,
  insuranceCarrierAddressID?: string | null,
  insuranceCarrierFaxNumberID?: string | null,
  insuranceCarrierPhoneNumberID?: string | null,
  applicantAttorney?: AttorneyInfoInput | null,
  applicantAttorneyLawFirmID?: string | null,
  applicantAttorneyAddressID?: string | null,
  applicantAttorneyFaxNumberID?: string | null,
  applicantAttorneyPhoneNumberID?: string | null,
  defenseAttorney?: AttorneyInfoInput | null,
  defenseAttorneyLawFirmID?: string | null,
  defenseAttorneyAddressID?: string | null,
  defenseAttorneyFaxNumberID?: string | null,
  defenseAttorneyPhoneNumberID?: string | null,
  nurseCaseManager?: ContactPersonInfoInput | null,
  ccPerson?: ContactPersonInfoInput | null,
  applicantAttorneyCcEmails?: Array< string | null > | null,
  defenseAttorneyCcEmails?: Array< string | null > | null,
  adjusterCcEmails?: Array< string | null > | null,
  scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
  employmentAtInjury?: EmploymentRecordInput | null,
  WCAB?: string | null,
};

export type DeletePatientCaseInput = {
  id: string,
};

export type CreateDoctorInput = {
  id?: string | null,
  ownerCognitoId?: string | null,
  firstName?: string | null,
  middleName?: string | null,
  lastName?: string | null,
  name?: string | null,
  signatureName?: string | null,
  status?: DoctorStatus | null,
  ramped?: boolean | null,
  title?: string | null,
  titleExtension?: TitleExtension | null,
  contact?: ContactInfoInput | null,
  officePhone?: string | null,
  cellPhone?: string | null,
  clinicPhone?: string | null,
  workCity?: string | null,
  workState?: string | null,
  collectionRate?: number | null,
  licenseNumber?: string | null,
  licenseRenewalDate?: string | null,
  qmeLicense?: QmeLicenseInput | null,
  specialties?: Array< SpecialtyType | null > | null,
  npi?: string | null,
  bankingInfo?: BankingInfoInput | null,
  availabilities?: AvailabilitiesInput | null,
  availabilitiesNote?: string | null,
  emails?: Array< string | null > | null,
  profileImages?: Array< DoctorProfileImageInput | null > | null,
  qmeReportConfigs?: DoctorQMEReportConfigsInput | null,
  physicalEvalConfigs?: DoctorPhysicalEvalConfigsInput | null,
  signatureDepartment?: string | null,
  profileAssetS3Prefix?: string | null,
  calendarPreference?: CalendarPreferenceInput | null,
  homeOffice?: HomeOfficeInput | null,
  reportFormatPreferences?: ReportFormatPreferencesInput | null,
  evaluationInputPreferences?: EvaluationInputPreferencesInput | null,
  preferredAssessmentMode?: AssessmentMode | null,
  isDemo?: boolean | null,
  fieldTemplateId?: string | null,
  templateFolderLink?: string | null,
  supplementalReportOpsAssignments?: Array< SupplementalReportOpsAssignmentInput | null > | null,
  defaultAppointmentDurationMinutes?: DefaultAppointmentDurationMinutesInput | null,
  defaultEarlyArrivalTimeMinutes?: DefaultEarlyArrivalTimeMinutesInput | null,
  assessmentTreatmentOptions?: Array< string | null > | null,
  dismissedProTips?: Array< string | null > | null,
  doctorPhysicianPartnerId?: string | null,
  doctorDefaultPrimaryOnsiteOpsId?: string | null,
  doctorDefaultSecondaryOnsiteOpsId?: string | null,
  doctorDefaultSchedulerId?: string | null,
  doctorDefaultReportOpsId?: string | null,
  doctorDefaultPreVisitReviewerId?: string | null,
  doctorDefaultBillingOpsId?: string | null,
  doctorDefaultSupplementalReportOpsId?: string | null,
  doctorUserId?: string | null,
};

export type QmeLicenseInput = {
  licenseNumber?: string | null,
  approvalDate?: string | null,
  renewalDate?: string | null,
};

export type BankingInfoInput = {
  bankEntityName?: string | null,
  accountNumber?: string | null,
  routingNumber?: string | null,
};

export type AvailabilitiesInput = {
  generalAvailabilities?: Array< GeneralAvailabilityInput | null > | null,
  additionalAvailabilities?: Array< AdditionalAvailabilityInput | null > | null,
  blackoutDates?: Array< BlackoutDateInput | null > | null,
};

export type GeneralAvailabilityInput = {
  during?: DateRangeInput | null,
  recurrence?: RecurrenceType | null,
  dayOfWeek?: DayOfWeek | null,
  dayOfMonth?: number | null,
  weekOfMonth?: WeekOfMonth | null,
  monthInterval?: number | null,
  startTime?: string | null,
  endTime?: string | null,
  flexibleTimeBefore?: FlexibleTimeWindowInput | null,
  flexibleTimeAfter?: FlexibleTimeWindowInput | null,
  locationIDs?: Array< string | null > | null,
  isAllLocations?: boolean | null,
};

export type FlexibleTimeWindowInput = {
  startTime?: string | null,
  endTime?: string | null,
};

export type AdditionalAvailabilityInput = {
  during?: DateRangeInput | null,
  startTime?: string | null,
  endTime?: string | null,
  flexibleTimeBefore?: FlexibleTimeWindowInput | null,
  flexibleTimeAfter?: FlexibleTimeWindowInput | null,
  locationIDs?: Array< string | null > | null,
  isAllLocations?: boolean | null,
};

export type BlackoutDateInput = {
  during?: DateRangeInput | null,
  startTime?: string | null,
  endTime?: string | null,
  allDay?: boolean | null,
};

export type DoctorProfileImageInput = {
  type?: DoctorProfileImageType | null,
  name?: string | null,
  order?: number | null,
  s3Prefix?: string | null,
  widthInInches?: number | null,
  heightInInches?: number | null,
};

export type DoctorQMEReportConfigsInput = {
  hasIntroTitle?: boolean | null,
  introTemplate?: string | null,
};

export type DoctorPhysicalEvalConfigsInput = {
  templates?: Array< PhysicalEvalTemplateTag | null > | null,
};

export type CalendarPreferenceInput = {
  mailingList?: Array< string | null > | null,
  showPatientFullName?: boolean | null,
  showPatientAddress?: boolean | null,
  showPatientDOB?: boolean | null,
  showPortalLink?: boolean | null,
};

export type HomeOfficeInput = {
  county?: string | null,
  state?: string | null,
};

export type ReportFormatPreferencesInput = {
  evaluationReport: FormatPreferencesInput,
  reEvaluationReport: FormatPreferencesInput,
  supplementalReport: FormatPreferencesInput,
};

export type FormatPreferencesInput = {
  sections: Array< ReportSection >,
  assessmentSubSections: Array< ReportAssessmentSubSection >,
};

export type EvaluationInputPreferencesInput = {
  evaluationReport: ReportInputPreferencesInput,
  reEvaluationReport: ReportInputPreferencesInput,
  supplementalReport: SupplementalReportInputPreferencesInput,
};

export type ReportInputPreferencesInput = {
  history: ReportSource,
  physicalExamination: ReportSource,
  assessment: ReportSource,
};

export type SupplementalReportInputPreferencesInput = {
  assessment: ReportSource,
};

export type SupplementalReportOpsAssignmentInput = {
  medicalAssistantID: string,
  weightPercentage: number,
};

export type DefaultAppointmentDurationMinutesInput = {
  qme?: number | null,
  qmeReevaluation?: number | null,
  ime?: number | null,
  deposition?: number | null,
};

export type DefaultEarlyArrivalTimeMinutesInput = {
  workersComp?: number | null,
  ime?: number | null,
  deposition?: number | null,
};

export type ModelDoctorConditionInput = {
  ownerCognitoId?: ModelIDInput | null,
  firstName?: ModelStringInput | null,
  middleName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  name?: ModelStringInput | null,
  signatureName?: ModelStringInput | null,
  status?: ModelDoctorStatusInput | null,
  ramped?: ModelBooleanInput | null,
  title?: ModelStringInput | null,
  titleExtension?: ModelTitleExtensionInput | null,
  officePhone?: ModelStringInput | null,
  cellPhone?: ModelStringInput | null,
  clinicPhone?: ModelStringInput | null,
  workCity?: ModelStringInput | null,
  workState?: ModelStringInput | null,
  collectionRate?: ModelFloatInput | null,
  licenseNumber?: ModelStringInput | null,
  licenseRenewalDate?: ModelStringInput | null,
  specialties?: ModelSpecialtyTypeListInput | null,
  npi?: ModelStringInput | null,
  availabilitiesNote?: ModelStringInput | null,
  emails?: ModelStringInput | null,
  signatureDepartment?: ModelStringInput | null,
  profileAssetS3Prefix?: ModelStringInput | null,
  preferredAssessmentMode?: ModelAssessmentModeInput | null,
  isDemo?: ModelBooleanInput | null,
  fieldTemplateId?: ModelIDInput | null,
  templateFolderLink?: ModelStringInput | null,
  assessmentTreatmentOptions?: ModelStringInput | null,
  dismissedProTips?: ModelStringInput | null,
  and?: Array< ModelDoctorConditionInput | null > | null,
  or?: Array< ModelDoctorConditionInput | null > | null,
  not?: ModelDoctorConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  doctorPhysicianPartnerId?: ModelIDInput | null,
  doctorDefaultPrimaryOnsiteOpsId?: ModelIDInput | null,
  doctorDefaultSecondaryOnsiteOpsId?: ModelIDInput | null,
  doctorDefaultSchedulerId?: ModelIDInput | null,
  doctorDefaultReportOpsId?: ModelIDInput | null,
  doctorDefaultPreVisitReviewerId?: ModelIDInput | null,
  doctorDefaultBillingOpsId?: ModelIDInput | null,
  doctorDefaultSupplementalReportOpsId?: ModelIDInput | null,
  doctorUserId?: ModelIDInput | null,
};

export type ModelDoctorStatusInput = {
  eq?: DoctorStatus | null,
  ne?: DoctorStatus | null,
};

export type ModelTitleExtensionInput = {
  eq?: TitleExtension | null,
  ne?: TitleExtension | null,
};

export type ModelSpecialtyTypeListInput = {
  eq?: Array< SpecialtyType | null > | null,
  ne?: Array< SpecialtyType | null > | null,
  contains?: SpecialtyType | null,
  notContains?: SpecialtyType | null,
};

export type ModelAssessmentModeInput = {
  eq?: AssessmentMode | null,
  ne?: AssessmentMode | null,
};

export type UpdateDoctorInput = {
  id: string,
  ownerCognitoId?: string | null,
  firstName?: string | null,
  middleName?: string | null,
  lastName?: string | null,
  name?: string | null,
  signatureName?: string | null,
  status?: DoctorStatus | null,
  ramped?: boolean | null,
  title?: string | null,
  titleExtension?: TitleExtension | null,
  contact?: ContactInfoInput | null,
  officePhone?: string | null,
  cellPhone?: string | null,
  clinicPhone?: string | null,
  workCity?: string | null,
  workState?: string | null,
  collectionRate?: number | null,
  licenseNumber?: string | null,
  licenseRenewalDate?: string | null,
  qmeLicense?: QmeLicenseInput | null,
  specialties?: Array< SpecialtyType | null > | null,
  npi?: string | null,
  bankingInfo?: BankingInfoInput | null,
  availabilities?: AvailabilitiesInput | null,
  availabilitiesNote?: string | null,
  emails?: Array< string | null > | null,
  profileImages?: Array< DoctorProfileImageInput | null > | null,
  qmeReportConfigs?: DoctorQMEReportConfigsInput | null,
  physicalEvalConfigs?: DoctorPhysicalEvalConfigsInput | null,
  signatureDepartment?: string | null,
  profileAssetS3Prefix?: string | null,
  calendarPreference?: CalendarPreferenceInput | null,
  homeOffice?: HomeOfficeInput | null,
  reportFormatPreferences?: ReportFormatPreferencesInput | null,
  evaluationInputPreferences?: EvaluationInputPreferencesInput | null,
  preferredAssessmentMode?: AssessmentMode | null,
  isDemo?: boolean | null,
  fieldTemplateId?: string | null,
  templateFolderLink?: string | null,
  supplementalReportOpsAssignments?: Array< SupplementalReportOpsAssignmentInput | null > | null,
  defaultAppointmentDurationMinutes?: DefaultAppointmentDurationMinutesInput | null,
  defaultEarlyArrivalTimeMinutes?: DefaultEarlyArrivalTimeMinutesInput | null,
  assessmentTreatmentOptions?: Array< string | null > | null,
  dismissedProTips?: Array< string | null > | null,
  doctorPhysicianPartnerId?: string | null,
  doctorDefaultPrimaryOnsiteOpsId?: string | null,
  doctorDefaultSecondaryOnsiteOpsId?: string | null,
  doctorDefaultSchedulerId?: string | null,
  doctorDefaultReportOpsId?: string | null,
  doctorDefaultPreVisitReviewerId?: string | null,
  doctorDefaultBillingOpsId?: string | null,
  doctorDefaultSupplementalReportOpsId?: string | null,
  doctorUserId?: string | null,
};

export type DeleteDoctorInput = {
  id: string,
};

export type CreateLocationInput = {
  id?: string | null,
  name?: string | null,
  abbreviation?: string | null,
  status?: LocationStatus | null,
  region?: Region | null,
  address?: AddressInput | null,
  indigoOfficePhoneNumber?: string | null,
  isWaitingArea?: boolean | null,
  additionalRoomsNumber?: number | null,
  landlordContactInfo?: LocationLandlordContactInfoInput | null,
  calendarCcEmails?: Array< string | null > | null,
  isParkingFree?: boolean | null,
  parkingRate?: number | null,
  isFrontDoorLocked?: boolean | null,
  frontDoorCode?: string | null,
  backDoor?: BackDoorStatus | null,
  backDoorCode?: string | null,
  securityUnlockingProcess?: string | null,
  securityLockingProcess?: string | null,
  maleBathroomCode?: string | null,
  femaleBathroomCode?: string | null,
  wifiName?: string | null,
  wifiPassword?: string | null,
  locationInstructionsForVisitor?: string | null,
  additionalNote?: string | null,
  locationDefaultOnsiteOpsId?: string | null,
  locationSecondaryOnsiteOpsId?: string | null,
};

export type LocationLandlordContactInfoInput = {
  name?: string | null,
  phone?: string | null,
  email?: string | null,
};

export type ModelLocationConditionInput = {
  name?: ModelStringInput | null,
  abbreviation?: ModelStringInput | null,
  status?: ModelLocationStatusInput | null,
  region?: ModelRegionInput | null,
  indigoOfficePhoneNumber?: ModelStringInput | null,
  isWaitingArea?: ModelBooleanInput | null,
  additionalRoomsNumber?: ModelIntInput | null,
  calendarCcEmails?: ModelStringInput | null,
  isParkingFree?: ModelBooleanInput | null,
  parkingRate?: ModelFloatInput | null,
  isFrontDoorLocked?: ModelBooleanInput | null,
  frontDoorCode?: ModelStringInput | null,
  backDoor?: ModelBackDoorStatusInput | null,
  backDoorCode?: ModelStringInput | null,
  securityUnlockingProcess?: ModelStringInput | null,
  securityLockingProcess?: ModelStringInput | null,
  maleBathroomCode?: ModelStringInput | null,
  femaleBathroomCode?: ModelStringInput | null,
  wifiName?: ModelStringInput | null,
  wifiPassword?: ModelStringInput | null,
  locationInstructionsForVisitor?: ModelStringInput | null,
  additionalNote?: ModelStringInput | null,
  and?: Array< ModelLocationConditionInput | null > | null,
  or?: Array< ModelLocationConditionInput | null > | null,
  not?: ModelLocationConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  locationDefaultOnsiteOpsId?: ModelIDInput | null,
  locationSecondaryOnsiteOpsId?: ModelIDInput | null,
};

export type ModelLocationStatusInput = {
  eq?: LocationStatus | null,
  ne?: LocationStatus | null,
};

export type ModelRegionInput = {
  eq?: Region | null,
  ne?: Region | null,
};

export type ModelBackDoorStatusInput = {
  eq?: BackDoorStatus | null,
  ne?: BackDoorStatus | null,
};

export type UpdateLocationInput = {
  id: string,
  name?: string | null,
  abbreviation?: string | null,
  status?: LocationStatus | null,
  region?: Region | null,
  address?: AddressInput | null,
  indigoOfficePhoneNumber?: string | null,
  isWaitingArea?: boolean | null,
  additionalRoomsNumber?: number | null,
  landlordContactInfo?: LocationLandlordContactInfoInput | null,
  calendarCcEmails?: Array< string | null > | null,
  isParkingFree?: boolean | null,
  parkingRate?: number | null,
  isFrontDoorLocked?: boolean | null,
  frontDoorCode?: string | null,
  backDoor?: BackDoorStatus | null,
  backDoorCode?: string | null,
  securityUnlockingProcess?: string | null,
  securityLockingProcess?: string | null,
  maleBathroomCode?: string | null,
  femaleBathroomCode?: string | null,
  wifiName?: string | null,
  wifiPassword?: string | null,
  locationInstructionsForVisitor?: string | null,
  additionalNote?: string | null,
  locationDefaultOnsiteOpsId?: string | null,
  locationSecondaryOnsiteOpsId?: string | null,
};

export type DeleteLocationInput = {
  id: string,
};

export type CreateWorkflowExecutionInput = {
  executionArn: string,
  appointmentRecordID: string,
  type?: WorkflowExecutionType | null,
  status?: WorkflowExecutionStatus | null,
  errorMessage?: string | null,
};

export type ModelWorkflowExecutionConditionInput = {
  appointmentRecordID?: ModelIDInput | null,
  type?: ModelWorkflowExecutionTypeInput | null,
  status?: ModelWorkflowExecutionStatusInput | null,
  errorMessage?: ModelStringInput | null,
  and?: Array< ModelWorkflowExecutionConditionInput | null > | null,
  or?: Array< ModelWorkflowExecutionConditionInput | null > | null,
  not?: ModelWorkflowExecutionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelWorkflowExecutionTypeInput = {
  eq?: WorkflowExecutionType | null,
  ne?: WorkflowExecutionType | null,
};

export type ModelWorkflowExecutionStatusInput = {
  eq?: WorkflowExecutionStatus | null,
  ne?: WorkflowExecutionStatus | null,
};

export type UpdateWorkflowExecutionInput = {
  executionArn: string,
  appointmentRecordID?: string | null,
  type?: WorkflowExecutionType | null,
  status?: WorkflowExecutionStatus | null,
  errorMessage?: string | null,
};

export type DeleteWorkflowExecutionInput = {
  executionArn: string,
};

export type CreateHistoryOfInjuryInsightsInput = {
  id?: string | null,
  appointmentRecordID: string,
  mechanismOfInjury?: string | null,
  employerJobDescription?: string | null,
  injuryCausations?: Array< InjuryCausationInfoInput | null > | null,
  currentSymptoms?: Array< SymptomInput | null > | null,
  priorSymptomsBeforeCurrentInjury?: Array< SymptomInput | null > | null,
  previousSurgeries?: Array< SurgeryHistoryInfoInput | null > | null,
  previousWorkInjuries?: Array< InjuryHistoryInfoInput | null > | null,
  previousInjuries?: Array< InjuryHistoryInfoInput | null > | null,
  injuryEmploymentStatus?: string | null,
  currentWorkRestrictionsFromPatient?: string | null,
  activitiesOfDailyLiving?: string | null,
};

export type InjuryCausationInfoInput = {
  injuryType?: InjuryType | null,
  dateOfInjury?: string | null,
  dateOfInjuryEnd?: string | null,
  bodyParts?: Array< BodyPart | null > | null,
  mechanismOfInjury?: string | null,
  employerJobDescription?: string | null,
};

export type SymptomInput = {
  bodyParts?: Array< string | null > | null,
  description?: string | null,
};

export type SurgeryHistoryInfoInput = {
  date?: string | null,
  bodyParts?: Array< string | null > | null,
  type?: string | null,
};

export type InjuryHistoryInfoInput = {
  date?: string | null,
  bodyParts?: Array< string | null > | null,
  description?: string | null,
};

export type ModelHistoryOfInjuryInsightsConditionInput = {
  appointmentRecordID?: ModelIDInput | null,
  mechanismOfInjury?: ModelStringInput | null,
  employerJobDescription?: ModelStringInput | null,
  injuryEmploymentStatus?: ModelStringInput | null,
  currentWorkRestrictionsFromPatient?: ModelStringInput | null,
  activitiesOfDailyLiving?: ModelStringInput | null,
  and?: Array< ModelHistoryOfInjuryInsightsConditionInput | null > | null,
  or?: Array< ModelHistoryOfInjuryInsightsConditionInput | null > | null,
  not?: ModelHistoryOfInjuryInsightsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateHistoryOfInjuryInsightsInput = {
  id: string,
  appointmentRecordID?: string | null,
  mechanismOfInjury?: string | null,
  employerJobDescription?: string | null,
  injuryCausations?: Array< InjuryCausationInfoInput | null > | null,
  currentSymptoms?: Array< SymptomInput | null > | null,
  priorSymptomsBeforeCurrentInjury?: Array< SymptomInput | null > | null,
  previousSurgeries?: Array< SurgeryHistoryInfoInput | null > | null,
  previousWorkInjuries?: Array< InjuryHistoryInfoInput | null > | null,
  previousInjuries?: Array< InjuryHistoryInfoInput | null > | null,
  injuryEmploymentStatus?: string | null,
  currentWorkRestrictionsFromPatient?: string | null,
  activitiesOfDailyLiving?: string | null,
};

export type DeleteHistoryOfInjuryInsightsInput = {
  id: string,
};

export type CreateOpinionRecapInput = {
  id?: string | null,
  appointmentRecordID: string,
  causation?: string | null,
  diagnosis?: string | null,
  mmiFutureMedicalTreatment?: string | null,
  impairmentRating?: string | null,
  apportionment?: string | null,
  workStatus?: string | null,
  sourceReportFileID?: string | null,
};

export type ModelOpinionRecapConditionInput = {
  appointmentRecordID?: ModelIDInput | null,
  causation?: ModelStringInput | null,
  diagnosis?: ModelStringInput | null,
  mmiFutureMedicalTreatment?: ModelStringInput | null,
  impairmentRating?: ModelStringInput | null,
  apportionment?: ModelStringInput | null,
  workStatus?: ModelStringInput | null,
  sourceReportFileID?: ModelStringInput | null,
  and?: Array< ModelOpinionRecapConditionInput | null > | null,
  or?: Array< ModelOpinionRecapConditionInput | null > | null,
  not?: ModelOpinionRecapConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateOpinionRecapInput = {
  id: string,
  appointmentRecordID?: string | null,
  causation?: string | null,
  diagnosis?: string | null,
  mmiFutureMedicalTreatment?: string | null,
  impairmentRating?: string | null,
  apportionment?: string | null,
  workStatus?: string | null,
  sourceReportFileID?: string | null,
};

export type DeleteOpinionRecapInput = {
  id: string,
};

export type CreateReviewOfMedicalRecordsInsightsInput = {
  id?: string | null,
  appointmentRecordID: string,
  latestDiagnosis?: Array< BodyPartDiagnosisInput | null > | null,
  diagnosticStudies?: Array< DiagnosticStudyInput | null > | null,
  treatments?: Array< TreatmentWrapperInput | null > | null,
  currentWorkRestrictionsFromMedicalRecords?: string | null,
  previousReports?: Array< PreviousReportInput | null > | null,
  durableMedicalEquipment?: Array< DurableMedicalEquipmentInput | null > | null,
  derivedFromDocumentInsightIDs?: Array< string | null > | null,
  derivedAt?: string | null,
};

export type BodyPartDiagnosisInput = {
  bodyPart?: string | null,
  date?: string | null,
  descriptions?: Array< string | null > | null,
};

export type DiagnosticStudyInput = {
  date?: string | null,
  typeOfStudy?: DiagnosticStudyType | null,
  bodyPart?: string | null,
  impression?: string | null,
  source?: DiagnosticStudySource | null,
};

export type TreatmentWrapperInput = {
  discreteTreatment?: DiscreteTreatmentInput | null,
  recurringTreatment?: RecurringTreatmentInput | null,
};

export type DiscreteTreatmentInput = {
  date?: string | null,
  treatmentType?: DiscreteTreatmentType | null,
  bodyPart?: string | null,
  description?: string | null,
};

export type RecurringTreatmentInput = {
  year?: string | null,
  treatmentType?: RecurringTreatmentType | null,
  frequency?: string | null,
  description?: string | null,
};

export type PreviousReportInput = {
  date?: string | null,
  reportType?: string | null,
  reportContent?: string | null,
};

export type DurableMedicalEquipmentInput = {
  startDate?: string | null,
  endDate?: string | null,
  bodyParts?: Array< string | null > | null,
  equipmentType?: string | null,
  description?: string | null,
};

export type ModelReviewOfMedicalRecordsInsightsConditionInput = {
  appointmentRecordID?: ModelIDInput | null,
  currentWorkRestrictionsFromMedicalRecords?: ModelStringInput | null,
  derivedFromDocumentInsightIDs?: ModelIDInput | null,
  derivedAt?: ModelStringInput | null,
  and?: Array< ModelReviewOfMedicalRecordsInsightsConditionInput | null > | null,
  or?: Array< ModelReviewOfMedicalRecordsInsightsConditionInput | null > | null,
  not?: ModelReviewOfMedicalRecordsInsightsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateReviewOfMedicalRecordsInsightsInput = {
  id: string,
  appointmentRecordID?: string | null,
  latestDiagnosis?: Array< BodyPartDiagnosisInput | null > | null,
  diagnosticStudies?: Array< DiagnosticStudyInput | null > | null,
  treatments?: Array< TreatmentWrapperInput | null > | null,
  currentWorkRestrictionsFromMedicalRecords?: string | null,
  previousReports?: Array< PreviousReportInput | null > | null,
  durableMedicalEquipment?: Array< DurableMedicalEquipmentInput | null > | null,
  derivedFromDocumentInsightIDs?: Array< string | null > | null,
  derivedAt?: string | null,
};

export type DeleteReviewOfMedicalRecordsInsightsInput = {
  id: string,
};

export type CreateDocumentBriefingInsightsInput = {
  id?: string | null,
  documentID: string,
  appointmentRecordID: string,
  latestDiagnosis?: Array< BodyPartDiagnosisInput | null > | null,
  diagnosticStudies?: Array< DiagnosticStudyInput | null > | null,
  treatments?: Array< TreatmentWrapperInput | null > | null,
  currentWorkRestrictionsFromMedicalRecords?: string | null,
  previousReports?: Array< PreviousReportInput | null > | null,
  durableMedicalEquipment?: Array< DurableMedicalEquipmentInput | null > | null,
  sourceRecordBriefingID: string,
  generatedAt: string,
};

export type ModelDocumentBriefingInsightsConditionInput = {
  documentID?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  currentWorkRestrictionsFromMedicalRecords?: ModelStringInput | null,
  sourceRecordBriefingID?: ModelIDInput | null,
  generatedAt?: ModelStringInput | null,
  and?: Array< ModelDocumentBriefingInsightsConditionInput | null > | null,
  or?: Array< ModelDocumentBriefingInsightsConditionInput | null > | null,
  not?: ModelDocumentBriefingInsightsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type DocumentBriefingInsights = {
  __typename: "DocumentBriefingInsights",
  id: string,
  documentID: string,
  appointmentRecordID: string,
  latestDiagnosis?:  Array<BodyPartDiagnosis | null > | null,
  diagnosticStudies?:  Array<DiagnosticStudy | null > | null,
  treatments?:  Array<TreatmentWrapper | null > | null,
  currentWorkRestrictionsFromMedicalRecords?: string | null,
  previousReports?:  Array<PreviousReport | null > | null,
  durableMedicalEquipment?:  Array<DurableMedicalEquipment | null > | null,
  sourceRecordBriefingID: string,
  generatedAt: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateDocumentBriefingInsightsInput = {
  id: string,
  documentID?: string | null,
  appointmentRecordID?: string | null,
  latestDiagnosis?: Array< BodyPartDiagnosisInput | null > | null,
  diagnosticStudies?: Array< DiagnosticStudyInput | null > | null,
  treatments?: Array< TreatmentWrapperInput | null > | null,
  currentWorkRestrictionsFromMedicalRecords?: string | null,
  previousReports?: Array< PreviousReportInput | null > | null,
  durableMedicalEquipment?: Array< DurableMedicalEquipmentInput | null > | null,
  sourceRecordBriefingID?: string | null,
  generatedAt?: string | null,
};

export type DeleteDocumentBriefingInsightsInput = {
  id: string,
};

export type CreatePhysicalExamInsightsInput = {
  id?: string | null,
  appointmentRecordID: string,
  physicalExaminationInfo?: string | null,
};

export type ModelPhysicalExamInsightsConditionInput = {
  appointmentRecordID?: ModelIDInput | null,
  physicalExaminationInfo?: ModelStringInput | null,
  and?: Array< ModelPhysicalExamInsightsConditionInput | null > | null,
  or?: Array< ModelPhysicalExamInsightsConditionInput | null > | null,
  not?: ModelPhysicalExamInsightsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdatePhysicalExamInsightsInput = {
  id: string,
  appointmentRecordID?: string | null,
  physicalExaminationInfo?: string | null,
};

export type DeletePhysicalExamInsightsInput = {
  id: string,
};

export type CreateDataFieldInput = {
  id?: string | null,
  name: string,
  category: DataFieldCategory,
  dataType: DataFieldType,
  default: boolean,
  description?: string | null,
  sectionID?: string | null,
  migrationKey?: string | null,
};

export enum DataFieldCategory {
  ADL = "ADL",
  MEDICAL_HISTORY = "MEDICAL_HISTORY",
}


export enum DataFieldType {
  STRING = "STRING",
  NUMBER = "NUMBER",
  BOOLEAN = "BOOLEAN",
  BOOLEAN_WITH_NOTES = "BOOLEAN_WITH_NOTES",
  ADL_WITH_NOTES = "ADL_WITH_NOTES",
}


export type ModelDataFieldConditionInput = {
  name?: ModelStringInput | null,
  category?: ModelDataFieldCategoryInput | null,
  dataType?: ModelDataFieldTypeInput | null,
  default?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  sectionID?: ModelIDInput | null,
  migrationKey?: ModelStringInput | null,
  and?: Array< ModelDataFieldConditionInput | null > | null,
  or?: Array< ModelDataFieldConditionInput | null > | null,
  not?: ModelDataFieldConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelDataFieldCategoryInput = {
  eq?: DataFieldCategory | null,
  ne?: DataFieldCategory | null,
};

export type ModelDataFieldTypeInput = {
  eq?: DataFieldType | null,
  ne?: DataFieldType | null,
};

export type DataField = {
  __typename: "DataField",
  id: string,
  name: string,
  category: DataFieldCategory,
  dataType: DataFieldType,
  default: boolean,
  description?: string | null,
  sectionID?: string | null,
  section?: DataFieldSection | null,
  migrationKey?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type DataFieldSection = {
  __typename: "DataFieldSection",
  id: string,
  name: string,
  default: boolean,
  fields?: ModelDataFieldConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelDataFieldConnection = {
  __typename: "ModelDataFieldConnection",
  items:  Array<DataField | null >,
  nextToken?: string | null,
};

export type UpdateDataFieldInput = {
  id: string,
  name?: string | null,
  category?: DataFieldCategory | null,
  dataType?: DataFieldType | null,
  default?: boolean | null,
  description?: string | null,
  sectionID?: string | null,
  migrationKey?: string | null,
};

export type DeleteDataFieldInput = {
  id: string,
};

export type CreateDataFieldSectionInput = {
  id?: string | null,
  name: string,
  default: boolean,
};

export type ModelDataFieldSectionConditionInput = {
  name?: ModelStringInput | null,
  default?: ModelBooleanInput | null,
  and?: Array< ModelDataFieldSectionConditionInput | null > | null,
  or?: Array< ModelDataFieldSectionConditionInput | null > | null,
  not?: ModelDataFieldSectionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateDataFieldSectionInput = {
  id: string,
  name?: string | null,
  default?: boolean | null,
};

export type DeleteDataFieldSectionInput = {
  id: string,
};

export type CreateBriefingFieldInput = {
  id?: string | null,
  name: string,
  default: boolean,
  description?: string | null,
  briefingPrompt?: string | null,
  briefingRecordTypeID: string,
};

export type ModelBriefingFieldConditionInput = {
  name?: ModelStringInput | null,
  default?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  briefingPrompt?: ModelStringInput | null,
  briefingRecordTypeID?: ModelIDInput | null,
  and?: Array< ModelBriefingFieldConditionInput | null > | null,
  or?: Array< ModelBriefingFieldConditionInput | null > | null,
  not?: ModelBriefingFieldConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateBriefingFieldInput = {
  id: string,
  name?: string | null,
  default?: boolean | null,
  description?: string | null,
  briefingPrompt?: string | null,
  briefingRecordTypeID?: string | null,
};

export type DeleteBriefingFieldInput = {
  id: string,
};

export type CreateCaseSummaryFieldInput = {
  id?: string | null,
  name: string,
  default: boolean,
  description?: string | null,
  summaryPrompt?: string | null,
};

export type ModelCaseSummaryFieldConditionInput = {
  name?: ModelStringInput | null,
  default?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  summaryPrompt?: ModelStringInput | null,
  and?: Array< ModelCaseSummaryFieldConditionInput | null > | null,
  or?: Array< ModelCaseSummaryFieldConditionInput | null > | null,
  not?: ModelCaseSummaryFieldConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateCaseSummaryFieldInput = {
  id: string,
  name?: string | null,
  default?: boolean | null,
  description?: string | null,
  summaryPrompt?: string | null,
};

export type DeleteCaseSummaryFieldInput = {
  id: string,
};

export type CreatePastInjuryMatrixInput = {
  id?: string | null,
  appointmentRecordID: string,
  preExistingConditions: Array< string >,
  familyHistory: Array< string >,
  injuryMatrix: Array< InjuryMatrixEntryInput >,
};

export type InjuryMatrixEntryInput = {
  date: string,
  bodyPart: BodyPart,
  status: InjuryStatus,
};

export type ModelPastInjuryMatrixConditionInput = {
  appointmentRecordID?: ModelIDInput | null,
  preExistingConditions?: ModelStringInput | null,
  familyHistory?: ModelStringInput | null,
  and?: Array< ModelPastInjuryMatrixConditionInput | null > | null,
  or?: Array< ModelPastInjuryMatrixConditionInput | null > | null,
  not?: ModelPastInjuryMatrixConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdatePastInjuryMatrixInput = {
  id: string,
  appointmentRecordID?: string | null,
  preExistingConditions?: Array< string > | null,
  familyHistory?: Array< string > | null,
  injuryMatrix?: Array< InjuryMatrixEntryInput > | null,
};

export type DeletePastInjuryMatrixInput = {
  id: string,
};

export type CreateAppointmentFilterPresetInput = {
  id?: string | null,
  name: string,
  filters: Array< FilterEntryInput >,
  appliesTo: UserGroup,
  view?: AppointmentsView | null,
};

export type FilterEntryInput = {
  type: FilterType,
  values: Array< string >,
};

export type ModelAppointmentFilterPresetConditionInput = {
  name?: ModelStringInput | null,
  appliesTo?: ModelUserGroupInput | null,
  view?: ModelAppointmentsViewInput | null,
  and?: Array< ModelAppointmentFilterPresetConditionInput | null > | null,
  or?: Array< ModelAppointmentFilterPresetConditionInput | null > | null,
  not?: ModelAppointmentFilterPresetConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelUserGroupInput = {
  eq?: UserGroup | null,
  ne?: UserGroup | null,
};

export type ModelAppointmentsViewInput = {
  eq?: AppointmentsView | null,
  ne?: AppointmentsView | null,
};

export type UpdateAppointmentFilterPresetInput = {
  id: string,
  name?: string | null,
  filters?: Array< FilterEntryInput > | null,
  appliesTo?: UserGroup | null,
  view?: AppointmentsView | null,
};

export type DeleteAppointmentFilterPresetInput = {
  id: string,
};

export type CreateRecordBriefingSegmentInput = {
  id?: string | null,
  logicalSegmentID: string,
  title?: string | null,
  text?: string | null,
  bodyParts?: Array< BodyPart | null > | null,
  injuredBodyParts?: Array< BodyPart | null > | null,
  editedBy?: string | null,
  pdfFileName: string,
  sourceTag?: string | null,
  segmentNumber?: number | null,
  sourcePdfS3Key: string,
  startPageNumber: number,
  endPageNumber: number,
  recordType: RecordType,
  extractedDate?: string | null,
  doctorName?: string | null,
  processingModel?: string | null,
  classificationConfidence?: number | null,
  hasDate?: boolean | null,
  potentialDuplicateID?: string | null,
  needsReview?: boolean | null,
  status?: SegmentStatus | null,
  documentID?: string | null,
  videoStartTime?: string | null,
  videoEndTime?: string | null,
};

export type ModelRecordBriefingSegmentConditionInput = {
  logicalSegmentID?: ModelIDInput | null,
  title?: ModelStringInput | null,
  text?: ModelStringInput | null,
  bodyParts?: ModelBodyPartListInput | null,
  injuredBodyParts?: ModelBodyPartListInput | null,
  editedBy?: ModelIDInput | null,
  pdfFileName?: ModelStringInput | null,
  sourceTag?: ModelStringInput | null,
  segmentNumber?: ModelIntInput | null,
  sourcePdfS3Key?: ModelStringInput | null,
  startPageNumber?: ModelIntInput | null,
  endPageNumber?: ModelIntInput | null,
  recordType?: ModelRecordTypeInput | null,
  extractedDate?: ModelStringInput | null,
  doctorName?: ModelStringInput | null,
  processingModel?: ModelStringInput | null,
  classificationConfidence?: ModelFloatInput | null,
  hasDate?: ModelBooleanInput | null,
  potentialDuplicateID?: ModelIDInput | null,
  needsReview?: ModelBooleanInput | null,
  status?: ModelSegmentStatusInput | null,
  documentID?: ModelIDInput | null,
  videoStartTime?: ModelStringInput | null,
  videoEndTime?: ModelStringInput | null,
  and?: Array< ModelRecordBriefingSegmentConditionInput | null > | null,
  or?: Array< ModelRecordBriefingSegmentConditionInput | null > | null,
  not?: ModelRecordBriefingSegmentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelRecordTypeInput = {
  eq?: RecordType | null,
  ne?: RecordType | null,
};

export type ModelSegmentStatusInput = {
  eq?: SegmentStatus | null,
  ne?: SegmentStatus | null,
};

export type UpdateRecordBriefingSegmentInput = {
  id: string,
  logicalSegmentID?: string | null,
  title?: string | null,
  text?: string | null,
  bodyParts?: Array< BodyPart | null > | null,
  injuredBodyParts?: Array< BodyPart | null > | null,
  editedBy?: string | null,
  pdfFileName?: string | null,
  sourceTag?: string | null,
  segmentNumber?: number | null,
  sourcePdfS3Key?: string | null,
  startPageNumber?: number | null,
  endPageNumber?: number | null,
  recordType?: RecordType | null,
  extractedDate?: string | null,
  doctorName?: string | null,
  processingModel?: string | null,
  classificationConfidence?: number | null,
  hasDate?: boolean | null,
  potentialDuplicateID?: string | null,
  needsReview?: boolean | null,
  status?: SegmentStatus | null,
  documentID?: string | null,
  videoStartTime?: string | null,
  videoEndTime?: string | null,
};

export type DeleteRecordBriefingSegmentInput = {
  id: string,
};

export type CreateRecordBriefingSegmentMappingInput = {
  id?: string | null,
  briefingID: string,
  logicalSegmentID: string,
  publishedSegmentID?: string | null,
  draftSegmentID?: string | null,
  markedForDeletion?: boolean | null,
  markedForCreation?: boolean | null,
};

export type ModelRecordBriefingSegmentMappingConditionInput = {
  briefingID?: ModelIDInput | null,
  logicalSegmentID?: ModelIDInput | null,
  publishedSegmentID?: ModelIDInput | null,
  draftSegmentID?: ModelIDInput | null,
  markedForDeletion?: ModelBooleanInput | null,
  markedForCreation?: ModelBooleanInput | null,
  and?: Array< ModelRecordBriefingSegmentMappingConditionInput | null > | null,
  or?: Array< ModelRecordBriefingSegmentMappingConditionInput | null > | null,
  not?: ModelRecordBriefingSegmentMappingConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateRecordBriefingSegmentMappingInput = {
  id: string,
  briefingID?: string | null,
  logicalSegmentID?: string | null,
  publishedSegmentID?: string | null,
  draftSegmentID?: string | null,
  markedForDeletion?: boolean | null,
  markedForCreation?: boolean | null,
};

export type DeleteRecordBriefingSegmentMappingInput = {
  id: string,
};

export type CreateRecordBriefingInput = {
  id?: string | null,
  logicalBriefingID: string,
  generatedAt?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
  googleDocExportLink?: string | null,
  googleDocExportedAt?: string | null,
  suggestionGeneration?: SuggestionGenerationJobInput | null,
  editingPresence?: string | null,
};

export type SuggestionGenerationJobInput = {
  status?: SuggestionGenerationStatus | null,
  jobId?: string | null,
  startedAt?: string | null,
  completedAt?: string | null,
  error?: string | null,
};

export type ModelRecordBriefingConditionInput = {
  logicalBriefingID?: ModelIDInput | null,
  generatedAt?: ModelStringInput | null,
  lastEditedAt?: ModelStringInput | null,
  lastEditedBy?: ModelIDInput | null,
  googleDocExportLink?: ModelStringInput | null,
  googleDocExportedAt?: ModelStringInput | null,
  editingPresence?: ModelStringInput | null,
  and?: Array< ModelRecordBriefingConditionInput | null > | null,
  or?: Array< ModelRecordBriefingConditionInput | null > | null,
  not?: ModelRecordBriefingConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateRecordBriefingInput = {
  id: string,
  logicalBriefingID?: string | null,
  generatedAt?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
  googleDocExportLink?: string | null,
  googleDocExportedAt?: string | null,
  suggestionGeneration?: SuggestionGenerationJobInput | null,
  editingPresence?: string | null,
};

export type DeleteRecordBriefingInput = {
  id: string,
};

export type CreateRecordBriefingSegmentAnnotationInput = {
  id?: string | null,
  logicalSegmentID: string,
  isStarred?: boolean | null,
  isImportant?: boolean | null,
};

export type ModelRecordBriefingSegmentAnnotationConditionInput = {
  isStarred?: ModelBooleanInput | null,
  isImportant?: ModelBooleanInput | null,
  and?: Array< ModelRecordBriefingSegmentAnnotationConditionInput | null > | null,
  or?: Array< ModelRecordBriefingSegmentAnnotationConditionInput | null > | null,
  not?: ModelRecordBriefingSegmentAnnotationConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type RecordBriefingSegmentAnnotation = {
  __typename: "RecordBriefingSegmentAnnotation",
  id: string,
  logicalSegmentID: string,
  isStarred?: boolean | null,
  isImportant?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateRecordBriefingSegmentAnnotationInput = {
  id: string,
  logicalSegmentID: string,
  isStarred?: boolean | null,
  isImportant?: boolean | null,
};

export type DeleteRecordBriefingSegmentAnnotationInput = {
  id: string,
  logicalSegmentID: string,
};

export type CreateRecordBriefingSegmentSuggestionInput = {
  id?: string | null,
  briefingID: string,
  logicalSegmentID: string,
  suggestionType: SegmentSuggestionType,
  reason: SegmentSuggestionReason,
  reasonDetails?: string | null,
  textRange?: TextRangeInput | null,
  status: SegmentSuggestionStatus,
  resolvedBy?: string | null,
  resolvedAt?: string | null,
  seen?: boolean | null,
  confidence?: number | null,
  relatedSegmentID?: string | null,
};

export enum SegmentSuggestionType {
  DELETE_SEGMENT = "DELETE_SEGMENT",
  DELETE_TEXT_RANGE = "DELETE_TEXT_RANGE",
}


export enum SegmentSuggestionReason {
  DUPLICATE_PRIOR_SEGMENTS = "DUPLICATE_PRIOR_SEGMENTS",
  MISC_NOT_USEFUL = "MISC_NOT_USEFUL",
  IRRELEVANT_BODY_PARTS = "IRRELEVANT_BODY_PARTS",
  OUTSIDE_SPECIALTY_PANEL = "OUTSIDE_SPECIALTY_PANEL",
  DUPLICATE_WITHIN_SEGMENT = "DUPLICATE_WITHIN_SEGMENT",
  IRRELEVANT_INFORMATION = "IRRELEVANT_INFORMATION",
  DUPLICATE_IN_ANOTHER_SEGMENT = "DUPLICATE_IN_ANOTHER_SEGMENT",
  EXISTING_INFORMATION = "EXISTING_INFORMATION",
  NO_ADDITIONAL_INSIGHT = "NO_ADDITIONAL_INSIGHT",
  REDUNDANT_CLINICAL_DETAIL = "REDUNDANT_CLINICAL_DETAIL",
}


export type TextRangeInput = {
  textToDelete: string,
  occurrenceIndex?: number | null,
  prefixContext?: string | null,
  suffixContext?: string | null,
};

export enum SegmentSuggestionStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}


export type ModelRecordBriefingSegmentSuggestionConditionInput = {
  briefingID?: ModelIDInput | null,
  logicalSegmentID?: ModelIDInput | null,
  suggestionType?: ModelSegmentSuggestionTypeInput | null,
  reason?: ModelSegmentSuggestionReasonInput | null,
  reasonDetails?: ModelStringInput | null,
  status?: ModelSegmentSuggestionStatusInput | null,
  resolvedBy?: ModelIDInput | null,
  resolvedAt?: ModelStringInput | null,
  seen?: ModelBooleanInput | null,
  confidence?: ModelFloatInput | null,
  relatedSegmentID?: ModelIDInput | null,
  and?: Array< ModelRecordBriefingSegmentSuggestionConditionInput | null > | null,
  or?: Array< ModelRecordBriefingSegmentSuggestionConditionInput | null > | null,
  not?: ModelRecordBriefingSegmentSuggestionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelSegmentSuggestionTypeInput = {
  eq?: SegmentSuggestionType | null,
  ne?: SegmentSuggestionType | null,
};

export type ModelSegmentSuggestionReasonInput = {
  eq?: SegmentSuggestionReason | null,
  ne?: SegmentSuggestionReason | null,
};

export type ModelSegmentSuggestionStatusInput = {
  eq?: SegmentSuggestionStatus | null,
  ne?: SegmentSuggestionStatus | null,
};

export type RecordBriefingSegmentSuggestion = {
  __typename: "RecordBriefingSegmentSuggestion",
  id: string,
  briefingID: string,
  logicalSegmentID: string,
  suggestionType: SegmentSuggestionType,
  reason: SegmentSuggestionReason,
  reasonDetails?: string | null,
  textRange?: TextRange | null,
  status: SegmentSuggestionStatus,
  resolvedBy?: string | null,
  resolvedAt?: string | null,
  seen?: boolean | null,
  confidence?: number | null,
  relatedSegmentID?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type TextRange = {
  __typename: "TextRange",
  textToDelete: string,
  occurrenceIndex?: number | null,
  prefixContext?: string | null,
  suffixContext?: string | null,
};

export type UpdateRecordBriefingSegmentSuggestionInput = {
  id: string,
  briefingID?: string | null,
  logicalSegmentID?: string | null,
  suggestionType?: SegmentSuggestionType | null,
  reason?: SegmentSuggestionReason | null,
  reasonDetails?: string | null,
  textRange?: TextRangeInput | null,
  status?: SegmentSuggestionStatus | null,
  resolvedBy?: string | null,
  resolvedAt?: string | null,
  seen?: boolean | null,
  confidence?: number | null,
  relatedSegmentID?: string | null,
};

export type DeleteRecordBriefingSegmentSuggestionInput = {
  id: string,
};

export type CreateSummaryCitationInput = {
  id?: string | null,
  briefingID: string,
  logicalSegmentID: string,
  summaryText: string,
  citationID: string,
  status: SummaryCitationStatus,
  removedBy?: string | null,
  removedAt?: string | null,
};

export enum SummaryCitationStatus {
  ACTIVE = "ACTIVE",
  REMOVED = "REMOVED",
}


export type ModelSummaryCitationConditionInput = {
  briefingID?: ModelIDInput | null,
  logicalSegmentID?: ModelIDInput | null,
  summaryText?: ModelStringInput | null,
  citationID?: ModelIDInput | null,
  status?: ModelSummaryCitationStatusInput | null,
  removedBy?: ModelIDInput | null,
  removedAt?: ModelStringInput | null,
  and?: Array< ModelSummaryCitationConditionInput | null > | null,
  or?: Array< ModelSummaryCitationConditionInput | null > | null,
  not?: ModelSummaryCitationConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelSummaryCitationStatusInput = {
  eq?: SummaryCitationStatus | null,
  ne?: SummaryCitationStatus | null,
};

export type SummaryCitation = {
  __typename: "SummaryCitation",
  id: string,
  briefingID: string,
  logicalSegmentID: string,
  summaryText: string,
  citationID: string,
  status: SummaryCitationStatus,
  removedBy?: string | null,
  removedAt?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateSummaryCitationInput = {
  id: string,
  briefingID?: string | null,
  logicalSegmentID?: string | null,
  summaryText?: string | null,
  citationID?: string | null,
  status?: SummaryCitationStatus | null,
  removedBy?: string | null,
  removedAt?: string | null,
};

export type DeleteSummaryCitationInput = {
  id: string,
};

export type CreateSuggestionInput = {
  id?: string | null,
  appointmentID: string,
  source: SuggestionSource,
  changeType: SuggestionChangeType,
  resourceURI: string,
  suggestedValue?: string | null,
  existingValue?: string | null,
  rationale?: string | null,
  status?: SuggestionStatus | null,
  resolvedByUserID?: string | null,
  resolvedAt?: string | null,
  versionID: string,
  createdAt?: string | null,
};

export enum SuggestionSource {
  HISTORY_TRANSCRIPT_POPULATION = "HISTORY_TRANSCRIPT_POPULATION",
  JOTFORM_POPULATION = "JOTFORM_POPULATION",
}


export enum SuggestionChangeType {
  FIELD_UPDATE = "FIELD_UPDATE",
  ENTRY_FIELD_UPDATE = "ENTRY_FIELD_UPDATE",
  ENTRY_ADD = "ENTRY_ADD",
  ENTRY_REMOVE = "ENTRY_REMOVE",
}


export enum SuggestionStatus {
  ACCEPTED = "ACCEPTED",
  IGNORED = "IGNORED",
  STALE = "STALE",
}


export type ModelSuggestionConditionInput = {
  appointmentID?: ModelIDInput | null,
  source?: ModelSuggestionSourceInput | null,
  changeType?: ModelSuggestionChangeTypeInput | null,
  resourceURI?: ModelStringInput | null,
  suggestedValue?: ModelStringInput | null,
  existingValue?: ModelStringInput | null,
  rationale?: ModelStringInput | null,
  status?: ModelSuggestionStatusInput | null,
  resolvedByUserID?: ModelIDInput | null,
  resolvedAt?: ModelStringInput | null,
  versionID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelSuggestionConditionInput | null > | null,
  or?: Array< ModelSuggestionConditionInput | null > | null,
  not?: ModelSuggestionConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelSuggestionSourceInput = {
  eq?: SuggestionSource | null,
  ne?: SuggestionSource | null,
};

export type ModelSuggestionChangeTypeInput = {
  eq?: SuggestionChangeType | null,
  ne?: SuggestionChangeType | null,
};

export type ModelSuggestionStatusInput = {
  eq?: SuggestionStatus | null,
  ne?: SuggestionStatus | null,
};

export type Suggestion = {
  __typename: "Suggestion",
  id: string,
  appointmentID: string,
  source: SuggestionSource,
  changeType: SuggestionChangeType,
  resourceURI: string,
  suggestedValue?: string | null,
  existingValue?: string | null,
  rationale?: string | null,
  status?: SuggestionStatus | null,
  resolvedByUserID?: string | null,
  resolvedAt?: string | null,
  versionID: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateSuggestionInput = {
  id: string,
  appointmentID?: string | null,
  source?: SuggestionSource | null,
  changeType?: SuggestionChangeType | null,
  resourceURI?: string | null,
  suggestedValue?: string | null,
  existingValue?: string | null,
  rationale?: string | null,
  status?: SuggestionStatus | null,
  resolvedByUserID?: string | null,
  resolvedAt?: string | null,
  versionID?: string | null,
  createdAt?: string | null,
};

export type DeleteSuggestionInput = {
  id: string,
};

export type CreateOnsiteOpsConfigInput = {
  doctorLocationKey: string,
  assignmentEffectiveDate?: string | null,
  onsiteOpsConfigDoctorId?: string | null,
  onsiteOpsConfigLocationId?: string | null,
  onsiteOpsConfigMedicalAssistantId?: string | null,
  onsiteOpsConfigSecondaryMedicalAssistantId?: string | null,
};

export type ModelOnsiteOpsConfigConditionInput = {
  assignmentEffectiveDate?: ModelStringInput | null,
  and?: Array< ModelOnsiteOpsConfigConditionInput | null > | null,
  or?: Array< ModelOnsiteOpsConfigConditionInput | null > | null,
  not?: ModelOnsiteOpsConfigConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  onsiteOpsConfigDoctorId?: ModelIDInput | null,
  onsiteOpsConfigLocationId?: ModelIDInput | null,
  onsiteOpsConfigMedicalAssistantId?: ModelIDInput | null,
  onsiteOpsConfigSecondaryMedicalAssistantId?: ModelIDInput | null,
};

export type OnsiteOpsConfig = {
  __typename: "OnsiteOpsConfig",
  doctorLocationKey: string,
  doctor?: Doctor | null,
  location?: Location | null,
  medicalAssistant?: MedicalAssistant | null,
  secondaryMedicalAssistant?: MedicalAssistant | null,
  assignmentEffectiveDate?: string | null,
  createdAt: string,
  updatedAt: string,
  onsiteOpsConfigDoctorId?: string | null,
  onsiteOpsConfigLocationId?: string | null,
  onsiteOpsConfigMedicalAssistantId?: string | null,
  onsiteOpsConfigSecondaryMedicalAssistantId?: string | null,
};

export type UpdateOnsiteOpsConfigInput = {
  doctorLocationKey: string,
  assignmentEffectiveDate?: string | null,
  onsiteOpsConfigDoctorId?: string | null,
  onsiteOpsConfigLocationId?: string | null,
  onsiteOpsConfigMedicalAssistantId?: string | null,
  onsiteOpsConfigSecondaryMedicalAssistantId?: string | null,
};

export type DeleteOnsiteOpsConfigInput = {
  doctorLocationKey: string,
};

export type CreateOpsGlobalSettingsInput = {
  key: string,
  inPersonEvaluationPreVisitDurationDays?: number | null,
  supplementalPreVisitDurationDays?: number | null,
  depositionPreVisitDurationDays?: number | null,
  appointmentTypeMAAssignments?: Array< AppointmentTypeMAAssignmentInput | null > | null,
  maAssignmentCapacitySettings?: MAAssignmentCapacitySettingsInput | null,
  bodyPartSpecialtiesMappings?: Array< BodyPartSpecialtiesMappingInput | null > | null,
  opsGlobalSettingsDefaultGlobalOnsiteOpsId?: string | null,
  opsGlobalSettingsDefaultGlobalMAId?: string | null,
  opsGlobalSettingsDefaultGlobalSchedulerId?: string | null,
  opsGlobalSettingsDefaultGlobalReportOpsId?: string | null,
  opsGlobalSettingsDefaultGlobalPreVisitReviewerId?: string | null,
  opsGlobalSettingsDefaultGlobalBillingOpsId?: string | null,
};

export type AppointmentTypeMAAssignmentInput = {
  appointmentType: AppointmentType,
  maWeights: Array< AppointmentTypeMAWeightInput >,
};

export type AppointmentTypeMAWeightInput = {
  medicalAssistantID: string,
  weightPercentage: number,
};

export type MAAssignmentCapacitySettingsInput = {
  level1WeeklyPointBudget: number,
  level2WeeklyPointBudget: number,
  level3WeeklyPointBudget: number,
  level4WeeklyPointBudget: number,
  maxAppointmentsPerMAWeek: number,
  maxAppointmentsPerMADay?: number | null,
};

export type BodyPartSpecialtiesMappingInput = {
  bodyPart: BodyPart,
  specialties: Array< SpecialtyType >,
};

export type ModelOpsGlobalSettingsConditionInput = {
  inPersonEvaluationPreVisitDurationDays?: ModelIntInput | null,
  supplementalPreVisitDurationDays?: ModelIntInput | null,
  depositionPreVisitDurationDays?: ModelIntInput | null,
  and?: Array< ModelOpsGlobalSettingsConditionInput | null > | null,
  or?: Array< ModelOpsGlobalSettingsConditionInput | null > | null,
  not?: ModelOpsGlobalSettingsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  opsGlobalSettingsDefaultGlobalOnsiteOpsId?: ModelIDInput | null,
  opsGlobalSettingsDefaultGlobalMAId?: ModelIDInput | null,
  opsGlobalSettingsDefaultGlobalSchedulerId?: ModelIDInput | null,
  opsGlobalSettingsDefaultGlobalReportOpsId?: ModelIDInput | null,
  opsGlobalSettingsDefaultGlobalPreVisitReviewerId?: ModelIDInput | null,
  opsGlobalSettingsDefaultGlobalBillingOpsId?: ModelIDInput | null,
};

export type OpsGlobalSettings = {
  __typename: "OpsGlobalSettings",
  key: string,
  inPersonEvaluationPreVisitDurationDays?: number | null,
  supplementalPreVisitDurationDays?: number | null,
  depositionPreVisitDurationDays?: number | null,
  defaultGlobalOnsiteOps?: MedicalAssistant | null,
  defaultGlobalMA?: MedicalAssistant | null,
  defaultGlobalScheduler?: MedicalAssistant | null,
  defaultGlobalReportOps?: MedicalAssistant | null,
  defaultGlobalPreVisitReviewer?: MedicalAssistant | null,
  defaultGlobalBillingOps?: MedicalAssistant | null,
  appointmentTypeMAAssignments?:  Array<AppointmentTypeMAAssignment | null > | null,
  maAssignmentCapacitySettings?: MAAssignmentCapacitySettings | null,
  bodyPartSpecialtiesMappings?:  Array<BodyPartSpecialtiesMapping | null > | null,
  createdAt: string,
  updatedAt: string,
  opsGlobalSettingsDefaultGlobalOnsiteOpsId?: string | null,
  opsGlobalSettingsDefaultGlobalMAId?: string | null,
  opsGlobalSettingsDefaultGlobalSchedulerId?: string | null,
  opsGlobalSettingsDefaultGlobalReportOpsId?: string | null,
  opsGlobalSettingsDefaultGlobalPreVisitReviewerId?: string | null,
  opsGlobalSettingsDefaultGlobalBillingOpsId?: string | null,
};

export type AppointmentTypeMAAssignment = {
  __typename: "AppointmentTypeMAAssignment",
  appointmentType: AppointmentType,
  maWeights:  Array<AppointmentTypeMAWeight >,
};

export type AppointmentTypeMAWeight = {
  __typename: "AppointmentTypeMAWeight",
  medicalAssistantID: string,
  weightPercentage: number,
};

export type MAAssignmentCapacitySettings = {
  __typename: "MAAssignmentCapacitySettings",
  level1WeeklyPointBudget: number,
  level2WeeklyPointBudget: number,
  level3WeeklyPointBudget: number,
  level4WeeklyPointBudget: number,
  maxAppointmentsPerMAWeek: number,
  maxAppointmentsPerMADay?: number | null,
};

export type BodyPartSpecialtiesMapping = {
  __typename: "BodyPartSpecialtiesMapping",
  bodyPart: BodyPart,
  specialties: Array< SpecialtyType >,
};

export type UpdateOpsGlobalSettingsInput = {
  key: string,
  inPersonEvaluationPreVisitDurationDays?: number | null,
  supplementalPreVisitDurationDays?: number | null,
  depositionPreVisitDurationDays?: number | null,
  appointmentTypeMAAssignments?: Array< AppointmentTypeMAAssignmentInput | null > | null,
  maAssignmentCapacitySettings?: MAAssignmentCapacitySettingsInput | null,
  bodyPartSpecialtiesMappings?: Array< BodyPartSpecialtiesMappingInput | null > | null,
  opsGlobalSettingsDefaultGlobalOnsiteOpsId?: string | null,
  opsGlobalSettingsDefaultGlobalMAId?: string | null,
  opsGlobalSettingsDefaultGlobalSchedulerId?: string | null,
  opsGlobalSettingsDefaultGlobalReportOpsId?: string | null,
  opsGlobalSettingsDefaultGlobalPreVisitReviewerId?: string | null,
  opsGlobalSettingsDefaultGlobalBillingOpsId?: string | null,
};

export type DeleteOpsGlobalSettingsInput = {
  key: string,
};

export type CreateSpecialtyCategoryInput = {
  id?: string | null,
  name: string,
  specialties?: Array< SpecialtyType > | null,
  specialtyCategoryFallbackMAId?: string | null,
};

export type ModelSpecialtyCategoryConditionInput = {
  name?: ModelStringInput | null,
  specialties?: ModelSpecialtyTypeListInput | null,
  and?: Array< ModelSpecialtyCategoryConditionInput | null > | null,
  or?: Array< ModelSpecialtyCategoryConditionInput | null > | null,
  not?: ModelSpecialtyCategoryConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  specialtyCategoryFallbackMAId?: ModelIDInput | null,
};

export type UpdateSpecialtyCategoryInput = {
  id: string,
  name?: string | null,
  specialties?: Array< SpecialtyType > | null,
  specialtyCategoryFallbackMAId?: string | null,
};

export type DeleteSpecialtyCategoryInput = {
  id: string,
};

export type CreateCoverLetterRecapInput = {
  id?: string | null,
  uploadedFileID: string,
  recapText?: string | null,
  status: CoverLetterRecapStatus,
  errorMessage?: string | null,
  generatedAt?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
};

export enum CoverLetterRecapStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}


export type ModelCoverLetterRecapConditionInput = {
  uploadedFileID?: ModelIDInput | null,
  recapText?: ModelStringInput | null,
  status?: ModelCoverLetterRecapStatusInput | null,
  errorMessage?: ModelStringInput | null,
  generatedAt?: ModelStringInput | null,
  lastEditedAt?: ModelStringInput | null,
  lastEditedBy?: ModelIDInput | null,
  and?: Array< ModelCoverLetterRecapConditionInput | null > | null,
  or?: Array< ModelCoverLetterRecapConditionInput | null > | null,
  not?: ModelCoverLetterRecapConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelCoverLetterRecapStatusInput = {
  eq?: CoverLetterRecapStatus | null,
  ne?: CoverLetterRecapStatus | null,
};

export type CoverLetterRecap = {
  __typename: "CoverLetterRecap",
  id: string,
  uploadedFileID: string,
  recapText?: string | null,
  status: CoverLetterRecapStatus,
  errorMessage?: string | null,
  generatedAt?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateCoverLetterRecapInput = {
  id: string,
  uploadedFileID?: string | null,
  recapText?: string | null,
  status?: CoverLetterRecapStatus | null,
  errorMessage?: string | null,
  generatedAt?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
};

export type DeleteCoverLetterRecapInput = {
  id: string,
};

export type CreateIntroParagraphInput = {
  id?: string | null,
  appointmentRecordID: string,
  introParagraphText?: string | null,
  sourceRecaps?: Array< CoverLetterRecapSnapshotInput | null > | null,
  status: IntroParagraphStatus,
  errorMessage?: string | null,
  generatedAt?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
};

export type CoverLetterRecapSnapshotInput = {
  coverLetterRecapID: string,
  uploadedFileID: string,
  recapText: string,
  generatedAt?: string | null,
};

export type ModelIntroParagraphConditionInput = {
  appointmentRecordID?: ModelIDInput | null,
  introParagraphText?: ModelStringInput | null,
  status?: ModelIntroParagraphStatusInput | null,
  errorMessage?: ModelStringInput | null,
  generatedAt?: ModelStringInput | null,
  lastEditedAt?: ModelStringInput | null,
  lastEditedBy?: ModelIDInput | null,
  and?: Array< ModelIntroParagraphConditionInput | null > | null,
  or?: Array< ModelIntroParagraphConditionInput | null > | null,
  not?: ModelIntroParagraphConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelIntroParagraphStatusInput = {
  eq?: IntroParagraphStatus | null,
  ne?: IntroParagraphStatus | null,
};

export type UpdateIntroParagraphInput = {
  id: string,
  appointmentRecordID?: string | null,
  introParagraphText?: string | null,
  sourceRecaps?: Array< CoverLetterRecapSnapshotInput | null > | null,
  status?: IntroParagraphStatus | null,
  errorMessage?: string | null,
  generatedAt?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
};

export type DeleteIntroParagraphInput = {
  id: string,
};

export type CreateIntroductionStatementInput = {
  id?: string | null,
  appointmentRecordID: string,
  kind: IntroductionStatementKind,
  text?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
  selectedCoverLetterFileID?: string | null,
  selectionConfirmedAt?: string | null,
};

export enum IntroductionStatementKind {
  DEFENSE_ATTORNEY = "DEFENSE_ATTORNEY",
  APPLICANT_ATTORNEY = "APPLICANT_ATTORNEY",
  ADJUSTER = "ADJUSTER",
  OTHER = "OTHER",
  PATIENT = "PATIENT",
  CLOSING = "CLOSING",
}


export type ModelIntroductionStatementConditionInput = {
  appointmentRecordID?: ModelIDInput | null,
  kind?: ModelIntroductionStatementKindInput | null,
  text?: ModelStringInput | null,
  lastEditedAt?: ModelStringInput | null,
  lastEditedBy?: ModelIDInput | null,
  selectedCoverLetterFileID?: ModelIDInput | null,
  selectionConfirmedAt?: ModelStringInput | null,
  and?: Array< ModelIntroductionStatementConditionInput | null > | null,
  or?: Array< ModelIntroductionStatementConditionInput | null > | null,
  not?: ModelIntroductionStatementConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelIntroductionStatementKindInput = {
  eq?: IntroductionStatementKind | null,
  ne?: IntroductionStatementKind | null,
};

export type IntroductionStatement = {
  __typename: "IntroductionStatement",
  id: string,
  appointmentRecordID: string,
  kind: IntroductionStatementKind,
  text?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
  selectedCoverLetterFileID?: string | null,
  selectionConfirmedAt?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateIntroductionStatementInput = {
  id: string,
  appointmentRecordID?: string | null,
  kind?: IntroductionStatementKind | null,
  text?: string | null,
  lastEditedAt?: string | null,
  lastEditedBy?: string | null,
  selectedCoverLetterFileID?: string | null,
  selectionConfirmedAt?: string | null,
};

export type DeleteIntroductionStatementInput = {
  id: string,
};

export type CreateAssessmentInput = {
  id?: string | null,
  injuries?: Array< AssessmentInjuryInput | null > | null,
  discussedBodyParts?: Array< BodyPart | null > | null,
  bodyPartsNotDiscussedReason?: string | null,
  discussions?: string | null,
  diagnoses?: Array< AssessmentDiagnosisInput | null > | null,
  bodyPartMMIStatus?: AssessmentBodyPartMMIStatusInput | null,
  workStatus?: string | null,
  markedAsDone?: boolean | null,
  discussDiagnosesFreeForm?: boolean | null,
  diagnosesFreeform?: string | null,
  discussCausationFreeForm?: boolean | null,
  causationFreeForm?: string | null,
  discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
  hasPatientReachedMMIFreeForm?: string | null,
  discussMMIByBodyPartFreeForm?: string | null,
  impairmentRatingByBodyPartFreeForm?: string | null,
  apportionmentByBodyPartFreeForm?: string | null,
  impairmentRatingOtherComments?: string | null,
  apportionmentOtherComments?: string | null,
  assessmentMode?: AssessmentMode | null,
  assessmentFreeForm?: AssessmentFreeFormInput | null,
};

export type AssessmentInjuryInput = {
  injuryType?: InjuryType | null,
  dateOfInjury?: string | null,
  dateOfInjuryFlexible?: FlexibleDateInput | null,
  dateOfInjuryEnd?: string | null,
  dateOfInjuryEndFlexible?: FlexibleDateInput | null,
  bodyParts?: Array< BodyPart | null > | null,
  causeOfInjury?: string | null,
  causedByWork?: AssessmentCausationOption | null,
  causedByWorkExplanation?: string | null,
};

export type AssessmentDiagnosisInput = {
  diagnosis?: string | null,
  icdCode?: string | null,
  evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
  evidence?: string | null,
};

export type AssessmentBodyPartMMIStatusInput = {
  discussByBodyPart?: boolean | null,
  allBodyPartsMMI?: AssessmentBodyPartEvaluationInput | null,
  bodyPartMMIStatuses?: Array< AssessmentBodyPartInput | null > | null,
};

export type AssessmentBodyPartEvaluationInput = {
  mmi?: boolean | null,
  mmiReason?: string | null,
  expectedMMITimeRange?: AssessmentMmiTimeRange | null,
  expectedMMITimeRangeExplanation?: string | null,
  treatments?: Array< string | null > | null,
  treatmentsExplanation?: string | null,
  discussions?: string | null,
  impairmentRating?: string | null,
  impairmentRatingNotApplicable?: boolean | null,
  deferImpairmentRating?: boolean | null,
  deferImpairmentRatingReason?: string | null,
  apportionment?: string | null,
  apportionmentNotApplicable?: boolean | null,
  deferApportionment?: boolean | null,
  deferApportionmentReason?: string | null,
};

export type AssessmentBodyPartInput = {
  bodyPart?: BodyPart | null,
  evaluation?: AssessmentBodyPartEvaluationInput | null,
};

export type AssessmentFreeFormInput = {
  injuries?: Array< AssessmentInjuryInput | null > | null,
  discussions?: string | null,
  diagnosesAndEvidence?: string | null,
  causation?: string | null,
  hasPatientReachedMMI?: string | null,
  discussMMIByBodyPart?: string | null,
  impairmentRatingByBodyPart?: string | null,
  apportionmentByBodyPart?: string | null,
  workStatus?: string | null,
};

export type ModelAssessmentConditionInput = {
  discussedBodyParts?: ModelBodyPartListInput | null,
  bodyPartsNotDiscussedReason?: ModelStringInput | null,
  discussions?: ModelStringInput | null,
  workStatus?: ModelStringInput | null,
  markedAsDone?: ModelBooleanInput | null,
  discussDiagnosesFreeForm?: ModelBooleanInput | null,
  diagnosesFreeform?: ModelStringInput | null,
  discussCausationFreeForm?: ModelBooleanInput | null,
  causationFreeForm?: ModelStringInput | null,
  discussMMIImpairmentRatingApportionmentFreeForm?: ModelBooleanInput | null,
  hasPatientReachedMMIFreeForm?: ModelStringInput | null,
  discussMMIByBodyPartFreeForm?: ModelStringInput | null,
  impairmentRatingByBodyPartFreeForm?: ModelStringInput | null,
  apportionmentByBodyPartFreeForm?: ModelStringInput | null,
  impairmentRatingOtherComments?: ModelStringInput | null,
  apportionmentOtherComments?: ModelStringInput | null,
  assessmentMode?: ModelAssessmentModeInput | null,
  and?: Array< ModelAssessmentConditionInput | null > | null,
  or?: Array< ModelAssessmentConditionInput | null > | null,
  not?: ModelAssessmentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateAssessmentInput = {
  id: string,
  injuries?: Array< AssessmentInjuryInput | null > | null,
  discussedBodyParts?: Array< BodyPart | null > | null,
  bodyPartsNotDiscussedReason?: string | null,
  discussions?: string | null,
  diagnoses?: Array< AssessmentDiagnosisInput | null > | null,
  bodyPartMMIStatus?: AssessmentBodyPartMMIStatusInput | null,
  workStatus?: string | null,
  markedAsDone?: boolean | null,
  discussDiagnosesFreeForm?: boolean | null,
  diagnosesFreeform?: string | null,
  discussCausationFreeForm?: boolean | null,
  causationFreeForm?: string | null,
  discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
  hasPatientReachedMMIFreeForm?: string | null,
  discussMMIByBodyPartFreeForm?: string | null,
  impairmentRatingByBodyPartFreeForm?: string | null,
  apportionmentByBodyPartFreeForm?: string | null,
  impairmentRatingOtherComments?: string | null,
  apportionmentOtherComments?: string | null,
  assessmentMode?: AssessmentMode | null,
  assessmentFreeForm?: AssessmentFreeFormInput | null,
};

export type DeleteAssessmentInput = {
  id: string,
};

export type CreateValidationCheckInput = {
  id?: string | null,
  validationID: string,
  checkType: string,
  inputResourceURIs: Array< string | null >,
  status: ValidationStatus,
};

export type ModelValidationCheckConditionInput = {
  validationID?: ModelIDInput | null,
  checkType?: ModelStringInput | null,
  inputResourceURIs?: ModelStringInput | null,
  status?: ModelValidationStatusInput | null,
  and?: Array< ModelValidationCheckConditionInput | null > | null,
  or?: Array< ModelValidationCheckConditionInput | null > | null,
  not?: ModelValidationCheckConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelValidationStatusInput = {
  eq?: ValidationStatus | null,
  ne?: ValidationStatus | null,
};

export type ValidationCheck = {
  __typename: "ValidationCheck",
  id: string,
  validationID: string,
  checkType: string,
  inputResourceURIs: Array< string | null >,
  status: ValidationStatus,
  issues?: ModelValidationIssueConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateValidationCheckInput = {
  id: string,
  validationID?: string | null,
  checkType?: string | null,
  inputResourceURIs?: Array< string | null > | null,
  status?: ValidationStatus | null,
};

export type DeleteValidationCheckInput = {
  id: string,
};

export type CreateValidationIssueInput = {
  id?: string | null,
  validationID: string,
  validationCheckID: string,
  title?: string | null,
  issue: string,
  status: ValidationStatus,
  resourceURI: string,
  issueGroup: string,
  issueType?: ValidationIssueType | null,
};

export type ModelValidationIssueConditionInput = {
  validationID?: ModelIDInput | null,
  validationCheckID?: ModelIDInput | null,
  title?: ModelStringInput | null,
  issue?: ModelStringInput | null,
  status?: ModelValidationStatusInput | null,
  resourceURI?: ModelStringInput | null,
  issueGroup?: ModelStringInput | null,
  issueType?: ModelValidationIssueTypeInput | null,
  and?: Array< ModelValidationIssueConditionInput | null > | null,
  or?: Array< ModelValidationIssueConditionInput | null > | null,
  not?: ModelValidationIssueConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelValidationIssueTypeInput = {
  eq?: ValidationIssueType | null,
  ne?: ValidationIssueType | null,
};

export type UpdateValidationIssueInput = {
  id: string,
  validationID?: string | null,
  validationCheckID?: string | null,
  title?: string | null,
  issue?: string | null,
  status?: ValidationStatus | null,
  resourceURI?: string | null,
  issueGroup?: string | null,
  issueType?: ValidationIssueType | null,
};

export type DeleteValidationIssueInput = {
  id: string,
};

export type CreateValidationInput = {
  id?: string | null,
  issueGroups: Array< string | null >,
};

export type ModelValidationConditionInput = {
  issueGroups?: ModelStringInput | null,
  and?: Array< ModelValidationConditionInput | null > | null,
  or?: Array< ModelValidationConditionInput | null > | null,
  not?: ModelValidationConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateValidationInput = {
  id: string,
  issueGroups?: Array< string | null > | null,
};

export type DeleteValidationInput = {
  id: string,
};

export type CreateWorkflowAuditEntryInput = {
  id?: string | null,
  workflowAuditID: string,
  message: string,
  actorType?: UserGroup | null,
  actorID?: string | null,
  entryType?: string | null,
  attachments: Array< S3BlobInput >,
  relatedActionIDs?: Array< string > | null,
  payload?: string | null,
  correlationID?: string | null,
};

export type ModelWorkflowAuditEntryConditionInput = {
  workflowAuditID?: ModelIDInput | null,
  message?: ModelStringInput | null,
  actorType?: ModelUserGroupInput | null,
  actorID?: ModelIDInput | null,
  entryType?: ModelStringInput | null,
  relatedActionIDs?: ModelIDInput | null,
  payload?: ModelStringInput | null,
  correlationID?: ModelStringInput | null,
  and?: Array< ModelWorkflowAuditEntryConditionInput | null > | null,
  or?: Array< ModelWorkflowAuditEntryConditionInput | null > | null,
  not?: ModelWorkflowAuditEntryConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type WorkflowAuditEntry = {
  __typename: "WorkflowAuditEntry",
  id: string,
  workflowAuditID: string,
  message: string,
  actorType?: UserGroup | null,
  actorID?: string | null,
  entryType?: string | null,
  attachments:  Array<S3Blob >,
  relatedActionIDs?: Array< string > | null,
  payload?: string | null,
  correlationID?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateWorkflowAuditEntryInput = {
  id: string,
  workflowAuditID?: string | null,
  message?: string | null,
  actorType?: UserGroup | null,
  actorID?: string | null,
  entryType?: string | null,
  attachments?: Array< S3BlobInput > | null,
  relatedActionIDs?: Array< string > | null,
  payload?: string | null,
  correlationID?: string | null,
};

export type DeleteWorkflowAuditEntryInput = {
  id: string,
};

export type CreateWorkflowAuditInput = {
  id?: string | null,
  workflowType: string,
  entityID: string,
  entityType: string,
  appointmentID?: string | null,
};

export type ModelWorkflowAuditConditionInput = {
  workflowType?: ModelStringInput | null,
  entityID?: ModelIDInput | null,
  entityType?: ModelStringInput | null,
  appointmentID?: ModelIDInput | null,
  and?: Array< ModelWorkflowAuditConditionInput | null > | null,
  or?: Array< ModelWorkflowAuditConditionInput | null > | null,
  not?: ModelWorkflowAuditConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type WorkflowAudit = {
  __typename: "WorkflowAudit",
  id: string,
  workflowType: string,
  entityID: string,
  entityType: string,
  appointmentID?: string | null,
  entries?: ModelWorkflowAuditEntryConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelWorkflowAuditEntryConnection = {
  __typename: "ModelWorkflowAuditEntryConnection",
  items:  Array<WorkflowAuditEntry | null >,
  nextToken?: string | null,
};

export type UpdateWorkflowAuditInput = {
  id: string,
  workflowType?: string | null,
  entityID?: string | null,
  entityType?: string | null,
  appointmentID?: string | null,
};

export type DeleteWorkflowAuditInput = {
  id: string,
};

export type CreateWorkflowAuditActionInput = {
  id?: string | null,
  workflowAuditID: string,
  appointmentID?: string | null,
  actionType: string,
  status: WorkflowAuditActionStatus,
  payload: string,
  rationale?: string | null,
};

export enum WorkflowAuditActionStatus {
  PROPOSED = "PROPOSED",
  RESOLVED = "RESOLVED",
  REJECTED = "REJECTED",
  STALE = "STALE",
}


export type ModelWorkflowAuditActionConditionInput = {
  workflowAuditID?: ModelIDInput | null,
  appointmentID?: ModelIDInput | null,
  actionType?: ModelStringInput | null,
  status?: ModelWorkflowAuditActionStatusInput | null,
  payload?: ModelStringInput | null,
  rationale?: ModelStringInput | null,
  and?: Array< ModelWorkflowAuditActionConditionInput | null > | null,
  or?: Array< ModelWorkflowAuditActionConditionInput | null > | null,
  not?: ModelWorkflowAuditActionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelWorkflowAuditActionStatusInput = {
  eq?: WorkflowAuditActionStatus | null,
  ne?: WorkflowAuditActionStatus | null,
};

export type WorkflowAuditAction = {
  __typename: "WorkflowAuditAction",
  id: string,
  workflowAuditID: string,
  appointmentID?: string | null,
  actionType: string,
  status: WorkflowAuditActionStatus,
  payload: string,
  rationale?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateWorkflowAuditActionInput = {
  id: string,
  workflowAuditID?: string | null,
  appointmentID?: string | null,
  actionType?: string | null,
  status?: WorkflowAuditActionStatus | null,
  payload?: string | null,
  rationale?: string | null,
};

export type DeleteWorkflowAuditActionInput = {
  id: string,
};

export type CreateFormDataDraftInput = {
  id?: string | null,
  timestamp: string,
  formType: string,
  appointmentId: string,
  data: string,
  ttl?: number | null,
};

export type ModelFormDataDraftConditionInput = {
  formType?: ModelStringInput | null,
  appointmentId?: ModelIDInput | null,
  data?: ModelStringInput | null,
  ttl?: ModelIntInput | null,
  and?: Array< ModelFormDataDraftConditionInput | null > | null,
  or?: Array< ModelFormDataDraftConditionInput | null > | null,
  not?: ModelFormDataDraftConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type FormDataDraft = {
  __typename: "FormDataDraft",
  id: string,
  timestamp: string,
  formType: string,
  appointmentId: string,
  data: string,
  ttl?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateFormDataDraftInput = {
  id: string,
  timestamp: string,
  formType?: string | null,
  appointmentId?: string | null,
  data?: string | null,
  ttl?: number | null,
};

export type DeleteFormDataDraftInput = {
  id: string,
  timestamp: string,
};

export type CreateHistoryValidationInput = {
  id?: string | null,
  appointmentRecordID: string,
  status: HistoryValidationStatus,
  groups: Array< HistoryValidationGroupInput | null >,
  validatedAt?: string | null,
  errorMessage?: string | null,
};

export type HistoryValidationGroupInput = {
  id: string,
  title: string,
  status: HistoryValidationGroupStatus,
  issues: Array< HistoryValidationIssueInput | null >,
};

export type HistoryValidationIssueInput = {
  id: string,
  title: string,
  description?: string | null,
  patientInfoSection?: PatientInfoSection | null,
  issueType?: ValidationIssueType | null,
};

export type ModelHistoryValidationConditionInput = {
  appointmentRecordID?: ModelIDInput | null,
  status?: ModelHistoryValidationStatusInput | null,
  validatedAt?: ModelStringInput | null,
  errorMessage?: ModelStringInput | null,
  and?: Array< ModelHistoryValidationConditionInput | null > | null,
  or?: Array< ModelHistoryValidationConditionInput | null > | null,
  not?: ModelHistoryValidationConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelHistoryValidationStatusInput = {
  eq?: HistoryValidationStatus | null,
  ne?: HistoryValidationStatus | null,
};

export type UpdateHistoryValidationInput = {
  id: string,
  appointmentRecordID?: string | null,
  status?: HistoryValidationStatus | null,
  groups?: Array< HistoryValidationGroupInput | null > | null,
  validatedAt?: string | null,
  errorMessage?: string | null,
};

export type DeleteHistoryValidationInput = {
  id: string,
};

export type CreateFieldTemplateInput = {
  id?: string | null,
  version: number,
  templateType: FieldTemplateType,
  specialty?: SpecialtyType | null,
  doctorId?: string | null,
  latestMarker?: string | null,
  adlFieldSectionMappings?: Array< ADLFieldSectionMappingInput | null > | null,
  medicalHistoryFieldIDs?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  lastUpdatedBy?: string | null,
  changeDescription?: string | null,
};

export enum FieldTemplateType {
  GLOBAL = "GLOBAL",
  SPECIALTY = "SPECIALTY",
  DOCTOR = "DOCTOR",
}


export type ADLFieldSectionMappingInput = {
  ADLFieldSectionID: string,
  ADLFieldIDs: Array< string >,
};

export type ModelFieldTemplateConditionInput = {
  templateType?: ModelFieldTemplateTypeInput | null,
  specialty?: ModelSpecialtyTypeInput | null,
  doctorId?: ModelIDInput | null,
  latestMarker?: ModelStringInput | null,
  medicalHistoryFieldIDs?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  lastUpdatedBy?: ModelIDInput | null,
  changeDescription?: ModelStringInput | null,
  and?: Array< ModelFieldTemplateConditionInput | null > | null,
  or?: Array< ModelFieldTemplateConditionInput | null > | null,
  not?: ModelFieldTemplateConditionInput | null,
};

export type ModelFieldTemplateTypeInput = {
  eq?: FieldTemplateType | null,
  ne?: FieldTemplateType | null,
};

export type FieldTemplate = {
  __typename: "FieldTemplate",
  id: string,
  version: number,
  templateType: FieldTemplateType,
  specialty?: SpecialtyType | null,
  doctorId?: string | null,
  latestMarker?: string | null,
  adlFieldSectionMappings?:  Array<ADLFieldSectionMapping | null > | null,
  medicalHistoryFieldIDs?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  lastUpdatedBy?: string | null,
  changeDescription?: string | null,
};

export type ADLFieldSectionMapping = {
  __typename: "ADLFieldSectionMapping",
  ADLFieldSectionID: string,
  ADLFieldIDs: Array< string >,
};

export type UpdateFieldTemplateInput = {
  id: string,
  version: number,
  templateType?: FieldTemplateType | null,
  specialty?: SpecialtyType | null,
  doctorId?: string | null,
  latestMarker?: string | null,
  adlFieldSectionMappings?: Array< ADLFieldSectionMappingInput | null > | null,
  medicalHistoryFieldIDs?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  lastUpdatedBy?: string | null,
  changeDescription?: string | null,
};

export type DeleteFieldTemplateInput = {
  id: string,
  version: number,
};

export type CreatePhysicalEvalTemplateInput = {
  id?: string | null,
  version: number,
  templateType: PhysicalEvalTemplateType,
  specialtyCategoryId: string,
  doctorId?: string | null,
  latestMarker?: string | null,
  exams?: Array< PhysicalExamInput | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  lastUpdatedBy?: string | null,
  changeDescription?: string | null,
};

export enum PhysicalEvalTemplateType {
  SPECIALTY = "SPECIALTY",
  DOCTOR = "DOCTOR",
}


export type PhysicalExamInput = {
  examID: string,
  name: string,
  bodyParts: Array< BodyPart >,
  instructions?: string | null,
  sections?: Array< PhysicalExamSectionInput | null > | null,
};

export type PhysicalExamSectionInput = {
  sectionID: string,
  name: string,
  fieldType: PhysicalExamFieldType,
  config?: PhysicalExamSectionConfigInput | null,
  questions?: Array< PhysicalExamQuestionInput | null > | null,
};

export enum PhysicalExamFieldType {
  YES_NO = "YES_NO",
  POS_NEG = "POS_NEG",
  DEGREE = "DEGREE",
  SCALE = "SCALE",
  FREEFORM = "FREEFORM",
}


export type PhysicalExamSectionConfigInput = {
  minValue?: number | null,
  maxValue?: number | null,
  increment?: number | null,
  allowPlusMinus?: boolean | null,
  allowPlus?: boolean | null,
  unit?: PhysicalExamUnit | null,
  freeformInputCount?: number | null,
  laterality?: boolean | null,
  hasNote?: boolean | null,
  hasDefault?: boolean | null,
  hasOtherFindings?: boolean | null,
  renderStyle?: PhysicalExamRenderStyle | null,
};

export enum PhysicalExamUnit {
  CM = "CM",
  IN = "IN",
  FAHRENHEIT = "FAHRENHEIT",
  CELSIUS = "CELSIUS",
  LBS = "LBS",
}


export enum PhysicalExamRenderStyle {
  TABLE = "TABLE",
  PARAGRAPH = "PARAGRAPH",
}


export type PhysicalExamQuestionInput = {
  questionID: string,
  label: string,
  defaultValue?: string | null,
  defaultValueLeft?: string | null,
  defaultValueRight?: string | null,
  phrasing?: PhysicalExamPhrasing | null,
  positiveText?: string | null,
  negativeText?: string | null,
};

export enum PhysicalExamPhrasing {
  PRESENCE = "PRESENCE",
  ASSERTION = "ASSERTION",
  TEST = "TEST",
  CUSTOM = "CUSTOM",
}


export type ModelPhysicalEvalTemplateConditionInput = {
  templateType?: ModelPhysicalEvalTemplateTypeInput | null,
  specialtyCategoryId?: ModelIDInput | null,
  doctorId?: ModelIDInput | null,
  latestMarker?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  lastUpdatedBy?: ModelIDInput | null,
  changeDescription?: ModelStringInput | null,
  and?: Array< ModelPhysicalEvalTemplateConditionInput | null > | null,
  or?: Array< ModelPhysicalEvalTemplateConditionInput | null > | null,
  not?: ModelPhysicalEvalTemplateConditionInput | null,
};

export type ModelPhysicalEvalTemplateTypeInput = {
  eq?: PhysicalEvalTemplateType | null,
  ne?: PhysicalEvalTemplateType | null,
};

export type PhysicalEvalTemplate = {
  __typename: "PhysicalEvalTemplate",
  id: string,
  version: number,
  templateType: PhysicalEvalTemplateType,
  specialtyCategoryId: string,
  doctorId?: string | null,
  latestMarker?: string | null,
  exams?:  Array<PhysicalExam | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  lastUpdatedBy?: string | null,
  changeDescription?: string | null,
};

export type PhysicalExam = {
  __typename: "PhysicalExam",
  examID: string,
  name: string,
  bodyParts: Array< BodyPart >,
  instructions?: string | null,
  sections?:  Array<PhysicalExamSection | null > | null,
};

export type PhysicalExamSection = {
  __typename: "PhysicalExamSection",
  sectionID: string,
  name: string,
  fieldType: PhysicalExamFieldType,
  config?: PhysicalExamSectionConfig | null,
  questions?:  Array<PhysicalExamQuestion | null > | null,
};

export type PhysicalExamSectionConfig = {
  __typename: "PhysicalExamSectionConfig",
  minValue?: number | null,
  maxValue?: number | null,
  increment?: number | null,
  allowPlusMinus?: boolean | null,
  allowPlus?: boolean | null,
  unit?: PhysicalExamUnit | null,
  freeformInputCount?: number | null,
  laterality?: boolean | null,
  hasNote?: boolean | null,
  hasDefault?: boolean | null,
  hasOtherFindings?: boolean | null,
  renderStyle?: PhysicalExamRenderStyle | null,
};

export type PhysicalExamQuestion = {
  __typename: "PhysicalExamQuestion",
  questionID: string,
  label: string,
  defaultValue?: string | null,
  defaultValueLeft?: string | null,
  defaultValueRight?: string | null,
  phrasing?: PhysicalExamPhrasing | null,
  positiveText?: string | null,
  negativeText?: string | null,
};

export type UpdatePhysicalEvalTemplateInput = {
  id: string,
  version: number,
  templateType?: PhysicalEvalTemplateType | null,
  specialtyCategoryId?: string | null,
  doctorId?: string | null,
  latestMarker?: string | null,
  exams?: Array< PhysicalExamInput | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  lastUpdatedBy?: string | null,
  changeDescription?: string | null,
};

export type DeletePhysicalEvalTemplateInput = {
  id: string,
  version: number,
};

export type CreateZendeskTicketInput = {
  id?: string | null,
  ticketID: number,
  appointmentRecordID: string,
  recipientParty: InquiringParty,
  isPrimary: boolean,
  isTextTicket?: boolean | null,
  claimNumber: string,
  version: string,
  lastSyncedAt: string,
};

export type ModelZendeskTicketConditionInput = {
  ticketID?: ModelIntInput | null,
  appointmentRecordID?: ModelIDInput | null,
  recipientParty?: ModelInquiringPartyInput | null,
  isPrimary?: ModelBooleanInput | null,
  isTextTicket?: ModelBooleanInput | null,
  claimNumber?: ModelStringInput | null,
  version?: ModelStringInput | null,
  lastSyncedAt?: ModelStringInput | null,
  and?: Array< ModelZendeskTicketConditionInput | null > | null,
  or?: Array< ModelZendeskTicketConditionInput | null > | null,
  not?: ModelZendeskTicketConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelInquiringPartyInput = {
  eq?: InquiringParty | null,
  ne?: InquiringParty | null,
};

export type ZendeskTicket = {
  __typename: "ZendeskTicket",
  id: string,
  ticketID: number,
  appointmentRecordID: string,
  recipientParty: InquiringParty,
  isPrimary: boolean,
  isTextTicket?: boolean | null,
  claimNumber: string,
  version: string,
  lastSyncedAt: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateZendeskTicketInput = {
  id: string,
  ticketID?: number | null,
  appointmentRecordID?: string | null,
  recipientParty?: InquiringParty | null,
  isPrimary?: boolean | null,
  isTextTicket?: boolean | null,
  claimNumber?: string | null,
  version?: string | null,
  lastSyncedAt?: string | null,
};

export type DeleteZendeskTicketInput = {
  id: string,
};

export type CreateScheduledCommunicationInput = {
  id?: string | null,
  appointmentRecordID: string,
  communicationType: CommunicationType,
  targetParty: InquiringParty,
  scheduledDate: string,
  status: CommunicationStatus,
  templateParams?: string | null,
  sentAt?: string | null,
  zendeskTicketID?: number | null,
};

export enum CommunicationType {
  AA_COVER_LETTER_10D = "AA_COVER_LETTER_10D",
  DA_ADJ_RECORDS_10D = "DA_ADJ_RECORDS_10D",
  DA_ADJ_INTERPRETER_10D = "DA_ADJ_INTERPRETER_10D",
  DA_ADJ_RECORDS_AND_INTERPRETER_10D = "DA_ADJ_RECORDS_AND_INTERPRETER_10D",
  DA_ADJ_INTERPRETER_6D = "DA_ADJ_INTERPRETER_6D",
  DA_ADJ_INTERPRETER_3D = "DA_ADJ_INTERPRETER_3D",
  DA_ADJ_INTERPRETER_1D = "DA_ADJ_INTERPRETER_1D",
  REPORT_DELIVERY = "REPORT_DELIVERY",
  ATTENDANCE_NOTICE = "ATTENDANCE_NOTICE",
  APPOINTMENT_CONFIRMATION = "APPOINTMENT_CONFIRMATION",
  PATIENT_TEXT_PREVISIT_14D = "PATIENT_TEXT_PREVISIT_14D",
  PATIENT_TEXT_PREVISIT_10D = "PATIENT_TEXT_PREVISIT_10D",
  PATIENT_TEXT_PREVISIT_7D = "PATIENT_TEXT_PREVISIT_7D",
  PATIENT_TEXT_PREVISIT_5D = "PATIENT_TEXT_PREVISIT_5D",
  PATIENT_TEXT_PREVISIT_3D = "PATIENT_TEXT_PREVISIT_3D",
  PATIENT_TEXT_HISTORY_CALL_3D = "PATIENT_TEXT_HISTORY_CALL_3D",
  PATIENT_TEXT_HISTORY_CALL_1D = "PATIENT_TEXT_HISTORY_CALL_1D",
  PATIENT_TEXT_HISTORY_CALL_0D = "PATIENT_TEXT_HISTORY_CALL_0D",
  PATIENT_TEXT_FORM_CONFIRMATION = "PATIENT_TEXT_FORM_CONFIRMATION",
  PATIENT_TEXT_HISTORY_CALL_NO_SHOW = "PATIENT_TEXT_HISTORY_CALL_NO_SHOW",
  PATIENT_TEXT_APPOINTMENT_REMINDER_1D = "PATIENT_TEXT_APPOINTMENT_REMINDER_1D",
}


export enum CommunicationStatus {
  SCHEDULED = "SCHEDULED",
  SENT = "SENT",
  CANCELLED_AUTO = "CANCELLED_AUTO",
  CANCELLED_MANUAL = "CANCELLED_MANUAL",
}


export type ModelScheduledCommunicationConditionInput = {
  appointmentRecordID?: ModelIDInput | null,
  communicationType?: ModelCommunicationTypeInput | null,
  targetParty?: ModelInquiringPartyInput | null,
  scheduledDate?: ModelStringInput | null,
  status?: ModelCommunicationStatusInput | null,
  templateParams?: ModelStringInput | null,
  sentAt?: ModelStringInput | null,
  zendeskTicketID?: ModelIntInput | null,
  and?: Array< ModelScheduledCommunicationConditionInput | null > | null,
  or?: Array< ModelScheduledCommunicationConditionInput | null > | null,
  not?: ModelScheduledCommunicationConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelCommunicationTypeInput = {
  eq?: CommunicationType | null,
  ne?: CommunicationType | null,
};

export type ModelCommunicationStatusInput = {
  eq?: CommunicationStatus | null,
  ne?: CommunicationStatus | null,
};

export type ScheduledCommunication = {
  __typename: "ScheduledCommunication",
  id: string,
  appointmentRecordID: string,
  communicationType: CommunicationType,
  targetParty: InquiringParty,
  scheduledDate: string,
  status: CommunicationStatus,
  templateParams?: string | null,
  sentAt?: string | null,
  zendeskTicketID?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateScheduledCommunicationInput = {
  id: string,
  appointmentRecordID?: string | null,
  communicationType?: CommunicationType | null,
  targetParty?: InquiringParty | null,
  scheduledDate?: string | null,
  status?: CommunicationStatus | null,
  templateParams?: string | null,
  sentAt?: string | null,
  zendeskTicketID?: number | null,
};

export type DeleteScheduledCommunicationInput = {
  id: string,
};

export type CreateAppointmentEventInput = {
  id?: string | null,
  appointmentRecordID: string,
  entity?: string | null,
  entityID?: string | null,
  action?: string | null,
  actorType?: UserGroup | null,
  actorID?: string | null,
  timestamp?: string | null,
  properties?: string | null,
  source?: string | null,
};

export type ModelAppointmentEventConditionInput = {
  appointmentRecordID?: ModelIDInput | null,
  entity?: ModelStringInput | null,
  entityID?: ModelIDInput | null,
  action?: ModelStringInput | null,
  actorType?: ModelUserGroupInput | null,
  actorID?: ModelIDInput | null,
  timestamp?: ModelStringInput | null,
  properties?: ModelStringInput | null,
  source?: ModelStringInput | null,
  and?: Array< ModelAppointmentEventConditionInput | null > | null,
  or?: Array< ModelAppointmentEventConditionInput | null > | null,
  not?: ModelAppointmentEventConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type AppointmentEvent = {
  __typename: "AppointmentEvent",
  id: string,
  appointmentRecordID: string,
  entity?: string | null,
  entityID?: string | null,
  action?: string | null,
  actorType?: UserGroup | null,
  actorID?: string | null,
  timestamp?: string | null,
  properties?: string | null,
  source?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateAppointmentEventInput = {
  id: string,
  appointmentRecordID?: string | null,
  entity?: string | null,
  entityID?: string | null,
  action?: string | null,
  actorType?: UserGroup | null,
  actorID?: string | null,
  timestamp?: string | null,
  properties?: string | null,
  source?: string | null,
};

export type DeleteAppointmentEventInput = {
  id: string,
};

export type CreateAppointmentNotificationInput = {
  id?: string | null,
  appointmentRecordID: string,
  entityType?: string | null,
  entityID?: string | null,
  notificationType: string,
  channel: NotificationChannel,
  recipientType: UserGroup,
  recipientID: string,
  recipientName?: string | null,
  title: string,
  body: string,
  status: string,
  readAt?: string | null,
  ttl?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum NotificationChannel {
  EMAIL = "EMAIL",
  PORTAL = "PORTAL",
}


export type ModelAppointmentNotificationConditionInput = {
  appointmentRecordID?: ModelIDInput | null,
  entityType?: ModelStringInput | null,
  entityID?: ModelIDInput | null,
  notificationType?: ModelStringInput | null,
  channel?: ModelNotificationChannelInput | null,
  recipientType?: ModelUserGroupInput | null,
  recipientID?: ModelIDInput | null,
  recipientName?: ModelStringInput | null,
  title?: ModelStringInput | null,
  body?: ModelStringInput | null,
  status?: ModelStringInput | null,
  readAt?: ModelStringInput | null,
  ttl?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAppointmentNotificationConditionInput | null > | null,
  or?: Array< ModelAppointmentNotificationConditionInput | null > | null,
  not?: ModelAppointmentNotificationConditionInput | null,
};

export type ModelNotificationChannelInput = {
  eq?: NotificationChannel | null,
  ne?: NotificationChannel | null,
};

export type AppointmentNotification = {
  __typename: "AppointmentNotification",
  id: string,
  appointmentRecordID: string,
  entityType?: string | null,
  entityID?: string | null,
  notificationType: string,
  channel: NotificationChannel,
  recipientType: UserGroup,
  recipientID: string,
  recipientName?: string | null,
  title: string,
  body: string,
  status: string,
  readAt?: string | null,
  ttl?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateAppointmentNotificationInput = {
  id: string,
  appointmentRecordID?: string | null,
  entityType?: string | null,
  entityID?: string | null,
  notificationType?: string | null,
  channel?: NotificationChannel | null,
  recipientType?: UserGroup | null,
  recipientID?: string | null,
  recipientName?: string | null,
  title?: string | null,
  body?: string | null,
  status?: string | null,
  readAt?: string | null,
  ttl?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAppointmentNotificationInput = {
  id: string,
};

export type CreateEmailNotificationQueueInput = {
  id?: string | null,
  appointmentRecordID: string,
  notificationType: string,
  recipientID: string,
  status: EmailNotificationStatus,
  emailDeliveryID?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum EmailNotificationStatus {
  PENDING = "PENDING",
  SENT = "SENT",
}


export type ModelEmailNotificationQueueConditionInput = {
  appointmentRecordID?: ModelIDInput | null,
  notificationType?: ModelStringInput | null,
  recipientID?: ModelIDInput | null,
  status?: ModelEmailNotificationStatusInput | null,
  emailDeliveryID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEmailNotificationQueueConditionInput | null > | null,
  or?: Array< ModelEmailNotificationQueueConditionInput | null > | null,
  not?: ModelEmailNotificationQueueConditionInput | null,
};

export type ModelEmailNotificationStatusInput = {
  eq?: EmailNotificationStatus | null,
  ne?: EmailNotificationStatus | null,
};

export type EmailNotificationQueue = {
  __typename: "EmailNotificationQueue",
  id: string,
  appointmentRecordID: string,
  notificationType: string,
  recipientID: string,
  status: EmailNotificationStatus,
  emailDeliveryID?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateEmailNotificationQueueInput = {
  id: string,
  appointmentRecordID?: string | null,
  notificationType?: string | null,
  recipientID?: string | null,
  status?: EmailNotificationStatus | null,
  emailDeliveryID?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteEmailNotificationQueueInput = {
  id: string,
};

export type CreateEmailDeliveryInput = {
  id?: string | null,
  emailType: string,
  recipientID: string,
  recipientEmail: string,
  subject: string,
  body: string,
  htmlBody?: string | null,
  status: EmailDeliveryStatus,
  sentAt?: string | null,
  failureReason?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum EmailDeliveryStatus {
  PENDING = "PENDING",
  SENT = "SENT",
  FAILED = "FAILED",
}


export type ModelEmailDeliveryConditionInput = {
  emailType?: ModelStringInput | null,
  recipientID?: ModelIDInput | null,
  recipientEmail?: ModelStringInput | null,
  subject?: ModelStringInput | null,
  body?: ModelStringInput | null,
  htmlBody?: ModelStringInput | null,
  status?: ModelEmailDeliveryStatusInput | null,
  sentAt?: ModelStringInput | null,
  failureReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEmailDeliveryConditionInput | null > | null,
  or?: Array< ModelEmailDeliveryConditionInput | null > | null,
  not?: ModelEmailDeliveryConditionInput | null,
};

export type ModelEmailDeliveryStatusInput = {
  eq?: EmailDeliveryStatus | null,
  ne?: EmailDeliveryStatus | null,
};

export type EmailDelivery = {
  __typename: "EmailDelivery",
  id: string,
  emailType: string,
  recipientID: string,
  recipientEmail: string,
  subject: string,
  body: string,
  htmlBody?: string | null,
  status: EmailDeliveryStatus,
  sentAt?: string | null,
  failureReason?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateEmailDeliveryInput = {
  id: string,
  emailType?: string | null,
  recipientID?: string | null,
  recipientEmail?: string | null,
  subject?: string | null,
  body?: string | null,
  htmlBody?: string | null,
  status?: EmailDeliveryStatus | null,
  sentAt?: string | null,
  failureReason?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteEmailDeliveryInput = {
  id: string,
};

export type CreateChatbotMessageInput = {
  userId: string,
  conversationIdTimestamp: string,
  messageId: string,
  conversationId: string,
  role: ChatbotMessageRole,
  content: string,
  suggestedUserPrompt?: string | null,
  createdAt?: string | null,
  llmInput?: string | null,
  inputTokens?: number | null,
  outputTokens?: number | null,
  reasoningTokens?: number | null,
  cachedTokens?: number | null,
  totalTokens?: number | null,
  toolsCalled?: Array< string | null > | null,
  toolsSucceeded?: Array< string | null > | null,
  toolsFailed?: Array< string | null > | null,
  ttftMs?: number | null,
  total_latency_ms?: number | null,
  userPaused?: boolean | null,
  agentTurns?: number | null,
  attachments?: Array< ChatbotAttachmentInput | null > | null,
  dataBlocks?: string | null,
};

export enum ChatbotMessageRole {
  user = "user",
  assistant = "assistant",
}


export type ChatbotAttachmentInput = {
  filename: string,
  contentType: string,
  sizeBytes: number,
  s3Bucket?: string | null,
  s3Key?: string | null,
  slackUrl?: string | null,
  source?: string | null,
};

export type ModelChatbotMessageConditionInput = {
  messageId?: ModelStringInput | null,
  conversationId?: ModelStringInput | null,
  role?: ModelChatbotMessageRoleInput | null,
  content?: ModelStringInput | null,
  suggestedUserPrompt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  llmInput?: ModelStringInput | null,
  inputTokens?: ModelIntInput | null,
  outputTokens?: ModelIntInput | null,
  reasoningTokens?: ModelIntInput | null,
  cachedTokens?: ModelIntInput | null,
  totalTokens?: ModelIntInput | null,
  toolsCalled?: ModelStringInput | null,
  toolsSucceeded?: ModelStringInput | null,
  toolsFailed?: ModelStringInput | null,
  ttftMs?: ModelFloatInput | null,
  total_latency_ms?: ModelFloatInput | null,
  userPaused?: ModelBooleanInput | null,
  agentTurns?: ModelIntInput | null,
  dataBlocks?: ModelStringInput | null,
  and?: Array< ModelChatbotMessageConditionInput | null > | null,
  or?: Array< ModelChatbotMessageConditionInput | null > | null,
  not?: ModelChatbotMessageConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelChatbotMessageRoleInput = {
  eq?: ChatbotMessageRole | null,
  ne?: ChatbotMessageRole | null,
};

export type ChatbotMessage = {
  __typename: "ChatbotMessage",
  userId: string,
  conversationIdTimestamp: string,
  messageId: string,
  conversationId: string,
  role: ChatbotMessageRole,
  content: string,
  suggestedUserPrompt?: string | null,
  createdAt: string,
  llmInput?: string | null,
  inputTokens?: number | null,
  outputTokens?: number | null,
  reasoningTokens?: number | null,
  cachedTokens?: number | null,
  totalTokens?: number | null,
  toolsCalled?: Array< string | null > | null,
  toolsSucceeded?: Array< string | null > | null,
  toolsFailed?: Array< string | null > | null,
  ttftMs?: number | null,
  total_latency_ms?: number | null,
  userPaused?: boolean | null,
  agentTurns?: number | null,
  attachments?:  Array<ChatbotAttachment | null > | null,
  dataBlocks?: string | null,
  updatedAt: string,
};

export type ChatbotAttachment = {
  __typename: "ChatbotAttachment",
  filename: string,
  contentType: string,
  sizeBytes: number,
  s3Bucket?: string | null,
  s3Key?: string | null,
  slackUrl?: string | null,
  source?: string | null,
};

export type UpdateChatbotMessageInput = {
  userId: string,
  conversationIdTimestamp: string,
  messageId?: string | null,
  conversationId?: string | null,
  role?: ChatbotMessageRole | null,
  content?: string | null,
  suggestedUserPrompt?: string | null,
  createdAt?: string | null,
  llmInput?: string | null,
  inputTokens?: number | null,
  outputTokens?: number | null,
  reasoningTokens?: number | null,
  cachedTokens?: number | null,
  totalTokens?: number | null,
  toolsCalled?: Array< string | null > | null,
  toolsSucceeded?: Array< string | null > | null,
  toolsFailed?: Array< string | null > | null,
  ttftMs?: number | null,
  total_latency_ms?: number | null,
  userPaused?: boolean | null,
  agentTurns?: number | null,
  attachments?: Array< ChatbotAttachmentInput | null > | null,
  dataBlocks?: string | null,
};

export type DeleteChatbotMessageInput = {
  userId: string,
  conversationIdTimestamp: string,
};

export type CreateChatbotConversationInput = {
  userId: string,
  conversationId: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  name?: string | null,
  archived?: boolean | null,
  pausedStreaming?: boolean | null,
  modelConversationId?: string | null,
  claudeSessionId?: string | null,
  routineId?: string | null,
  routineRunId?: string | null,
};

export type ModelChatbotConversationConditionInput = {
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  name?: ModelStringInput | null,
  archived?: ModelBooleanInput | null,
  pausedStreaming?: ModelBooleanInput | null,
  modelConversationId?: ModelStringInput | null,
  claudeSessionId?: ModelStringInput | null,
  routineId?: ModelStringInput | null,
  routineRunId?: ModelStringInput | null,
  and?: Array< ModelChatbotConversationConditionInput | null > | null,
  or?: Array< ModelChatbotConversationConditionInput | null > | null,
  not?: ModelChatbotConversationConditionInput | null,
};

export type ChatbotConversation = {
  __typename: "ChatbotConversation",
  userId: string,
  conversationId: string,
  createdAt: string,
  updatedAt: string,
  name?: string | null,
  archived?: boolean | null,
  pausedStreaming?: boolean | null,
  modelConversationId?: string | null,
  claudeSessionId?: string | null,
  routineId?: string | null,
  routineRunId?: string | null,
};

export type UpdateChatbotConversationInput = {
  userId: string,
  conversationId: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  name?: string | null,
  archived?: boolean | null,
  pausedStreaming?: boolean | null,
  modelConversationId?: string | null,
  claudeSessionId?: string | null,
  routineId?: string | null,
  routineRunId?: string | null,
};

export type DeleteChatbotConversationInput = {
  userId: string,
  conversationId: string,
};

export type CreateChatbotMonitoringInput = {
  userId: string,
  totalTokens: number,
  lastWeekTokens: number,
  totalConversations?: number | null,
  totalToolsCalled?: number | null,
};

export type ModelChatbotMonitoringConditionInput = {
  totalTokens?: ModelIntInput | null,
  lastWeekTokens?: ModelIntInput | null,
  totalConversations?: ModelIntInput | null,
  totalToolsCalled?: ModelIntInput | null,
  and?: Array< ModelChatbotMonitoringConditionInput | null > | null,
  or?: Array< ModelChatbotMonitoringConditionInput | null > | null,
  not?: ModelChatbotMonitoringConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ChatbotMonitoring = {
  __typename: "ChatbotMonitoring",
  userId: string,
  totalTokens: number,
  lastWeekTokens: number,
  totalConversations?: number | null,
  totalToolsCalled?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateChatbotMonitoringInput = {
  userId: string,
  totalTokens?: number | null,
  lastWeekTokens?: number | null,
  totalConversations?: number | null,
  totalToolsCalled?: number | null,
};

export type DeleteChatbotMonitoringInput = {
  userId: string,
};

export type CreatePromptExecutionInput = {
  id?: string | null,
  promptId: string,
  attachments?: Array< PromptExecutionAttachmentInput | null > | null,
  input: S3BlobInput,
  output: S3BlobInput,
  toolCalls?: S3BlobInput | null,
  reasoningSummary?: string | null,
  executedAt: string,
  appointmentID?: string | null,
  entityType?: string | null,
  entityId?: string | null,
  promptHash: string,
  apiHash?: string | null,
  modelName: string,
  modelConfig?: string | null,
  correlationID?: string | null,
};

export type PromptExecutionAttachmentInput = {
  blob: S3BlobInput,
  caption?: string | null,
};

export type ModelPromptExecutionConditionInput = {
  promptId?: ModelStringInput | null,
  reasoningSummary?: ModelStringInput | null,
  executedAt?: ModelStringInput | null,
  appointmentID?: ModelIDInput | null,
  entityType?: ModelStringInput | null,
  entityId?: ModelStringInput | null,
  promptHash?: ModelStringInput | null,
  apiHash?: ModelStringInput | null,
  modelName?: ModelStringInput | null,
  modelConfig?: ModelStringInput | null,
  correlationID?: ModelStringInput | null,
  and?: Array< ModelPromptExecutionConditionInput | null > | null,
  or?: Array< ModelPromptExecutionConditionInput | null > | null,
  not?: ModelPromptExecutionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PromptExecution = {
  __typename: "PromptExecution",
  id: string,
  promptId: string,
  attachments?:  Array<PromptExecutionAttachment | null > | null,
  input: S3Blob,
  output: S3Blob,
  toolCalls?: S3Blob | null,
  reasoningSummary?: string | null,
  executedAt: string,
  appointmentID?: string | null,
  entityType?: string | null,
  entityId?: string | null,
  promptHash: string,
  apiHash?: string | null,
  modelName: string,
  modelConfig?: string | null,
  correlationID?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type PromptExecutionAttachment = {
  __typename: "PromptExecutionAttachment",
  blob: S3Blob,
  caption?: string | null,
};

export type UpdatePromptExecutionInput = {
  id: string,
  promptId?: string | null,
  attachments?: Array< PromptExecutionAttachmentInput | null > | null,
  input?: S3BlobInput | null,
  output?: S3BlobInput | null,
  toolCalls?: S3BlobInput | null,
  reasoningSummary?: string | null,
  executedAt?: string | null,
  appointmentID?: string | null,
  entityType?: string | null,
  entityId?: string | null,
  promptHash?: string | null,
  apiHash?: string | null,
  modelName?: string | null,
  modelConfig?: string | null,
  correlationID?: string | null,
};

export type DeletePromptExecutionInput = {
  id: string,
};

export type CreateAppointmentEntityCorrelationInput = {
  id?: string | null,
  appointmentID: string,
  entityType?: string | null,
  entityID?: string | null,
  properties?: string | null,
  correlationID: string,
};

export type ModelAppointmentEntityCorrelationConditionInput = {
  appointmentID?: ModelIDInput | null,
  entityType?: ModelStringInput | null,
  entityID?: ModelIDInput | null,
  properties?: ModelStringInput | null,
  correlationID?: ModelStringInput | null,
  and?: Array< ModelAppointmentEntityCorrelationConditionInput | null > | null,
  or?: Array< ModelAppointmentEntityCorrelationConditionInput | null > | null,
  not?: ModelAppointmentEntityCorrelationConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type AppointmentEntityCorrelation = {
  __typename: "AppointmentEntityCorrelation",
  id: string,
  appointmentID: string,
  entityType?: string | null,
  entityID?: string | null,
  properties?: string | null,
  correlationID: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateAppointmentEntityCorrelationInput = {
  id: string,
  appointmentID?: string | null,
  entityType?: string | null,
  entityID?: string | null,
  properties?: string | null,
  correlationID?: string | null,
};

export type DeleteAppointmentEntityCorrelationInput = {
  id: string,
};

export type CreatePromptFeedbackInput = {
  id?: string | null,
  promptId: string,
  promptExecutionId?: string | null,
  feedback: string,
  feedbackSource: PromptFeedbackSource,
  actorType?: UserGroup | null,
  actorID?: string | null,
  status?: FeedbackStatus | null,
};

export enum PromptFeedbackSource {
  USER = "USER",
  SYSTEM = "SYSTEM",
}


export enum FeedbackStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
}


export type ModelPromptFeedbackConditionInput = {
  promptId?: ModelStringInput | null,
  promptExecutionId?: ModelIDInput | null,
  feedback?: ModelStringInput | null,
  feedbackSource?: ModelPromptFeedbackSourceInput | null,
  actorType?: ModelUserGroupInput | null,
  actorID?: ModelIDInput | null,
  status?: ModelFeedbackStatusInput | null,
  and?: Array< ModelPromptFeedbackConditionInput | null > | null,
  or?: Array< ModelPromptFeedbackConditionInput | null > | null,
  not?: ModelPromptFeedbackConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelPromptFeedbackSourceInput = {
  eq?: PromptFeedbackSource | null,
  ne?: PromptFeedbackSource | null,
};

export type ModelFeedbackStatusInput = {
  eq?: FeedbackStatus | null,
  ne?: FeedbackStatus | null,
};

export type PromptFeedback = {
  __typename: "PromptFeedback",
  id: string,
  promptId: string,
  promptExecutionId?: string | null,
  feedback: string,
  feedbackSource: PromptFeedbackSource,
  actorType?: UserGroup | null,
  actorID?: string | null,
  status?: FeedbackStatus | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePromptFeedbackInput = {
  id: string,
  promptId?: string | null,
  promptExecutionId?: string | null,
  feedback?: string | null,
  feedbackSource?: PromptFeedbackSource | null,
  actorType?: UserGroup | null,
  actorID?: string | null,
  status?: FeedbackStatus | null,
};

export type DeletePromptFeedbackInput = {
  id: string,
};

export type CreatePromptOfflineEvalCaseInput = {
  id?: string | null,
  promptId: string,
  sourcePromptExecutionId?: string | null,
  apiHash: string,
  attachments?: Array< PromptExecutionAttachmentInput | null > | null,
  input: S3BlobInput,
  output: S3BlobInput,
  toolCalls?: S3BlobInput | null,
  description?: string | null,
  verified?: boolean | null,
  tags?: Array< string | null > | null,
};

export type ModelPromptOfflineEvalCaseConditionInput = {
  promptId?: ModelStringInput | null,
  sourcePromptExecutionId?: ModelIDInput | null,
  apiHash?: ModelStringInput | null,
  description?: ModelStringInput | null,
  verified?: ModelBooleanInput | null,
  tags?: ModelStringInput | null,
  and?: Array< ModelPromptOfflineEvalCaseConditionInput | null > | null,
  or?: Array< ModelPromptOfflineEvalCaseConditionInput | null > | null,
  not?: ModelPromptOfflineEvalCaseConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PromptOfflineEvalCase = {
  __typename: "PromptOfflineEvalCase",
  id: string,
  promptId: string,
  sourcePromptExecutionId?: string | null,
  apiHash: string,
  attachments?:  Array<PromptExecutionAttachment | null > | null,
  input: S3Blob,
  output: S3Blob,
  toolCalls?: S3Blob | null,
  description?: string | null,
  verified?: boolean | null,
  tags?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePromptOfflineEvalCaseInput = {
  id: string,
  promptId?: string | null,
  sourcePromptExecutionId?: string | null,
  apiHash?: string | null,
  attachments?: Array< PromptExecutionAttachmentInput | null > | null,
  input?: S3BlobInput | null,
  output?: S3BlobInput | null,
  toolCalls?: S3BlobInput | null,
  description?: string | null,
  verified?: boolean | null,
  tags?: Array< string | null > | null,
};

export type DeletePromptOfflineEvalCaseInput = {
  id: string,
};

export type CreateSkillInput = {
  id?: string | null,
  name: string,
  description: string,
  body: string,
  scope: SkillScope,
  ownerUserId: string,
  roles?: Array< UserGroup > | null,
  inputs?: Array< SkillInputInput > | null,
  visibility: SkillVisibility,
  version: number,
  archivedAt?: string | null,
};

export enum SkillScope {
  ORG = "ORG",
  PERSONAL = "PERSONAL",
}


export type SkillInputInput = {
  name: string,
  description?: string | null,
  required: boolean,
};

export enum SkillVisibility {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}


export type ModelSkillConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  body?: ModelStringInput | null,
  scope?: ModelSkillScopeInput | null,
  ownerUserId?: ModelStringInput | null,
  roles?: ModelUserGroupListInput | null,
  visibility?: ModelSkillVisibilityInput | null,
  version?: ModelIntInput | null,
  archivedAt?: ModelStringInput | null,
  and?: Array< ModelSkillConditionInput | null > | null,
  or?: Array< ModelSkillConditionInput | null > | null,
  not?: ModelSkillConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelSkillScopeInput = {
  eq?: SkillScope | null,
  ne?: SkillScope | null,
};

export type ModelUserGroupListInput = {
  eq?: Array< UserGroup | null > | null,
  ne?: Array< UserGroup | null > | null,
  contains?: UserGroup | null,
  notContains?: UserGroup | null,
};

export type ModelSkillVisibilityInput = {
  eq?: SkillVisibility | null,
  ne?: SkillVisibility | null,
};

export type Skill = {
  __typename: "Skill",
  id: string,
  name: string,
  description: string,
  body: string,
  scope: SkillScope,
  ownerUserId: string,
  roles?: Array< UserGroup > | null,
  inputs?:  Array<SkillInput > | null,
  visibility: SkillVisibility,
  version: number,
  archivedAt?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type SkillInput = {
  __typename: "SkillInput",
  name: string,
  description?: string | null,
  required: boolean,
};

export type UpdateSkillInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  body?: string | null,
  scope?: SkillScope | null,
  ownerUserId?: string | null,
  roles?: Array< UserGroup > | null,
  inputs?: Array< SkillInputInput > | null,
  visibility?: SkillVisibility | null,
  version?: number | null,
  archivedAt?: string | null,
};

export type DeleteSkillInput = {
  id: string,
};

export type UpdateRoutineInput = {
  id: string,
  scope?: RoutineScope | null,
  name?: string | null,
  description?: string | null,
  promptBody?: string | null,
  model?: string | null,
  reasoningEffort?: string | null,
  enableWebSearch?: boolean | null,
  maxAgentTurns?: number | null,
  conversationMode?: RoutineConversationMode | null,
  schedule?: RoutineScheduleInput | null,
  timezone?: string | null,
  enabled?: boolean | null,
  notifyOwner?: RoutineNotify | null,
  slackChannel?: string | null,
  ownerUserId?: string | null,
  createdAt?: string | null,
  createdVia?: RoutineOrigin | null,
  version?: number | null,
  archivedAt?: string | null,
};

export enum RoutineScope {
  ORG = "ORG",
  PERSONAL = "PERSONAL",
}


export enum RoutineConversationMode {
  NEW_PER_RUN = "NEW_PER_RUN",
  CONTINUE = "CONTINUE",
}


export type RoutineScheduleInput = {
  frequency: RoutineFrequency,
  intervalHours?: number | null,
  timeOfDay?: string | null,
  weekdays?: Array< number > | null,
  runAt?: string | null,
};

export enum RoutineFrequency {
  HOURLY = "HOURLY",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  ONCE = "ONCE",
  MANUAL = "MANUAL",
}


export enum RoutineNotify {
  NEVER = "NEVER",
  WHEN_NOTEWORTHY = "WHEN_NOTEWORTHY",
  ALWAYS = "ALWAYS",
}


export enum RoutineOrigin {
  PORTAL = "PORTAL",
  INDY = "INDY",
}


export type ModelRoutineConditionInput = {
  scope?: ModelRoutineScopeInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  promptBody?: ModelStringInput | null,
  model?: ModelStringInput | null,
  reasoningEffort?: ModelStringInput | null,
  enableWebSearch?: ModelBooleanInput | null,
  maxAgentTurns?: ModelIntInput | null,
  conversationMode?: ModelRoutineConversationModeInput | null,
  timezone?: ModelStringInput | null,
  enabled?: ModelBooleanInput | null,
  notifyOwner?: ModelRoutineNotifyInput | null,
  slackChannel?: ModelStringInput | null,
  ownerUserId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdVia?: ModelRoutineOriginInput | null,
  version?: ModelIntInput | null,
  archivedAt?: ModelStringInput | null,
  and?: Array< ModelRoutineConditionInput | null > | null,
  or?: Array< ModelRoutineConditionInput | null > | null,
  not?: ModelRoutineConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelRoutineScopeInput = {
  eq?: RoutineScope | null,
  ne?: RoutineScope | null,
};

export type ModelRoutineConversationModeInput = {
  eq?: RoutineConversationMode | null,
  ne?: RoutineConversationMode | null,
};

export type ModelRoutineNotifyInput = {
  eq?: RoutineNotify | null,
  ne?: RoutineNotify | null,
};

export type ModelRoutineOriginInput = {
  eq?: RoutineOrigin | null,
  ne?: RoutineOrigin | null,
};

export type Routine = {
  __typename: "Routine",
  id: string,
  scope: RoutineScope,
  name: string,
  description?: string | null,
  promptBody: string,
  model: string,
  reasoningEffort: string,
  enableWebSearch: boolean,
  maxAgentTurns?: number | null,
  conversationMode: RoutineConversationMode,
  schedule: RoutineSchedule,
  timezone: string,
  enabled: boolean,
  notifyOwner: RoutineNotify,
  slackChannel?: string | null,
  ownerUserId: string,
  createdAt: string,
  createdVia: RoutineOrigin,
  version: number,
  archivedAt?: string | null,
  updatedAt: string,
};

export type RoutineSchedule = {
  __typename: "RoutineSchedule",
  frequency: RoutineFrequency,
  intervalHours?: number | null,
  timeOfDay?: string | null,
  weekdays?: Array< number > | null,
  runAt?: string | null,
};

export type UpdateRoutineStateInput = {
  id: string,
  scope?: RoutineScope | null,
  ownerUserId?: string | null,
  definitionVersion?: number | null,
  schedulePartition?: string | null,
  nextRunAt?: string | null,
  currentConversationId?: string | null,
  activeRunId?: string | null,
  lastRunId?: string | null,
  consecutiveFailures?: number | null,
  endedReason?: RoutineEndedReason | null,
};

export enum RoutineEndedReason {
  ONCE_FIRED = "ONCE_FIRED",
  FAILED_REPEATEDLY = "FAILED_REPEATEDLY",
  EXECUTION_UNKNOWN = "EXECUTION_UNKNOWN",
}


export type ModelRoutineStateConditionInput = {
  scope?: ModelRoutineScopeInput | null,
  ownerUserId?: ModelStringInput | null,
  definitionVersion?: ModelIntInput | null,
  schedulePartition?: ModelStringInput | null,
  nextRunAt?: ModelStringInput | null,
  currentConversationId?: ModelStringInput | null,
  activeRunId?: ModelStringInput | null,
  lastRunId?: ModelStringInput | null,
  consecutiveFailures?: ModelIntInput | null,
  endedReason?: ModelRoutineEndedReasonInput | null,
  and?: Array< ModelRoutineStateConditionInput | null > | null,
  or?: Array< ModelRoutineStateConditionInput | null > | null,
  not?: ModelRoutineStateConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelRoutineEndedReasonInput = {
  eq?: RoutineEndedReason | null,
  ne?: RoutineEndedReason | null,
};

export type RoutineState = {
  __typename: "RoutineState",
  id: string,
  scope: RoutineScope,
  ownerUserId: string,
  definitionVersion: number,
  schedulePartition?: string | null,
  nextRunAt?: string | null,
  currentConversationId?: string | null,
  activeRunId?: string | null,
  lastRunId?: string | null,
  consecutiveFailures: number,
  endedReason?: RoutineEndedReason | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateRoutineRunInput = {
  id: string,
  scope?: RoutineScope | null,
  routineId?: string | null,
  routineVersion?: number | null,
  createdAt?: string | null,
  definitionSnapshot?: string | null,
  status?: RoutineRunStatus | null,
  trigger?: RoutineTrigger | null,
  triggeredByUserId?: string | null,
  extraContext?: string | null,
  scheduledFor?: string | null,
  startedAt?: string | null,
  finishedAt?: string | null,
  durationMs?: number | null,
  processingStage?: string | null,
  nextProcessingAt?: string | null,
  dispatchAttempts?: number | null,
  lastDispatchedAt?: string | null,
  executionToken?: string | null,
  executionDeadlineAt?: string | null,
  conversationOwnerUserId?: string | null,
  conversationId?: string | null,
  previousConversationId?: string | null,
  userMessageId?: string | null,
  assistantMessageId?: string | null,
  outcome?: RoutineOutcome | null,
  headline?: string | null,
  summary?: string | null,
  totalTokens?: number | null,
  agentTurns?: number | null,
  toolsCalled?: Array< string | null > | null,
  toolsFailed?: Array< string | null > | null,
  correlationId?: string | null,
  errorMessage?: string | null,
  ownerDelivery?: RoutineDeliveryInput | null,
  channelDelivery?: RoutineDeliveryInput | null,
};

export enum RoutineRunStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  TIMEOUT = "TIMEOUT",
  SKIPPED = "SKIPPED",
  UNKNOWN = "UNKNOWN",
}


export enum RoutineTrigger {
  SCHEDULED = "SCHEDULED",
  MANUAL = "MANUAL",
}


export enum RoutineOutcome {
  DONE = "DONE",
  NOTHING_TO_REPORT = "NOTHING_TO_REPORT",
  NEEDS_INPUT = "NEEDS_INPUT",
}


export type RoutineDeliveryInput = {
  status: RoutineDeliveryStatus,
  target?: string | null,
  claimToken?: string | null,
  claimExpiresAt?: string | null,
  attemptedAt?: string | null,
  finishedAt?: string | null,
  messageId?: string | null,
  errorMessage?: string | null,
};

export enum RoutineDeliveryStatus {
  NOT_REQUIRED = "NOT_REQUIRED",
  PENDING = "PENDING",
  SENDING = "SENDING",
  SENT = "SENT",
  FAILED = "FAILED",
  UNKNOWN = "UNKNOWN",
}


export type ModelRoutineRunConditionInput = {
  scope?: ModelRoutineScopeInput | null,
  routineId?: ModelIDInput | null,
  routineVersion?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  definitionSnapshot?: ModelStringInput | null,
  status?: ModelRoutineRunStatusInput | null,
  trigger?: ModelRoutineTriggerInput | null,
  triggeredByUserId?: ModelStringInput | null,
  extraContext?: ModelStringInput | null,
  scheduledFor?: ModelStringInput | null,
  startedAt?: ModelStringInput | null,
  finishedAt?: ModelStringInput | null,
  durationMs?: ModelIntInput | null,
  processingStage?: ModelStringInput | null,
  nextProcessingAt?: ModelStringInput | null,
  dispatchAttempts?: ModelIntInput | null,
  lastDispatchedAt?: ModelStringInput | null,
  executionToken?: ModelStringInput | null,
  executionDeadlineAt?: ModelStringInput | null,
  conversationOwnerUserId?: ModelStringInput | null,
  conversationId?: ModelStringInput | null,
  previousConversationId?: ModelStringInput | null,
  userMessageId?: ModelStringInput | null,
  assistantMessageId?: ModelStringInput | null,
  outcome?: ModelRoutineOutcomeInput | null,
  headline?: ModelStringInput | null,
  summary?: ModelStringInput | null,
  totalTokens?: ModelIntInput | null,
  agentTurns?: ModelIntInput | null,
  toolsCalled?: ModelStringInput | null,
  toolsFailed?: ModelStringInput | null,
  correlationId?: ModelStringInput | null,
  errorMessage?: ModelStringInput | null,
  and?: Array< ModelRoutineRunConditionInput | null > | null,
  or?: Array< ModelRoutineRunConditionInput | null > | null,
  not?: ModelRoutineRunConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelRoutineRunStatusInput = {
  eq?: RoutineRunStatus | null,
  ne?: RoutineRunStatus | null,
};

export type ModelRoutineTriggerInput = {
  eq?: RoutineTrigger | null,
  ne?: RoutineTrigger | null,
};

export type ModelRoutineOutcomeInput = {
  eq?: RoutineOutcome | null,
  ne?: RoutineOutcome | null,
};

export type RoutineRun = {
  __typename: "RoutineRun",
  id: string,
  scope: RoutineScope,
  routineId: string,
  routineVersion: number,
  createdAt: string,
  definitionSnapshot: string,
  status: RoutineRunStatus,
  trigger: RoutineTrigger,
  triggeredByUserId?: string | null,
  extraContext?: string | null,
  scheduledFor?: string | null,
  startedAt?: string | null,
  finishedAt?: string | null,
  durationMs?: number | null,
  processingStage?: string | null,
  nextProcessingAt?: string | null,
  dispatchAttempts: number,
  lastDispatchedAt?: string | null,
  executionToken?: string | null,
  executionDeadlineAt?: string | null,
  conversationOwnerUserId: string,
  conversationId?: string | null,
  previousConversationId?: string | null,
  userMessageId?: string | null,
  assistantMessageId?: string | null,
  outcome?: RoutineOutcome | null,
  headline?: string | null,
  summary?: string | null,
  totalTokens?: number | null,
  agentTurns?: number | null,
  toolsCalled?: Array< string | null > | null,
  toolsFailed?: Array< string | null > | null,
  correlationId?: string | null,
  errorMessage?: string | null,
  ownerDelivery?: RoutineDelivery | null,
  channelDelivery?: RoutineDelivery | null,
  updatedAt: string,
};

export type RoutineDelivery = {
  __typename: "RoutineDelivery",
  status: RoutineDeliveryStatus,
  target?: string | null,
  claimToken?: string | null,
  claimExpiresAt?: string | null,
  attemptedAt?: string | null,
  finishedAt?: string | null,
  messageId?: string | null,
  errorMessage?: string | null,
};

export type CreateDoctorSupportingMAInput = {
  id?: string | null,
  medicalAssistantId: string,
  doctorId: string,
};

export type ModelDoctorSupportingMAConditionInput = {
  medicalAssistantId?: ModelIDInput | null,
  doctorId?: ModelIDInput | null,
  and?: Array< ModelDoctorSupportingMAConditionInput | null > | null,
  or?: Array< ModelDoctorSupportingMAConditionInput | null > | null,
  not?: ModelDoctorSupportingMAConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  ownerCognitoId?: ModelStringInput | null,
};

export type UpdateDoctorSupportingMAInput = {
  id: string,
  medicalAssistantId?: string | null,
  doctorId?: string | null,
};

export type DeleteDoctorSupportingMAInput = {
  id: string,
};

export type CreateMedicalAssistantSpecialtyCategoryInput = {
  id?: string | null,
  medicalAssistantId: string,
  specialtyCategoryId: string,
};

export type ModelMedicalAssistantSpecialtyCategoryConditionInput = {
  medicalAssistantId?: ModelIDInput | null,
  specialtyCategoryId?: ModelIDInput | null,
  and?: Array< ModelMedicalAssistantSpecialtyCategoryConditionInput | null > | null,
  or?: Array< ModelMedicalAssistantSpecialtyCategoryConditionInput | null > | null,
  not?: ModelMedicalAssistantSpecialtyCategoryConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateMedicalAssistantSpecialtyCategoryInput = {
  id: string,
  medicalAssistantId?: string | null,
  specialtyCategoryId?: string | null,
};

export type DeleteMedicalAssistantSpecialtyCategoryInput = {
  id: string,
};

export type CreateUserAppointmentFilterPresetInput = {
  id?: string | null,
  userId: string,
  appointmentFilterPresetId: string,
};

export type ModelUserAppointmentFilterPresetConditionInput = {
  userId?: ModelIDInput | null,
  appointmentFilterPresetId?: ModelIDInput | null,
  and?: Array< ModelUserAppointmentFilterPresetConditionInput | null > | null,
  or?: Array< ModelUserAppointmentFilterPresetConditionInput | null > | null,
  not?: ModelUserAppointmentFilterPresetConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateUserAppointmentFilterPresetInput = {
  id: string,
  userId?: string | null,
  appointmentFilterPresetId?: string | null,
};

export type DeleteUserAppointmentFilterPresetInput = {
  id: string,
};

export type CreateAppointmentRecordPatientCaseInput = {
  id?: string | null,
  appointmentRecordId: string,
  patientCaseId: string,
};

export type ModelAppointmentRecordPatientCaseConditionInput = {
  appointmentRecordId?: ModelIDInput | null,
  patientCaseId?: ModelIDInput | null,
  and?: Array< ModelAppointmentRecordPatientCaseConditionInput | null > | null,
  or?: Array< ModelAppointmentRecordPatientCaseConditionInput | null > | null,
  not?: ModelAppointmentRecordPatientCaseConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  doctorOwnerCognitoId?: ModelStringInput | null,
  assistantCognitoIds?: ModelStringInput | null,
};

export type UpdateAppointmentRecordPatientCaseInput = {
  id: string,
  appointmentRecordId?: string | null,
  patientCaseId?: string | null,
};

export type DeleteAppointmentRecordPatientCaseInput = {
  id: string,
};

export type CreateDoctorLocationInput = {
  id?: string | null,
  doctorId: string,
  locationId: string,
};

export type ModelDoctorLocationConditionInput = {
  doctorId?: ModelIDInput | null,
  locationId?: ModelIDInput | null,
  and?: Array< ModelDoctorLocationConditionInput | null > | null,
  or?: Array< ModelDoctorLocationConditionInput | null > | null,
  not?: ModelDoctorLocationConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  ownerCognitoId?: ModelStringInput | null,
};

export type UpdateDoctorLocationInput = {
  id: string,
  doctorId?: string | null,
  locationId?: string | null,
};

export type DeleteDoctorLocationInput = {
  id: string,
};

export type CreateDoctorCaseSummaryFieldInput = {
  id?: string | null,
  doctorId: string,
  caseSummaryFieldId: string,
};

export type ModelDoctorCaseSummaryFieldConditionInput = {
  doctorId?: ModelIDInput | null,
  caseSummaryFieldId?: ModelIDInput | null,
  and?: Array< ModelDoctorCaseSummaryFieldConditionInput | null > | null,
  or?: Array< ModelDoctorCaseSummaryFieldConditionInput | null > | null,
  not?: ModelDoctorCaseSummaryFieldConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  ownerCognitoId?: ModelStringInput | null,
};

export type UpdateDoctorCaseSummaryFieldInput = {
  id: string,
  doctorId?: string | null,
  caseSummaryFieldId?: string | null,
};

export type DeleteDoctorCaseSummaryFieldInput = {
  id: string,
};

export type CreateDoctorBriefingFieldInput = {
  id?: string | null,
  doctorId: string,
  briefingFieldId: string,
};

export type ModelDoctorBriefingFieldConditionInput = {
  doctorId?: ModelIDInput | null,
  briefingFieldId?: ModelIDInput | null,
  and?: Array< ModelDoctorBriefingFieldConditionInput | null > | null,
  or?: Array< ModelDoctorBriefingFieldConditionInput | null > | null,
  not?: ModelDoctorBriefingFieldConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  ownerCognitoId?: ModelStringInput | null,
};

export type UpdateDoctorBriefingFieldInput = {
  id: string,
  doctorId?: string | null,
  briefingFieldId?: string | null,
};

export type DeleteDoctorBriefingFieldInput = {
  id: string,
};

export type GlobalBillingCounter = {
  __typename: "GlobalBillingCounter",
  id: string,
  count?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type AppointmentSearchInput = {
  query?: string | null,
  from?: number | null,
  size?: number | null,
  filters?: AppointmentSearchFilters | null,
};

export type AppointmentSearchFilters = {
  doctor_id?: string | null,
  is_prod?: boolean | null,
  is_demo?: boolean | null,
  language?: string | null,
  appt_type?: string | null,
};

export type AppointmentSearchConnection = {
  __typename: "AppointmentSearchConnection",
  items:  Array<AppointmentSearchResult | null >,
  total?: number | null,
  nextToken?: string | null,
};

export type AppointmentSearchResult = {
  __typename: "AppointmentSearchResult",
  id: string,
  patient_name?: string | null,
  primary_claim_number?: string | null,
  other_claim_numbers?: Array< string | null > | null,
  doctor_name?: string | null,
  location?: string | null,
  doctor_id?: string | null,
  date?: string | null,
  time?: string | null,
  language?: string | null,
  appt_type?: string | null,
  is_prod?: boolean | null,
};

export type AppointmentDocSearchInput = {
  appointment_id: string,
  query: string,
  size?: number | null,
  filters?: AppointmentDocSearchFilters | null,
};

export type AppointmentDocSearchFilters = {
  uploaded_file_id?: string | null,
  start_page?: number | null,
  end_page?: number | null,
};

export type AppointmentDocSearchConnection = {
  __typename: "AppointmentDocSearchConnection",
  items:  Array<AppointmentDocSearchResult | null >,
  total?: number | null,
};

export type AppointmentDocSearchResult = {
  __typename: "AppointmentDocSearchResult",
  chunk_id: string,
  uploaded_file_id: string,
  filename?: string | null,
  content: string,
  start_page_number: number,
  end_page_number: number,
  chunk_index: number,
  token_count?: number | null,
  score: number,
  highlights?: Array< string > | null,
};

export type GeneralDocSearchInput = {
  query: string,
  size?: number | null,
  filters?: GeneralDocSearchFilters | null,
};

export type GeneralDocSearchFilters = {
  filename?: string | null,
  start_page?: number | null,
  end_page?: number | null,
};

export type GeneralDocSearchConnection = {
  __typename: "GeneralDocSearchConnection",
  items:  Array<GeneralDocSearchResult | null >,
  total?: number | null,
};

export type GeneralDocSearchResult = {
  __typename: "GeneralDocSearchResult",
  chunk_id: string,
  filename?: string | null,
  content: string,
  start_page_number: number,
  end_page_number: number,
  chunk_index: number,
  token_count?: number | null,
  score: number,
  highlights?: Array< string > | null,
};

export type DoctorSearchInput = {
  query?: string | null,
  from?: number | null,
  size?: number | null,
  filters?: DoctorSearchFilters | null,
};

export type DoctorSearchFilters = {
  work_state?: string | null,
  home_state?: string | null,
  specialties?: Array< string | null > | null,
  is_demo?: boolean | null,
};

export type DoctorSearchConnection = {
  __typename: "DoctorSearchConnection",
  items:  Array<DoctorSearchResult | null >,
  total?: number | null,
  nextToken?: string | null,
};

export type DoctorSearchResult = {
  __typename: "DoctorSearchResult",
  id: string,
  first_name?: string | null,
  middle_name?: string | null,
  last_name?: string | null,
  npi?: string | null,
  office_phone?: string | null,
  email?: string | null,
  title?: string | null,
  specialties?: Array< string | null > | null,
  work_city?: string | null,
  work_state?: string | null,
  home_state?: string | null,
  physician_partner_id?: string | null,
  doctor_user_id?: string | null,
  license_number?: string | null,
};

export type LocationSearchInput = {
  query?: string | null,
  from?: number | null,
  size?: number | null,
  filters?: LocationSearchFilters | null,
};

export type LocationSearchFilters = {
  state?: string | null,
  region?: string | null,
  status?: string | null,
};

export type LocationSearchConnection = {
  __typename: "LocationSearchConnection",
  items:  Array<LocationSearchResult | null >,
  total?: number | null,
  nextToken?: string | null,
};

export type LocationSearchResult = {
  __typename: "LocationSearchResult",
  id: string,
  location_name?: string | null,
  abbreviation?: string | null,
  city?: string | null,
  street?: string | null,
  zip?: string | null,
  state?: string | null,
  region?: string | null,
  status?: string | null,
};

export type InsuranceCarrierSearchInput = {
  query?: string | null,
  from?: number | null,
  size?: number | null,
  filters?: InsuranceCarrierSearchFilters | null,
};

export type InsuranceCarrierSearchFilters = {
  state?: string | null,
};

export type InsuranceCarrierSearchConnection = {
  __typename: "InsuranceCarrierSearchConnection",
  items:  Array<InsuranceCarrierSearchResult | null >,
  total?: number | null,
  nextToken?: string | null,
};

export type InsuranceCarrierSearchResult = {
  __typename: "InsuranceCarrierSearchResult",
  id: string,
  name?: string | null,
  cities?: Array< string | null > | null,
  states?: Array< string | null > | null,
  default_address_id?: string | null,
  default_fax_number_id?: string | null,
  default_phone_number_id?: string | null,
};

export type LawFirmSearchInput = {
  query?: string | null,
  from?: number | null,
  size?: number | null,
  filters?: LawFirmSearchFilters | null,
};

export type LawFirmSearchFilters = {
  law_firm_type?: string | null,
  state?: string | null,
};

export type LawFirmSearchConnection = {
  __typename: "LawFirmSearchConnection",
  items:  Array<LawFirmSearchResult | null >,
  total?: number | null,
  nextToken?: string | null,
};

export type LawFirmSearchResult = {
  __typename: "LawFirmSearchResult",
  id: string,
  name?: string | null,
  law_firm_type?: string | null,
  cities?: Array< string | null > | null,
  states?: Array< string | null > | null,
  default_address_id?: string | null,
  default_fax_number_id?: string | null,
  default_phone_number_id?: string | null,
};

export type ListAppointmentsOptimizedInput = {
  isProd: boolean,
  isDemo?: boolean | null,
  sortingField: SortingField,
  sortingDirection: SortingDirection,
  startDate?: string | null,
  endDate?: string | null,
  includeEmptyDates?: boolean | null,
  inquiryStartDate?: string | null,
  inquiryEndDate?: string | null,
  nextToken?: string | null,
  limit?: number | null,
  minResults?: number | null,
  filters?: AppointmentListFiltersInput | null,
};

export enum SortingField {
  APPOINTMENT_DATE = "APPOINTMENT_DATE",
  INQUIRY_DATE = "INQUIRY_DATE",
  REPORT_DUE = "REPORT_DUE",
  HISTORY_CALL_DATE = "HISTORY_CALL_DATE",
}


export enum SortingDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type AppointmentListFiltersInput = {
  appointmentType?: Array< AppointmentType | null > | null,
  locationID?: Array< string | null > | null,
  physicianID?: Array< string | null > | null,
  difficultyLevel?: Array< number | null > | null,
  billingStatus?: Array< BillingStatus | null > | null,
  reportStatus?: Array< ReportStatus | null > | null,
  status?: Array< AppointmentStatus | null > | null,
  noShowReason?: Array< NoShowReason | null > | null,
  reschedulingRequestedBy?: Array< ParticipantType | null > | null,
  requestingParty?: Array< ParticipantType | null > | null,
};

export type ListAppointmentsOptimizedResponse = {
  __typename: "ListAppointmentsOptimizedResponse",
  appointments:  Array<AppointmentRecord | null >,
  nextToken?: string | null,
};

export type ModelAppointmentFileReferenceFilterInput = {
  id?: ModelIDInput | null,
  appointmentID?: ModelIDInput | null,
  uploadedFileID?: ModelIDInput | null,
  status?: ModelAppointmentFileReferenceStatusInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAppointmentFileReferenceFilterInput | null > | null,
  or?: Array< ModelAppointmentFileReferenceFilterInput | null > | null,
  not?: ModelAppointmentFileReferenceFilterInput | null,
};

export type ModelAppointmentFileReferenceConnection = {
  __typename: "ModelAppointmentFileReferenceConnection",
  items:  Array<AppointmentFileReference | null >,
  nextToken?: string | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelUploadedFileFilterInput = {
  id?: ModelIDInput | null,
  key?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  type?: ModelFileTypeInput | null,
  provider?: ModelFileProviderInput | null,
  uploadedBy?: ModelStringInput | null,
  uploadedAt?: ModelStringInput | null,
  fileSizeBytes?: ModelFloatInput | null,
  fileSetID?: ModelIDInput | null,
  sourceAppointmentID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUploadedFileFilterInput | null > | null,
  or?: Array< ModelUploadedFileFilterInput | null > | null,
  not?: ModelUploadedFileFilterInput | null,
};

export type ModelUploadedFileSetFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUploadedFileSetFilterInput | null > | null,
  or?: Array< ModelUploadedFileSetFilterInput | null > | null,
  not?: ModelUploadedFileSetFilterInput | null,
};

export type ModelUploadedFileSetConnection = {
  __typename: "ModelUploadedFileSetConnection",
  items:  Array<UploadedFileSet | null >,
  nextToken?: string | null,
};

export type ModelDocumentFilterInput = {
  id?: ModelIDInput | null,
  uploadedFileID?: ModelIDInput | null,
  providerTag?: ModelStringInput | null,
  pageCount?: ModelIntInput | null,
  executionArn?: ModelStringInput | null,
  recordBriefingId?: ModelIDInput | null,
  segmentSplits?: ModelIntInput | null,
  hasUnresolvedSplits?: ModelBooleanInput | null,
  videoDurationSeconds?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDocumentFilterInput | null > | null,
  or?: Array< ModelDocumentFilterInput | null > | null,
  not?: ModelDocumentFilterInput | null,
  documentMrrValidationId?: ModelIDInput | null,
};

export type ModelDocumentConnection = {
  __typename: "ModelDocumentConnection",
  items:  Array<Document | null >,
  nextToken?: string | null,
};

export type ModelDocumentIngestionStepFilterInput = {
  id?: ModelIDInput | null,
  documentID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelIngestionStepStatusInput | null,
  startedAt?: ModelStringInput | null,
  endedAt?: ModelStringInput | null,
  errorMessage?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDocumentIngestionStepFilterInput | null > | null,
  or?: Array< ModelDocumentIngestionStepFilterInput | null > | null,
  not?: ModelDocumentIngestionStepFilterInput | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelOperationStatusFilterInput = {
  id?: ModelIDInput | null,
  scope?: ModelStringInput | null,
  operation?: ModelStringInput | null,
  name?: ModelStringInput | null,
  status?: ModelOperationStateInput | null,
  startedAt?: ModelStringInput | null,
  heartbeatAt?: ModelStringInput | null,
  endedAt?: ModelStringInput | null,
  attempt?: ModelIntInput | null,
  errorMessage?: ModelStringInput | null,
  correlationId?: ModelStringInput | null,
  metadata?: ModelStringInput | null,
  expiresAt?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOperationStatusFilterInput | null > | null,
  or?: Array< ModelOperationStatusFilterInput | null > | null,
  not?: ModelOperationStatusFilterInput | null,
};

export type ModelOperationStatusConnection = {
  __typename: "ModelOperationStatusConnection",
  items:  Array<OperationStatus | null >,
  nextToken?: string | null,
};

export type ModelDocumentPageFilterInput = {
  id?: ModelIDInput | null,
  documentID?: ModelIDInput | null,
  pageNumber?: ModelIntInput | null,
  imageS3Key?: ModelStringInput | null,
  text?: ModelStringInput | null,
  isBlank?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDocumentPageFilterInput | null > | null,
  or?: Array< ModelDocumentPageFilterInput | null > | null,
  not?: ModelDocumentPageFilterInput | null,
};

export type ModelIntKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelCitationFilterInput = {
  id?: ModelIDInput | null,
  documentPageID?: ModelIDInput | null,
  documentID?: ModelIDInput | null,
  pageNumber?: ModelIntInput | null,
  blockIndex?: ModelIntInput | null,
  text?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCitationFilterInput | null > | null,
  or?: Array< ModelCitationFilterInput | null > | null,
  not?: ModelCitationFilterInput | null,
};

export type ModelDocumentSegmentIntervalFilterInput = {
  id?: ModelIDInput | null,
  documentID?: ModelIDInput | null,
  startPageNumber?: ModelIntInput | null,
  endPageNumber?: ModelIntInput | null,
  startLineNumber?: ModelIntInput | null,
  endLineNumber?: ModelIntInput | null,
  confidence?: ModelFloatInput | null,
  confidenceReasoning?: ModelStringInput | null,
  edited?: ModelBooleanInput | null,
  needsReSummary?: ModelBooleanInput | null,
  archived?: ModelBooleanInput | null,
  parentIntervals?: ModelIDInput | null,
  lastEditAction?: ModelStringInput | null,
  lastEditedAt?: ModelStringInput | null,
  lastEditedBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDocumentSegmentIntervalFilterInput | null > | null,
  or?: Array< ModelDocumentSegmentIntervalFilterInput | null > | null,
  not?: ModelDocumentSegmentIntervalFilterInput | null,
};

export type ModelAudioFilterInput = {
  id?: ModelIDInput | null,
  uploadedFileID?: ModelIDInput | null,
  executionArn?: ModelStringInput | null,
  fileFormat?: ModelStringInput | null,
  durationSeconds?: ModelFloatInput | null,
  transcriptWordCount?: ModelIntInput | null,
  transcriptGrammarCorrectedWordCount?: ModelIntInput | null,
  detectedLanguages?: ModelLanguageListInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAudioFilterInput | null > | null,
  or?: Array< ModelAudioFilterInput | null > | null,
  not?: ModelAudioFilterInput | null,
};

export type ModelAudioConnection = {
  __typename: "ModelAudioConnection",
  items:  Array<Audio | null >,
  nextToken?: string | null,
};

export type ModelHistoryTranscriptFilterInput = {
  id?: ModelIDInput | null,
  uploadedFileID?: ModelIDInput | null,
  callId?: ModelStringInput | null,
  recordingId?: ModelStringInput | null,
  callStartTime?: ModelStringInput | null,
  callDurationSeconds?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelHistoryTranscriptFilterInput | null > | null,
  or?: Array< ModelHistoryTranscriptFilterInput | null > | null,
  not?: ModelHistoryTranscriptFilterInput | null,
};

export type ModelHistoryTranscriptConnection = {
  __typename: "ModelHistoryTranscriptConnection",
  items:  Array<HistoryTranscript | null >,
  nextToken?: string | null,
};

export type ModelPanelFileFilterInput = {
  id?: ModelIDInput | null,
  uploadedFileID?: ModelIDInput | null,
  sourceAppointmentID?: ModelIDInput | null,
  correlationId?: ModelStringInput | null,
  panelNumber?: ModelStringInput | null,
  panelIssueDate?: ModelStringInput | null,
  numberOfRequests?: ModelIntInput | null,
  requestingParty?: ModelParticipantTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPanelFileFilterInput | null > | null,
  or?: Array< ModelPanelFileFilterInput | null > | null,
  not?: ModelPanelFileFilterInput | null,
};

export type ModelPanelFileConnection = {
  __typename: "ModelPanelFileConnection",
  items:  Array<PanelFile | null >,
  nextToken?: string | null,
};

export type ModelNotesFilterInput = {
  id?: ModelIDInput | null,
  content?: ModelStringInput | null,
  type?: ModelNotesTypeInput | null,
  timeStamp?: ModelIntInput | null,
  appointmentrecordID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelNotesFilterInput | null > | null,
  or?: Array< ModelNotesFilterInput | null > | null,
  not?: ModelNotesFilterInput | null,
  notesAuthorId?: ModelIDInput | null,
};

export type ModelHuddleNoteFilterInput = {
  id?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  contentMarkdown?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelHuddleNoteFilterInput | null > | null,
  or?: Array< ModelHuddleNoteFilterInput | null > | null,
  not?: ModelHuddleNoteFilterInput | null,
};

export type ModelHuddleNoteConnection = {
  __typename: "ModelHuddleNoteConnection",
  items:  Array<HuddleNote | null >,
  nextToken?: string | null,
};

export type ModelMedicalAssistantFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  preVisitCallScheduleLink?: ModelStringInput | null,
  enableCalendarNotify?: ModelBooleanInput | null,
  inactive?: ModelBooleanInput | null,
  languages?: ModelLanguageListInput | null,
  isDemo?: ModelBooleanInput | null,
  dismissedProTips?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  joinedDate?: ModelStringInput | null,
  level?: ModelIntInput | null,
  capacityPercent?: ModelIntInput | null,
  roles?: ModelOpsRoleListInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMedicalAssistantFilterInput | null > | null,
  or?: Array< ModelMedicalAssistantFilterInput | null > | null,
  not?: ModelMedicalAssistantFilterInput | null,
  medicalAssistantUserId?: ModelIDInput | null,
};

export type ModelMedicalAssistantConnection = {
  __typename: "ModelMedicalAssistantConnection",
  items:  Array<MedicalAssistant | null >,
  nextToken?: string | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  cognitoUserId?: ModelIDInput | null,
  avatarUrl?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
  userDoctorId?: ModelIDInput | null,
  userAssistantId?: ModelIDInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelStoredAddressFilterInput = {
  id?: ModelIDInput | null,
  street?: ModelStringInput | null,
  city?: ModelStringInput | null,
  state?: ModelStringInput | null,
  zip?: ModelStringInput | null,
  insuranceCarrierID?: ModelIDInput | null,
  lawFirmID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelStoredAddressFilterInput | null > | null,
  or?: Array< ModelStoredAddressFilterInput | null > | null,
  not?: ModelStoredAddressFilterInput | null,
};

export type ModelStoredFaxNumberFilterInput = {
  id?: ModelIDInput | null,
  faxNumber?: ModelStringInput | null,
  insuranceCarrierID?: ModelIDInput | null,
  lawFirmID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelStoredFaxNumberFilterInput | null > | null,
  or?: Array< ModelStoredFaxNumberFilterInput | null > | null,
  not?: ModelStoredFaxNumberFilterInput | null,
};

export type ModelStoredPhoneNumberFilterInput = {
  id?: ModelIDInput | null,
  phoneNumber?: ModelStringInput | null,
  extension?: ModelStringInput | null,
  insuranceCarrierID?: ModelIDInput | null,
  lawFirmID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelStoredPhoneNumberFilterInput | null > | null,
  or?: Array< ModelStoredPhoneNumberFilterInput | null > | null,
  not?: ModelStoredPhoneNumberFilterInput | null,
};

export type ModelFaxJobFilterInput = {
  id?: ModelIDInput | null,
  appointmentID?: ModelIDInput | null,
  uploadedFileID?: ModelIDInput | null,
  recipientParty?: ModelFaxRecipientPartyInput | null,
  recipientEntityID?: ModelIDInput | null,
  faxNumber?: ModelStringInput | null,
  iFaxJobId?: ModelStringInput | null,
  status?: ModelFaxJobStatusInput | null,
  failureCode?: ModelStringInput | null,
  failureMessage?: ModelStringInput | null,
  submittedAt?: ModelStringInput | null,
  completedAt?: ModelStringInput | null,
  submittedByUserID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFaxJobFilterInput | null > | null,
  or?: Array< ModelFaxJobFilterInput | null > | null,
  not?: ModelFaxJobFilterInput | null,
};

export type ModelFaxJobConnection = {
  __typename: "ModelFaxJobConnection",
  items:  Array<FaxJob | null >,
  nextToken?: string | null,
};

export type ModelN110PartyDeliveryFilterInput = {
  id?: ModelIDInput | null,
  appointmentID?: ModelIDInput | null,
  uploadedFileID?: ModelIDInput | null,
  party?: ModelN110ServicePartyInput | null,
  status?: ModelN110UploadStatusInput | null,
  reason?: ModelN110MailReasonInput | null,
  driveFileID?: ModelStringInput | null,
  uploadedAt?: ModelStringInput | null,
  submittedByUserID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelN110PartyDeliveryFilterInput | null > | null,
  or?: Array< ModelN110PartyDeliveryFilterInput | null > | null,
  not?: ModelN110PartyDeliveryFilterInput | null,
};

export type ModelN110PartyDeliveryConnection = {
  __typename: "ModelN110PartyDeliveryConnection",
  items:  Array<N110PartyDelivery | null >,
  nextToken?: string | null,
};

export type ModelInsuranceCarrierFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  defaultAddressID?: ModelIDInput | null,
  defaultFaxNumberID?: ModelIDInput | null,
  defaultPhoneNumberID?: ModelIDInput | null,
  defaultEmail?: ModelStringInput | null,
  supportedDomains?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelInsuranceCarrierFilterInput | null > | null,
  or?: Array< ModelInsuranceCarrierFilterInput | null > | null,
  not?: ModelInsuranceCarrierFilterInput | null,
};

export type ModelInsuranceCarrierConnection = {
  __typename: "ModelInsuranceCarrierConnection",
  items:  Array<InsuranceCarrier | null >,
  nextToken?: string | null,
};

export type ModelLawFirmFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  type?: ModelLawFirmTypeInput | null,
  defaultAddressID?: ModelIDInput | null,
  defaultFaxNumberID?: ModelIDInput | null,
  defaultPhoneNumberID?: ModelIDInput | null,
  defaultEmail?: ModelStringInput | null,
  supportedDomains?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLawFirmFilterInput | null > | null,
  or?: Array< ModelLawFirmFilterInput | null > | null,
  not?: ModelLawFirmFilterInput | null,
};

export type ModelLawFirmConnection = {
  __typename: "ModelLawFirmConnection",
  items:  Array<LawFirm | null >,
  nextToken?: string | null,
};

export type ModelGlobalBillingCounterFilterInput = {
  id?: ModelIDInput | null,
  count?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelGlobalBillingCounterFilterInput | null > | null,
  or?: Array< ModelGlobalBillingCounterFilterInput | null > | null,
  not?: ModelGlobalBillingCounterFilterInput | null,
};

export type ModelGlobalBillingCounterConnection = {
  __typename: "ModelGlobalBillingCounterConnection",
  items:  Array<GlobalBillingCounter | null >,
  nextToken?: string | null,
};

export type ModelCaseRecordFilterInput = {
  id?: ModelIDInput | null,
  state?: ModelCaseStateInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCaseRecordFilterInput | null > | null,
  or?: Array< ModelCaseRecordFilterInput | null > | null,
  not?: ModelCaseRecordFilterInput | null,
};

export type ModelCaseRecordConnection = {
  __typename: "ModelCaseRecordConnection",
  items:  Array<CaseRecord | null >,
  nextToken?: string | null,
};

export type ModelAppointmentRecordFilterInput = {
  id?: ModelIDInput | null,
  doctorOwnerCognitoId?: ModelIDInput | null,
  assistantCognitoIds?: ModelIDInput | null,
  globalPartitionKey?: ModelStringInput | null,
  originalAppointmentID?: ModelIDInput | null,
  supplementalAppointmentIDs?: ModelIDInput | null,
  supplementalSourceAppointmentIDs?: ModelIDInput | null,
  depositionAppointmentIDs?: ModelIDInput | null,
  depositionSourceAppointmentIDs?: ModelIDInput | null,
  rescheduledFromAppointmentID?: ModelIDInput | null,
  rescheduledToAppointmentID?: ModelIDInput | null,
  date?: ModelStringInput | null,
  yearMonth?: ModelStringInput | null,
  doctorYearMonth?: ModelStringInput | null,
  time?: ModelStringInput | null,
  bookedInFlexibleTime?: ModelBooleanInput | null,
  inquiryDate?: ModelStringInput | null,
  inquiryYearMonth?: ModelStringInput | null,
  type?: ModelAppointmentTypeInput | null,
  doctorID?: ModelIDInput | null,
  locationID?: ModelIDInput | null,
  visitForm?: ModelStringInput | null,
  active?: ModelBooleanInput | null,
  durationMinutes?: ModelIntInput | null,
  reportDue?: ModelStringInput | null,
  reportSubmitted?: ModelStringInput | null,
  status?: ModelAppointmentStatusInput | null,
  reportStatus?: ModelReportStatusInput | null,
  paymentStatus?: ModelPaymentStatusInput | null,
  billingStatus?: ModelBillingStatusInput | null,
  difficultyLevel?: ModelIntInput | null,
  patientDescribedInjuries?: ModelBodyPartListInput | null,
  uploadedFilesSetID?: ModelIDInput | null,
  referredBy?: ModelStringInput | null,
  s3FileKey?: ModelStringInput | null,
  medicalRecordsReceived?: ModelBooleanInput | null,
  medicalRecordsBriefingFileID?: ModelStringInput | null,
  medicalRecordsBriefingExecutionArn?: ModelStringInput | null,
  medicalRecordsTotalPagesProcessed?: ModelIntInput | null,
  reportGenerationFileID?: ModelStringInput | null,
  reportGenerationExecutionArn?: ModelStringInput | null,
  reportGenerationGeneratedAt?: ModelStringInput | null,
  historyOfInjuryFileID?: ModelStringInput | null,
  historyOfInjuryGeneratedAt?: ModelStringInput | null,
  evaluationFileID?: ModelStringInput | null,
  assessmentFileID?: ModelStringInput | null,
  depositionPreparationFileID?: ModelStringInput | null,
  cancellationReason?: ModelCancellationReasonInput | null,
  cancellationRequestedBy?: ModelParticipantTypeInput | null,
  cancellationRequestedInternally?: ModelBooleanInput | null,
  cancellationNote?: ModelStringInput | null,
  cancellationDate?: ModelStringInput | null,
  inquiryClosingReason?: ModelInquiryClosingReasonInput | null,
  inquiryClosingNote?: ModelStringInput | null,
  inquiryClosingDate?: ModelStringInput | null,
  noShowReason?: ModelNoShowReasonInput | null,
  noShowNote?: ModelStringInput | null,
  reschedulingReason?: ModelReschedulingReasonInput | null,
  reschedulingOthersReason?: ModelStringInput | null,
  reschedulingRequestedBy?: ModelParticipantTypeInput | null,
  reschedulingRequestedInternally?: ModelBooleanInput | null,
  reschedulingNote?: ModelStringInput | null,
  reschedulingDate?: ModelStringInput | null,
  historyCallDate?: ModelStringInput | null,
  historyCallTime?: ModelStringInput | null,
  historyCallCompleted?: ModelBooleanInput | null,
  historyCallCompletedWithoutRecords?: ModelBooleanInput | null,
  historyCallCompletedOnSite?: ModelBooleanInput | null,
  historyCallNoShow?: ModelBooleanInput | null,
  historyCallCalendarEventID?: ModelIDInput | null,
  historyCallCalendarLink?: ModelStringInput | null,
  isProd?: ModelBooleanInput | null,
  isDemo?: ModelBooleanInput | null,
  primaryPatientCaseID?: ModelIDInput | null,
  calendarEventID?: ModelIDInput | null,
  defenseAttorneyPagesDeclaration?: ModelIntInput | null,
  applicantAttorneyPagesDeclaration?: ModelIntInput | null,
  tempUploadedIntakeFormS3Keys?: ModelStringInput | null,
  panelUnavailable?: ModelBooleanInput | null,
  panelSpecialty?: ModelSpecialtyTypeInput | null,
  defenseAttorneyNotPresent?: ModelBooleanInput | null,
  applicantAttorneyNotPresent?: ModelBooleanInput | null,
  videoCallLink?: ModelStringInput | null,
  caseID?: ModelIDInput | null,
  briefingModelVersion?: ModelBriefingModelVersionInput | null,
  briefingGdocExportLink?: ModelStringInput | null,
  briefingGdocExportedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAppointmentRecordFilterInput | null > | null,
  or?: Array< ModelAppointmentRecordFilterInput | null > | null,
  not?: ModelAppointmentRecordFilterInput | null,
  appointmentRecordMedicalAssistantId?: ModelIDInput | null,
  appointmentRecordSchedulingAssistantId?: ModelIDInput | null,
  appointmentRecordOnSiteOpId?: ModelIDInput | null,
  appointmentRecordReportOpId?: ModelIDInput | null,
  appointmentRecordBillingOpId?: ModelIDInput | null,
  appointmentRecordPreVisitReviewerId?: ModelIDInput | null,
  appointmentRecordHuddleNoteId?: ModelIDInput | null,
  appointmentRecordHistoryOfInjuryNotesId?: ModelIDInput | null,
  appointmentRecordCurrentComplaintNotesId?: ModelIDInput | null,
  appointmentRecordHistoryCallAssistantId?: ModelIDInput | null,
  appointmentRecordHistoryOfInjuryInsightsId?: ModelIDInput | null,
  appointmentRecordReviewOfMedicalRecordsInsightsId?: ModelIDInput | null,
  appointmentRecordPhysicalExamInsightsId?: ModelIDInput | null,
  appointmentRecordPastInjuryMatrixId?: ModelIDInput | null,
  appointmentRecordBriefingId?: ModelIDInput | null,
  appointmentRecordIntroParagraphId?: ModelIDInput | null,
  appointmentRecordAssessmentId?: ModelIDInput | null,
  appointmentRecordAssessmentValidationId?: ModelIDInput | null,
  appointmentRecordOpinionRecapId?: ModelIDInput | null,
  appointmentRecordHistoryValidationId?: ModelIDInput | null,
  appointmentRecordPatientHistoryValidationId?: ModelIDInput | null,
  appointmentRecordMrrValidationId?: ModelIDInput | null,
  appointmentRecordHistoryMrrCrossValidationId?: ModelIDInput | null,
};

export type ModelAppointmentRecordByGlobalDateTimeCompositeKeyConditionInput = {
  eq?: ModelAppointmentRecordByGlobalDateTimeCompositeKeyInput | null,
  le?: ModelAppointmentRecordByGlobalDateTimeCompositeKeyInput | null,
  lt?: ModelAppointmentRecordByGlobalDateTimeCompositeKeyInput | null,
  ge?: ModelAppointmentRecordByGlobalDateTimeCompositeKeyInput | null,
  gt?: ModelAppointmentRecordByGlobalDateTimeCompositeKeyInput | null,
  between?: Array< ModelAppointmentRecordByGlobalDateTimeCompositeKeyInput | null > | null,
  beginsWith?: ModelAppointmentRecordByGlobalDateTimeCompositeKeyInput | null,
};

export type ModelAppointmentRecordByGlobalDateTimeCompositeKeyInput = {
  date?: string | null,
  time?: string | null,
};

export type ModelAppointmentRecordByDoctorCompositeKeyConditionInput = {
  eq?: ModelAppointmentRecordByDoctorCompositeKeyInput | null,
  le?: ModelAppointmentRecordByDoctorCompositeKeyInput | null,
  lt?: ModelAppointmentRecordByDoctorCompositeKeyInput | null,
  ge?: ModelAppointmentRecordByDoctorCompositeKeyInput | null,
  gt?: ModelAppointmentRecordByDoctorCompositeKeyInput | null,
  between?: Array< ModelAppointmentRecordByDoctorCompositeKeyInput | null > | null,
  beginsWith?: ModelAppointmentRecordByDoctorCompositeKeyInput | null,
};

export type ModelAppointmentRecordByDoctorCompositeKeyInput = {
  date?: string | null,
  time?: string | null,
};

export type ModelAppointmentRecordByLocationCompositeKeyConditionInput = {
  eq?: ModelAppointmentRecordByLocationCompositeKeyInput | null,
  le?: ModelAppointmentRecordByLocationCompositeKeyInput | null,
  lt?: ModelAppointmentRecordByLocationCompositeKeyInput | null,
  ge?: ModelAppointmentRecordByLocationCompositeKeyInput | null,
  gt?: ModelAppointmentRecordByLocationCompositeKeyInput | null,
  between?: Array< ModelAppointmentRecordByLocationCompositeKeyInput | null > | null,
  beginsWith?: ModelAppointmentRecordByLocationCompositeKeyInput | null,
};

export type ModelAppointmentRecordByLocationCompositeKeyInput = {
  date?: string | null,
  time?: string | null,
};

export type ModelAppointmentRecordByCaseCompositeKeyConditionInput = {
  eq?: ModelAppointmentRecordByCaseCompositeKeyInput | null,
  le?: ModelAppointmentRecordByCaseCompositeKeyInput | null,
  lt?: ModelAppointmentRecordByCaseCompositeKeyInput | null,
  ge?: ModelAppointmentRecordByCaseCompositeKeyInput | null,
  gt?: ModelAppointmentRecordByCaseCompositeKeyInput | null,
  between?: Array< ModelAppointmentRecordByCaseCompositeKeyInput | null > | null,
  beginsWith?: ModelAppointmentRecordByCaseCompositeKeyInput | null,
};

export type ModelAppointmentRecordByCaseCompositeKeyInput = {
  date?: string | null,
  time?: string | null,
};

export type ModelPatientFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  dateOfBirth?: ModelStringInput | null,
  SSN?: ModelStringInput | null,
  language?: ModelLanguageInput | null,
  dominantHand?: ModelDominantHandInput | null,
  occupation?: ModelStringInput | null,
  sex?: ModelSexInput | null,
  weightLb?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPatientFilterInput | null > | null,
  or?: Array< ModelPatientFilterInput | null > | null,
  not?: ModelPatientFilterInput | null,
};

export type ModelPatientConnection = {
  __typename: "ModelPatientConnection",
  items:  Array<Patient | null >,
  nextToken?: string | null,
};

export type ModelPatientCaseFilterInput = {
  id?: ModelIDInput | null,
  patientID?: ModelIDInput | null,
  claimNumber?: ModelStringInput | null,
  qmePanelNumber?: ModelStringInput | null,
  insuranceCarrierID?: ModelIDInput | null,
  insuranceCarrierAddressID?: ModelIDInput | null,
  insuranceCarrierFaxNumberID?: ModelIDInput | null,
  insuranceCarrierPhoneNumberID?: ModelIDInput | null,
  applicantAttorneyLawFirmID?: ModelIDInput | null,
  applicantAttorneyAddressID?: ModelIDInput | null,
  applicantAttorneyFaxNumberID?: ModelIDInput | null,
  applicantAttorneyPhoneNumberID?: ModelIDInput | null,
  defenseAttorneyLawFirmID?: ModelIDInput | null,
  defenseAttorneyAddressID?: ModelIDInput | null,
  defenseAttorneyFaxNumberID?: ModelIDInput | null,
  defenseAttorneyPhoneNumberID?: ModelIDInput | null,
  applicantAttorneyCcEmails?: ModelStringInput | null,
  defenseAttorneyCcEmails?: ModelStringInput | null,
  adjusterCcEmails?: ModelStringInput | null,
  scheduledCommsSuppressedParties?: ModelInquiringPartyListInput | null,
  WCAB?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPatientCaseFilterInput | null > | null,
  or?: Array< ModelPatientCaseFilterInput | null > | null,
  not?: ModelPatientCaseFilterInput | null,
};

export type ModelDoctorFilterInput = {
  id?: ModelIDInput | null,
  ownerCognitoId?: ModelIDInput | null,
  firstName?: ModelStringInput | null,
  middleName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  name?: ModelStringInput | null,
  signatureName?: ModelStringInput | null,
  status?: ModelDoctorStatusInput | null,
  ramped?: ModelBooleanInput | null,
  title?: ModelStringInput | null,
  titleExtension?: ModelTitleExtensionInput | null,
  officePhone?: ModelStringInput | null,
  cellPhone?: ModelStringInput | null,
  clinicPhone?: ModelStringInput | null,
  workCity?: ModelStringInput | null,
  workState?: ModelStringInput | null,
  collectionRate?: ModelFloatInput | null,
  licenseNumber?: ModelStringInput | null,
  licenseRenewalDate?: ModelStringInput | null,
  specialties?: ModelSpecialtyTypeListInput | null,
  npi?: ModelStringInput | null,
  availabilitiesNote?: ModelStringInput | null,
  emails?: ModelStringInput | null,
  signatureDepartment?: ModelStringInput | null,
  profileAssetS3Prefix?: ModelStringInput | null,
  preferredAssessmentMode?: ModelAssessmentModeInput | null,
  isDemo?: ModelBooleanInput | null,
  fieldTemplateId?: ModelIDInput | null,
  templateFolderLink?: ModelStringInput | null,
  assessmentTreatmentOptions?: ModelStringInput | null,
  dismissedProTips?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDoctorFilterInput | null > | null,
  or?: Array< ModelDoctorFilterInput | null > | null,
  not?: ModelDoctorFilterInput | null,
  doctorPhysicianPartnerId?: ModelIDInput | null,
  doctorDefaultPrimaryOnsiteOpsId?: ModelIDInput | null,
  doctorDefaultSecondaryOnsiteOpsId?: ModelIDInput | null,
  doctorDefaultSchedulerId?: ModelIDInput | null,
  doctorDefaultReportOpsId?: ModelIDInput | null,
  doctorDefaultPreVisitReviewerId?: ModelIDInput | null,
  doctorDefaultBillingOpsId?: ModelIDInput | null,
  doctorDefaultSupplementalReportOpsId?: ModelIDInput | null,
  doctorUserId?: ModelIDInput | null,
};

export type ModelDoctorConnection = {
  __typename: "ModelDoctorConnection",
  items:  Array<Doctor | null >,
  nextToken?: string | null,
};

export type ModelLocationFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  abbreviation?: ModelStringInput | null,
  status?: ModelLocationStatusInput | null,
  region?: ModelRegionInput | null,
  indigoOfficePhoneNumber?: ModelStringInput | null,
  isWaitingArea?: ModelBooleanInput | null,
  additionalRoomsNumber?: ModelIntInput | null,
  calendarCcEmails?: ModelStringInput | null,
  isParkingFree?: ModelBooleanInput | null,
  parkingRate?: ModelFloatInput | null,
  isFrontDoorLocked?: ModelBooleanInput | null,
  frontDoorCode?: ModelStringInput | null,
  backDoor?: ModelBackDoorStatusInput | null,
  backDoorCode?: ModelStringInput | null,
  securityUnlockingProcess?: ModelStringInput | null,
  securityLockingProcess?: ModelStringInput | null,
  maleBathroomCode?: ModelStringInput | null,
  femaleBathroomCode?: ModelStringInput | null,
  wifiName?: ModelStringInput | null,
  wifiPassword?: ModelStringInput | null,
  locationInstructionsForVisitor?: ModelStringInput | null,
  additionalNote?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLocationFilterInput | null > | null,
  or?: Array< ModelLocationFilterInput | null > | null,
  not?: ModelLocationFilterInput | null,
  locationDefaultOnsiteOpsId?: ModelIDInput | null,
  locationSecondaryOnsiteOpsId?: ModelIDInput | null,
};

export type ModelLocationConnection = {
  __typename: "ModelLocationConnection",
  items:  Array<Location | null >,
  nextToken?: string | null,
};

export type ModelWorkflowExecutionFilterInput = {
  executionArn?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  type?: ModelWorkflowExecutionTypeInput | null,
  status?: ModelWorkflowExecutionStatusInput | null,
  errorMessage?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelWorkflowExecutionFilterInput | null > | null,
  or?: Array< ModelWorkflowExecutionFilterInput | null > | null,
  not?: ModelWorkflowExecutionFilterInput | null,
};

export type ModelHistoryOfInjuryInsightsFilterInput = {
  id?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  mechanismOfInjury?: ModelStringInput | null,
  employerJobDescription?: ModelStringInput | null,
  injuryEmploymentStatus?: ModelStringInput | null,
  currentWorkRestrictionsFromPatient?: ModelStringInput | null,
  activitiesOfDailyLiving?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelHistoryOfInjuryInsightsFilterInput | null > | null,
  or?: Array< ModelHistoryOfInjuryInsightsFilterInput | null > | null,
  not?: ModelHistoryOfInjuryInsightsFilterInput | null,
};

export type ModelHistoryOfInjuryInsightsConnection = {
  __typename: "ModelHistoryOfInjuryInsightsConnection",
  items:  Array<HistoryOfInjuryInsights | null >,
  nextToken?: string | null,
};

export type ModelOpinionRecapFilterInput = {
  id?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  causation?: ModelStringInput | null,
  diagnosis?: ModelStringInput | null,
  mmiFutureMedicalTreatment?: ModelStringInput | null,
  impairmentRating?: ModelStringInput | null,
  apportionment?: ModelStringInput | null,
  workStatus?: ModelStringInput | null,
  sourceReportFileID?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOpinionRecapFilterInput | null > | null,
  or?: Array< ModelOpinionRecapFilterInput | null > | null,
  not?: ModelOpinionRecapFilterInput | null,
};

export type ModelOpinionRecapConnection = {
  __typename: "ModelOpinionRecapConnection",
  items:  Array<OpinionRecap | null >,
  nextToken?: string | null,
};

export type ModelReviewOfMedicalRecordsInsightsFilterInput = {
  id?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  currentWorkRestrictionsFromMedicalRecords?: ModelStringInput | null,
  derivedFromDocumentInsightIDs?: ModelIDInput | null,
  derivedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReviewOfMedicalRecordsInsightsFilterInput | null > | null,
  or?: Array< ModelReviewOfMedicalRecordsInsightsFilterInput | null > | null,
  not?: ModelReviewOfMedicalRecordsInsightsFilterInput | null,
};

export type ModelReviewOfMedicalRecordsInsightsConnection = {
  __typename: "ModelReviewOfMedicalRecordsInsightsConnection",
  items:  Array<ReviewOfMedicalRecordsInsights | null >,
  nextToken?: string | null,
};

export type ModelDocumentBriefingInsightsFilterInput = {
  id?: ModelIDInput | null,
  documentID?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  currentWorkRestrictionsFromMedicalRecords?: ModelStringInput | null,
  sourceRecordBriefingID?: ModelIDInput | null,
  generatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDocumentBriefingInsightsFilterInput | null > | null,
  or?: Array< ModelDocumentBriefingInsightsFilterInput | null > | null,
  not?: ModelDocumentBriefingInsightsFilterInput | null,
};

export type ModelDocumentBriefingInsightsConnection = {
  __typename: "ModelDocumentBriefingInsightsConnection",
  items:  Array<DocumentBriefingInsights | null >,
  nextToken?: string | null,
};

export type ModelPhysicalExamInsightsFilterInput = {
  id?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  physicalExaminationInfo?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPhysicalExamInsightsFilterInput | null > | null,
  or?: Array< ModelPhysicalExamInsightsFilterInput | null > | null,
  not?: ModelPhysicalExamInsightsFilterInput | null,
};

export type ModelPhysicalExamInsightsConnection = {
  __typename: "ModelPhysicalExamInsightsConnection",
  items:  Array<PhysicalExamInsights | null >,
  nextToken?: string | null,
};

export type ModelDataFieldFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  category?: ModelDataFieldCategoryInput | null,
  dataType?: ModelDataFieldTypeInput | null,
  default?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  sectionID?: ModelIDInput | null,
  migrationKey?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDataFieldFilterInput | null > | null,
  or?: Array< ModelDataFieldFilterInput | null > | null,
  not?: ModelDataFieldFilterInput | null,
};

export type ModelDataFieldSectionFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  default?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDataFieldSectionFilterInput | null > | null,
  or?: Array< ModelDataFieldSectionFilterInput | null > | null,
  not?: ModelDataFieldSectionFilterInput | null,
};

export type ModelDataFieldSectionConnection = {
  __typename: "ModelDataFieldSectionConnection",
  items:  Array<DataFieldSection | null >,
  nextToken?: string | null,
};

export type ModelBriefingFieldFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  default?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  briefingPrompt?: ModelStringInput | null,
  briefingRecordTypeID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBriefingFieldFilterInput | null > | null,
  or?: Array< ModelBriefingFieldFilterInput | null > | null,
  not?: ModelBriefingFieldFilterInput | null,
};

export type ModelBriefingRecordTypeFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  recordType?: ModelRecordTypeInput | null,
  description?: ModelStringInput | null,
  default?: ModelBooleanInput | null,
  classificationPrompt?: ModelStringInput | null,
  recordBasePrompt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBriefingRecordTypeFilterInput | null > | null,
  or?: Array< ModelBriefingRecordTypeFilterInput | null > | null,
  not?: ModelBriefingRecordTypeFilterInput | null,
};

export type ModelBriefingRecordTypeConnection = {
  __typename: "ModelBriefingRecordTypeConnection",
  items:  Array<BriefingRecordType | null >,
  nextToken?: string | null,
};

export type ModelCaseSummaryFieldFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  default?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  summaryPrompt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCaseSummaryFieldFilterInput | null > | null,
  or?: Array< ModelCaseSummaryFieldFilterInput | null > | null,
  not?: ModelCaseSummaryFieldFilterInput | null,
};

export type ModelCaseSummaryFieldConnection = {
  __typename: "ModelCaseSummaryFieldConnection",
  items:  Array<CaseSummaryField | null >,
  nextToken?: string | null,
};

export type ModelPastInjuryMatrixFilterInput = {
  id?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  preExistingConditions?: ModelStringInput | null,
  familyHistory?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPastInjuryMatrixFilterInput | null > | null,
  or?: Array< ModelPastInjuryMatrixFilterInput | null > | null,
  not?: ModelPastInjuryMatrixFilterInput | null,
};

export type ModelPastInjuryMatrixConnection = {
  __typename: "ModelPastInjuryMatrixConnection",
  items:  Array<PastInjuryMatrix | null >,
  nextToken?: string | null,
};

export type ModelAppointmentFilterPresetFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  appliesTo?: ModelUserGroupInput | null,
  view?: ModelAppointmentsViewInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAppointmentFilterPresetFilterInput | null > | null,
  or?: Array< ModelAppointmentFilterPresetFilterInput | null > | null,
  not?: ModelAppointmentFilterPresetFilterInput | null,
};

export type ModelAppointmentFilterPresetConnection = {
  __typename: "ModelAppointmentFilterPresetConnection",
  items:  Array<AppointmentFilterPreset | null >,
  nextToken?: string | null,
};

export type FeatureFlag = {
  __typename: "FeatureFlag",
  key: string,
  enabled: boolean,
  enabledForUserIds?: Array< string > | null,
  enabledForRoles?: Array< UserGroup > | null,
  enabledForDoctorIds?: Array< string > | null,
  description?: string | null,
  variants?:  Array<VariantPercentageMapping > | null,
  seed?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type VariantPercentageMapping = {
  __typename: "VariantPercentageMapping",
  variant: string,
  percentage: number,
};

export type ModelFeatureFlagFilterInput = {
  key?: ModelIDInput | null,
  enabled?: ModelBooleanInput | null,
  enabledForUserIds?: ModelStringInput | null,
  enabledForRoles?: ModelUserGroupListInput | null,
  enabledForDoctorIds?: ModelStringInput | null,
  description?: ModelStringInput | null,
  seed?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFeatureFlagFilterInput | null > | null,
  or?: Array< ModelFeatureFlagFilterInput | null > | null,
  not?: ModelFeatureFlagFilterInput | null,
};

export type ModelFeatureFlagConnection = {
  __typename: "ModelFeatureFlagConnection",
  items:  Array<FeatureFlag | null >,
  nextToken?: string | null,
};

export type FeatureFlagVariantAssignment = {
  __typename: "FeatureFlagVariantAssignment",
  assignmentId: string,
  flagKey: string,
  subjectId: string,
  variant: string,
  assignedAt: string,
  createdAt: string,
  updatedAt: string,
};

export type ModelFeatureFlagVariantAssignmentFilterInput = {
  assignmentId?: ModelIDInput | null,
  flagKey?: ModelIDInput | null,
  subjectId?: ModelIDInput | null,
  variant?: ModelStringInput | null,
  assignedAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFeatureFlagVariantAssignmentFilterInput | null > | null,
  or?: Array< ModelFeatureFlagVariantAssignmentFilterInput | null > | null,
  not?: ModelFeatureFlagVariantAssignmentFilterInput | null,
};

export type ModelFeatureFlagVariantAssignmentConnection = {
  __typename: "ModelFeatureFlagVariantAssignmentConnection",
  items:  Array<FeatureFlagVariantAssignment | null >,
  nextToken?: string | null,
};

export type ModelRecordBriefingSegmentFilterInput = {
  id?: ModelIDInput | null,
  logicalSegmentID?: ModelIDInput | null,
  title?: ModelStringInput | null,
  text?: ModelStringInput | null,
  bodyParts?: ModelBodyPartListInput | null,
  injuredBodyParts?: ModelBodyPartListInput | null,
  editedBy?: ModelIDInput | null,
  pdfFileName?: ModelStringInput | null,
  sourceTag?: ModelStringInput | null,
  segmentNumber?: ModelIntInput | null,
  sourcePdfS3Key?: ModelStringInput | null,
  startPageNumber?: ModelIntInput | null,
  endPageNumber?: ModelIntInput | null,
  recordType?: ModelRecordTypeInput | null,
  extractedDate?: ModelStringInput | null,
  doctorName?: ModelStringInput | null,
  processingModel?: ModelStringInput | null,
  classificationConfidence?: ModelFloatInput | null,
  hasDate?: ModelBooleanInput | null,
  potentialDuplicateID?: ModelIDInput | null,
  needsReview?: ModelBooleanInput | null,
  status?: ModelSegmentStatusInput | null,
  documentID?: ModelIDInput | null,
  videoStartTime?: ModelStringInput | null,
  videoEndTime?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRecordBriefingSegmentFilterInput | null > | null,
  or?: Array< ModelRecordBriefingSegmentFilterInput | null > | null,
  not?: ModelRecordBriefingSegmentFilterInput | null,
};

export type ModelRecordBriefingSegmentConnection = {
  __typename: "ModelRecordBriefingSegmentConnection",
  items:  Array<RecordBriefingSegment | null >,
  nextToken?: string | null,
};

export type ModelRecordBriefingSegmentMappingFilterInput = {
  id?: ModelIDInput | null,
  briefingID?: ModelIDInput | null,
  logicalSegmentID?: ModelIDInput | null,
  publishedSegmentID?: ModelIDInput | null,
  draftSegmentID?: ModelIDInput | null,
  markedForDeletion?: ModelBooleanInput | null,
  markedForCreation?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRecordBriefingSegmentMappingFilterInput | null > | null,
  or?: Array< ModelRecordBriefingSegmentMappingFilterInput | null > | null,
  not?: ModelRecordBriefingSegmentMappingFilterInput | null,
};

export type ModelRecordBriefingFilterInput = {
  id?: ModelIDInput | null,
  logicalBriefingID?: ModelIDInput | null,
  generatedAt?: ModelStringInput | null,
  lastEditedAt?: ModelStringInput | null,
  lastEditedBy?: ModelIDInput | null,
  googleDocExportLink?: ModelStringInput | null,
  googleDocExportedAt?: ModelStringInput | null,
  editingPresence?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRecordBriefingFilterInput | null > | null,
  or?: Array< ModelRecordBriefingFilterInput | null > | null,
  not?: ModelRecordBriefingFilterInput | null,
};

export type ModelRecordBriefingConnection = {
  __typename: "ModelRecordBriefingConnection",
  items:  Array<RecordBriefing | null >,
  nextToken?: string | null,
};

export type ModelRecordBriefingSegmentAnnotationFilterInput = {
  id?: ModelIDInput | null,
  logicalSegmentID?: ModelStringInput | null,
  isStarred?: ModelBooleanInput | null,
  isImportant?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRecordBriefingSegmentAnnotationFilterInput | null > | null,
  or?: Array< ModelRecordBriefingSegmentAnnotationFilterInput | null > | null,
  not?: ModelRecordBriefingSegmentAnnotationFilterInput | null,
};

export type ModelRecordBriefingSegmentAnnotationConnection = {
  __typename: "ModelRecordBriefingSegmentAnnotationConnection",
  items:  Array<RecordBriefingSegmentAnnotation | null >,
  nextToken?: string | null,
};

export type ModelRecordBriefingSegmentSuggestionFilterInput = {
  id?: ModelIDInput | null,
  briefingID?: ModelIDInput | null,
  logicalSegmentID?: ModelIDInput | null,
  suggestionType?: ModelSegmentSuggestionTypeInput | null,
  reason?: ModelSegmentSuggestionReasonInput | null,
  reasonDetails?: ModelStringInput | null,
  status?: ModelSegmentSuggestionStatusInput | null,
  resolvedBy?: ModelIDInput | null,
  resolvedAt?: ModelStringInput | null,
  seen?: ModelBooleanInput | null,
  confidence?: ModelFloatInput | null,
  relatedSegmentID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRecordBriefingSegmentSuggestionFilterInput | null > | null,
  or?: Array< ModelRecordBriefingSegmentSuggestionFilterInput | null > | null,
  not?: ModelRecordBriefingSegmentSuggestionFilterInput | null,
};

export type ModelRecordBriefingSegmentSuggestionConnection = {
  __typename: "ModelRecordBriefingSegmentSuggestionConnection",
  items:  Array<RecordBriefingSegmentSuggestion | null >,
  nextToken?: string | null,
};

export type ModelSummaryCitationFilterInput = {
  id?: ModelIDInput | null,
  briefingID?: ModelIDInput | null,
  logicalSegmentID?: ModelIDInput | null,
  summaryText?: ModelStringInput | null,
  citationID?: ModelIDInput | null,
  status?: ModelSummaryCitationStatusInput | null,
  removedBy?: ModelIDInput | null,
  removedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSummaryCitationFilterInput | null > | null,
  or?: Array< ModelSummaryCitationFilterInput | null > | null,
  not?: ModelSummaryCitationFilterInput | null,
};

export type ModelSummaryCitationConnection = {
  __typename: "ModelSummaryCitationConnection",
  items:  Array<SummaryCitation | null >,
  nextToken?: string | null,
};

export type ModelSuggestionFilterInput = {
  id?: ModelIDInput | null,
  appointmentID?: ModelIDInput | null,
  source?: ModelSuggestionSourceInput | null,
  changeType?: ModelSuggestionChangeTypeInput | null,
  resourceURI?: ModelStringInput | null,
  suggestedValue?: ModelStringInput | null,
  existingValue?: ModelStringInput | null,
  rationale?: ModelStringInput | null,
  status?: ModelSuggestionStatusInput | null,
  resolvedByUserID?: ModelIDInput | null,
  resolvedAt?: ModelStringInput | null,
  versionID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSuggestionFilterInput | null > | null,
  or?: Array< ModelSuggestionFilterInput | null > | null,
  not?: ModelSuggestionFilterInput | null,
};

export type ModelSuggestionConnection = {
  __typename: "ModelSuggestionConnection",
  items:  Array<Suggestion | null >,
  nextToken?: string | null,
};

export type ModelOnsiteOpsConfigFilterInput = {
  doctorLocationKey?: ModelIDInput | null,
  assignmentEffectiveDate?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOnsiteOpsConfigFilterInput | null > | null,
  or?: Array< ModelOnsiteOpsConfigFilterInput | null > | null,
  not?: ModelOnsiteOpsConfigFilterInput | null,
  onsiteOpsConfigDoctorId?: ModelIDInput | null,
  onsiteOpsConfigLocationId?: ModelIDInput | null,
  onsiteOpsConfigMedicalAssistantId?: ModelIDInput | null,
  onsiteOpsConfigSecondaryMedicalAssistantId?: ModelIDInput | null,
};

export type ModelOnsiteOpsConfigConnection = {
  __typename: "ModelOnsiteOpsConfigConnection",
  items:  Array<OnsiteOpsConfig | null >,
  nextToken?: string | null,
};

export type ModelOpsGlobalSettingsFilterInput = {
  key?: ModelIDInput | null,
  inPersonEvaluationPreVisitDurationDays?: ModelIntInput | null,
  supplementalPreVisitDurationDays?: ModelIntInput | null,
  depositionPreVisitDurationDays?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOpsGlobalSettingsFilterInput | null > | null,
  or?: Array< ModelOpsGlobalSettingsFilterInput | null > | null,
  not?: ModelOpsGlobalSettingsFilterInput | null,
  opsGlobalSettingsDefaultGlobalOnsiteOpsId?: ModelIDInput | null,
  opsGlobalSettingsDefaultGlobalMAId?: ModelIDInput | null,
  opsGlobalSettingsDefaultGlobalSchedulerId?: ModelIDInput | null,
  opsGlobalSettingsDefaultGlobalReportOpsId?: ModelIDInput | null,
  opsGlobalSettingsDefaultGlobalPreVisitReviewerId?: ModelIDInput | null,
  opsGlobalSettingsDefaultGlobalBillingOpsId?: ModelIDInput | null,
};

export type ModelOpsGlobalSettingsConnection = {
  __typename: "ModelOpsGlobalSettingsConnection",
  items:  Array<OpsGlobalSettings | null >,
  nextToken?: string | null,
};

export type ModelSpecialtyCategoryFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  specialties?: ModelSpecialtyTypeListInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSpecialtyCategoryFilterInput | null > | null,
  or?: Array< ModelSpecialtyCategoryFilterInput | null > | null,
  not?: ModelSpecialtyCategoryFilterInput | null,
  specialtyCategoryFallbackMAId?: ModelIDInput | null,
};

export type ModelSpecialtyCategoryConnection = {
  __typename: "ModelSpecialtyCategoryConnection",
  items:  Array<SpecialtyCategory | null >,
  nextToken?: string | null,
};

export type ModelCoverLetterRecapFilterInput = {
  id?: ModelIDInput | null,
  uploadedFileID?: ModelIDInput | null,
  recapText?: ModelStringInput | null,
  status?: ModelCoverLetterRecapStatusInput | null,
  errorMessage?: ModelStringInput | null,
  generatedAt?: ModelStringInput | null,
  lastEditedAt?: ModelStringInput | null,
  lastEditedBy?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCoverLetterRecapFilterInput | null > | null,
  or?: Array< ModelCoverLetterRecapFilterInput | null > | null,
  not?: ModelCoverLetterRecapFilterInput | null,
};

export type ModelCoverLetterRecapConnection = {
  __typename: "ModelCoverLetterRecapConnection",
  items:  Array<CoverLetterRecap | null >,
  nextToken?: string | null,
};

export type ModelIntroParagraphFilterInput = {
  id?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  introParagraphText?: ModelStringInput | null,
  status?: ModelIntroParagraphStatusInput | null,
  errorMessage?: ModelStringInput | null,
  generatedAt?: ModelStringInput | null,
  lastEditedAt?: ModelStringInput | null,
  lastEditedBy?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelIntroParagraphFilterInput | null > | null,
  or?: Array< ModelIntroParagraphFilterInput | null > | null,
  not?: ModelIntroParagraphFilterInput | null,
};

export type ModelIntroParagraphConnection = {
  __typename: "ModelIntroParagraphConnection",
  items:  Array<IntroParagraph | null >,
  nextToken?: string | null,
};

export type ModelIntroductionStatementFilterInput = {
  id?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  kind?: ModelIntroductionStatementKindInput | null,
  text?: ModelStringInput | null,
  lastEditedAt?: ModelStringInput | null,
  lastEditedBy?: ModelIDInput | null,
  selectedCoverLetterFileID?: ModelIDInput | null,
  selectionConfirmedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelIntroductionStatementFilterInput | null > | null,
  or?: Array< ModelIntroductionStatementFilterInput | null > | null,
  not?: ModelIntroductionStatementFilterInput | null,
};

export type ModelIntroductionStatementConnection = {
  __typename: "ModelIntroductionStatementConnection",
  items:  Array<IntroductionStatement | null >,
  nextToken?: string | null,
};

export type ModelAssessmentFilterInput = {
  id?: ModelIDInput | null,
  discussedBodyParts?: ModelBodyPartListInput | null,
  bodyPartsNotDiscussedReason?: ModelStringInput | null,
  discussions?: ModelStringInput | null,
  workStatus?: ModelStringInput | null,
  markedAsDone?: ModelBooleanInput | null,
  discussDiagnosesFreeForm?: ModelBooleanInput | null,
  diagnosesFreeform?: ModelStringInput | null,
  discussCausationFreeForm?: ModelBooleanInput | null,
  causationFreeForm?: ModelStringInput | null,
  discussMMIImpairmentRatingApportionmentFreeForm?: ModelBooleanInput | null,
  hasPatientReachedMMIFreeForm?: ModelStringInput | null,
  discussMMIByBodyPartFreeForm?: ModelStringInput | null,
  impairmentRatingByBodyPartFreeForm?: ModelStringInput | null,
  apportionmentByBodyPartFreeForm?: ModelStringInput | null,
  impairmentRatingOtherComments?: ModelStringInput | null,
  apportionmentOtherComments?: ModelStringInput | null,
  assessmentMode?: ModelAssessmentModeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAssessmentFilterInput | null > | null,
  or?: Array< ModelAssessmentFilterInput | null > | null,
  not?: ModelAssessmentFilterInput | null,
};

export type ModelAssessmentConnection = {
  __typename: "ModelAssessmentConnection",
  items:  Array<Assessment | null >,
  nextToken?: string | null,
};

export type ModelValidationCheckFilterInput = {
  id?: ModelIDInput | null,
  validationID?: ModelIDInput | null,
  checkType?: ModelStringInput | null,
  inputResourceURIs?: ModelStringInput | null,
  status?: ModelValidationStatusInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelValidationCheckFilterInput | null > | null,
  or?: Array< ModelValidationCheckFilterInput | null > | null,
  not?: ModelValidationCheckFilterInput | null,
};

export type ModelValidationCheckConnection = {
  __typename: "ModelValidationCheckConnection",
  items:  Array<ValidationCheck | null >,
  nextToken?: string | null,
};

export type ModelValidationIssueFilterInput = {
  id?: ModelIDInput | null,
  validationID?: ModelIDInput | null,
  validationCheckID?: ModelIDInput | null,
  title?: ModelStringInput | null,
  issue?: ModelStringInput | null,
  status?: ModelValidationStatusInput | null,
  resourceURI?: ModelStringInput | null,
  issueGroup?: ModelStringInput | null,
  issueType?: ModelValidationIssueTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelValidationIssueFilterInput | null > | null,
  or?: Array< ModelValidationIssueFilterInput | null > | null,
  not?: ModelValidationIssueFilterInput | null,
};

export type ModelValidationFilterInput = {
  id?: ModelIDInput | null,
  issueGroups?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelValidationFilterInput | null > | null,
  or?: Array< ModelValidationFilterInput | null > | null,
  not?: ModelValidationFilterInput | null,
};

export type ModelValidationConnection = {
  __typename: "ModelValidationConnection",
  items:  Array<Validation | null >,
  nextToken?: string | null,
};

export type ModelWorkflowAuditEntryFilterInput = {
  id?: ModelIDInput | null,
  workflowAuditID?: ModelIDInput | null,
  message?: ModelStringInput | null,
  actorType?: ModelUserGroupInput | null,
  actorID?: ModelIDInput | null,
  entryType?: ModelStringInput | null,
  relatedActionIDs?: ModelIDInput | null,
  payload?: ModelStringInput | null,
  correlationID?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelWorkflowAuditEntryFilterInput | null > | null,
  or?: Array< ModelWorkflowAuditEntryFilterInput | null > | null,
  not?: ModelWorkflowAuditEntryFilterInput | null,
};

export type ModelWorkflowAuditFilterInput = {
  id?: ModelIDInput | null,
  workflowType?: ModelStringInput | null,
  entityID?: ModelIDInput | null,
  entityType?: ModelStringInput | null,
  appointmentID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelWorkflowAuditFilterInput | null > | null,
  or?: Array< ModelWorkflowAuditFilterInput | null > | null,
  not?: ModelWorkflowAuditFilterInput | null,
};

export type ModelWorkflowAuditConnection = {
  __typename: "ModelWorkflowAuditConnection",
  items:  Array<WorkflowAudit | null >,
  nextToken?: string | null,
};

export type ModelWorkflowAuditByWorkflowTypeCompositeKeyConditionInput = {
  eq?: ModelWorkflowAuditByWorkflowTypeCompositeKeyInput | null,
  le?: ModelWorkflowAuditByWorkflowTypeCompositeKeyInput | null,
  lt?: ModelWorkflowAuditByWorkflowTypeCompositeKeyInput | null,
  ge?: ModelWorkflowAuditByWorkflowTypeCompositeKeyInput | null,
  gt?: ModelWorkflowAuditByWorkflowTypeCompositeKeyInput | null,
  between?: Array< ModelWorkflowAuditByWorkflowTypeCompositeKeyInput | null > | null,
  beginsWith?: ModelWorkflowAuditByWorkflowTypeCompositeKeyInput | null,
};

export type ModelWorkflowAuditByWorkflowTypeCompositeKeyInput = {
  entityType?: string | null,
  entityID?: string | null,
};

export type ModelWorkflowAuditActionFilterInput = {
  id?: ModelIDInput | null,
  workflowAuditID?: ModelIDInput | null,
  appointmentID?: ModelIDInput | null,
  actionType?: ModelStringInput | null,
  status?: ModelWorkflowAuditActionStatusInput | null,
  payload?: ModelStringInput | null,
  rationale?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelWorkflowAuditActionFilterInput | null > | null,
  or?: Array< ModelWorkflowAuditActionFilterInput | null > | null,
  not?: ModelWorkflowAuditActionFilterInput | null,
};

export type ModelWorkflowAuditActionConnection = {
  __typename: "ModelWorkflowAuditActionConnection",
  items:  Array<WorkflowAuditAction | null >,
  nextToken?: string | null,
};

export type ModelFormDataDraftFilterInput = {
  id?: ModelIDInput | null,
  timestamp?: ModelStringInput | null,
  formType?: ModelStringInput | null,
  appointmentId?: ModelIDInput | null,
  data?: ModelStringInput | null,
  ttl?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFormDataDraftFilterInput | null > | null,
  or?: Array< ModelFormDataDraftFilterInput | null > | null,
  not?: ModelFormDataDraftFilterInput | null,
};

export type ModelFormDataDraftConnection = {
  __typename: "ModelFormDataDraftConnection",
  items:  Array<FormDataDraft | null >,
  nextToken?: string | null,
};

export type AuditLog = {
  __typename: "AuditLog",
  id: string,
  timestamp: string,
  tableName: string,
  recordId: string,
  action: string,
  ttl?: number | null,
  oldImage?: string | null,
  newImage?: string | null,
  changedFields?: Array< string | null > | null,
  eventID?: string | null,
  eventSource?: string | null,
  approximateCreationDateTime?: number | null,
  modifiedBy?: string | null,
  impersonatedBy?: string | null,
  impersonationSessionId?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelAuditLogFilterInput = {
  id?: ModelIDInput | null,
  timestamp?: ModelStringInput | null,
  tableName?: ModelStringInput | null,
  recordId?: ModelIDInput | null,
  action?: ModelStringInput | null,
  ttl?: ModelIntInput | null,
  oldImage?: ModelStringInput | null,
  newImage?: ModelStringInput | null,
  changedFields?: ModelStringInput | null,
  eventID?: ModelStringInput | null,
  eventSource?: ModelStringInput | null,
  approximateCreationDateTime?: ModelIntInput | null,
  modifiedBy?: ModelStringInput | null,
  impersonatedBy?: ModelStringInput | null,
  impersonationSessionId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAuditLogFilterInput | null > | null,
  or?: Array< ModelAuditLogFilterInput | null > | null,
  not?: ModelAuditLogFilterInput | null,
};

export type ModelAuditLogConnection = {
  __typename: "ModelAuditLogConnection",
  items:  Array<AuditLog | null >,
  nextToken?: string | null,
};

export type ModelHistoryValidationFilterInput = {
  id?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  status?: ModelHistoryValidationStatusInput | null,
  validatedAt?: ModelStringInput | null,
  errorMessage?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelHistoryValidationFilterInput | null > | null,
  or?: Array< ModelHistoryValidationFilterInput | null > | null,
  not?: ModelHistoryValidationFilterInput | null,
};

export type ModelHistoryValidationConnection = {
  __typename: "ModelHistoryValidationConnection",
  items:  Array<HistoryValidation | null >,
  nextToken?: string | null,
};

export type ModelFieldTemplateFilterInput = {
  id?: ModelIDInput | null,
  version?: ModelIntInput | null,
  templateType?: ModelFieldTemplateTypeInput | null,
  specialty?: ModelSpecialtyTypeInput | null,
  doctorId?: ModelIDInput | null,
  latestMarker?: ModelStringInput | null,
  medicalHistoryFieldIDs?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  lastUpdatedBy?: ModelIDInput | null,
  changeDescription?: ModelStringInput | null,
  and?: Array< ModelFieldTemplateFilterInput | null > | null,
  or?: Array< ModelFieldTemplateFilterInput | null > | null,
  not?: ModelFieldTemplateFilterInput | null,
};

export type ModelFieldTemplateConnection = {
  __typename: "ModelFieldTemplateConnection",
  items:  Array<FieldTemplate | null >,
  nextToken?: string | null,
};

export type ModelPhysicalEvalTemplateFilterInput = {
  id?: ModelIDInput | null,
  version?: ModelIntInput | null,
  templateType?: ModelPhysicalEvalTemplateTypeInput | null,
  specialtyCategoryId?: ModelIDInput | null,
  doctorId?: ModelIDInput | null,
  latestMarker?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  lastUpdatedBy?: ModelIDInput | null,
  changeDescription?: ModelStringInput | null,
  and?: Array< ModelPhysicalEvalTemplateFilterInput | null > | null,
  or?: Array< ModelPhysicalEvalTemplateFilterInput | null > | null,
  not?: ModelPhysicalEvalTemplateFilterInput | null,
};

export type ModelPhysicalEvalTemplateConnection = {
  __typename: "ModelPhysicalEvalTemplateConnection",
  items:  Array<PhysicalEvalTemplate | null >,
  nextToken?: string | null,
};

export type ModelZendeskTicketFilterInput = {
  id?: ModelIDInput | null,
  ticketID?: ModelIntInput | null,
  appointmentRecordID?: ModelIDInput | null,
  recipientParty?: ModelInquiringPartyInput | null,
  isPrimary?: ModelBooleanInput | null,
  isTextTicket?: ModelBooleanInput | null,
  claimNumber?: ModelStringInput | null,
  version?: ModelStringInput | null,
  lastSyncedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelZendeskTicketFilterInput | null > | null,
  or?: Array< ModelZendeskTicketFilterInput | null > | null,
  not?: ModelZendeskTicketFilterInput | null,
};

export type ModelZendeskTicketConnection = {
  __typename: "ModelZendeskTicketConnection",
  items:  Array<ZendeskTicket | null >,
  nextToken?: string | null,
};

export type ModelScheduledCommunicationFilterInput = {
  id?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  communicationType?: ModelCommunicationTypeInput | null,
  targetParty?: ModelInquiringPartyInput | null,
  scheduledDate?: ModelStringInput | null,
  status?: ModelCommunicationStatusInput | null,
  templateParams?: ModelStringInput | null,
  sentAt?: ModelStringInput | null,
  zendeskTicketID?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelScheduledCommunicationFilterInput | null > | null,
  or?: Array< ModelScheduledCommunicationFilterInput | null > | null,
  not?: ModelScheduledCommunicationFilterInput | null,
};

export type ModelScheduledCommunicationConnection = {
  __typename: "ModelScheduledCommunicationConnection",
  items:  Array<ScheduledCommunication | null >,
  nextToken?: string | null,
};

export type MedicalRecordPageImageTags = {
  __typename: "MedicalRecordPageImageTags",
  documentID: string,
  pageNumber: number,
  createdAt?: string | null,
  updatedAt?: string | null,
  isHandWritten?: boolean | null,
  lowQualityPage?: boolean | null,
};

export type ModelMedicalRecordPageImageTagsFilterInput = {
  documentID?: ModelIDInput | null,
  pageNumber?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  isHandWritten?: ModelBooleanInput | null,
  lowQualityPage?: ModelBooleanInput | null,
  id?: ModelIDInput | null,
  and?: Array< ModelMedicalRecordPageImageTagsFilterInput | null > | null,
  or?: Array< ModelMedicalRecordPageImageTagsFilterInput | null > | null,
  not?: ModelMedicalRecordPageImageTagsFilterInput | null,
};

export type ModelMedicalRecordPageImageTagsConnection = {
  __typename: "ModelMedicalRecordPageImageTagsConnection",
  items:  Array<MedicalRecordPageImageTags | null >,
  nextToken?: string | null,
};

export type MedicalRecordSegmentRawTextTags = {
  __typename: "MedicalRecordSegmentRawTextTags",
  documentID: string,
  startPageNumber: number,
  endPageNumber: number,
  createdAt?: string | null,
  updatedAt?: string | null,
  isWrongPatient?: boolean | null,
  wrongPatientReasoning?: string | null,
  extractedPatientName?: string | null,
  extractedPatientDob?: string | null,
  extractedPatientSex?: Sex | null,
  wrongPatientPossibility?: WrongPatientPossibility | null,
  doctorName?: string | null,
  doctorNameDetails?: Array< string | null > | null,
  xrayDetails?: string | null,
  mriDetails?: string | null,
  emgDetails?: string | null,
  ctDetails?: string | null,
};

export enum WrongPatientPossibility {
  NONE = "NONE",
  LOW = "LOW",
  MID = "MID",
  HIGH = "HIGH",
}


export type ModelMedicalRecordSegmentRawTextTagsFilterInput = {
  documentID?: ModelIDInput | null,
  startPageNumber?: ModelIntInput | null,
  endPageNumber?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  isWrongPatient?: ModelBooleanInput | null,
  wrongPatientReasoning?: ModelStringInput | null,
  extractedPatientName?: ModelStringInput | null,
  extractedPatientDob?: ModelStringInput | null,
  extractedPatientSex?: ModelSexInput | null,
  wrongPatientPossibility?: ModelWrongPatientPossibilityInput | null,
  doctorName?: ModelStringInput | null,
  doctorNameDetails?: ModelStringInput | null,
  xrayDetails?: ModelStringInput | null,
  mriDetails?: ModelStringInput | null,
  emgDetails?: ModelStringInput | null,
  ctDetails?: ModelStringInput | null,
  id?: ModelIDInput | null,
  and?: Array< ModelMedicalRecordSegmentRawTextTagsFilterInput | null > | null,
  or?: Array< ModelMedicalRecordSegmentRawTextTagsFilterInput | null > | null,
  not?: ModelMedicalRecordSegmentRawTextTagsFilterInput | null,
};

export type ModelWrongPatientPossibilityInput = {
  eq?: WrongPatientPossibility | null,
  ne?: WrongPatientPossibility | null,
};

export type ModelMedicalRecordSegmentRawTextTagsConnection = {
  __typename: "ModelMedicalRecordSegmentRawTextTagsConnection",
  items:  Array<MedicalRecordSegmentRawTextTags | null >,
  nextToken?: string | null,
};

export type ModelAppointmentEventFilterInput = {
  id?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  entity?: ModelStringInput | null,
  entityID?: ModelIDInput | null,
  action?: ModelStringInput | null,
  actorType?: ModelUserGroupInput | null,
  actorID?: ModelIDInput | null,
  timestamp?: ModelStringInput | null,
  properties?: ModelStringInput | null,
  source?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAppointmentEventFilterInput | null > | null,
  or?: Array< ModelAppointmentEventFilterInput | null > | null,
  not?: ModelAppointmentEventFilterInput | null,
};

export type ModelAppointmentEventConnection = {
  __typename: "ModelAppointmentEventConnection",
  items:  Array<AppointmentEvent | null >,
  nextToken?: string | null,
};

export type ModelIDKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelAppointmentNotificationFilterInput = {
  id?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  entityType?: ModelStringInput | null,
  entityID?: ModelIDInput | null,
  notificationType?: ModelStringInput | null,
  channel?: ModelNotificationChannelInput | null,
  recipientType?: ModelUserGroupInput | null,
  recipientID?: ModelIDInput | null,
  recipientName?: ModelStringInput | null,
  title?: ModelStringInput | null,
  body?: ModelStringInput | null,
  status?: ModelStringInput | null,
  readAt?: ModelStringInput | null,
  ttl?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAppointmentNotificationFilterInput | null > | null,
  or?: Array< ModelAppointmentNotificationFilterInput | null > | null,
  not?: ModelAppointmentNotificationFilterInput | null,
};

export type ModelAppointmentNotificationConnection = {
  __typename: "ModelAppointmentNotificationConnection",
  items:  Array<AppointmentNotification | null >,
  nextToken?: string | null,
};

export type ModelEmailNotificationQueueFilterInput = {
  id?: ModelIDInput | null,
  appointmentRecordID?: ModelIDInput | null,
  notificationType?: ModelStringInput | null,
  recipientID?: ModelIDInput | null,
  status?: ModelEmailNotificationStatusInput | null,
  emailDeliveryID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEmailNotificationQueueFilterInput | null > | null,
  or?: Array< ModelEmailNotificationQueueFilterInput | null > | null,
  not?: ModelEmailNotificationQueueFilterInput | null,
};

export type ModelEmailNotificationQueueConnection = {
  __typename: "ModelEmailNotificationQueueConnection",
  items:  Array<EmailNotificationQueue | null >,
  nextToken?: string | null,
};

export type ModelEmailDeliveryFilterInput = {
  id?: ModelIDInput | null,
  emailType?: ModelStringInput | null,
  recipientID?: ModelIDInput | null,
  recipientEmail?: ModelStringInput | null,
  subject?: ModelStringInput | null,
  body?: ModelStringInput | null,
  htmlBody?: ModelStringInput | null,
  status?: ModelEmailDeliveryStatusInput | null,
  sentAt?: ModelStringInput | null,
  failureReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEmailDeliveryFilterInput | null > | null,
  or?: Array< ModelEmailDeliveryFilterInput | null > | null,
  not?: ModelEmailDeliveryFilterInput | null,
};

export type ModelEmailDeliveryConnection = {
  __typename: "ModelEmailDeliveryConnection",
  items:  Array<EmailDelivery | null >,
  nextToken?: string | null,
};

export type ModelChatbotMessageFilterInput = {
  userId?: ModelIDInput | null,
  conversationIdTimestamp?: ModelStringInput | null,
  messageId?: ModelStringInput | null,
  conversationId?: ModelStringInput | null,
  role?: ModelChatbotMessageRoleInput | null,
  content?: ModelStringInput | null,
  suggestedUserPrompt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  llmInput?: ModelStringInput | null,
  inputTokens?: ModelIntInput | null,
  outputTokens?: ModelIntInput | null,
  reasoningTokens?: ModelIntInput | null,
  cachedTokens?: ModelIntInput | null,
  totalTokens?: ModelIntInput | null,
  toolsCalled?: ModelStringInput | null,
  toolsSucceeded?: ModelStringInput | null,
  toolsFailed?: ModelStringInput | null,
  ttftMs?: ModelFloatInput | null,
  total_latency_ms?: ModelFloatInput | null,
  userPaused?: ModelBooleanInput | null,
  agentTurns?: ModelIntInput | null,
  dataBlocks?: ModelStringInput | null,
  id?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelChatbotMessageFilterInput | null > | null,
  or?: Array< ModelChatbotMessageFilterInput | null > | null,
  not?: ModelChatbotMessageFilterInput | null,
};

export type ModelChatbotMessageConnection = {
  __typename: "ModelChatbotMessageConnection",
  items:  Array<ChatbotMessage | null >,
  nextToken?: string | null,
};

export type ModelChatbotConversationFilterInput = {
  userId?: ModelIDInput | null,
  conversationId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  name?: ModelStringInput | null,
  archived?: ModelBooleanInput | null,
  pausedStreaming?: ModelBooleanInput | null,
  modelConversationId?: ModelStringInput | null,
  claudeSessionId?: ModelStringInput | null,
  routineId?: ModelStringInput | null,
  routineRunId?: ModelStringInput | null,
  id?: ModelIDInput | null,
  and?: Array< ModelChatbotConversationFilterInput | null > | null,
  or?: Array< ModelChatbotConversationFilterInput | null > | null,
  not?: ModelChatbotConversationFilterInput | null,
};

export type ModelChatbotConversationConnection = {
  __typename: "ModelChatbotConversationConnection",
  items:  Array<ChatbotConversation | null >,
  nextToken?: string | null,
};

export type ModelChatbotMonitoringFilterInput = {
  userId?: ModelIDInput | null,
  totalTokens?: ModelIntInput | null,
  lastWeekTokens?: ModelIntInput | null,
  totalConversations?: ModelIntInput | null,
  totalToolsCalled?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelChatbotMonitoringFilterInput | null > | null,
  or?: Array< ModelChatbotMonitoringFilterInput | null > | null,
  not?: ModelChatbotMonitoringFilterInput | null,
};

export type ModelChatbotMonitoringConnection = {
  __typename: "ModelChatbotMonitoringConnection",
  items:  Array<ChatbotMonitoring | null >,
  nextToken?: string | null,
};

export type SlackAgentInvocation = {
  __typename: "SlackAgentInvocation",
  slackUserEmail: string,
  timestamp: string,
  channel: string,
  threadTs?: string | null,
  eventId?: string | null,
  slackUserId?: string | null,
  slackUserName?: string | null,
  userMessage: string,
  assistantResponse?: string | null,
  inputTokens?: number | null,
  outputTokens?: number | null,
  reasoningTokens?: number | null,
  cachedTokens?: number | null,
  totalTokens?: number | null,
  toolsCalled?: Array< string | null > | null,
  toolsSucceeded?: Array< string | null > | null,
  toolsFailed?: Array< string | null > | null,
  ttftMs?: number | null,
  totalLatencyMs?: number | null,
  agentTurns?: number | null,
  status?: string | null,
  errorMessage?: string | null,
  ttl?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelSlackAgentInvocationFilterInput = {
  slackUserEmail?: ModelStringInput | null,
  timestamp?: ModelStringInput | null,
  channel?: ModelStringInput | null,
  threadTs?: ModelStringInput | null,
  eventId?: ModelStringInput | null,
  slackUserId?: ModelStringInput | null,
  slackUserName?: ModelStringInput | null,
  userMessage?: ModelStringInput | null,
  assistantResponse?: ModelStringInput | null,
  inputTokens?: ModelIntInput | null,
  outputTokens?: ModelIntInput | null,
  reasoningTokens?: ModelIntInput | null,
  cachedTokens?: ModelIntInput | null,
  totalTokens?: ModelIntInput | null,
  toolsCalled?: ModelStringInput | null,
  toolsSucceeded?: ModelStringInput | null,
  toolsFailed?: ModelStringInput | null,
  ttftMs?: ModelFloatInput | null,
  totalLatencyMs?: ModelFloatInput | null,
  agentTurns?: ModelIntInput | null,
  status?: ModelStringInput | null,
  errorMessage?: ModelStringInput | null,
  ttl?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSlackAgentInvocationFilterInput | null > | null,
  or?: Array< ModelSlackAgentInvocationFilterInput | null > | null,
  not?: ModelSlackAgentInvocationFilterInput | null,
};

export type ModelSlackAgentInvocationConnection = {
  __typename: "ModelSlackAgentInvocationConnection",
  items:  Array<SlackAgentInvocation | null >,
  nextToken?: string | null,
};

export type ModelPromptExecutionFilterInput = {
  id?: ModelIDInput | null,
  promptId?: ModelStringInput | null,
  reasoningSummary?: ModelStringInput | null,
  executedAt?: ModelStringInput | null,
  appointmentID?: ModelIDInput | null,
  entityType?: ModelStringInput | null,
  entityId?: ModelStringInput | null,
  promptHash?: ModelStringInput | null,
  apiHash?: ModelStringInput | null,
  modelName?: ModelStringInput | null,
  modelConfig?: ModelStringInput | null,
  correlationID?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPromptExecutionFilterInput | null > | null,
  or?: Array< ModelPromptExecutionFilterInput | null > | null,
  not?: ModelPromptExecutionFilterInput | null,
};

export type ModelPromptExecutionConnection = {
  __typename: "ModelPromptExecutionConnection",
  items:  Array<PromptExecution | null >,
  nextToken?: string | null,
};

export type ModelAppointmentEntityCorrelationFilterInput = {
  id?: ModelIDInput | null,
  appointmentID?: ModelIDInput | null,
  entityType?: ModelStringInput | null,
  entityID?: ModelIDInput | null,
  properties?: ModelStringInput | null,
  correlationID?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAppointmentEntityCorrelationFilterInput | null > | null,
  or?: Array< ModelAppointmentEntityCorrelationFilterInput | null > | null,
  not?: ModelAppointmentEntityCorrelationFilterInput | null,
};

export type ModelAppointmentEntityCorrelationConnection = {
  __typename: "ModelAppointmentEntityCorrelationConnection",
  items:  Array<AppointmentEntityCorrelation | null >,
  nextToken?: string | null,
};

export type ModelPromptFeedbackFilterInput = {
  id?: ModelIDInput | null,
  promptId?: ModelStringInput | null,
  promptExecutionId?: ModelIDInput | null,
  feedback?: ModelStringInput | null,
  feedbackSource?: ModelPromptFeedbackSourceInput | null,
  actorType?: ModelUserGroupInput | null,
  actorID?: ModelIDInput | null,
  status?: ModelFeedbackStatusInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPromptFeedbackFilterInput | null > | null,
  or?: Array< ModelPromptFeedbackFilterInput | null > | null,
  not?: ModelPromptFeedbackFilterInput | null,
};

export type ModelPromptFeedbackConnection = {
  __typename: "ModelPromptFeedbackConnection",
  items:  Array<PromptFeedback | null >,
  nextToken?: string | null,
};

export type ModelPromptOfflineEvalCaseFilterInput = {
  id?: ModelIDInput | null,
  promptId?: ModelStringInput | null,
  sourcePromptExecutionId?: ModelIDInput | null,
  apiHash?: ModelStringInput | null,
  description?: ModelStringInput | null,
  verified?: ModelBooleanInput | null,
  tags?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPromptOfflineEvalCaseFilterInput | null > | null,
  or?: Array< ModelPromptOfflineEvalCaseFilterInput | null > | null,
  not?: ModelPromptOfflineEvalCaseFilterInput | null,
};

export type ModelPromptOfflineEvalCaseConnection = {
  __typename: "ModelPromptOfflineEvalCaseConnection",
  items:  Array<PromptOfflineEvalCase | null >,
  nextToken?: string | null,
};

export type PromptExecutionCounter = {
  __typename: "PromptExecutionCounter",
  id: string,
  execCount: number,
  imageCount: number,
  totalBytes: number,
  ttl: number,
  createdAt: string,
  updatedAt: string,
};

export type ModelPromptExecutionCounterFilterInput = {
  id?: ModelIDInput | null,
  execCount?: ModelIntInput | null,
  imageCount?: ModelIntInput | null,
  totalBytes?: ModelIntInput | null,
  ttl?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPromptExecutionCounterFilterInput | null > | null,
  or?: Array< ModelPromptExecutionCounterFilterInput | null > | null,
  not?: ModelPromptExecutionCounterFilterInput | null,
};

export type ModelPromptExecutionCounterConnection = {
  __typename: "ModelPromptExecutionCounterConnection",
  items:  Array<PromptExecutionCounter | null >,
  nextToken?: string | null,
};

export type ModelSkillFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  body?: ModelStringInput | null,
  scope?: ModelSkillScopeInput | null,
  ownerUserId?: ModelStringInput | null,
  roles?: ModelUserGroupListInput | null,
  visibility?: ModelSkillVisibilityInput | null,
  version?: ModelIntInput | null,
  archivedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSkillFilterInput | null > | null,
  or?: Array< ModelSkillFilterInput | null > | null,
  not?: ModelSkillFilterInput | null,
};

export type ModelSkillConnection = {
  __typename: "ModelSkillConnection",
  items:  Array<Skill | null >,
  nextToken?: string | null,
};

export type ModelRoutineFilterInput = {
  id?: ModelIDInput | null,
  scope?: ModelRoutineScopeInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  promptBody?: ModelStringInput | null,
  model?: ModelStringInput | null,
  reasoningEffort?: ModelStringInput | null,
  enableWebSearch?: ModelBooleanInput | null,
  maxAgentTurns?: ModelIntInput | null,
  conversationMode?: ModelRoutineConversationModeInput | null,
  timezone?: ModelStringInput | null,
  enabled?: ModelBooleanInput | null,
  notifyOwner?: ModelRoutineNotifyInput | null,
  slackChannel?: ModelStringInput | null,
  ownerUserId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdVia?: ModelRoutineOriginInput | null,
  version?: ModelIntInput | null,
  archivedAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRoutineFilterInput | null > | null,
  or?: Array< ModelRoutineFilterInput | null > | null,
  not?: ModelRoutineFilterInput | null,
};

export type ModelRoutineConnection = {
  __typename: "ModelRoutineConnection",
  items:  Array<Routine | null >,
  nextToken?: string | null,
};

export type ModelRoutineStateFilterInput = {
  id?: ModelIDInput | null,
  scope?: ModelRoutineScopeInput | null,
  ownerUserId?: ModelStringInput | null,
  definitionVersion?: ModelIntInput | null,
  schedulePartition?: ModelStringInput | null,
  nextRunAt?: ModelStringInput | null,
  currentConversationId?: ModelStringInput | null,
  activeRunId?: ModelStringInput | null,
  lastRunId?: ModelStringInput | null,
  consecutiveFailures?: ModelIntInput | null,
  endedReason?: ModelRoutineEndedReasonInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRoutineStateFilterInput | null > | null,
  or?: Array< ModelRoutineStateFilterInput | null > | null,
  not?: ModelRoutineStateFilterInput | null,
};

export type ModelRoutineStateConnection = {
  __typename: "ModelRoutineStateConnection",
  items:  Array<RoutineState | null >,
  nextToken?: string | null,
};

export type ModelRoutineRunFilterInput = {
  id?: ModelIDInput | null,
  scope?: ModelRoutineScopeInput | null,
  routineId?: ModelIDInput | null,
  routineVersion?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  definitionSnapshot?: ModelStringInput | null,
  status?: ModelRoutineRunStatusInput | null,
  trigger?: ModelRoutineTriggerInput | null,
  triggeredByUserId?: ModelStringInput | null,
  extraContext?: ModelStringInput | null,
  scheduledFor?: ModelStringInput | null,
  startedAt?: ModelStringInput | null,
  finishedAt?: ModelStringInput | null,
  durationMs?: ModelIntInput | null,
  processingStage?: ModelStringInput | null,
  nextProcessingAt?: ModelStringInput | null,
  dispatchAttempts?: ModelIntInput | null,
  lastDispatchedAt?: ModelStringInput | null,
  executionToken?: ModelStringInput | null,
  executionDeadlineAt?: ModelStringInput | null,
  conversationOwnerUserId?: ModelStringInput | null,
  conversationId?: ModelStringInput | null,
  previousConversationId?: ModelStringInput | null,
  userMessageId?: ModelStringInput | null,
  assistantMessageId?: ModelStringInput | null,
  outcome?: ModelRoutineOutcomeInput | null,
  headline?: ModelStringInput | null,
  summary?: ModelStringInput | null,
  totalTokens?: ModelIntInput | null,
  agentTurns?: ModelIntInput | null,
  toolsCalled?: ModelStringInput | null,
  toolsFailed?: ModelStringInput | null,
  correlationId?: ModelStringInput | null,
  errorMessage?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRoutineRunFilterInput | null > | null,
  or?: Array< ModelRoutineRunFilterInput | null > | null,
  not?: ModelRoutineRunFilterInput | null,
};

export type ModelRoutineRunConnection = {
  __typename: "ModelRoutineRunConnection",
  items:  Array<RoutineRun | null >,
  nextToken?: string | null,
};

export type ModelDoctorSupportingMAFilterInput = {
  id?: ModelIDInput | null,
  medicalAssistantId?: ModelIDInput | null,
  doctorId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDoctorSupportingMAFilterInput | null > | null,
  or?: Array< ModelDoctorSupportingMAFilterInput | null > | null,
  not?: ModelDoctorSupportingMAFilterInput | null,
  ownerCognitoId?: ModelStringInput | null,
};

export type ModelMedicalAssistantSpecialtyCategoryFilterInput = {
  id?: ModelIDInput | null,
  medicalAssistantId?: ModelIDInput | null,
  specialtyCategoryId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMedicalAssistantSpecialtyCategoryFilterInput | null > | null,
  or?: Array< ModelMedicalAssistantSpecialtyCategoryFilterInput | null > | null,
  not?: ModelMedicalAssistantSpecialtyCategoryFilterInput | null,
};

export type ModelUserAppointmentFilterPresetFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  appointmentFilterPresetId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserAppointmentFilterPresetFilterInput | null > | null,
  or?: Array< ModelUserAppointmentFilterPresetFilterInput | null > | null,
  not?: ModelUserAppointmentFilterPresetFilterInput | null,
};

export type ModelAppointmentRecordPatientCaseFilterInput = {
  id?: ModelIDInput | null,
  appointmentRecordId?: ModelIDInput | null,
  patientCaseId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAppointmentRecordPatientCaseFilterInput | null > | null,
  or?: Array< ModelAppointmentRecordPatientCaseFilterInput | null > | null,
  not?: ModelAppointmentRecordPatientCaseFilterInput | null,
  doctorOwnerCognitoId?: ModelStringInput | null,
  assistantCognitoIds?: ModelStringInput | null,
};

export type ModelDoctorLocationFilterInput = {
  id?: ModelIDInput | null,
  doctorId?: ModelIDInput | null,
  locationId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDoctorLocationFilterInput | null > | null,
  or?: Array< ModelDoctorLocationFilterInput | null > | null,
  not?: ModelDoctorLocationFilterInput | null,
  ownerCognitoId?: ModelStringInput | null,
};

export type ModelDoctorCaseSummaryFieldFilterInput = {
  id?: ModelIDInput | null,
  doctorId?: ModelIDInput | null,
  caseSummaryFieldId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDoctorCaseSummaryFieldFilterInput | null > | null,
  or?: Array< ModelDoctorCaseSummaryFieldFilterInput | null > | null,
  not?: ModelDoctorCaseSummaryFieldFilterInput | null,
  ownerCognitoId?: ModelStringInput | null,
};

export type ModelDoctorBriefingFieldFilterInput = {
  id?: ModelIDInput | null,
  doctorId?: ModelIDInput | null,
  briefingFieldId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDoctorBriefingFieldFilterInput | null > | null,
  or?: Array< ModelDoctorBriefingFieldFilterInput | null > | null,
  not?: ModelDoctorBriefingFieldFilterInput | null,
  ownerCognitoId?: ModelStringInput | null,
};

export type ModelSubscriptionAppointmentFileReferenceFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  appointmentID?: ModelSubscriptionIDInput | null,
  uploadedFileID?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAppointmentFileReferenceFilterInput | null > | null,
  or?: Array< ModelSubscriptionAppointmentFileReferenceFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionUploadedFileFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  key?: ModelSubscriptionStringInput | null,
  fileName?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  provider?: ModelSubscriptionStringInput | null,
  uploadedBy?: ModelSubscriptionStringInput | null,
  uploadedAt?: ModelSubscriptionStringInput | null,
  fileSizeBytes?: ModelSubscriptionFloatInput | null,
  fileSetID?: ModelSubscriptionIDInput | null,
  sourceAppointmentID?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUploadedFileFilterInput | null > | null,
  or?: Array< ModelSubscriptionUploadedFileFilterInput | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionDocumentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  uploadedFileID?: ModelSubscriptionIDInput | null,
  providerTag?: ModelSubscriptionStringInput | null,
  pageCount?: ModelSubscriptionIntInput | null,
  executionArn?: ModelSubscriptionStringInput | null,
  recordBriefingId?: ModelSubscriptionIDInput | null,
  segmentSplits?: ModelSubscriptionIntInput | null,
  hasUnresolvedSplits?: ModelSubscriptionBooleanInput | null,
  videoDurationSeconds?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDocumentFilterInput | null > | null,
  or?: Array< ModelSubscriptionDocumentFilterInput | null > | null,
  documentMrrValidationId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionOperationStatusFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  scope?: ModelSubscriptionStringInput | null,
  operation?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  startedAt?: ModelSubscriptionStringInput | null,
  heartbeatAt?: ModelSubscriptionStringInput | null,
  endedAt?: ModelSubscriptionStringInput | null,
  attempt?: ModelSubscriptionIntInput | null,
  errorMessage?: ModelSubscriptionStringInput | null,
  correlationId?: ModelSubscriptionStringInput | null,
  metadata?: ModelSubscriptionStringInput | null,
  expiresAt?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionOperationStatusFilterInput | null > | null,
  or?: Array< ModelSubscriptionOperationStatusFilterInput | null > | null,
};

export type ModelSubscriptionDocumentPageFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  documentID?: ModelSubscriptionIDInput | null,
  pageNumber?: ModelSubscriptionIntInput | null,
  imageS3Key?: ModelSubscriptionStringInput | null,
  text?: ModelSubscriptionStringInput | null,
  isBlank?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDocumentPageFilterInput | null > | null,
  or?: Array< ModelSubscriptionDocumentPageFilterInput | null > | null,
};

export type ModelSubscriptionNotesFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  content?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  timeStamp?: ModelSubscriptionIntInput | null,
  appointmentrecordID?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionNotesFilterInput | null > | null,
  or?: Array< ModelSubscriptionNotesFilterInput | null > | null,
  notesAuthorId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionHuddleNoteFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  appointmentRecordID?: ModelSubscriptionIDInput | null,
  contentMarkdown?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionHuddleNoteFilterInput | null > | null,
  or?: Array< ModelSubscriptionHuddleNoteFilterInput | null > | null,
};

export type ModelSubscriptionUserFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  cognitoUserId?: ModelSubscriptionIDInput | null,
  avatarUrl?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
  userDoctorId?: ModelSubscriptionIDInput | null,
  userAssistantId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionCaseRecordFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  state?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCaseRecordFilterInput | null > | null,
  or?: Array< ModelSubscriptionCaseRecordFilterInput | null > | null,
};

export type ModelSubscriptionAppointmentRecordFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  globalPartitionKey?: ModelSubscriptionStringInput | null,
  originalAppointmentID?: ModelSubscriptionIDInput | null,
  supplementalAppointmentIDs?: ModelSubscriptionIDInput | null,
  supplementalSourceAppointmentIDs?: ModelSubscriptionIDInput | null,
  depositionAppointmentIDs?: ModelSubscriptionIDInput | null,
  depositionSourceAppointmentIDs?: ModelSubscriptionIDInput | null,
  rescheduledFromAppointmentID?: ModelSubscriptionIDInput | null,
  rescheduledToAppointmentID?: ModelSubscriptionIDInput | null,
  date?: ModelSubscriptionStringInput | null,
  yearMonth?: ModelSubscriptionStringInput | null,
  doctorYearMonth?: ModelSubscriptionStringInput | null,
  time?: ModelSubscriptionStringInput | null,
  bookedInFlexibleTime?: ModelSubscriptionBooleanInput | null,
  inquiryDate?: ModelSubscriptionStringInput | null,
  inquiryYearMonth?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  doctorID?: ModelSubscriptionIDInput | null,
  locationID?: ModelSubscriptionIDInput | null,
  visitForm?: ModelSubscriptionStringInput | null,
  active?: ModelSubscriptionBooleanInput | null,
  durationMinutes?: ModelSubscriptionIntInput | null,
  reportDue?: ModelSubscriptionStringInput | null,
  reportSubmitted?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  reportStatus?: ModelSubscriptionStringInput | null,
  paymentStatus?: ModelSubscriptionStringInput | null,
  billingStatus?: ModelSubscriptionStringInput | null,
  difficultyLevel?: ModelSubscriptionIntInput | null,
  patientDescribedInjuries?: ModelSubscriptionStringInput | null,
  uploadedFilesSetID?: ModelSubscriptionIDInput | null,
  referredBy?: ModelSubscriptionStringInput | null,
  s3FileKey?: ModelSubscriptionStringInput | null,
  medicalRecordsReceived?: ModelSubscriptionBooleanInput | null,
  medicalRecordsBriefingFileID?: ModelSubscriptionStringInput | null,
  medicalRecordsBriefingExecutionArn?: ModelSubscriptionStringInput | null,
  medicalRecordsTotalPagesProcessed?: ModelSubscriptionIntInput | null,
  reportGenerationFileID?: ModelSubscriptionStringInput | null,
  reportGenerationExecutionArn?: ModelSubscriptionStringInput | null,
  reportGenerationGeneratedAt?: ModelSubscriptionStringInput | null,
  historyOfInjuryFileID?: ModelSubscriptionStringInput | null,
  historyOfInjuryGeneratedAt?: ModelSubscriptionStringInput | null,
  evaluationFileID?: ModelSubscriptionStringInput | null,
  assessmentFileID?: ModelSubscriptionStringInput | null,
  depositionPreparationFileID?: ModelSubscriptionStringInput | null,
  cancellationReason?: ModelSubscriptionStringInput | null,
  cancellationRequestedBy?: ModelSubscriptionStringInput | null,
  cancellationRequestedInternally?: ModelSubscriptionBooleanInput | null,
  cancellationNote?: ModelSubscriptionStringInput | null,
  cancellationDate?: ModelSubscriptionStringInput | null,
  inquiryClosingReason?: ModelSubscriptionStringInput | null,
  inquiryClosingNote?: ModelSubscriptionStringInput | null,
  inquiryClosingDate?: ModelSubscriptionStringInput | null,
  noShowReason?: ModelSubscriptionStringInput | null,
  noShowNote?: ModelSubscriptionStringInput | null,
  reschedulingReason?: ModelSubscriptionStringInput | null,
  reschedulingOthersReason?: ModelSubscriptionStringInput | null,
  reschedulingRequestedBy?: ModelSubscriptionStringInput | null,
  reschedulingRequestedInternally?: ModelSubscriptionBooleanInput | null,
  reschedulingNote?: ModelSubscriptionStringInput | null,
  reschedulingDate?: ModelSubscriptionStringInput | null,
  historyCallDate?: ModelSubscriptionStringInput | null,
  historyCallTime?: ModelSubscriptionStringInput | null,
  historyCallCompleted?: ModelSubscriptionBooleanInput | null,
  historyCallCompletedWithoutRecords?: ModelSubscriptionBooleanInput | null,
  historyCallCompletedOnSite?: ModelSubscriptionBooleanInput | null,
  historyCallNoShow?: ModelSubscriptionBooleanInput | null,
  historyCallCalendarEventID?: ModelSubscriptionIDInput | null,
  historyCallCalendarLink?: ModelSubscriptionStringInput | null,
  isProd?: ModelSubscriptionBooleanInput | null,
  isDemo?: ModelSubscriptionBooleanInput | null,
  primaryPatientCaseID?: ModelSubscriptionIDInput | null,
  calendarEventID?: ModelSubscriptionIDInput | null,
  defenseAttorneyPagesDeclaration?: ModelSubscriptionIntInput | null,
  applicantAttorneyPagesDeclaration?: ModelSubscriptionIntInput | null,
  tempUploadedIntakeFormS3Keys?: ModelSubscriptionStringInput | null,
  panelUnavailable?: ModelSubscriptionBooleanInput | null,
  panelSpecialty?: ModelSubscriptionStringInput | null,
  defenseAttorneyNotPresent?: ModelSubscriptionBooleanInput | null,
  applicantAttorneyNotPresent?: ModelSubscriptionBooleanInput | null,
  videoCallLink?: ModelSubscriptionStringInput | null,
  caseID?: ModelSubscriptionIDInput | null,
  briefingModelVersion?: ModelSubscriptionStringInput | null,
  briefingGdocExportLink?: ModelSubscriptionStringInput | null,
  briefingGdocExportedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAppointmentRecordFilterInput | null > | null,
  or?: Array< ModelSubscriptionAppointmentRecordFilterInput | null > | null,
  appointmentRecordMedicalAssistantId?: ModelSubscriptionIDInput | null,
  appointmentRecordSchedulingAssistantId?: ModelSubscriptionIDInput | null,
  appointmentRecordOnSiteOpId?: ModelSubscriptionIDInput | null,
  appointmentRecordReportOpId?: ModelSubscriptionIDInput | null,
  appointmentRecordBillingOpId?: ModelSubscriptionIDInput | null,
  appointmentRecordPreVisitReviewerId?: ModelSubscriptionIDInput | null,
  appointmentRecordHuddleNoteId?: ModelSubscriptionIDInput | null,
  appointmentRecordHistoryOfInjuryNotesId?: ModelSubscriptionIDInput | null,
  appointmentRecordCurrentComplaintNotesId?: ModelSubscriptionIDInput | null,
  appointmentRecordHistoryCallAssistantId?: ModelSubscriptionIDInput | null,
  appointmentRecordHistoryOfInjuryInsightsId?: ModelSubscriptionIDInput | null,
  appointmentRecordReviewOfMedicalRecordsInsightsId?: ModelSubscriptionIDInput | null,
  appointmentRecordPhysicalExamInsightsId?: ModelSubscriptionIDInput | null,
  appointmentRecordPastInjuryMatrixId?: ModelSubscriptionIDInput | null,
  appointmentRecordBriefingId?: ModelSubscriptionIDInput | null,
  appointmentRecordIntroParagraphId?: ModelSubscriptionIDInput | null,
  appointmentRecordAssessmentId?: ModelSubscriptionIDInput | null,
  appointmentRecordAssessmentValidationId?: ModelSubscriptionIDInput | null,
  appointmentRecordOpinionRecapId?: ModelSubscriptionIDInput | null,
  appointmentRecordHistoryValidationId?: ModelSubscriptionIDInput | null,
  appointmentRecordPatientHistoryValidationId?: ModelSubscriptionIDInput | null,
  appointmentRecordMrrValidationId?: ModelSubscriptionIDInput | null,
  appointmentRecordHistoryMrrCrossValidationId?: ModelSubscriptionIDInput | null,
  doctorOwnerCognitoId?: ModelStringInput | null,
  assistantCognitoIds?: ModelStringInput | null,
};

export type ModelSubscriptionPatientCaseFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  patientID?: ModelSubscriptionIDInput | null,
  claimNumber?: ModelSubscriptionStringInput | null,
  qmePanelNumber?: ModelSubscriptionStringInput | null,
  insuranceCarrierID?: ModelSubscriptionIDInput | null,
  insuranceCarrierAddressID?: ModelSubscriptionIDInput | null,
  insuranceCarrierFaxNumberID?: ModelSubscriptionIDInput | null,
  insuranceCarrierPhoneNumberID?: ModelSubscriptionIDInput | null,
  applicantAttorneyLawFirmID?: ModelSubscriptionIDInput | null,
  applicantAttorneyAddressID?: ModelSubscriptionIDInput | null,
  applicantAttorneyFaxNumberID?: ModelSubscriptionIDInput | null,
  applicantAttorneyPhoneNumberID?: ModelSubscriptionIDInput | null,
  defenseAttorneyLawFirmID?: ModelSubscriptionIDInput | null,
  defenseAttorneyAddressID?: ModelSubscriptionIDInput | null,
  defenseAttorneyFaxNumberID?: ModelSubscriptionIDInput | null,
  defenseAttorneyPhoneNumberID?: ModelSubscriptionIDInput | null,
  applicantAttorneyCcEmails?: ModelSubscriptionStringInput | null,
  defenseAttorneyCcEmails?: ModelSubscriptionStringInput | null,
  adjusterCcEmails?: ModelSubscriptionStringInput | null,
  scheduledCommsSuppressedParties?: ModelSubscriptionStringInput | null,
  WCAB?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPatientCaseFilterInput | null > | null,
  or?: Array< ModelSubscriptionPatientCaseFilterInput | null > | null,
};

export type ModelSubscriptionDoctorFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  middleName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  signatureName?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  ramped?: ModelSubscriptionBooleanInput | null,
  title?: ModelSubscriptionStringInput | null,
  titleExtension?: ModelSubscriptionStringInput | null,
  officePhone?: ModelSubscriptionStringInput | null,
  cellPhone?: ModelSubscriptionStringInput | null,
  clinicPhone?: ModelSubscriptionStringInput | null,
  workCity?: ModelSubscriptionStringInput | null,
  workState?: ModelSubscriptionStringInput | null,
  collectionRate?: ModelSubscriptionFloatInput | null,
  licenseNumber?: ModelSubscriptionStringInput | null,
  licenseRenewalDate?: ModelSubscriptionStringInput | null,
  specialties?: ModelSubscriptionStringInput | null,
  npi?: ModelSubscriptionStringInput | null,
  availabilitiesNote?: ModelSubscriptionStringInput | null,
  emails?: ModelSubscriptionStringInput | null,
  signatureDepartment?: ModelSubscriptionStringInput | null,
  profileAssetS3Prefix?: ModelSubscriptionStringInput | null,
  preferredAssessmentMode?: ModelSubscriptionStringInput | null,
  isDemo?: ModelSubscriptionBooleanInput | null,
  fieldTemplateId?: ModelSubscriptionIDInput | null,
  templateFolderLink?: ModelSubscriptionStringInput | null,
  assessmentTreatmentOptions?: ModelSubscriptionStringInput | null,
  dismissedProTips?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDoctorFilterInput | null > | null,
  or?: Array< ModelSubscriptionDoctorFilterInput | null > | null,
  doctorPhysicianPartnerId?: ModelSubscriptionIDInput | null,
  doctorDefaultPrimaryOnsiteOpsId?: ModelSubscriptionIDInput | null,
  doctorDefaultSecondaryOnsiteOpsId?: ModelSubscriptionIDInput | null,
  doctorDefaultSchedulerId?: ModelSubscriptionIDInput | null,
  doctorDefaultReportOpsId?: ModelSubscriptionIDInput | null,
  doctorDefaultPreVisitReviewerId?: ModelSubscriptionIDInput | null,
  doctorDefaultBillingOpsId?: ModelSubscriptionIDInput | null,
  doctorDefaultSupplementalReportOpsId?: ModelSubscriptionIDInput | null,
  doctorUserId?: ModelSubscriptionIDInput | null,
  ownerCognitoId?: ModelStringInput | null,
};

export type ModelSubscriptionLocationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  abbreviation?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  region?: ModelSubscriptionStringInput | null,
  indigoOfficePhoneNumber?: ModelSubscriptionStringInput | null,
  isWaitingArea?: ModelSubscriptionBooleanInput | null,
  additionalRoomsNumber?: ModelSubscriptionIntInput | null,
  calendarCcEmails?: ModelSubscriptionStringInput | null,
  isParkingFree?: ModelSubscriptionBooleanInput | null,
  parkingRate?: ModelSubscriptionFloatInput | null,
  isFrontDoorLocked?: ModelSubscriptionBooleanInput | null,
  frontDoorCode?: ModelSubscriptionStringInput | null,
  backDoor?: ModelSubscriptionStringInput | null,
  backDoorCode?: ModelSubscriptionStringInput | null,
  securityUnlockingProcess?: ModelSubscriptionStringInput | null,
  securityLockingProcess?: ModelSubscriptionStringInput | null,
  maleBathroomCode?: ModelSubscriptionStringInput | null,
  femaleBathroomCode?: ModelSubscriptionStringInput | null,
  wifiName?: ModelSubscriptionStringInput | null,
  wifiPassword?: ModelSubscriptionStringInput | null,
  locationInstructionsForVisitor?: ModelSubscriptionStringInput | null,
  additionalNote?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLocationFilterInput | null > | null,
  or?: Array< ModelSubscriptionLocationFilterInput | null > | null,
  locationDefaultOnsiteOpsId?: ModelSubscriptionIDInput | null,
  locationSecondaryOnsiteOpsId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionWorkflowExecutionFilterInput = {
  executionArn?: ModelSubscriptionIDInput | null,
  appointmentRecordID?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  errorMessage?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionWorkflowExecutionFilterInput | null > | null,
  or?: Array< ModelSubscriptionWorkflowExecutionFilterInput | null > | null,
};

export type ModelSubscriptionHistoryOfInjuryInsightsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  appointmentRecordID?: ModelSubscriptionIDInput | null,
  mechanismOfInjury?: ModelSubscriptionStringInput | null,
  employerJobDescription?: ModelSubscriptionStringInput | null,
  injuryEmploymentStatus?: ModelSubscriptionStringInput | null,
  currentWorkRestrictionsFromPatient?: ModelSubscriptionStringInput | null,
  activitiesOfDailyLiving?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionHistoryOfInjuryInsightsFilterInput | null > | null,
  or?: Array< ModelSubscriptionHistoryOfInjuryInsightsFilterInput | null > | null,
};

export type ModelSubscriptionReviewOfMedicalRecordsInsightsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  appointmentRecordID?: ModelSubscriptionIDInput | null,
  currentWorkRestrictionsFromMedicalRecords?: ModelSubscriptionStringInput | null,
  derivedFromDocumentInsightIDs?: ModelSubscriptionIDInput | null,
  derivedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionReviewOfMedicalRecordsInsightsFilterInput | null > | null,
  or?: Array< ModelSubscriptionReviewOfMedicalRecordsInsightsFilterInput | null > | null,
};

export type ModelSubscriptionDocumentBriefingInsightsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  documentID?: ModelSubscriptionIDInput | null,
  appointmentRecordID?: ModelSubscriptionIDInput | null,
  currentWorkRestrictionsFromMedicalRecords?: ModelSubscriptionStringInput | null,
  sourceRecordBriefingID?: ModelSubscriptionIDInput | null,
  generatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDocumentBriefingInsightsFilterInput | null > | null,
  or?: Array< ModelSubscriptionDocumentBriefingInsightsFilterInput | null > | null,
};

export type ModelSubscriptionPhysicalExamInsightsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  appointmentRecordID?: ModelSubscriptionIDInput | null,
  physicalExaminationInfo?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPhysicalExamInsightsFilterInput | null > | null,
  or?: Array< ModelSubscriptionPhysicalExamInsightsFilterInput | null > | null,
};

export type ModelSubscriptionAppointmentFilterPresetFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  appliesTo?: ModelSubscriptionStringInput | null,
  view?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAppointmentFilterPresetFilterInput | null > | null,
  or?: Array< ModelSubscriptionAppointmentFilterPresetFilterInput | null > | null,
};

export type ModelSubscriptionRecordBriefingSegmentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  logicalSegmentID?: ModelSubscriptionIDInput | null,
  title?: ModelSubscriptionStringInput | null,
  text?: ModelSubscriptionStringInput | null,
  bodyParts?: ModelSubscriptionStringInput | null,
  injuredBodyParts?: ModelSubscriptionStringInput | null,
  editedBy?: ModelSubscriptionIDInput | null,
  pdfFileName?: ModelSubscriptionStringInput | null,
  sourceTag?: ModelSubscriptionStringInput | null,
  segmentNumber?: ModelSubscriptionIntInput | null,
  sourcePdfS3Key?: ModelSubscriptionStringInput | null,
  startPageNumber?: ModelSubscriptionIntInput | null,
  endPageNumber?: ModelSubscriptionIntInput | null,
  recordType?: ModelSubscriptionStringInput | null,
  extractedDate?: ModelSubscriptionStringInput | null,
  doctorName?: ModelSubscriptionStringInput | null,
  processingModel?: ModelSubscriptionStringInput | null,
  classificationConfidence?: ModelSubscriptionFloatInput | null,
  hasDate?: ModelSubscriptionBooleanInput | null,
  potentialDuplicateID?: ModelSubscriptionIDInput | null,
  needsReview?: ModelSubscriptionBooleanInput | null,
  status?: ModelSubscriptionStringInput | null,
  documentID?: ModelSubscriptionIDInput | null,
  videoStartTime?: ModelSubscriptionStringInput | null,
  videoEndTime?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRecordBriefingSegmentFilterInput | null > | null,
  or?: Array< ModelSubscriptionRecordBriefingSegmentFilterInput | null > | null,
};

export type ModelSubscriptionRecordBriefingSegmentMappingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  briefingID?: ModelSubscriptionIDInput | null,
  logicalSegmentID?: ModelSubscriptionIDInput | null,
  publishedSegmentID?: ModelSubscriptionIDInput | null,
  draftSegmentID?: ModelSubscriptionIDInput | null,
  markedForDeletion?: ModelSubscriptionBooleanInput | null,
  markedForCreation?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRecordBriefingSegmentMappingFilterInput | null > | null,
  or?: Array< ModelSubscriptionRecordBriefingSegmentMappingFilterInput | null > | null,
};

export type ModelSubscriptionRecordBriefingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  logicalBriefingID?: ModelSubscriptionIDInput | null,
  generatedAt?: ModelSubscriptionStringInput | null,
  lastEditedAt?: ModelSubscriptionStringInput | null,
  lastEditedBy?: ModelSubscriptionIDInput | null,
  googleDocExportLink?: ModelSubscriptionStringInput | null,
  googleDocExportedAt?: ModelSubscriptionStringInput | null,
  editingPresence?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRecordBriefingFilterInput | null > | null,
  or?: Array< ModelSubscriptionRecordBriefingFilterInput | null > | null,
};

export type ModelSubscriptionSummaryCitationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  briefingID?: ModelSubscriptionIDInput | null,
  logicalSegmentID?: ModelSubscriptionIDInput | null,
  summaryText?: ModelSubscriptionStringInput | null,
  citationID?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  removedBy?: ModelSubscriptionIDInput | null,
  removedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSummaryCitationFilterInput | null > | null,
  or?: Array< ModelSubscriptionSummaryCitationFilterInput | null > | null,
};

export type ModelSubscriptionCoverLetterRecapFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  uploadedFileID?: ModelSubscriptionIDInput | null,
  recapText?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  errorMessage?: ModelSubscriptionStringInput | null,
  generatedAt?: ModelSubscriptionStringInput | null,
  lastEditedAt?: ModelSubscriptionStringInput | null,
  lastEditedBy?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCoverLetterRecapFilterInput | null > | null,
  or?: Array< ModelSubscriptionCoverLetterRecapFilterInput | null > | null,
};

export type ModelSubscriptionIntroParagraphFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  appointmentRecordID?: ModelSubscriptionIDInput | null,
  introParagraphText?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  errorMessage?: ModelSubscriptionStringInput | null,
  generatedAt?: ModelSubscriptionStringInput | null,
  lastEditedAt?: ModelSubscriptionStringInput | null,
  lastEditedBy?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionIntroParagraphFilterInput | null > | null,
  or?: Array< ModelSubscriptionIntroParagraphFilterInput | null > | null,
};

export type ModelSubscriptionIntroductionStatementFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  appointmentRecordID?: ModelSubscriptionIDInput | null,
  kind?: ModelSubscriptionStringInput | null,
  text?: ModelSubscriptionStringInput | null,
  lastEditedAt?: ModelSubscriptionStringInput | null,
  lastEditedBy?: ModelSubscriptionIDInput | null,
  selectedCoverLetterFileID?: ModelSubscriptionIDInput | null,
  selectionConfirmedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionIntroductionStatementFilterInput | null > | null,
  or?: Array< ModelSubscriptionIntroductionStatementFilterInput | null > | null,
};

export type ModelSubscriptionAssessmentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  discussedBodyParts?: ModelSubscriptionStringInput | null,
  bodyPartsNotDiscussedReason?: ModelSubscriptionStringInput | null,
  discussions?: ModelSubscriptionStringInput | null,
  workStatus?: ModelSubscriptionStringInput | null,
  markedAsDone?: ModelSubscriptionBooleanInput | null,
  discussDiagnosesFreeForm?: ModelSubscriptionBooleanInput | null,
  diagnosesFreeform?: ModelSubscriptionStringInput | null,
  discussCausationFreeForm?: ModelSubscriptionBooleanInput | null,
  causationFreeForm?: ModelSubscriptionStringInput | null,
  discussMMIImpairmentRatingApportionmentFreeForm?: ModelSubscriptionBooleanInput | null,
  hasPatientReachedMMIFreeForm?: ModelSubscriptionStringInput | null,
  discussMMIByBodyPartFreeForm?: ModelSubscriptionStringInput | null,
  impairmentRatingByBodyPartFreeForm?: ModelSubscriptionStringInput | null,
  apportionmentByBodyPartFreeForm?: ModelSubscriptionStringInput | null,
  impairmentRatingOtherComments?: ModelSubscriptionStringInput | null,
  apportionmentOtherComments?: ModelSubscriptionStringInput | null,
  assessmentMode?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAssessmentFilterInput | null > | null,
  or?: Array< ModelSubscriptionAssessmentFilterInput | null > | null,
};

export type ModelSubscriptionValidationCheckFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  validationID?: ModelSubscriptionIDInput | null,
  checkType?: ModelSubscriptionStringInput | null,
  inputResourceURIs?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionValidationCheckFilterInput | null > | null,
  or?: Array< ModelSubscriptionValidationCheckFilterInput | null > | null,
};

export type ModelSubscriptionValidationIssueFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  validationID?: ModelSubscriptionIDInput | null,
  validationCheckID?: ModelSubscriptionIDInput | null,
  title?: ModelSubscriptionStringInput | null,
  issue?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  resourceURI?: ModelSubscriptionStringInput | null,
  issueGroup?: ModelSubscriptionStringInput | null,
  issueType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionValidationIssueFilterInput | null > | null,
  or?: Array< ModelSubscriptionValidationIssueFilterInput | null > | null,
};

export type ModelSubscriptionWorkflowAuditEntryFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  workflowAuditID?: ModelSubscriptionIDInput | null,
  message?: ModelSubscriptionStringInput | null,
  actorType?: ModelSubscriptionStringInput | null,
  actorID?: ModelSubscriptionIDInput | null,
  entryType?: ModelSubscriptionStringInput | null,
  relatedActionIDs?: ModelSubscriptionIDInput | null,
  payload?: ModelSubscriptionStringInput | null,
  correlationID?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionWorkflowAuditEntryFilterInput | null > | null,
  or?: Array< ModelSubscriptionWorkflowAuditEntryFilterInput | null > | null,
};

export type ModelSubscriptionHistoryValidationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  appointmentRecordID?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  validatedAt?: ModelSubscriptionStringInput | null,
  errorMessage?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionHistoryValidationFilterInput | null > | null,
  or?: Array< ModelSubscriptionHistoryValidationFilterInput | null > | null,
};

export type ModelSubscriptionZendeskTicketFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  ticketID?: ModelSubscriptionIntInput | null,
  appointmentRecordID?: ModelSubscriptionIDInput | null,
  recipientParty?: ModelSubscriptionStringInput | null,
  isPrimary?: ModelSubscriptionBooleanInput | null,
  isTextTicket?: ModelSubscriptionBooleanInput | null,
  claimNumber?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionStringInput | null,
  lastSyncedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionZendeskTicketFilterInput | null > | null,
  or?: Array< ModelSubscriptionZendeskTicketFilterInput | null > | null,
};

export type ModelSubscriptionAppointmentNotificationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  appointmentRecordID?: ModelSubscriptionIDInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  entityID?: ModelSubscriptionIDInput | null,
  notificationType?: ModelSubscriptionStringInput | null,
  channel?: ModelSubscriptionStringInput | null,
  recipientType?: ModelSubscriptionStringInput | null,
  recipientID?: ModelSubscriptionIDInput | null,
  recipientName?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  body?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  readAt?: ModelSubscriptionStringInput | null,
  ttl?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAppointmentNotificationFilterInput | null > | null,
  or?: Array< ModelSubscriptionAppointmentNotificationFilterInput | null > | null,
};

export type ModelSubscriptionSkillFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  body?: ModelSubscriptionStringInput | null,
  scope?: ModelSubscriptionStringInput | null,
  ownerUserId?: ModelSubscriptionStringInput | null,
  roles?: ModelSubscriptionStringInput | null,
  visibility?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionIntInput | null,
  archivedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSkillFilterInput | null > | null,
  or?: Array< ModelSubscriptionSkillFilterInput | null > | null,
};

export type ModelSubscriptionRoutineFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  scope?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  promptBody?: ModelSubscriptionStringInput | null,
  model?: ModelSubscriptionStringInput | null,
  reasoningEffort?: ModelSubscriptionStringInput | null,
  enableWebSearch?: ModelSubscriptionBooleanInput | null,
  maxAgentTurns?: ModelSubscriptionIntInput | null,
  conversationMode?: ModelSubscriptionStringInput | null,
  timezone?: ModelSubscriptionStringInput | null,
  enabled?: ModelSubscriptionBooleanInput | null,
  notifyOwner?: ModelSubscriptionStringInput | null,
  slackChannel?: ModelSubscriptionStringInput | null,
  ownerUserId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdVia?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionIntInput | null,
  archivedAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRoutineFilterInput | null > | null,
  or?: Array< ModelSubscriptionRoutineFilterInput | null > | null,
};

export type ModelSubscriptionRoutineStateFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  scope?: ModelSubscriptionStringInput | null,
  ownerUserId?: ModelSubscriptionStringInput | null,
  definitionVersion?: ModelSubscriptionIntInput | null,
  schedulePartition?: ModelSubscriptionStringInput | null,
  nextRunAt?: ModelSubscriptionStringInput | null,
  currentConversationId?: ModelSubscriptionStringInput | null,
  activeRunId?: ModelSubscriptionStringInput | null,
  lastRunId?: ModelSubscriptionStringInput | null,
  consecutiveFailures?: ModelSubscriptionIntInput | null,
  endedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRoutineStateFilterInput | null > | null,
  or?: Array< ModelSubscriptionRoutineStateFilterInput | null > | null,
};

export type ModelSubscriptionRoutineRunFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  scope?: ModelSubscriptionStringInput | null,
  routineId?: ModelSubscriptionIDInput | null,
  routineVersion?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  definitionSnapshot?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  trigger?: ModelSubscriptionStringInput | null,
  triggeredByUserId?: ModelSubscriptionStringInput | null,
  extraContext?: ModelSubscriptionStringInput | null,
  scheduledFor?: ModelSubscriptionStringInput | null,
  startedAt?: ModelSubscriptionStringInput | null,
  finishedAt?: ModelSubscriptionStringInput | null,
  durationMs?: ModelSubscriptionIntInput | null,
  processingStage?: ModelSubscriptionStringInput | null,
  nextProcessingAt?: ModelSubscriptionStringInput | null,
  dispatchAttempts?: ModelSubscriptionIntInput | null,
  lastDispatchedAt?: ModelSubscriptionStringInput | null,
  executionToken?: ModelSubscriptionStringInput | null,
  executionDeadlineAt?: ModelSubscriptionStringInput | null,
  conversationOwnerUserId?: ModelSubscriptionStringInput | null,
  conversationId?: ModelSubscriptionStringInput | null,
  previousConversationId?: ModelSubscriptionStringInput | null,
  userMessageId?: ModelSubscriptionStringInput | null,
  assistantMessageId?: ModelSubscriptionStringInput | null,
  outcome?: ModelSubscriptionStringInput | null,
  headline?: ModelSubscriptionStringInput | null,
  summary?: ModelSubscriptionStringInput | null,
  totalTokens?: ModelSubscriptionIntInput | null,
  agentTurns?: ModelSubscriptionIntInput | null,
  toolsCalled?: ModelSubscriptionStringInput | null,
  toolsFailed?: ModelSubscriptionStringInput | null,
  correlationId?: ModelSubscriptionStringInput | null,
  errorMessage?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRoutineRunFilterInput | null > | null,
  or?: Array< ModelSubscriptionRoutineRunFilterInput | null > | null,
};

export type ModelSubscriptionDoctorSupportingMAFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  medicalAssistantId?: ModelSubscriptionIDInput | null,
  doctorId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDoctorSupportingMAFilterInput | null > | null,
  or?: Array< ModelSubscriptionDoctorSupportingMAFilterInput | null > | null,
  ownerCognitoId?: ModelStringInput | null,
};

export type ModelSubscriptionMedicalAssistantSpecialtyCategoryFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  medicalAssistantId?: ModelSubscriptionIDInput | null,
  specialtyCategoryId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMedicalAssistantSpecialtyCategoryFilterInput | null > | null,
  or?: Array< ModelSubscriptionMedicalAssistantSpecialtyCategoryFilterInput | null > | null,
};

export type ModelSubscriptionUserAppointmentFilterPresetFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  appointmentFilterPresetId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserAppointmentFilterPresetFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserAppointmentFilterPresetFilterInput | null > | null,
};

export type ModelSubscriptionAppointmentRecordPatientCaseFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  appointmentRecordId?: ModelSubscriptionIDInput | null,
  patientCaseId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAppointmentRecordPatientCaseFilterInput | null > | null,
  or?: Array< ModelSubscriptionAppointmentRecordPatientCaseFilterInput | null > | null,
  doctorOwnerCognitoId?: ModelStringInput | null,
  assistantCognitoIds?: ModelStringInput | null,
};

export type ModelSubscriptionDoctorLocationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  doctorId?: ModelSubscriptionIDInput | null,
  locationId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDoctorLocationFilterInput | null > | null,
  or?: Array< ModelSubscriptionDoctorLocationFilterInput | null > | null,
  ownerCognitoId?: ModelStringInput | null,
};

export type ModelSubscriptionDoctorCaseSummaryFieldFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  doctorId?: ModelSubscriptionIDInput | null,
  caseSummaryFieldId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDoctorCaseSummaryFieldFilterInput | null > | null,
  or?: Array< ModelSubscriptionDoctorCaseSummaryFieldFilterInput | null > | null,
  ownerCognitoId?: ModelStringInput | null,
};

export type ModelSubscriptionDoctorBriefingFieldFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  doctorId?: ModelSubscriptionIDInput | null,
  briefingFieldId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDoctorBriefingFieldFilterInput | null > | null,
  or?: Array< ModelSubscriptionDoctorBriefingFieldFilterInput | null > | null,
  ownerCognitoId?: ModelStringInput | null,
};

export type SaveRecordBriefingMutationVariables = {
  recordBriefingId: string,
  appointmentId: string,
};

export type SaveRecordBriefingMutation = {
  saveRecordBriefing?:  {
    __typename: "SaveRecordBriefingResponse",
    success: boolean,
    recordBriefingId: string,
    publishedAt?: string | null,
    error?: string | null,
  } | null,
};

export type ResetRecordBriefingDraftsMutationVariables = {
  recordBriefingId: string,
};

export type ResetRecordBriefingDraftsMutation = {
  resetRecordBriefingDrafts?:  {
    __typename: "ResetRecordBriefingResponse",
    success: boolean,
    recordBriefingId: string,
    error?: string | null,
  } | null,
};

export type BatchUpdateRecordBriefingMappingsMutationVariables = {
  recordBriefingId: string,
  mappingIds: Array< string >,
  action: string,
};

export type BatchUpdateRecordBriefingMappingsMutation = {
  batchUpdateRecordBriefingMappings?:  {
    __typename: "BatchUpdateRecordBriefingMappingsResponse",
    success: boolean,
    error?: string | null,
    succeededIds: Array< string >,
    failedIds: Array< string >,
  } | null,
};

export type CreateAppointmentFileReferenceMutationVariables = {
  input: CreateAppointmentFileReferenceInput,
  condition?: ModelAppointmentFileReferenceConditionInput | null,
};

export type CreateAppointmentFileReferenceMutation = {
  createAppointmentFileReference?:  {
    __typename: "AppointmentFileReference",
    id: string,
    appointmentID: string,
    uploadedFileID: string,
    status?: AppointmentFileReferenceStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAppointmentFileReferenceMutationVariables = {
  input: UpdateAppointmentFileReferenceInput,
  condition?: ModelAppointmentFileReferenceConditionInput | null,
};

export type UpdateAppointmentFileReferenceMutation = {
  updateAppointmentFileReference?:  {
    __typename: "AppointmentFileReference",
    id: string,
    appointmentID: string,
    uploadedFileID: string,
    status?: AppointmentFileReferenceStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAppointmentFileReferenceMutationVariables = {
  input: DeleteAppointmentFileReferenceInput,
  condition?: ModelAppointmentFileReferenceConditionInput | null,
};

export type DeleteAppointmentFileReferenceMutation = {
  deleteAppointmentFileReference?:  {
    __typename: "AppointmentFileReference",
    id: string,
    appointmentID: string,
    uploadedFileID: string,
    status?: AppointmentFileReferenceStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUploadedFileMutationVariables = {
  input: CreateUploadedFileInput,
  condition?: ModelUploadedFileConditionInput | null,
};

export type CreateUploadedFileMutation = {
  createUploadedFile?:  {
    __typename: "UploadedFile",
    id: string,
    key?: string | null,
    fileName?: string | null,
    type?: FileType | null,
    provider?: FileProvider | null,
    uploadedBy?: string | null,
    uploadedAt?: string | null,
    fileSizeBytes?: number | null,
    fileSet?:  {
      __typename: "UploadedFileSet",
      id: string,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      uploadedFiles?:  {
        __typename: "ModelUploadedFileConnection",
        items:  Array< {
          __typename: "UploadedFile",
          id: string,
          key?: string | null,
          fileName?: string | null,
          type?: FileType | null,
          provider?: FileProvider | null,
          uploadedBy?: string | null,
          uploadedAt?: string | null,
          fileSizeBytes?: number | null,
          fileSetID?: string | null,
          sourceAppointmentID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fileSetID?: string | null,
    sourceAppointmentID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUploadedFileMutationVariables = {
  input: UpdateUploadedFileInput,
  condition?: ModelUploadedFileConditionInput | null,
};

export type UpdateUploadedFileMutation = {
  updateUploadedFile?:  {
    __typename: "UploadedFile",
    id: string,
    key?: string | null,
    fileName?: string | null,
    type?: FileType | null,
    provider?: FileProvider | null,
    uploadedBy?: string | null,
    uploadedAt?: string | null,
    fileSizeBytes?: number | null,
    fileSet?:  {
      __typename: "UploadedFileSet",
      id: string,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      uploadedFiles?:  {
        __typename: "ModelUploadedFileConnection",
        items:  Array< {
          __typename: "UploadedFile",
          id: string,
          key?: string | null,
          fileName?: string | null,
          type?: FileType | null,
          provider?: FileProvider | null,
          uploadedBy?: string | null,
          uploadedAt?: string | null,
          fileSizeBytes?: number | null,
          fileSetID?: string | null,
          sourceAppointmentID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fileSetID?: string | null,
    sourceAppointmentID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUploadedFileMutationVariables = {
  input: DeleteUploadedFileInput,
  condition?: ModelUploadedFileConditionInput | null,
};

export type DeleteUploadedFileMutation = {
  deleteUploadedFile?:  {
    __typename: "UploadedFile",
    id: string,
    key?: string | null,
    fileName?: string | null,
    type?: FileType | null,
    provider?: FileProvider | null,
    uploadedBy?: string | null,
    uploadedAt?: string | null,
    fileSizeBytes?: number | null,
    fileSet?:  {
      __typename: "UploadedFileSet",
      id: string,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      uploadedFiles?:  {
        __typename: "ModelUploadedFileConnection",
        items:  Array< {
          __typename: "UploadedFile",
          id: string,
          key?: string | null,
          fileName?: string | null,
          type?: FileType | null,
          provider?: FileProvider | null,
          uploadedBy?: string | null,
          uploadedAt?: string | null,
          fileSizeBytes?: number | null,
          fileSetID?: string | null,
          sourceAppointmentID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fileSetID?: string | null,
    sourceAppointmentID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDocumentMutationVariables = {
  input: CreateDocumentInput,
  condition?: ModelDocumentConditionInput | null,
};

export type CreateDocumentMutation = {
  createDocument?:  {
    __typename: "Document",
    id: string,
    uploadedFileID: string,
    providerTag?: string | null,
    pageCount: number,
    executionArn: string,
    recordBriefingId?: string | null,
    segmentSplits?: Array< number | null > | null,
    segmentIntervals?:  Array< {
      __typename: "SegmentInterval",
      startPageNumber: number,
      endPageNumber: number,
      startLineNumber?: number | null,
      endLineNumber?: number | null,
      confidence?: number | null,
      confidenceReasoning?: string | null,
      edited?: boolean | null,
      needsReSummary?: boolean | null,
    } | null > | null,
    segmentIntervalRows?:  {
      __typename: "ModelDocumentSegmentIntervalConnection",
      items:  Array< {
        __typename: "DocumentSegmentInterval",
        id: string,
        documentID: string,
        startPageNumber: number,
        endPageNumber: number,
        startLineNumber?: number | null,
        endLineNumber?: number | null,
        confidence?: number | null,
        confidenceReasoning?: string | null,
        edited?: boolean | null,
        needsReSummary?: boolean | null,
        archived?: boolean | null,
        parentIntervals?: Array< string > | null,
        lastEditAction?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    pages?:  {
      __typename: "ModelDocumentPageConnection",
      items:  Array< {
        __typename: "DocumentPage",
        id: string,
        documentID: string,
        pageNumber: number,
        imageS3Key?: string | null,
        text?: string | null,
        isBlank?: boolean | null,
        citations?:  {
          __typename: "ModelCitationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    preview?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    hasUnresolvedSplits?: boolean | null,
    videoDurationSeconds?: number | null,
    ingestionSteps?:  {
      __typename: "ModelDocumentIngestionStepConnection",
      items:  Array< {
        __typename: "DocumentIngestionStep",
        id: string,
        documentID: string,
        name: string,
        status: IngestionStepStatus,
        startedAt: string,
        endedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mrrValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    documentMrrValidationId?: string | null,
  } | null,
};

export type UpdateDocumentMutationVariables = {
  input: UpdateDocumentInput,
  condition?: ModelDocumentConditionInput | null,
};

export type UpdateDocumentMutation = {
  updateDocument?:  {
    __typename: "Document",
    id: string,
    uploadedFileID: string,
    providerTag?: string | null,
    pageCount: number,
    executionArn: string,
    recordBriefingId?: string | null,
    segmentSplits?: Array< number | null > | null,
    segmentIntervals?:  Array< {
      __typename: "SegmentInterval",
      startPageNumber: number,
      endPageNumber: number,
      startLineNumber?: number | null,
      endLineNumber?: number | null,
      confidence?: number | null,
      confidenceReasoning?: string | null,
      edited?: boolean | null,
      needsReSummary?: boolean | null,
    } | null > | null,
    segmentIntervalRows?:  {
      __typename: "ModelDocumentSegmentIntervalConnection",
      items:  Array< {
        __typename: "DocumentSegmentInterval",
        id: string,
        documentID: string,
        startPageNumber: number,
        endPageNumber: number,
        startLineNumber?: number | null,
        endLineNumber?: number | null,
        confidence?: number | null,
        confidenceReasoning?: string | null,
        edited?: boolean | null,
        needsReSummary?: boolean | null,
        archived?: boolean | null,
        parentIntervals?: Array< string > | null,
        lastEditAction?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    pages?:  {
      __typename: "ModelDocumentPageConnection",
      items:  Array< {
        __typename: "DocumentPage",
        id: string,
        documentID: string,
        pageNumber: number,
        imageS3Key?: string | null,
        text?: string | null,
        isBlank?: boolean | null,
        citations?:  {
          __typename: "ModelCitationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    preview?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    hasUnresolvedSplits?: boolean | null,
    videoDurationSeconds?: number | null,
    ingestionSteps?:  {
      __typename: "ModelDocumentIngestionStepConnection",
      items:  Array< {
        __typename: "DocumentIngestionStep",
        id: string,
        documentID: string,
        name: string,
        status: IngestionStepStatus,
        startedAt: string,
        endedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mrrValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    documentMrrValidationId?: string | null,
  } | null,
};

export type DeleteDocumentMutationVariables = {
  input: DeleteDocumentInput,
  condition?: ModelDocumentConditionInput | null,
};

export type DeleteDocumentMutation = {
  deleteDocument?:  {
    __typename: "Document",
    id: string,
    uploadedFileID: string,
    providerTag?: string | null,
    pageCount: number,
    executionArn: string,
    recordBriefingId?: string | null,
    segmentSplits?: Array< number | null > | null,
    segmentIntervals?:  Array< {
      __typename: "SegmentInterval",
      startPageNumber: number,
      endPageNumber: number,
      startLineNumber?: number | null,
      endLineNumber?: number | null,
      confidence?: number | null,
      confidenceReasoning?: string | null,
      edited?: boolean | null,
      needsReSummary?: boolean | null,
    } | null > | null,
    segmentIntervalRows?:  {
      __typename: "ModelDocumentSegmentIntervalConnection",
      items:  Array< {
        __typename: "DocumentSegmentInterval",
        id: string,
        documentID: string,
        startPageNumber: number,
        endPageNumber: number,
        startLineNumber?: number | null,
        endLineNumber?: number | null,
        confidence?: number | null,
        confidenceReasoning?: string | null,
        edited?: boolean | null,
        needsReSummary?: boolean | null,
        archived?: boolean | null,
        parentIntervals?: Array< string > | null,
        lastEditAction?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    pages?:  {
      __typename: "ModelDocumentPageConnection",
      items:  Array< {
        __typename: "DocumentPage",
        id: string,
        documentID: string,
        pageNumber: number,
        imageS3Key?: string | null,
        text?: string | null,
        isBlank?: boolean | null,
        citations?:  {
          __typename: "ModelCitationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    preview?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    hasUnresolvedSplits?: boolean | null,
    videoDurationSeconds?: number | null,
    ingestionSteps?:  {
      __typename: "ModelDocumentIngestionStepConnection",
      items:  Array< {
        __typename: "DocumentIngestionStep",
        id: string,
        documentID: string,
        name: string,
        status: IngestionStepStatus,
        startedAt: string,
        endedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mrrValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    documentMrrValidationId?: string | null,
  } | null,
};

export type CreateDocumentIngestionStepMutationVariables = {
  input: CreateDocumentIngestionStepInput,
  condition?: ModelDocumentIngestionStepConditionInput | null,
};

export type CreateDocumentIngestionStepMutation = {
  createDocumentIngestionStep?:  {
    __typename: "DocumentIngestionStep",
    id: string,
    documentID: string,
    name: string,
    status: IngestionStepStatus,
    startedAt: string,
    endedAt?: string | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateDocumentIngestionStepMutationVariables = {
  input: UpdateDocumentIngestionStepInput,
  condition?: ModelDocumentIngestionStepConditionInput | null,
};

export type UpdateDocumentIngestionStepMutation = {
  updateDocumentIngestionStep?:  {
    __typename: "DocumentIngestionStep",
    id: string,
    documentID: string,
    name: string,
    status: IngestionStepStatus,
    startedAt: string,
    endedAt?: string | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteDocumentIngestionStepMutationVariables = {
  input: DeleteDocumentIngestionStepInput,
  condition?: ModelDocumentIngestionStepConditionInput | null,
};

export type DeleteDocumentIngestionStepMutation = {
  deleteDocumentIngestionStep?:  {
    __typename: "DocumentIngestionStep",
    id: string,
    documentID: string,
    name: string,
    status: IngestionStepStatus,
    startedAt: string,
    endedAt?: string | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOperationStatusMutationVariables = {
  input: CreateOperationStatusInput,
  condition?: ModelOperationStatusConditionInput | null,
};

export type CreateOperationStatusMutation = {
  createOperationStatus?:  {
    __typename: "OperationStatus",
    id: string,
    scope: string,
    operation: string,
    name: string,
    status: OperationState,
    startedAt: string,
    heartbeatAt?: string | null,
    endedAt?: string | null,
    attempt?: number | null,
    errorMessage?: string | null,
    correlationId?: string | null,
    metadata?: string | null,
    expiresAt?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateOperationStatusMutationVariables = {
  input: UpdateOperationStatusInput,
  condition?: ModelOperationStatusConditionInput | null,
};

export type UpdateOperationStatusMutation = {
  updateOperationStatus?:  {
    __typename: "OperationStatus",
    id: string,
    scope: string,
    operation: string,
    name: string,
    status: OperationState,
    startedAt: string,
    heartbeatAt?: string | null,
    endedAt?: string | null,
    attempt?: number | null,
    errorMessage?: string | null,
    correlationId?: string | null,
    metadata?: string | null,
    expiresAt?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteOperationStatusMutationVariables = {
  input: DeleteOperationStatusInput,
  condition?: ModelOperationStatusConditionInput | null,
};

export type DeleteOperationStatusMutation = {
  deleteOperationStatus?:  {
    __typename: "OperationStatus",
    id: string,
    scope: string,
    operation: string,
    name: string,
    status: OperationState,
    startedAt: string,
    heartbeatAt?: string | null,
    endedAt?: string | null,
    attempt?: number | null,
    errorMessage?: string | null,
    correlationId?: string | null,
    metadata?: string | null,
    expiresAt?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDocumentPageMutationVariables = {
  input: CreateDocumentPageInput,
  condition?: ModelDocumentPageConditionInput | null,
};

export type CreateDocumentPageMutation = {
  createDocumentPage?:  {
    __typename: "DocumentPage",
    id: string,
    documentID: string,
    pageNumber: number,
    imageS3Key?: string | null,
    text?: string | null,
    isBlank?: boolean | null,
    citations?:  {
      __typename: "ModelCitationConnection",
      items:  Array< {
        __typename: "Citation",
        id: string,
        documentPageID: string,
        documentID: string,
        pageNumber: number,
        blockIndex: number,
        text: string,
        bbox:  {
          __typename: "BoundingBox",
          yMin: number,
          xMin: number,
          yMax: number,
          xMax: number,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateDocumentPageMutationVariables = {
  input: UpdateDocumentPageInput,
  condition?: ModelDocumentPageConditionInput | null,
};

export type UpdateDocumentPageMutation = {
  updateDocumentPage?:  {
    __typename: "DocumentPage",
    id: string,
    documentID: string,
    pageNumber: number,
    imageS3Key?: string | null,
    text?: string | null,
    isBlank?: boolean | null,
    citations?:  {
      __typename: "ModelCitationConnection",
      items:  Array< {
        __typename: "Citation",
        id: string,
        documentPageID: string,
        documentID: string,
        pageNumber: number,
        blockIndex: number,
        text: string,
        bbox:  {
          __typename: "BoundingBox",
          yMin: number,
          xMin: number,
          yMax: number,
          xMax: number,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteDocumentPageMutationVariables = {
  input: DeleteDocumentPageInput,
  condition?: ModelDocumentPageConditionInput | null,
};

export type DeleteDocumentPageMutation = {
  deleteDocumentPage?:  {
    __typename: "DocumentPage",
    id: string,
    documentID: string,
    pageNumber: number,
    imageS3Key?: string | null,
    text?: string | null,
    isBlank?: boolean | null,
    citations?:  {
      __typename: "ModelCitationConnection",
      items:  Array< {
        __typename: "Citation",
        id: string,
        documentPageID: string,
        documentID: string,
        pageNumber: number,
        blockIndex: number,
        text: string,
        bbox:  {
          __typename: "BoundingBox",
          yMin: number,
          xMin: number,
          yMax: number,
          xMax: number,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDocumentSegmentIntervalMutationVariables = {
  input: CreateDocumentSegmentIntervalInput,
  condition?: ModelDocumentSegmentIntervalConditionInput | null,
};

export type CreateDocumentSegmentIntervalMutation = {
  createDocumentSegmentInterval?:  {
    __typename: "DocumentSegmentInterval",
    id: string,
    documentID: string,
    startPageNumber: number,
    endPageNumber: number,
    startLineNumber?: number | null,
    endLineNumber?: number | null,
    confidence?: number | null,
    confidenceReasoning?: string | null,
    edited?: boolean | null,
    needsReSummary?: boolean | null,
    archived?: boolean | null,
    parentIntervals?: Array< string > | null,
    lastEditAction?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateDocumentSegmentIntervalMutationVariables = {
  input: UpdateDocumentSegmentIntervalInput,
  condition?: ModelDocumentSegmentIntervalConditionInput | null,
};

export type UpdateDocumentSegmentIntervalMutation = {
  updateDocumentSegmentInterval?:  {
    __typename: "DocumentSegmentInterval",
    id: string,
    documentID: string,
    startPageNumber: number,
    endPageNumber: number,
    startLineNumber?: number | null,
    endLineNumber?: number | null,
    confidence?: number | null,
    confidenceReasoning?: string | null,
    edited?: boolean | null,
    needsReSummary?: boolean | null,
    archived?: boolean | null,
    parentIntervals?: Array< string > | null,
    lastEditAction?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteDocumentSegmentIntervalMutationVariables = {
  input: DeleteDocumentSegmentIntervalInput,
  condition?: ModelDocumentSegmentIntervalConditionInput | null,
};

export type DeleteDocumentSegmentIntervalMutation = {
  deleteDocumentSegmentInterval?:  {
    __typename: "DocumentSegmentInterval",
    id: string,
    documentID: string,
    startPageNumber: number,
    endPageNumber: number,
    startLineNumber?: number | null,
    endLineNumber?: number | null,
    confidence?: number | null,
    confidenceReasoning?: string | null,
    edited?: boolean | null,
    needsReSummary?: boolean | null,
    archived?: boolean | null,
    parentIntervals?: Array< string > | null,
    lastEditAction?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAudioMutationVariables = {
  input: CreateAudioInput,
  condition?: ModelAudioConditionInput | null,
};

export type CreateAudioMutation = {
  createAudio?:  {
    __typename: "Audio",
    id: string,
    uploadedFileID: string,
    executionArn?: string | null,
    fileFormat: string,
    durationSeconds?: number | null,
    transcript?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    transcriptWordCount?: number | null,
    transcriptGrammarCorrected?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    transcriptGrammarCorrectedWordCount?: number | null,
    transcriptPreview?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    detectedLanguages?: Array< Language | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAudioMutationVariables = {
  input: UpdateAudioInput,
  condition?: ModelAudioConditionInput | null,
};

export type UpdateAudioMutation = {
  updateAudio?:  {
    __typename: "Audio",
    id: string,
    uploadedFileID: string,
    executionArn?: string | null,
    fileFormat: string,
    durationSeconds?: number | null,
    transcript?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    transcriptWordCount?: number | null,
    transcriptGrammarCorrected?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    transcriptGrammarCorrectedWordCount?: number | null,
    transcriptPreview?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    detectedLanguages?: Array< Language | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAudioMutationVariables = {
  input: DeleteAudioInput,
  condition?: ModelAudioConditionInput | null,
};

export type DeleteAudioMutation = {
  deleteAudio?:  {
    __typename: "Audio",
    id: string,
    uploadedFileID: string,
    executionArn?: string | null,
    fileFormat: string,
    durationSeconds?: number | null,
    transcript?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    transcriptWordCount?: number | null,
    transcriptGrammarCorrected?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    transcriptGrammarCorrectedWordCount?: number | null,
    transcriptPreview?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    detectedLanguages?: Array< Language | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateHistoryTranscriptMutationVariables = {
  input: CreateHistoryTranscriptInput,
  condition?: ModelHistoryTranscriptConditionInput | null,
};

export type CreateHistoryTranscriptMutation = {
  createHistoryTranscript?:  {
    __typename: "HistoryTranscript",
    id: string,
    uploadedFileID: string,
    callId?: string | null,
    recordingId?: string | null,
    callStartTime?: string | null,
    callDurationSeconds?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateHistoryTranscriptMutationVariables = {
  input: UpdateHistoryTranscriptInput,
  condition?: ModelHistoryTranscriptConditionInput | null,
};

export type UpdateHistoryTranscriptMutation = {
  updateHistoryTranscript?:  {
    __typename: "HistoryTranscript",
    id: string,
    uploadedFileID: string,
    callId?: string | null,
    recordingId?: string | null,
    callStartTime?: string | null,
    callDurationSeconds?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteHistoryTranscriptMutationVariables = {
  input: DeleteHistoryTranscriptInput,
  condition?: ModelHistoryTranscriptConditionInput | null,
};

export type DeleteHistoryTranscriptMutation = {
  deleteHistoryTranscript?:  {
    __typename: "HistoryTranscript",
    id: string,
    uploadedFileID: string,
    callId?: string | null,
    recordingId?: string | null,
    callStartTime?: string | null,
    callDurationSeconds?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePanelFileMutationVariables = {
  input: CreatePanelFileInput,
  condition?: ModelPanelFileConditionInput | null,
};

export type CreatePanelFileMutation = {
  createPanelFile?:  {
    __typename: "PanelFile",
    id: string,
    uploadedFileID: string,
    sourceAppointmentID?: string | null,
    correlationId?: string | null,
    panelNumber?: string | null,
    panelIssueDate?: string | null,
    numberOfRequests?: number | null,
    requestingParty?: ParticipantType | null,
    claim?:  {
      __typename: "PanelClaimInfo",
      claimNumber?: string | null,
      dateOfInjury?: string | null,
    } | null,
    patient?:  {
      __typename: "PanelPatientInfo",
      name?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    employer?:  {
      __typename: "PanelEmployerInfo",
      name?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    adjuster?:  {
      __typename: "PanelPartyInfo",
      name?: string | null,
      company?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    applicantAttorney?:  {
      __typename: "PanelPartyInfo",
      name?: string | null,
      company?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    defenseAttorney?:  {
      __typename: "PanelPartyInfo",
      name?: string | null,
      company?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    physicians?:  Array< {
      __typename: "PanelPhysician",
      name?: string | null,
      specialty?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
      yearsInPractice?: number | null,
      education?: string | null,
      phoneNumber?: string | null,
      isStruck?: boolean | null,
      strikeDate?: string | null,
      strikeParty?: ParticipantType | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePanelFileMutationVariables = {
  input: UpdatePanelFileInput,
  condition?: ModelPanelFileConditionInput | null,
};

export type UpdatePanelFileMutation = {
  updatePanelFile?:  {
    __typename: "PanelFile",
    id: string,
    uploadedFileID: string,
    sourceAppointmentID?: string | null,
    correlationId?: string | null,
    panelNumber?: string | null,
    panelIssueDate?: string | null,
    numberOfRequests?: number | null,
    requestingParty?: ParticipantType | null,
    claim?:  {
      __typename: "PanelClaimInfo",
      claimNumber?: string | null,
      dateOfInjury?: string | null,
    } | null,
    patient?:  {
      __typename: "PanelPatientInfo",
      name?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    employer?:  {
      __typename: "PanelEmployerInfo",
      name?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    adjuster?:  {
      __typename: "PanelPartyInfo",
      name?: string | null,
      company?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    applicantAttorney?:  {
      __typename: "PanelPartyInfo",
      name?: string | null,
      company?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    defenseAttorney?:  {
      __typename: "PanelPartyInfo",
      name?: string | null,
      company?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    physicians?:  Array< {
      __typename: "PanelPhysician",
      name?: string | null,
      specialty?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
      yearsInPractice?: number | null,
      education?: string | null,
      phoneNumber?: string | null,
      isStruck?: boolean | null,
      strikeDate?: string | null,
      strikeParty?: ParticipantType | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePanelFileMutationVariables = {
  input: DeletePanelFileInput,
  condition?: ModelPanelFileConditionInput | null,
};

export type DeletePanelFileMutation = {
  deletePanelFile?:  {
    __typename: "PanelFile",
    id: string,
    uploadedFileID: string,
    sourceAppointmentID?: string | null,
    correlationId?: string | null,
    panelNumber?: string | null,
    panelIssueDate?: string | null,
    numberOfRequests?: number | null,
    requestingParty?: ParticipantType | null,
    claim?:  {
      __typename: "PanelClaimInfo",
      claimNumber?: string | null,
      dateOfInjury?: string | null,
    } | null,
    patient?:  {
      __typename: "PanelPatientInfo",
      name?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    employer?:  {
      __typename: "PanelEmployerInfo",
      name?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    adjuster?:  {
      __typename: "PanelPartyInfo",
      name?: string | null,
      company?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    applicantAttorney?:  {
      __typename: "PanelPartyInfo",
      name?: string | null,
      company?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    defenseAttorney?:  {
      __typename: "PanelPartyInfo",
      name?: string | null,
      company?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    physicians?:  Array< {
      __typename: "PanelPhysician",
      name?: string | null,
      specialty?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
      yearsInPractice?: number | null,
      education?: string | null,
      phoneNumber?: string | null,
      isStruck?: boolean | null,
      strikeDate?: string | null,
      strikeParty?: ParticipantType | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateNotesMutationVariables = {
  input: CreateNotesInput,
  condition?: ModelNotesConditionInput | null,
};

export type CreateNotesMutation = {
  createNotes?:  {
    __typename: "Notes",
    id: string,
    content?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    type?: NotesType | null,
    timeStamp?: number | null,
    appointmentrecordID: string,
    createdAt: string,
    updatedAt: string,
    notesAuthorId?: string | null,
  } | null,
};

export type UpdateNotesMutationVariables = {
  input: UpdateNotesInput,
  condition?: ModelNotesConditionInput | null,
};

export type UpdateNotesMutation = {
  updateNotes?:  {
    __typename: "Notes",
    id: string,
    content?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    type?: NotesType | null,
    timeStamp?: number | null,
    appointmentrecordID: string,
    createdAt: string,
    updatedAt: string,
    notesAuthorId?: string | null,
  } | null,
};

export type DeleteNotesMutationVariables = {
  input: DeleteNotesInput,
  condition?: ModelNotesConditionInput | null,
};

export type DeleteNotesMutation = {
  deleteNotes?:  {
    __typename: "Notes",
    id: string,
    content?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    type?: NotesType | null,
    timeStamp?: number | null,
    appointmentrecordID: string,
    createdAt: string,
    updatedAt: string,
    notesAuthorId?: string | null,
  } | null,
};

export type CreateHuddleNoteMutationVariables = {
  input: CreateHuddleNoteInput,
  condition?: ModelHuddleNoteConditionInput | null,
};

export type CreateHuddleNoteMutation = {
  createHuddleNote?:  {
    __typename: "HuddleNote",
    id: string,
    appointmentRecordID: string,
    contentMarkdown?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateHuddleNoteMutationVariables = {
  input: UpdateHuddleNoteInput,
  condition?: ModelHuddleNoteConditionInput | null,
};

export type UpdateHuddleNoteMutation = {
  updateHuddleNote?:  {
    __typename: "HuddleNote",
    id: string,
    appointmentRecordID: string,
    contentMarkdown?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteHuddleNoteMutationVariables = {
  input: DeleteHuddleNoteInput,
  condition?: ModelHuddleNoteConditionInput | null,
};

export type DeleteHuddleNoteMutation = {
  deleteHuddleNote?:  {
    __typename: "HuddleNote",
    id: string,
    appointmentRecordID: string,
    contentMarkdown?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMedicalAssistantMutationVariables = {
  input: CreateMedicalAssistantInput,
  condition?: ModelMedicalAssistantConditionInput | null,
};

export type CreateMedicalAssistantMutation = {
  createMedicalAssistant?:  {
    __typename: "MedicalAssistant",
    id: string,
    name?: string | null,
    email?: string | null,
    preVisitCallScheduleLink?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    enableCalendarNotify?: boolean | null,
    inactive?: boolean | null,
    languages?: Array< Language > | null,
    assignmentCriteria?:  {
      __typename: "MedicalAssistantAppointmentAssignmentCriteria",
      languageWeights:  Array< {
        __typename: "LanguageWeight",
        language: Language,
        weight: number,
        doctorSpecialty?: SpecialtyType | null,
      } >,
    } | null,
    isDemo?: boolean | null,
    dismissedProTips?: Array< string | null > | null,
    phoneNumber?: string | null,
    joinedDate?: string | null,
    level?: number | null,
    capacityPercent?: number | null,
    supportedDoctors?:  {
      __typename: "ModelDoctorSupportingMAConnection",
      items:  Array< {
        __typename: "DoctorSupportingMA",
        id: string,
        medicalAssistantId: string,
        doctorId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    supportedSpecialtyCategories?:  {
      __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
      items:  Array< {
        __typename: "MedicalAssistantSpecialtyCategory",
        id: string,
        medicalAssistantId: string,
        specialtyCategoryId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        specialtyCategory:  {
          __typename: "SpecialtyCategory",
          id: string,
          name: string,
          specialties?: Array< SpecialtyType > | null,
          createdAt: string,
          updatedAt: string,
          specialtyCategoryFallbackMAId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    availabilityExceptions?:  Array< {
      __typename: "AvailabilityException",
      type: AvailabilityExceptionType,
      during?:  {
        __typename: "DateRange",
        start?: string | null,
        end?: string | null,
      } | null,
      startTime?: string | null,
      endTime?: string | null,
      allDay?: boolean | null,
    } | null > | null,
    roles?: Array< OpsRole > | null,
    createdAt: string,
    updatedAt: string,
    medicalAssistantUserId?: string | null,
  } | null,
};

export type UpdateMedicalAssistantMutationVariables = {
  input: UpdateMedicalAssistantInput,
  condition?: ModelMedicalAssistantConditionInput | null,
};

export type UpdateMedicalAssistantMutation = {
  updateMedicalAssistant?:  {
    __typename: "MedicalAssistant",
    id: string,
    name?: string | null,
    email?: string | null,
    preVisitCallScheduleLink?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    enableCalendarNotify?: boolean | null,
    inactive?: boolean | null,
    languages?: Array< Language > | null,
    assignmentCriteria?:  {
      __typename: "MedicalAssistantAppointmentAssignmentCriteria",
      languageWeights:  Array< {
        __typename: "LanguageWeight",
        language: Language,
        weight: number,
        doctorSpecialty?: SpecialtyType | null,
      } >,
    } | null,
    isDemo?: boolean | null,
    dismissedProTips?: Array< string | null > | null,
    phoneNumber?: string | null,
    joinedDate?: string | null,
    level?: number | null,
    capacityPercent?: number | null,
    supportedDoctors?:  {
      __typename: "ModelDoctorSupportingMAConnection",
      items:  Array< {
        __typename: "DoctorSupportingMA",
        id: string,
        medicalAssistantId: string,
        doctorId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    supportedSpecialtyCategories?:  {
      __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
      items:  Array< {
        __typename: "MedicalAssistantSpecialtyCategory",
        id: string,
        medicalAssistantId: string,
        specialtyCategoryId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        specialtyCategory:  {
          __typename: "SpecialtyCategory",
          id: string,
          name: string,
          specialties?: Array< SpecialtyType > | null,
          createdAt: string,
          updatedAt: string,
          specialtyCategoryFallbackMAId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    availabilityExceptions?:  Array< {
      __typename: "AvailabilityException",
      type: AvailabilityExceptionType,
      during?:  {
        __typename: "DateRange",
        start?: string | null,
        end?: string | null,
      } | null,
      startTime?: string | null,
      endTime?: string | null,
      allDay?: boolean | null,
    } | null > | null,
    roles?: Array< OpsRole > | null,
    createdAt: string,
    updatedAt: string,
    medicalAssistantUserId?: string | null,
  } | null,
};

export type DeleteMedicalAssistantMutationVariables = {
  input: DeleteMedicalAssistantInput,
  condition?: ModelMedicalAssistantConditionInput | null,
};

export type DeleteMedicalAssistantMutation = {
  deleteMedicalAssistant?:  {
    __typename: "MedicalAssistant",
    id: string,
    name?: string | null,
    email?: string | null,
    preVisitCallScheduleLink?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    enableCalendarNotify?: boolean | null,
    inactive?: boolean | null,
    languages?: Array< Language > | null,
    assignmentCriteria?:  {
      __typename: "MedicalAssistantAppointmentAssignmentCriteria",
      languageWeights:  Array< {
        __typename: "LanguageWeight",
        language: Language,
        weight: number,
        doctorSpecialty?: SpecialtyType | null,
      } >,
    } | null,
    isDemo?: boolean | null,
    dismissedProTips?: Array< string | null > | null,
    phoneNumber?: string | null,
    joinedDate?: string | null,
    level?: number | null,
    capacityPercent?: number | null,
    supportedDoctors?:  {
      __typename: "ModelDoctorSupportingMAConnection",
      items:  Array< {
        __typename: "DoctorSupportingMA",
        id: string,
        medicalAssistantId: string,
        doctorId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    supportedSpecialtyCategories?:  {
      __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
      items:  Array< {
        __typename: "MedicalAssistantSpecialtyCategory",
        id: string,
        medicalAssistantId: string,
        specialtyCategoryId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        specialtyCategory:  {
          __typename: "SpecialtyCategory",
          id: string,
          name: string,
          specialties?: Array< SpecialtyType > | null,
          createdAt: string,
          updatedAt: string,
          specialtyCategoryFallbackMAId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    availabilityExceptions?:  Array< {
      __typename: "AvailabilityException",
      type: AvailabilityExceptionType,
      during?:  {
        __typename: "DateRange",
        start?: string | null,
        end?: string | null,
      } | null,
      startTime?: string | null,
      endTime?: string | null,
      allDay?: boolean | null,
    } | null > | null,
    roles?: Array< OpsRole > | null,
    createdAt: string,
    updatedAt: string,
    medicalAssistantUserId?: string | null,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    cognitoUserId: string,
    avatarUrl?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    doctor?:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null,
    assistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    appointmentFilterPreset?:  {
      __typename: "ModelUserAppointmentFilterPresetConnection",
      items:  Array< {
        __typename: "UserAppointmentFilterPreset",
        id: string,
        userId: string,
        appointmentFilterPresetId: string,
        user:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        },
        appointmentFilterPreset:  {
          __typename: "AppointmentFilterPreset",
          id: string,
          name: string,
          appliesTo: UserGroup,
          view?: AppointmentsView | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    onboardingDismissals?:  Array< {
      __typename: "OnboardingDismissal",
      itemId: string,
      dismissedAt: string,
    } | null > | null,
    settings?:  {
      __typename: "UserSettings",
      opsChecklistDefaultExpanded?: boolean | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    userDoctorId?: string | null,
    userAssistantId?: string | null,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    cognitoUserId: string,
    avatarUrl?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    doctor?:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null,
    assistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    appointmentFilterPreset?:  {
      __typename: "ModelUserAppointmentFilterPresetConnection",
      items:  Array< {
        __typename: "UserAppointmentFilterPreset",
        id: string,
        userId: string,
        appointmentFilterPresetId: string,
        user:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        },
        appointmentFilterPreset:  {
          __typename: "AppointmentFilterPreset",
          id: string,
          name: string,
          appliesTo: UserGroup,
          view?: AppointmentsView | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    onboardingDismissals?:  Array< {
      __typename: "OnboardingDismissal",
      itemId: string,
      dismissedAt: string,
    } | null > | null,
    settings?:  {
      __typename: "UserSettings",
      opsChecklistDefaultExpanded?: boolean | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    userDoctorId?: string | null,
    userAssistantId?: string | null,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    cognitoUserId: string,
    avatarUrl?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    doctor?:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null,
    assistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    appointmentFilterPreset?:  {
      __typename: "ModelUserAppointmentFilterPresetConnection",
      items:  Array< {
        __typename: "UserAppointmentFilterPreset",
        id: string,
        userId: string,
        appointmentFilterPresetId: string,
        user:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        },
        appointmentFilterPreset:  {
          __typename: "AppointmentFilterPreset",
          id: string,
          name: string,
          appliesTo: UserGroup,
          view?: AppointmentsView | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    onboardingDismissals?:  Array< {
      __typename: "OnboardingDismissal",
      itemId: string,
      dismissedAt: string,
    } | null > | null,
    settings?:  {
      __typename: "UserSettings",
      opsChecklistDefaultExpanded?: boolean | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    userDoctorId?: string | null,
    userAssistantId?: string | null,
  } | null,
};

export type CreateStoredAddressMutationVariables = {
  input: CreateStoredAddressInput,
  condition?: ModelStoredAddressConditionInput | null,
};

export type CreateStoredAddressMutation = {
  createStoredAddress?:  {
    __typename: "StoredAddress",
    id: string,
    street?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: string | null,
    insuranceCarrierID?: string | null,
    lawFirmID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateStoredAddressMutationVariables = {
  input: UpdateStoredAddressInput,
  condition?: ModelStoredAddressConditionInput | null,
};

export type UpdateStoredAddressMutation = {
  updateStoredAddress?:  {
    __typename: "StoredAddress",
    id: string,
    street?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: string | null,
    insuranceCarrierID?: string | null,
    lawFirmID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteStoredAddressMutationVariables = {
  input: DeleteStoredAddressInput,
  condition?: ModelStoredAddressConditionInput | null,
};

export type DeleteStoredAddressMutation = {
  deleteStoredAddress?:  {
    __typename: "StoredAddress",
    id: string,
    street?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: string | null,
    insuranceCarrierID?: string | null,
    lawFirmID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateStoredFaxNumberMutationVariables = {
  input: CreateStoredFaxNumberInput,
  condition?: ModelStoredFaxNumberConditionInput | null,
};

export type CreateStoredFaxNumberMutation = {
  createStoredFaxNumber?:  {
    __typename: "StoredFaxNumber",
    id: string,
    faxNumber?: string | null,
    insuranceCarrierID?: string | null,
    lawFirmID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateStoredFaxNumberMutationVariables = {
  input: UpdateStoredFaxNumberInput,
  condition?: ModelStoredFaxNumberConditionInput | null,
};

export type UpdateStoredFaxNumberMutation = {
  updateStoredFaxNumber?:  {
    __typename: "StoredFaxNumber",
    id: string,
    faxNumber?: string | null,
    insuranceCarrierID?: string | null,
    lawFirmID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteStoredFaxNumberMutationVariables = {
  input: DeleteStoredFaxNumberInput,
  condition?: ModelStoredFaxNumberConditionInput | null,
};

export type DeleteStoredFaxNumberMutation = {
  deleteStoredFaxNumber?:  {
    __typename: "StoredFaxNumber",
    id: string,
    faxNumber?: string | null,
    insuranceCarrierID?: string | null,
    lawFirmID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateStoredPhoneNumberMutationVariables = {
  input: CreateStoredPhoneNumberInput,
  condition?: ModelStoredPhoneNumberConditionInput | null,
};

export type CreateStoredPhoneNumberMutation = {
  createStoredPhoneNumber?:  {
    __typename: "StoredPhoneNumber",
    id: string,
    phoneNumber?: string | null,
    extension?: string | null,
    insuranceCarrierID?: string | null,
    lawFirmID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateStoredPhoneNumberMutationVariables = {
  input: UpdateStoredPhoneNumberInput,
  condition?: ModelStoredPhoneNumberConditionInput | null,
};

export type UpdateStoredPhoneNumberMutation = {
  updateStoredPhoneNumber?:  {
    __typename: "StoredPhoneNumber",
    id: string,
    phoneNumber?: string | null,
    extension?: string | null,
    insuranceCarrierID?: string | null,
    lawFirmID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteStoredPhoneNumberMutationVariables = {
  input: DeleteStoredPhoneNumberInput,
  condition?: ModelStoredPhoneNumberConditionInput | null,
};

export type DeleteStoredPhoneNumberMutation = {
  deleteStoredPhoneNumber?:  {
    __typename: "StoredPhoneNumber",
    id: string,
    phoneNumber?: string | null,
    extension?: string | null,
    insuranceCarrierID?: string | null,
    lawFirmID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFaxJobMutationVariables = {
  input: CreateFaxJobInput,
  condition?: ModelFaxJobConditionInput | null,
};

export type CreateFaxJobMutation = {
  createFaxJob?:  {
    __typename: "FaxJob",
    id: string,
    appointmentID: string,
    uploadedFileID: string,
    recipientParty: FaxRecipientParty,
    recipientEntityID?: string | null,
    faxNumber: string,
    iFaxJobId?: string | null,
    status: FaxJobStatus,
    failureCode?: string | null,
    failureMessage?: string | null,
    submittedAt: string,
    completedAt?: string | null,
    submittedByUserID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFaxJobMutationVariables = {
  input: UpdateFaxJobInput,
  condition?: ModelFaxJobConditionInput | null,
};

export type UpdateFaxJobMutation = {
  updateFaxJob?:  {
    __typename: "FaxJob",
    id: string,
    appointmentID: string,
    uploadedFileID: string,
    recipientParty: FaxRecipientParty,
    recipientEntityID?: string | null,
    faxNumber: string,
    iFaxJobId?: string | null,
    status: FaxJobStatus,
    failureCode?: string | null,
    failureMessage?: string | null,
    submittedAt: string,
    completedAt?: string | null,
    submittedByUserID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFaxJobMutationVariables = {
  input: DeleteFaxJobInput,
  condition?: ModelFaxJobConditionInput | null,
};

export type DeleteFaxJobMutation = {
  deleteFaxJob?:  {
    __typename: "FaxJob",
    id: string,
    appointmentID: string,
    uploadedFileID: string,
    recipientParty: FaxRecipientParty,
    recipientEntityID?: string | null,
    faxNumber: string,
    iFaxJobId?: string | null,
    status: FaxJobStatus,
    failureCode?: string | null,
    failureMessage?: string | null,
    submittedAt: string,
    completedAt?: string | null,
    submittedByUserID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateN110PartyDeliveryMutationVariables = {
  input: CreateN110PartyDeliveryInput,
  condition?: ModelN110PartyDeliveryConditionInput | null,
};

export type CreateN110PartyDeliveryMutation = {
  createN110PartyDelivery?:  {
    __typename: "N110PartyDelivery",
    id: string,
    appointmentID: string,
    uploadedFileID?: string | null,
    party: N110ServiceParty,
    status: N110UploadStatus,
    reason: N110MailReason,
    driveFileID?: string | null,
    uploadedAt?: string | null,
    submittedByUserID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateN110PartyDeliveryMutationVariables = {
  input: UpdateN110PartyDeliveryInput,
  condition?: ModelN110PartyDeliveryConditionInput | null,
};

export type UpdateN110PartyDeliveryMutation = {
  updateN110PartyDelivery?:  {
    __typename: "N110PartyDelivery",
    id: string,
    appointmentID: string,
    uploadedFileID?: string | null,
    party: N110ServiceParty,
    status: N110UploadStatus,
    reason: N110MailReason,
    driveFileID?: string | null,
    uploadedAt?: string | null,
    submittedByUserID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteN110PartyDeliveryMutationVariables = {
  input: DeleteN110PartyDeliveryInput,
  condition?: ModelN110PartyDeliveryConditionInput | null,
};

export type DeleteN110PartyDeliveryMutation = {
  deleteN110PartyDelivery?:  {
    __typename: "N110PartyDelivery",
    id: string,
    appointmentID: string,
    uploadedFileID?: string | null,
    party: N110ServiceParty,
    status: N110UploadStatus,
    reason: N110MailReason,
    driveFileID?: string | null,
    uploadedAt?: string | null,
    submittedByUserID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateInsuranceCarrierMutationVariables = {
  input: CreateInsuranceCarrierInput,
  condition?: ModelInsuranceCarrierConditionInput | null,
};

export type CreateInsuranceCarrierMutation = {
  createInsuranceCarrier?:  {
    __typename: "InsuranceCarrier",
    id: string,
    name: string,
    defaultAddressID?: string | null,
    defaultAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    addresses?:  {
      __typename: "ModelStoredAddressConnection",
      items:  Array< {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultFaxNumberID?: string | null,
    defaultFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    faxNumbers?:  {
      __typename: "ModelStoredFaxNumberConnection",
      items:  Array< {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultPhoneNumberID?: string | null,
    defaultPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    phoneNumbers?:  {
      __typename: "ModelStoredPhoneNumberConnection",
      items:  Array< {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultEmail?: string | null,
    supportedDomains?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateInsuranceCarrierMutationVariables = {
  input: UpdateInsuranceCarrierInput,
  condition?: ModelInsuranceCarrierConditionInput | null,
};

export type UpdateInsuranceCarrierMutation = {
  updateInsuranceCarrier?:  {
    __typename: "InsuranceCarrier",
    id: string,
    name: string,
    defaultAddressID?: string | null,
    defaultAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    addresses?:  {
      __typename: "ModelStoredAddressConnection",
      items:  Array< {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultFaxNumberID?: string | null,
    defaultFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    faxNumbers?:  {
      __typename: "ModelStoredFaxNumberConnection",
      items:  Array< {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultPhoneNumberID?: string | null,
    defaultPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    phoneNumbers?:  {
      __typename: "ModelStoredPhoneNumberConnection",
      items:  Array< {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultEmail?: string | null,
    supportedDomains?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteInsuranceCarrierMutationVariables = {
  input: DeleteInsuranceCarrierInput,
  condition?: ModelInsuranceCarrierConditionInput | null,
};

export type DeleteInsuranceCarrierMutation = {
  deleteInsuranceCarrier?:  {
    __typename: "InsuranceCarrier",
    id: string,
    name: string,
    defaultAddressID?: string | null,
    defaultAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    addresses?:  {
      __typename: "ModelStoredAddressConnection",
      items:  Array< {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultFaxNumberID?: string | null,
    defaultFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    faxNumbers?:  {
      __typename: "ModelStoredFaxNumberConnection",
      items:  Array< {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultPhoneNumberID?: string | null,
    defaultPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    phoneNumbers?:  {
      __typename: "ModelStoredPhoneNumberConnection",
      items:  Array< {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultEmail?: string | null,
    supportedDomains?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLawFirmMutationVariables = {
  input: CreateLawFirmInput,
  condition?: ModelLawFirmConditionInput | null,
};

export type CreateLawFirmMutation = {
  createLawFirm?:  {
    __typename: "LawFirm",
    id: string,
    name: string,
    type: LawFirmType,
    defaultAddressID?: string | null,
    defaultAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    addresses?:  {
      __typename: "ModelStoredAddressConnection",
      items:  Array< {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultFaxNumberID?: string | null,
    defaultFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    faxNumbers?:  {
      __typename: "ModelStoredFaxNumberConnection",
      items:  Array< {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultPhoneNumberID?: string | null,
    defaultPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    phoneNumbers?:  {
      __typename: "ModelStoredPhoneNumberConnection",
      items:  Array< {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultEmail?: string | null,
    supportedDomains?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLawFirmMutationVariables = {
  input: UpdateLawFirmInput,
  condition?: ModelLawFirmConditionInput | null,
};

export type UpdateLawFirmMutation = {
  updateLawFirm?:  {
    __typename: "LawFirm",
    id: string,
    name: string,
    type: LawFirmType,
    defaultAddressID?: string | null,
    defaultAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    addresses?:  {
      __typename: "ModelStoredAddressConnection",
      items:  Array< {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultFaxNumberID?: string | null,
    defaultFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    faxNumbers?:  {
      __typename: "ModelStoredFaxNumberConnection",
      items:  Array< {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultPhoneNumberID?: string | null,
    defaultPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    phoneNumbers?:  {
      __typename: "ModelStoredPhoneNumberConnection",
      items:  Array< {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultEmail?: string | null,
    supportedDomains?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLawFirmMutationVariables = {
  input: DeleteLawFirmInput,
  condition?: ModelLawFirmConditionInput | null,
};

export type DeleteLawFirmMutation = {
  deleteLawFirm?:  {
    __typename: "LawFirm",
    id: string,
    name: string,
    type: LawFirmType,
    defaultAddressID?: string | null,
    defaultAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    addresses?:  {
      __typename: "ModelStoredAddressConnection",
      items:  Array< {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultFaxNumberID?: string | null,
    defaultFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    faxNumbers?:  {
      __typename: "ModelStoredFaxNumberConnection",
      items:  Array< {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultPhoneNumberID?: string | null,
    defaultPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    phoneNumbers?:  {
      __typename: "ModelStoredPhoneNumberConnection",
      items:  Array< {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultEmail?: string | null,
    supportedDomains?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCaseRecordMutationVariables = {
  input: CreateCaseRecordInput,
  condition?: ModelCaseRecordConditionInput | null,
};

export type CreateCaseRecordMutation = {
  createCaseRecord?:  {
    __typename: "CaseRecord",
    id: string,
    state?: CaseState | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCaseRecordMutationVariables = {
  input: UpdateCaseRecordInput,
  condition?: ModelCaseRecordConditionInput | null,
};

export type UpdateCaseRecordMutation = {
  updateCaseRecord?:  {
    __typename: "CaseRecord",
    id: string,
    state?: CaseState | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCaseRecordMutationVariables = {
  input: DeleteCaseRecordInput,
  condition?: ModelCaseRecordConditionInput | null,
};

export type DeleteCaseRecordMutation = {
  deleteCaseRecord?:  {
    __typename: "CaseRecord",
    id: string,
    state?: CaseState | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAppointmentRecordMutationVariables = {
  input: CreateAppointmentRecordInput,
  condition?: ModelAppointmentRecordConditionInput | null,
};

export type CreateAppointmentRecordMutation = {
  createAppointmentRecord?:  {
    __typename: "AppointmentRecord",
    id: string,
    doctorOwnerCognitoId?: string | null,
    assistantCognitoIds?: Array< string > | null,
    globalPartitionKey: string,
    originalAppointmentID: string,
    supplementalAppointmentIDs?: Array< string | null > | null,
    supplementalSourceAppointmentIDs?: Array< string | null > | null,
    depositionAppointmentIDs?: Array< string | null > | null,
    depositionSourceAppointmentIDs?: Array< string | null > | null,
    rescheduledFromAppointmentID?: string | null,
    rescheduledToAppointmentID?: string | null,
    date?: string | null,
    yearMonth?: string | null,
    doctorYearMonth?: string | null,
    time?: string | null,
    bookedInFlexibleTime?: boolean | null,
    inquiryDate: string,
    inquiryYearMonth: string,
    type?: AppointmentType | null,
    doctorID?: string | null,
    doctor?:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null,
    locationID?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    } | null,
    visitForm?: string | null,
    jotformSubmissions?:  Array< {
      __typename: "JotformSubmission",
      id: string,
      receivedAt: string,
      populatedAt?: string | null,
    } | null > | null,
    historyTranscriptPopulations?:  Array< {
      __typename: "HistoryTranscriptPopulation",
      uploadedFileID: string,
      populatedAt: string,
    } | null > | null,
    active?: boolean | null,
    durationMinutes?: number | null,
    reportDue?: string | null,
    reportSubmitted?: string | null,
    status?: AppointmentStatus | null,
    reportStatus?: ReportStatus | null,
    paymentStatus?: PaymentStatus | null,
    billingStatus?: BillingStatus | null,
    difficultyLevel?: number | null,
    scheduler?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    medicalAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    schedulingAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    onSiteOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    reportOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    billingOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    preVisitReviewer?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    inquirerInfo?:  {
      __typename: "InquirerInfo",
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      inquiringParty?: InquiringParty | null,
      name?: string | null,
      inquiryDate?: string | null,
      notification_110_required?: boolean | null,
    } | null,
    notes?:  {
      __typename: "ModelNotesConnection",
      items:  Array< {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    huddleNote?:  {
      __typename: "HuddleNote",
      id: string,
      appointmentRecordID: string,
      contentMarkdown?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    patientCases?:  {
      __typename: "ModelAppointmentRecordPatientCaseConnection",
      items:  Array< {
        __typename: "AppointmentRecordPatientCase",
        id: string,
        appointmentRecordId: string,
        patientCaseId: string,
        appointmentRecord:  {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        },
        patientCase:  {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    employments?:  Array< {
      __typename: "EmploymentRecord",
      employerName?: string | null,
      jobTitle?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      dateOfHire?: string | null,
      dateOfHireFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      hoursPerWeek?: string | null,
      jobDuties?: string | null,
      dateOfTermination?: string | null,
      dateOfTerminationFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
      stillWorkingHere?: boolean | null,
      type?: EmploymentType | null,
      currentWorkRestrictions?: string | null,
      workStatus?: string | null,
      departureReason?: string | null,
    } | null > | null,
    employmentGaps?:  Array< {
      __typename: "EmploymentGapRecord",
      type?: EmploymentGapType | null,
      startDate?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      endDate?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
    } | null > | null,
    patientDescribedInjuries?: Array< BodyPart | null > | null,
    uploadedFilesSet?:  {
      __typename: "UploadedFileSet",
      id: string,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      uploadedFiles?:  {
        __typename: "ModelUploadedFileConnection",
        items:  Array< {
          __typename: "UploadedFile",
          id: string,
          key?: string | null,
          fileName?: string | null,
          type?: FileType | null,
          provider?: FileProvider | null,
          uploadedBy?: string | null,
          uploadedAt?: string | null,
          fileSizeBytes?: number | null,
          fileSetID?: string | null,
          sourceAppointmentID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploadedFilesSetID?: string | null,
    referredBy?: string | null,
    s3FileKey?: string | null,
    medicalRecordsReceived?: boolean | null,
    medicalRecordsBriefingFileID?: string | null,
    medicalRecordsBriefingExecutionArn?: string | null,
    medicalRecordsTotalPagesProcessed?: number | null,
    reportGenerationFileID?: string | null,
    reportGenerationExecutionArn?: string | null,
    reportGenerationGeneratedAt?: string | null,
    historyOfInjuryFileID?: string | null,
    historyOfInjuryGeneratedAt?: string | null,
    evaluationFileID?: string | null,
    assessmentFileID?: string | null,
    depositionPreparationFileID?: string | null,
    documentStatus?:  {
      __typename: "DocumentStatus",
      evaluationPublished?: boolean | null,
      assessmentPublished?: boolean | null,
      historyInProgress?: boolean | null,
      historyPublished?: boolean | null,
      historyCleaned?: boolean | null,
      reportPublished?: boolean | null,
      briefingInProgress?: boolean | null,
      briefingPublished?: boolean | null,
      briefingCleaned?: boolean | null,
    } | null,
    cancellationReason?: CancellationReason | null,
    cancellationRequestedBy?: ParticipantType | null,
    cancellationRequestedInternally?: boolean | null,
    cancellationNote?: string | null,
    cancellationDate?: string | null,
    inquiryClosingReason?: InquiryClosingReason | null,
    inquiryClosingNote?: string | null,
    inquiryClosingDate?: string | null,
    noShowReason?: NoShowReason | null,
    noShowNote?: string | null,
    reschedulingReason?: ReschedulingReason | null,
    reschedulingOthersReason?: string | null,
    reschedulingRequestedBy?: ParticipantType | null,
    reschedulingRequestedInternally?: boolean | null,
    reschedulingNote?: string | null,
    reschedulingDate?: string | null,
    interpreter?:  {
      __typename: "InterpreterInfo",
      certificateId?: string | null,
      name?: string | null,
      companyName?: string | null,
      phoneNumber?: string | null,
      phoneExtension?: string | null,
      note?: string | null,
      confirmed?: boolean | null,
    } | null,
    historyOfInjuryNotes?:  {
      __typename: "Notes",
      id: string,
      content?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      type?: NotesType | null,
      timeStamp?: number | null,
      appointmentrecordID: string,
      createdAt: string,
      updatedAt: string,
      notesAuthorId?: string | null,
    } | null,
    currentComplaintNotes?:  {
      __typename: "Notes",
      id: string,
      content?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      type?: NotesType | null,
      timeStamp?: number | null,
      appointmentrecordID: string,
      createdAt: string,
      updatedAt: string,
      notesAuthorId?: string | null,
    } | null,
    historyCallDate?: string | null,
    historyCallTime?: string | null,
    historyCallAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    historyCallCompleted?: boolean | null,
    historyCallCompletedWithoutRecords?: boolean | null,
    historyCallCompletedOnSite?: boolean | null,
    historyCallNoShow?: boolean | null,
    historyCallCalendarEventID?: string | null,
    historyCallCalendarLink?: string | null,
    billingInfo?:  {
      __typename: "BillingInfo",
      diagnosisMappings?:  Array< {
        __typename: "DiagnosisMapping",
        code?: string | null,
        pointer?: string | null,
        description?: string | null,
      } | null > | null,
      serviceDetails?:  Array< {
        __typename: "ServiceDetail",
        dateOfStart?: string | null,
        dateOfEnd?: string | null,
        place?: number | null,
        emergencyIndicator?: boolean | null,
        serviceType?: ServiceType | null,
        modifiers?: Array< ServiceModifier | null > | null,
        diagnosisPointers?: Array< string | null > | null,
        chargedAmount?: number | null,
        quantity?: number | null,
        amountPaid?: number | null,
        renderingProviderId?: string | null,
      } | null > | null,
      totalCharge?: number | null,
      amountPaid?: number | null,
      billingCounter?: number | null,
      billedDate?: string | null,
      paidDate?: string | null,
      correctionDate?: string | null,
    } | null,
    caseInfo?:  {
      __typename: "CaseInfo",
      confirmationEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
      recordsFollowupEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
      attendanceEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
    } | null,
    isProd?: boolean | null,
    isDemo?: boolean | null,
    primaryPatientCaseID?: string | null,
    calendarEventID?: string | null,
    reportConfiguration?:  {
      __typename: "ReportConfiguration",
      history?: ReportSource | null,
      physicalExamination?: ReportSource | null,
      assessment?: ReportSource | null,
    } | null,
    workflowExecutions?:  {
      __typename: "ModelWorkflowExecutionConnection",
      items:  Array< {
        __typename: "WorkflowExecution",
        executionArn: string,
        appointmentRecordID: string,
        type?: WorkflowExecutionType | null,
        status?: WorkflowExecutionStatus | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    historyOfInjuryInsights?:  {
      __typename: "HistoryOfInjuryInsights",
      id: string,
      appointmentRecordID: string,
      mechanismOfInjury?: string | null,
      employerJobDescription?: string | null,
      injuryCausations?:  Array< {
        __typename: "InjuryCausationInfo",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryEnd?: string | null,
        bodyParts?: Array< BodyPart | null > | null,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
      } | null > | null,
      currentSymptoms?:  Array< {
        __typename: "Symptom",
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      priorSymptomsBeforeCurrentInjury?:  Array< {
        __typename: "Symptom",
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      previousSurgeries?:  Array< {
        __typename: "SurgeryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        type?: string | null,
      } | null > | null,
      previousWorkInjuries?:  Array< {
        __typename: "InjuryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      previousInjuries?:  Array< {
        __typename: "InjuryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      injuryEmploymentStatus?: string | null,
      currentWorkRestrictionsFromPatient?: string | null,
      activitiesOfDailyLiving?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reviewOfMedicalRecordsInsights?:  {
      __typename: "ReviewOfMedicalRecordsInsights",
      id: string,
      appointmentRecordID: string,
      latestDiagnosis?:  Array< {
        __typename: "BodyPartDiagnosis",
        bodyPart?: string | null,
        date?: string | null,
        descriptions?: Array< string | null > | null,
      } | null > | null,
      diagnosticStudies?:  Array< {
        __typename: "DiagnosticStudy",
        date?: string | null,
        typeOfStudy?: DiagnosticStudyType | null,
        bodyPart?: string | null,
        impression?: string | null,
        source?: DiagnosticStudySource | null,
      } | null > | null,
      treatments?:  Array< {
        __typename: "TreatmentWrapper",
        discreteTreatment?:  {
          __typename: "DiscreteTreatment",
          date?: string | null,
          treatmentType?: DiscreteTreatmentType | null,
          bodyPart?: string | null,
          description?: string | null,
        } | null,
        recurringTreatment?:  {
          __typename: "RecurringTreatment",
          year?: string | null,
          treatmentType?: RecurringTreatmentType | null,
          frequency?: string | null,
          description?: string | null,
        } | null,
      } | null > | null,
      currentWorkRestrictionsFromMedicalRecords?: string | null,
      previousReports?:  Array< {
        __typename: "PreviousReport",
        date?: string | null,
        reportType?: string | null,
        reportContent?: string | null,
      } | null > | null,
      durableMedicalEquipment?:  Array< {
        __typename: "DurableMedicalEquipment",
        startDate?: string | null,
        endDate?: string | null,
        bodyParts?: Array< string | null > | null,
        equipmentType?: string | null,
        description?: string | null,
      } | null > | null,
      derivedFromDocumentInsightIDs?: Array< string | null > | null,
      derivedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    physicalExamInsights?:  {
      __typename: "PhysicalExamInsights",
      id: string,
      appointmentRecordID: string,
      physicalExaminationInfo?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    pastInjuryMatrix?:  {
      __typename: "PastInjuryMatrix",
      id: string,
      appointmentRecordID: string,
      preExistingConditions: Array< string >,
      familyHistory: Array< string >,
      injuryMatrix:  Array< {
        __typename: "InjuryMatrixEntry",
        date: string,
        bodyPart: BodyPart,
        status: InjuryStatus,
      } >,
      createdAt: string,
      updatedAt: string,
    } | null,
    briefing?:  {
      __typename: "RecordBriefing",
      id: string,
      logicalBriefingID: string,
      segmentMappings?:  {
        __typename: "ModelRecordBriefingSegmentMappingConnection",
        items:  Array< {
          __typename: "RecordBriefingSegmentMapping",
          id: string,
          briefingID: string,
          logicalSegmentID: string,
          publishedSegmentID?: string | null,
          draftSegmentID?: string | null,
          markedForDeletion?: boolean | null,
          markedForCreation?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      googleDocExportLink?: string | null,
      googleDocExportedAt?: string | null,
      suggestionGeneration?:  {
        __typename: "SuggestionGenerationJob",
        status?: SuggestionGenerationStatus | null,
        jobId?: string | null,
        startedAt?: string | null,
        completedAt?: string | null,
        error?: string | null,
      } | null,
      editingPresence?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    introParagraph?:  {
      __typename: "IntroParagraph",
      id: string,
      appointmentRecordID: string,
      introParagraphText?: string | null,
      sourceRecaps?:  Array< {
        __typename: "CoverLetterRecapSnapshot",
        coverLetterRecapID: string,
        uploadedFileID: string,
        recapText: string,
        generatedAt?: string | null,
      } | null > | null,
      status: IntroParagraphStatus,
      errorMessage?: string | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    impairmentRatingResults?:  Array< {
      __typename: "ImpairmentRatingResult",
      ts?: number | null,
      bodyParts?: Array< string | null > | null,
      enabledStrictRating?: boolean | null,
      enabledPainRating?: boolean | null,
      enabledAG?: boolean | null,
      enabledStrengthRating?: boolean | null,
      enabledDBE?: boolean | null,
      autoMode?: boolean | null,
      result?: string | null,
      resultFeedback?:  {
        __typename: "ImpairmentRatingResultFeedback",
        exists?: boolean | null,
        isGood?: boolean | null,
        notes?: string | null,
      } | null,
    } | null > | null,
    defenseAttorneyPagesDeclaration?: number | null,
    applicantAttorneyPagesDeclaration?: number | null,
    fieldTemplateRef?:  {
      __typename: "FieldTemplateRef",
      id: string,
      version: number,
    } | null,
    dataFieldValuesMappings?:  Array< {
      __typename: "DataFieldValueMapping",
      dataFieldID?: string | null,
      value?: string | null,
    } | null > | null,
    physicalEvalTemplateRef?:  {
      __typename: "FieldTemplateRef",
      id: string,
      version: number,
    } | null,
    physicalExamValues?:  Array< {
      __typename: "PhysicalExamValue",
      sectionID: string,
      questionID: string,
      side?: PhysicalExamSide | null,
      value?: string | null,
      note?: string | null,
      excluded?: boolean | null,
    } | null > | null,
    physicalExamOtherFindings?:  Array< {
      __typename: "PhysicalExamOtherFinding",
      sectionID: string,
      text?: string | null,
    } | null > | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      injuries?:  Array< {
        __typename: "AssessmentInjury",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        dateOfInjuryEnd?: string | null,
        dateOfInjuryEndFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        bodyParts?: Array< BodyPart | null > | null,
        causeOfInjury?: string | null,
        causedByWork?: AssessmentCausationOption | null,
        causedByWorkExplanation?: string | null,
      } | null > | null,
      discussedBodyParts?: Array< BodyPart | null > | null,
      bodyPartsNotDiscussedReason?: string | null,
      discussions?: string | null,
      diagnoses?:  Array< {
        __typename: "AssessmentDiagnosis",
        diagnosis?: string | null,
        icdCode?: string | null,
        evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
        evidence?: string | null,
      } | null > | null,
      bodyPartMMIStatus?:  {
        __typename: "AssessmentBodyPartMMIStatus",
        discussByBodyPart?: boolean | null,
        allBodyPartsMMI?:  {
          __typename: "AssessmentBodyPartEvaluation",
          mmi?: boolean | null,
          mmiReason?: string | null,
          expectedMMITimeRange?: AssessmentMmiTimeRange | null,
          expectedMMITimeRangeExplanation?: string | null,
          treatments?: Array< string | null > | null,
          treatmentsExplanation?: string | null,
          discussions?: string | null,
          impairmentRating?: string | null,
          impairmentRatingNotApplicable?: boolean | null,
          deferImpairmentRating?: boolean | null,
          deferImpairmentRatingReason?: string | null,
          apportionment?: string | null,
          apportionmentNotApplicable?: boolean | null,
          deferApportionment?: boolean | null,
          deferApportionmentReason?: string | null,
        } | null,
        bodyPartMMIStatuses?:  Array< {
          __typename: "AssessmentBodyPart",
          bodyPart?: BodyPart | null,
        } | null > | null,
      } | null,
      workStatus?: string | null,
      markedAsDone?: boolean | null,
      discussDiagnosesFreeForm?: boolean | null,
      diagnosesFreeform?: string | null,
      discussCausationFreeForm?: boolean | null,
      causationFreeForm?: string | null,
      discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
      hasPatientReachedMMIFreeForm?: string | null,
      discussMMIByBodyPartFreeForm?: string | null,
      impairmentRatingByBodyPartFreeForm?: string | null,
      apportionmentByBodyPartFreeForm?: string | null,
      impairmentRatingOtherComments?: string | null,
      apportionmentOtherComments?: string | null,
      assessmentMode?: AssessmentMode | null,
      assessmentFreeForm?:  {
        __typename: "AssessmentFreeForm",
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussions?: string | null,
        diagnosesAndEvidence?: string | null,
        causation?: string | null,
        hasPatientReachedMMI?: string | null,
        discussMMIByBodyPart?: string | null,
        impairmentRatingByBodyPart?: string | null,
        apportionmentByBodyPart?: string | null,
        workStatus?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    opinionRecap?:  {
      __typename: "OpinionRecap",
      id: string,
      appointmentRecordID: string,
      causation?: string | null,
      diagnosis?: string | null,
      mmiFutureMedicalTreatment?: string | null,
      impairmentRating?: string | null,
      apportionment?: string | null,
      workStatus?: string | null,
      sourceReportFileID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
    featureFlags?:  Array< {
      __typename: "AppointmentFeatureConfig",
      featureFlagKey: string,
      enabled: boolean,
    } | null > | null,
    opsChecklist?:  {
      __typename: "OpsChecklist",
      panel?: OpsChecklistItemStatus | null,
      contact_info?: OpsChecklistItemStatus | null,
      all_parties?: OpsChecklistItemStatus | null,
      notice_110?: OpsChecklistItemStatus | null,
      cover_letter?: OpsChecklistItemStatus | null,
      record_review?: OpsChecklistItemStatus | null,
      history_call?: OpsChecklistItemStatus | null,
      history_of_injury?: OpsChecklistItemStatus | null,
      interpreter_info?: OpsChecklistItemStatus | null,
      jotform?: OpsChecklistItemStatus | null,
      deu_100?: OpsChecklistItemStatus | null,
      final_report?: OpsChecklistItemStatus | null,
    } | null,
    panelUnavailable?: boolean | null,
    panelSpecialty?: SpecialtyType | null,
    defenseAttorneyNotPresent?: boolean | null,
    applicantAttorneyNotPresent?: boolean | null,
    contactUnavailability?:  {
      __typename: "ParticipantContactUnavailability",
      patient?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      adjuster?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      applicantAttorney?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      defenseAttorney?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
    } | null,
    historyValidation?:  {
      __typename: "HistoryValidation",
      id: string,
      appointmentRecordID: string,
      status: HistoryValidationStatus,
      groups:  Array< {
        __typename: "HistoryValidationGroup",
        id: string,
        title: string,
        status: HistoryValidationGroupStatus,
        issues:  Array< {
          __typename: "HistoryValidationIssue",
          id: string,
          title: string,
          description?: string | null,
          patientInfoSection?: PatientInfoSection | null,
          issueType?: ValidationIssueType | null,
        } | null >,
      } | null >,
      validatedAt?: string | null,
      errorMessage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    patientHistoryValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    videoCallLink?: string | null,
    additionalTimeslots?:  Array< {
      __typename: "AdditionalTimeslot",
      date: string,
      time: string,
      locationID?: string | null,
    } | null > | null,
    mrrValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    historyMrrCrossValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseID?: string | null,
    briefingModelVersion?: BriefingModelVersion | null,
    briefingGdocExportLink?: string | null,
    briefingGdocExportedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    appointmentRecordMedicalAssistantId?: string | null,
    appointmentRecordSchedulingAssistantId?: string | null,
    appointmentRecordOnSiteOpId?: string | null,
    appointmentRecordReportOpId?: string | null,
    appointmentRecordBillingOpId?: string | null,
    appointmentRecordPreVisitReviewerId?: string | null,
    appointmentRecordHuddleNoteId?: string | null,
    appointmentRecordHistoryOfInjuryNotesId?: string | null,
    appointmentRecordCurrentComplaintNotesId?: string | null,
    appointmentRecordHistoryCallAssistantId?: string | null,
    appointmentRecordHistoryOfInjuryInsightsId?: string | null,
    appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
    appointmentRecordPhysicalExamInsightsId?: string | null,
    appointmentRecordPastInjuryMatrixId?: string | null,
    appointmentRecordBriefingId?: string | null,
    appointmentRecordIntroParagraphId?: string | null,
    appointmentRecordAssessmentId?: string | null,
    appointmentRecordAssessmentValidationId?: string | null,
    appointmentRecordOpinionRecapId?: string | null,
    appointmentRecordHistoryValidationId?: string | null,
    appointmentRecordPatientHistoryValidationId?: string | null,
    appointmentRecordMrrValidationId?: string | null,
    appointmentRecordHistoryMrrCrossValidationId?: string | null,
  } | null,
};

export type UpdateAppointmentRecordMutationVariables = {
  input: UpdateAppointmentRecordInput,
  condition?: ModelAppointmentRecordConditionInput | null,
};

export type UpdateAppointmentRecordMutation = {
  updateAppointmentRecord?:  {
    __typename: "AppointmentRecord",
    id: string,
    doctorOwnerCognitoId?: string | null,
    assistantCognitoIds?: Array< string > | null,
    globalPartitionKey: string,
    originalAppointmentID: string,
    supplementalAppointmentIDs?: Array< string | null > | null,
    supplementalSourceAppointmentIDs?: Array< string | null > | null,
    depositionAppointmentIDs?: Array< string | null > | null,
    depositionSourceAppointmentIDs?: Array< string | null > | null,
    rescheduledFromAppointmentID?: string | null,
    rescheduledToAppointmentID?: string | null,
    date?: string | null,
    yearMonth?: string | null,
    doctorYearMonth?: string | null,
    time?: string | null,
    bookedInFlexibleTime?: boolean | null,
    inquiryDate: string,
    inquiryYearMonth: string,
    type?: AppointmentType | null,
    doctorID?: string | null,
    doctor?:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null,
    locationID?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    } | null,
    visitForm?: string | null,
    jotformSubmissions?:  Array< {
      __typename: "JotformSubmission",
      id: string,
      receivedAt: string,
      populatedAt?: string | null,
    } | null > | null,
    historyTranscriptPopulations?:  Array< {
      __typename: "HistoryTranscriptPopulation",
      uploadedFileID: string,
      populatedAt: string,
    } | null > | null,
    active?: boolean | null,
    durationMinutes?: number | null,
    reportDue?: string | null,
    reportSubmitted?: string | null,
    status?: AppointmentStatus | null,
    reportStatus?: ReportStatus | null,
    paymentStatus?: PaymentStatus | null,
    billingStatus?: BillingStatus | null,
    difficultyLevel?: number | null,
    scheduler?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    medicalAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    schedulingAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    onSiteOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    reportOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    billingOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    preVisitReviewer?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    inquirerInfo?:  {
      __typename: "InquirerInfo",
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      inquiringParty?: InquiringParty | null,
      name?: string | null,
      inquiryDate?: string | null,
      notification_110_required?: boolean | null,
    } | null,
    notes?:  {
      __typename: "ModelNotesConnection",
      items:  Array< {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    huddleNote?:  {
      __typename: "HuddleNote",
      id: string,
      appointmentRecordID: string,
      contentMarkdown?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    patientCases?:  {
      __typename: "ModelAppointmentRecordPatientCaseConnection",
      items:  Array< {
        __typename: "AppointmentRecordPatientCase",
        id: string,
        appointmentRecordId: string,
        patientCaseId: string,
        appointmentRecord:  {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        },
        patientCase:  {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    employments?:  Array< {
      __typename: "EmploymentRecord",
      employerName?: string | null,
      jobTitle?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      dateOfHire?: string | null,
      dateOfHireFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      hoursPerWeek?: string | null,
      jobDuties?: string | null,
      dateOfTermination?: string | null,
      dateOfTerminationFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
      stillWorkingHere?: boolean | null,
      type?: EmploymentType | null,
      currentWorkRestrictions?: string | null,
      workStatus?: string | null,
      departureReason?: string | null,
    } | null > | null,
    employmentGaps?:  Array< {
      __typename: "EmploymentGapRecord",
      type?: EmploymentGapType | null,
      startDate?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      endDate?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
    } | null > | null,
    patientDescribedInjuries?: Array< BodyPart | null > | null,
    uploadedFilesSet?:  {
      __typename: "UploadedFileSet",
      id: string,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      uploadedFiles?:  {
        __typename: "ModelUploadedFileConnection",
        items:  Array< {
          __typename: "UploadedFile",
          id: string,
          key?: string | null,
          fileName?: string | null,
          type?: FileType | null,
          provider?: FileProvider | null,
          uploadedBy?: string | null,
          uploadedAt?: string | null,
          fileSizeBytes?: number | null,
          fileSetID?: string | null,
          sourceAppointmentID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploadedFilesSetID?: string | null,
    referredBy?: string | null,
    s3FileKey?: string | null,
    medicalRecordsReceived?: boolean | null,
    medicalRecordsBriefingFileID?: string | null,
    medicalRecordsBriefingExecutionArn?: string | null,
    medicalRecordsTotalPagesProcessed?: number | null,
    reportGenerationFileID?: string | null,
    reportGenerationExecutionArn?: string | null,
    reportGenerationGeneratedAt?: string | null,
    historyOfInjuryFileID?: string | null,
    historyOfInjuryGeneratedAt?: string | null,
    evaluationFileID?: string | null,
    assessmentFileID?: string | null,
    depositionPreparationFileID?: string | null,
    documentStatus?:  {
      __typename: "DocumentStatus",
      evaluationPublished?: boolean | null,
      assessmentPublished?: boolean | null,
      historyInProgress?: boolean | null,
      historyPublished?: boolean | null,
      historyCleaned?: boolean | null,
      reportPublished?: boolean | null,
      briefingInProgress?: boolean | null,
      briefingPublished?: boolean | null,
      briefingCleaned?: boolean | null,
    } | null,
    cancellationReason?: CancellationReason | null,
    cancellationRequestedBy?: ParticipantType | null,
    cancellationRequestedInternally?: boolean | null,
    cancellationNote?: string | null,
    cancellationDate?: string | null,
    inquiryClosingReason?: InquiryClosingReason | null,
    inquiryClosingNote?: string | null,
    inquiryClosingDate?: string | null,
    noShowReason?: NoShowReason | null,
    noShowNote?: string | null,
    reschedulingReason?: ReschedulingReason | null,
    reschedulingOthersReason?: string | null,
    reschedulingRequestedBy?: ParticipantType | null,
    reschedulingRequestedInternally?: boolean | null,
    reschedulingNote?: string | null,
    reschedulingDate?: string | null,
    interpreter?:  {
      __typename: "InterpreterInfo",
      certificateId?: string | null,
      name?: string | null,
      companyName?: string | null,
      phoneNumber?: string | null,
      phoneExtension?: string | null,
      note?: string | null,
      confirmed?: boolean | null,
    } | null,
    historyOfInjuryNotes?:  {
      __typename: "Notes",
      id: string,
      content?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      type?: NotesType | null,
      timeStamp?: number | null,
      appointmentrecordID: string,
      createdAt: string,
      updatedAt: string,
      notesAuthorId?: string | null,
    } | null,
    currentComplaintNotes?:  {
      __typename: "Notes",
      id: string,
      content?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      type?: NotesType | null,
      timeStamp?: number | null,
      appointmentrecordID: string,
      createdAt: string,
      updatedAt: string,
      notesAuthorId?: string | null,
    } | null,
    historyCallDate?: string | null,
    historyCallTime?: string | null,
    historyCallAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    historyCallCompleted?: boolean | null,
    historyCallCompletedWithoutRecords?: boolean | null,
    historyCallCompletedOnSite?: boolean | null,
    historyCallNoShow?: boolean | null,
    historyCallCalendarEventID?: string | null,
    historyCallCalendarLink?: string | null,
    billingInfo?:  {
      __typename: "BillingInfo",
      diagnosisMappings?:  Array< {
        __typename: "DiagnosisMapping",
        code?: string | null,
        pointer?: string | null,
        description?: string | null,
      } | null > | null,
      serviceDetails?:  Array< {
        __typename: "ServiceDetail",
        dateOfStart?: string | null,
        dateOfEnd?: string | null,
        place?: number | null,
        emergencyIndicator?: boolean | null,
        serviceType?: ServiceType | null,
        modifiers?: Array< ServiceModifier | null > | null,
        diagnosisPointers?: Array< string | null > | null,
        chargedAmount?: number | null,
        quantity?: number | null,
        amountPaid?: number | null,
        renderingProviderId?: string | null,
      } | null > | null,
      totalCharge?: number | null,
      amountPaid?: number | null,
      billingCounter?: number | null,
      billedDate?: string | null,
      paidDate?: string | null,
      correctionDate?: string | null,
    } | null,
    caseInfo?:  {
      __typename: "CaseInfo",
      confirmationEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
      recordsFollowupEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
      attendanceEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
    } | null,
    isProd?: boolean | null,
    isDemo?: boolean | null,
    primaryPatientCaseID?: string | null,
    calendarEventID?: string | null,
    reportConfiguration?:  {
      __typename: "ReportConfiguration",
      history?: ReportSource | null,
      physicalExamination?: ReportSource | null,
      assessment?: ReportSource | null,
    } | null,
    workflowExecutions?:  {
      __typename: "ModelWorkflowExecutionConnection",
      items:  Array< {
        __typename: "WorkflowExecution",
        executionArn: string,
        appointmentRecordID: string,
        type?: WorkflowExecutionType | null,
        status?: WorkflowExecutionStatus | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    historyOfInjuryInsights?:  {
      __typename: "HistoryOfInjuryInsights",
      id: string,
      appointmentRecordID: string,
      mechanismOfInjury?: string | null,
      employerJobDescription?: string | null,
      injuryCausations?:  Array< {
        __typename: "InjuryCausationInfo",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryEnd?: string | null,
        bodyParts?: Array< BodyPart | null > | null,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
      } | null > | null,
      currentSymptoms?:  Array< {
        __typename: "Symptom",
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      priorSymptomsBeforeCurrentInjury?:  Array< {
        __typename: "Symptom",
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      previousSurgeries?:  Array< {
        __typename: "SurgeryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        type?: string | null,
      } | null > | null,
      previousWorkInjuries?:  Array< {
        __typename: "InjuryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      previousInjuries?:  Array< {
        __typename: "InjuryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      injuryEmploymentStatus?: string | null,
      currentWorkRestrictionsFromPatient?: string | null,
      activitiesOfDailyLiving?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reviewOfMedicalRecordsInsights?:  {
      __typename: "ReviewOfMedicalRecordsInsights",
      id: string,
      appointmentRecordID: string,
      latestDiagnosis?:  Array< {
        __typename: "BodyPartDiagnosis",
        bodyPart?: string | null,
        date?: string | null,
        descriptions?: Array< string | null > | null,
      } | null > | null,
      diagnosticStudies?:  Array< {
        __typename: "DiagnosticStudy",
        date?: string | null,
        typeOfStudy?: DiagnosticStudyType | null,
        bodyPart?: string | null,
        impression?: string | null,
        source?: DiagnosticStudySource | null,
      } | null > | null,
      treatments?:  Array< {
        __typename: "TreatmentWrapper",
        discreteTreatment?:  {
          __typename: "DiscreteTreatment",
          date?: string | null,
          treatmentType?: DiscreteTreatmentType | null,
          bodyPart?: string | null,
          description?: string | null,
        } | null,
        recurringTreatment?:  {
          __typename: "RecurringTreatment",
          year?: string | null,
          treatmentType?: RecurringTreatmentType | null,
          frequency?: string | null,
          description?: string | null,
        } | null,
      } | null > | null,
      currentWorkRestrictionsFromMedicalRecords?: string | null,
      previousReports?:  Array< {
        __typename: "PreviousReport",
        date?: string | null,
        reportType?: string | null,
        reportContent?: string | null,
      } | null > | null,
      durableMedicalEquipment?:  Array< {
        __typename: "DurableMedicalEquipment",
        startDate?: string | null,
        endDate?: string | null,
        bodyParts?: Array< string | null > | null,
        equipmentType?: string | null,
        description?: string | null,
      } | null > | null,
      derivedFromDocumentInsightIDs?: Array< string | null > | null,
      derivedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    physicalExamInsights?:  {
      __typename: "PhysicalExamInsights",
      id: string,
      appointmentRecordID: string,
      physicalExaminationInfo?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    pastInjuryMatrix?:  {
      __typename: "PastInjuryMatrix",
      id: string,
      appointmentRecordID: string,
      preExistingConditions: Array< string >,
      familyHistory: Array< string >,
      injuryMatrix:  Array< {
        __typename: "InjuryMatrixEntry",
        date: string,
        bodyPart: BodyPart,
        status: InjuryStatus,
      } >,
      createdAt: string,
      updatedAt: string,
    } | null,
    briefing?:  {
      __typename: "RecordBriefing",
      id: string,
      logicalBriefingID: string,
      segmentMappings?:  {
        __typename: "ModelRecordBriefingSegmentMappingConnection",
        items:  Array< {
          __typename: "RecordBriefingSegmentMapping",
          id: string,
          briefingID: string,
          logicalSegmentID: string,
          publishedSegmentID?: string | null,
          draftSegmentID?: string | null,
          markedForDeletion?: boolean | null,
          markedForCreation?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      googleDocExportLink?: string | null,
      googleDocExportedAt?: string | null,
      suggestionGeneration?:  {
        __typename: "SuggestionGenerationJob",
        status?: SuggestionGenerationStatus | null,
        jobId?: string | null,
        startedAt?: string | null,
        completedAt?: string | null,
        error?: string | null,
      } | null,
      editingPresence?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    introParagraph?:  {
      __typename: "IntroParagraph",
      id: string,
      appointmentRecordID: string,
      introParagraphText?: string | null,
      sourceRecaps?:  Array< {
        __typename: "CoverLetterRecapSnapshot",
        coverLetterRecapID: string,
        uploadedFileID: string,
        recapText: string,
        generatedAt?: string | null,
      } | null > | null,
      status: IntroParagraphStatus,
      errorMessage?: string | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    impairmentRatingResults?:  Array< {
      __typename: "ImpairmentRatingResult",
      ts?: number | null,
      bodyParts?: Array< string | null > | null,
      enabledStrictRating?: boolean | null,
      enabledPainRating?: boolean | null,
      enabledAG?: boolean | null,
      enabledStrengthRating?: boolean | null,
      enabledDBE?: boolean | null,
      autoMode?: boolean | null,
      result?: string | null,
      resultFeedback?:  {
        __typename: "ImpairmentRatingResultFeedback",
        exists?: boolean | null,
        isGood?: boolean | null,
        notes?: string | null,
      } | null,
    } | null > | null,
    defenseAttorneyPagesDeclaration?: number | null,
    applicantAttorneyPagesDeclaration?: number | null,
    fieldTemplateRef?:  {
      __typename: "FieldTemplateRef",
      id: string,
      version: number,
    } | null,
    dataFieldValuesMappings?:  Array< {
      __typename: "DataFieldValueMapping",
      dataFieldID?: string | null,
      value?: string | null,
    } | null > | null,
    physicalEvalTemplateRef?:  {
      __typename: "FieldTemplateRef",
      id: string,
      version: number,
    } | null,
    physicalExamValues?:  Array< {
      __typename: "PhysicalExamValue",
      sectionID: string,
      questionID: string,
      side?: PhysicalExamSide | null,
      value?: string | null,
      note?: string | null,
      excluded?: boolean | null,
    } | null > | null,
    physicalExamOtherFindings?:  Array< {
      __typename: "PhysicalExamOtherFinding",
      sectionID: string,
      text?: string | null,
    } | null > | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      injuries?:  Array< {
        __typename: "AssessmentInjury",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        dateOfInjuryEnd?: string | null,
        dateOfInjuryEndFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        bodyParts?: Array< BodyPart | null > | null,
        causeOfInjury?: string | null,
        causedByWork?: AssessmentCausationOption | null,
        causedByWorkExplanation?: string | null,
      } | null > | null,
      discussedBodyParts?: Array< BodyPart | null > | null,
      bodyPartsNotDiscussedReason?: string | null,
      discussions?: string | null,
      diagnoses?:  Array< {
        __typename: "AssessmentDiagnosis",
        diagnosis?: string | null,
        icdCode?: string | null,
        evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
        evidence?: string | null,
      } | null > | null,
      bodyPartMMIStatus?:  {
        __typename: "AssessmentBodyPartMMIStatus",
        discussByBodyPart?: boolean | null,
        allBodyPartsMMI?:  {
          __typename: "AssessmentBodyPartEvaluation",
          mmi?: boolean | null,
          mmiReason?: string | null,
          expectedMMITimeRange?: AssessmentMmiTimeRange | null,
          expectedMMITimeRangeExplanation?: string | null,
          treatments?: Array< string | null > | null,
          treatmentsExplanation?: string | null,
          discussions?: string | null,
          impairmentRating?: string | null,
          impairmentRatingNotApplicable?: boolean | null,
          deferImpairmentRating?: boolean | null,
          deferImpairmentRatingReason?: string | null,
          apportionment?: string | null,
          apportionmentNotApplicable?: boolean | null,
          deferApportionment?: boolean | null,
          deferApportionmentReason?: string | null,
        } | null,
        bodyPartMMIStatuses?:  Array< {
          __typename: "AssessmentBodyPart",
          bodyPart?: BodyPart | null,
        } | null > | null,
      } | null,
      workStatus?: string | null,
      markedAsDone?: boolean | null,
      discussDiagnosesFreeForm?: boolean | null,
      diagnosesFreeform?: string | null,
      discussCausationFreeForm?: boolean | null,
      causationFreeForm?: string | null,
      discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
      hasPatientReachedMMIFreeForm?: string | null,
      discussMMIByBodyPartFreeForm?: string | null,
      impairmentRatingByBodyPartFreeForm?: string | null,
      apportionmentByBodyPartFreeForm?: string | null,
      impairmentRatingOtherComments?: string | null,
      apportionmentOtherComments?: string | null,
      assessmentMode?: AssessmentMode | null,
      assessmentFreeForm?:  {
        __typename: "AssessmentFreeForm",
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussions?: string | null,
        diagnosesAndEvidence?: string | null,
        causation?: string | null,
        hasPatientReachedMMI?: string | null,
        discussMMIByBodyPart?: string | null,
        impairmentRatingByBodyPart?: string | null,
        apportionmentByBodyPart?: string | null,
        workStatus?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    opinionRecap?:  {
      __typename: "OpinionRecap",
      id: string,
      appointmentRecordID: string,
      causation?: string | null,
      diagnosis?: string | null,
      mmiFutureMedicalTreatment?: string | null,
      impairmentRating?: string | null,
      apportionment?: string | null,
      workStatus?: string | null,
      sourceReportFileID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
    featureFlags?:  Array< {
      __typename: "AppointmentFeatureConfig",
      featureFlagKey: string,
      enabled: boolean,
    } | null > | null,
    opsChecklist?:  {
      __typename: "OpsChecklist",
      panel?: OpsChecklistItemStatus | null,
      contact_info?: OpsChecklistItemStatus | null,
      all_parties?: OpsChecklistItemStatus | null,
      notice_110?: OpsChecklistItemStatus | null,
      cover_letter?: OpsChecklistItemStatus | null,
      record_review?: OpsChecklistItemStatus | null,
      history_call?: OpsChecklistItemStatus | null,
      history_of_injury?: OpsChecklistItemStatus | null,
      interpreter_info?: OpsChecklistItemStatus | null,
      jotform?: OpsChecklistItemStatus | null,
      deu_100?: OpsChecklistItemStatus | null,
      final_report?: OpsChecklistItemStatus | null,
    } | null,
    panelUnavailable?: boolean | null,
    panelSpecialty?: SpecialtyType | null,
    defenseAttorneyNotPresent?: boolean | null,
    applicantAttorneyNotPresent?: boolean | null,
    contactUnavailability?:  {
      __typename: "ParticipantContactUnavailability",
      patient?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      adjuster?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      applicantAttorney?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      defenseAttorney?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
    } | null,
    historyValidation?:  {
      __typename: "HistoryValidation",
      id: string,
      appointmentRecordID: string,
      status: HistoryValidationStatus,
      groups:  Array< {
        __typename: "HistoryValidationGroup",
        id: string,
        title: string,
        status: HistoryValidationGroupStatus,
        issues:  Array< {
          __typename: "HistoryValidationIssue",
          id: string,
          title: string,
          description?: string | null,
          patientInfoSection?: PatientInfoSection | null,
          issueType?: ValidationIssueType | null,
        } | null >,
      } | null >,
      validatedAt?: string | null,
      errorMessage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    patientHistoryValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    videoCallLink?: string | null,
    additionalTimeslots?:  Array< {
      __typename: "AdditionalTimeslot",
      date: string,
      time: string,
      locationID?: string | null,
    } | null > | null,
    mrrValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    historyMrrCrossValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseID?: string | null,
    briefingModelVersion?: BriefingModelVersion | null,
    briefingGdocExportLink?: string | null,
    briefingGdocExportedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    appointmentRecordMedicalAssistantId?: string | null,
    appointmentRecordSchedulingAssistantId?: string | null,
    appointmentRecordOnSiteOpId?: string | null,
    appointmentRecordReportOpId?: string | null,
    appointmentRecordBillingOpId?: string | null,
    appointmentRecordPreVisitReviewerId?: string | null,
    appointmentRecordHuddleNoteId?: string | null,
    appointmentRecordHistoryOfInjuryNotesId?: string | null,
    appointmentRecordCurrentComplaintNotesId?: string | null,
    appointmentRecordHistoryCallAssistantId?: string | null,
    appointmentRecordHistoryOfInjuryInsightsId?: string | null,
    appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
    appointmentRecordPhysicalExamInsightsId?: string | null,
    appointmentRecordPastInjuryMatrixId?: string | null,
    appointmentRecordBriefingId?: string | null,
    appointmentRecordIntroParagraphId?: string | null,
    appointmentRecordAssessmentId?: string | null,
    appointmentRecordAssessmentValidationId?: string | null,
    appointmentRecordOpinionRecapId?: string | null,
    appointmentRecordHistoryValidationId?: string | null,
    appointmentRecordPatientHistoryValidationId?: string | null,
    appointmentRecordMrrValidationId?: string | null,
    appointmentRecordHistoryMrrCrossValidationId?: string | null,
  } | null,
};

export type DeleteAppointmentRecordMutationVariables = {
  input: DeleteAppointmentRecordInput,
  condition?: ModelAppointmentRecordConditionInput | null,
};

export type DeleteAppointmentRecordMutation = {
  deleteAppointmentRecord?:  {
    __typename: "AppointmentRecord",
    id: string,
    doctorOwnerCognitoId?: string | null,
    assistantCognitoIds?: Array< string > | null,
    globalPartitionKey: string,
    originalAppointmentID: string,
    supplementalAppointmentIDs?: Array< string | null > | null,
    supplementalSourceAppointmentIDs?: Array< string | null > | null,
    depositionAppointmentIDs?: Array< string | null > | null,
    depositionSourceAppointmentIDs?: Array< string | null > | null,
    rescheduledFromAppointmentID?: string | null,
    rescheduledToAppointmentID?: string | null,
    date?: string | null,
    yearMonth?: string | null,
    doctorYearMonth?: string | null,
    time?: string | null,
    bookedInFlexibleTime?: boolean | null,
    inquiryDate: string,
    inquiryYearMonth: string,
    type?: AppointmentType | null,
    doctorID?: string | null,
    doctor?:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null,
    locationID?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    } | null,
    visitForm?: string | null,
    jotformSubmissions?:  Array< {
      __typename: "JotformSubmission",
      id: string,
      receivedAt: string,
      populatedAt?: string | null,
    } | null > | null,
    historyTranscriptPopulations?:  Array< {
      __typename: "HistoryTranscriptPopulation",
      uploadedFileID: string,
      populatedAt: string,
    } | null > | null,
    active?: boolean | null,
    durationMinutes?: number | null,
    reportDue?: string | null,
    reportSubmitted?: string | null,
    status?: AppointmentStatus | null,
    reportStatus?: ReportStatus | null,
    paymentStatus?: PaymentStatus | null,
    billingStatus?: BillingStatus | null,
    difficultyLevel?: number | null,
    scheduler?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    medicalAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    schedulingAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    onSiteOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    reportOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    billingOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    preVisitReviewer?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    inquirerInfo?:  {
      __typename: "InquirerInfo",
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      inquiringParty?: InquiringParty | null,
      name?: string | null,
      inquiryDate?: string | null,
      notification_110_required?: boolean | null,
    } | null,
    notes?:  {
      __typename: "ModelNotesConnection",
      items:  Array< {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    huddleNote?:  {
      __typename: "HuddleNote",
      id: string,
      appointmentRecordID: string,
      contentMarkdown?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    patientCases?:  {
      __typename: "ModelAppointmentRecordPatientCaseConnection",
      items:  Array< {
        __typename: "AppointmentRecordPatientCase",
        id: string,
        appointmentRecordId: string,
        patientCaseId: string,
        appointmentRecord:  {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        },
        patientCase:  {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    employments?:  Array< {
      __typename: "EmploymentRecord",
      employerName?: string | null,
      jobTitle?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      dateOfHire?: string | null,
      dateOfHireFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      hoursPerWeek?: string | null,
      jobDuties?: string | null,
      dateOfTermination?: string | null,
      dateOfTerminationFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
      stillWorkingHere?: boolean | null,
      type?: EmploymentType | null,
      currentWorkRestrictions?: string | null,
      workStatus?: string | null,
      departureReason?: string | null,
    } | null > | null,
    employmentGaps?:  Array< {
      __typename: "EmploymentGapRecord",
      type?: EmploymentGapType | null,
      startDate?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      endDate?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
    } | null > | null,
    patientDescribedInjuries?: Array< BodyPart | null > | null,
    uploadedFilesSet?:  {
      __typename: "UploadedFileSet",
      id: string,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      uploadedFiles?:  {
        __typename: "ModelUploadedFileConnection",
        items:  Array< {
          __typename: "UploadedFile",
          id: string,
          key?: string | null,
          fileName?: string | null,
          type?: FileType | null,
          provider?: FileProvider | null,
          uploadedBy?: string | null,
          uploadedAt?: string | null,
          fileSizeBytes?: number | null,
          fileSetID?: string | null,
          sourceAppointmentID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploadedFilesSetID?: string | null,
    referredBy?: string | null,
    s3FileKey?: string | null,
    medicalRecordsReceived?: boolean | null,
    medicalRecordsBriefingFileID?: string | null,
    medicalRecordsBriefingExecutionArn?: string | null,
    medicalRecordsTotalPagesProcessed?: number | null,
    reportGenerationFileID?: string | null,
    reportGenerationExecutionArn?: string | null,
    reportGenerationGeneratedAt?: string | null,
    historyOfInjuryFileID?: string | null,
    historyOfInjuryGeneratedAt?: string | null,
    evaluationFileID?: string | null,
    assessmentFileID?: string | null,
    depositionPreparationFileID?: string | null,
    documentStatus?:  {
      __typename: "DocumentStatus",
      evaluationPublished?: boolean | null,
      assessmentPublished?: boolean | null,
      historyInProgress?: boolean | null,
      historyPublished?: boolean | null,
      historyCleaned?: boolean | null,
      reportPublished?: boolean | null,
      briefingInProgress?: boolean | null,
      briefingPublished?: boolean | null,
      briefingCleaned?: boolean | null,
    } | null,
    cancellationReason?: CancellationReason | null,
    cancellationRequestedBy?: ParticipantType | null,
    cancellationRequestedInternally?: boolean | null,
    cancellationNote?: string | null,
    cancellationDate?: string | null,
    inquiryClosingReason?: InquiryClosingReason | null,
    inquiryClosingNote?: string | null,
    inquiryClosingDate?: string | null,
    noShowReason?: NoShowReason | null,
    noShowNote?: string | null,
    reschedulingReason?: ReschedulingReason | null,
    reschedulingOthersReason?: string | null,
    reschedulingRequestedBy?: ParticipantType | null,
    reschedulingRequestedInternally?: boolean | null,
    reschedulingNote?: string | null,
    reschedulingDate?: string | null,
    interpreter?:  {
      __typename: "InterpreterInfo",
      certificateId?: string | null,
      name?: string | null,
      companyName?: string | null,
      phoneNumber?: string | null,
      phoneExtension?: string | null,
      note?: string | null,
      confirmed?: boolean | null,
    } | null,
    historyOfInjuryNotes?:  {
      __typename: "Notes",
      id: string,
      content?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      type?: NotesType | null,
      timeStamp?: number | null,
      appointmentrecordID: string,
      createdAt: string,
      updatedAt: string,
      notesAuthorId?: string | null,
    } | null,
    currentComplaintNotes?:  {
      __typename: "Notes",
      id: string,
      content?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      type?: NotesType | null,
      timeStamp?: number | null,
      appointmentrecordID: string,
      createdAt: string,
      updatedAt: string,
      notesAuthorId?: string | null,
    } | null,
    historyCallDate?: string | null,
    historyCallTime?: string | null,
    historyCallAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    historyCallCompleted?: boolean | null,
    historyCallCompletedWithoutRecords?: boolean | null,
    historyCallCompletedOnSite?: boolean | null,
    historyCallNoShow?: boolean | null,
    historyCallCalendarEventID?: string | null,
    historyCallCalendarLink?: string | null,
    billingInfo?:  {
      __typename: "BillingInfo",
      diagnosisMappings?:  Array< {
        __typename: "DiagnosisMapping",
        code?: string | null,
        pointer?: string | null,
        description?: string | null,
      } | null > | null,
      serviceDetails?:  Array< {
        __typename: "ServiceDetail",
        dateOfStart?: string | null,
        dateOfEnd?: string | null,
        place?: number | null,
        emergencyIndicator?: boolean | null,
        serviceType?: ServiceType | null,
        modifiers?: Array< ServiceModifier | null > | null,
        diagnosisPointers?: Array< string | null > | null,
        chargedAmount?: number | null,
        quantity?: number | null,
        amountPaid?: number | null,
        renderingProviderId?: string | null,
      } | null > | null,
      totalCharge?: number | null,
      amountPaid?: number | null,
      billingCounter?: number | null,
      billedDate?: string | null,
      paidDate?: string | null,
      correctionDate?: string | null,
    } | null,
    caseInfo?:  {
      __typename: "CaseInfo",
      confirmationEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
      recordsFollowupEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
      attendanceEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
    } | null,
    isProd?: boolean | null,
    isDemo?: boolean | null,
    primaryPatientCaseID?: string | null,
    calendarEventID?: string | null,
    reportConfiguration?:  {
      __typename: "ReportConfiguration",
      history?: ReportSource | null,
      physicalExamination?: ReportSource | null,
      assessment?: ReportSource | null,
    } | null,
    workflowExecutions?:  {
      __typename: "ModelWorkflowExecutionConnection",
      items:  Array< {
        __typename: "WorkflowExecution",
        executionArn: string,
        appointmentRecordID: string,
        type?: WorkflowExecutionType | null,
        status?: WorkflowExecutionStatus | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    historyOfInjuryInsights?:  {
      __typename: "HistoryOfInjuryInsights",
      id: string,
      appointmentRecordID: string,
      mechanismOfInjury?: string | null,
      employerJobDescription?: string | null,
      injuryCausations?:  Array< {
        __typename: "InjuryCausationInfo",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryEnd?: string | null,
        bodyParts?: Array< BodyPart | null > | null,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
      } | null > | null,
      currentSymptoms?:  Array< {
        __typename: "Symptom",
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      priorSymptomsBeforeCurrentInjury?:  Array< {
        __typename: "Symptom",
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      previousSurgeries?:  Array< {
        __typename: "SurgeryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        type?: string | null,
      } | null > | null,
      previousWorkInjuries?:  Array< {
        __typename: "InjuryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      previousInjuries?:  Array< {
        __typename: "InjuryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      injuryEmploymentStatus?: string | null,
      currentWorkRestrictionsFromPatient?: string | null,
      activitiesOfDailyLiving?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reviewOfMedicalRecordsInsights?:  {
      __typename: "ReviewOfMedicalRecordsInsights",
      id: string,
      appointmentRecordID: string,
      latestDiagnosis?:  Array< {
        __typename: "BodyPartDiagnosis",
        bodyPart?: string | null,
        date?: string | null,
        descriptions?: Array< string | null > | null,
      } | null > | null,
      diagnosticStudies?:  Array< {
        __typename: "DiagnosticStudy",
        date?: string | null,
        typeOfStudy?: DiagnosticStudyType | null,
        bodyPart?: string | null,
        impression?: string | null,
        source?: DiagnosticStudySource | null,
      } | null > | null,
      treatments?:  Array< {
        __typename: "TreatmentWrapper",
        discreteTreatment?:  {
          __typename: "DiscreteTreatment",
          date?: string | null,
          treatmentType?: DiscreteTreatmentType | null,
          bodyPart?: string | null,
          description?: string | null,
        } | null,
        recurringTreatment?:  {
          __typename: "RecurringTreatment",
          year?: string | null,
          treatmentType?: RecurringTreatmentType | null,
          frequency?: string | null,
          description?: string | null,
        } | null,
      } | null > | null,
      currentWorkRestrictionsFromMedicalRecords?: string | null,
      previousReports?:  Array< {
        __typename: "PreviousReport",
        date?: string | null,
        reportType?: string | null,
        reportContent?: string | null,
      } | null > | null,
      durableMedicalEquipment?:  Array< {
        __typename: "DurableMedicalEquipment",
        startDate?: string | null,
        endDate?: string | null,
        bodyParts?: Array< string | null > | null,
        equipmentType?: string | null,
        description?: string | null,
      } | null > | null,
      derivedFromDocumentInsightIDs?: Array< string | null > | null,
      derivedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    physicalExamInsights?:  {
      __typename: "PhysicalExamInsights",
      id: string,
      appointmentRecordID: string,
      physicalExaminationInfo?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    pastInjuryMatrix?:  {
      __typename: "PastInjuryMatrix",
      id: string,
      appointmentRecordID: string,
      preExistingConditions: Array< string >,
      familyHistory: Array< string >,
      injuryMatrix:  Array< {
        __typename: "InjuryMatrixEntry",
        date: string,
        bodyPart: BodyPart,
        status: InjuryStatus,
      } >,
      createdAt: string,
      updatedAt: string,
    } | null,
    briefing?:  {
      __typename: "RecordBriefing",
      id: string,
      logicalBriefingID: string,
      segmentMappings?:  {
        __typename: "ModelRecordBriefingSegmentMappingConnection",
        items:  Array< {
          __typename: "RecordBriefingSegmentMapping",
          id: string,
          briefingID: string,
          logicalSegmentID: string,
          publishedSegmentID?: string | null,
          draftSegmentID?: string | null,
          markedForDeletion?: boolean | null,
          markedForCreation?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      googleDocExportLink?: string | null,
      googleDocExportedAt?: string | null,
      suggestionGeneration?:  {
        __typename: "SuggestionGenerationJob",
        status?: SuggestionGenerationStatus | null,
        jobId?: string | null,
        startedAt?: string | null,
        completedAt?: string | null,
        error?: string | null,
      } | null,
      editingPresence?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    introParagraph?:  {
      __typename: "IntroParagraph",
      id: string,
      appointmentRecordID: string,
      introParagraphText?: string | null,
      sourceRecaps?:  Array< {
        __typename: "CoverLetterRecapSnapshot",
        coverLetterRecapID: string,
        uploadedFileID: string,
        recapText: string,
        generatedAt?: string | null,
      } | null > | null,
      status: IntroParagraphStatus,
      errorMessage?: string | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    impairmentRatingResults?:  Array< {
      __typename: "ImpairmentRatingResult",
      ts?: number | null,
      bodyParts?: Array< string | null > | null,
      enabledStrictRating?: boolean | null,
      enabledPainRating?: boolean | null,
      enabledAG?: boolean | null,
      enabledStrengthRating?: boolean | null,
      enabledDBE?: boolean | null,
      autoMode?: boolean | null,
      result?: string | null,
      resultFeedback?:  {
        __typename: "ImpairmentRatingResultFeedback",
        exists?: boolean | null,
        isGood?: boolean | null,
        notes?: string | null,
      } | null,
    } | null > | null,
    defenseAttorneyPagesDeclaration?: number | null,
    applicantAttorneyPagesDeclaration?: number | null,
    fieldTemplateRef?:  {
      __typename: "FieldTemplateRef",
      id: string,
      version: number,
    } | null,
    dataFieldValuesMappings?:  Array< {
      __typename: "DataFieldValueMapping",
      dataFieldID?: string | null,
      value?: string | null,
    } | null > | null,
    physicalEvalTemplateRef?:  {
      __typename: "FieldTemplateRef",
      id: string,
      version: number,
    } | null,
    physicalExamValues?:  Array< {
      __typename: "PhysicalExamValue",
      sectionID: string,
      questionID: string,
      side?: PhysicalExamSide | null,
      value?: string | null,
      note?: string | null,
      excluded?: boolean | null,
    } | null > | null,
    physicalExamOtherFindings?:  Array< {
      __typename: "PhysicalExamOtherFinding",
      sectionID: string,
      text?: string | null,
    } | null > | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      injuries?:  Array< {
        __typename: "AssessmentInjury",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        dateOfInjuryEnd?: string | null,
        dateOfInjuryEndFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        bodyParts?: Array< BodyPart | null > | null,
        causeOfInjury?: string | null,
        causedByWork?: AssessmentCausationOption | null,
        causedByWorkExplanation?: string | null,
      } | null > | null,
      discussedBodyParts?: Array< BodyPart | null > | null,
      bodyPartsNotDiscussedReason?: string | null,
      discussions?: string | null,
      diagnoses?:  Array< {
        __typename: "AssessmentDiagnosis",
        diagnosis?: string | null,
        icdCode?: string | null,
        evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
        evidence?: string | null,
      } | null > | null,
      bodyPartMMIStatus?:  {
        __typename: "AssessmentBodyPartMMIStatus",
        discussByBodyPart?: boolean | null,
        allBodyPartsMMI?:  {
          __typename: "AssessmentBodyPartEvaluation",
          mmi?: boolean | null,
          mmiReason?: string | null,
          expectedMMITimeRange?: AssessmentMmiTimeRange | null,
          expectedMMITimeRangeExplanation?: string | null,
          treatments?: Array< string | null > | null,
          treatmentsExplanation?: string | null,
          discussions?: string | null,
          impairmentRating?: string | null,
          impairmentRatingNotApplicable?: boolean | null,
          deferImpairmentRating?: boolean | null,
          deferImpairmentRatingReason?: string | null,
          apportionment?: string | null,
          apportionmentNotApplicable?: boolean | null,
          deferApportionment?: boolean | null,
          deferApportionmentReason?: string | null,
        } | null,
        bodyPartMMIStatuses?:  Array< {
          __typename: "AssessmentBodyPart",
          bodyPart?: BodyPart | null,
        } | null > | null,
      } | null,
      workStatus?: string | null,
      markedAsDone?: boolean | null,
      discussDiagnosesFreeForm?: boolean | null,
      diagnosesFreeform?: string | null,
      discussCausationFreeForm?: boolean | null,
      causationFreeForm?: string | null,
      discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
      hasPatientReachedMMIFreeForm?: string | null,
      discussMMIByBodyPartFreeForm?: string | null,
      impairmentRatingByBodyPartFreeForm?: string | null,
      apportionmentByBodyPartFreeForm?: string | null,
      impairmentRatingOtherComments?: string | null,
      apportionmentOtherComments?: string | null,
      assessmentMode?: AssessmentMode | null,
      assessmentFreeForm?:  {
        __typename: "AssessmentFreeForm",
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussions?: string | null,
        diagnosesAndEvidence?: string | null,
        causation?: string | null,
        hasPatientReachedMMI?: string | null,
        discussMMIByBodyPart?: string | null,
        impairmentRatingByBodyPart?: string | null,
        apportionmentByBodyPart?: string | null,
        workStatus?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    opinionRecap?:  {
      __typename: "OpinionRecap",
      id: string,
      appointmentRecordID: string,
      causation?: string | null,
      diagnosis?: string | null,
      mmiFutureMedicalTreatment?: string | null,
      impairmentRating?: string | null,
      apportionment?: string | null,
      workStatus?: string | null,
      sourceReportFileID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
    featureFlags?:  Array< {
      __typename: "AppointmentFeatureConfig",
      featureFlagKey: string,
      enabled: boolean,
    } | null > | null,
    opsChecklist?:  {
      __typename: "OpsChecklist",
      panel?: OpsChecklistItemStatus | null,
      contact_info?: OpsChecklistItemStatus | null,
      all_parties?: OpsChecklistItemStatus | null,
      notice_110?: OpsChecklistItemStatus | null,
      cover_letter?: OpsChecklistItemStatus | null,
      record_review?: OpsChecklistItemStatus | null,
      history_call?: OpsChecklistItemStatus | null,
      history_of_injury?: OpsChecklistItemStatus | null,
      interpreter_info?: OpsChecklistItemStatus | null,
      jotform?: OpsChecklistItemStatus | null,
      deu_100?: OpsChecklistItemStatus | null,
      final_report?: OpsChecklistItemStatus | null,
    } | null,
    panelUnavailable?: boolean | null,
    panelSpecialty?: SpecialtyType | null,
    defenseAttorneyNotPresent?: boolean | null,
    applicantAttorneyNotPresent?: boolean | null,
    contactUnavailability?:  {
      __typename: "ParticipantContactUnavailability",
      patient?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      adjuster?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      applicantAttorney?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      defenseAttorney?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
    } | null,
    historyValidation?:  {
      __typename: "HistoryValidation",
      id: string,
      appointmentRecordID: string,
      status: HistoryValidationStatus,
      groups:  Array< {
        __typename: "HistoryValidationGroup",
        id: string,
        title: string,
        status: HistoryValidationGroupStatus,
        issues:  Array< {
          __typename: "HistoryValidationIssue",
          id: string,
          title: string,
          description?: string | null,
          patientInfoSection?: PatientInfoSection | null,
          issueType?: ValidationIssueType | null,
        } | null >,
      } | null >,
      validatedAt?: string | null,
      errorMessage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    patientHistoryValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    videoCallLink?: string | null,
    additionalTimeslots?:  Array< {
      __typename: "AdditionalTimeslot",
      date: string,
      time: string,
      locationID?: string | null,
    } | null > | null,
    mrrValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    historyMrrCrossValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseID?: string | null,
    briefingModelVersion?: BriefingModelVersion | null,
    briefingGdocExportLink?: string | null,
    briefingGdocExportedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    appointmentRecordMedicalAssistantId?: string | null,
    appointmentRecordSchedulingAssistantId?: string | null,
    appointmentRecordOnSiteOpId?: string | null,
    appointmentRecordReportOpId?: string | null,
    appointmentRecordBillingOpId?: string | null,
    appointmentRecordPreVisitReviewerId?: string | null,
    appointmentRecordHuddleNoteId?: string | null,
    appointmentRecordHistoryOfInjuryNotesId?: string | null,
    appointmentRecordCurrentComplaintNotesId?: string | null,
    appointmentRecordHistoryCallAssistantId?: string | null,
    appointmentRecordHistoryOfInjuryInsightsId?: string | null,
    appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
    appointmentRecordPhysicalExamInsightsId?: string | null,
    appointmentRecordPastInjuryMatrixId?: string | null,
    appointmentRecordBriefingId?: string | null,
    appointmentRecordIntroParagraphId?: string | null,
    appointmentRecordAssessmentId?: string | null,
    appointmentRecordAssessmentValidationId?: string | null,
    appointmentRecordOpinionRecapId?: string | null,
    appointmentRecordHistoryValidationId?: string | null,
    appointmentRecordPatientHistoryValidationId?: string | null,
    appointmentRecordMrrValidationId?: string | null,
    appointmentRecordHistoryMrrCrossValidationId?: string | null,
  } | null,
};

export type CreatePatientMutationVariables = {
  input: CreatePatientInput,
  condition?: ModelPatientConditionInput | null,
};

export type CreatePatientMutation = {
  createPatient?:  {
    __typename: "Patient",
    id: string,
    name?: string | null,
    dateOfBirth?: string | null,
    SSN?: string | null,
    language?: Language | null,
    dominantHand?: DominantHand | null,
    cases?:  {
      __typename: "ModelPatientCaseConnection",
      items:  Array< {
        __typename: "PatientCase",
        id: string,
        patientID: string,
        patient?:  {
          __typename: "Patient",
          id: string,
          name?: string | null,
          dateOfBirth?: string | null,
          SSN?: string | null,
          language?: Language | null,
          dominantHand?: DominantHand | null,
          occupation?: string | null,
          sex?: Sex | null,
          weightLb?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        claimNumber: string,
        qmePanelNumber?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        injuryInfo?:  {
          __typename: "InjuryInfo",
          injuryType?: InjuryType | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          claimedBodyParts?: Array< BodyPart | null > | null,
          description?: string | null,
          dateOfInjury?: string | null,
          startDateOfInjury?: string | null,
        } | null,
        workersCompInsurance?:  {
          __typename: "WorkersCompInsuranceInfo",
          insuranceCarrier?: string | null,
          adjuster?: string | null,
        } | null,
        insuranceCarrierID?: string | null,
        insuranceCarrier?:  {
          __typename: "InsuranceCarrier",
          id: string,
          name: string,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierAddressID?: string | null,
        insuranceCarrierAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierFaxNumberID?: string | null,
        insuranceCarrierFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierPhoneNumberID?: string | null,
        insuranceCarrierPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        applicantAttorney?:  {
          __typename: "AttorneyInfo",
          name?: string | null,
          lawFirmName?: string | null,
        } | null,
        applicantAttorneyLawFirmID?: string | null,
        applicantAttorneyLawFirm?:  {
          __typename: "LawFirm",
          id: string,
          name: string,
          type: LawFirmType,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyAddressID?: string | null,
        applicantAttorneyAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyFaxNumberID?: string | null,
        applicantAttorneyFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyPhoneNumberID?: string | null,
        applicantAttorneyPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorney?:  {
          __typename: "AttorneyInfo",
          name?: string | null,
          lawFirmName?: string | null,
        } | null,
        defenseAttorneyLawFirmID?: string | null,
        defenseAttorneyLawFirm?:  {
          __typename: "LawFirm",
          id: string,
          name: string,
          type: LawFirmType,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyAddressID?: string | null,
        defenseAttorneyAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyFaxNumberID?: string | null,
        defenseAttorneyFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyPhoneNumberID?: string | null,
        defenseAttorneyPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nurseCaseManager?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        ccPerson?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        applicantAttorneyCcEmails?: Array< string | null > | null,
        defenseAttorneyCcEmails?: Array< string | null > | null,
        adjusterCcEmails?: Array< string | null > | null,
        scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
        employmentAtInjury?:  {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null,
        WCAB?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    occupation?: string | null,
    sex?: Sex | null,
    weightLb?: number | null,
    height?:  {
      __typename: "Height",
      feet?: number | null,
      inches?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePatientMutationVariables = {
  input: UpdatePatientInput,
  condition?: ModelPatientConditionInput | null,
};

export type UpdatePatientMutation = {
  updatePatient?:  {
    __typename: "Patient",
    id: string,
    name?: string | null,
    dateOfBirth?: string | null,
    SSN?: string | null,
    language?: Language | null,
    dominantHand?: DominantHand | null,
    cases?:  {
      __typename: "ModelPatientCaseConnection",
      items:  Array< {
        __typename: "PatientCase",
        id: string,
        patientID: string,
        patient?:  {
          __typename: "Patient",
          id: string,
          name?: string | null,
          dateOfBirth?: string | null,
          SSN?: string | null,
          language?: Language | null,
          dominantHand?: DominantHand | null,
          occupation?: string | null,
          sex?: Sex | null,
          weightLb?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        claimNumber: string,
        qmePanelNumber?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        injuryInfo?:  {
          __typename: "InjuryInfo",
          injuryType?: InjuryType | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          claimedBodyParts?: Array< BodyPart | null > | null,
          description?: string | null,
          dateOfInjury?: string | null,
          startDateOfInjury?: string | null,
        } | null,
        workersCompInsurance?:  {
          __typename: "WorkersCompInsuranceInfo",
          insuranceCarrier?: string | null,
          adjuster?: string | null,
        } | null,
        insuranceCarrierID?: string | null,
        insuranceCarrier?:  {
          __typename: "InsuranceCarrier",
          id: string,
          name: string,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierAddressID?: string | null,
        insuranceCarrierAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierFaxNumberID?: string | null,
        insuranceCarrierFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierPhoneNumberID?: string | null,
        insuranceCarrierPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        applicantAttorney?:  {
          __typename: "AttorneyInfo",
          name?: string | null,
          lawFirmName?: string | null,
        } | null,
        applicantAttorneyLawFirmID?: string | null,
        applicantAttorneyLawFirm?:  {
          __typename: "LawFirm",
          id: string,
          name: string,
          type: LawFirmType,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyAddressID?: string | null,
        applicantAttorneyAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyFaxNumberID?: string | null,
        applicantAttorneyFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyPhoneNumberID?: string | null,
        applicantAttorneyPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorney?:  {
          __typename: "AttorneyInfo",
          name?: string | null,
          lawFirmName?: string | null,
        } | null,
        defenseAttorneyLawFirmID?: string | null,
        defenseAttorneyLawFirm?:  {
          __typename: "LawFirm",
          id: string,
          name: string,
          type: LawFirmType,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyAddressID?: string | null,
        defenseAttorneyAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyFaxNumberID?: string | null,
        defenseAttorneyFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyPhoneNumberID?: string | null,
        defenseAttorneyPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nurseCaseManager?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        ccPerson?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        applicantAttorneyCcEmails?: Array< string | null > | null,
        defenseAttorneyCcEmails?: Array< string | null > | null,
        adjusterCcEmails?: Array< string | null > | null,
        scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
        employmentAtInjury?:  {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null,
        WCAB?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    occupation?: string | null,
    sex?: Sex | null,
    weightLb?: number | null,
    height?:  {
      __typename: "Height",
      feet?: number | null,
      inches?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePatientMutationVariables = {
  input: DeletePatientInput,
  condition?: ModelPatientConditionInput | null,
};

export type DeletePatientMutation = {
  deletePatient?:  {
    __typename: "Patient",
    id: string,
    name?: string | null,
    dateOfBirth?: string | null,
    SSN?: string | null,
    language?: Language | null,
    dominantHand?: DominantHand | null,
    cases?:  {
      __typename: "ModelPatientCaseConnection",
      items:  Array< {
        __typename: "PatientCase",
        id: string,
        patientID: string,
        patient?:  {
          __typename: "Patient",
          id: string,
          name?: string | null,
          dateOfBirth?: string | null,
          SSN?: string | null,
          language?: Language | null,
          dominantHand?: DominantHand | null,
          occupation?: string | null,
          sex?: Sex | null,
          weightLb?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        claimNumber: string,
        qmePanelNumber?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        injuryInfo?:  {
          __typename: "InjuryInfo",
          injuryType?: InjuryType | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          claimedBodyParts?: Array< BodyPart | null > | null,
          description?: string | null,
          dateOfInjury?: string | null,
          startDateOfInjury?: string | null,
        } | null,
        workersCompInsurance?:  {
          __typename: "WorkersCompInsuranceInfo",
          insuranceCarrier?: string | null,
          adjuster?: string | null,
        } | null,
        insuranceCarrierID?: string | null,
        insuranceCarrier?:  {
          __typename: "InsuranceCarrier",
          id: string,
          name: string,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierAddressID?: string | null,
        insuranceCarrierAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierFaxNumberID?: string | null,
        insuranceCarrierFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierPhoneNumberID?: string | null,
        insuranceCarrierPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        applicantAttorney?:  {
          __typename: "AttorneyInfo",
          name?: string | null,
          lawFirmName?: string | null,
        } | null,
        applicantAttorneyLawFirmID?: string | null,
        applicantAttorneyLawFirm?:  {
          __typename: "LawFirm",
          id: string,
          name: string,
          type: LawFirmType,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyAddressID?: string | null,
        applicantAttorneyAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyFaxNumberID?: string | null,
        applicantAttorneyFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyPhoneNumberID?: string | null,
        applicantAttorneyPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorney?:  {
          __typename: "AttorneyInfo",
          name?: string | null,
          lawFirmName?: string | null,
        } | null,
        defenseAttorneyLawFirmID?: string | null,
        defenseAttorneyLawFirm?:  {
          __typename: "LawFirm",
          id: string,
          name: string,
          type: LawFirmType,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyAddressID?: string | null,
        defenseAttorneyAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyFaxNumberID?: string | null,
        defenseAttorneyFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyPhoneNumberID?: string | null,
        defenseAttorneyPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nurseCaseManager?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        ccPerson?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        applicantAttorneyCcEmails?: Array< string | null > | null,
        defenseAttorneyCcEmails?: Array< string | null > | null,
        adjusterCcEmails?: Array< string | null > | null,
        scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
        employmentAtInjury?:  {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null,
        WCAB?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    occupation?: string | null,
    sex?: Sex | null,
    weightLb?: number | null,
    height?:  {
      __typename: "Height",
      feet?: number | null,
      inches?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePatientCaseMutationVariables = {
  input: CreatePatientCaseInput,
  condition?: ModelPatientCaseConditionInput | null,
};

export type CreatePatientCaseMutation = {
  createPatientCase?:  {
    __typename: "PatientCase",
    id: string,
    patientID: string,
    patient?:  {
      __typename: "Patient",
      id: string,
      name?: string | null,
      dateOfBirth?: string | null,
      SSN?: string | null,
      language?: Language | null,
      dominantHand?: DominantHand | null,
      cases?:  {
        __typename: "ModelPatientCaseConnection",
        items:  Array< {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      occupation?: string | null,
      sex?: Sex | null,
      weightLb?: number | null,
      height?:  {
        __typename: "Height",
        feet?: number | null,
        inches?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    claimNumber: string,
    qmePanelNumber?: string | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    injuryInfo?:  {
      __typename: "InjuryInfo",
      injuryType?: InjuryType | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      claimedBodyParts?: Array< BodyPart | null > | null,
      description?: string | null,
      dateOfInjury?: string | null,
      dateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      startDateOfInjury?: string | null,
      startDateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
    } | null,
    workersCompInsurance?:  {
      __typename: "WorkersCompInsuranceInfo",
      insuranceCarrier?: string | null,
      adjuster?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    insuranceCarrierID?: string | null,
    insuranceCarrier?:  {
      __typename: "InsuranceCarrier",
      id: string,
      name: string,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierAddressID?: string | null,
    insuranceCarrierAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierFaxNumberID?: string | null,
    insuranceCarrierFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierPhoneNumberID?: string | null,
    insuranceCarrierPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordPatientCaseConnection",
      items:  Array< {
        __typename: "AppointmentRecordPatientCase",
        id: string,
        appointmentRecordId: string,
        patientCaseId: string,
        appointmentRecord:  {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        },
        patientCase:  {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    applicantAttorney?:  {
      __typename: "AttorneyInfo",
      name?: string | null,
      lawFirmName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    applicantAttorneyLawFirmID?: string | null,
    applicantAttorneyLawFirm?:  {
      __typename: "LawFirm",
      id: string,
      name: string,
      type: LawFirmType,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyAddressID?: string | null,
    applicantAttorneyAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyFaxNumberID?: string | null,
    applicantAttorneyFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyPhoneNumberID?: string | null,
    applicantAttorneyPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorney?:  {
      __typename: "AttorneyInfo",
      name?: string | null,
      lawFirmName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    defenseAttorneyLawFirmID?: string | null,
    defenseAttorneyLawFirm?:  {
      __typename: "LawFirm",
      id: string,
      name: string,
      type: LawFirmType,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyAddressID?: string | null,
    defenseAttorneyAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyFaxNumberID?: string | null,
    defenseAttorneyFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyPhoneNumberID?: string | null,
    defenseAttorneyPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nurseCaseManager?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    ccPerson?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    applicantAttorneyCcEmails?: Array< string | null > | null,
    defenseAttorneyCcEmails?: Array< string | null > | null,
    adjusterCcEmails?: Array< string | null > | null,
    scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
    employmentAtInjury?:  {
      __typename: "EmploymentRecord",
      employerName?: string | null,
      jobTitle?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      dateOfHire?: string | null,
      dateOfHireFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      hoursPerWeek?: string | null,
      jobDuties?: string | null,
      dateOfTermination?: string | null,
      dateOfTerminationFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
      stillWorkingHere?: boolean | null,
      type?: EmploymentType | null,
      currentWorkRestrictions?: string | null,
      workStatus?: string | null,
      departureReason?: string | null,
    } | null,
    WCAB?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePatientCaseMutationVariables = {
  input: UpdatePatientCaseInput,
  condition?: ModelPatientCaseConditionInput | null,
};

export type UpdatePatientCaseMutation = {
  updatePatientCase?:  {
    __typename: "PatientCase",
    id: string,
    patientID: string,
    patient?:  {
      __typename: "Patient",
      id: string,
      name?: string | null,
      dateOfBirth?: string | null,
      SSN?: string | null,
      language?: Language | null,
      dominantHand?: DominantHand | null,
      cases?:  {
        __typename: "ModelPatientCaseConnection",
        items:  Array< {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      occupation?: string | null,
      sex?: Sex | null,
      weightLb?: number | null,
      height?:  {
        __typename: "Height",
        feet?: number | null,
        inches?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    claimNumber: string,
    qmePanelNumber?: string | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    injuryInfo?:  {
      __typename: "InjuryInfo",
      injuryType?: InjuryType | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      claimedBodyParts?: Array< BodyPart | null > | null,
      description?: string | null,
      dateOfInjury?: string | null,
      dateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      startDateOfInjury?: string | null,
      startDateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
    } | null,
    workersCompInsurance?:  {
      __typename: "WorkersCompInsuranceInfo",
      insuranceCarrier?: string | null,
      adjuster?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    insuranceCarrierID?: string | null,
    insuranceCarrier?:  {
      __typename: "InsuranceCarrier",
      id: string,
      name: string,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierAddressID?: string | null,
    insuranceCarrierAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierFaxNumberID?: string | null,
    insuranceCarrierFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierPhoneNumberID?: string | null,
    insuranceCarrierPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordPatientCaseConnection",
      items:  Array< {
        __typename: "AppointmentRecordPatientCase",
        id: string,
        appointmentRecordId: string,
        patientCaseId: string,
        appointmentRecord:  {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        },
        patientCase:  {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    applicantAttorney?:  {
      __typename: "AttorneyInfo",
      name?: string | null,
      lawFirmName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    applicantAttorneyLawFirmID?: string | null,
    applicantAttorneyLawFirm?:  {
      __typename: "LawFirm",
      id: string,
      name: string,
      type: LawFirmType,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyAddressID?: string | null,
    applicantAttorneyAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyFaxNumberID?: string | null,
    applicantAttorneyFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyPhoneNumberID?: string | null,
    applicantAttorneyPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorney?:  {
      __typename: "AttorneyInfo",
      name?: string | null,
      lawFirmName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    defenseAttorneyLawFirmID?: string | null,
    defenseAttorneyLawFirm?:  {
      __typename: "LawFirm",
      id: string,
      name: string,
      type: LawFirmType,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyAddressID?: string | null,
    defenseAttorneyAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyFaxNumberID?: string | null,
    defenseAttorneyFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyPhoneNumberID?: string | null,
    defenseAttorneyPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nurseCaseManager?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    ccPerson?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    applicantAttorneyCcEmails?: Array< string | null > | null,
    defenseAttorneyCcEmails?: Array< string | null > | null,
    adjusterCcEmails?: Array< string | null > | null,
    scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
    employmentAtInjury?:  {
      __typename: "EmploymentRecord",
      employerName?: string | null,
      jobTitle?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      dateOfHire?: string | null,
      dateOfHireFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      hoursPerWeek?: string | null,
      jobDuties?: string | null,
      dateOfTermination?: string | null,
      dateOfTerminationFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
      stillWorkingHere?: boolean | null,
      type?: EmploymentType | null,
      currentWorkRestrictions?: string | null,
      workStatus?: string | null,
      departureReason?: string | null,
    } | null,
    WCAB?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePatientCaseMutationVariables = {
  input: DeletePatientCaseInput,
  condition?: ModelPatientCaseConditionInput | null,
};

export type DeletePatientCaseMutation = {
  deletePatientCase?:  {
    __typename: "PatientCase",
    id: string,
    patientID: string,
    patient?:  {
      __typename: "Patient",
      id: string,
      name?: string | null,
      dateOfBirth?: string | null,
      SSN?: string | null,
      language?: Language | null,
      dominantHand?: DominantHand | null,
      cases?:  {
        __typename: "ModelPatientCaseConnection",
        items:  Array< {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      occupation?: string | null,
      sex?: Sex | null,
      weightLb?: number | null,
      height?:  {
        __typename: "Height",
        feet?: number | null,
        inches?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    claimNumber: string,
    qmePanelNumber?: string | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    injuryInfo?:  {
      __typename: "InjuryInfo",
      injuryType?: InjuryType | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      claimedBodyParts?: Array< BodyPart | null > | null,
      description?: string | null,
      dateOfInjury?: string | null,
      dateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      startDateOfInjury?: string | null,
      startDateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
    } | null,
    workersCompInsurance?:  {
      __typename: "WorkersCompInsuranceInfo",
      insuranceCarrier?: string | null,
      adjuster?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    insuranceCarrierID?: string | null,
    insuranceCarrier?:  {
      __typename: "InsuranceCarrier",
      id: string,
      name: string,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierAddressID?: string | null,
    insuranceCarrierAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierFaxNumberID?: string | null,
    insuranceCarrierFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierPhoneNumberID?: string | null,
    insuranceCarrierPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordPatientCaseConnection",
      items:  Array< {
        __typename: "AppointmentRecordPatientCase",
        id: string,
        appointmentRecordId: string,
        patientCaseId: string,
        appointmentRecord:  {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        },
        patientCase:  {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    applicantAttorney?:  {
      __typename: "AttorneyInfo",
      name?: string | null,
      lawFirmName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    applicantAttorneyLawFirmID?: string | null,
    applicantAttorneyLawFirm?:  {
      __typename: "LawFirm",
      id: string,
      name: string,
      type: LawFirmType,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyAddressID?: string | null,
    applicantAttorneyAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyFaxNumberID?: string | null,
    applicantAttorneyFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyPhoneNumberID?: string | null,
    applicantAttorneyPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorney?:  {
      __typename: "AttorneyInfo",
      name?: string | null,
      lawFirmName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    defenseAttorneyLawFirmID?: string | null,
    defenseAttorneyLawFirm?:  {
      __typename: "LawFirm",
      id: string,
      name: string,
      type: LawFirmType,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyAddressID?: string | null,
    defenseAttorneyAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyFaxNumberID?: string | null,
    defenseAttorneyFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyPhoneNumberID?: string | null,
    defenseAttorneyPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nurseCaseManager?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    ccPerson?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    applicantAttorneyCcEmails?: Array< string | null > | null,
    defenseAttorneyCcEmails?: Array< string | null > | null,
    adjusterCcEmails?: Array< string | null > | null,
    scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
    employmentAtInjury?:  {
      __typename: "EmploymentRecord",
      employerName?: string | null,
      jobTitle?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      dateOfHire?: string | null,
      dateOfHireFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      hoursPerWeek?: string | null,
      jobDuties?: string | null,
      dateOfTermination?: string | null,
      dateOfTerminationFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
      stillWorkingHere?: boolean | null,
      type?: EmploymentType | null,
      currentWorkRestrictions?: string | null,
      workStatus?: string | null,
      departureReason?: string | null,
    } | null,
    WCAB?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDoctorMutationVariables = {
  input: CreateDoctorInput,
  condition?: ModelDoctorConditionInput | null,
};

export type CreateDoctorMutation = {
  createDoctor?:  {
    __typename: "Doctor",
    id: string,
    ownerCognitoId?: string | null,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    name?: string | null,
    signatureName?: string | null,
    status?: DoctorStatus | null,
    ramped?: boolean | null,
    title?: string | null,
    titleExtension?: TitleExtension | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    officePhone?: string | null,
    cellPhone?: string | null,
    clinicPhone?: string | null,
    workCity?: string | null,
    workState?: string | null,
    collectionRate?: number | null,
    licenseNumber?: string | null,
    licenseRenewalDate?: string | null,
    qmeLicense?:  {
      __typename: "QmeLicense",
      licenseNumber?: string | null,
      approvalDate?: string | null,
      renewalDate?: string | null,
    } | null,
    locations?:  {
      __typename: "ModelDoctorLocationConnection",
      items:  Array< {
        __typename: "DoctorLocation",
        id: string,
        doctorId: string,
        locationId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        location:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    specialties?: Array< SpecialtyType | null > | null,
    npi?: string | null,
    bankingInfo?:  {
      __typename: "BankingInfo",
      bankEntityName?: string | null,
      accountNumber?: string | null,
      routingNumber?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    availabilities?:  {
      __typename: "Availabilities",
      generalAvailabilities?:  Array< {
        __typename: "GeneralAvailability",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        recurrence?: RecurrenceType | null,
        dayOfWeek?: DayOfWeek | null,
        dayOfMonth?: number | null,
        weekOfMonth?: WeekOfMonth | null,
        monthInterval?: number | null,
        startTime?: string | null,
        endTime?: string | null,
        flexibleTimeBefore?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        flexibleTimeAfter?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        locationIDs?: Array< string | null > | null,
        isAllLocations?: boolean | null,
      } | null > | null,
      additionalAvailabilities?:  Array< {
        __typename: "AdditionalAvailability",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        flexibleTimeBefore?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        flexibleTimeAfter?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        locationIDs?: Array< string | null > | null,
        isAllLocations?: boolean | null,
      } | null > | null,
      blackoutDates?:  Array< {
        __typename: "BlackoutDate",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
    } | null,
    availabilitiesNote?: string | null,
    emails?: Array< string | null > | null,
    profileImages?:  Array< {
      __typename: "DoctorProfileImage",
      type?: DoctorProfileImageType | null,
      name?: string | null,
      order?: number | null,
      s3Prefix?: string | null,
      widthInInches?: number | null,
      heightInInches?: number | null,
    } | null > | null,
    qmeReportConfigs?:  {
      __typename: "DoctorQMEReportConfigs",
      hasIntroTitle?: boolean | null,
      introTemplate?: string | null,
    } | null,
    physicalEvalConfigs?:  {
      __typename: "DoctorPhysicalEvalConfigs",
      templates?: Array< PhysicalEvalTemplateTag | null > | null,
    } | null,
    signatureDepartment?: string | null,
    profileAssetS3Prefix?: string | null,
    calendarPreference?:  {
      __typename: "CalendarPreference",
      mailingList?: Array< string | null > | null,
      showPatientFullName?: boolean | null,
      showPatientAddress?: boolean | null,
      showPatientDOB?: boolean | null,
      showPortalLink?: boolean | null,
    } | null,
    homeOffice?:  {
      __typename: "HomeOffice",
      county?: string | null,
      state?: string | null,
    } | null,
    reportFormatPreferences?:  {
      __typename: "ReportFormatPreferences",
      evaluationReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
      reEvaluationReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
      supplementalReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
    } | null,
    evaluationInputPreferences?:  {
      __typename: "EvaluationInputPreferences",
      evaluationReport:  {
        __typename: "ReportInputPreferences",
        history: ReportSource,
        physicalExamination: ReportSource,
        assessment: ReportSource,
      },
      reEvaluationReport:  {
        __typename: "ReportInputPreferences",
        history: ReportSource,
        physicalExamination: ReportSource,
        assessment: ReportSource,
      },
      supplementalReport:  {
        __typename: "SupplementalReportInputPreferences",
        assessment: ReportSource,
      },
    } | null,
    preferredAssessmentMode?: AssessmentMode | null,
    caseSummaryFields?:  {
      __typename: "ModelDoctorCaseSummaryFieldConnection",
      items:  Array< {
        __typename: "DoctorCaseSummaryField",
        id: string,
        doctorId: string,
        caseSummaryFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        caseSummaryField:  {
          __typename: "CaseSummaryField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          summaryPrompt?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    briefingFields?:  {
      __typename: "ModelDoctorBriefingFieldConnection",
      items:  Array< {
        __typename: "DoctorBriefingField",
        id: string,
        doctorId: string,
        briefingFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        briefingField:  {
          __typename: "BriefingField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          briefingPrompt?: string | null,
          briefingRecordTypeID: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    isDemo?: boolean | null,
    fieldTemplateId?: string | null,
    templateFolderLink?: string | null,
    physicianPartner?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultPrimaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultSecondaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultScheduler?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultReportOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultPreVisitReviewer?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultBillingOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultSupplementalReportOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    supplementalReportOpsAssignments?:  Array< {
      __typename: "SupplementalReportOpsAssignment",
      medicalAssistantID: string,
      weightPercentage: number,
    } | null > | null,
    supportingMAs?:  {
      __typename: "ModelDoctorSupportingMAConnection",
      items:  Array< {
        __typename: "DoctorSupportingMA",
        id: string,
        medicalAssistantId: string,
        doctorId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultAppointmentDurationMinutes?:  {
      __typename: "DefaultAppointmentDurationMinutes",
      qme?: number | null,
      qmeReevaluation?: number | null,
      ime?: number | null,
      deposition?: number | null,
    } | null,
    defaultEarlyArrivalTimeMinutes?:  {
      __typename: "DefaultEarlyArrivalTimeMinutes",
      workersComp?: number | null,
      ime?: number | null,
      deposition?: number | null,
    } | null,
    assessmentTreatmentOptions?: Array< string | null > | null,
    dismissedProTips?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    doctorPhysicianPartnerId?: string | null,
    doctorDefaultPrimaryOnsiteOpsId?: string | null,
    doctorDefaultSecondaryOnsiteOpsId?: string | null,
    doctorDefaultSchedulerId?: string | null,
    doctorDefaultReportOpsId?: string | null,
    doctorDefaultPreVisitReviewerId?: string | null,
    doctorDefaultBillingOpsId?: string | null,
    doctorDefaultSupplementalReportOpsId?: string | null,
    doctorUserId?: string | null,
  } | null,
};

export type UpdateDoctorMutationVariables = {
  input: UpdateDoctorInput,
  condition?: ModelDoctorConditionInput | null,
};

export type UpdateDoctorMutation = {
  updateDoctor?:  {
    __typename: "Doctor",
    id: string,
    ownerCognitoId?: string | null,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    name?: string | null,
    signatureName?: string | null,
    status?: DoctorStatus | null,
    ramped?: boolean | null,
    title?: string | null,
    titleExtension?: TitleExtension | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    officePhone?: string | null,
    cellPhone?: string | null,
    clinicPhone?: string | null,
    workCity?: string | null,
    workState?: string | null,
    collectionRate?: number | null,
    licenseNumber?: string | null,
    licenseRenewalDate?: string | null,
    qmeLicense?:  {
      __typename: "QmeLicense",
      licenseNumber?: string | null,
      approvalDate?: string | null,
      renewalDate?: string | null,
    } | null,
    locations?:  {
      __typename: "ModelDoctorLocationConnection",
      items:  Array< {
        __typename: "DoctorLocation",
        id: string,
        doctorId: string,
        locationId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        location:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    specialties?: Array< SpecialtyType | null > | null,
    npi?: string | null,
    bankingInfo?:  {
      __typename: "BankingInfo",
      bankEntityName?: string | null,
      accountNumber?: string | null,
      routingNumber?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    availabilities?:  {
      __typename: "Availabilities",
      generalAvailabilities?:  Array< {
        __typename: "GeneralAvailability",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        recurrence?: RecurrenceType | null,
        dayOfWeek?: DayOfWeek | null,
        dayOfMonth?: number | null,
        weekOfMonth?: WeekOfMonth | null,
        monthInterval?: number | null,
        startTime?: string | null,
        endTime?: string | null,
        flexibleTimeBefore?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        flexibleTimeAfter?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        locationIDs?: Array< string | null > | null,
        isAllLocations?: boolean | null,
      } | null > | null,
      additionalAvailabilities?:  Array< {
        __typename: "AdditionalAvailability",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        flexibleTimeBefore?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        flexibleTimeAfter?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        locationIDs?: Array< string | null > | null,
        isAllLocations?: boolean | null,
      } | null > | null,
      blackoutDates?:  Array< {
        __typename: "BlackoutDate",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
    } | null,
    availabilitiesNote?: string | null,
    emails?: Array< string | null > | null,
    profileImages?:  Array< {
      __typename: "DoctorProfileImage",
      type?: DoctorProfileImageType | null,
      name?: string | null,
      order?: number | null,
      s3Prefix?: string | null,
      widthInInches?: number | null,
      heightInInches?: number | null,
    } | null > | null,
    qmeReportConfigs?:  {
      __typename: "DoctorQMEReportConfigs",
      hasIntroTitle?: boolean | null,
      introTemplate?: string | null,
    } | null,
    physicalEvalConfigs?:  {
      __typename: "DoctorPhysicalEvalConfigs",
      templates?: Array< PhysicalEvalTemplateTag | null > | null,
    } | null,
    signatureDepartment?: string | null,
    profileAssetS3Prefix?: string | null,
    calendarPreference?:  {
      __typename: "CalendarPreference",
      mailingList?: Array< string | null > | null,
      showPatientFullName?: boolean | null,
      showPatientAddress?: boolean | null,
      showPatientDOB?: boolean | null,
      showPortalLink?: boolean | null,
    } | null,
    homeOffice?:  {
      __typename: "HomeOffice",
      county?: string | null,
      state?: string | null,
    } | null,
    reportFormatPreferences?:  {
      __typename: "ReportFormatPreferences",
      evaluationReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
      reEvaluationReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
      supplementalReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
    } | null,
    evaluationInputPreferences?:  {
      __typename: "EvaluationInputPreferences",
      evaluationReport:  {
        __typename: "ReportInputPreferences",
        history: ReportSource,
        physicalExamination: ReportSource,
        assessment: ReportSource,
      },
      reEvaluationReport:  {
        __typename: "ReportInputPreferences",
        history: ReportSource,
        physicalExamination: ReportSource,
        assessment: ReportSource,
      },
      supplementalReport:  {
        __typename: "SupplementalReportInputPreferences",
        assessment: ReportSource,
      },
    } | null,
    preferredAssessmentMode?: AssessmentMode | null,
    caseSummaryFields?:  {
      __typename: "ModelDoctorCaseSummaryFieldConnection",
      items:  Array< {
        __typename: "DoctorCaseSummaryField",
        id: string,
        doctorId: string,
        caseSummaryFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        caseSummaryField:  {
          __typename: "CaseSummaryField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          summaryPrompt?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    briefingFields?:  {
      __typename: "ModelDoctorBriefingFieldConnection",
      items:  Array< {
        __typename: "DoctorBriefingField",
        id: string,
        doctorId: string,
        briefingFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        briefingField:  {
          __typename: "BriefingField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          briefingPrompt?: string | null,
          briefingRecordTypeID: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    isDemo?: boolean | null,
    fieldTemplateId?: string | null,
    templateFolderLink?: string | null,
    physicianPartner?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultPrimaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultSecondaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultScheduler?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultReportOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultPreVisitReviewer?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultBillingOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultSupplementalReportOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    supplementalReportOpsAssignments?:  Array< {
      __typename: "SupplementalReportOpsAssignment",
      medicalAssistantID: string,
      weightPercentage: number,
    } | null > | null,
    supportingMAs?:  {
      __typename: "ModelDoctorSupportingMAConnection",
      items:  Array< {
        __typename: "DoctorSupportingMA",
        id: string,
        medicalAssistantId: string,
        doctorId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultAppointmentDurationMinutes?:  {
      __typename: "DefaultAppointmentDurationMinutes",
      qme?: number | null,
      qmeReevaluation?: number | null,
      ime?: number | null,
      deposition?: number | null,
    } | null,
    defaultEarlyArrivalTimeMinutes?:  {
      __typename: "DefaultEarlyArrivalTimeMinutes",
      workersComp?: number | null,
      ime?: number | null,
      deposition?: number | null,
    } | null,
    assessmentTreatmentOptions?: Array< string | null > | null,
    dismissedProTips?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    doctorPhysicianPartnerId?: string | null,
    doctorDefaultPrimaryOnsiteOpsId?: string | null,
    doctorDefaultSecondaryOnsiteOpsId?: string | null,
    doctorDefaultSchedulerId?: string | null,
    doctorDefaultReportOpsId?: string | null,
    doctorDefaultPreVisitReviewerId?: string | null,
    doctorDefaultBillingOpsId?: string | null,
    doctorDefaultSupplementalReportOpsId?: string | null,
    doctorUserId?: string | null,
  } | null,
};

export type DeleteDoctorMutationVariables = {
  input: DeleteDoctorInput,
  condition?: ModelDoctorConditionInput | null,
};

export type DeleteDoctorMutation = {
  deleteDoctor?:  {
    __typename: "Doctor",
    id: string,
    ownerCognitoId?: string | null,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    name?: string | null,
    signatureName?: string | null,
    status?: DoctorStatus | null,
    ramped?: boolean | null,
    title?: string | null,
    titleExtension?: TitleExtension | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    officePhone?: string | null,
    cellPhone?: string | null,
    clinicPhone?: string | null,
    workCity?: string | null,
    workState?: string | null,
    collectionRate?: number | null,
    licenseNumber?: string | null,
    licenseRenewalDate?: string | null,
    qmeLicense?:  {
      __typename: "QmeLicense",
      licenseNumber?: string | null,
      approvalDate?: string | null,
      renewalDate?: string | null,
    } | null,
    locations?:  {
      __typename: "ModelDoctorLocationConnection",
      items:  Array< {
        __typename: "DoctorLocation",
        id: string,
        doctorId: string,
        locationId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        location:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    specialties?: Array< SpecialtyType | null > | null,
    npi?: string | null,
    bankingInfo?:  {
      __typename: "BankingInfo",
      bankEntityName?: string | null,
      accountNumber?: string | null,
      routingNumber?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    availabilities?:  {
      __typename: "Availabilities",
      generalAvailabilities?:  Array< {
        __typename: "GeneralAvailability",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        recurrence?: RecurrenceType | null,
        dayOfWeek?: DayOfWeek | null,
        dayOfMonth?: number | null,
        weekOfMonth?: WeekOfMonth | null,
        monthInterval?: number | null,
        startTime?: string | null,
        endTime?: string | null,
        flexibleTimeBefore?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        flexibleTimeAfter?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        locationIDs?: Array< string | null > | null,
        isAllLocations?: boolean | null,
      } | null > | null,
      additionalAvailabilities?:  Array< {
        __typename: "AdditionalAvailability",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        flexibleTimeBefore?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        flexibleTimeAfter?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        locationIDs?: Array< string | null > | null,
        isAllLocations?: boolean | null,
      } | null > | null,
      blackoutDates?:  Array< {
        __typename: "BlackoutDate",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
    } | null,
    availabilitiesNote?: string | null,
    emails?: Array< string | null > | null,
    profileImages?:  Array< {
      __typename: "DoctorProfileImage",
      type?: DoctorProfileImageType | null,
      name?: string | null,
      order?: number | null,
      s3Prefix?: string | null,
      widthInInches?: number | null,
      heightInInches?: number | null,
    } | null > | null,
    qmeReportConfigs?:  {
      __typename: "DoctorQMEReportConfigs",
      hasIntroTitle?: boolean | null,
      introTemplate?: string | null,
    } | null,
    physicalEvalConfigs?:  {
      __typename: "DoctorPhysicalEvalConfigs",
      templates?: Array< PhysicalEvalTemplateTag | null > | null,
    } | null,
    signatureDepartment?: string | null,
    profileAssetS3Prefix?: string | null,
    calendarPreference?:  {
      __typename: "CalendarPreference",
      mailingList?: Array< string | null > | null,
      showPatientFullName?: boolean | null,
      showPatientAddress?: boolean | null,
      showPatientDOB?: boolean | null,
      showPortalLink?: boolean | null,
    } | null,
    homeOffice?:  {
      __typename: "HomeOffice",
      county?: string | null,
      state?: string | null,
    } | null,
    reportFormatPreferences?:  {
      __typename: "ReportFormatPreferences",
      evaluationReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
      reEvaluationReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
      supplementalReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
    } | null,
    evaluationInputPreferences?:  {
      __typename: "EvaluationInputPreferences",
      evaluationReport:  {
        __typename: "ReportInputPreferences",
        history: ReportSource,
        physicalExamination: ReportSource,
        assessment: ReportSource,
      },
      reEvaluationReport:  {
        __typename: "ReportInputPreferences",
        history: ReportSource,
        physicalExamination: ReportSource,
        assessment: ReportSource,
      },
      supplementalReport:  {
        __typename: "SupplementalReportInputPreferences",
        assessment: ReportSource,
      },
    } | null,
    preferredAssessmentMode?: AssessmentMode | null,
    caseSummaryFields?:  {
      __typename: "ModelDoctorCaseSummaryFieldConnection",
      items:  Array< {
        __typename: "DoctorCaseSummaryField",
        id: string,
        doctorId: string,
        caseSummaryFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        caseSummaryField:  {
          __typename: "CaseSummaryField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          summaryPrompt?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    briefingFields?:  {
      __typename: "ModelDoctorBriefingFieldConnection",
      items:  Array< {
        __typename: "DoctorBriefingField",
        id: string,
        doctorId: string,
        briefingFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        briefingField:  {
          __typename: "BriefingField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          briefingPrompt?: string | null,
          briefingRecordTypeID: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    isDemo?: boolean | null,
    fieldTemplateId?: string | null,
    templateFolderLink?: string | null,
    physicianPartner?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultPrimaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultSecondaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultScheduler?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultReportOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultPreVisitReviewer?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultBillingOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultSupplementalReportOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    supplementalReportOpsAssignments?:  Array< {
      __typename: "SupplementalReportOpsAssignment",
      medicalAssistantID: string,
      weightPercentage: number,
    } | null > | null,
    supportingMAs?:  {
      __typename: "ModelDoctorSupportingMAConnection",
      items:  Array< {
        __typename: "DoctorSupportingMA",
        id: string,
        medicalAssistantId: string,
        doctorId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultAppointmentDurationMinutes?:  {
      __typename: "DefaultAppointmentDurationMinutes",
      qme?: number | null,
      qmeReevaluation?: number | null,
      ime?: number | null,
      deposition?: number | null,
    } | null,
    defaultEarlyArrivalTimeMinutes?:  {
      __typename: "DefaultEarlyArrivalTimeMinutes",
      workersComp?: number | null,
      ime?: number | null,
      deposition?: number | null,
    } | null,
    assessmentTreatmentOptions?: Array< string | null > | null,
    dismissedProTips?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    doctorPhysicianPartnerId?: string | null,
    doctorDefaultPrimaryOnsiteOpsId?: string | null,
    doctorDefaultSecondaryOnsiteOpsId?: string | null,
    doctorDefaultSchedulerId?: string | null,
    doctorDefaultReportOpsId?: string | null,
    doctorDefaultPreVisitReviewerId?: string | null,
    doctorDefaultBillingOpsId?: string | null,
    doctorDefaultSupplementalReportOpsId?: string | null,
    doctorUserId?: string | null,
  } | null,
};

export type CreateLocationMutationVariables = {
  input: CreateLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type CreateLocationMutation = {
  createLocation?:  {
    __typename: "Location",
    id: string,
    name?: string | null,
    abbreviation?: string | null,
    status?: LocationStatus | null,
    region?: Region | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      county?: string | null,
    } | null,
    indigoOfficePhoneNumber?: string | null,
    isWaitingArea?: boolean | null,
    additionalRoomsNumber?: number | null,
    landlordContactInfo?:  {
      __typename: "LocationLandlordContactInfo",
      name?: string | null,
      phone?: string | null,
      email?: string | null,
    } | null,
    calendarCcEmails?: Array< string | null > | null,
    isParkingFree?: boolean | null,
    parkingRate?: number | null,
    isFrontDoorLocked?: boolean | null,
    frontDoorCode?: string | null,
    backDoor?: BackDoorStatus | null,
    backDoorCode?: string | null,
    securityUnlockingProcess?: string | null,
    securityLockingProcess?: string | null,
    maleBathroomCode?: string | null,
    femaleBathroomCode?: string | null,
    wifiName?: string | null,
    wifiPassword?: string | null,
    defaultOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    secondaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    locationInstructionsForVisitor?: string | null,
    additionalNote?: string | null,
    doctors?:  {
      __typename: "ModelDoctorLocationConnection",
      items:  Array< {
        __typename: "DoctorLocation",
        id: string,
        doctorId: string,
        locationId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        location:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    locationDefaultOnsiteOpsId?: string | null,
    locationSecondaryOnsiteOpsId?: string | null,
  } | null,
};

export type UpdateLocationMutationVariables = {
  input: UpdateLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type UpdateLocationMutation = {
  updateLocation?:  {
    __typename: "Location",
    id: string,
    name?: string | null,
    abbreviation?: string | null,
    status?: LocationStatus | null,
    region?: Region | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      county?: string | null,
    } | null,
    indigoOfficePhoneNumber?: string | null,
    isWaitingArea?: boolean | null,
    additionalRoomsNumber?: number | null,
    landlordContactInfo?:  {
      __typename: "LocationLandlordContactInfo",
      name?: string | null,
      phone?: string | null,
      email?: string | null,
    } | null,
    calendarCcEmails?: Array< string | null > | null,
    isParkingFree?: boolean | null,
    parkingRate?: number | null,
    isFrontDoorLocked?: boolean | null,
    frontDoorCode?: string | null,
    backDoor?: BackDoorStatus | null,
    backDoorCode?: string | null,
    securityUnlockingProcess?: string | null,
    securityLockingProcess?: string | null,
    maleBathroomCode?: string | null,
    femaleBathroomCode?: string | null,
    wifiName?: string | null,
    wifiPassword?: string | null,
    defaultOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    secondaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    locationInstructionsForVisitor?: string | null,
    additionalNote?: string | null,
    doctors?:  {
      __typename: "ModelDoctorLocationConnection",
      items:  Array< {
        __typename: "DoctorLocation",
        id: string,
        doctorId: string,
        locationId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        location:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    locationDefaultOnsiteOpsId?: string | null,
    locationSecondaryOnsiteOpsId?: string | null,
  } | null,
};

export type DeleteLocationMutationVariables = {
  input: DeleteLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type DeleteLocationMutation = {
  deleteLocation?:  {
    __typename: "Location",
    id: string,
    name?: string | null,
    abbreviation?: string | null,
    status?: LocationStatus | null,
    region?: Region | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      county?: string | null,
    } | null,
    indigoOfficePhoneNumber?: string | null,
    isWaitingArea?: boolean | null,
    additionalRoomsNumber?: number | null,
    landlordContactInfo?:  {
      __typename: "LocationLandlordContactInfo",
      name?: string | null,
      phone?: string | null,
      email?: string | null,
    } | null,
    calendarCcEmails?: Array< string | null > | null,
    isParkingFree?: boolean | null,
    parkingRate?: number | null,
    isFrontDoorLocked?: boolean | null,
    frontDoorCode?: string | null,
    backDoor?: BackDoorStatus | null,
    backDoorCode?: string | null,
    securityUnlockingProcess?: string | null,
    securityLockingProcess?: string | null,
    maleBathroomCode?: string | null,
    femaleBathroomCode?: string | null,
    wifiName?: string | null,
    wifiPassword?: string | null,
    defaultOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    secondaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    locationInstructionsForVisitor?: string | null,
    additionalNote?: string | null,
    doctors?:  {
      __typename: "ModelDoctorLocationConnection",
      items:  Array< {
        __typename: "DoctorLocation",
        id: string,
        doctorId: string,
        locationId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        location:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    locationDefaultOnsiteOpsId?: string | null,
    locationSecondaryOnsiteOpsId?: string | null,
  } | null,
};

export type CreateWorkflowExecutionMutationVariables = {
  input: CreateWorkflowExecutionInput,
  condition?: ModelWorkflowExecutionConditionInput | null,
};

export type CreateWorkflowExecutionMutation = {
  createWorkflowExecution?:  {
    __typename: "WorkflowExecution",
    executionArn: string,
    appointmentRecordID: string,
    type?: WorkflowExecutionType | null,
    status?: WorkflowExecutionStatus | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateWorkflowExecutionMutationVariables = {
  input: UpdateWorkflowExecutionInput,
  condition?: ModelWorkflowExecutionConditionInput | null,
};

export type UpdateWorkflowExecutionMutation = {
  updateWorkflowExecution?:  {
    __typename: "WorkflowExecution",
    executionArn: string,
    appointmentRecordID: string,
    type?: WorkflowExecutionType | null,
    status?: WorkflowExecutionStatus | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteWorkflowExecutionMutationVariables = {
  input: DeleteWorkflowExecutionInput,
  condition?: ModelWorkflowExecutionConditionInput | null,
};

export type DeleteWorkflowExecutionMutation = {
  deleteWorkflowExecution?:  {
    __typename: "WorkflowExecution",
    executionArn: string,
    appointmentRecordID: string,
    type?: WorkflowExecutionType | null,
    status?: WorkflowExecutionStatus | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateHistoryOfInjuryInsightsMutationVariables = {
  input: CreateHistoryOfInjuryInsightsInput,
  condition?: ModelHistoryOfInjuryInsightsConditionInput | null,
};

export type CreateHistoryOfInjuryInsightsMutation = {
  createHistoryOfInjuryInsights?:  {
    __typename: "HistoryOfInjuryInsights",
    id: string,
    appointmentRecordID: string,
    mechanismOfInjury?: string | null,
    employerJobDescription?: string | null,
    injuryCausations?:  Array< {
      __typename: "InjuryCausationInfo",
      injuryType?: InjuryType | null,
      dateOfInjury?: string | null,
      dateOfInjuryEnd?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      mechanismOfInjury?: string | null,
      employerJobDescription?: string | null,
    } | null > | null,
    currentSymptoms?:  Array< {
      __typename: "Symptom",
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    priorSymptomsBeforeCurrentInjury?:  Array< {
      __typename: "Symptom",
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    previousSurgeries?:  Array< {
      __typename: "SurgeryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      type?: string | null,
    } | null > | null,
    previousWorkInjuries?:  Array< {
      __typename: "InjuryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    previousInjuries?:  Array< {
      __typename: "InjuryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    injuryEmploymentStatus?: string | null,
    currentWorkRestrictionsFromPatient?: string | null,
    activitiesOfDailyLiving?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateHistoryOfInjuryInsightsMutationVariables = {
  input: UpdateHistoryOfInjuryInsightsInput,
  condition?: ModelHistoryOfInjuryInsightsConditionInput | null,
};

export type UpdateHistoryOfInjuryInsightsMutation = {
  updateHistoryOfInjuryInsights?:  {
    __typename: "HistoryOfInjuryInsights",
    id: string,
    appointmentRecordID: string,
    mechanismOfInjury?: string | null,
    employerJobDescription?: string | null,
    injuryCausations?:  Array< {
      __typename: "InjuryCausationInfo",
      injuryType?: InjuryType | null,
      dateOfInjury?: string | null,
      dateOfInjuryEnd?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      mechanismOfInjury?: string | null,
      employerJobDescription?: string | null,
    } | null > | null,
    currentSymptoms?:  Array< {
      __typename: "Symptom",
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    priorSymptomsBeforeCurrentInjury?:  Array< {
      __typename: "Symptom",
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    previousSurgeries?:  Array< {
      __typename: "SurgeryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      type?: string | null,
    } | null > | null,
    previousWorkInjuries?:  Array< {
      __typename: "InjuryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    previousInjuries?:  Array< {
      __typename: "InjuryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    injuryEmploymentStatus?: string | null,
    currentWorkRestrictionsFromPatient?: string | null,
    activitiesOfDailyLiving?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteHistoryOfInjuryInsightsMutationVariables = {
  input: DeleteHistoryOfInjuryInsightsInput,
  condition?: ModelHistoryOfInjuryInsightsConditionInput | null,
};

export type DeleteHistoryOfInjuryInsightsMutation = {
  deleteHistoryOfInjuryInsights?:  {
    __typename: "HistoryOfInjuryInsights",
    id: string,
    appointmentRecordID: string,
    mechanismOfInjury?: string | null,
    employerJobDescription?: string | null,
    injuryCausations?:  Array< {
      __typename: "InjuryCausationInfo",
      injuryType?: InjuryType | null,
      dateOfInjury?: string | null,
      dateOfInjuryEnd?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      mechanismOfInjury?: string | null,
      employerJobDescription?: string | null,
    } | null > | null,
    currentSymptoms?:  Array< {
      __typename: "Symptom",
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    priorSymptomsBeforeCurrentInjury?:  Array< {
      __typename: "Symptom",
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    previousSurgeries?:  Array< {
      __typename: "SurgeryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      type?: string | null,
    } | null > | null,
    previousWorkInjuries?:  Array< {
      __typename: "InjuryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    previousInjuries?:  Array< {
      __typename: "InjuryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    injuryEmploymentStatus?: string | null,
    currentWorkRestrictionsFromPatient?: string | null,
    activitiesOfDailyLiving?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOpinionRecapMutationVariables = {
  input: CreateOpinionRecapInput,
  condition?: ModelOpinionRecapConditionInput | null,
};

export type CreateOpinionRecapMutation = {
  createOpinionRecap?:  {
    __typename: "OpinionRecap",
    id: string,
    appointmentRecordID: string,
    causation?: string | null,
    diagnosis?: string | null,
    mmiFutureMedicalTreatment?: string | null,
    impairmentRating?: string | null,
    apportionment?: string | null,
    workStatus?: string | null,
    sourceReportFileID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateOpinionRecapMutationVariables = {
  input: UpdateOpinionRecapInput,
  condition?: ModelOpinionRecapConditionInput | null,
};

export type UpdateOpinionRecapMutation = {
  updateOpinionRecap?:  {
    __typename: "OpinionRecap",
    id: string,
    appointmentRecordID: string,
    causation?: string | null,
    diagnosis?: string | null,
    mmiFutureMedicalTreatment?: string | null,
    impairmentRating?: string | null,
    apportionment?: string | null,
    workStatus?: string | null,
    sourceReportFileID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteOpinionRecapMutationVariables = {
  input: DeleteOpinionRecapInput,
  condition?: ModelOpinionRecapConditionInput | null,
};

export type DeleteOpinionRecapMutation = {
  deleteOpinionRecap?:  {
    __typename: "OpinionRecap",
    id: string,
    appointmentRecordID: string,
    causation?: string | null,
    diagnosis?: string | null,
    mmiFutureMedicalTreatment?: string | null,
    impairmentRating?: string | null,
    apportionment?: string | null,
    workStatus?: string | null,
    sourceReportFileID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateReviewOfMedicalRecordsInsightsMutationVariables = {
  input: CreateReviewOfMedicalRecordsInsightsInput,
  condition?: ModelReviewOfMedicalRecordsInsightsConditionInput | null,
};

export type CreateReviewOfMedicalRecordsInsightsMutation = {
  createReviewOfMedicalRecordsInsights?:  {
    __typename: "ReviewOfMedicalRecordsInsights",
    id: string,
    appointmentRecordID: string,
    latestDiagnosis?:  Array< {
      __typename: "BodyPartDiagnosis",
      bodyPart?: string | null,
      date?: string | null,
      descriptions?: Array< string | null > | null,
    } | null > | null,
    diagnosticStudies?:  Array< {
      __typename: "DiagnosticStudy",
      date?: string | null,
      typeOfStudy?: DiagnosticStudyType | null,
      bodyPart?: string | null,
      impression?: string | null,
      source?: DiagnosticStudySource | null,
    } | null > | null,
    treatments?:  Array< {
      __typename: "TreatmentWrapper",
      discreteTreatment?:  {
        __typename: "DiscreteTreatment",
        date?: string | null,
        treatmentType?: DiscreteTreatmentType | null,
        bodyPart?: string | null,
        description?: string | null,
      } | null,
      recurringTreatment?:  {
        __typename: "RecurringTreatment",
        year?: string | null,
        treatmentType?: RecurringTreatmentType | null,
        frequency?: string | null,
        description?: string | null,
      } | null,
    } | null > | null,
    currentWorkRestrictionsFromMedicalRecords?: string | null,
    previousReports?:  Array< {
      __typename: "PreviousReport",
      date?: string | null,
      reportType?: string | null,
      reportContent?: string | null,
    } | null > | null,
    durableMedicalEquipment?:  Array< {
      __typename: "DurableMedicalEquipment",
      startDate?: string | null,
      endDate?: string | null,
      bodyParts?: Array< string | null > | null,
      equipmentType?: string | null,
      description?: string | null,
    } | null > | null,
    derivedFromDocumentInsightIDs?: Array< string | null > | null,
    derivedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateReviewOfMedicalRecordsInsightsMutationVariables = {
  input: UpdateReviewOfMedicalRecordsInsightsInput,
  condition?: ModelReviewOfMedicalRecordsInsightsConditionInput | null,
};

export type UpdateReviewOfMedicalRecordsInsightsMutation = {
  updateReviewOfMedicalRecordsInsights?:  {
    __typename: "ReviewOfMedicalRecordsInsights",
    id: string,
    appointmentRecordID: string,
    latestDiagnosis?:  Array< {
      __typename: "BodyPartDiagnosis",
      bodyPart?: string | null,
      date?: string | null,
      descriptions?: Array< string | null > | null,
    } | null > | null,
    diagnosticStudies?:  Array< {
      __typename: "DiagnosticStudy",
      date?: string | null,
      typeOfStudy?: DiagnosticStudyType | null,
      bodyPart?: string | null,
      impression?: string | null,
      source?: DiagnosticStudySource | null,
    } | null > | null,
    treatments?:  Array< {
      __typename: "TreatmentWrapper",
      discreteTreatment?:  {
        __typename: "DiscreteTreatment",
        date?: string | null,
        treatmentType?: DiscreteTreatmentType | null,
        bodyPart?: string | null,
        description?: string | null,
      } | null,
      recurringTreatment?:  {
        __typename: "RecurringTreatment",
        year?: string | null,
        treatmentType?: RecurringTreatmentType | null,
        frequency?: string | null,
        description?: string | null,
      } | null,
    } | null > | null,
    currentWorkRestrictionsFromMedicalRecords?: string | null,
    previousReports?:  Array< {
      __typename: "PreviousReport",
      date?: string | null,
      reportType?: string | null,
      reportContent?: string | null,
    } | null > | null,
    durableMedicalEquipment?:  Array< {
      __typename: "DurableMedicalEquipment",
      startDate?: string | null,
      endDate?: string | null,
      bodyParts?: Array< string | null > | null,
      equipmentType?: string | null,
      description?: string | null,
    } | null > | null,
    derivedFromDocumentInsightIDs?: Array< string | null > | null,
    derivedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteReviewOfMedicalRecordsInsightsMutationVariables = {
  input: DeleteReviewOfMedicalRecordsInsightsInput,
  condition?: ModelReviewOfMedicalRecordsInsightsConditionInput | null,
};

export type DeleteReviewOfMedicalRecordsInsightsMutation = {
  deleteReviewOfMedicalRecordsInsights?:  {
    __typename: "ReviewOfMedicalRecordsInsights",
    id: string,
    appointmentRecordID: string,
    latestDiagnosis?:  Array< {
      __typename: "BodyPartDiagnosis",
      bodyPart?: string | null,
      date?: string | null,
      descriptions?: Array< string | null > | null,
    } | null > | null,
    diagnosticStudies?:  Array< {
      __typename: "DiagnosticStudy",
      date?: string | null,
      typeOfStudy?: DiagnosticStudyType | null,
      bodyPart?: string | null,
      impression?: string | null,
      source?: DiagnosticStudySource | null,
    } | null > | null,
    treatments?:  Array< {
      __typename: "TreatmentWrapper",
      discreteTreatment?:  {
        __typename: "DiscreteTreatment",
        date?: string | null,
        treatmentType?: DiscreteTreatmentType | null,
        bodyPart?: string | null,
        description?: string | null,
      } | null,
      recurringTreatment?:  {
        __typename: "RecurringTreatment",
        year?: string | null,
        treatmentType?: RecurringTreatmentType | null,
        frequency?: string | null,
        description?: string | null,
      } | null,
    } | null > | null,
    currentWorkRestrictionsFromMedicalRecords?: string | null,
    previousReports?:  Array< {
      __typename: "PreviousReport",
      date?: string | null,
      reportType?: string | null,
      reportContent?: string | null,
    } | null > | null,
    durableMedicalEquipment?:  Array< {
      __typename: "DurableMedicalEquipment",
      startDate?: string | null,
      endDate?: string | null,
      bodyParts?: Array< string | null > | null,
      equipmentType?: string | null,
      description?: string | null,
    } | null > | null,
    derivedFromDocumentInsightIDs?: Array< string | null > | null,
    derivedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDocumentBriefingInsightsMutationVariables = {
  input: CreateDocumentBriefingInsightsInput,
  condition?: ModelDocumentBriefingInsightsConditionInput | null,
};

export type CreateDocumentBriefingInsightsMutation = {
  createDocumentBriefingInsights?:  {
    __typename: "DocumentBriefingInsights",
    id: string,
    documentID: string,
    appointmentRecordID: string,
    latestDiagnosis?:  Array< {
      __typename: "BodyPartDiagnosis",
      bodyPart?: string | null,
      date?: string | null,
      descriptions?: Array< string | null > | null,
    } | null > | null,
    diagnosticStudies?:  Array< {
      __typename: "DiagnosticStudy",
      date?: string | null,
      typeOfStudy?: DiagnosticStudyType | null,
      bodyPart?: string | null,
      impression?: string | null,
      source?: DiagnosticStudySource | null,
    } | null > | null,
    treatments?:  Array< {
      __typename: "TreatmentWrapper",
      discreteTreatment?:  {
        __typename: "DiscreteTreatment",
        date?: string | null,
        treatmentType?: DiscreteTreatmentType | null,
        bodyPart?: string | null,
        description?: string | null,
      } | null,
      recurringTreatment?:  {
        __typename: "RecurringTreatment",
        year?: string | null,
        treatmentType?: RecurringTreatmentType | null,
        frequency?: string | null,
        description?: string | null,
      } | null,
    } | null > | null,
    currentWorkRestrictionsFromMedicalRecords?: string | null,
    previousReports?:  Array< {
      __typename: "PreviousReport",
      date?: string | null,
      reportType?: string | null,
      reportContent?: string | null,
    } | null > | null,
    durableMedicalEquipment?:  Array< {
      __typename: "DurableMedicalEquipment",
      startDate?: string | null,
      endDate?: string | null,
      bodyParts?: Array< string | null > | null,
      equipmentType?: string | null,
      description?: string | null,
    } | null > | null,
    sourceRecordBriefingID: string,
    generatedAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateDocumentBriefingInsightsMutationVariables = {
  input: UpdateDocumentBriefingInsightsInput,
  condition?: ModelDocumentBriefingInsightsConditionInput | null,
};

export type UpdateDocumentBriefingInsightsMutation = {
  updateDocumentBriefingInsights?:  {
    __typename: "DocumentBriefingInsights",
    id: string,
    documentID: string,
    appointmentRecordID: string,
    latestDiagnosis?:  Array< {
      __typename: "BodyPartDiagnosis",
      bodyPart?: string | null,
      date?: string | null,
      descriptions?: Array< string | null > | null,
    } | null > | null,
    diagnosticStudies?:  Array< {
      __typename: "DiagnosticStudy",
      date?: string | null,
      typeOfStudy?: DiagnosticStudyType | null,
      bodyPart?: string | null,
      impression?: string | null,
      source?: DiagnosticStudySource | null,
    } | null > | null,
    treatments?:  Array< {
      __typename: "TreatmentWrapper",
      discreteTreatment?:  {
        __typename: "DiscreteTreatment",
        date?: string | null,
        treatmentType?: DiscreteTreatmentType | null,
        bodyPart?: string | null,
        description?: string | null,
      } | null,
      recurringTreatment?:  {
        __typename: "RecurringTreatment",
        year?: string | null,
        treatmentType?: RecurringTreatmentType | null,
        frequency?: string | null,
        description?: string | null,
      } | null,
    } | null > | null,
    currentWorkRestrictionsFromMedicalRecords?: string | null,
    previousReports?:  Array< {
      __typename: "PreviousReport",
      date?: string | null,
      reportType?: string | null,
      reportContent?: string | null,
    } | null > | null,
    durableMedicalEquipment?:  Array< {
      __typename: "DurableMedicalEquipment",
      startDate?: string | null,
      endDate?: string | null,
      bodyParts?: Array< string | null > | null,
      equipmentType?: string | null,
      description?: string | null,
    } | null > | null,
    sourceRecordBriefingID: string,
    generatedAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteDocumentBriefingInsightsMutationVariables = {
  input: DeleteDocumentBriefingInsightsInput,
  condition?: ModelDocumentBriefingInsightsConditionInput | null,
};

export type DeleteDocumentBriefingInsightsMutation = {
  deleteDocumentBriefingInsights?:  {
    __typename: "DocumentBriefingInsights",
    id: string,
    documentID: string,
    appointmentRecordID: string,
    latestDiagnosis?:  Array< {
      __typename: "BodyPartDiagnosis",
      bodyPart?: string | null,
      date?: string | null,
      descriptions?: Array< string | null > | null,
    } | null > | null,
    diagnosticStudies?:  Array< {
      __typename: "DiagnosticStudy",
      date?: string | null,
      typeOfStudy?: DiagnosticStudyType | null,
      bodyPart?: string | null,
      impression?: string | null,
      source?: DiagnosticStudySource | null,
    } | null > | null,
    treatments?:  Array< {
      __typename: "TreatmentWrapper",
      discreteTreatment?:  {
        __typename: "DiscreteTreatment",
        date?: string | null,
        treatmentType?: DiscreteTreatmentType | null,
        bodyPart?: string | null,
        description?: string | null,
      } | null,
      recurringTreatment?:  {
        __typename: "RecurringTreatment",
        year?: string | null,
        treatmentType?: RecurringTreatmentType | null,
        frequency?: string | null,
        description?: string | null,
      } | null,
    } | null > | null,
    currentWorkRestrictionsFromMedicalRecords?: string | null,
    previousReports?:  Array< {
      __typename: "PreviousReport",
      date?: string | null,
      reportType?: string | null,
      reportContent?: string | null,
    } | null > | null,
    durableMedicalEquipment?:  Array< {
      __typename: "DurableMedicalEquipment",
      startDate?: string | null,
      endDate?: string | null,
      bodyParts?: Array< string | null > | null,
      equipmentType?: string | null,
      description?: string | null,
    } | null > | null,
    sourceRecordBriefingID: string,
    generatedAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePhysicalExamInsightsMutationVariables = {
  input: CreatePhysicalExamInsightsInput,
  condition?: ModelPhysicalExamInsightsConditionInput | null,
};

export type CreatePhysicalExamInsightsMutation = {
  createPhysicalExamInsights?:  {
    __typename: "PhysicalExamInsights",
    id: string,
    appointmentRecordID: string,
    physicalExaminationInfo?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePhysicalExamInsightsMutationVariables = {
  input: UpdatePhysicalExamInsightsInput,
  condition?: ModelPhysicalExamInsightsConditionInput | null,
};

export type UpdatePhysicalExamInsightsMutation = {
  updatePhysicalExamInsights?:  {
    __typename: "PhysicalExamInsights",
    id: string,
    appointmentRecordID: string,
    physicalExaminationInfo?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePhysicalExamInsightsMutationVariables = {
  input: DeletePhysicalExamInsightsInput,
  condition?: ModelPhysicalExamInsightsConditionInput | null,
};

export type DeletePhysicalExamInsightsMutation = {
  deletePhysicalExamInsights?:  {
    __typename: "PhysicalExamInsights",
    id: string,
    appointmentRecordID: string,
    physicalExaminationInfo?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDataFieldMutationVariables = {
  input: CreateDataFieldInput,
  condition?: ModelDataFieldConditionInput | null,
};

export type CreateDataFieldMutation = {
  createDataField?:  {
    __typename: "DataField",
    id: string,
    name: string,
    category: DataFieldCategory,
    dataType: DataFieldType,
    default: boolean,
    description?: string | null,
    sectionID?: string | null,
    section?:  {
      __typename: "DataFieldSection",
      id: string,
      name: string,
      default: boolean,
      fields?:  {
        __typename: "ModelDataFieldConnection",
        items:  Array< {
          __typename: "DataField",
          id: string,
          name: string,
          category: DataFieldCategory,
          dataType: DataFieldType,
          default: boolean,
          description?: string | null,
          sectionID?: string | null,
          migrationKey?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    migrationKey?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateDataFieldMutationVariables = {
  input: UpdateDataFieldInput,
  condition?: ModelDataFieldConditionInput | null,
};

export type UpdateDataFieldMutation = {
  updateDataField?:  {
    __typename: "DataField",
    id: string,
    name: string,
    category: DataFieldCategory,
    dataType: DataFieldType,
    default: boolean,
    description?: string | null,
    sectionID?: string | null,
    section?:  {
      __typename: "DataFieldSection",
      id: string,
      name: string,
      default: boolean,
      fields?:  {
        __typename: "ModelDataFieldConnection",
        items:  Array< {
          __typename: "DataField",
          id: string,
          name: string,
          category: DataFieldCategory,
          dataType: DataFieldType,
          default: boolean,
          description?: string | null,
          sectionID?: string | null,
          migrationKey?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    migrationKey?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteDataFieldMutationVariables = {
  input: DeleteDataFieldInput,
  condition?: ModelDataFieldConditionInput | null,
};

export type DeleteDataFieldMutation = {
  deleteDataField?:  {
    __typename: "DataField",
    id: string,
    name: string,
    category: DataFieldCategory,
    dataType: DataFieldType,
    default: boolean,
    description?: string | null,
    sectionID?: string | null,
    section?:  {
      __typename: "DataFieldSection",
      id: string,
      name: string,
      default: boolean,
      fields?:  {
        __typename: "ModelDataFieldConnection",
        items:  Array< {
          __typename: "DataField",
          id: string,
          name: string,
          category: DataFieldCategory,
          dataType: DataFieldType,
          default: boolean,
          description?: string | null,
          sectionID?: string | null,
          migrationKey?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    migrationKey?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDataFieldSectionMutationVariables = {
  input: CreateDataFieldSectionInput,
  condition?: ModelDataFieldSectionConditionInput | null,
};

export type CreateDataFieldSectionMutation = {
  createDataFieldSection?:  {
    __typename: "DataFieldSection",
    id: string,
    name: string,
    default: boolean,
    fields?:  {
      __typename: "ModelDataFieldConnection",
      items:  Array< {
        __typename: "DataField",
        id: string,
        name: string,
        category: DataFieldCategory,
        dataType: DataFieldType,
        default: boolean,
        description?: string | null,
        sectionID?: string | null,
        section?:  {
          __typename: "DataFieldSection",
          id: string,
          name: string,
          default: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        migrationKey?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateDataFieldSectionMutationVariables = {
  input: UpdateDataFieldSectionInput,
  condition?: ModelDataFieldSectionConditionInput | null,
};

export type UpdateDataFieldSectionMutation = {
  updateDataFieldSection?:  {
    __typename: "DataFieldSection",
    id: string,
    name: string,
    default: boolean,
    fields?:  {
      __typename: "ModelDataFieldConnection",
      items:  Array< {
        __typename: "DataField",
        id: string,
        name: string,
        category: DataFieldCategory,
        dataType: DataFieldType,
        default: boolean,
        description?: string | null,
        sectionID?: string | null,
        section?:  {
          __typename: "DataFieldSection",
          id: string,
          name: string,
          default: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        migrationKey?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteDataFieldSectionMutationVariables = {
  input: DeleteDataFieldSectionInput,
  condition?: ModelDataFieldSectionConditionInput | null,
};

export type DeleteDataFieldSectionMutation = {
  deleteDataFieldSection?:  {
    __typename: "DataFieldSection",
    id: string,
    name: string,
    default: boolean,
    fields?:  {
      __typename: "ModelDataFieldConnection",
      items:  Array< {
        __typename: "DataField",
        id: string,
        name: string,
        category: DataFieldCategory,
        dataType: DataFieldType,
        default: boolean,
        description?: string | null,
        sectionID?: string | null,
        section?:  {
          __typename: "DataFieldSection",
          id: string,
          name: string,
          default: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        migrationKey?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateBriefingFieldMutationVariables = {
  input: CreateBriefingFieldInput,
  condition?: ModelBriefingFieldConditionInput | null,
};

export type CreateBriefingFieldMutation = {
  createBriefingField?:  {
    __typename: "BriefingField",
    id: string,
    name: string,
    default: boolean,
    description?: string | null,
    briefingPrompt?: string | null,
    doctors?:  {
      __typename: "ModelDoctorBriefingFieldConnection",
      items:  Array< {
        __typename: "DoctorBriefingField",
        id: string,
        doctorId: string,
        briefingFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        briefingField:  {
          __typename: "BriefingField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          briefingPrompt?: string | null,
          briefingRecordTypeID: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    briefingRecordTypeID: string,
    recordType:  {
      __typename: "BriefingRecordType",
      id: string,
      name: string,
      recordType: RecordType,
      description?: string | null,
      default: boolean,
      classificationPrompt?: string | null,
      recordBasePrompt?: string | null,
      briefingFields?:  {
        __typename: "ModelBriefingFieldConnection",
        items:  Array< {
          __typename: "BriefingField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          briefingPrompt?: string | null,
          briefingRecordTypeID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBriefingFieldMutationVariables = {
  input: UpdateBriefingFieldInput,
  condition?: ModelBriefingFieldConditionInput | null,
};

export type UpdateBriefingFieldMutation = {
  updateBriefingField?:  {
    __typename: "BriefingField",
    id: string,
    name: string,
    default: boolean,
    description?: string | null,
    briefingPrompt?: string | null,
    doctors?:  {
      __typename: "ModelDoctorBriefingFieldConnection",
      items:  Array< {
        __typename: "DoctorBriefingField",
        id: string,
        doctorId: string,
        briefingFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        briefingField:  {
          __typename: "BriefingField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          briefingPrompt?: string | null,
          briefingRecordTypeID: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    briefingRecordTypeID: string,
    recordType:  {
      __typename: "BriefingRecordType",
      id: string,
      name: string,
      recordType: RecordType,
      description?: string | null,
      default: boolean,
      classificationPrompt?: string | null,
      recordBasePrompt?: string | null,
      briefingFields?:  {
        __typename: "ModelBriefingFieldConnection",
        items:  Array< {
          __typename: "BriefingField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          briefingPrompt?: string | null,
          briefingRecordTypeID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteBriefingFieldMutationVariables = {
  input: DeleteBriefingFieldInput,
  condition?: ModelBriefingFieldConditionInput | null,
};

export type DeleteBriefingFieldMutation = {
  deleteBriefingField?:  {
    __typename: "BriefingField",
    id: string,
    name: string,
    default: boolean,
    description?: string | null,
    briefingPrompt?: string | null,
    doctors?:  {
      __typename: "ModelDoctorBriefingFieldConnection",
      items:  Array< {
        __typename: "DoctorBriefingField",
        id: string,
        doctorId: string,
        briefingFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        briefingField:  {
          __typename: "BriefingField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          briefingPrompt?: string | null,
          briefingRecordTypeID: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    briefingRecordTypeID: string,
    recordType:  {
      __typename: "BriefingRecordType",
      id: string,
      name: string,
      recordType: RecordType,
      description?: string | null,
      default: boolean,
      classificationPrompt?: string | null,
      recordBasePrompt?: string | null,
      briefingFields?:  {
        __typename: "ModelBriefingFieldConnection",
        items:  Array< {
          __typename: "BriefingField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          briefingPrompt?: string | null,
          briefingRecordTypeID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCaseSummaryFieldMutationVariables = {
  input: CreateCaseSummaryFieldInput,
  condition?: ModelCaseSummaryFieldConditionInput | null,
};

export type CreateCaseSummaryFieldMutation = {
  createCaseSummaryField?:  {
    __typename: "CaseSummaryField",
    id: string,
    name: string,
    default: boolean,
    description?: string | null,
    summaryPrompt?: string | null,
    doctors?:  {
      __typename: "ModelDoctorCaseSummaryFieldConnection",
      items:  Array< {
        __typename: "DoctorCaseSummaryField",
        id: string,
        doctorId: string,
        caseSummaryFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        caseSummaryField:  {
          __typename: "CaseSummaryField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          summaryPrompt?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCaseSummaryFieldMutationVariables = {
  input: UpdateCaseSummaryFieldInput,
  condition?: ModelCaseSummaryFieldConditionInput | null,
};

export type UpdateCaseSummaryFieldMutation = {
  updateCaseSummaryField?:  {
    __typename: "CaseSummaryField",
    id: string,
    name: string,
    default: boolean,
    description?: string | null,
    summaryPrompt?: string | null,
    doctors?:  {
      __typename: "ModelDoctorCaseSummaryFieldConnection",
      items:  Array< {
        __typename: "DoctorCaseSummaryField",
        id: string,
        doctorId: string,
        caseSummaryFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        caseSummaryField:  {
          __typename: "CaseSummaryField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          summaryPrompt?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCaseSummaryFieldMutationVariables = {
  input: DeleteCaseSummaryFieldInput,
  condition?: ModelCaseSummaryFieldConditionInput | null,
};

export type DeleteCaseSummaryFieldMutation = {
  deleteCaseSummaryField?:  {
    __typename: "CaseSummaryField",
    id: string,
    name: string,
    default: boolean,
    description?: string | null,
    summaryPrompt?: string | null,
    doctors?:  {
      __typename: "ModelDoctorCaseSummaryFieldConnection",
      items:  Array< {
        __typename: "DoctorCaseSummaryField",
        id: string,
        doctorId: string,
        caseSummaryFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        caseSummaryField:  {
          __typename: "CaseSummaryField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          summaryPrompt?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePastInjuryMatrixMutationVariables = {
  input: CreatePastInjuryMatrixInput,
  condition?: ModelPastInjuryMatrixConditionInput | null,
};

export type CreatePastInjuryMatrixMutation = {
  createPastInjuryMatrix?:  {
    __typename: "PastInjuryMatrix",
    id: string,
    appointmentRecordID: string,
    preExistingConditions: Array< string >,
    familyHistory: Array< string >,
    injuryMatrix:  Array< {
      __typename: "InjuryMatrixEntry",
      date: string,
      bodyPart: BodyPart,
      status: InjuryStatus,
    } >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePastInjuryMatrixMutationVariables = {
  input: UpdatePastInjuryMatrixInput,
  condition?: ModelPastInjuryMatrixConditionInput | null,
};

export type UpdatePastInjuryMatrixMutation = {
  updatePastInjuryMatrix?:  {
    __typename: "PastInjuryMatrix",
    id: string,
    appointmentRecordID: string,
    preExistingConditions: Array< string >,
    familyHistory: Array< string >,
    injuryMatrix:  Array< {
      __typename: "InjuryMatrixEntry",
      date: string,
      bodyPart: BodyPart,
      status: InjuryStatus,
    } >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePastInjuryMatrixMutationVariables = {
  input: DeletePastInjuryMatrixInput,
  condition?: ModelPastInjuryMatrixConditionInput | null,
};

export type DeletePastInjuryMatrixMutation = {
  deletePastInjuryMatrix?:  {
    __typename: "PastInjuryMatrix",
    id: string,
    appointmentRecordID: string,
    preExistingConditions: Array< string >,
    familyHistory: Array< string >,
    injuryMatrix:  Array< {
      __typename: "InjuryMatrixEntry",
      date: string,
      bodyPart: BodyPart,
      status: InjuryStatus,
    } >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAppointmentFilterPresetMutationVariables = {
  input: CreateAppointmentFilterPresetInput,
  condition?: ModelAppointmentFilterPresetConditionInput | null,
};

export type CreateAppointmentFilterPresetMutation = {
  createAppointmentFilterPreset?:  {
    __typename: "AppointmentFilterPreset",
    id: string,
    name: string,
    filters:  Array< {
      __typename: "FilterEntry",
      type: FilterType,
      values: Array< string >,
    } >,
    appliesTo: UserGroup,
    view?: AppointmentsView | null,
    users?:  {
      __typename: "ModelUserAppointmentFilterPresetConnection",
      items:  Array< {
        __typename: "UserAppointmentFilterPreset",
        id: string,
        userId: string,
        appointmentFilterPresetId: string,
        user:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        },
        appointmentFilterPreset:  {
          __typename: "AppointmentFilterPreset",
          id: string,
          name: string,
          appliesTo: UserGroup,
          view?: AppointmentsView | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAppointmentFilterPresetMutationVariables = {
  input: UpdateAppointmentFilterPresetInput,
  condition?: ModelAppointmentFilterPresetConditionInput | null,
};

export type UpdateAppointmentFilterPresetMutation = {
  updateAppointmentFilterPreset?:  {
    __typename: "AppointmentFilterPreset",
    id: string,
    name: string,
    filters:  Array< {
      __typename: "FilterEntry",
      type: FilterType,
      values: Array< string >,
    } >,
    appliesTo: UserGroup,
    view?: AppointmentsView | null,
    users?:  {
      __typename: "ModelUserAppointmentFilterPresetConnection",
      items:  Array< {
        __typename: "UserAppointmentFilterPreset",
        id: string,
        userId: string,
        appointmentFilterPresetId: string,
        user:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        },
        appointmentFilterPreset:  {
          __typename: "AppointmentFilterPreset",
          id: string,
          name: string,
          appliesTo: UserGroup,
          view?: AppointmentsView | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAppointmentFilterPresetMutationVariables = {
  input: DeleteAppointmentFilterPresetInput,
  condition?: ModelAppointmentFilterPresetConditionInput | null,
};

export type DeleteAppointmentFilterPresetMutation = {
  deleteAppointmentFilterPreset?:  {
    __typename: "AppointmentFilterPreset",
    id: string,
    name: string,
    filters:  Array< {
      __typename: "FilterEntry",
      type: FilterType,
      values: Array< string >,
    } >,
    appliesTo: UserGroup,
    view?: AppointmentsView | null,
    users?:  {
      __typename: "ModelUserAppointmentFilterPresetConnection",
      items:  Array< {
        __typename: "UserAppointmentFilterPreset",
        id: string,
        userId: string,
        appointmentFilterPresetId: string,
        user:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        },
        appointmentFilterPreset:  {
          __typename: "AppointmentFilterPreset",
          id: string,
          name: string,
          appliesTo: UserGroup,
          view?: AppointmentsView | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRecordBriefingSegmentMutationVariables = {
  input: CreateRecordBriefingSegmentInput,
  condition?: ModelRecordBriefingSegmentConditionInput | null,
};

export type CreateRecordBriefingSegmentMutation = {
  createRecordBriefingSegment?:  {
    __typename: "RecordBriefingSegment",
    id: string,
    logicalSegmentID: string,
    title?: string | null,
    text?: string | null,
    bodyParts?: Array< BodyPart | null > | null,
    injuredBodyParts?: Array< BodyPart | null > | null,
    editedBy?: string | null,
    pdfFileName: string,
    sourceTag?: string | null,
    segmentNumber?: number | null,
    sourcePdfS3Key: string,
    startPageNumber: number,
    endPageNumber: number,
    recordType: RecordType,
    extractedDate?: string | null,
    doctorName?: string | null,
    processingModel?: string | null,
    classificationConfidence?: number | null,
    hasDate?: boolean | null,
    potentialDuplicateID?: string | null,
    needsReview?: boolean | null,
    status?: SegmentStatus | null,
    documentID?: string | null,
    videoStartTime?: string | null,
    videoEndTime?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRecordBriefingSegmentMutationVariables = {
  input: UpdateRecordBriefingSegmentInput,
  condition?: ModelRecordBriefingSegmentConditionInput | null,
};

export type UpdateRecordBriefingSegmentMutation = {
  updateRecordBriefingSegment?:  {
    __typename: "RecordBriefingSegment",
    id: string,
    logicalSegmentID: string,
    title?: string | null,
    text?: string | null,
    bodyParts?: Array< BodyPart | null > | null,
    injuredBodyParts?: Array< BodyPart | null > | null,
    editedBy?: string | null,
    pdfFileName: string,
    sourceTag?: string | null,
    segmentNumber?: number | null,
    sourcePdfS3Key: string,
    startPageNumber: number,
    endPageNumber: number,
    recordType: RecordType,
    extractedDate?: string | null,
    doctorName?: string | null,
    processingModel?: string | null,
    classificationConfidence?: number | null,
    hasDate?: boolean | null,
    potentialDuplicateID?: string | null,
    needsReview?: boolean | null,
    status?: SegmentStatus | null,
    documentID?: string | null,
    videoStartTime?: string | null,
    videoEndTime?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRecordBriefingSegmentMutationVariables = {
  input: DeleteRecordBriefingSegmentInput,
  condition?: ModelRecordBriefingSegmentConditionInput | null,
};

export type DeleteRecordBriefingSegmentMutation = {
  deleteRecordBriefingSegment?:  {
    __typename: "RecordBriefingSegment",
    id: string,
    logicalSegmentID: string,
    title?: string | null,
    text?: string | null,
    bodyParts?: Array< BodyPart | null > | null,
    injuredBodyParts?: Array< BodyPart | null > | null,
    editedBy?: string | null,
    pdfFileName: string,
    sourceTag?: string | null,
    segmentNumber?: number | null,
    sourcePdfS3Key: string,
    startPageNumber: number,
    endPageNumber: number,
    recordType: RecordType,
    extractedDate?: string | null,
    doctorName?: string | null,
    processingModel?: string | null,
    classificationConfidence?: number | null,
    hasDate?: boolean | null,
    potentialDuplicateID?: string | null,
    needsReview?: boolean | null,
    status?: SegmentStatus | null,
    documentID?: string | null,
    videoStartTime?: string | null,
    videoEndTime?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRecordBriefingSegmentMappingMutationVariables = {
  input: CreateRecordBriefingSegmentMappingInput,
  condition?: ModelRecordBriefingSegmentMappingConditionInput | null,
};

export type CreateRecordBriefingSegmentMappingMutation = {
  createRecordBriefingSegmentMapping?:  {
    __typename: "RecordBriefingSegmentMapping",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    publishedSegmentID?: string | null,
    draftSegmentID?: string | null,
    markedForDeletion?: boolean | null,
    markedForCreation?: boolean | null,
    publishedSegment?:  {
      __typename: "RecordBriefingSegment",
      id: string,
      logicalSegmentID: string,
      title?: string | null,
      text?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      editedBy?: string | null,
      pdfFileName: string,
      sourceTag?: string | null,
      segmentNumber?: number | null,
      sourcePdfS3Key: string,
      startPageNumber: number,
      endPageNumber: number,
      recordType: RecordType,
      extractedDate?: string | null,
      doctorName?: string | null,
      processingModel?: string | null,
      classificationConfidence?: number | null,
      hasDate?: boolean | null,
      potentialDuplicateID?: string | null,
      needsReview?: boolean | null,
      status?: SegmentStatus | null,
      documentID?: string | null,
      videoStartTime?: string | null,
      videoEndTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    draftSegment?:  {
      __typename: "RecordBriefingSegment",
      id: string,
      logicalSegmentID: string,
      title?: string | null,
      text?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      editedBy?: string | null,
      pdfFileName: string,
      sourceTag?: string | null,
      segmentNumber?: number | null,
      sourcePdfS3Key: string,
      startPageNumber: number,
      endPageNumber: number,
      recordType: RecordType,
      extractedDate?: string | null,
      doctorName?: string | null,
      processingModel?: string | null,
      classificationConfidence?: number | null,
      hasDate?: boolean | null,
      potentialDuplicateID?: string | null,
      needsReview?: boolean | null,
      status?: SegmentStatus | null,
      documentID?: string | null,
      videoStartTime?: string | null,
      videoEndTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRecordBriefingSegmentMappingMutationVariables = {
  input: UpdateRecordBriefingSegmentMappingInput,
  condition?: ModelRecordBriefingSegmentMappingConditionInput | null,
};

export type UpdateRecordBriefingSegmentMappingMutation = {
  updateRecordBriefingSegmentMapping?:  {
    __typename: "RecordBriefingSegmentMapping",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    publishedSegmentID?: string | null,
    draftSegmentID?: string | null,
    markedForDeletion?: boolean | null,
    markedForCreation?: boolean | null,
    publishedSegment?:  {
      __typename: "RecordBriefingSegment",
      id: string,
      logicalSegmentID: string,
      title?: string | null,
      text?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      editedBy?: string | null,
      pdfFileName: string,
      sourceTag?: string | null,
      segmentNumber?: number | null,
      sourcePdfS3Key: string,
      startPageNumber: number,
      endPageNumber: number,
      recordType: RecordType,
      extractedDate?: string | null,
      doctorName?: string | null,
      processingModel?: string | null,
      classificationConfidence?: number | null,
      hasDate?: boolean | null,
      potentialDuplicateID?: string | null,
      needsReview?: boolean | null,
      status?: SegmentStatus | null,
      documentID?: string | null,
      videoStartTime?: string | null,
      videoEndTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    draftSegment?:  {
      __typename: "RecordBriefingSegment",
      id: string,
      logicalSegmentID: string,
      title?: string | null,
      text?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      editedBy?: string | null,
      pdfFileName: string,
      sourceTag?: string | null,
      segmentNumber?: number | null,
      sourcePdfS3Key: string,
      startPageNumber: number,
      endPageNumber: number,
      recordType: RecordType,
      extractedDate?: string | null,
      doctorName?: string | null,
      processingModel?: string | null,
      classificationConfidence?: number | null,
      hasDate?: boolean | null,
      potentialDuplicateID?: string | null,
      needsReview?: boolean | null,
      status?: SegmentStatus | null,
      documentID?: string | null,
      videoStartTime?: string | null,
      videoEndTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRecordBriefingSegmentMappingMutationVariables = {
  input: DeleteRecordBriefingSegmentMappingInput,
  condition?: ModelRecordBriefingSegmentMappingConditionInput | null,
};

export type DeleteRecordBriefingSegmentMappingMutation = {
  deleteRecordBriefingSegmentMapping?:  {
    __typename: "RecordBriefingSegmentMapping",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    publishedSegmentID?: string | null,
    draftSegmentID?: string | null,
    markedForDeletion?: boolean | null,
    markedForCreation?: boolean | null,
    publishedSegment?:  {
      __typename: "RecordBriefingSegment",
      id: string,
      logicalSegmentID: string,
      title?: string | null,
      text?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      editedBy?: string | null,
      pdfFileName: string,
      sourceTag?: string | null,
      segmentNumber?: number | null,
      sourcePdfS3Key: string,
      startPageNumber: number,
      endPageNumber: number,
      recordType: RecordType,
      extractedDate?: string | null,
      doctorName?: string | null,
      processingModel?: string | null,
      classificationConfidence?: number | null,
      hasDate?: boolean | null,
      potentialDuplicateID?: string | null,
      needsReview?: boolean | null,
      status?: SegmentStatus | null,
      documentID?: string | null,
      videoStartTime?: string | null,
      videoEndTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    draftSegment?:  {
      __typename: "RecordBriefingSegment",
      id: string,
      logicalSegmentID: string,
      title?: string | null,
      text?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      editedBy?: string | null,
      pdfFileName: string,
      sourceTag?: string | null,
      segmentNumber?: number | null,
      sourcePdfS3Key: string,
      startPageNumber: number,
      endPageNumber: number,
      recordType: RecordType,
      extractedDate?: string | null,
      doctorName?: string | null,
      processingModel?: string | null,
      classificationConfidence?: number | null,
      hasDate?: boolean | null,
      potentialDuplicateID?: string | null,
      needsReview?: boolean | null,
      status?: SegmentStatus | null,
      documentID?: string | null,
      videoStartTime?: string | null,
      videoEndTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRecordBriefingMutationVariables = {
  input: CreateRecordBriefingInput,
  condition?: ModelRecordBriefingConditionInput | null,
};

export type CreateRecordBriefingMutation = {
  createRecordBriefing?:  {
    __typename: "RecordBriefing",
    id: string,
    logicalBriefingID: string,
    segmentMappings?:  {
      __typename: "ModelRecordBriefingSegmentMappingConnection",
      items:  Array< {
        __typename: "RecordBriefingSegmentMapping",
        id: string,
        briefingID: string,
        logicalSegmentID: string,
        publishedSegmentID?: string | null,
        draftSegmentID?: string | null,
        markedForDeletion?: boolean | null,
        markedForCreation?: boolean | null,
        publishedSegment?:  {
          __typename: "RecordBriefingSegment",
          id: string,
          logicalSegmentID: string,
          title?: string | null,
          text?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          editedBy?: string | null,
          pdfFileName: string,
          sourceTag?: string | null,
          segmentNumber?: number | null,
          sourcePdfS3Key: string,
          startPageNumber: number,
          endPageNumber: number,
          recordType: RecordType,
          extractedDate?: string | null,
          doctorName?: string | null,
          processingModel?: string | null,
          classificationConfidence?: number | null,
          hasDate?: boolean | null,
          potentialDuplicateID?: string | null,
          needsReview?: boolean | null,
          status?: SegmentStatus | null,
          documentID?: string | null,
          videoStartTime?: string | null,
          videoEndTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        draftSegment?:  {
          __typename: "RecordBriefingSegment",
          id: string,
          logicalSegmentID: string,
          title?: string | null,
          text?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          editedBy?: string | null,
          pdfFileName: string,
          sourceTag?: string | null,
          segmentNumber?: number | null,
          sourcePdfS3Key: string,
          startPageNumber: number,
          endPageNumber: number,
          recordType: RecordType,
          extractedDate?: string | null,
          doctorName?: string | null,
          processingModel?: string | null,
          classificationConfidence?: number | null,
          hasDate?: boolean | null,
          potentialDuplicateID?: string | null,
          needsReview?: boolean | null,
          status?: SegmentStatus | null,
          documentID?: string | null,
          videoStartTime?: string | null,
          videoEndTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    googleDocExportLink?: string | null,
    googleDocExportedAt?: string | null,
    suggestionGeneration?:  {
      __typename: "SuggestionGenerationJob",
      status?: SuggestionGenerationStatus | null,
      jobId?: string | null,
      startedAt?: string | null,
      completedAt?: string | null,
      error?: string | null,
    } | null,
    editingPresence?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRecordBriefingMutationVariables = {
  input: UpdateRecordBriefingInput,
  condition?: ModelRecordBriefingConditionInput | null,
};

export type UpdateRecordBriefingMutation = {
  updateRecordBriefing?:  {
    __typename: "RecordBriefing",
    id: string,
    logicalBriefingID: string,
    segmentMappings?:  {
      __typename: "ModelRecordBriefingSegmentMappingConnection",
      items:  Array< {
        __typename: "RecordBriefingSegmentMapping",
        id: string,
        briefingID: string,
        logicalSegmentID: string,
        publishedSegmentID?: string | null,
        draftSegmentID?: string | null,
        markedForDeletion?: boolean | null,
        markedForCreation?: boolean | null,
        publishedSegment?:  {
          __typename: "RecordBriefingSegment",
          id: string,
          logicalSegmentID: string,
          title?: string | null,
          text?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          editedBy?: string | null,
          pdfFileName: string,
          sourceTag?: string | null,
          segmentNumber?: number | null,
          sourcePdfS3Key: string,
          startPageNumber: number,
          endPageNumber: number,
          recordType: RecordType,
          extractedDate?: string | null,
          doctorName?: string | null,
          processingModel?: string | null,
          classificationConfidence?: number | null,
          hasDate?: boolean | null,
          potentialDuplicateID?: string | null,
          needsReview?: boolean | null,
          status?: SegmentStatus | null,
          documentID?: string | null,
          videoStartTime?: string | null,
          videoEndTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        draftSegment?:  {
          __typename: "RecordBriefingSegment",
          id: string,
          logicalSegmentID: string,
          title?: string | null,
          text?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          editedBy?: string | null,
          pdfFileName: string,
          sourceTag?: string | null,
          segmentNumber?: number | null,
          sourcePdfS3Key: string,
          startPageNumber: number,
          endPageNumber: number,
          recordType: RecordType,
          extractedDate?: string | null,
          doctorName?: string | null,
          processingModel?: string | null,
          classificationConfidence?: number | null,
          hasDate?: boolean | null,
          potentialDuplicateID?: string | null,
          needsReview?: boolean | null,
          status?: SegmentStatus | null,
          documentID?: string | null,
          videoStartTime?: string | null,
          videoEndTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    googleDocExportLink?: string | null,
    googleDocExportedAt?: string | null,
    suggestionGeneration?:  {
      __typename: "SuggestionGenerationJob",
      status?: SuggestionGenerationStatus | null,
      jobId?: string | null,
      startedAt?: string | null,
      completedAt?: string | null,
      error?: string | null,
    } | null,
    editingPresence?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRecordBriefingMutationVariables = {
  input: DeleteRecordBriefingInput,
  condition?: ModelRecordBriefingConditionInput | null,
};

export type DeleteRecordBriefingMutation = {
  deleteRecordBriefing?:  {
    __typename: "RecordBriefing",
    id: string,
    logicalBriefingID: string,
    segmentMappings?:  {
      __typename: "ModelRecordBriefingSegmentMappingConnection",
      items:  Array< {
        __typename: "RecordBriefingSegmentMapping",
        id: string,
        briefingID: string,
        logicalSegmentID: string,
        publishedSegmentID?: string | null,
        draftSegmentID?: string | null,
        markedForDeletion?: boolean | null,
        markedForCreation?: boolean | null,
        publishedSegment?:  {
          __typename: "RecordBriefingSegment",
          id: string,
          logicalSegmentID: string,
          title?: string | null,
          text?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          editedBy?: string | null,
          pdfFileName: string,
          sourceTag?: string | null,
          segmentNumber?: number | null,
          sourcePdfS3Key: string,
          startPageNumber: number,
          endPageNumber: number,
          recordType: RecordType,
          extractedDate?: string | null,
          doctorName?: string | null,
          processingModel?: string | null,
          classificationConfidence?: number | null,
          hasDate?: boolean | null,
          potentialDuplicateID?: string | null,
          needsReview?: boolean | null,
          status?: SegmentStatus | null,
          documentID?: string | null,
          videoStartTime?: string | null,
          videoEndTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        draftSegment?:  {
          __typename: "RecordBriefingSegment",
          id: string,
          logicalSegmentID: string,
          title?: string | null,
          text?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          editedBy?: string | null,
          pdfFileName: string,
          sourceTag?: string | null,
          segmentNumber?: number | null,
          sourcePdfS3Key: string,
          startPageNumber: number,
          endPageNumber: number,
          recordType: RecordType,
          extractedDate?: string | null,
          doctorName?: string | null,
          processingModel?: string | null,
          classificationConfidence?: number | null,
          hasDate?: boolean | null,
          potentialDuplicateID?: string | null,
          needsReview?: boolean | null,
          status?: SegmentStatus | null,
          documentID?: string | null,
          videoStartTime?: string | null,
          videoEndTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    googleDocExportLink?: string | null,
    googleDocExportedAt?: string | null,
    suggestionGeneration?:  {
      __typename: "SuggestionGenerationJob",
      status?: SuggestionGenerationStatus | null,
      jobId?: string | null,
      startedAt?: string | null,
      completedAt?: string | null,
      error?: string | null,
    } | null,
    editingPresence?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRecordBriefingSegmentAnnotationMutationVariables = {
  input: CreateRecordBriefingSegmentAnnotationInput,
  condition?: ModelRecordBriefingSegmentAnnotationConditionInput | null,
};

export type CreateRecordBriefingSegmentAnnotationMutation = {
  createRecordBriefingSegmentAnnotation?:  {
    __typename: "RecordBriefingSegmentAnnotation",
    id: string,
    logicalSegmentID: string,
    isStarred?: boolean | null,
    isImportant?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRecordBriefingSegmentAnnotationMutationVariables = {
  input: UpdateRecordBriefingSegmentAnnotationInput,
  condition?: ModelRecordBriefingSegmentAnnotationConditionInput | null,
};

export type UpdateRecordBriefingSegmentAnnotationMutation = {
  updateRecordBriefingSegmentAnnotation?:  {
    __typename: "RecordBriefingSegmentAnnotation",
    id: string,
    logicalSegmentID: string,
    isStarred?: boolean | null,
    isImportant?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRecordBriefingSegmentAnnotationMutationVariables = {
  input: DeleteRecordBriefingSegmentAnnotationInput,
  condition?: ModelRecordBriefingSegmentAnnotationConditionInput | null,
};

export type DeleteRecordBriefingSegmentAnnotationMutation = {
  deleteRecordBriefingSegmentAnnotation?:  {
    __typename: "RecordBriefingSegmentAnnotation",
    id: string,
    logicalSegmentID: string,
    isStarred?: boolean | null,
    isImportant?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRecordBriefingSegmentSuggestionMutationVariables = {
  input: CreateRecordBriefingSegmentSuggestionInput,
  condition?: ModelRecordBriefingSegmentSuggestionConditionInput | null,
};

export type CreateRecordBriefingSegmentSuggestionMutation = {
  createRecordBriefingSegmentSuggestion?:  {
    __typename: "RecordBriefingSegmentSuggestion",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    suggestionType: SegmentSuggestionType,
    reason: SegmentSuggestionReason,
    reasonDetails?: string | null,
    textRange?:  {
      __typename: "TextRange",
      textToDelete: string,
      occurrenceIndex?: number | null,
      prefixContext?: string | null,
      suffixContext?: string | null,
    } | null,
    status: SegmentSuggestionStatus,
    resolvedBy?: string | null,
    resolvedAt?: string | null,
    seen?: boolean | null,
    confidence?: number | null,
    relatedSegmentID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRecordBriefingSegmentSuggestionMutationVariables = {
  input: UpdateRecordBriefingSegmentSuggestionInput,
  condition?: ModelRecordBriefingSegmentSuggestionConditionInput | null,
};

export type UpdateRecordBriefingSegmentSuggestionMutation = {
  updateRecordBriefingSegmentSuggestion?:  {
    __typename: "RecordBriefingSegmentSuggestion",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    suggestionType: SegmentSuggestionType,
    reason: SegmentSuggestionReason,
    reasonDetails?: string | null,
    textRange?:  {
      __typename: "TextRange",
      textToDelete: string,
      occurrenceIndex?: number | null,
      prefixContext?: string | null,
      suffixContext?: string | null,
    } | null,
    status: SegmentSuggestionStatus,
    resolvedBy?: string | null,
    resolvedAt?: string | null,
    seen?: boolean | null,
    confidence?: number | null,
    relatedSegmentID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRecordBriefingSegmentSuggestionMutationVariables = {
  input: DeleteRecordBriefingSegmentSuggestionInput,
  condition?: ModelRecordBriefingSegmentSuggestionConditionInput | null,
};

export type DeleteRecordBriefingSegmentSuggestionMutation = {
  deleteRecordBriefingSegmentSuggestion?:  {
    __typename: "RecordBriefingSegmentSuggestion",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    suggestionType: SegmentSuggestionType,
    reason: SegmentSuggestionReason,
    reasonDetails?: string | null,
    textRange?:  {
      __typename: "TextRange",
      textToDelete: string,
      occurrenceIndex?: number | null,
      prefixContext?: string | null,
      suffixContext?: string | null,
    } | null,
    status: SegmentSuggestionStatus,
    resolvedBy?: string | null,
    resolvedAt?: string | null,
    seen?: boolean | null,
    confidence?: number | null,
    relatedSegmentID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSummaryCitationMutationVariables = {
  input: CreateSummaryCitationInput,
  condition?: ModelSummaryCitationConditionInput | null,
};

export type CreateSummaryCitationMutation = {
  createSummaryCitation?:  {
    __typename: "SummaryCitation",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    summaryText: string,
    citationID: string,
    status: SummaryCitationStatus,
    removedBy?: string | null,
    removedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSummaryCitationMutationVariables = {
  input: UpdateSummaryCitationInput,
  condition?: ModelSummaryCitationConditionInput | null,
};

export type UpdateSummaryCitationMutation = {
  updateSummaryCitation?:  {
    __typename: "SummaryCitation",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    summaryText: string,
    citationID: string,
    status: SummaryCitationStatus,
    removedBy?: string | null,
    removedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSummaryCitationMutationVariables = {
  input: DeleteSummaryCitationInput,
  condition?: ModelSummaryCitationConditionInput | null,
};

export type DeleteSummaryCitationMutation = {
  deleteSummaryCitation?:  {
    __typename: "SummaryCitation",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    summaryText: string,
    citationID: string,
    status: SummaryCitationStatus,
    removedBy?: string | null,
    removedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSuggestionMutationVariables = {
  input: CreateSuggestionInput,
  condition?: ModelSuggestionConditionInput | null,
};

export type CreateSuggestionMutation = {
  createSuggestion?:  {
    __typename: "Suggestion",
    id: string,
    appointmentID: string,
    source: SuggestionSource,
    changeType: SuggestionChangeType,
    resourceURI: string,
    suggestedValue?: string | null,
    existingValue?: string | null,
    rationale?: string | null,
    status?: SuggestionStatus | null,
    resolvedByUserID?: string | null,
    resolvedAt?: string | null,
    versionID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSuggestionMutationVariables = {
  input: UpdateSuggestionInput,
  condition?: ModelSuggestionConditionInput | null,
};

export type UpdateSuggestionMutation = {
  updateSuggestion?:  {
    __typename: "Suggestion",
    id: string,
    appointmentID: string,
    source: SuggestionSource,
    changeType: SuggestionChangeType,
    resourceURI: string,
    suggestedValue?: string | null,
    existingValue?: string | null,
    rationale?: string | null,
    status?: SuggestionStatus | null,
    resolvedByUserID?: string | null,
    resolvedAt?: string | null,
    versionID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSuggestionMutationVariables = {
  input: DeleteSuggestionInput,
  condition?: ModelSuggestionConditionInput | null,
};

export type DeleteSuggestionMutation = {
  deleteSuggestion?:  {
    __typename: "Suggestion",
    id: string,
    appointmentID: string,
    source: SuggestionSource,
    changeType: SuggestionChangeType,
    resourceURI: string,
    suggestedValue?: string | null,
    existingValue?: string | null,
    rationale?: string | null,
    status?: SuggestionStatus | null,
    resolvedByUserID?: string | null,
    resolvedAt?: string | null,
    versionID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOnsiteOpsConfigMutationVariables = {
  input: CreateOnsiteOpsConfigInput,
  condition?: ModelOnsiteOpsConfigConditionInput | null,
};

export type CreateOnsiteOpsConfigMutation = {
  createOnsiteOpsConfig?:  {
    __typename: "OnsiteOpsConfig",
    doctorLocationKey: string,
    doctor?:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null,
    location?:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    } | null,
    medicalAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    secondaryMedicalAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    assignmentEffectiveDate?: string | null,
    createdAt: string,
    updatedAt: string,
    onsiteOpsConfigDoctorId?: string | null,
    onsiteOpsConfigLocationId?: string | null,
    onsiteOpsConfigMedicalAssistantId?: string | null,
    onsiteOpsConfigSecondaryMedicalAssistantId?: string | null,
  } | null,
};

export type UpdateOnsiteOpsConfigMutationVariables = {
  input: UpdateOnsiteOpsConfigInput,
  condition?: ModelOnsiteOpsConfigConditionInput | null,
};

export type UpdateOnsiteOpsConfigMutation = {
  updateOnsiteOpsConfig?:  {
    __typename: "OnsiteOpsConfig",
    doctorLocationKey: string,
    doctor?:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null,
    location?:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    } | null,
    medicalAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    secondaryMedicalAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    assignmentEffectiveDate?: string | null,
    createdAt: string,
    updatedAt: string,
    onsiteOpsConfigDoctorId?: string | null,
    onsiteOpsConfigLocationId?: string | null,
    onsiteOpsConfigMedicalAssistantId?: string | null,
    onsiteOpsConfigSecondaryMedicalAssistantId?: string | null,
  } | null,
};

export type DeleteOnsiteOpsConfigMutationVariables = {
  input: DeleteOnsiteOpsConfigInput,
  condition?: ModelOnsiteOpsConfigConditionInput | null,
};

export type DeleteOnsiteOpsConfigMutation = {
  deleteOnsiteOpsConfig?:  {
    __typename: "OnsiteOpsConfig",
    doctorLocationKey: string,
    doctor?:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null,
    location?:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    } | null,
    medicalAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    secondaryMedicalAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    assignmentEffectiveDate?: string | null,
    createdAt: string,
    updatedAt: string,
    onsiteOpsConfigDoctorId?: string | null,
    onsiteOpsConfigLocationId?: string | null,
    onsiteOpsConfigMedicalAssistantId?: string | null,
    onsiteOpsConfigSecondaryMedicalAssistantId?: string | null,
  } | null,
};

export type CreateOpsGlobalSettingsMutationVariables = {
  input: CreateOpsGlobalSettingsInput,
  condition?: ModelOpsGlobalSettingsConditionInput | null,
};

export type CreateOpsGlobalSettingsMutation = {
  createOpsGlobalSettings?:  {
    __typename: "OpsGlobalSettings",
    key: string,
    inPersonEvaluationPreVisitDurationDays?: number | null,
    supplementalPreVisitDurationDays?: number | null,
    depositionPreVisitDurationDays?: number | null,
    defaultGlobalOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalMA?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalScheduler?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalReportOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalPreVisitReviewer?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalBillingOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    appointmentTypeMAAssignments?:  Array< {
      __typename: "AppointmentTypeMAAssignment",
      appointmentType: AppointmentType,
      maWeights:  Array< {
        __typename: "AppointmentTypeMAWeight",
        medicalAssistantID: string,
        weightPercentage: number,
      } >,
    } | null > | null,
    maAssignmentCapacitySettings?:  {
      __typename: "MAAssignmentCapacitySettings",
      level1WeeklyPointBudget: number,
      level2WeeklyPointBudget: number,
      level3WeeklyPointBudget: number,
      level4WeeklyPointBudget: number,
      maxAppointmentsPerMAWeek: number,
      maxAppointmentsPerMADay?: number | null,
    } | null,
    bodyPartSpecialtiesMappings?:  Array< {
      __typename: "BodyPartSpecialtiesMapping",
      bodyPart: BodyPart,
      specialties: Array< SpecialtyType >,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    opsGlobalSettingsDefaultGlobalOnsiteOpsId?: string | null,
    opsGlobalSettingsDefaultGlobalMAId?: string | null,
    opsGlobalSettingsDefaultGlobalSchedulerId?: string | null,
    opsGlobalSettingsDefaultGlobalReportOpsId?: string | null,
    opsGlobalSettingsDefaultGlobalPreVisitReviewerId?: string | null,
    opsGlobalSettingsDefaultGlobalBillingOpsId?: string | null,
  } | null,
};

export type UpdateOpsGlobalSettingsMutationVariables = {
  input: UpdateOpsGlobalSettingsInput,
  condition?: ModelOpsGlobalSettingsConditionInput | null,
};

export type UpdateOpsGlobalSettingsMutation = {
  updateOpsGlobalSettings?:  {
    __typename: "OpsGlobalSettings",
    key: string,
    inPersonEvaluationPreVisitDurationDays?: number | null,
    supplementalPreVisitDurationDays?: number | null,
    depositionPreVisitDurationDays?: number | null,
    defaultGlobalOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalMA?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalScheduler?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalReportOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalPreVisitReviewer?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalBillingOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    appointmentTypeMAAssignments?:  Array< {
      __typename: "AppointmentTypeMAAssignment",
      appointmentType: AppointmentType,
      maWeights:  Array< {
        __typename: "AppointmentTypeMAWeight",
        medicalAssistantID: string,
        weightPercentage: number,
      } >,
    } | null > | null,
    maAssignmentCapacitySettings?:  {
      __typename: "MAAssignmentCapacitySettings",
      level1WeeklyPointBudget: number,
      level2WeeklyPointBudget: number,
      level3WeeklyPointBudget: number,
      level4WeeklyPointBudget: number,
      maxAppointmentsPerMAWeek: number,
      maxAppointmentsPerMADay?: number | null,
    } | null,
    bodyPartSpecialtiesMappings?:  Array< {
      __typename: "BodyPartSpecialtiesMapping",
      bodyPart: BodyPart,
      specialties: Array< SpecialtyType >,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    opsGlobalSettingsDefaultGlobalOnsiteOpsId?: string | null,
    opsGlobalSettingsDefaultGlobalMAId?: string | null,
    opsGlobalSettingsDefaultGlobalSchedulerId?: string | null,
    opsGlobalSettingsDefaultGlobalReportOpsId?: string | null,
    opsGlobalSettingsDefaultGlobalPreVisitReviewerId?: string | null,
    opsGlobalSettingsDefaultGlobalBillingOpsId?: string | null,
  } | null,
};

export type DeleteOpsGlobalSettingsMutationVariables = {
  input: DeleteOpsGlobalSettingsInput,
  condition?: ModelOpsGlobalSettingsConditionInput | null,
};

export type DeleteOpsGlobalSettingsMutation = {
  deleteOpsGlobalSettings?:  {
    __typename: "OpsGlobalSettings",
    key: string,
    inPersonEvaluationPreVisitDurationDays?: number | null,
    supplementalPreVisitDurationDays?: number | null,
    depositionPreVisitDurationDays?: number | null,
    defaultGlobalOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalMA?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalScheduler?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalReportOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalPreVisitReviewer?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalBillingOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    appointmentTypeMAAssignments?:  Array< {
      __typename: "AppointmentTypeMAAssignment",
      appointmentType: AppointmentType,
      maWeights:  Array< {
        __typename: "AppointmentTypeMAWeight",
        medicalAssistantID: string,
        weightPercentage: number,
      } >,
    } | null > | null,
    maAssignmentCapacitySettings?:  {
      __typename: "MAAssignmentCapacitySettings",
      level1WeeklyPointBudget: number,
      level2WeeklyPointBudget: number,
      level3WeeklyPointBudget: number,
      level4WeeklyPointBudget: number,
      maxAppointmentsPerMAWeek: number,
      maxAppointmentsPerMADay?: number | null,
    } | null,
    bodyPartSpecialtiesMappings?:  Array< {
      __typename: "BodyPartSpecialtiesMapping",
      bodyPart: BodyPart,
      specialties: Array< SpecialtyType >,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    opsGlobalSettingsDefaultGlobalOnsiteOpsId?: string | null,
    opsGlobalSettingsDefaultGlobalMAId?: string | null,
    opsGlobalSettingsDefaultGlobalSchedulerId?: string | null,
    opsGlobalSettingsDefaultGlobalReportOpsId?: string | null,
    opsGlobalSettingsDefaultGlobalPreVisitReviewerId?: string | null,
    opsGlobalSettingsDefaultGlobalBillingOpsId?: string | null,
  } | null,
};

export type CreateSpecialtyCategoryMutationVariables = {
  input: CreateSpecialtyCategoryInput,
  condition?: ModelSpecialtyCategoryConditionInput | null,
};

export type CreateSpecialtyCategoryMutation = {
  createSpecialtyCategory?:  {
    __typename: "SpecialtyCategory",
    id: string,
    name: string,
    specialties?: Array< SpecialtyType > | null,
    fallbackMA?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    medicalAssistants?:  {
      __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
      items:  Array< {
        __typename: "MedicalAssistantSpecialtyCategory",
        id: string,
        medicalAssistantId: string,
        specialtyCategoryId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        specialtyCategory:  {
          __typename: "SpecialtyCategory",
          id: string,
          name: string,
          specialties?: Array< SpecialtyType > | null,
          createdAt: string,
          updatedAt: string,
          specialtyCategoryFallbackMAId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    specialtyCategoryFallbackMAId?: string | null,
  } | null,
};

export type UpdateSpecialtyCategoryMutationVariables = {
  input: UpdateSpecialtyCategoryInput,
  condition?: ModelSpecialtyCategoryConditionInput | null,
};

export type UpdateSpecialtyCategoryMutation = {
  updateSpecialtyCategory?:  {
    __typename: "SpecialtyCategory",
    id: string,
    name: string,
    specialties?: Array< SpecialtyType > | null,
    fallbackMA?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    medicalAssistants?:  {
      __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
      items:  Array< {
        __typename: "MedicalAssistantSpecialtyCategory",
        id: string,
        medicalAssistantId: string,
        specialtyCategoryId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        specialtyCategory:  {
          __typename: "SpecialtyCategory",
          id: string,
          name: string,
          specialties?: Array< SpecialtyType > | null,
          createdAt: string,
          updatedAt: string,
          specialtyCategoryFallbackMAId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    specialtyCategoryFallbackMAId?: string | null,
  } | null,
};

export type DeleteSpecialtyCategoryMutationVariables = {
  input: DeleteSpecialtyCategoryInput,
  condition?: ModelSpecialtyCategoryConditionInput | null,
};

export type DeleteSpecialtyCategoryMutation = {
  deleteSpecialtyCategory?:  {
    __typename: "SpecialtyCategory",
    id: string,
    name: string,
    specialties?: Array< SpecialtyType > | null,
    fallbackMA?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    medicalAssistants?:  {
      __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
      items:  Array< {
        __typename: "MedicalAssistantSpecialtyCategory",
        id: string,
        medicalAssistantId: string,
        specialtyCategoryId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        specialtyCategory:  {
          __typename: "SpecialtyCategory",
          id: string,
          name: string,
          specialties?: Array< SpecialtyType > | null,
          createdAt: string,
          updatedAt: string,
          specialtyCategoryFallbackMAId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    specialtyCategoryFallbackMAId?: string | null,
  } | null,
};

export type CreateCoverLetterRecapMutationVariables = {
  input: CreateCoverLetterRecapInput,
  condition?: ModelCoverLetterRecapConditionInput | null,
};

export type CreateCoverLetterRecapMutation = {
  createCoverLetterRecap?:  {
    __typename: "CoverLetterRecap",
    id: string,
    uploadedFileID: string,
    recapText?: string | null,
    status: CoverLetterRecapStatus,
    errorMessage?: string | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCoverLetterRecapMutationVariables = {
  input: UpdateCoverLetterRecapInput,
  condition?: ModelCoverLetterRecapConditionInput | null,
};

export type UpdateCoverLetterRecapMutation = {
  updateCoverLetterRecap?:  {
    __typename: "CoverLetterRecap",
    id: string,
    uploadedFileID: string,
    recapText?: string | null,
    status: CoverLetterRecapStatus,
    errorMessage?: string | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCoverLetterRecapMutationVariables = {
  input: DeleteCoverLetterRecapInput,
  condition?: ModelCoverLetterRecapConditionInput | null,
};

export type DeleteCoverLetterRecapMutation = {
  deleteCoverLetterRecap?:  {
    __typename: "CoverLetterRecap",
    id: string,
    uploadedFileID: string,
    recapText?: string | null,
    status: CoverLetterRecapStatus,
    errorMessage?: string | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateIntroParagraphMutationVariables = {
  input: CreateIntroParagraphInput,
  condition?: ModelIntroParagraphConditionInput | null,
};

export type CreateIntroParagraphMutation = {
  createIntroParagraph?:  {
    __typename: "IntroParagraph",
    id: string,
    appointmentRecordID: string,
    introParagraphText?: string | null,
    sourceRecaps?:  Array< {
      __typename: "CoverLetterRecapSnapshot",
      coverLetterRecapID: string,
      uploadedFileID: string,
      recapText: string,
      generatedAt?: string | null,
    } | null > | null,
    status: IntroParagraphStatus,
    errorMessage?: string | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateIntroParagraphMutationVariables = {
  input: UpdateIntroParagraphInput,
  condition?: ModelIntroParagraphConditionInput | null,
};

export type UpdateIntroParagraphMutation = {
  updateIntroParagraph?:  {
    __typename: "IntroParagraph",
    id: string,
    appointmentRecordID: string,
    introParagraphText?: string | null,
    sourceRecaps?:  Array< {
      __typename: "CoverLetterRecapSnapshot",
      coverLetterRecapID: string,
      uploadedFileID: string,
      recapText: string,
      generatedAt?: string | null,
    } | null > | null,
    status: IntroParagraphStatus,
    errorMessage?: string | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteIntroParagraphMutationVariables = {
  input: DeleteIntroParagraphInput,
  condition?: ModelIntroParagraphConditionInput | null,
};

export type DeleteIntroParagraphMutation = {
  deleteIntroParagraph?:  {
    __typename: "IntroParagraph",
    id: string,
    appointmentRecordID: string,
    introParagraphText?: string | null,
    sourceRecaps?:  Array< {
      __typename: "CoverLetterRecapSnapshot",
      coverLetterRecapID: string,
      uploadedFileID: string,
      recapText: string,
      generatedAt?: string | null,
    } | null > | null,
    status: IntroParagraphStatus,
    errorMessage?: string | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateIntroductionStatementMutationVariables = {
  input: CreateIntroductionStatementInput,
  condition?: ModelIntroductionStatementConditionInput | null,
};

export type CreateIntroductionStatementMutation = {
  createIntroductionStatement?:  {
    __typename: "IntroductionStatement",
    id: string,
    appointmentRecordID: string,
    kind: IntroductionStatementKind,
    text?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    selectedCoverLetterFileID?: string | null,
    selectionConfirmedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateIntroductionStatementMutationVariables = {
  input: UpdateIntroductionStatementInput,
  condition?: ModelIntroductionStatementConditionInput | null,
};

export type UpdateIntroductionStatementMutation = {
  updateIntroductionStatement?:  {
    __typename: "IntroductionStatement",
    id: string,
    appointmentRecordID: string,
    kind: IntroductionStatementKind,
    text?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    selectedCoverLetterFileID?: string | null,
    selectionConfirmedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteIntroductionStatementMutationVariables = {
  input: DeleteIntroductionStatementInput,
  condition?: ModelIntroductionStatementConditionInput | null,
};

export type DeleteIntroductionStatementMutation = {
  deleteIntroductionStatement?:  {
    __typename: "IntroductionStatement",
    id: string,
    appointmentRecordID: string,
    kind: IntroductionStatementKind,
    text?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    selectedCoverLetterFileID?: string | null,
    selectionConfirmedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAssessmentMutationVariables = {
  input: CreateAssessmentInput,
  condition?: ModelAssessmentConditionInput | null,
};

export type CreateAssessmentMutation = {
  createAssessment?:  {
    __typename: "Assessment",
    id: string,
    injuries?:  Array< {
      __typename: "AssessmentInjury",
      injuryType?: InjuryType | null,
      dateOfInjury?: string | null,
      dateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      dateOfInjuryEnd?: string | null,
      dateOfInjuryEndFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      bodyParts?: Array< BodyPart | null > | null,
      causeOfInjury?: string | null,
      causedByWork?: AssessmentCausationOption | null,
      causedByWorkExplanation?: string | null,
    } | null > | null,
    discussedBodyParts?: Array< BodyPart | null > | null,
    bodyPartsNotDiscussedReason?: string | null,
    discussions?: string | null,
    diagnoses?:  Array< {
      __typename: "AssessmentDiagnosis",
      diagnosis?: string | null,
      icdCode?: string | null,
      evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
      evidence?: string | null,
    } | null > | null,
    bodyPartMMIStatus?:  {
      __typename: "AssessmentBodyPartMMIStatus",
      discussByBodyPart?: boolean | null,
      allBodyPartsMMI?:  {
        __typename: "AssessmentBodyPartEvaluation",
        mmi?: boolean | null,
        mmiReason?: string | null,
        expectedMMITimeRange?: AssessmentMmiTimeRange | null,
        expectedMMITimeRangeExplanation?: string | null,
        treatments?: Array< string | null > | null,
        treatmentsExplanation?: string | null,
        discussions?: string | null,
        impairmentRating?: string | null,
        impairmentRatingNotApplicable?: boolean | null,
        deferImpairmentRating?: boolean | null,
        deferImpairmentRatingReason?: string | null,
        apportionment?: string | null,
        apportionmentNotApplicable?: boolean | null,
        deferApportionment?: boolean | null,
        deferApportionmentReason?: string | null,
      } | null,
      bodyPartMMIStatuses?:  Array< {
        __typename: "AssessmentBodyPart",
        bodyPart?: BodyPart | null,
        evaluation?:  {
          __typename: "AssessmentBodyPartEvaluation",
          mmi?: boolean | null,
          mmiReason?: string | null,
          expectedMMITimeRange?: AssessmentMmiTimeRange | null,
          expectedMMITimeRangeExplanation?: string | null,
          treatments?: Array< string | null > | null,
          treatmentsExplanation?: string | null,
          discussions?: string | null,
          impairmentRating?: string | null,
          impairmentRatingNotApplicable?: boolean | null,
          deferImpairmentRating?: boolean | null,
          deferImpairmentRatingReason?: string | null,
          apportionment?: string | null,
          apportionmentNotApplicable?: boolean | null,
          deferApportionment?: boolean | null,
          deferApportionmentReason?: string | null,
        } | null,
      } | null > | null,
    } | null,
    workStatus?: string | null,
    markedAsDone?: boolean | null,
    discussDiagnosesFreeForm?: boolean | null,
    diagnosesFreeform?: string | null,
    discussCausationFreeForm?: boolean | null,
    causationFreeForm?: string | null,
    discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
    hasPatientReachedMMIFreeForm?: string | null,
    discussMMIByBodyPartFreeForm?: string | null,
    impairmentRatingByBodyPartFreeForm?: string | null,
    apportionmentByBodyPartFreeForm?: string | null,
    impairmentRatingOtherComments?: string | null,
    apportionmentOtherComments?: string | null,
    assessmentMode?: AssessmentMode | null,
    assessmentFreeForm?:  {
      __typename: "AssessmentFreeForm",
      injuries?:  Array< {
        __typename: "AssessmentInjury",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        dateOfInjuryEnd?: string | null,
        dateOfInjuryEndFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        bodyParts?: Array< BodyPart | null > | null,
        causeOfInjury?: string | null,
        causedByWork?: AssessmentCausationOption | null,
        causedByWorkExplanation?: string | null,
      } | null > | null,
      discussions?: string | null,
      diagnosesAndEvidence?: string | null,
      causation?: string | null,
      hasPatientReachedMMI?: string | null,
      discussMMIByBodyPart?: string | null,
      impairmentRatingByBodyPart?: string | null,
      apportionmentByBodyPart?: string | null,
      workStatus?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAssessmentMutationVariables = {
  input: UpdateAssessmentInput,
  condition?: ModelAssessmentConditionInput | null,
};

export type UpdateAssessmentMutation = {
  updateAssessment?:  {
    __typename: "Assessment",
    id: string,
    injuries?:  Array< {
      __typename: "AssessmentInjury",
      injuryType?: InjuryType | null,
      dateOfInjury?: string | null,
      dateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      dateOfInjuryEnd?: string | null,
      dateOfInjuryEndFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      bodyParts?: Array< BodyPart | null > | null,
      causeOfInjury?: string | null,
      causedByWork?: AssessmentCausationOption | null,
      causedByWorkExplanation?: string | null,
    } | null > | null,
    discussedBodyParts?: Array< BodyPart | null > | null,
    bodyPartsNotDiscussedReason?: string | null,
    discussions?: string | null,
    diagnoses?:  Array< {
      __typename: "AssessmentDiagnosis",
      diagnosis?: string | null,
      icdCode?: string | null,
      evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
      evidence?: string | null,
    } | null > | null,
    bodyPartMMIStatus?:  {
      __typename: "AssessmentBodyPartMMIStatus",
      discussByBodyPart?: boolean | null,
      allBodyPartsMMI?:  {
        __typename: "AssessmentBodyPartEvaluation",
        mmi?: boolean | null,
        mmiReason?: string | null,
        expectedMMITimeRange?: AssessmentMmiTimeRange | null,
        expectedMMITimeRangeExplanation?: string | null,
        treatments?: Array< string | null > | null,
        treatmentsExplanation?: string | null,
        discussions?: string | null,
        impairmentRating?: string | null,
        impairmentRatingNotApplicable?: boolean | null,
        deferImpairmentRating?: boolean | null,
        deferImpairmentRatingReason?: string | null,
        apportionment?: string | null,
        apportionmentNotApplicable?: boolean | null,
        deferApportionment?: boolean | null,
        deferApportionmentReason?: string | null,
      } | null,
      bodyPartMMIStatuses?:  Array< {
        __typename: "AssessmentBodyPart",
        bodyPart?: BodyPart | null,
        evaluation?:  {
          __typename: "AssessmentBodyPartEvaluation",
          mmi?: boolean | null,
          mmiReason?: string | null,
          expectedMMITimeRange?: AssessmentMmiTimeRange | null,
          expectedMMITimeRangeExplanation?: string | null,
          treatments?: Array< string | null > | null,
          treatmentsExplanation?: string | null,
          discussions?: string | null,
          impairmentRating?: string | null,
          impairmentRatingNotApplicable?: boolean | null,
          deferImpairmentRating?: boolean | null,
          deferImpairmentRatingReason?: string | null,
          apportionment?: string | null,
          apportionmentNotApplicable?: boolean | null,
          deferApportionment?: boolean | null,
          deferApportionmentReason?: string | null,
        } | null,
      } | null > | null,
    } | null,
    workStatus?: string | null,
    markedAsDone?: boolean | null,
    discussDiagnosesFreeForm?: boolean | null,
    diagnosesFreeform?: string | null,
    discussCausationFreeForm?: boolean | null,
    causationFreeForm?: string | null,
    discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
    hasPatientReachedMMIFreeForm?: string | null,
    discussMMIByBodyPartFreeForm?: string | null,
    impairmentRatingByBodyPartFreeForm?: string | null,
    apportionmentByBodyPartFreeForm?: string | null,
    impairmentRatingOtherComments?: string | null,
    apportionmentOtherComments?: string | null,
    assessmentMode?: AssessmentMode | null,
    assessmentFreeForm?:  {
      __typename: "AssessmentFreeForm",
      injuries?:  Array< {
        __typename: "AssessmentInjury",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        dateOfInjuryEnd?: string | null,
        dateOfInjuryEndFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        bodyParts?: Array< BodyPart | null > | null,
        causeOfInjury?: string | null,
        causedByWork?: AssessmentCausationOption | null,
        causedByWorkExplanation?: string | null,
      } | null > | null,
      discussions?: string | null,
      diagnosesAndEvidence?: string | null,
      causation?: string | null,
      hasPatientReachedMMI?: string | null,
      discussMMIByBodyPart?: string | null,
      impairmentRatingByBodyPart?: string | null,
      apportionmentByBodyPart?: string | null,
      workStatus?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAssessmentMutationVariables = {
  input: DeleteAssessmentInput,
  condition?: ModelAssessmentConditionInput | null,
};

export type DeleteAssessmentMutation = {
  deleteAssessment?:  {
    __typename: "Assessment",
    id: string,
    injuries?:  Array< {
      __typename: "AssessmentInjury",
      injuryType?: InjuryType | null,
      dateOfInjury?: string | null,
      dateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      dateOfInjuryEnd?: string | null,
      dateOfInjuryEndFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      bodyParts?: Array< BodyPart | null > | null,
      causeOfInjury?: string | null,
      causedByWork?: AssessmentCausationOption | null,
      causedByWorkExplanation?: string | null,
    } | null > | null,
    discussedBodyParts?: Array< BodyPart | null > | null,
    bodyPartsNotDiscussedReason?: string | null,
    discussions?: string | null,
    diagnoses?:  Array< {
      __typename: "AssessmentDiagnosis",
      diagnosis?: string | null,
      icdCode?: string | null,
      evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
      evidence?: string | null,
    } | null > | null,
    bodyPartMMIStatus?:  {
      __typename: "AssessmentBodyPartMMIStatus",
      discussByBodyPart?: boolean | null,
      allBodyPartsMMI?:  {
        __typename: "AssessmentBodyPartEvaluation",
        mmi?: boolean | null,
        mmiReason?: string | null,
        expectedMMITimeRange?: AssessmentMmiTimeRange | null,
        expectedMMITimeRangeExplanation?: string | null,
        treatments?: Array< string | null > | null,
        treatmentsExplanation?: string | null,
        discussions?: string | null,
        impairmentRating?: string | null,
        impairmentRatingNotApplicable?: boolean | null,
        deferImpairmentRating?: boolean | null,
        deferImpairmentRatingReason?: string | null,
        apportionment?: string | null,
        apportionmentNotApplicable?: boolean | null,
        deferApportionment?: boolean | null,
        deferApportionmentReason?: string | null,
      } | null,
      bodyPartMMIStatuses?:  Array< {
        __typename: "AssessmentBodyPart",
        bodyPart?: BodyPart | null,
        evaluation?:  {
          __typename: "AssessmentBodyPartEvaluation",
          mmi?: boolean | null,
          mmiReason?: string | null,
          expectedMMITimeRange?: AssessmentMmiTimeRange | null,
          expectedMMITimeRangeExplanation?: string | null,
          treatments?: Array< string | null > | null,
          treatmentsExplanation?: string | null,
          discussions?: string | null,
          impairmentRating?: string | null,
          impairmentRatingNotApplicable?: boolean | null,
          deferImpairmentRating?: boolean | null,
          deferImpairmentRatingReason?: string | null,
          apportionment?: string | null,
          apportionmentNotApplicable?: boolean | null,
          deferApportionment?: boolean | null,
          deferApportionmentReason?: string | null,
        } | null,
      } | null > | null,
    } | null,
    workStatus?: string | null,
    markedAsDone?: boolean | null,
    discussDiagnosesFreeForm?: boolean | null,
    diagnosesFreeform?: string | null,
    discussCausationFreeForm?: boolean | null,
    causationFreeForm?: string | null,
    discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
    hasPatientReachedMMIFreeForm?: string | null,
    discussMMIByBodyPartFreeForm?: string | null,
    impairmentRatingByBodyPartFreeForm?: string | null,
    apportionmentByBodyPartFreeForm?: string | null,
    impairmentRatingOtherComments?: string | null,
    apportionmentOtherComments?: string | null,
    assessmentMode?: AssessmentMode | null,
    assessmentFreeForm?:  {
      __typename: "AssessmentFreeForm",
      injuries?:  Array< {
        __typename: "AssessmentInjury",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        dateOfInjuryEnd?: string | null,
        dateOfInjuryEndFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        bodyParts?: Array< BodyPart | null > | null,
        causeOfInjury?: string | null,
        causedByWork?: AssessmentCausationOption | null,
        causedByWorkExplanation?: string | null,
      } | null > | null,
      discussions?: string | null,
      diagnosesAndEvidence?: string | null,
      causation?: string | null,
      hasPatientReachedMMI?: string | null,
      discussMMIByBodyPart?: string | null,
      impairmentRatingByBodyPart?: string | null,
      apportionmentByBodyPart?: string | null,
      workStatus?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateValidationCheckMutationVariables = {
  input: CreateValidationCheckInput,
  condition?: ModelValidationCheckConditionInput | null,
};

export type CreateValidationCheckMutation = {
  createValidationCheck?:  {
    __typename: "ValidationCheck",
    id: string,
    validationID: string,
    checkType: string,
    inputResourceURIs: Array< string | null >,
    status: ValidationStatus,
    issues?:  {
      __typename: "ModelValidationIssueConnection",
      items:  Array< {
        __typename: "ValidationIssue",
        id: string,
        validationID: string,
        validationCheckID: string,
        title?: string | null,
        issue: string,
        status: ValidationStatus,
        resourceURI: string,
        issueGroup: string,
        issueType?: ValidationIssueType | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateValidationCheckMutationVariables = {
  input: UpdateValidationCheckInput,
  condition?: ModelValidationCheckConditionInput | null,
};

export type UpdateValidationCheckMutation = {
  updateValidationCheck?:  {
    __typename: "ValidationCheck",
    id: string,
    validationID: string,
    checkType: string,
    inputResourceURIs: Array< string | null >,
    status: ValidationStatus,
    issues?:  {
      __typename: "ModelValidationIssueConnection",
      items:  Array< {
        __typename: "ValidationIssue",
        id: string,
        validationID: string,
        validationCheckID: string,
        title?: string | null,
        issue: string,
        status: ValidationStatus,
        resourceURI: string,
        issueGroup: string,
        issueType?: ValidationIssueType | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteValidationCheckMutationVariables = {
  input: DeleteValidationCheckInput,
  condition?: ModelValidationCheckConditionInput | null,
};

export type DeleteValidationCheckMutation = {
  deleteValidationCheck?:  {
    __typename: "ValidationCheck",
    id: string,
    validationID: string,
    checkType: string,
    inputResourceURIs: Array< string | null >,
    status: ValidationStatus,
    issues?:  {
      __typename: "ModelValidationIssueConnection",
      items:  Array< {
        __typename: "ValidationIssue",
        id: string,
        validationID: string,
        validationCheckID: string,
        title?: string | null,
        issue: string,
        status: ValidationStatus,
        resourceURI: string,
        issueGroup: string,
        issueType?: ValidationIssueType | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateValidationIssueMutationVariables = {
  input: CreateValidationIssueInput,
  condition?: ModelValidationIssueConditionInput | null,
};

export type CreateValidationIssueMutation = {
  createValidationIssue?:  {
    __typename: "ValidationIssue",
    id: string,
    validationID: string,
    validationCheckID: string,
    title?: string | null,
    issue: string,
    status: ValidationStatus,
    resourceURI: string,
    issueGroup: string,
    issueType?: ValidationIssueType | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateValidationIssueMutationVariables = {
  input: UpdateValidationIssueInput,
  condition?: ModelValidationIssueConditionInput | null,
};

export type UpdateValidationIssueMutation = {
  updateValidationIssue?:  {
    __typename: "ValidationIssue",
    id: string,
    validationID: string,
    validationCheckID: string,
    title?: string | null,
    issue: string,
    status: ValidationStatus,
    resourceURI: string,
    issueGroup: string,
    issueType?: ValidationIssueType | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteValidationIssueMutationVariables = {
  input: DeleteValidationIssueInput,
  condition?: ModelValidationIssueConditionInput | null,
};

export type DeleteValidationIssueMutation = {
  deleteValidationIssue?:  {
    __typename: "ValidationIssue",
    id: string,
    validationID: string,
    validationCheckID: string,
    title?: string | null,
    issue: string,
    status: ValidationStatus,
    resourceURI: string,
    issueGroup: string,
    issueType?: ValidationIssueType | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateValidationMutationVariables = {
  input: CreateValidationInput,
  condition?: ModelValidationConditionInput | null,
};

export type CreateValidationMutation = {
  createValidation?:  {
    __typename: "Validation",
    id: string,
    issueGroups: Array< string | null >,
    issues?:  {
      __typename: "ModelValidationIssueConnection",
      items:  Array< {
        __typename: "ValidationIssue",
        id: string,
        validationID: string,
        validationCheckID: string,
        title?: string | null,
        issue: string,
        status: ValidationStatus,
        resourceURI: string,
        issueGroup: string,
        issueType?: ValidationIssueType | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateValidationMutationVariables = {
  input: UpdateValidationInput,
  condition?: ModelValidationConditionInput | null,
};

export type UpdateValidationMutation = {
  updateValidation?:  {
    __typename: "Validation",
    id: string,
    issueGroups: Array< string | null >,
    issues?:  {
      __typename: "ModelValidationIssueConnection",
      items:  Array< {
        __typename: "ValidationIssue",
        id: string,
        validationID: string,
        validationCheckID: string,
        title?: string | null,
        issue: string,
        status: ValidationStatus,
        resourceURI: string,
        issueGroup: string,
        issueType?: ValidationIssueType | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteValidationMutationVariables = {
  input: DeleteValidationInput,
  condition?: ModelValidationConditionInput | null,
};

export type DeleteValidationMutation = {
  deleteValidation?:  {
    __typename: "Validation",
    id: string,
    issueGroups: Array< string | null >,
    issues?:  {
      __typename: "ModelValidationIssueConnection",
      items:  Array< {
        __typename: "ValidationIssue",
        id: string,
        validationID: string,
        validationCheckID: string,
        title?: string | null,
        issue: string,
        status: ValidationStatus,
        resourceURI: string,
        issueGroup: string,
        issueType?: ValidationIssueType | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateWorkflowAuditEntryMutationVariables = {
  input: CreateWorkflowAuditEntryInput,
  condition?: ModelWorkflowAuditEntryConditionInput | null,
};

export type CreateWorkflowAuditEntryMutation = {
  createWorkflowAuditEntry?:  {
    __typename: "WorkflowAuditEntry",
    id: string,
    workflowAuditID: string,
    message: string,
    actorType?: UserGroup | null,
    actorID?: string | null,
    entryType?: string | null,
    attachments:  Array< {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } >,
    relatedActionIDs?: Array< string > | null,
    payload?: string | null,
    correlationID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateWorkflowAuditEntryMutationVariables = {
  input: UpdateWorkflowAuditEntryInput,
  condition?: ModelWorkflowAuditEntryConditionInput | null,
};

export type UpdateWorkflowAuditEntryMutation = {
  updateWorkflowAuditEntry?:  {
    __typename: "WorkflowAuditEntry",
    id: string,
    workflowAuditID: string,
    message: string,
    actorType?: UserGroup | null,
    actorID?: string | null,
    entryType?: string | null,
    attachments:  Array< {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } >,
    relatedActionIDs?: Array< string > | null,
    payload?: string | null,
    correlationID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteWorkflowAuditEntryMutationVariables = {
  input: DeleteWorkflowAuditEntryInput,
  condition?: ModelWorkflowAuditEntryConditionInput | null,
};

export type DeleteWorkflowAuditEntryMutation = {
  deleteWorkflowAuditEntry?:  {
    __typename: "WorkflowAuditEntry",
    id: string,
    workflowAuditID: string,
    message: string,
    actorType?: UserGroup | null,
    actorID?: string | null,
    entryType?: string | null,
    attachments:  Array< {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } >,
    relatedActionIDs?: Array< string > | null,
    payload?: string | null,
    correlationID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateWorkflowAuditMutationVariables = {
  input: CreateWorkflowAuditInput,
  condition?: ModelWorkflowAuditConditionInput | null,
};

export type CreateWorkflowAuditMutation = {
  createWorkflowAudit?:  {
    __typename: "WorkflowAudit",
    id: string,
    workflowType: string,
    entityID: string,
    entityType: string,
    appointmentID?: string | null,
    entries?:  {
      __typename: "ModelWorkflowAuditEntryConnection",
      items:  Array< {
        __typename: "WorkflowAuditEntry",
        id: string,
        workflowAuditID: string,
        message: string,
        actorType?: UserGroup | null,
        actorID?: string | null,
        entryType?: string | null,
        attachments:  Array< {
          __typename: "S3Blob",
          bucket: string,
          key: string,
        } >,
        relatedActionIDs?: Array< string > | null,
        payload?: string | null,
        correlationID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateWorkflowAuditMutationVariables = {
  input: UpdateWorkflowAuditInput,
  condition?: ModelWorkflowAuditConditionInput | null,
};

export type UpdateWorkflowAuditMutation = {
  updateWorkflowAudit?:  {
    __typename: "WorkflowAudit",
    id: string,
    workflowType: string,
    entityID: string,
    entityType: string,
    appointmentID?: string | null,
    entries?:  {
      __typename: "ModelWorkflowAuditEntryConnection",
      items:  Array< {
        __typename: "WorkflowAuditEntry",
        id: string,
        workflowAuditID: string,
        message: string,
        actorType?: UserGroup | null,
        actorID?: string | null,
        entryType?: string | null,
        attachments:  Array< {
          __typename: "S3Blob",
          bucket: string,
          key: string,
        } >,
        relatedActionIDs?: Array< string > | null,
        payload?: string | null,
        correlationID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteWorkflowAuditMutationVariables = {
  input: DeleteWorkflowAuditInput,
  condition?: ModelWorkflowAuditConditionInput | null,
};

export type DeleteWorkflowAuditMutation = {
  deleteWorkflowAudit?:  {
    __typename: "WorkflowAudit",
    id: string,
    workflowType: string,
    entityID: string,
    entityType: string,
    appointmentID?: string | null,
    entries?:  {
      __typename: "ModelWorkflowAuditEntryConnection",
      items:  Array< {
        __typename: "WorkflowAuditEntry",
        id: string,
        workflowAuditID: string,
        message: string,
        actorType?: UserGroup | null,
        actorID?: string | null,
        entryType?: string | null,
        attachments:  Array< {
          __typename: "S3Blob",
          bucket: string,
          key: string,
        } >,
        relatedActionIDs?: Array< string > | null,
        payload?: string | null,
        correlationID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateWorkflowAuditActionMutationVariables = {
  input: CreateWorkflowAuditActionInput,
  condition?: ModelWorkflowAuditActionConditionInput | null,
};

export type CreateWorkflowAuditActionMutation = {
  createWorkflowAuditAction?:  {
    __typename: "WorkflowAuditAction",
    id: string,
    workflowAuditID: string,
    appointmentID?: string | null,
    actionType: string,
    status: WorkflowAuditActionStatus,
    payload: string,
    rationale?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateWorkflowAuditActionMutationVariables = {
  input: UpdateWorkflowAuditActionInput,
  condition?: ModelWorkflowAuditActionConditionInput | null,
};

export type UpdateWorkflowAuditActionMutation = {
  updateWorkflowAuditAction?:  {
    __typename: "WorkflowAuditAction",
    id: string,
    workflowAuditID: string,
    appointmentID?: string | null,
    actionType: string,
    status: WorkflowAuditActionStatus,
    payload: string,
    rationale?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteWorkflowAuditActionMutationVariables = {
  input: DeleteWorkflowAuditActionInput,
  condition?: ModelWorkflowAuditActionConditionInput | null,
};

export type DeleteWorkflowAuditActionMutation = {
  deleteWorkflowAuditAction?:  {
    __typename: "WorkflowAuditAction",
    id: string,
    workflowAuditID: string,
    appointmentID?: string | null,
    actionType: string,
    status: WorkflowAuditActionStatus,
    payload: string,
    rationale?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFormDataDraftMutationVariables = {
  input: CreateFormDataDraftInput,
  condition?: ModelFormDataDraftConditionInput | null,
};

export type CreateFormDataDraftMutation = {
  createFormDataDraft?:  {
    __typename: "FormDataDraft",
    id: string,
    timestamp: string,
    formType: string,
    appointmentId: string,
    data: string,
    ttl?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFormDataDraftMutationVariables = {
  input: UpdateFormDataDraftInput,
  condition?: ModelFormDataDraftConditionInput | null,
};

export type UpdateFormDataDraftMutation = {
  updateFormDataDraft?:  {
    __typename: "FormDataDraft",
    id: string,
    timestamp: string,
    formType: string,
    appointmentId: string,
    data: string,
    ttl?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFormDataDraftMutationVariables = {
  input: DeleteFormDataDraftInput,
  condition?: ModelFormDataDraftConditionInput | null,
};

export type DeleteFormDataDraftMutation = {
  deleteFormDataDraft?:  {
    __typename: "FormDataDraft",
    id: string,
    timestamp: string,
    formType: string,
    appointmentId: string,
    data: string,
    ttl?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateHistoryValidationMutationVariables = {
  input: CreateHistoryValidationInput,
  condition?: ModelHistoryValidationConditionInput | null,
};

export type CreateHistoryValidationMutation = {
  createHistoryValidation?:  {
    __typename: "HistoryValidation",
    id: string,
    appointmentRecordID: string,
    status: HistoryValidationStatus,
    groups:  Array< {
      __typename: "HistoryValidationGroup",
      id: string,
      title: string,
      status: HistoryValidationGroupStatus,
      issues:  Array< {
        __typename: "HistoryValidationIssue",
        id: string,
        title: string,
        description?: string | null,
        patientInfoSection?: PatientInfoSection | null,
        issueType?: ValidationIssueType | null,
      } | null >,
    } | null >,
    validatedAt?: string | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateHistoryValidationMutationVariables = {
  input: UpdateHistoryValidationInput,
  condition?: ModelHistoryValidationConditionInput | null,
};

export type UpdateHistoryValidationMutation = {
  updateHistoryValidation?:  {
    __typename: "HistoryValidation",
    id: string,
    appointmentRecordID: string,
    status: HistoryValidationStatus,
    groups:  Array< {
      __typename: "HistoryValidationGroup",
      id: string,
      title: string,
      status: HistoryValidationGroupStatus,
      issues:  Array< {
        __typename: "HistoryValidationIssue",
        id: string,
        title: string,
        description?: string | null,
        patientInfoSection?: PatientInfoSection | null,
        issueType?: ValidationIssueType | null,
      } | null >,
    } | null >,
    validatedAt?: string | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteHistoryValidationMutationVariables = {
  input: DeleteHistoryValidationInput,
  condition?: ModelHistoryValidationConditionInput | null,
};

export type DeleteHistoryValidationMutation = {
  deleteHistoryValidation?:  {
    __typename: "HistoryValidation",
    id: string,
    appointmentRecordID: string,
    status: HistoryValidationStatus,
    groups:  Array< {
      __typename: "HistoryValidationGroup",
      id: string,
      title: string,
      status: HistoryValidationGroupStatus,
      issues:  Array< {
        __typename: "HistoryValidationIssue",
        id: string,
        title: string,
        description?: string | null,
        patientInfoSection?: PatientInfoSection | null,
        issueType?: ValidationIssueType | null,
      } | null >,
    } | null >,
    validatedAt?: string | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFieldTemplateMutationVariables = {
  input: CreateFieldTemplateInput,
  condition?: ModelFieldTemplateConditionInput | null,
};

export type CreateFieldTemplateMutation = {
  createFieldTemplate?:  {
    __typename: "FieldTemplate",
    id: string,
    version: number,
    templateType: FieldTemplateType,
    specialty?: SpecialtyType | null,
    doctorId?: string | null,
    latestMarker?: string | null,
    adlFieldSectionMappings?:  Array< {
      __typename: "ADLFieldSectionMapping",
      ADLFieldSectionID: string,
      ADLFieldIDs: Array< string >,
    } | null > | null,
    medicalHistoryFieldIDs?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    lastUpdatedBy?: string | null,
    changeDescription?: string | null,
  } | null,
};

export type UpdateFieldTemplateMutationVariables = {
  input: UpdateFieldTemplateInput,
  condition?: ModelFieldTemplateConditionInput | null,
};

export type UpdateFieldTemplateMutation = {
  updateFieldTemplate?:  {
    __typename: "FieldTemplate",
    id: string,
    version: number,
    templateType: FieldTemplateType,
    specialty?: SpecialtyType | null,
    doctorId?: string | null,
    latestMarker?: string | null,
    adlFieldSectionMappings?:  Array< {
      __typename: "ADLFieldSectionMapping",
      ADLFieldSectionID: string,
      ADLFieldIDs: Array< string >,
    } | null > | null,
    medicalHistoryFieldIDs?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    lastUpdatedBy?: string | null,
    changeDescription?: string | null,
  } | null,
};

export type DeleteFieldTemplateMutationVariables = {
  input: DeleteFieldTemplateInput,
  condition?: ModelFieldTemplateConditionInput | null,
};

export type DeleteFieldTemplateMutation = {
  deleteFieldTemplate?:  {
    __typename: "FieldTemplate",
    id: string,
    version: number,
    templateType: FieldTemplateType,
    specialty?: SpecialtyType | null,
    doctorId?: string | null,
    latestMarker?: string | null,
    adlFieldSectionMappings?:  Array< {
      __typename: "ADLFieldSectionMapping",
      ADLFieldSectionID: string,
      ADLFieldIDs: Array< string >,
    } | null > | null,
    medicalHistoryFieldIDs?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    lastUpdatedBy?: string | null,
    changeDescription?: string | null,
  } | null,
};

export type CreatePhysicalEvalTemplateMutationVariables = {
  input: CreatePhysicalEvalTemplateInput,
  condition?: ModelPhysicalEvalTemplateConditionInput | null,
};

export type CreatePhysicalEvalTemplateMutation = {
  createPhysicalEvalTemplate?:  {
    __typename: "PhysicalEvalTemplate",
    id: string,
    version: number,
    templateType: PhysicalEvalTemplateType,
    specialtyCategoryId: string,
    doctorId?: string | null,
    latestMarker?: string | null,
    exams?:  Array< {
      __typename: "PhysicalExam",
      examID: string,
      name: string,
      bodyParts: Array< BodyPart >,
      instructions?: string | null,
      sections?:  Array< {
        __typename: "PhysicalExamSection",
        sectionID: string,
        name: string,
        fieldType: PhysicalExamFieldType,
        config?:  {
          __typename: "PhysicalExamSectionConfig",
          minValue?: number | null,
          maxValue?: number | null,
          increment?: number | null,
          allowPlusMinus?: boolean | null,
          allowPlus?: boolean | null,
          unit?: PhysicalExamUnit | null,
          freeformInputCount?: number | null,
          laterality?: boolean | null,
          hasNote?: boolean | null,
          hasDefault?: boolean | null,
          hasOtherFindings?: boolean | null,
          renderStyle?: PhysicalExamRenderStyle | null,
        } | null,
        questions?:  Array< {
          __typename: "PhysicalExamQuestion",
          questionID: string,
          label: string,
          defaultValue?: string | null,
          defaultValueLeft?: string | null,
          defaultValueRight?: string | null,
          phrasing?: PhysicalExamPhrasing | null,
          positiveText?: string | null,
          negativeText?: string | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    lastUpdatedBy?: string | null,
    changeDescription?: string | null,
  } | null,
};

export type UpdatePhysicalEvalTemplateMutationVariables = {
  input: UpdatePhysicalEvalTemplateInput,
  condition?: ModelPhysicalEvalTemplateConditionInput | null,
};

export type UpdatePhysicalEvalTemplateMutation = {
  updatePhysicalEvalTemplate?:  {
    __typename: "PhysicalEvalTemplate",
    id: string,
    version: number,
    templateType: PhysicalEvalTemplateType,
    specialtyCategoryId: string,
    doctorId?: string | null,
    latestMarker?: string | null,
    exams?:  Array< {
      __typename: "PhysicalExam",
      examID: string,
      name: string,
      bodyParts: Array< BodyPart >,
      instructions?: string | null,
      sections?:  Array< {
        __typename: "PhysicalExamSection",
        sectionID: string,
        name: string,
        fieldType: PhysicalExamFieldType,
        config?:  {
          __typename: "PhysicalExamSectionConfig",
          minValue?: number | null,
          maxValue?: number | null,
          increment?: number | null,
          allowPlusMinus?: boolean | null,
          allowPlus?: boolean | null,
          unit?: PhysicalExamUnit | null,
          freeformInputCount?: number | null,
          laterality?: boolean | null,
          hasNote?: boolean | null,
          hasDefault?: boolean | null,
          hasOtherFindings?: boolean | null,
          renderStyle?: PhysicalExamRenderStyle | null,
        } | null,
        questions?:  Array< {
          __typename: "PhysicalExamQuestion",
          questionID: string,
          label: string,
          defaultValue?: string | null,
          defaultValueLeft?: string | null,
          defaultValueRight?: string | null,
          phrasing?: PhysicalExamPhrasing | null,
          positiveText?: string | null,
          negativeText?: string | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    lastUpdatedBy?: string | null,
    changeDescription?: string | null,
  } | null,
};

export type DeletePhysicalEvalTemplateMutationVariables = {
  input: DeletePhysicalEvalTemplateInput,
  condition?: ModelPhysicalEvalTemplateConditionInput | null,
};

export type DeletePhysicalEvalTemplateMutation = {
  deletePhysicalEvalTemplate?:  {
    __typename: "PhysicalEvalTemplate",
    id: string,
    version: number,
    templateType: PhysicalEvalTemplateType,
    specialtyCategoryId: string,
    doctorId?: string | null,
    latestMarker?: string | null,
    exams?:  Array< {
      __typename: "PhysicalExam",
      examID: string,
      name: string,
      bodyParts: Array< BodyPart >,
      instructions?: string | null,
      sections?:  Array< {
        __typename: "PhysicalExamSection",
        sectionID: string,
        name: string,
        fieldType: PhysicalExamFieldType,
        config?:  {
          __typename: "PhysicalExamSectionConfig",
          minValue?: number | null,
          maxValue?: number | null,
          increment?: number | null,
          allowPlusMinus?: boolean | null,
          allowPlus?: boolean | null,
          unit?: PhysicalExamUnit | null,
          freeformInputCount?: number | null,
          laterality?: boolean | null,
          hasNote?: boolean | null,
          hasDefault?: boolean | null,
          hasOtherFindings?: boolean | null,
          renderStyle?: PhysicalExamRenderStyle | null,
        } | null,
        questions?:  Array< {
          __typename: "PhysicalExamQuestion",
          questionID: string,
          label: string,
          defaultValue?: string | null,
          defaultValueLeft?: string | null,
          defaultValueRight?: string | null,
          phrasing?: PhysicalExamPhrasing | null,
          positiveText?: string | null,
          negativeText?: string | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    lastUpdatedBy?: string | null,
    changeDescription?: string | null,
  } | null,
};

export type CreateZendeskTicketMutationVariables = {
  input: CreateZendeskTicketInput,
  condition?: ModelZendeskTicketConditionInput | null,
};

export type CreateZendeskTicketMutation = {
  createZendeskTicket?:  {
    __typename: "ZendeskTicket",
    id: string,
    ticketID: number,
    appointmentRecordID: string,
    recipientParty: InquiringParty,
    isPrimary: boolean,
    isTextTicket?: boolean | null,
    claimNumber: string,
    version: string,
    lastSyncedAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateZendeskTicketMutationVariables = {
  input: UpdateZendeskTicketInput,
  condition?: ModelZendeskTicketConditionInput | null,
};

export type UpdateZendeskTicketMutation = {
  updateZendeskTicket?:  {
    __typename: "ZendeskTicket",
    id: string,
    ticketID: number,
    appointmentRecordID: string,
    recipientParty: InquiringParty,
    isPrimary: boolean,
    isTextTicket?: boolean | null,
    claimNumber: string,
    version: string,
    lastSyncedAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteZendeskTicketMutationVariables = {
  input: DeleteZendeskTicketInput,
  condition?: ModelZendeskTicketConditionInput | null,
};

export type DeleteZendeskTicketMutation = {
  deleteZendeskTicket?:  {
    __typename: "ZendeskTicket",
    id: string,
    ticketID: number,
    appointmentRecordID: string,
    recipientParty: InquiringParty,
    isPrimary: boolean,
    isTextTicket?: boolean | null,
    claimNumber: string,
    version: string,
    lastSyncedAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateScheduledCommunicationMutationVariables = {
  input: CreateScheduledCommunicationInput,
  condition?: ModelScheduledCommunicationConditionInput | null,
};

export type CreateScheduledCommunicationMutation = {
  createScheduledCommunication?:  {
    __typename: "ScheduledCommunication",
    id: string,
    appointmentRecordID: string,
    communicationType: CommunicationType,
    targetParty: InquiringParty,
    scheduledDate: string,
    status: CommunicationStatus,
    templateParams?: string | null,
    sentAt?: string | null,
    zendeskTicketID?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateScheduledCommunicationMutationVariables = {
  input: UpdateScheduledCommunicationInput,
  condition?: ModelScheduledCommunicationConditionInput | null,
};

export type UpdateScheduledCommunicationMutation = {
  updateScheduledCommunication?:  {
    __typename: "ScheduledCommunication",
    id: string,
    appointmentRecordID: string,
    communicationType: CommunicationType,
    targetParty: InquiringParty,
    scheduledDate: string,
    status: CommunicationStatus,
    templateParams?: string | null,
    sentAt?: string | null,
    zendeskTicketID?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteScheduledCommunicationMutationVariables = {
  input: DeleteScheduledCommunicationInput,
  condition?: ModelScheduledCommunicationConditionInput | null,
};

export type DeleteScheduledCommunicationMutation = {
  deleteScheduledCommunication?:  {
    __typename: "ScheduledCommunication",
    id: string,
    appointmentRecordID: string,
    communicationType: CommunicationType,
    targetParty: InquiringParty,
    scheduledDate: string,
    status: CommunicationStatus,
    templateParams?: string | null,
    sentAt?: string | null,
    zendeskTicketID?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAppointmentEventMutationVariables = {
  input: CreateAppointmentEventInput,
  condition?: ModelAppointmentEventConditionInput | null,
};

export type CreateAppointmentEventMutation = {
  createAppointmentEvent?:  {
    __typename: "AppointmentEvent",
    id: string,
    appointmentRecordID: string,
    entity?: string | null,
    entityID?: string | null,
    action?: string | null,
    actorType?: UserGroup | null,
    actorID?: string | null,
    timestamp?: string | null,
    properties?: string | null,
    source?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAppointmentEventMutationVariables = {
  input: UpdateAppointmentEventInput,
  condition?: ModelAppointmentEventConditionInput | null,
};

export type UpdateAppointmentEventMutation = {
  updateAppointmentEvent?:  {
    __typename: "AppointmentEvent",
    id: string,
    appointmentRecordID: string,
    entity?: string | null,
    entityID?: string | null,
    action?: string | null,
    actorType?: UserGroup | null,
    actorID?: string | null,
    timestamp?: string | null,
    properties?: string | null,
    source?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAppointmentEventMutationVariables = {
  input: DeleteAppointmentEventInput,
  condition?: ModelAppointmentEventConditionInput | null,
};

export type DeleteAppointmentEventMutation = {
  deleteAppointmentEvent?:  {
    __typename: "AppointmentEvent",
    id: string,
    appointmentRecordID: string,
    entity?: string | null,
    entityID?: string | null,
    action?: string | null,
    actorType?: UserGroup | null,
    actorID?: string | null,
    timestamp?: string | null,
    properties?: string | null,
    source?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAppointmentNotificationMutationVariables = {
  input: CreateAppointmentNotificationInput,
  condition?: ModelAppointmentNotificationConditionInput | null,
};

export type CreateAppointmentNotificationMutation = {
  createAppointmentNotification?:  {
    __typename: "AppointmentNotification",
    id: string,
    appointmentRecordID: string,
    entityType?: string | null,
    entityID?: string | null,
    notificationType: string,
    channel: NotificationChannel,
    recipientType: UserGroup,
    recipientID: string,
    recipientName?: string | null,
    title: string,
    body: string,
    status: string,
    readAt?: string | null,
    ttl?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAppointmentNotificationMutationVariables = {
  input: UpdateAppointmentNotificationInput,
  condition?: ModelAppointmentNotificationConditionInput | null,
};

export type UpdateAppointmentNotificationMutation = {
  updateAppointmentNotification?:  {
    __typename: "AppointmentNotification",
    id: string,
    appointmentRecordID: string,
    entityType?: string | null,
    entityID?: string | null,
    notificationType: string,
    channel: NotificationChannel,
    recipientType: UserGroup,
    recipientID: string,
    recipientName?: string | null,
    title: string,
    body: string,
    status: string,
    readAt?: string | null,
    ttl?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAppointmentNotificationMutationVariables = {
  input: DeleteAppointmentNotificationInput,
  condition?: ModelAppointmentNotificationConditionInput | null,
};

export type DeleteAppointmentNotificationMutation = {
  deleteAppointmentNotification?:  {
    __typename: "AppointmentNotification",
    id: string,
    appointmentRecordID: string,
    entityType?: string | null,
    entityID?: string | null,
    notificationType: string,
    channel: NotificationChannel,
    recipientType: UserGroup,
    recipientID: string,
    recipientName?: string | null,
    title: string,
    body: string,
    status: string,
    readAt?: string | null,
    ttl?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateEmailNotificationQueueMutationVariables = {
  input: CreateEmailNotificationQueueInput,
  condition?: ModelEmailNotificationQueueConditionInput | null,
};

export type CreateEmailNotificationQueueMutation = {
  createEmailNotificationQueue?:  {
    __typename: "EmailNotificationQueue",
    id: string,
    appointmentRecordID: string,
    notificationType: string,
    recipientID: string,
    status: EmailNotificationStatus,
    emailDeliveryID?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateEmailNotificationQueueMutationVariables = {
  input: UpdateEmailNotificationQueueInput,
  condition?: ModelEmailNotificationQueueConditionInput | null,
};

export type UpdateEmailNotificationQueueMutation = {
  updateEmailNotificationQueue?:  {
    __typename: "EmailNotificationQueue",
    id: string,
    appointmentRecordID: string,
    notificationType: string,
    recipientID: string,
    status: EmailNotificationStatus,
    emailDeliveryID?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteEmailNotificationQueueMutationVariables = {
  input: DeleteEmailNotificationQueueInput,
  condition?: ModelEmailNotificationQueueConditionInput | null,
};

export type DeleteEmailNotificationQueueMutation = {
  deleteEmailNotificationQueue?:  {
    __typename: "EmailNotificationQueue",
    id: string,
    appointmentRecordID: string,
    notificationType: string,
    recipientID: string,
    status: EmailNotificationStatus,
    emailDeliveryID?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateEmailDeliveryMutationVariables = {
  input: CreateEmailDeliveryInput,
  condition?: ModelEmailDeliveryConditionInput | null,
};

export type CreateEmailDeliveryMutation = {
  createEmailDelivery?:  {
    __typename: "EmailDelivery",
    id: string,
    emailType: string,
    recipientID: string,
    recipientEmail: string,
    subject: string,
    body: string,
    htmlBody?: string | null,
    status: EmailDeliveryStatus,
    sentAt?: string | null,
    failureReason?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateEmailDeliveryMutationVariables = {
  input: UpdateEmailDeliveryInput,
  condition?: ModelEmailDeliveryConditionInput | null,
};

export type UpdateEmailDeliveryMutation = {
  updateEmailDelivery?:  {
    __typename: "EmailDelivery",
    id: string,
    emailType: string,
    recipientID: string,
    recipientEmail: string,
    subject: string,
    body: string,
    htmlBody?: string | null,
    status: EmailDeliveryStatus,
    sentAt?: string | null,
    failureReason?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteEmailDeliveryMutationVariables = {
  input: DeleteEmailDeliveryInput,
  condition?: ModelEmailDeliveryConditionInput | null,
};

export type DeleteEmailDeliveryMutation = {
  deleteEmailDelivery?:  {
    __typename: "EmailDelivery",
    id: string,
    emailType: string,
    recipientID: string,
    recipientEmail: string,
    subject: string,
    body: string,
    htmlBody?: string | null,
    status: EmailDeliveryStatus,
    sentAt?: string | null,
    failureReason?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateChatbotMessageMutationVariables = {
  input: CreateChatbotMessageInput,
  condition?: ModelChatbotMessageConditionInput | null,
};

export type CreateChatbotMessageMutation = {
  createChatbotMessage?:  {
    __typename: "ChatbotMessage",
    userId: string,
    conversationIdTimestamp: string,
    messageId: string,
    conversationId: string,
    role: ChatbotMessageRole,
    content: string,
    suggestedUserPrompt?: string | null,
    createdAt: string,
    llmInput?: string | null,
    inputTokens?: number | null,
    outputTokens?: number | null,
    reasoningTokens?: number | null,
    cachedTokens?: number | null,
    totalTokens?: number | null,
    toolsCalled?: Array< string | null > | null,
    toolsSucceeded?: Array< string | null > | null,
    toolsFailed?: Array< string | null > | null,
    ttftMs?: number | null,
    total_latency_ms?: number | null,
    userPaused?: boolean | null,
    agentTurns?: number | null,
    attachments?:  Array< {
      __typename: "ChatbotAttachment",
      filename: string,
      contentType: string,
      sizeBytes: number,
      s3Bucket?: string | null,
      s3Key?: string | null,
      slackUrl?: string | null,
      source?: string | null,
    } | null > | null,
    dataBlocks?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateChatbotMessageMutationVariables = {
  input: UpdateChatbotMessageInput,
  condition?: ModelChatbotMessageConditionInput | null,
};

export type UpdateChatbotMessageMutation = {
  updateChatbotMessage?:  {
    __typename: "ChatbotMessage",
    userId: string,
    conversationIdTimestamp: string,
    messageId: string,
    conversationId: string,
    role: ChatbotMessageRole,
    content: string,
    suggestedUserPrompt?: string | null,
    createdAt: string,
    llmInput?: string | null,
    inputTokens?: number | null,
    outputTokens?: number | null,
    reasoningTokens?: number | null,
    cachedTokens?: number | null,
    totalTokens?: number | null,
    toolsCalled?: Array< string | null > | null,
    toolsSucceeded?: Array< string | null > | null,
    toolsFailed?: Array< string | null > | null,
    ttftMs?: number | null,
    total_latency_ms?: number | null,
    userPaused?: boolean | null,
    agentTurns?: number | null,
    attachments?:  Array< {
      __typename: "ChatbotAttachment",
      filename: string,
      contentType: string,
      sizeBytes: number,
      s3Bucket?: string | null,
      s3Key?: string | null,
      slackUrl?: string | null,
      source?: string | null,
    } | null > | null,
    dataBlocks?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteChatbotMessageMutationVariables = {
  input: DeleteChatbotMessageInput,
  condition?: ModelChatbotMessageConditionInput | null,
};

export type DeleteChatbotMessageMutation = {
  deleteChatbotMessage?:  {
    __typename: "ChatbotMessage",
    userId: string,
    conversationIdTimestamp: string,
    messageId: string,
    conversationId: string,
    role: ChatbotMessageRole,
    content: string,
    suggestedUserPrompt?: string | null,
    createdAt: string,
    llmInput?: string | null,
    inputTokens?: number | null,
    outputTokens?: number | null,
    reasoningTokens?: number | null,
    cachedTokens?: number | null,
    totalTokens?: number | null,
    toolsCalled?: Array< string | null > | null,
    toolsSucceeded?: Array< string | null > | null,
    toolsFailed?: Array< string | null > | null,
    ttftMs?: number | null,
    total_latency_ms?: number | null,
    userPaused?: boolean | null,
    agentTurns?: number | null,
    attachments?:  Array< {
      __typename: "ChatbotAttachment",
      filename: string,
      contentType: string,
      sizeBytes: number,
      s3Bucket?: string | null,
      s3Key?: string | null,
      slackUrl?: string | null,
      source?: string | null,
    } | null > | null,
    dataBlocks?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateChatbotConversationMutationVariables = {
  input: CreateChatbotConversationInput,
  condition?: ModelChatbotConversationConditionInput | null,
};

export type CreateChatbotConversationMutation = {
  createChatbotConversation?:  {
    __typename: "ChatbotConversation",
    userId: string,
    conversationId: string,
    createdAt: string,
    updatedAt: string,
    name?: string | null,
    archived?: boolean | null,
    pausedStreaming?: boolean | null,
    modelConversationId?: string | null,
    claudeSessionId?: string | null,
    routineId?: string | null,
    routineRunId?: string | null,
  } | null,
};

export type UpdateChatbotConversationMutationVariables = {
  input: UpdateChatbotConversationInput,
  condition?: ModelChatbotConversationConditionInput | null,
};

export type UpdateChatbotConversationMutation = {
  updateChatbotConversation?:  {
    __typename: "ChatbotConversation",
    userId: string,
    conversationId: string,
    createdAt: string,
    updatedAt: string,
    name?: string | null,
    archived?: boolean | null,
    pausedStreaming?: boolean | null,
    modelConversationId?: string | null,
    claudeSessionId?: string | null,
    routineId?: string | null,
    routineRunId?: string | null,
  } | null,
};

export type DeleteChatbotConversationMutationVariables = {
  input: DeleteChatbotConversationInput,
  condition?: ModelChatbotConversationConditionInput | null,
};

export type DeleteChatbotConversationMutation = {
  deleteChatbotConversation?:  {
    __typename: "ChatbotConversation",
    userId: string,
    conversationId: string,
    createdAt: string,
    updatedAt: string,
    name?: string | null,
    archived?: boolean | null,
    pausedStreaming?: boolean | null,
    modelConversationId?: string | null,
    claudeSessionId?: string | null,
    routineId?: string | null,
    routineRunId?: string | null,
  } | null,
};

export type CreateChatbotMonitoringMutationVariables = {
  input: CreateChatbotMonitoringInput,
  condition?: ModelChatbotMonitoringConditionInput | null,
};

export type CreateChatbotMonitoringMutation = {
  createChatbotMonitoring?:  {
    __typename: "ChatbotMonitoring",
    userId: string,
    totalTokens: number,
    lastWeekTokens: number,
    totalConversations?: number | null,
    totalToolsCalled?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateChatbotMonitoringMutationVariables = {
  input: UpdateChatbotMonitoringInput,
  condition?: ModelChatbotMonitoringConditionInput | null,
};

export type UpdateChatbotMonitoringMutation = {
  updateChatbotMonitoring?:  {
    __typename: "ChatbotMonitoring",
    userId: string,
    totalTokens: number,
    lastWeekTokens: number,
    totalConversations?: number | null,
    totalToolsCalled?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteChatbotMonitoringMutationVariables = {
  input: DeleteChatbotMonitoringInput,
  condition?: ModelChatbotMonitoringConditionInput | null,
};

export type DeleteChatbotMonitoringMutation = {
  deleteChatbotMonitoring?:  {
    __typename: "ChatbotMonitoring",
    userId: string,
    totalTokens: number,
    lastWeekTokens: number,
    totalConversations?: number | null,
    totalToolsCalled?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePromptExecutionMutationVariables = {
  input: CreatePromptExecutionInput,
  condition?: ModelPromptExecutionConditionInput | null,
};

export type CreatePromptExecutionMutation = {
  createPromptExecution?:  {
    __typename: "PromptExecution",
    id: string,
    promptId: string,
    attachments?:  Array< {
      __typename: "PromptExecutionAttachment",
      blob:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      caption?: string | null,
    } | null > | null,
    input:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    output:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    toolCalls?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    reasoningSummary?: string | null,
    executedAt: string,
    appointmentID?: string | null,
    entityType?: string | null,
    entityId?: string | null,
    promptHash: string,
    apiHash?: string | null,
    modelName: string,
    modelConfig?: string | null,
    correlationID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePromptExecutionMutationVariables = {
  input: UpdatePromptExecutionInput,
  condition?: ModelPromptExecutionConditionInput | null,
};

export type UpdatePromptExecutionMutation = {
  updatePromptExecution?:  {
    __typename: "PromptExecution",
    id: string,
    promptId: string,
    attachments?:  Array< {
      __typename: "PromptExecutionAttachment",
      blob:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      caption?: string | null,
    } | null > | null,
    input:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    output:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    toolCalls?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    reasoningSummary?: string | null,
    executedAt: string,
    appointmentID?: string | null,
    entityType?: string | null,
    entityId?: string | null,
    promptHash: string,
    apiHash?: string | null,
    modelName: string,
    modelConfig?: string | null,
    correlationID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePromptExecutionMutationVariables = {
  input: DeletePromptExecutionInput,
  condition?: ModelPromptExecutionConditionInput | null,
};

export type DeletePromptExecutionMutation = {
  deletePromptExecution?:  {
    __typename: "PromptExecution",
    id: string,
    promptId: string,
    attachments?:  Array< {
      __typename: "PromptExecutionAttachment",
      blob:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      caption?: string | null,
    } | null > | null,
    input:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    output:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    toolCalls?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    reasoningSummary?: string | null,
    executedAt: string,
    appointmentID?: string | null,
    entityType?: string | null,
    entityId?: string | null,
    promptHash: string,
    apiHash?: string | null,
    modelName: string,
    modelConfig?: string | null,
    correlationID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAppointmentEntityCorrelationMutationVariables = {
  input: CreateAppointmentEntityCorrelationInput,
  condition?: ModelAppointmentEntityCorrelationConditionInput | null,
};

export type CreateAppointmentEntityCorrelationMutation = {
  createAppointmentEntityCorrelation?:  {
    __typename: "AppointmentEntityCorrelation",
    id: string,
    appointmentID: string,
    entityType?: string | null,
    entityID?: string | null,
    properties?: string | null,
    correlationID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAppointmentEntityCorrelationMutationVariables = {
  input: UpdateAppointmentEntityCorrelationInput,
  condition?: ModelAppointmentEntityCorrelationConditionInput | null,
};

export type UpdateAppointmentEntityCorrelationMutation = {
  updateAppointmentEntityCorrelation?:  {
    __typename: "AppointmentEntityCorrelation",
    id: string,
    appointmentID: string,
    entityType?: string | null,
    entityID?: string | null,
    properties?: string | null,
    correlationID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAppointmentEntityCorrelationMutationVariables = {
  input: DeleteAppointmentEntityCorrelationInput,
  condition?: ModelAppointmentEntityCorrelationConditionInput | null,
};

export type DeleteAppointmentEntityCorrelationMutation = {
  deleteAppointmentEntityCorrelation?:  {
    __typename: "AppointmentEntityCorrelation",
    id: string,
    appointmentID: string,
    entityType?: string | null,
    entityID?: string | null,
    properties?: string | null,
    correlationID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePromptFeedbackMutationVariables = {
  input: CreatePromptFeedbackInput,
  condition?: ModelPromptFeedbackConditionInput | null,
};

export type CreatePromptFeedbackMutation = {
  createPromptFeedback?:  {
    __typename: "PromptFeedback",
    id: string,
    promptId: string,
    promptExecutionId?: string | null,
    feedback: string,
    feedbackSource: PromptFeedbackSource,
    actorType?: UserGroup | null,
    actorID?: string | null,
    status?: FeedbackStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePromptFeedbackMutationVariables = {
  input: UpdatePromptFeedbackInput,
  condition?: ModelPromptFeedbackConditionInput | null,
};

export type UpdatePromptFeedbackMutation = {
  updatePromptFeedback?:  {
    __typename: "PromptFeedback",
    id: string,
    promptId: string,
    promptExecutionId?: string | null,
    feedback: string,
    feedbackSource: PromptFeedbackSource,
    actorType?: UserGroup | null,
    actorID?: string | null,
    status?: FeedbackStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePromptFeedbackMutationVariables = {
  input: DeletePromptFeedbackInput,
  condition?: ModelPromptFeedbackConditionInput | null,
};

export type DeletePromptFeedbackMutation = {
  deletePromptFeedback?:  {
    __typename: "PromptFeedback",
    id: string,
    promptId: string,
    promptExecutionId?: string | null,
    feedback: string,
    feedbackSource: PromptFeedbackSource,
    actorType?: UserGroup | null,
    actorID?: string | null,
    status?: FeedbackStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePromptOfflineEvalCaseMutationVariables = {
  input: CreatePromptOfflineEvalCaseInput,
  condition?: ModelPromptOfflineEvalCaseConditionInput | null,
};

export type CreatePromptOfflineEvalCaseMutation = {
  createPromptOfflineEvalCase?:  {
    __typename: "PromptOfflineEvalCase",
    id: string,
    promptId: string,
    sourcePromptExecutionId?: string | null,
    apiHash: string,
    attachments?:  Array< {
      __typename: "PromptExecutionAttachment",
      blob:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      caption?: string | null,
    } | null > | null,
    input:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    output:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    toolCalls?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    description?: string | null,
    verified?: boolean | null,
    tags?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePromptOfflineEvalCaseMutationVariables = {
  input: UpdatePromptOfflineEvalCaseInput,
  condition?: ModelPromptOfflineEvalCaseConditionInput | null,
};

export type UpdatePromptOfflineEvalCaseMutation = {
  updatePromptOfflineEvalCase?:  {
    __typename: "PromptOfflineEvalCase",
    id: string,
    promptId: string,
    sourcePromptExecutionId?: string | null,
    apiHash: string,
    attachments?:  Array< {
      __typename: "PromptExecutionAttachment",
      blob:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      caption?: string | null,
    } | null > | null,
    input:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    output:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    toolCalls?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    description?: string | null,
    verified?: boolean | null,
    tags?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePromptOfflineEvalCaseMutationVariables = {
  input: DeletePromptOfflineEvalCaseInput,
  condition?: ModelPromptOfflineEvalCaseConditionInput | null,
};

export type DeletePromptOfflineEvalCaseMutation = {
  deletePromptOfflineEvalCase?:  {
    __typename: "PromptOfflineEvalCase",
    id: string,
    promptId: string,
    sourcePromptExecutionId?: string | null,
    apiHash: string,
    attachments?:  Array< {
      __typename: "PromptExecutionAttachment",
      blob:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      caption?: string | null,
    } | null > | null,
    input:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    output:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    toolCalls?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    description?: string | null,
    verified?: boolean | null,
    tags?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSkillMutationVariables = {
  input: CreateSkillInput,
  condition?: ModelSkillConditionInput | null,
};

export type CreateSkillMutation = {
  createSkill?:  {
    __typename: "Skill",
    id: string,
    name: string,
    description: string,
    body: string,
    scope: SkillScope,
    ownerUserId: string,
    roles?: Array< UserGroup > | null,
    inputs?:  Array< {
      __typename: "SkillInput",
      name: string,
      description?: string | null,
      required: boolean,
    } > | null,
    visibility: SkillVisibility,
    version: number,
    archivedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSkillMutationVariables = {
  input: UpdateSkillInput,
  condition?: ModelSkillConditionInput | null,
};

export type UpdateSkillMutation = {
  updateSkill?:  {
    __typename: "Skill",
    id: string,
    name: string,
    description: string,
    body: string,
    scope: SkillScope,
    ownerUserId: string,
    roles?: Array< UserGroup > | null,
    inputs?:  Array< {
      __typename: "SkillInput",
      name: string,
      description?: string | null,
      required: boolean,
    } > | null,
    visibility: SkillVisibility,
    version: number,
    archivedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSkillMutationVariables = {
  input: DeleteSkillInput,
  condition?: ModelSkillConditionInput | null,
};

export type DeleteSkillMutation = {
  deleteSkill?:  {
    __typename: "Skill",
    id: string,
    name: string,
    description: string,
    body: string,
    scope: SkillScope,
    ownerUserId: string,
    roles?: Array< UserGroup > | null,
    inputs?:  Array< {
      __typename: "SkillInput",
      name: string,
      description?: string | null,
      required: boolean,
    } > | null,
    visibility: SkillVisibility,
    version: number,
    archivedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRoutineMutationVariables = {
  input: UpdateRoutineInput,
  condition?: ModelRoutineConditionInput | null,
};

export type UpdateRoutineMutation = {
  updateRoutine?:  {
    __typename: "Routine",
    id: string,
    scope: RoutineScope,
    name: string,
    description?: string | null,
    promptBody: string,
    model: string,
    reasoningEffort: string,
    enableWebSearch: boolean,
    maxAgentTurns?: number | null,
    conversationMode: RoutineConversationMode,
    schedule:  {
      __typename: "RoutineSchedule",
      frequency: RoutineFrequency,
      intervalHours?: number | null,
      timeOfDay?: string | null,
      weekdays?: Array< number > | null,
      runAt?: string | null,
    },
    timezone: string,
    enabled: boolean,
    notifyOwner: RoutineNotify,
    slackChannel?: string | null,
    ownerUserId: string,
    createdAt: string,
    createdVia: RoutineOrigin,
    version: number,
    archivedAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateRoutineStateMutationVariables = {
  input: UpdateRoutineStateInput,
  condition?: ModelRoutineStateConditionInput | null,
};

export type UpdateRoutineStateMutation = {
  updateRoutineState?:  {
    __typename: "RoutineState",
    id: string,
    scope: RoutineScope,
    ownerUserId: string,
    definitionVersion: number,
    schedulePartition?: string | null,
    nextRunAt?: string | null,
    currentConversationId?: string | null,
    activeRunId?: string | null,
    lastRunId?: string | null,
    consecutiveFailures: number,
    endedReason?: RoutineEndedReason | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRoutineRunMutationVariables = {
  input: UpdateRoutineRunInput,
  condition?: ModelRoutineRunConditionInput | null,
};

export type UpdateRoutineRunMutation = {
  updateRoutineRun?:  {
    __typename: "RoutineRun",
    id: string,
    scope: RoutineScope,
    routineId: string,
    routineVersion: number,
    createdAt: string,
    definitionSnapshot: string,
    status: RoutineRunStatus,
    trigger: RoutineTrigger,
    triggeredByUserId?: string | null,
    extraContext?: string | null,
    scheduledFor?: string | null,
    startedAt?: string | null,
    finishedAt?: string | null,
    durationMs?: number | null,
    processingStage?: string | null,
    nextProcessingAt?: string | null,
    dispatchAttempts: number,
    lastDispatchedAt?: string | null,
    executionToken?: string | null,
    executionDeadlineAt?: string | null,
    conversationOwnerUserId: string,
    conversationId?: string | null,
    previousConversationId?: string | null,
    userMessageId?: string | null,
    assistantMessageId?: string | null,
    outcome?: RoutineOutcome | null,
    headline?: string | null,
    summary?: string | null,
    totalTokens?: number | null,
    agentTurns?: number | null,
    toolsCalled?: Array< string | null > | null,
    toolsFailed?: Array< string | null > | null,
    correlationId?: string | null,
    errorMessage?: string | null,
    ownerDelivery?:  {
      __typename: "RoutineDelivery",
      status: RoutineDeliveryStatus,
      target?: string | null,
      claimToken?: string | null,
      claimExpiresAt?: string | null,
      attemptedAt?: string | null,
      finishedAt?: string | null,
      messageId?: string | null,
      errorMessage?: string | null,
    } | null,
    channelDelivery?:  {
      __typename: "RoutineDelivery",
      status: RoutineDeliveryStatus,
      target?: string | null,
      claimToken?: string | null,
      claimExpiresAt?: string | null,
      attemptedAt?: string | null,
      finishedAt?: string | null,
      messageId?: string | null,
      errorMessage?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type CreateDoctorSupportingMAMutationVariables = {
  input: CreateDoctorSupportingMAInput,
  condition?: ModelDoctorSupportingMAConditionInput | null,
};

export type CreateDoctorSupportingMAMutation = {
  createDoctorSupportingMA?:  {
    __typename: "DoctorSupportingMA",
    id: string,
    medicalAssistantId: string,
    doctorId: string,
    medicalAssistant:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    },
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type UpdateDoctorSupportingMAMutationVariables = {
  input: UpdateDoctorSupportingMAInput,
  condition?: ModelDoctorSupportingMAConditionInput | null,
};

export type UpdateDoctorSupportingMAMutation = {
  updateDoctorSupportingMA?:  {
    __typename: "DoctorSupportingMA",
    id: string,
    medicalAssistantId: string,
    doctorId: string,
    medicalAssistant:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    },
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type DeleteDoctorSupportingMAMutationVariables = {
  input: DeleteDoctorSupportingMAInput,
  condition?: ModelDoctorSupportingMAConditionInput | null,
};

export type DeleteDoctorSupportingMAMutation = {
  deleteDoctorSupportingMA?:  {
    __typename: "DoctorSupportingMA",
    id: string,
    medicalAssistantId: string,
    doctorId: string,
    medicalAssistant:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    },
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type CreateMedicalAssistantSpecialtyCategoryMutationVariables = {
  input: CreateMedicalAssistantSpecialtyCategoryInput,
  condition?: ModelMedicalAssistantSpecialtyCategoryConditionInput | null,
};

export type CreateMedicalAssistantSpecialtyCategoryMutation = {
  createMedicalAssistantSpecialtyCategory?:  {
    __typename: "MedicalAssistantSpecialtyCategory",
    id: string,
    medicalAssistantId: string,
    specialtyCategoryId: string,
    medicalAssistant:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    },
    specialtyCategory:  {
      __typename: "SpecialtyCategory",
      id: string,
      name: string,
      specialties?: Array< SpecialtyType > | null,
      fallbackMA?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      medicalAssistants?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      specialtyCategoryFallbackMAId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMedicalAssistantSpecialtyCategoryMutationVariables = {
  input: UpdateMedicalAssistantSpecialtyCategoryInput,
  condition?: ModelMedicalAssistantSpecialtyCategoryConditionInput | null,
};

export type UpdateMedicalAssistantSpecialtyCategoryMutation = {
  updateMedicalAssistantSpecialtyCategory?:  {
    __typename: "MedicalAssistantSpecialtyCategory",
    id: string,
    medicalAssistantId: string,
    specialtyCategoryId: string,
    medicalAssistant:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    },
    specialtyCategory:  {
      __typename: "SpecialtyCategory",
      id: string,
      name: string,
      specialties?: Array< SpecialtyType > | null,
      fallbackMA?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      medicalAssistants?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      specialtyCategoryFallbackMAId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMedicalAssistantSpecialtyCategoryMutationVariables = {
  input: DeleteMedicalAssistantSpecialtyCategoryInput,
  condition?: ModelMedicalAssistantSpecialtyCategoryConditionInput | null,
};

export type DeleteMedicalAssistantSpecialtyCategoryMutation = {
  deleteMedicalAssistantSpecialtyCategory?:  {
    __typename: "MedicalAssistantSpecialtyCategory",
    id: string,
    medicalAssistantId: string,
    specialtyCategoryId: string,
    medicalAssistant:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    },
    specialtyCategory:  {
      __typename: "SpecialtyCategory",
      id: string,
      name: string,
      specialties?: Array< SpecialtyType > | null,
      fallbackMA?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      medicalAssistants?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      specialtyCategoryFallbackMAId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserAppointmentFilterPresetMutationVariables = {
  input: CreateUserAppointmentFilterPresetInput,
  condition?: ModelUserAppointmentFilterPresetConditionInput | null,
};

export type CreateUserAppointmentFilterPresetMutation = {
  createUserAppointmentFilterPreset?:  {
    __typename: "UserAppointmentFilterPreset",
    id: string,
    userId: string,
    appointmentFilterPresetId: string,
    user:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    },
    appointmentFilterPreset:  {
      __typename: "AppointmentFilterPreset",
      id: string,
      name: string,
      filters:  Array< {
        __typename: "FilterEntry",
        type: FilterType,
        values: Array< string >,
      } >,
      appliesTo: UserGroup,
      view?: AppointmentsView | null,
      users?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserAppointmentFilterPresetMutationVariables = {
  input: UpdateUserAppointmentFilterPresetInput,
  condition?: ModelUserAppointmentFilterPresetConditionInput | null,
};

export type UpdateUserAppointmentFilterPresetMutation = {
  updateUserAppointmentFilterPreset?:  {
    __typename: "UserAppointmentFilterPreset",
    id: string,
    userId: string,
    appointmentFilterPresetId: string,
    user:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    },
    appointmentFilterPreset:  {
      __typename: "AppointmentFilterPreset",
      id: string,
      name: string,
      filters:  Array< {
        __typename: "FilterEntry",
        type: FilterType,
        values: Array< string >,
      } >,
      appliesTo: UserGroup,
      view?: AppointmentsView | null,
      users?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserAppointmentFilterPresetMutationVariables = {
  input: DeleteUserAppointmentFilterPresetInput,
  condition?: ModelUserAppointmentFilterPresetConditionInput | null,
};

export type DeleteUserAppointmentFilterPresetMutation = {
  deleteUserAppointmentFilterPreset?:  {
    __typename: "UserAppointmentFilterPreset",
    id: string,
    userId: string,
    appointmentFilterPresetId: string,
    user:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    },
    appointmentFilterPreset:  {
      __typename: "AppointmentFilterPreset",
      id: string,
      name: string,
      filters:  Array< {
        __typename: "FilterEntry",
        type: FilterType,
        values: Array< string >,
      } >,
      appliesTo: UserGroup,
      view?: AppointmentsView | null,
      users?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAppointmentRecordPatientCaseMutationVariables = {
  input: CreateAppointmentRecordPatientCaseInput,
  condition?: ModelAppointmentRecordPatientCaseConditionInput | null,
};

export type CreateAppointmentRecordPatientCaseMutation = {
  createAppointmentRecordPatientCase?:  {
    __typename: "AppointmentRecordPatientCase",
    id: string,
    appointmentRecordId: string,
    patientCaseId: string,
    appointmentRecord:  {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    },
    patientCase:  {
      __typename: "PatientCase",
      id: string,
      patientID: string,
      patient?:  {
        __typename: "Patient",
        id: string,
        name?: string | null,
        dateOfBirth?: string | null,
        SSN?: string | null,
        language?: Language | null,
        dominantHand?: DominantHand | null,
        cases?:  {
          __typename: "ModelPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        occupation?: string | null,
        sex?: Sex | null,
        weightLb?: number | null,
        height?:  {
          __typename: "Height",
          feet?: number | null,
          inches?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      claimNumber: string,
      qmePanelNumber?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      injuryInfo?:  {
        __typename: "InjuryInfo",
        injuryType?: InjuryType | null,
        injuredBodyParts?: Array< BodyPart | null > | null,
        claimedBodyParts?: Array< BodyPart | null > | null,
        description?: string | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        startDateOfInjury?: string | null,
        startDateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
      } | null,
      workersCompInsurance?:  {
        __typename: "WorkersCompInsuranceInfo",
        insuranceCarrier?: string | null,
        adjuster?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      insuranceCarrierID?: string | null,
      insuranceCarrier?:  {
        __typename: "InsuranceCarrier",
        id: string,
        name: string,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierAddressID?: string | null,
      insuranceCarrierAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierFaxNumberID?: string | null,
      insuranceCarrierFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierPhoneNumberID?: string | null,
      insuranceCarrierPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      applicantAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyLawFirmID?: string | null,
      applicantAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyAddressID?: string | null,
      applicantAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyFaxNumberID?: string | null,
      applicantAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyPhoneNumberID?: string | null,
      applicantAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      defenseAttorneyLawFirmID?: string | null,
      defenseAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyAddressID?: string | null,
      defenseAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyFaxNumberID?: string | null,
      defenseAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyPhoneNumberID?: string | null,
      defenseAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nurseCaseManager?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      ccPerson?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyCcEmails?: Array< string | null > | null,
      defenseAttorneyCcEmails?: Array< string | null > | null,
      adjusterCcEmails?: Array< string | null > | null,
      scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
      employmentAtInjury?:  {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null,
      WCAB?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    doctorOwnerCognitoId?: string | null,
    assistantCognitoIds?: string | null,
  } | null,
};

export type UpdateAppointmentRecordPatientCaseMutationVariables = {
  input: UpdateAppointmentRecordPatientCaseInput,
  condition?: ModelAppointmentRecordPatientCaseConditionInput | null,
};

export type UpdateAppointmentRecordPatientCaseMutation = {
  updateAppointmentRecordPatientCase?:  {
    __typename: "AppointmentRecordPatientCase",
    id: string,
    appointmentRecordId: string,
    patientCaseId: string,
    appointmentRecord:  {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    },
    patientCase:  {
      __typename: "PatientCase",
      id: string,
      patientID: string,
      patient?:  {
        __typename: "Patient",
        id: string,
        name?: string | null,
        dateOfBirth?: string | null,
        SSN?: string | null,
        language?: Language | null,
        dominantHand?: DominantHand | null,
        cases?:  {
          __typename: "ModelPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        occupation?: string | null,
        sex?: Sex | null,
        weightLb?: number | null,
        height?:  {
          __typename: "Height",
          feet?: number | null,
          inches?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      claimNumber: string,
      qmePanelNumber?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      injuryInfo?:  {
        __typename: "InjuryInfo",
        injuryType?: InjuryType | null,
        injuredBodyParts?: Array< BodyPart | null > | null,
        claimedBodyParts?: Array< BodyPart | null > | null,
        description?: string | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        startDateOfInjury?: string | null,
        startDateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
      } | null,
      workersCompInsurance?:  {
        __typename: "WorkersCompInsuranceInfo",
        insuranceCarrier?: string | null,
        adjuster?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      insuranceCarrierID?: string | null,
      insuranceCarrier?:  {
        __typename: "InsuranceCarrier",
        id: string,
        name: string,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierAddressID?: string | null,
      insuranceCarrierAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierFaxNumberID?: string | null,
      insuranceCarrierFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierPhoneNumberID?: string | null,
      insuranceCarrierPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      applicantAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyLawFirmID?: string | null,
      applicantAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyAddressID?: string | null,
      applicantAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyFaxNumberID?: string | null,
      applicantAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyPhoneNumberID?: string | null,
      applicantAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      defenseAttorneyLawFirmID?: string | null,
      defenseAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyAddressID?: string | null,
      defenseAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyFaxNumberID?: string | null,
      defenseAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyPhoneNumberID?: string | null,
      defenseAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nurseCaseManager?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      ccPerson?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyCcEmails?: Array< string | null > | null,
      defenseAttorneyCcEmails?: Array< string | null > | null,
      adjusterCcEmails?: Array< string | null > | null,
      scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
      employmentAtInjury?:  {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null,
      WCAB?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    doctorOwnerCognitoId?: string | null,
    assistantCognitoIds?: string | null,
  } | null,
};

export type DeleteAppointmentRecordPatientCaseMutationVariables = {
  input: DeleteAppointmentRecordPatientCaseInput,
  condition?: ModelAppointmentRecordPatientCaseConditionInput | null,
};

export type DeleteAppointmentRecordPatientCaseMutation = {
  deleteAppointmentRecordPatientCase?:  {
    __typename: "AppointmentRecordPatientCase",
    id: string,
    appointmentRecordId: string,
    patientCaseId: string,
    appointmentRecord:  {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    },
    patientCase:  {
      __typename: "PatientCase",
      id: string,
      patientID: string,
      patient?:  {
        __typename: "Patient",
        id: string,
        name?: string | null,
        dateOfBirth?: string | null,
        SSN?: string | null,
        language?: Language | null,
        dominantHand?: DominantHand | null,
        cases?:  {
          __typename: "ModelPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        occupation?: string | null,
        sex?: Sex | null,
        weightLb?: number | null,
        height?:  {
          __typename: "Height",
          feet?: number | null,
          inches?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      claimNumber: string,
      qmePanelNumber?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      injuryInfo?:  {
        __typename: "InjuryInfo",
        injuryType?: InjuryType | null,
        injuredBodyParts?: Array< BodyPart | null > | null,
        claimedBodyParts?: Array< BodyPart | null > | null,
        description?: string | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        startDateOfInjury?: string | null,
        startDateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
      } | null,
      workersCompInsurance?:  {
        __typename: "WorkersCompInsuranceInfo",
        insuranceCarrier?: string | null,
        adjuster?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      insuranceCarrierID?: string | null,
      insuranceCarrier?:  {
        __typename: "InsuranceCarrier",
        id: string,
        name: string,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierAddressID?: string | null,
      insuranceCarrierAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierFaxNumberID?: string | null,
      insuranceCarrierFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierPhoneNumberID?: string | null,
      insuranceCarrierPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      applicantAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyLawFirmID?: string | null,
      applicantAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyAddressID?: string | null,
      applicantAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyFaxNumberID?: string | null,
      applicantAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyPhoneNumberID?: string | null,
      applicantAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      defenseAttorneyLawFirmID?: string | null,
      defenseAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyAddressID?: string | null,
      defenseAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyFaxNumberID?: string | null,
      defenseAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyPhoneNumberID?: string | null,
      defenseAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nurseCaseManager?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      ccPerson?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyCcEmails?: Array< string | null > | null,
      defenseAttorneyCcEmails?: Array< string | null > | null,
      adjusterCcEmails?: Array< string | null > | null,
      scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
      employmentAtInjury?:  {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null,
      WCAB?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    doctorOwnerCognitoId?: string | null,
    assistantCognitoIds?: string | null,
  } | null,
};

export type CreateDoctorLocationMutationVariables = {
  input: CreateDoctorLocationInput,
  condition?: ModelDoctorLocationConditionInput | null,
};

export type CreateDoctorLocationMutation = {
  createDoctorLocation?:  {
    __typename: "DoctorLocation",
    id: string,
    doctorId: string,
    locationId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    location:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type UpdateDoctorLocationMutationVariables = {
  input: UpdateDoctorLocationInput,
  condition?: ModelDoctorLocationConditionInput | null,
};

export type UpdateDoctorLocationMutation = {
  updateDoctorLocation?:  {
    __typename: "DoctorLocation",
    id: string,
    doctorId: string,
    locationId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    location:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type DeleteDoctorLocationMutationVariables = {
  input: DeleteDoctorLocationInput,
  condition?: ModelDoctorLocationConditionInput | null,
};

export type DeleteDoctorLocationMutation = {
  deleteDoctorLocation?:  {
    __typename: "DoctorLocation",
    id: string,
    doctorId: string,
    locationId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    location:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type CreateDoctorCaseSummaryFieldMutationVariables = {
  input: CreateDoctorCaseSummaryFieldInput,
  condition?: ModelDoctorCaseSummaryFieldConditionInput | null,
};

export type CreateDoctorCaseSummaryFieldMutation = {
  createDoctorCaseSummaryField?:  {
    __typename: "DoctorCaseSummaryField",
    id: string,
    doctorId: string,
    caseSummaryFieldId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    caseSummaryField:  {
      __typename: "CaseSummaryField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      summaryPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type UpdateDoctorCaseSummaryFieldMutationVariables = {
  input: UpdateDoctorCaseSummaryFieldInput,
  condition?: ModelDoctorCaseSummaryFieldConditionInput | null,
};

export type UpdateDoctorCaseSummaryFieldMutation = {
  updateDoctorCaseSummaryField?:  {
    __typename: "DoctorCaseSummaryField",
    id: string,
    doctorId: string,
    caseSummaryFieldId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    caseSummaryField:  {
      __typename: "CaseSummaryField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      summaryPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type DeleteDoctorCaseSummaryFieldMutationVariables = {
  input: DeleteDoctorCaseSummaryFieldInput,
  condition?: ModelDoctorCaseSummaryFieldConditionInput | null,
};

export type DeleteDoctorCaseSummaryFieldMutation = {
  deleteDoctorCaseSummaryField?:  {
    __typename: "DoctorCaseSummaryField",
    id: string,
    doctorId: string,
    caseSummaryFieldId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    caseSummaryField:  {
      __typename: "CaseSummaryField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      summaryPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type CreateDoctorBriefingFieldMutationVariables = {
  input: CreateDoctorBriefingFieldInput,
  condition?: ModelDoctorBriefingFieldConditionInput | null,
};

export type CreateDoctorBriefingFieldMutation = {
  createDoctorBriefingField?:  {
    __typename: "DoctorBriefingField",
    id: string,
    doctorId: string,
    briefingFieldId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    briefingField:  {
      __typename: "BriefingField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      briefingPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingRecordTypeID: string,
      recordType:  {
        __typename: "BriefingRecordType",
        id: string,
        name: string,
        recordType: RecordType,
        description?: string | null,
        default: boolean,
        classificationPrompt?: string | null,
        recordBasePrompt?: string | null,
        briefingFields?:  {
          __typename: "ModelBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type UpdateDoctorBriefingFieldMutationVariables = {
  input: UpdateDoctorBriefingFieldInput,
  condition?: ModelDoctorBriefingFieldConditionInput | null,
};

export type UpdateDoctorBriefingFieldMutation = {
  updateDoctorBriefingField?:  {
    __typename: "DoctorBriefingField",
    id: string,
    doctorId: string,
    briefingFieldId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    briefingField:  {
      __typename: "BriefingField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      briefingPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingRecordTypeID: string,
      recordType:  {
        __typename: "BriefingRecordType",
        id: string,
        name: string,
        recordType: RecordType,
        description?: string | null,
        default: boolean,
        classificationPrompt?: string | null,
        recordBasePrompt?: string | null,
        briefingFields?:  {
          __typename: "ModelBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type DeleteDoctorBriefingFieldMutationVariables = {
  input: DeleteDoctorBriefingFieldInput,
  condition?: ModelDoctorBriefingFieldConditionInput | null,
};

export type DeleteDoctorBriefingFieldMutation = {
  deleteDoctorBriefingField?:  {
    __typename: "DoctorBriefingField",
    id: string,
    doctorId: string,
    briefingFieldId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    briefingField:  {
      __typename: "BriefingField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      briefingPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingRecordTypeID: string,
      recordType:  {
        __typename: "BriefingRecordType",
        id: string,
        name: string,
        recordType: RecordType,
        description?: string | null,
        default: boolean,
        classificationPrompt?: string | null,
        recordBasePrompt?: string | null,
        briefingFields?:  {
          __typename: "ModelBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type IncrementGlobalBillingCounterAtomicMutationVariables = {
};

export type IncrementGlobalBillingCounterAtomicMutation = {
  incrementGlobalBillingCounterAtomic?:  {
    __typename: "GlobalBillingCounter",
    id: string,
    count?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type SearchAppointmentsCustomQueryVariables = {
  input: AppointmentSearchInput,
};

export type SearchAppointmentsCustomQuery = {
  searchAppointmentsCustom?:  {
    __typename: "AppointmentSearchConnection",
    items:  Array< {
      __typename: "AppointmentSearchResult",
      id: string,
      patient_name?: string | null,
      primary_claim_number?: string | null,
      other_claim_numbers?: Array< string | null > | null,
      doctor_name?: string | null,
      location?: string | null,
      doctor_id?: string | null,
      date?: string | null,
      time?: string | null,
      language?: string | null,
      appt_type?: string | null,
      is_prod?: boolean | null,
    } | null >,
    total?: number | null,
    nextToken?: string | null,
  } | null,
};

export type SearchAppointmentDocsQueryVariables = {
  input: AppointmentDocSearchInput,
};

export type SearchAppointmentDocsQuery = {
  searchAppointmentDocs?:  {
    __typename: "AppointmentDocSearchConnection",
    items:  Array< {
      __typename: "AppointmentDocSearchResult",
      chunk_id: string,
      uploaded_file_id: string,
      filename?: string | null,
      content: string,
      start_page_number: number,
      end_page_number: number,
      chunk_index: number,
      token_count?: number | null,
      score: number,
      highlights?: Array< string > | null,
    } | null >,
    total?: number | null,
  } | null,
};

export type SearchGeneralDocsQueryVariables = {
  input: GeneralDocSearchInput,
};

export type SearchGeneralDocsQuery = {
  searchGeneralDocs?:  {
    __typename: "GeneralDocSearchConnection",
    items:  Array< {
      __typename: "GeneralDocSearchResult",
      chunk_id: string,
      filename?: string | null,
      content: string,
      start_page_number: number,
      end_page_number: number,
      chunk_index: number,
      token_count?: number | null,
      score: number,
      highlights?: Array< string > | null,
    } | null >,
    total?: number | null,
  } | null,
};

export type SearchDoctorsQueryVariables = {
  input: DoctorSearchInput,
};

export type SearchDoctorsQuery = {
  searchDoctors?:  {
    __typename: "DoctorSearchConnection",
    items:  Array< {
      __typename: "DoctorSearchResult",
      id: string,
      first_name?: string | null,
      middle_name?: string | null,
      last_name?: string | null,
      npi?: string | null,
      office_phone?: string | null,
      email?: string | null,
      title?: string | null,
      specialties?: Array< string | null > | null,
      work_city?: string | null,
      work_state?: string | null,
      home_state?: string | null,
      physician_partner_id?: string | null,
      doctor_user_id?: string | null,
      license_number?: string | null,
    } | null >,
    total?: number | null,
    nextToken?: string | null,
  } | null,
};

export type SearchLocationsQueryVariables = {
  input: LocationSearchInput,
};

export type SearchLocationsQuery = {
  searchLocations?:  {
    __typename: "LocationSearchConnection",
    items:  Array< {
      __typename: "LocationSearchResult",
      id: string,
      location_name?: string | null,
      abbreviation?: string | null,
      city?: string | null,
      street?: string | null,
      zip?: string | null,
      state?: string | null,
      region?: string | null,
      status?: string | null,
    } | null >,
    total?: number | null,
    nextToken?: string | null,
  } | null,
};

export type SearchInsuranceCarriersQueryVariables = {
  input: InsuranceCarrierSearchInput,
};

export type SearchInsuranceCarriersQuery = {
  searchInsuranceCarriers?:  {
    __typename: "InsuranceCarrierSearchConnection",
    items:  Array< {
      __typename: "InsuranceCarrierSearchResult",
      id: string,
      name?: string | null,
      cities?: Array< string | null > | null,
      states?: Array< string | null > | null,
      default_address_id?: string | null,
      default_fax_number_id?: string | null,
      default_phone_number_id?: string | null,
    } | null >,
    total?: number | null,
    nextToken?: string | null,
  } | null,
};

export type SearchLawFirmsQueryVariables = {
  input: LawFirmSearchInput,
};

export type SearchLawFirmsQuery = {
  searchLawFirms?:  {
    __typename: "LawFirmSearchConnection",
    items:  Array< {
      __typename: "LawFirmSearchResult",
      id: string,
      name?: string | null,
      law_firm_type?: string | null,
      cities?: Array< string | null > | null,
      states?: Array< string | null > | null,
      default_address_id?: string | null,
      default_fax_number_id?: string | null,
      default_phone_number_id?: string | null,
    } | null >,
    total?: number | null,
    nextToken?: string | null,
  } | null,
};

export type ListAppointmentsOptimizedQueryVariables = {
  input: ListAppointmentsOptimizedInput,
};

export type ListAppointmentsOptimizedQuery = {
  listAppointmentsOptimized?:  {
    __typename: "ListAppointmentsOptimizedResponse",
    appointments:  Array< {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type BatchGetDataFieldsQueryVariables = {
  ids: Array< string >,
};

export type BatchGetDataFieldsQuery = {
  batchGetDataFields?:  Array< {
    __typename: "DataField",
    id: string,
    name: string,
    category: DataFieldCategory,
    dataType: DataFieldType,
    default: boolean,
    description?: string | null,
    sectionID?: string | null,
    section?:  {
      __typename: "DataFieldSection",
      id: string,
      name: string,
      default: boolean,
      fields?:  {
        __typename: "ModelDataFieldConnection",
        items:  Array< {
          __typename: "DataField",
          id: string,
          name: string,
          category: DataFieldCategory,
          dataType: DataFieldType,
          default: boolean,
          description?: string | null,
          sectionID?: string | null,
          migrationKey?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    migrationKey?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null > | null,
};

export type GetAppointmentFileReferenceQueryVariables = {
  id: string,
};

export type GetAppointmentFileReferenceQuery = {
  getAppointmentFileReference?:  {
    __typename: "AppointmentFileReference",
    id: string,
    appointmentID: string,
    uploadedFileID: string,
    status?: AppointmentFileReferenceStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAppointmentFileReferencesQueryVariables = {
  filter?: ModelAppointmentFileReferenceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAppointmentFileReferencesQuery = {
  listAppointmentFileReferences?:  {
    __typename: "ModelAppointmentFileReferenceConnection",
    items:  Array< {
      __typename: "AppointmentFileReference",
      id: string,
      appointmentID: string,
      uploadedFileID: string,
      status?: AppointmentFileReferenceStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentFileReferencesByAppointmentIDQueryVariables = {
  appointmentID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentFileReferenceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentFileReferencesByAppointmentIDQuery = {
  appointmentFileReferencesByAppointmentID?:  {
    __typename: "ModelAppointmentFileReferenceConnection",
    items:  Array< {
      __typename: "AppointmentFileReference",
      id: string,
      appointmentID: string,
      uploadedFileID: string,
      status?: AppointmentFileReferenceStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentFileReferencesByUploadedFileIDQueryVariables = {
  uploadedFileID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentFileReferenceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentFileReferencesByUploadedFileIDQuery = {
  appointmentFileReferencesByUploadedFileID?:  {
    __typename: "ModelAppointmentFileReferenceConnection",
    items:  Array< {
      __typename: "AppointmentFileReference",
      id: string,
      appointmentID: string,
      uploadedFileID: string,
      status?: AppointmentFileReferenceStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUploadedFileQueryVariables = {
  id: string,
};

export type GetUploadedFileQuery = {
  getUploadedFile?:  {
    __typename: "UploadedFile",
    id: string,
    key?: string | null,
    fileName?: string | null,
    type?: FileType | null,
    provider?: FileProvider | null,
    uploadedBy?: string | null,
    uploadedAt?: string | null,
    fileSizeBytes?: number | null,
    fileSet?:  {
      __typename: "UploadedFileSet",
      id: string,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      uploadedFiles?:  {
        __typename: "ModelUploadedFileConnection",
        items:  Array< {
          __typename: "UploadedFile",
          id: string,
          key?: string | null,
          fileName?: string | null,
          type?: FileType | null,
          provider?: FileProvider | null,
          uploadedBy?: string | null,
          uploadedAt?: string | null,
          fileSizeBytes?: number | null,
          fileSetID?: string | null,
          sourceAppointmentID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fileSetID?: string | null,
    sourceAppointmentID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUploadedFilesQueryVariables = {
  filter?: ModelUploadedFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUploadedFilesQuery = {
  listUploadedFiles?:  {
    __typename: "ModelUploadedFileConnection",
    items:  Array< {
      __typename: "UploadedFile",
      id: string,
      key?: string | null,
      fileName?: string | null,
      type?: FileType | null,
      provider?: FileProvider | null,
      uploadedBy?: string | null,
      uploadedAt?: string | null,
      fileSizeBytes?: number | null,
      fileSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      fileSetID?: string | null,
      sourceAppointmentID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UploadedFilesByFileSetIDQueryVariables = {
  fileSetID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUploadedFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UploadedFilesByFileSetIDQuery = {
  uploadedFilesByFileSetID?:  {
    __typename: "ModelUploadedFileConnection",
    items:  Array< {
      __typename: "UploadedFile",
      id: string,
      key?: string | null,
      fileName?: string | null,
      type?: FileType | null,
      provider?: FileProvider | null,
      uploadedBy?: string | null,
      uploadedAt?: string | null,
      fileSizeBytes?: number | null,
      fileSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      fileSetID?: string | null,
      sourceAppointmentID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UploadedFilesBySourceAppointmentIDQueryVariables = {
  sourceAppointmentID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUploadedFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UploadedFilesBySourceAppointmentIDQuery = {
  uploadedFilesBySourceAppointmentID?:  {
    __typename: "ModelUploadedFileConnection",
    items:  Array< {
      __typename: "UploadedFile",
      id: string,
      key?: string | null,
      fileName?: string | null,
      type?: FileType | null,
      provider?: FileProvider | null,
      uploadedBy?: string | null,
      uploadedAt?: string | null,
      fileSizeBytes?: number | null,
      fileSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      fileSetID?: string | null,
      sourceAppointmentID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUploadedFileSetQueryVariables = {
  id: string,
};

export type GetUploadedFileSetQuery = {
  getUploadedFileSet?:  {
    __typename: "UploadedFileSet",
    id: string,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    uploadedFiles?:  {
      __typename: "ModelUploadedFileConnection",
      items:  Array< {
        __typename: "UploadedFile",
        id: string,
        key?: string | null,
        fileName?: string | null,
        type?: FileType | null,
        provider?: FileProvider | null,
        uploadedBy?: string | null,
        uploadedAt?: string | null,
        fileSizeBytes?: number | null,
        fileSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        fileSetID?: string | null,
        sourceAppointmentID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUploadedFileSetsQueryVariables = {
  filter?: ModelUploadedFileSetFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUploadedFileSetsQuery = {
  listUploadedFileSets?:  {
    __typename: "ModelUploadedFileSetConnection",
    items:  Array< {
      __typename: "UploadedFileSet",
      id: string,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      uploadedFiles?:  {
        __typename: "ModelUploadedFileConnection",
        items:  Array< {
          __typename: "UploadedFile",
          id: string,
          key?: string | null,
          fileName?: string | null,
          type?: FileType | null,
          provider?: FileProvider | null,
          uploadedBy?: string | null,
          uploadedAt?: string | null,
          fileSizeBytes?: number | null,
          fileSetID?: string | null,
          sourceAppointmentID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDocumentQueryVariables = {
  id: string,
};

export type GetDocumentQuery = {
  getDocument?:  {
    __typename: "Document",
    id: string,
    uploadedFileID: string,
    providerTag?: string | null,
    pageCount: number,
    executionArn: string,
    recordBriefingId?: string | null,
    segmentSplits?: Array< number | null > | null,
    segmentIntervals?:  Array< {
      __typename: "SegmentInterval",
      startPageNumber: number,
      endPageNumber: number,
      startLineNumber?: number | null,
      endLineNumber?: number | null,
      confidence?: number | null,
      confidenceReasoning?: string | null,
      edited?: boolean | null,
      needsReSummary?: boolean | null,
    } | null > | null,
    segmentIntervalRows?:  {
      __typename: "ModelDocumentSegmentIntervalConnection",
      items:  Array< {
        __typename: "DocumentSegmentInterval",
        id: string,
        documentID: string,
        startPageNumber: number,
        endPageNumber: number,
        startLineNumber?: number | null,
        endLineNumber?: number | null,
        confidence?: number | null,
        confidenceReasoning?: string | null,
        edited?: boolean | null,
        needsReSummary?: boolean | null,
        archived?: boolean | null,
        parentIntervals?: Array< string > | null,
        lastEditAction?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    pages?:  {
      __typename: "ModelDocumentPageConnection",
      items:  Array< {
        __typename: "DocumentPage",
        id: string,
        documentID: string,
        pageNumber: number,
        imageS3Key?: string | null,
        text?: string | null,
        isBlank?: boolean | null,
        citations?:  {
          __typename: "ModelCitationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    preview?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    hasUnresolvedSplits?: boolean | null,
    videoDurationSeconds?: number | null,
    ingestionSteps?:  {
      __typename: "ModelDocumentIngestionStepConnection",
      items:  Array< {
        __typename: "DocumentIngestionStep",
        id: string,
        documentID: string,
        name: string,
        status: IngestionStepStatus,
        startedAt: string,
        endedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mrrValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    documentMrrValidationId?: string | null,
  } | null,
};

export type ListDocumentsQueryVariables = {
  filter?: ModelDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDocumentsQuery = {
  listDocuments?:  {
    __typename: "ModelDocumentConnection",
    items:  Array< {
      __typename: "Document",
      id: string,
      uploadedFileID: string,
      providerTag?: string | null,
      pageCount: number,
      executionArn: string,
      recordBriefingId?: string | null,
      segmentSplits?: Array< number | null > | null,
      segmentIntervals?:  Array< {
        __typename: "SegmentInterval",
        startPageNumber: number,
        endPageNumber: number,
        startLineNumber?: number | null,
        endLineNumber?: number | null,
        confidence?: number | null,
        confidenceReasoning?: string | null,
        edited?: boolean | null,
        needsReSummary?: boolean | null,
      } | null > | null,
      segmentIntervalRows?:  {
        __typename: "ModelDocumentSegmentIntervalConnection",
        items:  Array< {
          __typename: "DocumentSegmentInterval",
          id: string,
          documentID: string,
          startPageNumber: number,
          endPageNumber: number,
          startLineNumber?: number | null,
          endLineNumber?: number | null,
          confidence?: number | null,
          confidenceReasoning?: string | null,
          edited?: boolean | null,
          needsReSummary?: boolean | null,
          archived?: boolean | null,
          parentIntervals?: Array< string > | null,
          lastEditAction?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      pages?:  {
        __typename: "ModelDocumentPageConnection",
        items:  Array< {
          __typename: "DocumentPage",
          id: string,
          documentID: string,
          pageNumber: number,
          imageS3Key?: string | null,
          text?: string | null,
          isBlank?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      preview?:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } | null,
      hasUnresolvedSplits?: boolean | null,
      videoDurationSeconds?: number | null,
      ingestionSteps?:  {
        __typename: "ModelDocumentIngestionStepConnection",
        items:  Array< {
          __typename: "DocumentIngestionStep",
          id: string,
          documentID: string,
          name: string,
          status: IngestionStepStatus,
          startedAt: string,
          endedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      documentMrrValidationId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DocumentsByUploadedFileIDQueryVariables = {
  uploadedFileID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DocumentsByUploadedFileIDQuery = {
  documentsByUploadedFileID?:  {
    __typename: "ModelDocumentConnection",
    items:  Array< {
      __typename: "Document",
      id: string,
      uploadedFileID: string,
      providerTag?: string | null,
      pageCount: number,
      executionArn: string,
      recordBriefingId?: string | null,
      segmentSplits?: Array< number | null > | null,
      segmentIntervals?:  Array< {
        __typename: "SegmentInterval",
        startPageNumber: number,
        endPageNumber: number,
        startLineNumber?: number | null,
        endLineNumber?: number | null,
        confidence?: number | null,
        confidenceReasoning?: string | null,
        edited?: boolean | null,
        needsReSummary?: boolean | null,
      } | null > | null,
      segmentIntervalRows?:  {
        __typename: "ModelDocumentSegmentIntervalConnection",
        items:  Array< {
          __typename: "DocumentSegmentInterval",
          id: string,
          documentID: string,
          startPageNumber: number,
          endPageNumber: number,
          startLineNumber?: number | null,
          endLineNumber?: number | null,
          confidence?: number | null,
          confidenceReasoning?: string | null,
          edited?: boolean | null,
          needsReSummary?: boolean | null,
          archived?: boolean | null,
          parentIntervals?: Array< string > | null,
          lastEditAction?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      pages?:  {
        __typename: "ModelDocumentPageConnection",
        items:  Array< {
          __typename: "DocumentPage",
          id: string,
          documentID: string,
          pageNumber: number,
          imageS3Key?: string | null,
          text?: string | null,
          isBlank?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      preview?:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } | null,
      hasUnresolvedSplits?: boolean | null,
      videoDurationSeconds?: number | null,
      ingestionSteps?:  {
        __typename: "ModelDocumentIngestionStepConnection",
        items:  Array< {
          __typename: "DocumentIngestionStep",
          id: string,
          documentID: string,
          name: string,
          status: IngestionStepStatus,
          startedAt: string,
          endedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      documentMrrValidationId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDocumentIngestionStepQueryVariables = {
  id: string,
};

export type GetDocumentIngestionStepQuery = {
  getDocumentIngestionStep?:  {
    __typename: "DocumentIngestionStep",
    id: string,
    documentID: string,
    name: string,
    status: IngestionStepStatus,
    startedAt: string,
    endedAt?: string | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListDocumentIngestionStepsQueryVariables = {
  filter?: ModelDocumentIngestionStepFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDocumentIngestionStepsQuery = {
  listDocumentIngestionSteps?:  {
    __typename: "ModelDocumentIngestionStepConnection",
    items:  Array< {
      __typename: "DocumentIngestionStep",
      id: string,
      documentID: string,
      name: string,
      status: IngestionStepStatus,
      startedAt: string,
      endedAt?: string | null,
      errorMessage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DocumentIngestionStepsByDocumentIDAndStartedAtQueryVariables = {
  documentID: string,
  startedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDocumentIngestionStepFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DocumentIngestionStepsByDocumentIDAndStartedAtQuery = {
  documentIngestionStepsByDocumentIDAndStartedAt?:  {
    __typename: "ModelDocumentIngestionStepConnection",
    items:  Array< {
      __typename: "DocumentIngestionStep",
      id: string,
      documentID: string,
      name: string,
      status: IngestionStepStatus,
      startedAt: string,
      endedAt?: string | null,
      errorMessage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOperationStatusQueryVariables = {
  id: string,
};

export type GetOperationStatusQuery = {
  getOperationStatus?:  {
    __typename: "OperationStatus",
    id: string,
    scope: string,
    operation: string,
    name: string,
    status: OperationState,
    startedAt: string,
    heartbeatAt?: string | null,
    endedAt?: string | null,
    attempt?: number | null,
    errorMessage?: string | null,
    correlationId?: string | null,
    metadata?: string | null,
    expiresAt?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListOperationStatusesQueryVariables = {
  filter?: ModelOperationStatusFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOperationStatusesQuery = {
  listOperationStatuses?:  {
    __typename: "ModelOperationStatusConnection",
    items:  Array< {
      __typename: "OperationStatus",
      id: string,
      scope: string,
      operation: string,
      name: string,
      status: OperationState,
      startedAt: string,
      heartbeatAt?: string | null,
      endedAt?: string | null,
      attempt?: number | null,
      errorMessage?: string | null,
      correlationId?: string | null,
      metadata?: string | null,
      expiresAt?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OperationStatusesByScopeAndStartedAtQueryVariables = {
  scope: string,
  startedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOperationStatusFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OperationStatusesByScopeAndStartedAtQuery = {
  operationStatusesByScopeAndStartedAt?:  {
    __typename: "ModelOperationStatusConnection",
    items:  Array< {
      __typename: "OperationStatus",
      id: string,
      scope: string,
      operation: string,
      name: string,
      status: OperationState,
      startedAt: string,
      heartbeatAt?: string | null,
      endedAt?: string | null,
      attempt?: number | null,
      errorMessage?: string | null,
      correlationId?: string | null,
      metadata?: string | null,
      expiresAt?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDocumentPageQueryVariables = {
  id: string,
};

export type GetDocumentPageQuery = {
  getDocumentPage?:  {
    __typename: "DocumentPage",
    id: string,
    documentID: string,
    pageNumber: number,
    imageS3Key?: string | null,
    text?: string | null,
    isBlank?: boolean | null,
    citations?:  {
      __typename: "ModelCitationConnection",
      items:  Array< {
        __typename: "Citation",
        id: string,
        documentPageID: string,
        documentID: string,
        pageNumber: number,
        blockIndex: number,
        text: string,
        bbox:  {
          __typename: "BoundingBox",
          yMin: number,
          xMin: number,
          yMax: number,
          xMax: number,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListDocumentPagesQueryVariables = {
  filter?: ModelDocumentPageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDocumentPagesQuery = {
  listDocumentPages?:  {
    __typename: "ModelDocumentPageConnection",
    items:  Array< {
      __typename: "DocumentPage",
      id: string,
      documentID: string,
      pageNumber: number,
      imageS3Key?: string | null,
      text?: string | null,
      isBlank?: boolean | null,
      citations?:  {
        __typename: "ModelCitationConnection",
        items:  Array< {
          __typename: "Citation",
          id: string,
          documentPageID: string,
          documentID: string,
          pageNumber: number,
          blockIndex: number,
          text: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DocumentPagesByDocumentIDAndPageNumberQueryVariables = {
  documentID: string,
  pageNumber?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDocumentPageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DocumentPagesByDocumentIDAndPageNumberQuery = {
  documentPagesByDocumentIDAndPageNumber?:  {
    __typename: "ModelDocumentPageConnection",
    items:  Array< {
      __typename: "DocumentPage",
      id: string,
      documentID: string,
      pageNumber: number,
      imageS3Key?: string | null,
      text?: string | null,
      isBlank?: boolean | null,
      citations?:  {
        __typename: "ModelCitationConnection",
        items:  Array< {
          __typename: "Citation",
          id: string,
          documentPageID: string,
          documentID: string,
          pageNumber: number,
          blockIndex: number,
          text: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCitationQueryVariables = {
  id: string,
};

export type GetCitationQuery = {
  getCitation?:  {
    __typename: "Citation",
    id: string,
    documentPageID: string,
    documentID: string,
    pageNumber: number,
    blockIndex: number,
    text: string,
    bbox:  {
      __typename: "BoundingBox",
      yMin: number,
      xMin: number,
      yMax: number,
      xMax: number,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCitationsQueryVariables = {
  filter?: ModelCitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCitationsQuery = {
  listCitations?:  {
    __typename: "ModelCitationConnection",
    items:  Array< {
      __typename: "Citation",
      id: string,
      documentPageID: string,
      documentID: string,
      pageNumber: number,
      blockIndex: number,
      text: string,
      bbox:  {
        __typename: "BoundingBox",
        yMin: number,
        xMin: number,
        yMax: number,
        xMax: number,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CitationsByDocumentPageIDAndBlockIndexQueryVariables = {
  documentPageID: string,
  blockIndex?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CitationsByDocumentPageIDAndBlockIndexQuery = {
  citationsByDocumentPageIDAndBlockIndex?:  {
    __typename: "ModelCitationConnection",
    items:  Array< {
      __typename: "Citation",
      id: string,
      documentPageID: string,
      documentID: string,
      pageNumber: number,
      blockIndex: number,
      text: string,
      bbox:  {
        __typename: "BoundingBox",
        yMin: number,
        xMin: number,
        yMax: number,
        xMax: number,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDocumentSegmentIntervalQueryVariables = {
  id: string,
};

export type GetDocumentSegmentIntervalQuery = {
  getDocumentSegmentInterval?:  {
    __typename: "DocumentSegmentInterval",
    id: string,
    documentID: string,
    startPageNumber: number,
    endPageNumber: number,
    startLineNumber?: number | null,
    endLineNumber?: number | null,
    confidence?: number | null,
    confidenceReasoning?: string | null,
    edited?: boolean | null,
    needsReSummary?: boolean | null,
    archived?: boolean | null,
    parentIntervals?: Array< string > | null,
    lastEditAction?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListDocumentSegmentIntervalsQueryVariables = {
  filter?: ModelDocumentSegmentIntervalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDocumentSegmentIntervalsQuery = {
  listDocumentSegmentIntervals?:  {
    __typename: "ModelDocumentSegmentIntervalConnection",
    items:  Array< {
      __typename: "DocumentSegmentInterval",
      id: string,
      documentID: string,
      startPageNumber: number,
      endPageNumber: number,
      startLineNumber?: number | null,
      endLineNumber?: number | null,
      confidence?: number | null,
      confidenceReasoning?: string | null,
      edited?: boolean | null,
      needsReSummary?: boolean | null,
      archived?: boolean | null,
      parentIntervals?: Array< string > | null,
      lastEditAction?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DocumentSegmentIntervalsByDocumentIDAndStartPageNumberQueryVariables = {
  documentID: string,
  startPageNumber?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDocumentSegmentIntervalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DocumentSegmentIntervalsByDocumentIDAndStartPageNumberQuery = {
  documentSegmentIntervalsByDocumentIDAndStartPageNumber?:  {
    __typename: "ModelDocumentSegmentIntervalConnection",
    items:  Array< {
      __typename: "DocumentSegmentInterval",
      id: string,
      documentID: string,
      startPageNumber: number,
      endPageNumber: number,
      startLineNumber?: number | null,
      endLineNumber?: number | null,
      confidence?: number | null,
      confidenceReasoning?: string | null,
      edited?: boolean | null,
      needsReSummary?: boolean | null,
      archived?: boolean | null,
      parentIntervals?: Array< string > | null,
      lastEditAction?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAudioQueryVariables = {
  id: string,
};

export type GetAudioQuery = {
  getAudio?:  {
    __typename: "Audio",
    id: string,
    uploadedFileID: string,
    executionArn?: string | null,
    fileFormat: string,
    durationSeconds?: number | null,
    transcript?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    transcriptWordCount?: number | null,
    transcriptGrammarCorrected?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    transcriptGrammarCorrectedWordCount?: number | null,
    transcriptPreview?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    detectedLanguages?: Array< Language | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAudioQueryVariables = {
  filter?: ModelAudioFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAudioQuery = {
  listAudio?:  {
    __typename: "ModelAudioConnection",
    items:  Array< {
      __typename: "Audio",
      id: string,
      uploadedFileID: string,
      executionArn?: string | null,
      fileFormat: string,
      durationSeconds?: number | null,
      transcript?:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } | null,
      transcriptWordCount?: number | null,
      transcriptGrammarCorrected?:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } | null,
      transcriptGrammarCorrectedWordCount?: number | null,
      transcriptPreview?:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } | null,
      detectedLanguages?: Array< Language | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AudioByUploadedFileIDQueryVariables = {
  uploadedFileID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAudioFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AudioByUploadedFileIDQuery = {
  audioByUploadedFileID?:  {
    __typename: "ModelAudioConnection",
    items:  Array< {
      __typename: "Audio",
      id: string,
      uploadedFileID: string,
      executionArn?: string | null,
      fileFormat: string,
      durationSeconds?: number | null,
      transcript?:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } | null,
      transcriptWordCount?: number | null,
      transcriptGrammarCorrected?:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } | null,
      transcriptGrammarCorrectedWordCount?: number | null,
      transcriptPreview?:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } | null,
      detectedLanguages?: Array< Language | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetHistoryTranscriptQueryVariables = {
  id: string,
};

export type GetHistoryTranscriptQuery = {
  getHistoryTranscript?:  {
    __typename: "HistoryTranscript",
    id: string,
    uploadedFileID: string,
    callId?: string | null,
    recordingId?: string | null,
    callStartTime?: string | null,
    callDurationSeconds?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListHistoryTranscriptsQueryVariables = {
  filter?: ModelHistoryTranscriptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHistoryTranscriptsQuery = {
  listHistoryTranscripts?:  {
    __typename: "ModelHistoryTranscriptConnection",
    items:  Array< {
      __typename: "HistoryTranscript",
      id: string,
      uploadedFileID: string,
      callId?: string | null,
      recordingId?: string | null,
      callStartTime?: string | null,
      callDurationSeconds?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type HistoryTranscriptsByUploadedFileIDQueryVariables = {
  uploadedFileID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHistoryTranscriptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type HistoryTranscriptsByUploadedFileIDQuery = {
  historyTranscriptsByUploadedFileID?:  {
    __typename: "ModelHistoryTranscriptConnection",
    items:  Array< {
      __typename: "HistoryTranscript",
      id: string,
      uploadedFileID: string,
      callId?: string | null,
      recordingId?: string | null,
      callStartTime?: string | null,
      callDurationSeconds?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type HistoryTranscriptsByCallIdQueryVariables = {
  callId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHistoryTranscriptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type HistoryTranscriptsByCallIdQuery = {
  historyTranscriptsByCallId?:  {
    __typename: "ModelHistoryTranscriptConnection",
    items:  Array< {
      __typename: "HistoryTranscript",
      id: string,
      uploadedFileID: string,
      callId?: string | null,
      recordingId?: string | null,
      callStartTime?: string | null,
      callDurationSeconds?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPanelFileQueryVariables = {
  id: string,
};

export type GetPanelFileQuery = {
  getPanelFile?:  {
    __typename: "PanelFile",
    id: string,
    uploadedFileID: string,
    sourceAppointmentID?: string | null,
    correlationId?: string | null,
    panelNumber?: string | null,
    panelIssueDate?: string | null,
    numberOfRequests?: number | null,
    requestingParty?: ParticipantType | null,
    claim?:  {
      __typename: "PanelClaimInfo",
      claimNumber?: string | null,
      dateOfInjury?: string | null,
    } | null,
    patient?:  {
      __typename: "PanelPatientInfo",
      name?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    employer?:  {
      __typename: "PanelEmployerInfo",
      name?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    adjuster?:  {
      __typename: "PanelPartyInfo",
      name?: string | null,
      company?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    applicantAttorney?:  {
      __typename: "PanelPartyInfo",
      name?: string | null,
      company?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    defenseAttorney?:  {
      __typename: "PanelPartyInfo",
      name?: string | null,
      company?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
    } | null,
    physicians?:  Array< {
      __typename: "PanelPhysician",
      name?: string | null,
      specialty?: string | null,
      address?:  {
        __typename: "PanelAddress",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
      } | null,
      yearsInPractice?: number | null,
      education?: string | null,
      phoneNumber?: string | null,
      isStruck?: boolean | null,
      strikeDate?: string | null,
      strikeParty?: ParticipantType | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPanelFilesQueryVariables = {
  filter?: ModelPanelFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPanelFilesQuery = {
  listPanelFiles?:  {
    __typename: "ModelPanelFileConnection",
    items:  Array< {
      __typename: "PanelFile",
      id: string,
      uploadedFileID: string,
      sourceAppointmentID?: string | null,
      correlationId?: string | null,
      panelNumber?: string | null,
      panelIssueDate?: string | null,
      numberOfRequests?: number | null,
      requestingParty?: ParticipantType | null,
      claim?:  {
        __typename: "PanelClaimInfo",
        claimNumber?: string | null,
        dateOfInjury?: string | null,
      } | null,
      patient?:  {
        __typename: "PanelPatientInfo",
        name?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      employer?:  {
        __typename: "PanelEmployerInfo",
        name?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      adjuster?:  {
        __typename: "PanelPartyInfo",
        name?: string | null,
        company?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      applicantAttorney?:  {
        __typename: "PanelPartyInfo",
        name?: string | null,
        company?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      defenseAttorney?:  {
        __typename: "PanelPartyInfo",
        name?: string | null,
        company?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      physicians?:  Array< {
        __typename: "PanelPhysician",
        name?: string | null,
        specialty?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
        yearsInPractice?: number | null,
        education?: string | null,
        phoneNumber?: string | null,
        isStruck?: boolean | null,
        strikeDate?: string | null,
        strikeParty?: ParticipantType | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PanelFilesByUploadedFileQueryVariables = {
  uploadedFileID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPanelFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PanelFilesByUploadedFileQuery = {
  panelFilesByUploadedFile?:  {
    __typename: "ModelPanelFileConnection",
    items:  Array< {
      __typename: "PanelFile",
      id: string,
      uploadedFileID: string,
      sourceAppointmentID?: string | null,
      correlationId?: string | null,
      panelNumber?: string | null,
      panelIssueDate?: string | null,
      numberOfRequests?: number | null,
      requestingParty?: ParticipantType | null,
      claim?:  {
        __typename: "PanelClaimInfo",
        claimNumber?: string | null,
        dateOfInjury?: string | null,
      } | null,
      patient?:  {
        __typename: "PanelPatientInfo",
        name?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      employer?:  {
        __typename: "PanelEmployerInfo",
        name?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      adjuster?:  {
        __typename: "PanelPartyInfo",
        name?: string | null,
        company?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      applicantAttorney?:  {
        __typename: "PanelPartyInfo",
        name?: string | null,
        company?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      defenseAttorney?:  {
        __typename: "PanelPartyInfo",
        name?: string | null,
        company?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      physicians?:  Array< {
        __typename: "PanelPhysician",
        name?: string | null,
        specialty?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
        yearsInPractice?: number | null,
        education?: string | null,
        phoneNumber?: string | null,
        isStruck?: boolean | null,
        strikeDate?: string | null,
        strikeParty?: ParticipantType | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PanelFilesBySourceAppointmentQueryVariables = {
  sourceAppointmentID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPanelFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PanelFilesBySourceAppointmentQuery = {
  panelFilesBySourceAppointment?:  {
    __typename: "ModelPanelFileConnection",
    items:  Array< {
      __typename: "PanelFile",
      id: string,
      uploadedFileID: string,
      sourceAppointmentID?: string | null,
      correlationId?: string | null,
      panelNumber?: string | null,
      panelIssueDate?: string | null,
      numberOfRequests?: number | null,
      requestingParty?: ParticipantType | null,
      claim?:  {
        __typename: "PanelClaimInfo",
        claimNumber?: string | null,
        dateOfInjury?: string | null,
      } | null,
      patient?:  {
        __typename: "PanelPatientInfo",
        name?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      employer?:  {
        __typename: "PanelEmployerInfo",
        name?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      adjuster?:  {
        __typename: "PanelPartyInfo",
        name?: string | null,
        company?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      applicantAttorney?:  {
        __typename: "PanelPartyInfo",
        name?: string | null,
        company?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      defenseAttorney?:  {
        __typename: "PanelPartyInfo",
        name?: string | null,
        company?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
      } | null,
      physicians?:  Array< {
        __typename: "PanelPhysician",
        name?: string | null,
        specialty?: string | null,
        address?:  {
          __typename: "PanelAddress",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
        } | null,
        yearsInPractice?: number | null,
        education?: string | null,
        phoneNumber?: string | null,
        isStruck?: boolean | null,
        strikeDate?: string | null,
        strikeParty?: ParticipantType | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetNotesQueryVariables = {
  id: string,
};

export type GetNotesQuery = {
  getNotes?:  {
    __typename: "Notes",
    id: string,
    content?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    type?: NotesType | null,
    timeStamp?: number | null,
    appointmentrecordID: string,
    createdAt: string,
    updatedAt: string,
    notesAuthorId?: string | null,
  } | null,
};

export type ListNotesQueryVariables = {
  filter?: ModelNotesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNotesQuery = {
  listNotes?:  {
    __typename: "ModelNotesConnection",
    items:  Array< {
      __typename: "Notes",
      id: string,
      content?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      type?: NotesType | null,
      timeStamp?: number | null,
      appointmentrecordID: string,
      createdAt: string,
      updatedAt: string,
      notesAuthorId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NotesByAppointmentrecordIDQueryVariables = {
  appointmentrecordID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotesByAppointmentrecordIDQuery = {
  notesByAppointmentrecordID?:  {
    __typename: "ModelNotesConnection",
    items:  Array< {
      __typename: "Notes",
      id: string,
      content?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      type?: NotesType | null,
      timeStamp?: number | null,
      appointmentrecordID: string,
      createdAt: string,
      updatedAt: string,
      notesAuthorId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetHuddleNoteQueryVariables = {
  id: string,
};

export type GetHuddleNoteQuery = {
  getHuddleNote?:  {
    __typename: "HuddleNote",
    id: string,
    appointmentRecordID: string,
    contentMarkdown?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListHuddleNotesQueryVariables = {
  filter?: ModelHuddleNoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHuddleNotesQuery = {
  listHuddleNotes?:  {
    __typename: "ModelHuddleNoteConnection",
    items:  Array< {
      __typename: "HuddleNote",
      id: string,
      appointmentRecordID: string,
      contentMarkdown?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type HuddleNotesByAppointmentRecordQueryVariables = {
  appointmentRecordID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHuddleNoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type HuddleNotesByAppointmentRecordQuery = {
  huddleNotesByAppointmentRecord?:  {
    __typename: "ModelHuddleNoteConnection",
    items:  Array< {
      __typename: "HuddleNote",
      id: string,
      appointmentRecordID: string,
      contentMarkdown?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMedicalAssistantQueryVariables = {
  id: string,
};

export type GetMedicalAssistantQuery = {
  getMedicalAssistant?:  {
    __typename: "MedicalAssistant",
    id: string,
    name?: string | null,
    email?: string | null,
    preVisitCallScheduleLink?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    enableCalendarNotify?: boolean | null,
    inactive?: boolean | null,
    languages?: Array< Language > | null,
    assignmentCriteria?:  {
      __typename: "MedicalAssistantAppointmentAssignmentCriteria",
      languageWeights:  Array< {
        __typename: "LanguageWeight",
        language: Language,
        weight: number,
        doctorSpecialty?: SpecialtyType | null,
      } >,
    } | null,
    isDemo?: boolean | null,
    dismissedProTips?: Array< string | null > | null,
    phoneNumber?: string | null,
    joinedDate?: string | null,
    level?: number | null,
    capacityPercent?: number | null,
    supportedDoctors?:  {
      __typename: "ModelDoctorSupportingMAConnection",
      items:  Array< {
        __typename: "DoctorSupportingMA",
        id: string,
        medicalAssistantId: string,
        doctorId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    supportedSpecialtyCategories?:  {
      __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
      items:  Array< {
        __typename: "MedicalAssistantSpecialtyCategory",
        id: string,
        medicalAssistantId: string,
        specialtyCategoryId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        specialtyCategory:  {
          __typename: "SpecialtyCategory",
          id: string,
          name: string,
          specialties?: Array< SpecialtyType > | null,
          createdAt: string,
          updatedAt: string,
          specialtyCategoryFallbackMAId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    availabilityExceptions?:  Array< {
      __typename: "AvailabilityException",
      type: AvailabilityExceptionType,
      during?:  {
        __typename: "DateRange",
        start?: string | null,
        end?: string | null,
      } | null,
      startTime?: string | null,
      endTime?: string | null,
      allDay?: boolean | null,
    } | null > | null,
    roles?: Array< OpsRole > | null,
    createdAt: string,
    updatedAt: string,
    medicalAssistantUserId?: string | null,
  } | null,
};

export type ListMedicalAssistantsQueryVariables = {
  filter?: ModelMedicalAssistantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMedicalAssistantsQuery = {
  listMedicalAssistants?:  {
    __typename: "ModelMedicalAssistantConnection",
    items:  Array< {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    cognitoUserId: string,
    avatarUrl?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    doctor?:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null,
    assistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    appointmentFilterPreset?:  {
      __typename: "ModelUserAppointmentFilterPresetConnection",
      items:  Array< {
        __typename: "UserAppointmentFilterPreset",
        id: string,
        userId: string,
        appointmentFilterPresetId: string,
        user:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        },
        appointmentFilterPreset:  {
          __typename: "AppointmentFilterPreset",
          id: string,
          name: string,
          appliesTo: UserGroup,
          view?: AppointmentsView | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    onboardingDismissals?:  Array< {
      __typename: "OnboardingDismissal",
      itemId: string,
      dismissedAt: string,
    } | null > | null,
    settings?:  {
      __typename: "UserSettings",
      opsChecklistDefaultExpanded?: boolean | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    userDoctorId?: string | null,
    userAssistantId?: string | null,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByCognitoUserIdQueryVariables = {
  cognitoUserId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsersByCognitoUserIdQuery = {
  usersByCognitoUserId?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStoredAddressQueryVariables = {
  id: string,
};

export type GetStoredAddressQuery = {
  getStoredAddress?:  {
    __typename: "StoredAddress",
    id: string,
    street?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: string | null,
    insuranceCarrierID?: string | null,
    lawFirmID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListStoredAddressesQueryVariables = {
  filter?: ModelStoredAddressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStoredAddressesQuery = {
  listStoredAddresses?:  {
    __typename: "ModelStoredAddressConnection",
    items:  Array< {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type StoredAddressesByInsuranceCarrierIDQueryVariables = {
  insuranceCarrierID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStoredAddressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type StoredAddressesByInsuranceCarrierIDQuery = {
  storedAddressesByInsuranceCarrierID?:  {
    __typename: "ModelStoredAddressConnection",
    items:  Array< {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type StoredAddressesByLawFirmIDQueryVariables = {
  lawFirmID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStoredAddressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type StoredAddressesByLawFirmIDQuery = {
  storedAddressesByLawFirmID?:  {
    __typename: "ModelStoredAddressConnection",
    items:  Array< {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStoredFaxNumberQueryVariables = {
  id: string,
};

export type GetStoredFaxNumberQuery = {
  getStoredFaxNumber?:  {
    __typename: "StoredFaxNumber",
    id: string,
    faxNumber?: string | null,
    insuranceCarrierID?: string | null,
    lawFirmID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListStoredFaxNumbersQueryVariables = {
  filter?: ModelStoredFaxNumberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStoredFaxNumbersQuery = {
  listStoredFaxNumbers?:  {
    __typename: "ModelStoredFaxNumberConnection",
    items:  Array< {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type StoredFaxNumbersByInsuranceCarrierIDQueryVariables = {
  insuranceCarrierID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStoredFaxNumberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type StoredFaxNumbersByInsuranceCarrierIDQuery = {
  storedFaxNumbersByInsuranceCarrierID?:  {
    __typename: "ModelStoredFaxNumberConnection",
    items:  Array< {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type StoredFaxNumbersByLawFirmIDQueryVariables = {
  lawFirmID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStoredFaxNumberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type StoredFaxNumbersByLawFirmIDQuery = {
  storedFaxNumbersByLawFirmID?:  {
    __typename: "ModelStoredFaxNumberConnection",
    items:  Array< {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStoredPhoneNumberQueryVariables = {
  id: string,
};

export type GetStoredPhoneNumberQuery = {
  getStoredPhoneNumber?:  {
    __typename: "StoredPhoneNumber",
    id: string,
    phoneNumber?: string | null,
    extension?: string | null,
    insuranceCarrierID?: string | null,
    lawFirmID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListStoredPhoneNumbersQueryVariables = {
  filter?: ModelStoredPhoneNumberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStoredPhoneNumbersQuery = {
  listStoredPhoneNumbers?:  {
    __typename: "ModelStoredPhoneNumberConnection",
    items:  Array< {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type StoredPhoneNumbersByInsuranceCarrierIDQueryVariables = {
  insuranceCarrierID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStoredPhoneNumberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type StoredPhoneNumbersByInsuranceCarrierIDQuery = {
  storedPhoneNumbersByInsuranceCarrierID?:  {
    __typename: "ModelStoredPhoneNumberConnection",
    items:  Array< {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type StoredPhoneNumbersByLawFirmIDQueryVariables = {
  lawFirmID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStoredPhoneNumberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type StoredPhoneNumbersByLawFirmIDQuery = {
  storedPhoneNumbersByLawFirmID?:  {
    __typename: "ModelStoredPhoneNumberConnection",
    items:  Array< {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFaxJobQueryVariables = {
  id: string,
};

export type GetFaxJobQuery = {
  getFaxJob?:  {
    __typename: "FaxJob",
    id: string,
    appointmentID: string,
    uploadedFileID: string,
    recipientParty: FaxRecipientParty,
    recipientEntityID?: string | null,
    faxNumber: string,
    iFaxJobId?: string | null,
    status: FaxJobStatus,
    failureCode?: string | null,
    failureMessage?: string | null,
    submittedAt: string,
    completedAt?: string | null,
    submittedByUserID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFaxJobsQueryVariables = {
  filter?: ModelFaxJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFaxJobsQuery = {
  listFaxJobs?:  {
    __typename: "ModelFaxJobConnection",
    items:  Array< {
      __typename: "FaxJob",
      id: string,
      appointmentID: string,
      uploadedFileID: string,
      recipientParty: FaxRecipientParty,
      recipientEntityID?: string | null,
      faxNumber: string,
      iFaxJobId?: string | null,
      status: FaxJobStatus,
      failureCode?: string | null,
      failureMessage?: string | null,
      submittedAt: string,
      completedAt?: string | null,
      submittedByUserID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FaxJobsByAppointmentQueryVariables = {
  appointmentID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFaxJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FaxJobsByAppointmentQuery = {
  faxJobsByAppointment?:  {
    __typename: "ModelFaxJobConnection",
    items:  Array< {
      __typename: "FaxJob",
      id: string,
      appointmentID: string,
      uploadedFileID: string,
      recipientParty: FaxRecipientParty,
      recipientEntityID?: string | null,
      faxNumber: string,
      iFaxJobId?: string | null,
      status: FaxJobStatus,
      failureCode?: string | null,
      failureMessage?: string | null,
      submittedAt: string,
      completedAt?: string | null,
      submittedByUserID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FaxJobsByUploadedFileQueryVariables = {
  uploadedFileID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFaxJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FaxJobsByUploadedFileQuery = {
  faxJobsByUploadedFile?:  {
    __typename: "ModelFaxJobConnection",
    items:  Array< {
      __typename: "FaxJob",
      id: string,
      appointmentID: string,
      uploadedFileID: string,
      recipientParty: FaxRecipientParty,
      recipientEntityID?: string | null,
      faxNumber: string,
      iFaxJobId?: string | null,
      status: FaxJobStatus,
      failureCode?: string | null,
      failureMessage?: string | null,
      submittedAt: string,
      completedAt?: string | null,
      submittedByUserID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FaxJobsByIFaxJobIdQueryVariables = {
  iFaxJobId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFaxJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FaxJobsByIFaxJobIdQuery = {
  faxJobsByIFaxJobId?:  {
    __typename: "ModelFaxJobConnection",
    items:  Array< {
      __typename: "FaxJob",
      id: string,
      appointmentID: string,
      uploadedFileID: string,
      recipientParty: FaxRecipientParty,
      recipientEntityID?: string | null,
      faxNumber: string,
      iFaxJobId?: string | null,
      status: FaxJobStatus,
      failureCode?: string | null,
      failureMessage?: string | null,
      submittedAt: string,
      completedAt?: string | null,
      submittedByUserID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FaxJobsBySubmitterQueryVariables = {
  submittedByUserID: string,
  submittedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFaxJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FaxJobsBySubmitterQuery = {
  faxJobsBySubmitter?:  {
    __typename: "ModelFaxJobConnection",
    items:  Array< {
      __typename: "FaxJob",
      id: string,
      appointmentID: string,
      uploadedFileID: string,
      recipientParty: FaxRecipientParty,
      recipientEntityID?: string | null,
      faxNumber: string,
      iFaxJobId?: string | null,
      status: FaxJobStatus,
      failureCode?: string | null,
      failureMessage?: string | null,
      submittedAt: string,
      completedAt?: string | null,
      submittedByUserID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetN110PartyDeliveryQueryVariables = {
  id: string,
};

export type GetN110PartyDeliveryQuery = {
  getN110PartyDelivery?:  {
    __typename: "N110PartyDelivery",
    id: string,
    appointmentID: string,
    uploadedFileID?: string | null,
    party: N110ServiceParty,
    status: N110UploadStatus,
    reason: N110MailReason,
    driveFileID?: string | null,
    uploadedAt?: string | null,
    submittedByUserID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListN110PartyDeliveriesQueryVariables = {
  filter?: ModelN110PartyDeliveryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListN110PartyDeliveriesQuery = {
  listN110PartyDeliveries?:  {
    __typename: "ModelN110PartyDeliveryConnection",
    items:  Array< {
      __typename: "N110PartyDelivery",
      id: string,
      appointmentID: string,
      uploadedFileID?: string | null,
      party: N110ServiceParty,
      status: N110UploadStatus,
      reason: N110MailReason,
      driveFileID?: string | null,
      uploadedAt?: string | null,
      submittedByUserID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type N110PartyDeliveriesByAppointmentQueryVariables = {
  appointmentID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelN110PartyDeliveryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type N110PartyDeliveriesByAppointmentQuery = {
  n110PartyDeliveriesByAppointment?:  {
    __typename: "ModelN110PartyDeliveryConnection",
    items:  Array< {
      __typename: "N110PartyDelivery",
      id: string,
      appointmentID: string,
      uploadedFileID?: string | null,
      party: N110ServiceParty,
      status: N110UploadStatus,
      reason: N110MailReason,
      driveFileID?: string | null,
      uploadedAt?: string | null,
      submittedByUserID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type N110PartyDeliveriesBySubmitterQueryVariables = {
  submittedByUserID: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelN110PartyDeliveryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type N110PartyDeliveriesBySubmitterQuery = {
  n110PartyDeliveriesBySubmitter?:  {
    __typename: "ModelN110PartyDeliveryConnection",
    items:  Array< {
      __typename: "N110PartyDelivery",
      id: string,
      appointmentID: string,
      uploadedFileID?: string | null,
      party: N110ServiceParty,
      status: N110UploadStatus,
      reason: N110MailReason,
      driveFileID?: string | null,
      uploadedAt?: string | null,
      submittedByUserID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetInsuranceCarrierQueryVariables = {
  id: string,
};

export type GetInsuranceCarrierQuery = {
  getInsuranceCarrier?:  {
    __typename: "InsuranceCarrier",
    id: string,
    name: string,
    defaultAddressID?: string | null,
    defaultAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    addresses?:  {
      __typename: "ModelStoredAddressConnection",
      items:  Array< {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultFaxNumberID?: string | null,
    defaultFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    faxNumbers?:  {
      __typename: "ModelStoredFaxNumberConnection",
      items:  Array< {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultPhoneNumberID?: string | null,
    defaultPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    phoneNumbers?:  {
      __typename: "ModelStoredPhoneNumberConnection",
      items:  Array< {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultEmail?: string | null,
    supportedDomains?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListInsuranceCarriersQueryVariables = {
  filter?: ModelInsuranceCarrierFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInsuranceCarriersQuery = {
  listInsuranceCarriers?:  {
    __typename: "ModelInsuranceCarrierConnection",
    items:  Array< {
      __typename: "InsuranceCarrier",
      id: string,
      name: string,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLawFirmQueryVariables = {
  id: string,
};

export type GetLawFirmQuery = {
  getLawFirm?:  {
    __typename: "LawFirm",
    id: string,
    name: string,
    type: LawFirmType,
    defaultAddressID?: string | null,
    defaultAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    addresses?:  {
      __typename: "ModelStoredAddressConnection",
      items:  Array< {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultFaxNumberID?: string | null,
    defaultFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    faxNumbers?:  {
      __typename: "ModelStoredFaxNumberConnection",
      items:  Array< {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultPhoneNumberID?: string | null,
    defaultPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    phoneNumbers?:  {
      __typename: "ModelStoredPhoneNumberConnection",
      items:  Array< {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultEmail?: string | null,
    supportedDomains?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLawFirmsQueryVariables = {
  filter?: ModelLawFirmFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLawFirmsQuery = {
  listLawFirms?:  {
    __typename: "ModelLawFirmConnection",
    items:  Array< {
      __typename: "LawFirm",
      id: string,
      name: string,
      type: LawFirmType,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type LawFirmsByTypeQueryVariables = {
  type: LawFirmType,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLawFirmFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type LawFirmsByTypeQuery = {
  lawFirmsByType?:  {
    __typename: "ModelLawFirmConnection",
    items:  Array< {
      __typename: "LawFirm",
      id: string,
      name: string,
      type: LawFirmType,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetGlobalBillingCounterQueryVariables = {
  id: string,
};

export type GetGlobalBillingCounterQuery = {
  getGlobalBillingCounter?:  {
    __typename: "GlobalBillingCounter",
    id: string,
    count?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListGlobalBillingCountersQueryVariables = {
  filter?: ModelGlobalBillingCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGlobalBillingCountersQuery = {
  listGlobalBillingCounters?:  {
    __typename: "ModelGlobalBillingCounterConnection",
    items:  Array< {
      __typename: "GlobalBillingCounter",
      id: string,
      count?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCaseRecordQueryVariables = {
  id: string,
};

export type GetCaseRecordQuery = {
  getCaseRecord?:  {
    __typename: "CaseRecord",
    id: string,
    state?: CaseState | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCaseRecordsQueryVariables = {
  filter?: ModelCaseRecordFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCaseRecordsQuery = {
  listCaseRecords?:  {
    __typename: "ModelCaseRecordConnection",
    items:  Array< {
      __typename: "CaseRecord",
      id: string,
      state?: CaseState | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAppointmentRecordQueryVariables = {
  id: string,
};

export type GetAppointmentRecordQuery = {
  getAppointmentRecord?:  {
    __typename: "AppointmentRecord",
    id: string,
    doctorOwnerCognitoId?: string | null,
    assistantCognitoIds?: Array< string > | null,
    globalPartitionKey: string,
    originalAppointmentID: string,
    supplementalAppointmentIDs?: Array< string | null > | null,
    supplementalSourceAppointmentIDs?: Array< string | null > | null,
    depositionAppointmentIDs?: Array< string | null > | null,
    depositionSourceAppointmentIDs?: Array< string | null > | null,
    rescheduledFromAppointmentID?: string | null,
    rescheduledToAppointmentID?: string | null,
    date?: string | null,
    yearMonth?: string | null,
    doctorYearMonth?: string | null,
    time?: string | null,
    bookedInFlexibleTime?: boolean | null,
    inquiryDate: string,
    inquiryYearMonth: string,
    type?: AppointmentType | null,
    doctorID?: string | null,
    doctor?:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null,
    locationID?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    } | null,
    visitForm?: string | null,
    jotformSubmissions?:  Array< {
      __typename: "JotformSubmission",
      id: string,
      receivedAt: string,
      populatedAt?: string | null,
    } | null > | null,
    historyTranscriptPopulations?:  Array< {
      __typename: "HistoryTranscriptPopulation",
      uploadedFileID: string,
      populatedAt: string,
    } | null > | null,
    active?: boolean | null,
    durationMinutes?: number | null,
    reportDue?: string | null,
    reportSubmitted?: string | null,
    status?: AppointmentStatus | null,
    reportStatus?: ReportStatus | null,
    paymentStatus?: PaymentStatus | null,
    billingStatus?: BillingStatus | null,
    difficultyLevel?: number | null,
    scheduler?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    medicalAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    schedulingAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    onSiteOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    reportOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    billingOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    preVisitReviewer?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    inquirerInfo?:  {
      __typename: "InquirerInfo",
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      inquiringParty?: InquiringParty | null,
      name?: string | null,
      inquiryDate?: string | null,
      notification_110_required?: boolean | null,
    } | null,
    notes?:  {
      __typename: "ModelNotesConnection",
      items:  Array< {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    huddleNote?:  {
      __typename: "HuddleNote",
      id: string,
      appointmentRecordID: string,
      contentMarkdown?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    patientCases?:  {
      __typename: "ModelAppointmentRecordPatientCaseConnection",
      items:  Array< {
        __typename: "AppointmentRecordPatientCase",
        id: string,
        appointmentRecordId: string,
        patientCaseId: string,
        appointmentRecord:  {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        },
        patientCase:  {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    employments?:  Array< {
      __typename: "EmploymentRecord",
      employerName?: string | null,
      jobTitle?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      dateOfHire?: string | null,
      dateOfHireFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      hoursPerWeek?: string | null,
      jobDuties?: string | null,
      dateOfTermination?: string | null,
      dateOfTerminationFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
      stillWorkingHere?: boolean | null,
      type?: EmploymentType | null,
      currentWorkRestrictions?: string | null,
      workStatus?: string | null,
      departureReason?: string | null,
    } | null > | null,
    employmentGaps?:  Array< {
      __typename: "EmploymentGapRecord",
      type?: EmploymentGapType | null,
      startDate?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      endDate?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
    } | null > | null,
    patientDescribedInjuries?: Array< BodyPart | null > | null,
    uploadedFilesSet?:  {
      __typename: "UploadedFileSet",
      id: string,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      uploadedFiles?:  {
        __typename: "ModelUploadedFileConnection",
        items:  Array< {
          __typename: "UploadedFile",
          id: string,
          key?: string | null,
          fileName?: string | null,
          type?: FileType | null,
          provider?: FileProvider | null,
          uploadedBy?: string | null,
          uploadedAt?: string | null,
          fileSizeBytes?: number | null,
          fileSetID?: string | null,
          sourceAppointmentID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploadedFilesSetID?: string | null,
    referredBy?: string | null,
    s3FileKey?: string | null,
    medicalRecordsReceived?: boolean | null,
    medicalRecordsBriefingFileID?: string | null,
    medicalRecordsBriefingExecutionArn?: string | null,
    medicalRecordsTotalPagesProcessed?: number | null,
    reportGenerationFileID?: string | null,
    reportGenerationExecutionArn?: string | null,
    reportGenerationGeneratedAt?: string | null,
    historyOfInjuryFileID?: string | null,
    historyOfInjuryGeneratedAt?: string | null,
    evaluationFileID?: string | null,
    assessmentFileID?: string | null,
    depositionPreparationFileID?: string | null,
    documentStatus?:  {
      __typename: "DocumentStatus",
      evaluationPublished?: boolean | null,
      assessmentPublished?: boolean | null,
      historyInProgress?: boolean | null,
      historyPublished?: boolean | null,
      historyCleaned?: boolean | null,
      reportPublished?: boolean | null,
      briefingInProgress?: boolean | null,
      briefingPublished?: boolean | null,
      briefingCleaned?: boolean | null,
    } | null,
    cancellationReason?: CancellationReason | null,
    cancellationRequestedBy?: ParticipantType | null,
    cancellationRequestedInternally?: boolean | null,
    cancellationNote?: string | null,
    cancellationDate?: string | null,
    inquiryClosingReason?: InquiryClosingReason | null,
    inquiryClosingNote?: string | null,
    inquiryClosingDate?: string | null,
    noShowReason?: NoShowReason | null,
    noShowNote?: string | null,
    reschedulingReason?: ReschedulingReason | null,
    reschedulingOthersReason?: string | null,
    reschedulingRequestedBy?: ParticipantType | null,
    reschedulingRequestedInternally?: boolean | null,
    reschedulingNote?: string | null,
    reschedulingDate?: string | null,
    interpreter?:  {
      __typename: "InterpreterInfo",
      certificateId?: string | null,
      name?: string | null,
      companyName?: string | null,
      phoneNumber?: string | null,
      phoneExtension?: string | null,
      note?: string | null,
      confirmed?: boolean | null,
    } | null,
    historyOfInjuryNotes?:  {
      __typename: "Notes",
      id: string,
      content?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      type?: NotesType | null,
      timeStamp?: number | null,
      appointmentrecordID: string,
      createdAt: string,
      updatedAt: string,
      notesAuthorId?: string | null,
    } | null,
    currentComplaintNotes?:  {
      __typename: "Notes",
      id: string,
      content?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      type?: NotesType | null,
      timeStamp?: number | null,
      appointmentrecordID: string,
      createdAt: string,
      updatedAt: string,
      notesAuthorId?: string | null,
    } | null,
    historyCallDate?: string | null,
    historyCallTime?: string | null,
    historyCallAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    historyCallCompleted?: boolean | null,
    historyCallCompletedWithoutRecords?: boolean | null,
    historyCallCompletedOnSite?: boolean | null,
    historyCallNoShow?: boolean | null,
    historyCallCalendarEventID?: string | null,
    historyCallCalendarLink?: string | null,
    billingInfo?:  {
      __typename: "BillingInfo",
      diagnosisMappings?:  Array< {
        __typename: "DiagnosisMapping",
        code?: string | null,
        pointer?: string | null,
        description?: string | null,
      } | null > | null,
      serviceDetails?:  Array< {
        __typename: "ServiceDetail",
        dateOfStart?: string | null,
        dateOfEnd?: string | null,
        place?: number | null,
        emergencyIndicator?: boolean | null,
        serviceType?: ServiceType | null,
        modifiers?: Array< ServiceModifier | null > | null,
        diagnosisPointers?: Array< string | null > | null,
        chargedAmount?: number | null,
        quantity?: number | null,
        amountPaid?: number | null,
        renderingProviderId?: string | null,
      } | null > | null,
      totalCharge?: number | null,
      amountPaid?: number | null,
      billingCounter?: number | null,
      billedDate?: string | null,
      paidDate?: string | null,
      correctionDate?: string | null,
    } | null,
    caseInfo?:  {
      __typename: "CaseInfo",
      confirmationEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
      recordsFollowupEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
      attendanceEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
    } | null,
    isProd?: boolean | null,
    isDemo?: boolean | null,
    primaryPatientCaseID?: string | null,
    calendarEventID?: string | null,
    reportConfiguration?:  {
      __typename: "ReportConfiguration",
      history?: ReportSource | null,
      physicalExamination?: ReportSource | null,
      assessment?: ReportSource | null,
    } | null,
    workflowExecutions?:  {
      __typename: "ModelWorkflowExecutionConnection",
      items:  Array< {
        __typename: "WorkflowExecution",
        executionArn: string,
        appointmentRecordID: string,
        type?: WorkflowExecutionType | null,
        status?: WorkflowExecutionStatus | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    historyOfInjuryInsights?:  {
      __typename: "HistoryOfInjuryInsights",
      id: string,
      appointmentRecordID: string,
      mechanismOfInjury?: string | null,
      employerJobDescription?: string | null,
      injuryCausations?:  Array< {
        __typename: "InjuryCausationInfo",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryEnd?: string | null,
        bodyParts?: Array< BodyPart | null > | null,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
      } | null > | null,
      currentSymptoms?:  Array< {
        __typename: "Symptom",
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      priorSymptomsBeforeCurrentInjury?:  Array< {
        __typename: "Symptom",
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      previousSurgeries?:  Array< {
        __typename: "SurgeryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        type?: string | null,
      } | null > | null,
      previousWorkInjuries?:  Array< {
        __typename: "InjuryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      previousInjuries?:  Array< {
        __typename: "InjuryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      injuryEmploymentStatus?: string | null,
      currentWorkRestrictionsFromPatient?: string | null,
      activitiesOfDailyLiving?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reviewOfMedicalRecordsInsights?:  {
      __typename: "ReviewOfMedicalRecordsInsights",
      id: string,
      appointmentRecordID: string,
      latestDiagnosis?:  Array< {
        __typename: "BodyPartDiagnosis",
        bodyPart?: string | null,
        date?: string | null,
        descriptions?: Array< string | null > | null,
      } | null > | null,
      diagnosticStudies?:  Array< {
        __typename: "DiagnosticStudy",
        date?: string | null,
        typeOfStudy?: DiagnosticStudyType | null,
        bodyPart?: string | null,
        impression?: string | null,
        source?: DiagnosticStudySource | null,
      } | null > | null,
      treatments?:  Array< {
        __typename: "TreatmentWrapper",
        discreteTreatment?:  {
          __typename: "DiscreteTreatment",
          date?: string | null,
          treatmentType?: DiscreteTreatmentType | null,
          bodyPart?: string | null,
          description?: string | null,
        } | null,
        recurringTreatment?:  {
          __typename: "RecurringTreatment",
          year?: string | null,
          treatmentType?: RecurringTreatmentType | null,
          frequency?: string | null,
          description?: string | null,
        } | null,
      } | null > | null,
      currentWorkRestrictionsFromMedicalRecords?: string | null,
      previousReports?:  Array< {
        __typename: "PreviousReport",
        date?: string | null,
        reportType?: string | null,
        reportContent?: string | null,
      } | null > | null,
      durableMedicalEquipment?:  Array< {
        __typename: "DurableMedicalEquipment",
        startDate?: string | null,
        endDate?: string | null,
        bodyParts?: Array< string | null > | null,
        equipmentType?: string | null,
        description?: string | null,
      } | null > | null,
      derivedFromDocumentInsightIDs?: Array< string | null > | null,
      derivedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    physicalExamInsights?:  {
      __typename: "PhysicalExamInsights",
      id: string,
      appointmentRecordID: string,
      physicalExaminationInfo?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    pastInjuryMatrix?:  {
      __typename: "PastInjuryMatrix",
      id: string,
      appointmentRecordID: string,
      preExistingConditions: Array< string >,
      familyHistory: Array< string >,
      injuryMatrix:  Array< {
        __typename: "InjuryMatrixEntry",
        date: string,
        bodyPart: BodyPart,
        status: InjuryStatus,
      } >,
      createdAt: string,
      updatedAt: string,
    } | null,
    briefing?:  {
      __typename: "RecordBriefing",
      id: string,
      logicalBriefingID: string,
      segmentMappings?:  {
        __typename: "ModelRecordBriefingSegmentMappingConnection",
        items:  Array< {
          __typename: "RecordBriefingSegmentMapping",
          id: string,
          briefingID: string,
          logicalSegmentID: string,
          publishedSegmentID?: string | null,
          draftSegmentID?: string | null,
          markedForDeletion?: boolean | null,
          markedForCreation?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      googleDocExportLink?: string | null,
      googleDocExportedAt?: string | null,
      suggestionGeneration?:  {
        __typename: "SuggestionGenerationJob",
        status?: SuggestionGenerationStatus | null,
        jobId?: string | null,
        startedAt?: string | null,
        completedAt?: string | null,
        error?: string | null,
      } | null,
      editingPresence?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    introParagraph?:  {
      __typename: "IntroParagraph",
      id: string,
      appointmentRecordID: string,
      introParagraphText?: string | null,
      sourceRecaps?:  Array< {
        __typename: "CoverLetterRecapSnapshot",
        coverLetterRecapID: string,
        uploadedFileID: string,
        recapText: string,
        generatedAt?: string | null,
      } | null > | null,
      status: IntroParagraphStatus,
      errorMessage?: string | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    impairmentRatingResults?:  Array< {
      __typename: "ImpairmentRatingResult",
      ts?: number | null,
      bodyParts?: Array< string | null > | null,
      enabledStrictRating?: boolean | null,
      enabledPainRating?: boolean | null,
      enabledAG?: boolean | null,
      enabledStrengthRating?: boolean | null,
      enabledDBE?: boolean | null,
      autoMode?: boolean | null,
      result?: string | null,
      resultFeedback?:  {
        __typename: "ImpairmentRatingResultFeedback",
        exists?: boolean | null,
        isGood?: boolean | null,
        notes?: string | null,
      } | null,
    } | null > | null,
    defenseAttorneyPagesDeclaration?: number | null,
    applicantAttorneyPagesDeclaration?: number | null,
    fieldTemplateRef?:  {
      __typename: "FieldTemplateRef",
      id: string,
      version: number,
    } | null,
    dataFieldValuesMappings?:  Array< {
      __typename: "DataFieldValueMapping",
      dataFieldID?: string | null,
      value?: string | null,
    } | null > | null,
    physicalEvalTemplateRef?:  {
      __typename: "FieldTemplateRef",
      id: string,
      version: number,
    } | null,
    physicalExamValues?:  Array< {
      __typename: "PhysicalExamValue",
      sectionID: string,
      questionID: string,
      side?: PhysicalExamSide | null,
      value?: string | null,
      note?: string | null,
      excluded?: boolean | null,
    } | null > | null,
    physicalExamOtherFindings?:  Array< {
      __typename: "PhysicalExamOtherFinding",
      sectionID: string,
      text?: string | null,
    } | null > | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      injuries?:  Array< {
        __typename: "AssessmentInjury",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        dateOfInjuryEnd?: string | null,
        dateOfInjuryEndFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        bodyParts?: Array< BodyPart | null > | null,
        causeOfInjury?: string | null,
        causedByWork?: AssessmentCausationOption | null,
        causedByWorkExplanation?: string | null,
      } | null > | null,
      discussedBodyParts?: Array< BodyPart | null > | null,
      bodyPartsNotDiscussedReason?: string | null,
      discussions?: string | null,
      diagnoses?:  Array< {
        __typename: "AssessmentDiagnosis",
        diagnosis?: string | null,
        icdCode?: string | null,
        evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
        evidence?: string | null,
      } | null > | null,
      bodyPartMMIStatus?:  {
        __typename: "AssessmentBodyPartMMIStatus",
        discussByBodyPart?: boolean | null,
        allBodyPartsMMI?:  {
          __typename: "AssessmentBodyPartEvaluation",
          mmi?: boolean | null,
          mmiReason?: string | null,
          expectedMMITimeRange?: AssessmentMmiTimeRange | null,
          expectedMMITimeRangeExplanation?: string | null,
          treatments?: Array< string | null > | null,
          treatmentsExplanation?: string | null,
          discussions?: string | null,
          impairmentRating?: string | null,
          impairmentRatingNotApplicable?: boolean | null,
          deferImpairmentRating?: boolean | null,
          deferImpairmentRatingReason?: string | null,
          apportionment?: string | null,
          apportionmentNotApplicable?: boolean | null,
          deferApportionment?: boolean | null,
          deferApportionmentReason?: string | null,
        } | null,
        bodyPartMMIStatuses?:  Array< {
          __typename: "AssessmentBodyPart",
          bodyPart?: BodyPart | null,
        } | null > | null,
      } | null,
      workStatus?: string | null,
      markedAsDone?: boolean | null,
      discussDiagnosesFreeForm?: boolean | null,
      diagnosesFreeform?: string | null,
      discussCausationFreeForm?: boolean | null,
      causationFreeForm?: string | null,
      discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
      hasPatientReachedMMIFreeForm?: string | null,
      discussMMIByBodyPartFreeForm?: string | null,
      impairmentRatingByBodyPartFreeForm?: string | null,
      apportionmentByBodyPartFreeForm?: string | null,
      impairmentRatingOtherComments?: string | null,
      apportionmentOtherComments?: string | null,
      assessmentMode?: AssessmentMode | null,
      assessmentFreeForm?:  {
        __typename: "AssessmentFreeForm",
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussions?: string | null,
        diagnosesAndEvidence?: string | null,
        causation?: string | null,
        hasPatientReachedMMI?: string | null,
        discussMMIByBodyPart?: string | null,
        impairmentRatingByBodyPart?: string | null,
        apportionmentByBodyPart?: string | null,
        workStatus?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    opinionRecap?:  {
      __typename: "OpinionRecap",
      id: string,
      appointmentRecordID: string,
      causation?: string | null,
      diagnosis?: string | null,
      mmiFutureMedicalTreatment?: string | null,
      impairmentRating?: string | null,
      apportionment?: string | null,
      workStatus?: string | null,
      sourceReportFileID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
    featureFlags?:  Array< {
      __typename: "AppointmentFeatureConfig",
      featureFlagKey: string,
      enabled: boolean,
    } | null > | null,
    opsChecklist?:  {
      __typename: "OpsChecklist",
      panel?: OpsChecklistItemStatus | null,
      contact_info?: OpsChecklistItemStatus | null,
      all_parties?: OpsChecklistItemStatus | null,
      notice_110?: OpsChecklistItemStatus | null,
      cover_letter?: OpsChecklistItemStatus | null,
      record_review?: OpsChecklistItemStatus | null,
      history_call?: OpsChecklistItemStatus | null,
      history_of_injury?: OpsChecklistItemStatus | null,
      interpreter_info?: OpsChecklistItemStatus | null,
      jotform?: OpsChecklistItemStatus | null,
      deu_100?: OpsChecklistItemStatus | null,
      final_report?: OpsChecklistItemStatus | null,
    } | null,
    panelUnavailable?: boolean | null,
    panelSpecialty?: SpecialtyType | null,
    defenseAttorneyNotPresent?: boolean | null,
    applicantAttorneyNotPresent?: boolean | null,
    contactUnavailability?:  {
      __typename: "ParticipantContactUnavailability",
      patient?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      adjuster?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      applicantAttorney?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      defenseAttorney?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
    } | null,
    historyValidation?:  {
      __typename: "HistoryValidation",
      id: string,
      appointmentRecordID: string,
      status: HistoryValidationStatus,
      groups:  Array< {
        __typename: "HistoryValidationGroup",
        id: string,
        title: string,
        status: HistoryValidationGroupStatus,
        issues:  Array< {
          __typename: "HistoryValidationIssue",
          id: string,
          title: string,
          description?: string | null,
          patientInfoSection?: PatientInfoSection | null,
          issueType?: ValidationIssueType | null,
        } | null >,
      } | null >,
      validatedAt?: string | null,
      errorMessage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    patientHistoryValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    videoCallLink?: string | null,
    additionalTimeslots?:  Array< {
      __typename: "AdditionalTimeslot",
      date: string,
      time: string,
      locationID?: string | null,
    } | null > | null,
    mrrValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    historyMrrCrossValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseID?: string | null,
    briefingModelVersion?: BriefingModelVersion | null,
    briefingGdocExportLink?: string | null,
    briefingGdocExportedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    appointmentRecordMedicalAssistantId?: string | null,
    appointmentRecordSchedulingAssistantId?: string | null,
    appointmentRecordOnSiteOpId?: string | null,
    appointmentRecordReportOpId?: string | null,
    appointmentRecordBillingOpId?: string | null,
    appointmentRecordPreVisitReviewerId?: string | null,
    appointmentRecordHuddleNoteId?: string | null,
    appointmentRecordHistoryOfInjuryNotesId?: string | null,
    appointmentRecordCurrentComplaintNotesId?: string | null,
    appointmentRecordHistoryCallAssistantId?: string | null,
    appointmentRecordHistoryOfInjuryInsightsId?: string | null,
    appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
    appointmentRecordPhysicalExamInsightsId?: string | null,
    appointmentRecordPastInjuryMatrixId?: string | null,
    appointmentRecordBriefingId?: string | null,
    appointmentRecordIntroParagraphId?: string | null,
    appointmentRecordAssessmentId?: string | null,
    appointmentRecordAssessmentValidationId?: string | null,
    appointmentRecordOpinionRecapId?: string | null,
    appointmentRecordHistoryValidationId?: string | null,
    appointmentRecordPatientHistoryValidationId?: string | null,
    appointmentRecordMrrValidationId?: string | null,
    appointmentRecordHistoryMrrCrossValidationId?: string | null,
  } | null,
};

export type ListAppointmentRecordsQueryVariables = {
  filter?: ModelAppointmentRecordFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAppointmentRecordsQuery = {
  listAppointmentRecords?:  {
    __typename: "ModelAppointmentRecordConnection",
    items:  Array< {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentsByGlobalDateTimeQueryVariables = {
  globalPartitionKey: string,
  dateTime?: ModelAppointmentRecordByGlobalDateTimeCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentRecordFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentsByGlobalDateTimeQuery = {
  appointmentsByGlobalDateTime?:  {
    __typename: "ModelAppointmentRecordConnection",
    items:  Array< {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentsByGlobalInquiryDateQueryVariables = {
  globalPartitionKey: string,
  inquiryDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentRecordFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentsByGlobalInquiryDateQuery = {
  appointmentsByGlobalInquiryDate?:  {
    __typename: "ModelAppointmentRecordConnection",
    items:  Array< {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentsByGlobalReportDueQueryVariables = {
  globalPartitionKey: string,
  reportDue?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentRecordFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentsByGlobalReportDueQuery = {
  appointmentsByGlobalReportDue?:  {
    __typename: "ModelAppointmentRecordConnection",
    items:  Array< {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentRecordsByOriginalAppointmentIDQueryVariables = {
  originalAppointmentID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentRecordFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentRecordsByOriginalAppointmentIDQuery = {
  appointmentRecordsByOriginalAppointmentID?:  {
    __typename: "ModelAppointmentRecordConnection",
    items:  Array< {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentsByInquiryYearMonthQueryVariables = {
  inquiryYearMonth: string,
  inquiryDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentRecordFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentsByInquiryYearMonthQuery = {
  appointmentsByInquiryYearMonth?:  {
    __typename: "ModelAppointmentRecordConnection",
    items:  Array< {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentRecordsByDoctorIDAndDateAndTimeQueryVariables = {
  doctorID: string,
  dateTime?: ModelAppointmentRecordByDoctorCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentRecordFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentRecordsByDoctorIDAndDateAndTimeQuery = {
  appointmentRecordsByDoctorIDAndDateAndTime?:  {
    __typename: "ModelAppointmentRecordConnection",
    items:  Array< {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentRecordsByLocationIDAndDateAndTimeQueryVariables = {
  locationID: string,
  dateTime?: ModelAppointmentRecordByLocationCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentRecordFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentRecordsByLocationIDAndDateAndTimeQuery = {
  appointmentRecordsByLocationIDAndDateAndTime?:  {
    __typename: "ModelAppointmentRecordConnection",
    items:  Array< {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentRecordsByUploadedFilesSetIDQueryVariables = {
  uploadedFilesSetID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentRecordFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentRecordsByUploadedFilesSetIDQuery = {
  appointmentRecordsByUploadedFilesSetID?:  {
    __typename: "ModelAppointmentRecordConnection",
    items:  Array< {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentsByCaseQueryVariables = {
  caseID: string,
  dateTime?: ModelAppointmentRecordByCaseCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentRecordFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentsByCaseQuery = {
  appointmentsByCase?:  {
    __typename: "ModelAppointmentRecordConnection",
    items:  Array< {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPatientQueryVariables = {
  id: string,
};

export type GetPatientQuery = {
  getPatient?:  {
    __typename: "Patient",
    id: string,
    name?: string | null,
    dateOfBirth?: string | null,
    SSN?: string | null,
    language?: Language | null,
    dominantHand?: DominantHand | null,
    cases?:  {
      __typename: "ModelPatientCaseConnection",
      items:  Array< {
        __typename: "PatientCase",
        id: string,
        patientID: string,
        patient?:  {
          __typename: "Patient",
          id: string,
          name?: string | null,
          dateOfBirth?: string | null,
          SSN?: string | null,
          language?: Language | null,
          dominantHand?: DominantHand | null,
          occupation?: string | null,
          sex?: Sex | null,
          weightLb?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        claimNumber: string,
        qmePanelNumber?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        injuryInfo?:  {
          __typename: "InjuryInfo",
          injuryType?: InjuryType | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          claimedBodyParts?: Array< BodyPart | null > | null,
          description?: string | null,
          dateOfInjury?: string | null,
          startDateOfInjury?: string | null,
        } | null,
        workersCompInsurance?:  {
          __typename: "WorkersCompInsuranceInfo",
          insuranceCarrier?: string | null,
          adjuster?: string | null,
        } | null,
        insuranceCarrierID?: string | null,
        insuranceCarrier?:  {
          __typename: "InsuranceCarrier",
          id: string,
          name: string,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierAddressID?: string | null,
        insuranceCarrierAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierFaxNumberID?: string | null,
        insuranceCarrierFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierPhoneNumberID?: string | null,
        insuranceCarrierPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        applicantAttorney?:  {
          __typename: "AttorneyInfo",
          name?: string | null,
          lawFirmName?: string | null,
        } | null,
        applicantAttorneyLawFirmID?: string | null,
        applicantAttorneyLawFirm?:  {
          __typename: "LawFirm",
          id: string,
          name: string,
          type: LawFirmType,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyAddressID?: string | null,
        applicantAttorneyAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyFaxNumberID?: string | null,
        applicantAttorneyFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyPhoneNumberID?: string | null,
        applicantAttorneyPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorney?:  {
          __typename: "AttorneyInfo",
          name?: string | null,
          lawFirmName?: string | null,
        } | null,
        defenseAttorneyLawFirmID?: string | null,
        defenseAttorneyLawFirm?:  {
          __typename: "LawFirm",
          id: string,
          name: string,
          type: LawFirmType,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyAddressID?: string | null,
        defenseAttorneyAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyFaxNumberID?: string | null,
        defenseAttorneyFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyPhoneNumberID?: string | null,
        defenseAttorneyPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nurseCaseManager?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        ccPerson?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        applicantAttorneyCcEmails?: Array< string | null > | null,
        defenseAttorneyCcEmails?: Array< string | null > | null,
        adjusterCcEmails?: Array< string | null > | null,
        scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
        employmentAtInjury?:  {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null,
        WCAB?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    occupation?: string | null,
    sex?: Sex | null,
    weightLb?: number | null,
    height?:  {
      __typename: "Height",
      feet?: number | null,
      inches?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPatientsQueryVariables = {
  filter?: ModelPatientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPatientsQuery = {
  listPatients?:  {
    __typename: "ModelPatientConnection",
    items:  Array< {
      __typename: "Patient",
      id: string,
      name?: string | null,
      dateOfBirth?: string | null,
      SSN?: string | null,
      language?: Language | null,
      dominantHand?: DominantHand | null,
      cases?:  {
        __typename: "ModelPatientCaseConnection",
        items:  Array< {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      occupation?: string | null,
      sex?: Sex | null,
      weightLb?: number | null,
      height?:  {
        __typename: "Height",
        feet?: number | null,
        inches?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPatientCaseQueryVariables = {
  id: string,
};

export type GetPatientCaseQuery = {
  getPatientCase?:  {
    __typename: "PatientCase",
    id: string,
    patientID: string,
    patient?:  {
      __typename: "Patient",
      id: string,
      name?: string | null,
      dateOfBirth?: string | null,
      SSN?: string | null,
      language?: Language | null,
      dominantHand?: DominantHand | null,
      cases?:  {
        __typename: "ModelPatientCaseConnection",
        items:  Array< {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      occupation?: string | null,
      sex?: Sex | null,
      weightLb?: number | null,
      height?:  {
        __typename: "Height",
        feet?: number | null,
        inches?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    claimNumber: string,
    qmePanelNumber?: string | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    injuryInfo?:  {
      __typename: "InjuryInfo",
      injuryType?: InjuryType | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      claimedBodyParts?: Array< BodyPart | null > | null,
      description?: string | null,
      dateOfInjury?: string | null,
      dateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      startDateOfInjury?: string | null,
      startDateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
    } | null,
    workersCompInsurance?:  {
      __typename: "WorkersCompInsuranceInfo",
      insuranceCarrier?: string | null,
      adjuster?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    insuranceCarrierID?: string | null,
    insuranceCarrier?:  {
      __typename: "InsuranceCarrier",
      id: string,
      name: string,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierAddressID?: string | null,
    insuranceCarrierAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierFaxNumberID?: string | null,
    insuranceCarrierFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierPhoneNumberID?: string | null,
    insuranceCarrierPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordPatientCaseConnection",
      items:  Array< {
        __typename: "AppointmentRecordPatientCase",
        id: string,
        appointmentRecordId: string,
        patientCaseId: string,
        appointmentRecord:  {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        },
        patientCase:  {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    applicantAttorney?:  {
      __typename: "AttorneyInfo",
      name?: string | null,
      lawFirmName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    applicantAttorneyLawFirmID?: string | null,
    applicantAttorneyLawFirm?:  {
      __typename: "LawFirm",
      id: string,
      name: string,
      type: LawFirmType,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyAddressID?: string | null,
    applicantAttorneyAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyFaxNumberID?: string | null,
    applicantAttorneyFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyPhoneNumberID?: string | null,
    applicantAttorneyPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorney?:  {
      __typename: "AttorneyInfo",
      name?: string | null,
      lawFirmName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    defenseAttorneyLawFirmID?: string | null,
    defenseAttorneyLawFirm?:  {
      __typename: "LawFirm",
      id: string,
      name: string,
      type: LawFirmType,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyAddressID?: string | null,
    defenseAttorneyAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyFaxNumberID?: string | null,
    defenseAttorneyFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyPhoneNumberID?: string | null,
    defenseAttorneyPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nurseCaseManager?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    ccPerson?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    applicantAttorneyCcEmails?: Array< string | null > | null,
    defenseAttorneyCcEmails?: Array< string | null > | null,
    adjusterCcEmails?: Array< string | null > | null,
    scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
    employmentAtInjury?:  {
      __typename: "EmploymentRecord",
      employerName?: string | null,
      jobTitle?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      dateOfHire?: string | null,
      dateOfHireFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      hoursPerWeek?: string | null,
      jobDuties?: string | null,
      dateOfTermination?: string | null,
      dateOfTerminationFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
      stillWorkingHere?: boolean | null,
      type?: EmploymentType | null,
      currentWorkRestrictions?: string | null,
      workStatus?: string | null,
      departureReason?: string | null,
    } | null,
    WCAB?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPatientCasesQueryVariables = {
  filter?: ModelPatientCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPatientCasesQuery = {
  listPatientCases?:  {
    __typename: "ModelPatientCaseConnection",
    items:  Array< {
      __typename: "PatientCase",
      id: string,
      patientID: string,
      patient?:  {
        __typename: "Patient",
        id: string,
        name?: string | null,
        dateOfBirth?: string | null,
        SSN?: string | null,
        language?: Language | null,
        dominantHand?: DominantHand | null,
        cases?:  {
          __typename: "ModelPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        occupation?: string | null,
        sex?: Sex | null,
        weightLb?: number | null,
        height?:  {
          __typename: "Height",
          feet?: number | null,
          inches?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      claimNumber: string,
      qmePanelNumber?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      injuryInfo?:  {
        __typename: "InjuryInfo",
        injuryType?: InjuryType | null,
        injuredBodyParts?: Array< BodyPart | null > | null,
        claimedBodyParts?: Array< BodyPart | null > | null,
        description?: string | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        startDateOfInjury?: string | null,
        startDateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
      } | null,
      workersCompInsurance?:  {
        __typename: "WorkersCompInsuranceInfo",
        insuranceCarrier?: string | null,
        adjuster?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      insuranceCarrierID?: string | null,
      insuranceCarrier?:  {
        __typename: "InsuranceCarrier",
        id: string,
        name: string,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierAddressID?: string | null,
      insuranceCarrierAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierFaxNumberID?: string | null,
      insuranceCarrierFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierPhoneNumberID?: string | null,
      insuranceCarrierPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      applicantAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyLawFirmID?: string | null,
      applicantAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyAddressID?: string | null,
      applicantAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyFaxNumberID?: string | null,
      applicantAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyPhoneNumberID?: string | null,
      applicantAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      defenseAttorneyLawFirmID?: string | null,
      defenseAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyAddressID?: string | null,
      defenseAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyFaxNumberID?: string | null,
      defenseAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyPhoneNumberID?: string | null,
      defenseAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nurseCaseManager?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      ccPerson?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyCcEmails?: Array< string | null > | null,
      defenseAttorneyCcEmails?: Array< string | null > | null,
      adjusterCcEmails?: Array< string | null > | null,
      scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
      employmentAtInjury?:  {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null,
      WCAB?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PatientCasesByPatientIDQueryVariables = {
  patientID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPatientCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PatientCasesByPatientIDQuery = {
  patientCasesByPatientID?:  {
    __typename: "ModelPatientCaseConnection",
    items:  Array< {
      __typename: "PatientCase",
      id: string,
      patientID: string,
      patient?:  {
        __typename: "Patient",
        id: string,
        name?: string | null,
        dateOfBirth?: string | null,
        SSN?: string | null,
        language?: Language | null,
        dominantHand?: DominantHand | null,
        cases?:  {
          __typename: "ModelPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        occupation?: string | null,
        sex?: Sex | null,
        weightLb?: number | null,
        height?:  {
          __typename: "Height",
          feet?: number | null,
          inches?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      claimNumber: string,
      qmePanelNumber?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      injuryInfo?:  {
        __typename: "InjuryInfo",
        injuryType?: InjuryType | null,
        injuredBodyParts?: Array< BodyPart | null > | null,
        claimedBodyParts?: Array< BodyPart | null > | null,
        description?: string | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        startDateOfInjury?: string | null,
        startDateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
      } | null,
      workersCompInsurance?:  {
        __typename: "WorkersCompInsuranceInfo",
        insuranceCarrier?: string | null,
        adjuster?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      insuranceCarrierID?: string | null,
      insuranceCarrier?:  {
        __typename: "InsuranceCarrier",
        id: string,
        name: string,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierAddressID?: string | null,
      insuranceCarrierAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierFaxNumberID?: string | null,
      insuranceCarrierFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierPhoneNumberID?: string | null,
      insuranceCarrierPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      applicantAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyLawFirmID?: string | null,
      applicantAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyAddressID?: string | null,
      applicantAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyFaxNumberID?: string | null,
      applicantAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyPhoneNumberID?: string | null,
      applicantAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      defenseAttorneyLawFirmID?: string | null,
      defenseAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyAddressID?: string | null,
      defenseAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyFaxNumberID?: string | null,
      defenseAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyPhoneNumberID?: string | null,
      defenseAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nurseCaseManager?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      ccPerson?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyCcEmails?: Array< string | null > | null,
      defenseAttorneyCcEmails?: Array< string | null > | null,
      adjusterCcEmails?: Array< string | null > | null,
      scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
      employmentAtInjury?:  {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null,
      WCAB?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDoctorQueryVariables = {
  id: string,
};

export type GetDoctorQuery = {
  getDoctor?:  {
    __typename: "Doctor",
    id: string,
    ownerCognitoId?: string | null,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    name?: string | null,
    signatureName?: string | null,
    status?: DoctorStatus | null,
    ramped?: boolean | null,
    title?: string | null,
    titleExtension?: TitleExtension | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    officePhone?: string | null,
    cellPhone?: string | null,
    clinicPhone?: string | null,
    workCity?: string | null,
    workState?: string | null,
    collectionRate?: number | null,
    licenseNumber?: string | null,
    licenseRenewalDate?: string | null,
    qmeLicense?:  {
      __typename: "QmeLicense",
      licenseNumber?: string | null,
      approvalDate?: string | null,
      renewalDate?: string | null,
    } | null,
    locations?:  {
      __typename: "ModelDoctorLocationConnection",
      items:  Array< {
        __typename: "DoctorLocation",
        id: string,
        doctorId: string,
        locationId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        location:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    specialties?: Array< SpecialtyType | null > | null,
    npi?: string | null,
    bankingInfo?:  {
      __typename: "BankingInfo",
      bankEntityName?: string | null,
      accountNumber?: string | null,
      routingNumber?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    availabilities?:  {
      __typename: "Availabilities",
      generalAvailabilities?:  Array< {
        __typename: "GeneralAvailability",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        recurrence?: RecurrenceType | null,
        dayOfWeek?: DayOfWeek | null,
        dayOfMonth?: number | null,
        weekOfMonth?: WeekOfMonth | null,
        monthInterval?: number | null,
        startTime?: string | null,
        endTime?: string | null,
        flexibleTimeBefore?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        flexibleTimeAfter?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        locationIDs?: Array< string | null > | null,
        isAllLocations?: boolean | null,
      } | null > | null,
      additionalAvailabilities?:  Array< {
        __typename: "AdditionalAvailability",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        flexibleTimeBefore?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        flexibleTimeAfter?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        locationIDs?: Array< string | null > | null,
        isAllLocations?: boolean | null,
      } | null > | null,
      blackoutDates?:  Array< {
        __typename: "BlackoutDate",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
    } | null,
    availabilitiesNote?: string | null,
    emails?: Array< string | null > | null,
    profileImages?:  Array< {
      __typename: "DoctorProfileImage",
      type?: DoctorProfileImageType | null,
      name?: string | null,
      order?: number | null,
      s3Prefix?: string | null,
      widthInInches?: number | null,
      heightInInches?: number | null,
    } | null > | null,
    qmeReportConfigs?:  {
      __typename: "DoctorQMEReportConfigs",
      hasIntroTitle?: boolean | null,
      introTemplate?: string | null,
    } | null,
    physicalEvalConfigs?:  {
      __typename: "DoctorPhysicalEvalConfigs",
      templates?: Array< PhysicalEvalTemplateTag | null > | null,
    } | null,
    signatureDepartment?: string | null,
    profileAssetS3Prefix?: string | null,
    calendarPreference?:  {
      __typename: "CalendarPreference",
      mailingList?: Array< string | null > | null,
      showPatientFullName?: boolean | null,
      showPatientAddress?: boolean | null,
      showPatientDOB?: boolean | null,
      showPortalLink?: boolean | null,
    } | null,
    homeOffice?:  {
      __typename: "HomeOffice",
      county?: string | null,
      state?: string | null,
    } | null,
    reportFormatPreferences?:  {
      __typename: "ReportFormatPreferences",
      evaluationReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
      reEvaluationReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
      supplementalReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
    } | null,
    evaluationInputPreferences?:  {
      __typename: "EvaluationInputPreferences",
      evaluationReport:  {
        __typename: "ReportInputPreferences",
        history: ReportSource,
        physicalExamination: ReportSource,
        assessment: ReportSource,
      },
      reEvaluationReport:  {
        __typename: "ReportInputPreferences",
        history: ReportSource,
        physicalExamination: ReportSource,
        assessment: ReportSource,
      },
      supplementalReport:  {
        __typename: "SupplementalReportInputPreferences",
        assessment: ReportSource,
      },
    } | null,
    preferredAssessmentMode?: AssessmentMode | null,
    caseSummaryFields?:  {
      __typename: "ModelDoctorCaseSummaryFieldConnection",
      items:  Array< {
        __typename: "DoctorCaseSummaryField",
        id: string,
        doctorId: string,
        caseSummaryFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        caseSummaryField:  {
          __typename: "CaseSummaryField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          summaryPrompt?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    briefingFields?:  {
      __typename: "ModelDoctorBriefingFieldConnection",
      items:  Array< {
        __typename: "DoctorBriefingField",
        id: string,
        doctorId: string,
        briefingFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        briefingField:  {
          __typename: "BriefingField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          briefingPrompt?: string | null,
          briefingRecordTypeID: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    isDemo?: boolean | null,
    fieldTemplateId?: string | null,
    templateFolderLink?: string | null,
    physicianPartner?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultPrimaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultSecondaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultScheduler?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultReportOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultPreVisitReviewer?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultBillingOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultSupplementalReportOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    supplementalReportOpsAssignments?:  Array< {
      __typename: "SupplementalReportOpsAssignment",
      medicalAssistantID: string,
      weightPercentage: number,
    } | null > | null,
    supportingMAs?:  {
      __typename: "ModelDoctorSupportingMAConnection",
      items:  Array< {
        __typename: "DoctorSupportingMA",
        id: string,
        medicalAssistantId: string,
        doctorId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultAppointmentDurationMinutes?:  {
      __typename: "DefaultAppointmentDurationMinutes",
      qme?: number | null,
      qmeReevaluation?: number | null,
      ime?: number | null,
      deposition?: number | null,
    } | null,
    defaultEarlyArrivalTimeMinutes?:  {
      __typename: "DefaultEarlyArrivalTimeMinutes",
      workersComp?: number | null,
      ime?: number | null,
      deposition?: number | null,
    } | null,
    assessmentTreatmentOptions?: Array< string | null > | null,
    dismissedProTips?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    doctorPhysicianPartnerId?: string | null,
    doctorDefaultPrimaryOnsiteOpsId?: string | null,
    doctorDefaultSecondaryOnsiteOpsId?: string | null,
    doctorDefaultSchedulerId?: string | null,
    doctorDefaultReportOpsId?: string | null,
    doctorDefaultPreVisitReviewerId?: string | null,
    doctorDefaultBillingOpsId?: string | null,
    doctorDefaultSupplementalReportOpsId?: string | null,
    doctorUserId?: string | null,
  } | null,
};

export type ListDoctorsQueryVariables = {
  filter?: ModelDoctorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDoctorsQuery = {
  listDoctors?:  {
    __typename: "ModelDoctorConnection",
    items:  Array< {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLocationQueryVariables = {
  id: string,
};

export type GetLocationQuery = {
  getLocation?:  {
    __typename: "Location",
    id: string,
    name?: string | null,
    abbreviation?: string | null,
    status?: LocationStatus | null,
    region?: Region | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      county?: string | null,
    } | null,
    indigoOfficePhoneNumber?: string | null,
    isWaitingArea?: boolean | null,
    additionalRoomsNumber?: number | null,
    landlordContactInfo?:  {
      __typename: "LocationLandlordContactInfo",
      name?: string | null,
      phone?: string | null,
      email?: string | null,
    } | null,
    calendarCcEmails?: Array< string | null > | null,
    isParkingFree?: boolean | null,
    parkingRate?: number | null,
    isFrontDoorLocked?: boolean | null,
    frontDoorCode?: string | null,
    backDoor?: BackDoorStatus | null,
    backDoorCode?: string | null,
    securityUnlockingProcess?: string | null,
    securityLockingProcess?: string | null,
    maleBathroomCode?: string | null,
    femaleBathroomCode?: string | null,
    wifiName?: string | null,
    wifiPassword?: string | null,
    defaultOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    secondaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    locationInstructionsForVisitor?: string | null,
    additionalNote?: string | null,
    doctors?:  {
      __typename: "ModelDoctorLocationConnection",
      items:  Array< {
        __typename: "DoctorLocation",
        id: string,
        doctorId: string,
        locationId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        location:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    locationDefaultOnsiteOpsId?: string | null,
    locationSecondaryOnsiteOpsId?: string | null,
  } | null,
};

export type ListLocationsQueryVariables = {
  filter?: ModelLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLocationsQuery = {
  listLocations?:  {
    __typename: "ModelLocationConnection",
    items:  Array< {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetWorkflowExecutionQueryVariables = {
  executionArn: string,
};

export type GetWorkflowExecutionQuery = {
  getWorkflowExecution?:  {
    __typename: "WorkflowExecution",
    executionArn: string,
    appointmentRecordID: string,
    type?: WorkflowExecutionType | null,
    status?: WorkflowExecutionStatus | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListWorkflowExecutionsQueryVariables = {
  executionArn?: string | null,
  filter?: ModelWorkflowExecutionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListWorkflowExecutionsQuery = {
  listWorkflowExecutions?:  {
    __typename: "ModelWorkflowExecutionConnection",
    items:  Array< {
      __typename: "WorkflowExecution",
      executionArn: string,
      appointmentRecordID: string,
      type?: WorkflowExecutionType | null,
      status?: WorkflowExecutionStatus | null,
      errorMessage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type WorkflowExecutionsByAppointmentRecordIDQueryVariables = {
  appointmentRecordID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelWorkflowExecutionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type WorkflowExecutionsByAppointmentRecordIDQuery = {
  workflowExecutionsByAppointmentRecordID?:  {
    __typename: "ModelWorkflowExecutionConnection",
    items:  Array< {
      __typename: "WorkflowExecution",
      executionArn: string,
      appointmentRecordID: string,
      type?: WorkflowExecutionType | null,
      status?: WorkflowExecutionStatus | null,
      errorMessage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetHistoryOfInjuryInsightsQueryVariables = {
  id: string,
};

export type GetHistoryOfInjuryInsightsQuery = {
  getHistoryOfInjuryInsights?:  {
    __typename: "HistoryOfInjuryInsights",
    id: string,
    appointmentRecordID: string,
    mechanismOfInjury?: string | null,
    employerJobDescription?: string | null,
    injuryCausations?:  Array< {
      __typename: "InjuryCausationInfo",
      injuryType?: InjuryType | null,
      dateOfInjury?: string | null,
      dateOfInjuryEnd?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      mechanismOfInjury?: string | null,
      employerJobDescription?: string | null,
    } | null > | null,
    currentSymptoms?:  Array< {
      __typename: "Symptom",
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    priorSymptomsBeforeCurrentInjury?:  Array< {
      __typename: "Symptom",
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    previousSurgeries?:  Array< {
      __typename: "SurgeryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      type?: string | null,
    } | null > | null,
    previousWorkInjuries?:  Array< {
      __typename: "InjuryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    previousInjuries?:  Array< {
      __typename: "InjuryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    injuryEmploymentStatus?: string | null,
    currentWorkRestrictionsFromPatient?: string | null,
    activitiesOfDailyLiving?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListHistoryOfInjuryInsightsQueryVariables = {
  id?: string | null,
  filter?: ModelHistoryOfInjuryInsightsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListHistoryOfInjuryInsightsQuery = {
  listHistoryOfInjuryInsights?:  {
    __typename: "ModelHistoryOfInjuryInsightsConnection",
    items:  Array< {
      __typename: "HistoryOfInjuryInsights",
      id: string,
      appointmentRecordID: string,
      mechanismOfInjury?: string | null,
      employerJobDescription?: string | null,
      injuryCausations?:  Array< {
        __typename: "InjuryCausationInfo",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryEnd?: string | null,
        bodyParts?: Array< BodyPart | null > | null,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
      } | null > | null,
      currentSymptoms?:  Array< {
        __typename: "Symptom",
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      priorSymptomsBeforeCurrentInjury?:  Array< {
        __typename: "Symptom",
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      previousSurgeries?:  Array< {
        __typename: "SurgeryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        type?: string | null,
      } | null > | null,
      previousWorkInjuries?:  Array< {
        __typename: "InjuryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      previousInjuries?:  Array< {
        __typename: "InjuryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      injuryEmploymentStatus?: string | null,
      currentWorkRestrictionsFromPatient?: string | null,
      activitiesOfDailyLiving?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOpinionRecapQueryVariables = {
  id: string,
};

export type GetOpinionRecapQuery = {
  getOpinionRecap?:  {
    __typename: "OpinionRecap",
    id: string,
    appointmentRecordID: string,
    causation?: string | null,
    diagnosis?: string | null,
    mmiFutureMedicalTreatment?: string | null,
    impairmentRating?: string | null,
    apportionment?: string | null,
    workStatus?: string | null,
    sourceReportFileID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListOpinionRecapsQueryVariables = {
  id?: string | null,
  filter?: ModelOpinionRecapFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListOpinionRecapsQuery = {
  listOpinionRecaps?:  {
    __typename: "ModelOpinionRecapConnection",
    items:  Array< {
      __typename: "OpinionRecap",
      id: string,
      appointmentRecordID: string,
      causation?: string | null,
      diagnosis?: string | null,
      mmiFutureMedicalTreatment?: string | null,
      impairmentRating?: string | null,
      apportionment?: string | null,
      workStatus?: string | null,
      sourceReportFileID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetReviewOfMedicalRecordsInsightsQueryVariables = {
  id: string,
};

export type GetReviewOfMedicalRecordsInsightsQuery = {
  getReviewOfMedicalRecordsInsights?:  {
    __typename: "ReviewOfMedicalRecordsInsights",
    id: string,
    appointmentRecordID: string,
    latestDiagnosis?:  Array< {
      __typename: "BodyPartDiagnosis",
      bodyPart?: string | null,
      date?: string | null,
      descriptions?: Array< string | null > | null,
    } | null > | null,
    diagnosticStudies?:  Array< {
      __typename: "DiagnosticStudy",
      date?: string | null,
      typeOfStudy?: DiagnosticStudyType | null,
      bodyPart?: string | null,
      impression?: string | null,
      source?: DiagnosticStudySource | null,
    } | null > | null,
    treatments?:  Array< {
      __typename: "TreatmentWrapper",
      discreteTreatment?:  {
        __typename: "DiscreteTreatment",
        date?: string | null,
        treatmentType?: DiscreteTreatmentType | null,
        bodyPart?: string | null,
        description?: string | null,
      } | null,
      recurringTreatment?:  {
        __typename: "RecurringTreatment",
        year?: string | null,
        treatmentType?: RecurringTreatmentType | null,
        frequency?: string | null,
        description?: string | null,
      } | null,
    } | null > | null,
    currentWorkRestrictionsFromMedicalRecords?: string | null,
    previousReports?:  Array< {
      __typename: "PreviousReport",
      date?: string | null,
      reportType?: string | null,
      reportContent?: string | null,
    } | null > | null,
    durableMedicalEquipment?:  Array< {
      __typename: "DurableMedicalEquipment",
      startDate?: string | null,
      endDate?: string | null,
      bodyParts?: Array< string | null > | null,
      equipmentType?: string | null,
      description?: string | null,
    } | null > | null,
    derivedFromDocumentInsightIDs?: Array< string | null > | null,
    derivedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListReviewOfMedicalRecordsInsightsQueryVariables = {
  id?: string | null,
  filter?: ModelReviewOfMedicalRecordsInsightsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListReviewOfMedicalRecordsInsightsQuery = {
  listReviewOfMedicalRecordsInsights?:  {
    __typename: "ModelReviewOfMedicalRecordsInsightsConnection",
    items:  Array< {
      __typename: "ReviewOfMedicalRecordsInsights",
      id: string,
      appointmentRecordID: string,
      latestDiagnosis?:  Array< {
        __typename: "BodyPartDiagnosis",
        bodyPart?: string | null,
        date?: string | null,
        descriptions?: Array< string | null > | null,
      } | null > | null,
      diagnosticStudies?:  Array< {
        __typename: "DiagnosticStudy",
        date?: string | null,
        typeOfStudy?: DiagnosticStudyType | null,
        bodyPart?: string | null,
        impression?: string | null,
        source?: DiagnosticStudySource | null,
      } | null > | null,
      treatments?:  Array< {
        __typename: "TreatmentWrapper",
        discreteTreatment?:  {
          __typename: "DiscreteTreatment",
          date?: string | null,
          treatmentType?: DiscreteTreatmentType | null,
          bodyPart?: string | null,
          description?: string | null,
        } | null,
        recurringTreatment?:  {
          __typename: "RecurringTreatment",
          year?: string | null,
          treatmentType?: RecurringTreatmentType | null,
          frequency?: string | null,
          description?: string | null,
        } | null,
      } | null > | null,
      currentWorkRestrictionsFromMedicalRecords?: string | null,
      previousReports?:  Array< {
        __typename: "PreviousReport",
        date?: string | null,
        reportType?: string | null,
        reportContent?: string | null,
      } | null > | null,
      durableMedicalEquipment?:  Array< {
        __typename: "DurableMedicalEquipment",
        startDate?: string | null,
        endDate?: string | null,
        bodyParts?: Array< string | null > | null,
        equipmentType?: string | null,
        description?: string | null,
      } | null > | null,
      derivedFromDocumentInsightIDs?: Array< string | null > | null,
      derivedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDocumentBriefingInsightsQueryVariables = {
  id: string,
};

export type GetDocumentBriefingInsightsQuery = {
  getDocumentBriefingInsights?:  {
    __typename: "DocumentBriefingInsights",
    id: string,
    documentID: string,
    appointmentRecordID: string,
    latestDiagnosis?:  Array< {
      __typename: "BodyPartDiagnosis",
      bodyPart?: string | null,
      date?: string | null,
      descriptions?: Array< string | null > | null,
    } | null > | null,
    diagnosticStudies?:  Array< {
      __typename: "DiagnosticStudy",
      date?: string | null,
      typeOfStudy?: DiagnosticStudyType | null,
      bodyPart?: string | null,
      impression?: string | null,
      source?: DiagnosticStudySource | null,
    } | null > | null,
    treatments?:  Array< {
      __typename: "TreatmentWrapper",
      discreteTreatment?:  {
        __typename: "DiscreteTreatment",
        date?: string | null,
        treatmentType?: DiscreteTreatmentType | null,
        bodyPart?: string | null,
        description?: string | null,
      } | null,
      recurringTreatment?:  {
        __typename: "RecurringTreatment",
        year?: string | null,
        treatmentType?: RecurringTreatmentType | null,
        frequency?: string | null,
        description?: string | null,
      } | null,
    } | null > | null,
    currentWorkRestrictionsFromMedicalRecords?: string | null,
    previousReports?:  Array< {
      __typename: "PreviousReport",
      date?: string | null,
      reportType?: string | null,
      reportContent?: string | null,
    } | null > | null,
    durableMedicalEquipment?:  Array< {
      __typename: "DurableMedicalEquipment",
      startDate?: string | null,
      endDate?: string | null,
      bodyParts?: Array< string | null > | null,
      equipmentType?: string | null,
      description?: string | null,
    } | null > | null,
    sourceRecordBriefingID: string,
    generatedAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListDocumentBriefingInsightsQueryVariables = {
  id?: string | null,
  filter?: ModelDocumentBriefingInsightsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDocumentBriefingInsightsQuery = {
  listDocumentBriefingInsights?:  {
    __typename: "ModelDocumentBriefingInsightsConnection",
    items:  Array< {
      __typename: "DocumentBriefingInsights",
      id: string,
      documentID: string,
      appointmentRecordID: string,
      latestDiagnosis?:  Array< {
        __typename: "BodyPartDiagnosis",
        bodyPart?: string | null,
        date?: string | null,
        descriptions?: Array< string | null > | null,
      } | null > | null,
      diagnosticStudies?:  Array< {
        __typename: "DiagnosticStudy",
        date?: string | null,
        typeOfStudy?: DiagnosticStudyType | null,
        bodyPart?: string | null,
        impression?: string | null,
        source?: DiagnosticStudySource | null,
      } | null > | null,
      treatments?:  Array< {
        __typename: "TreatmentWrapper",
        discreteTreatment?:  {
          __typename: "DiscreteTreatment",
          date?: string | null,
          treatmentType?: DiscreteTreatmentType | null,
          bodyPart?: string | null,
          description?: string | null,
        } | null,
        recurringTreatment?:  {
          __typename: "RecurringTreatment",
          year?: string | null,
          treatmentType?: RecurringTreatmentType | null,
          frequency?: string | null,
          description?: string | null,
        } | null,
      } | null > | null,
      currentWorkRestrictionsFromMedicalRecords?: string | null,
      previousReports?:  Array< {
        __typename: "PreviousReport",
        date?: string | null,
        reportType?: string | null,
        reportContent?: string | null,
      } | null > | null,
      durableMedicalEquipment?:  Array< {
        __typename: "DurableMedicalEquipment",
        startDate?: string | null,
        endDate?: string | null,
        bodyParts?: Array< string | null > | null,
        equipmentType?: string | null,
        description?: string | null,
      } | null > | null,
      sourceRecordBriefingID: string,
      generatedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DocumentBriefingInsightsByDocumentQueryVariables = {
  documentID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDocumentBriefingInsightsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DocumentBriefingInsightsByDocumentQuery = {
  documentBriefingInsightsByDocument?:  {
    __typename: "ModelDocumentBriefingInsightsConnection",
    items:  Array< {
      __typename: "DocumentBriefingInsights",
      id: string,
      documentID: string,
      appointmentRecordID: string,
      latestDiagnosis?:  Array< {
        __typename: "BodyPartDiagnosis",
        bodyPart?: string | null,
        date?: string | null,
        descriptions?: Array< string | null > | null,
      } | null > | null,
      diagnosticStudies?:  Array< {
        __typename: "DiagnosticStudy",
        date?: string | null,
        typeOfStudy?: DiagnosticStudyType | null,
        bodyPart?: string | null,
        impression?: string | null,
        source?: DiagnosticStudySource | null,
      } | null > | null,
      treatments?:  Array< {
        __typename: "TreatmentWrapper",
        discreteTreatment?:  {
          __typename: "DiscreteTreatment",
          date?: string | null,
          treatmentType?: DiscreteTreatmentType | null,
          bodyPart?: string | null,
          description?: string | null,
        } | null,
        recurringTreatment?:  {
          __typename: "RecurringTreatment",
          year?: string | null,
          treatmentType?: RecurringTreatmentType | null,
          frequency?: string | null,
          description?: string | null,
        } | null,
      } | null > | null,
      currentWorkRestrictionsFromMedicalRecords?: string | null,
      previousReports?:  Array< {
        __typename: "PreviousReport",
        date?: string | null,
        reportType?: string | null,
        reportContent?: string | null,
      } | null > | null,
      durableMedicalEquipment?:  Array< {
        __typename: "DurableMedicalEquipment",
        startDate?: string | null,
        endDate?: string | null,
        bodyParts?: Array< string | null > | null,
        equipmentType?: string | null,
        description?: string | null,
      } | null > | null,
      sourceRecordBriefingID: string,
      generatedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DocumentBriefingInsightsByAppointmentRecordIDQueryVariables = {
  appointmentRecordID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDocumentBriefingInsightsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DocumentBriefingInsightsByAppointmentRecordIDQuery = {
  documentBriefingInsightsByAppointmentRecordID?:  {
    __typename: "ModelDocumentBriefingInsightsConnection",
    items:  Array< {
      __typename: "DocumentBriefingInsights",
      id: string,
      documentID: string,
      appointmentRecordID: string,
      latestDiagnosis?:  Array< {
        __typename: "BodyPartDiagnosis",
        bodyPart?: string | null,
        date?: string | null,
        descriptions?: Array< string | null > | null,
      } | null > | null,
      diagnosticStudies?:  Array< {
        __typename: "DiagnosticStudy",
        date?: string | null,
        typeOfStudy?: DiagnosticStudyType | null,
        bodyPart?: string | null,
        impression?: string | null,
        source?: DiagnosticStudySource | null,
      } | null > | null,
      treatments?:  Array< {
        __typename: "TreatmentWrapper",
        discreteTreatment?:  {
          __typename: "DiscreteTreatment",
          date?: string | null,
          treatmentType?: DiscreteTreatmentType | null,
          bodyPart?: string | null,
          description?: string | null,
        } | null,
        recurringTreatment?:  {
          __typename: "RecurringTreatment",
          year?: string | null,
          treatmentType?: RecurringTreatmentType | null,
          frequency?: string | null,
          description?: string | null,
        } | null,
      } | null > | null,
      currentWorkRestrictionsFromMedicalRecords?: string | null,
      previousReports?:  Array< {
        __typename: "PreviousReport",
        date?: string | null,
        reportType?: string | null,
        reportContent?: string | null,
      } | null > | null,
      durableMedicalEquipment?:  Array< {
        __typename: "DurableMedicalEquipment",
        startDate?: string | null,
        endDate?: string | null,
        bodyParts?: Array< string | null > | null,
        equipmentType?: string | null,
        description?: string | null,
      } | null > | null,
      sourceRecordBriefingID: string,
      generatedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPhysicalExamInsightsQueryVariables = {
  id: string,
};

export type GetPhysicalExamInsightsQuery = {
  getPhysicalExamInsights?:  {
    __typename: "PhysicalExamInsights",
    id: string,
    appointmentRecordID: string,
    physicalExaminationInfo?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPhysicalExamInsightsQueryVariables = {
  id?: string | null,
  filter?: ModelPhysicalExamInsightsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPhysicalExamInsightsQuery = {
  listPhysicalExamInsights?:  {
    __typename: "ModelPhysicalExamInsightsConnection",
    items:  Array< {
      __typename: "PhysicalExamInsights",
      id: string,
      appointmentRecordID: string,
      physicalExaminationInfo?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDataFieldQueryVariables = {
  id: string,
};

export type GetDataFieldQuery = {
  getDataField?:  {
    __typename: "DataField",
    id: string,
    name: string,
    category: DataFieldCategory,
    dataType: DataFieldType,
    default: boolean,
    description?: string | null,
    sectionID?: string | null,
    section?:  {
      __typename: "DataFieldSection",
      id: string,
      name: string,
      default: boolean,
      fields?:  {
        __typename: "ModelDataFieldConnection",
        items:  Array< {
          __typename: "DataField",
          id: string,
          name: string,
          category: DataFieldCategory,
          dataType: DataFieldType,
          default: boolean,
          description?: string | null,
          sectionID?: string | null,
          migrationKey?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    migrationKey?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListDataFieldsQueryVariables = {
  id?: string | null,
  filter?: ModelDataFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDataFieldsQuery = {
  listDataFields?:  {
    __typename: "ModelDataFieldConnection",
    items:  Array< {
      __typename: "DataField",
      id: string,
      name: string,
      category: DataFieldCategory,
      dataType: DataFieldType,
      default: boolean,
      description?: string | null,
      sectionID?: string | null,
      section?:  {
        __typename: "DataFieldSection",
        id: string,
        name: string,
        default: boolean,
        fields?:  {
          __typename: "ModelDataFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      migrationKey?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DataFieldsByCategoryQueryVariables = {
  category: DataFieldCategory,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDataFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DataFieldsByCategoryQuery = {
  dataFieldsByCategory?:  {
    __typename: "ModelDataFieldConnection",
    items:  Array< {
      __typename: "DataField",
      id: string,
      name: string,
      category: DataFieldCategory,
      dataType: DataFieldType,
      default: boolean,
      description?: string | null,
      sectionID?: string | null,
      section?:  {
        __typename: "DataFieldSection",
        id: string,
        name: string,
        default: boolean,
        fields?:  {
          __typename: "ModelDataFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      migrationKey?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DataFieldsBySectionIDQueryVariables = {
  sectionID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDataFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DataFieldsBySectionIDQuery = {
  dataFieldsBySectionID?:  {
    __typename: "ModelDataFieldConnection",
    items:  Array< {
      __typename: "DataField",
      id: string,
      name: string,
      category: DataFieldCategory,
      dataType: DataFieldType,
      default: boolean,
      description?: string | null,
      sectionID?: string | null,
      section?:  {
        __typename: "DataFieldSection",
        id: string,
        name: string,
        default: boolean,
        fields?:  {
          __typename: "ModelDataFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      migrationKey?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDataFieldSectionQueryVariables = {
  id: string,
};

export type GetDataFieldSectionQuery = {
  getDataFieldSection?:  {
    __typename: "DataFieldSection",
    id: string,
    name: string,
    default: boolean,
    fields?:  {
      __typename: "ModelDataFieldConnection",
      items:  Array< {
        __typename: "DataField",
        id: string,
        name: string,
        category: DataFieldCategory,
        dataType: DataFieldType,
        default: boolean,
        description?: string | null,
        sectionID?: string | null,
        section?:  {
          __typename: "DataFieldSection",
          id: string,
          name: string,
          default: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        migrationKey?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListDataFieldSectionsQueryVariables = {
  id?: string | null,
  filter?: ModelDataFieldSectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDataFieldSectionsQuery = {
  listDataFieldSections?:  {
    __typename: "ModelDataFieldSectionConnection",
    items:  Array< {
      __typename: "DataFieldSection",
      id: string,
      name: string,
      default: boolean,
      fields?:  {
        __typename: "ModelDataFieldConnection",
        items:  Array< {
          __typename: "DataField",
          id: string,
          name: string,
          category: DataFieldCategory,
          dataType: DataFieldType,
          default: boolean,
          description?: string | null,
          sectionID?: string | null,
          migrationKey?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBriefingFieldQueryVariables = {
  id: string,
};

export type GetBriefingFieldQuery = {
  getBriefingField?:  {
    __typename: "BriefingField",
    id: string,
    name: string,
    default: boolean,
    description?: string | null,
    briefingPrompt?: string | null,
    doctors?:  {
      __typename: "ModelDoctorBriefingFieldConnection",
      items:  Array< {
        __typename: "DoctorBriefingField",
        id: string,
        doctorId: string,
        briefingFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        briefingField:  {
          __typename: "BriefingField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          briefingPrompt?: string | null,
          briefingRecordTypeID: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    briefingRecordTypeID: string,
    recordType:  {
      __typename: "BriefingRecordType",
      id: string,
      name: string,
      recordType: RecordType,
      description?: string | null,
      default: boolean,
      classificationPrompt?: string | null,
      recordBasePrompt?: string | null,
      briefingFields?:  {
        __typename: "ModelBriefingFieldConnection",
        items:  Array< {
          __typename: "BriefingField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          briefingPrompt?: string | null,
          briefingRecordTypeID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBriefingFieldsQueryVariables = {
  id?: string | null,
  filter?: ModelBriefingFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBriefingFieldsQuery = {
  listBriefingFields?:  {
    __typename: "ModelBriefingFieldConnection",
    items:  Array< {
      __typename: "BriefingField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      briefingPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingRecordTypeID: string,
      recordType:  {
        __typename: "BriefingRecordType",
        id: string,
        name: string,
        recordType: RecordType,
        description?: string | null,
        default: boolean,
        classificationPrompt?: string | null,
        recordBasePrompt?: string | null,
        briefingFields?:  {
          __typename: "ModelBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type BriefingFieldsByBriefingRecordTypeIDQueryVariables = {
  briefingRecordTypeID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBriefingFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type BriefingFieldsByBriefingRecordTypeIDQuery = {
  briefingFieldsByBriefingRecordTypeID?:  {
    __typename: "ModelBriefingFieldConnection",
    items:  Array< {
      __typename: "BriefingField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      briefingPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingRecordTypeID: string,
      recordType:  {
        __typename: "BriefingRecordType",
        id: string,
        name: string,
        recordType: RecordType,
        description?: string | null,
        default: boolean,
        classificationPrompt?: string | null,
        recordBasePrompt?: string | null,
        briefingFields?:  {
          __typename: "ModelBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBriefingRecordTypeQueryVariables = {
  id: string,
};

export type GetBriefingRecordTypeQuery = {
  getBriefingRecordType?:  {
    __typename: "BriefingRecordType",
    id: string,
    name: string,
    recordType: RecordType,
    description?: string | null,
    default: boolean,
    classificationPrompt?: string | null,
    recordBasePrompt?: string | null,
    briefingFields?:  {
      __typename: "ModelBriefingFieldConnection",
      items:  Array< {
        __typename: "BriefingField",
        id: string,
        name: string,
        default: boolean,
        description?: string | null,
        briefingPrompt?: string | null,
        doctors?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingRecordTypeID: string,
        recordType:  {
          __typename: "BriefingRecordType",
          id: string,
          name: string,
          recordType: RecordType,
          description?: string | null,
          default: boolean,
          classificationPrompt?: string | null,
          recordBasePrompt?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBriefingRecordTypesQueryVariables = {
  id?: string | null,
  filter?: ModelBriefingRecordTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBriefingRecordTypesQuery = {
  listBriefingRecordTypes?:  {
    __typename: "ModelBriefingRecordTypeConnection",
    items:  Array< {
      __typename: "BriefingRecordType",
      id: string,
      name: string,
      recordType: RecordType,
      description?: string | null,
      default: boolean,
      classificationPrompt?: string | null,
      recordBasePrompt?: string | null,
      briefingFields?:  {
        __typename: "ModelBriefingFieldConnection",
        items:  Array< {
          __typename: "BriefingField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          briefingPrompt?: string | null,
          briefingRecordTypeID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCaseSummaryFieldQueryVariables = {
  id: string,
};

export type GetCaseSummaryFieldQuery = {
  getCaseSummaryField?:  {
    __typename: "CaseSummaryField",
    id: string,
    name: string,
    default: boolean,
    description?: string | null,
    summaryPrompt?: string | null,
    doctors?:  {
      __typename: "ModelDoctorCaseSummaryFieldConnection",
      items:  Array< {
        __typename: "DoctorCaseSummaryField",
        id: string,
        doctorId: string,
        caseSummaryFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        caseSummaryField:  {
          __typename: "CaseSummaryField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          summaryPrompt?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCaseSummaryFieldsQueryVariables = {
  id?: string | null,
  filter?: ModelCaseSummaryFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCaseSummaryFieldsQuery = {
  listCaseSummaryFields?:  {
    __typename: "ModelCaseSummaryFieldConnection",
    items:  Array< {
      __typename: "CaseSummaryField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      summaryPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPastInjuryMatrixQueryVariables = {
  id: string,
};

export type GetPastInjuryMatrixQuery = {
  getPastInjuryMatrix?:  {
    __typename: "PastInjuryMatrix",
    id: string,
    appointmentRecordID: string,
    preExistingConditions: Array< string >,
    familyHistory: Array< string >,
    injuryMatrix:  Array< {
      __typename: "InjuryMatrixEntry",
      date: string,
      bodyPart: BodyPart,
      status: InjuryStatus,
    } >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPastInjuryMatricesQueryVariables = {
  id?: string | null,
  filter?: ModelPastInjuryMatrixFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPastInjuryMatricesQuery = {
  listPastInjuryMatrices?:  {
    __typename: "ModelPastInjuryMatrixConnection",
    items:  Array< {
      __typename: "PastInjuryMatrix",
      id: string,
      appointmentRecordID: string,
      preExistingConditions: Array< string >,
      familyHistory: Array< string >,
      injuryMatrix:  Array< {
        __typename: "InjuryMatrixEntry",
        date: string,
        bodyPart: BodyPart,
        status: InjuryStatus,
      } >,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PastInjuryMatricesByAppointmentRecordIDQueryVariables = {
  appointmentRecordID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPastInjuryMatrixFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PastInjuryMatricesByAppointmentRecordIDQuery = {
  pastInjuryMatricesByAppointmentRecordID?:  {
    __typename: "ModelPastInjuryMatrixConnection",
    items:  Array< {
      __typename: "PastInjuryMatrix",
      id: string,
      appointmentRecordID: string,
      preExistingConditions: Array< string >,
      familyHistory: Array< string >,
      injuryMatrix:  Array< {
        __typename: "InjuryMatrixEntry",
        date: string,
        bodyPart: BodyPart,
        status: InjuryStatus,
      } >,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAppointmentFilterPresetQueryVariables = {
  id: string,
};

export type GetAppointmentFilterPresetQuery = {
  getAppointmentFilterPreset?:  {
    __typename: "AppointmentFilterPreset",
    id: string,
    name: string,
    filters:  Array< {
      __typename: "FilterEntry",
      type: FilterType,
      values: Array< string >,
    } >,
    appliesTo: UserGroup,
    view?: AppointmentsView | null,
    users?:  {
      __typename: "ModelUserAppointmentFilterPresetConnection",
      items:  Array< {
        __typename: "UserAppointmentFilterPreset",
        id: string,
        userId: string,
        appointmentFilterPresetId: string,
        user:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        },
        appointmentFilterPreset:  {
          __typename: "AppointmentFilterPreset",
          id: string,
          name: string,
          appliesTo: UserGroup,
          view?: AppointmentsView | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAppointmentFilterPresetsQueryVariables = {
  filter?: ModelAppointmentFilterPresetFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAppointmentFilterPresetsQuery = {
  listAppointmentFilterPresets?:  {
    __typename: "ModelAppointmentFilterPresetConnection",
    items:  Array< {
      __typename: "AppointmentFilterPreset",
      id: string,
      name: string,
      filters:  Array< {
        __typename: "FilterEntry",
        type: FilterType,
        values: Array< string >,
      } >,
      appliesTo: UserGroup,
      view?: AppointmentsView | null,
      users?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFeatureFlagQueryVariables = {
  key: string,
};

export type GetFeatureFlagQuery = {
  getFeatureFlag?:  {
    __typename: "FeatureFlag",
    key: string,
    enabled: boolean,
    enabledForUserIds?: Array< string > | null,
    enabledForRoles?: Array< UserGroup > | null,
    enabledForDoctorIds?: Array< string > | null,
    description?: string | null,
    variants?:  Array< {
      __typename: "VariantPercentageMapping",
      variant: string,
      percentage: number,
    } > | null,
    seed?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFeatureFlagsQueryVariables = {
  key?: string | null,
  filter?: ModelFeatureFlagFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFeatureFlagsQuery = {
  listFeatureFlags?:  {
    __typename: "ModelFeatureFlagConnection",
    items:  Array< {
      __typename: "FeatureFlag",
      key: string,
      enabled: boolean,
      enabledForUserIds?: Array< string > | null,
      enabledForRoles?: Array< UserGroup > | null,
      enabledForDoctorIds?: Array< string > | null,
      description?: string | null,
      variants?:  Array< {
        __typename: "VariantPercentageMapping",
        variant: string,
        percentage: number,
      } > | null,
      seed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFeatureFlagVariantAssignmentQueryVariables = {
  assignmentId: string,
};

export type GetFeatureFlagVariantAssignmentQuery = {
  getFeatureFlagVariantAssignment?:  {
    __typename: "FeatureFlagVariantAssignment",
    assignmentId: string,
    flagKey: string,
    subjectId: string,
    variant: string,
    assignedAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFeatureFlagVariantAssignmentsQueryVariables = {
  assignmentId?: string | null,
  filter?: ModelFeatureFlagVariantAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFeatureFlagVariantAssignmentsQuery = {
  listFeatureFlagVariantAssignments?:  {
    __typename: "ModelFeatureFlagVariantAssignmentConnection",
    items:  Array< {
      __typename: "FeatureFlagVariantAssignment",
      assignmentId: string,
      flagKey: string,
      subjectId: string,
      variant: string,
      assignedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FeatureFlagVariantAssignmentsByFlagKeyAndAssignedAtQueryVariables = {
  flagKey: string,
  assignedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFeatureFlagVariantAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FeatureFlagVariantAssignmentsByFlagKeyAndAssignedAtQuery = {
  featureFlagVariantAssignmentsByFlagKeyAndAssignedAt?:  {
    __typename: "ModelFeatureFlagVariantAssignmentConnection",
    items:  Array< {
      __typename: "FeatureFlagVariantAssignment",
      assignmentId: string,
      flagKey: string,
      subjectId: string,
      variant: string,
      assignedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FeatureFlagVariantAssignmentsBySubjectIdAndAssignedAtQueryVariables = {
  subjectId: string,
  assignedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFeatureFlagVariantAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FeatureFlagVariantAssignmentsBySubjectIdAndAssignedAtQuery = {
  featureFlagVariantAssignmentsBySubjectIdAndAssignedAt?:  {
    __typename: "ModelFeatureFlagVariantAssignmentConnection",
    items:  Array< {
      __typename: "FeatureFlagVariantAssignment",
      assignmentId: string,
      flagKey: string,
      subjectId: string,
      variant: string,
      assignedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRecordBriefingSegmentQueryVariables = {
  id: string,
};

export type GetRecordBriefingSegmentQuery = {
  getRecordBriefingSegment?:  {
    __typename: "RecordBriefingSegment",
    id: string,
    logicalSegmentID: string,
    title?: string | null,
    text?: string | null,
    bodyParts?: Array< BodyPart | null > | null,
    injuredBodyParts?: Array< BodyPart | null > | null,
    editedBy?: string | null,
    pdfFileName: string,
    sourceTag?: string | null,
    segmentNumber?: number | null,
    sourcePdfS3Key: string,
    startPageNumber: number,
    endPageNumber: number,
    recordType: RecordType,
    extractedDate?: string | null,
    doctorName?: string | null,
    processingModel?: string | null,
    classificationConfidence?: number | null,
    hasDate?: boolean | null,
    potentialDuplicateID?: string | null,
    needsReview?: boolean | null,
    status?: SegmentStatus | null,
    documentID?: string | null,
    videoStartTime?: string | null,
    videoEndTime?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRecordBriefingSegmentsQueryVariables = {
  id?: string | null,
  filter?: ModelRecordBriefingSegmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListRecordBriefingSegmentsQuery = {
  listRecordBriefingSegments?:  {
    __typename: "ModelRecordBriefingSegmentConnection",
    items:  Array< {
      __typename: "RecordBriefingSegment",
      id: string,
      logicalSegmentID: string,
      title?: string | null,
      text?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      editedBy?: string | null,
      pdfFileName: string,
      sourceTag?: string | null,
      segmentNumber?: number | null,
      sourcePdfS3Key: string,
      startPageNumber: number,
      endPageNumber: number,
      recordType: RecordType,
      extractedDate?: string | null,
      doctorName?: string | null,
      processingModel?: string | null,
      classificationConfidence?: number | null,
      hasDate?: boolean | null,
      potentialDuplicateID?: string | null,
      needsReview?: boolean | null,
      status?: SegmentStatus | null,
      documentID?: string | null,
      videoStartTime?: string | null,
      videoEndTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RecordBriefingSegmentsByLogicalIdQueryVariables = {
  logicalSegmentID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRecordBriefingSegmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RecordBriefingSegmentsByLogicalIdQuery = {
  recordBriefingSegmentsByLogicalId?:  {
    __typename: "ModelRecordBriefingSegmentConnection",
    items:  Array< {
      __typename: "RecordBriefingSegment",
      id: string,
      logicalSegmentID: string,
      title?: string | null,
      text?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      editedBy?: string | null,
      pdfFileName: string,
      sourceTag?: string | null,
      segmentNumber?: number | null,
      sourcePdfS3Key: string,
      startPageNumber: number,
      endPageNumber: number,
      recordType: RecordType,
      extractedDate?: string | null,
      doctorName?: string | null,
      processingModel?: string | null,
      classificationConfidence?: number | null,
      hasDate?: boolean | null,
      potentialDuplicateID?: string | null,
      needsReview?: boolean | null,
      status?: SegmentStatus | null,
      documentID?: string | null,
      videoStartTime?: string | null,
      videoEndTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRecordBriefingSegmentMappingQueryVariables = {
  id: string,
};

export type GetRecordBriefingSegmentMappingQuery = {
  getRecordBriefingSegmentMapping?:  {
    __typename: "RecordBriefingSegmentMapping",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    publishedSegmentID?: string | null,
    draftSegmentID?: string | null,
    markedForDeletion?: boolean | null,
    markedForCreation?: boolean | null,
    publishedSegment?:  {
      __typename: "RecordBriefingSegment",
      id: string,
      logicalSegmentID: string,
      title?: string | null,
      text?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      editedBy?: string | null,
      pdfFileName: string,
      sourceTag?: string | null,
      segmentNumber?: number | null,
      sourcePdfS3Key: string,
      startPageNumber: number,
      endPageNumber: number,
      recordType: RecordType,
      extractedDate?: string | null,
      doctorName?: string | null,
      processingModel?: string | null,
      classificationConfidence?: number | null,
      hasDate?: boolean | null,
      potentialDuplicateID?: string | null,
      needsReview?: boolean | null,
      status?: SegmentStatus | null,
      documentID?: string | null,
      videoStartTime?: string | null,
      videoEndTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    draftSegment?:  {
      __typename: "RecordBriefingSegment",
      id: string,
      logicalSegmentID: string,
      title?: string | null,
      text?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      editedBy?: string | null,
      pdfFileName: string,
      sourceTag?: string | null,
      segmentNumber?: number | null,
      sourcePdfS3Key: string,
      startPageNumber: number,
      endPageNumber: number,
      recordType: RecordType,
      extractedDate?: string | null,
      doctorName?: string | null,
      processingModel?: string | null,
      classificationConfidence?: number | null,
      hasDate?: boolean | null,
      potentialDuplicateID?: string | null,
      needsReview?: boolean | null,
      status?: SegmentStatus | null,
      documentID?: string | null,
      videoStartTime?: string | null,
      videoEndTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRecordBriefingSegmentMappingsQueryVariables = {
  id?: string | null,
  filter?: ModelRecordBriefingSegmentMappingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListRecordBriefingSegmentMappingsQuery = {
  listRecordBriefingSegmentMappings?:  {
    __typename: "ModelRecordBriefingSegmentMappingConnection",
    items:  Array< {
      __typename: "RecordBriefingSegmentMapping",
      id: string,
      briefingID: string,
      logicalSegmentID: string,
      publishedSegmentID?: string | null,
      draftSegmentID?: string | null,
      markedForDeletion?: boolean | null,
      markedForCreation?: boolean | null,
      publishedSegment?:  {
        __typename: "RecordBriefingSegment",
        id: string,
        logicalSegmentID: string,
        title?: string | null,
        text?: string | null,
        bodyParts?: Array< BodyPart | null > | null,
        injuredBodyParts?: Array< BodyPart | null > | null,
        editedBy?: string | null,
        pdfFileName: string,
        sourceTag?: string | null,
        segmentNumber?: number | null,
        sourcePdfS3Key: string,
        startPageNumber: number,
        endPageNumber: number,
        recordType: RecordType,
        extractedDate?: string | null,
        doctorName?: string | null,
        processingModel?: string | null,
        classificationConfidence?: number | null,
        hasDate?: boolean | null,
        potentialDuplicateID?: string | null,
        needsReview?: boolean | null,
        status?: SegmentStatus | null,
        documentID?: string | null,
        videoStartTime?: string | null,
        videoEndTime?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      draftSegment?:  {
        __typename: "RecordBriefingSegment",
        id: string,
        logicalSegmentID: string,
        title?: string | null,
        text?: string | null,
        bodyParts?: Array< BodyPart | null > | null,
        injuredBodyParts?: Array< BodyPart | null > | null,
        editedBy?: string | null,
        pdfFileName: string,
        sourceTag?: string | null,
        segmentNumber?: number | null,
        sourcePdfS3Key: string,
        startPageNumber: number,
        endPageNumber: number,
        recordType: RecordType,
        extractedDate?: string | null,
        doctorName?: string | null,
        processingModel?: string | null,
        classificationConfidence?: number | null,
        hasDate?: boolean | null,
        potentialDuplicateID?: string | null,
        needsReview?: boolean | null,
        status?: SegmentStatus | null,
        documentID?: string | null,
        videoStartTime?: string | null,
        videoEndTime?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SegmentMappingsByBriefingIdQueryVariables = {
  briefingID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRecordBriefingSegmentMappingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SegmentMappingsByBriefingIdQuery = {
  segmentMappingsByBriefingId?:  {
    __typename: "ModelRecordBriefingSegmentMappingConnection",
    items:  Array< {
      __typename: "RecordBriefingSegmentMapping",
      id: string,
      briefingID: string,
      logicalSegmentID: string,
      publishedSegmentID?: string | null,
      draftSegmentID?: string | null,
      markedForDeletion?: boolean | null,
      markedForCreation?: boolean | null,
      publishedSegment?:  {
        __typename: "RecordBriefingSegment",
        id: string,
        logicalSegmentID: string,
        title?: string | null,
        text?: string | null,
        bodyParts?: Array< BodyPart | null > | null,
        injuredBodyParts?: Array< BodyPart | null > | null,
        editedBy?: string | null,
        pdfFileName: string,
        sourceTag?: string | null,
        segmentNumber?: number | null,
        sourcePdfS3Key: string,
        startPageNumber: number,
        endPageNumber: number,
        recordType: RecordType,
        extractedDate?: string | null,
        doctorName?: string | null,
        processingModel?: string | null,
        classificationConfidence?: number | null,
        hasDate?: boolean | null,
        potentialDuplicateID?: string | null,
        needsReview?: boolean | null,
        status?: SegmentStatus | null,
        documentID?: string | null,
        videoStartTime?: string | null,
        videoEndTime?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      draftSegment?:  {
        __typename: "RecordBriefingSegment",
        id: string,
        logicalSegmentID: string,
        title?: string | null,
        text?: string | null,
        bodyParts?: Array< BodyPart | null > | null,
        injuredBodyParts?: Array< BodyPart | null > | null,
        editedBy?: string | null,
        pdfFileName: string,
        sourceTag?: string | null,
        segmentNumber?: number | null,
        sourcePdfS3Key: string,
        startPageNumber: number,
        endPageNumber: number,
        recordType: RecordType,
        extractedDate?: string | null,
        doctorName?: string | null,
        processingModel?: string | null,
        classificationConfidence?: number | null,
        hasDate?: boolean | null,
        potentialDuplicateID?: string | null,
        needsReview?: boolean | null,
        status?: SegmentStatus | null,
        documentID?: string | null,
        videoStartTime?: string | null,
        videoEndTime?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRecordBriefingQueryVariables = {
  id: string,
};

export type GetRecordBriefingQuery = {
  getRecordBriefing?:  {
    __typename: "RecordBriefing",
    id: string,
    logicalBriefingID: string,
    segmentMappings?:  {
      __typename: "ModelRecordBriefingSegmentMappingConnection",
      items:  Array< {
        __typename: "RecordBriefingSegmentMapping",
        id: string,
        briefingID: string,
        logicalSegmentID: string,
        publishedSegmentID?: string | null,
        draftSegmentID?: string | null,
        markedForDeletion?: boolean | null,
        markedForCreation?: boolean | null,
        publishedSegment?:  {
          __typename: "RecordBriefingSegment",
          id: string,
          logicalSegmentID: string,
          title?: string | null,
          text?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          editedBy?: string | null,
          pdfFileName: string,
          sourceTag?: string | null,
          segmentNumber?: number | null,
          sourcePdfS3Key: string,
          startPageNumber: number,
          endPageNumber: number,
          recordType: RecordType,
          extractedDate?: string | null,
          doctorName?: string | null,
          processingModel?: string | null,
          classificationConfidence?: number | null,
          hasDate?: boolean | null,
          potentialDuplicateID?: string | null,
          needsReview?: boolean | null,
          status?: SegmentStatus | null,
          documentID?: string | null,
          videoStartTime?: string | null,
          videoEndTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        draftSegment?:  {
          __typename: "RecordBriefingSegment",
          id: string,
          logicalSegmentID: string,
          title?: string | null,
          text?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          editedBy?: string | null,
          pdfFileName: string,
          sourceTag?: string | null,
          segmentNumber?: number | null,
          sourcePdfS3Key: string,
          startPageNumber: number,
          endPageNumber: number,
          recordType: RecordType,
          extractedDate?: string | null,
          doctorName?: string | null,
          processingModel?: string | null,
          classificationConfidence?: number | null,
          hasDate?: boolean | null,
          potentialDuplicateID?: string | null,
          needsReview?: boolean | null,
          status?: SegmentStatus | null,
          documentID?: string | null,
          videoStartTime?: string | null,
          videoEndTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    googleDocExportLink?: string | null,
    googleDocExportedAt?: string | null,
    suggestionGeneration?:  {
      __typename: "SuggestionGenerationJob",
      status?: SuggestionGenerationStatus | null,
      jobId?: string | null,
      startedAt?: string | null,
      completedAt?: string | null,
      error?: string | null,
    } | null,
    editingPresence?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRecordBriefingsQueryVariables = {
  id?: string | null,
  filter?: ModelRecordBriefingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListRecordBriefingsQuery = {
  listRecordBriefings?:  {
    __typename: "ModelRecordBriefingConnection",
    items:  Array< {
      __typename: "RecordBriefing",
      id: string,
      logicalBriefingID: string,
      segmentMappings?:  {
        __typename: "ModelRecordBriefingSegmentMappingConnection",
        items:  Array< {
          __typename: "RecordBriefingSegmentMapping",
          id: string,
          briefingID: string,
          logicalSegmentID: string,
          publishedSegmentID?: string | null,
          draftSegmentID?: string | null,
          markedForDeletion?: boolean | null,
          markedForCreation?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      googleDocExportLink?: string | null,
      googleDocExportedAt?: string | null,
      suggestionGeneration?:  {
        __typename: "SuggestionGenerationJob",
        status?: SuggestionGenerationStatus | null,
        jobId?: string | null,
        startedAt?: string | null,
        completedAt?: string | null,
        error?: string | null,
      } | null,
      editingPresence?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RecordBriefingsByLogicalIdQueryVariables = {
  logicalBriefingID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRecordBriefingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RecordBriefingsByLogicalIdQuery = {
  recordBriefingsByLogicalId?:  {
    __typename: "ModelRecordBriefingConnection",
    items:  Array< {
      __typename: "RecordBriefing",
      id: string,
      logicalBriefingID: string,
      segmentMappings?:  {
        __typename: "ModelRecordBriefingSegmentMappingConnection",
        items:  Array< {
          __typename: "RecordBriefingSegmentMapping",
          id: string,
          briefingID: string,
          logicalSegmentID: string,
          publishedSegmentID?: string | null,
          draftSegmentID?: string | null,
          markedForDeletion?: boolean | null,
          markedForCreation?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      googleDocExportLink?: string | null,
      googleDocExportedAt?: string | null,
      suggestionGeneration?:  {
        __typename: "SuggestionGenerationJob",
        status?: SuggestionGenerationStatus | null,
        jobId?: string | null,
        startedAt?: string | null,
        completedAt?: string | null,
        error?: string | null,
      } | null,
      editingPresence?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRecordBriefingSegmentAnnotationQueryVariables = {
  id: string,
  logicalSegmentID: string,
};

export type GetRecordBriefingSegmentAnnotationQuery = {
  getRecordBriefingSegmentAnnotation?:  {
    __typename: "RecordBriefingSegmentAnnotation",
    id: string,
    logicalSegmentID: string,
    isStarred?: boolean | null,
    isImportant?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRecordBriefingSegmentAnnotationsQueryVariables = {
  id?: string | null,
  logicalSegmentID?: ModelStringKeyConditionInput | null,
  filter?: ModelRecordBriefingSegmentAnnotationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListRecordBriefingSegmentAnnotationsQuery = {
  listRecordBriefingSegmentAnnotations?:  {
    __typename: "ModelRecordBriefingSegmentAnnotationConnection",
    items:  Array< {
      __typename: "RecordBriefingSegmentAnnotation",
      id: string,
      logicalSegmentID: string,
      isStarred?: boolean | null,
      isImportant?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRecordBriefingSegmentSuggestionQueryVariables = {
  id: string,
};

export type GetRecordBriefingSegmentSuggestionQuery = {
  getRecordBriefingSegmentSuggestion?:  {
    __typename: "RecordBriefingSegmentSuggestion",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    suggestionType: SegmentSuggestionType,
    reason: SegmentSuggestionReason,
    reasonDetails?: string | null,
    textRange?:  {
      __typename: "TextRange",
      textToDelete: string,
      occurrenceIndex?: number | null,
      prefixContext?: string | null,
      suffixContext?: string | null,
    } | null,
    status: SegmentSuggestionStatus,
    resolvedBy?: string | null,
    resolvedAt?: string | null,
    seen?: boolean | null,
    confidence?: number | null,
    relatedSegmentID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRecordBriefingSegmentSuggestionsQueryVariables = {
  id?: string | null,
  filter?: ModelRecordBriefingSegmentSuggestionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListRecordBriefingSegmentSuggestionsQuery = {
  listRecordBriefingSegmentSuggestions?:  {
    __typename: "ModelRecordBriefingSegmentSuggestionConnection",
    items:  Array< {
      __typename: "RecordBriefingSegmentSuggestion",
      id: string,
      briefingID: string,
      logicalSegmentID: string,
      suggestionType: SegmentSuggestionType,
      reason: SegmentSuggestionReason,
      reasonDetails?: string | null,
      textRange?:  {
        __typename: "TextRange",
        textToDelete: string,
        occurrenceIndex?: number | null,
        prefixContext?: string | null,
        suffixContext?: string | null,
      } | null,
      status: SegmentSuggestionStatus,
      resolvedBy?: string | null,
      resolvedAt?: string | null,
      seen?: boolean | null,
      confidence?: number | null,
      relatedSegmentID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SuggestionsByBriefingIdQueryVariables = {
  briefingID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRecordBriefingSegmentSuggestionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SuggestionsByBriefingIdQuery = {
  suggestionsByBriefingId?:  {
    __typename: "ModelRecordBriefingSegmentSuggestionConnection",
    items:  Array< {
      __typename: "RecordBriefingSegmentSuggestion",
      id: string,
      briefingID: string,
      logicalSegmentID: string,
      suggestionType: SegmentSuggestionType,
      reason: SegmentSuggestionReason,
      reasonDetails?: string | null,
      textRange?:  {
        __typename: "TextRange",
        textToDelete: string,
        occurrenceIndex?: number | null,
        prefixContext?: string | null,
        suffixContext?: string | null,
      } | null,
      status: SegmentSuggestionStatus,
      resolvedBy?: string | null,
      resolvedAt?: string | null,
      seen?: boolean | null,
      confidence?: number | null,
      relatedSegmentID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSummaryCitationQueryVariables = {
  id: string,
};

export type GetSummaryCitationQuery = {
  getSummaryCitation?:  {
    __typename: "SummaryCitation",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    summaryText: string,
    citationID: string,
    status: SummaryCitationStatus,
    removedBy?: string | null,
    removedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSummaryCitationsQueryVariables = {
  id?: string | null,
  filter?: ModelSummaryCitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSummaryCitationsQuery = {
  listSummaryCitations?:  {
    __typename: "ModelSummaryCitationConnection",
    items:  Array< {
      __typename: "SummaryCitation",
      id: string,
      briefingID: string,
      logicalSegmentID: string,
      summaryText: string,
      citationID: string,
      status: SummaryCitationStatus,
      removedBy?: string | null,
      removedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SummaryCitationsByBriefingIdQueryVariables = {
  briefingID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSummaryCitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SummaryCitationsByBriefingIdQuery = {
  summaryCitationsByBriefingId?:  {
    __typename: "ModelSummaryCitationConnection",
    items:  Array< {
      __typename: "SummaryCitation",
      id: string,
      briefingID: string,
      logicalSegmentID: string,
      summaryText: string,
      citationID: string,
      status: SummaryCitationStatus,
      removedBy?: string | null,
      removedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SummaryCitationsByLogicalSegmentIdQueryVariables = {
  logicalSegmentID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSummaryCitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SummaryCitationsByLogicalSegmentIdQuery = {
  summaryCitationsByLogicalSegmentId?:  {
    __typename: "ModelSummaryCitationConnection",
    items:  Array< {
      __typename: "SummaryCitation",
      id: string,
      briefingID: string,
      logicalSegmentID: string,
      summaryText: string,
      citationID: string,
      status: SummaryCitationStatus,
      removedBy?: string | null,
      removedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSuggestionQueryVariables = {
  id: string,
};

export type GetSuggestionQuery = {
  getSuggestion?:  {
    __typename: "Suggestion",
    id: string,
    appointmentID: string,
    source: SuggestionSource,
    changeType: SuggestionChangeType,
    resourceURI: string,
    suggestedValue?: string | null,
    existingValue?: string | null,
    rationale?: string | null,
    status?: SuggestionStatus | null,
    resolvedByUserID?: string | null,
    resolvedAt?: string | null,
    versionID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSuggestionsQueryVariables = {
  id?: string | null,
  filter?: ModelSuggestionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSuggestionsQuery = {
  listSuggestions?:  {
    __typename: "ModelSuggestionConnection",
    items:  Array< {
      __typename: "Suggestion",
      id: string,
      appointmentID: string,
      source: SuggestionSource,
      changeType: SuggestionChangeType,
      resourceURI: string,
      suggestedValue?: string | null,
      existingValue?: string | null,
      rationale?: string | null,
      status?: SuggestionStatus | null,
      resolvedByUserID?: string | null,
      resolvedAt?: string | null,
      versionID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SuggestionsByAppointmentQueryVariables = {
  appointmentID: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSuggestionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SuggestionsByAppointmentQuery = {
  suggestionsByAppointment?:  {
    __typename: "ModelSuggestionConnection",
    items:  Array< {
      __typename: "Suggestion",
      id: string,
      appointmentID: string,
      source: SuggestionSource,
      changeType: SuggestionChangeType,
      resourceURI: string,
      suggestedValue?: string | null,
      existingValue?: string | null,
      rationale?: string | null,
      status?: SuggestionStatus | null,
      resolvedByUserID?: string | null,
      resolvedAt?: string | null,
      versionID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SuggestionsByVersionQueryVariables = {
  versionID: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSuggestionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SuggestionsByVersionQuery = {
  suggestionsByVersion?:  {
    __typename: "ModelSuggestionConnection",
    items:  Array< {
      __typename: "Suggestion",
      id: string,
      appointmentID: string,
      source: SuggestionSource,
      changeType: SuggestionChangeType,
      resourceURI: string,
      suggestedValue?: string | null,
      existingValue?: string | null,
      rationale?: string | null,
      status?: SuggestionStatus | null,
      resolvedByUserID?: string | null,
      resolvedAt?: string | null,
      versionID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOnsiteOpsConfigQueryVariables = {
  doctorLocationKey: string,
};

export type GetOnsiteOpsConfigQuery = {
  getOnsiteOpsConfig?:  {
    __typename: "OnsiteOpsConfig",
    doctorLocationKey: string,
    doctor?:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null,
    location?:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    } | null,
    medicalAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    secondaryMedicalAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    assignmentEffectiveDate?: string | null,
    createdAt: string,
    updatedAt: string,
    onsiteOpsConfigDoctorId?: string | null,
    onsiteOpsConfigLocationId?: string | null,
    onsiteOpsConfigMedicalAssistantId?: string | null,
    onsiteOpsConfigSecondaryMedicalAssistantId?: string | null,
  } | null,
};

export type ListOnsiteOpsConfigsQueryVariables = {
  doctorLocationKey?: string | null,
  filter?: ModelOnsiteOpsConfigFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListOnsiteOpsConfigsQuery = {
  listOnsiteOpsConfigs?:  {
    __typename: "ModelOnsiteOpsConfigConnection",
    items:  Array< {
      __typename: "OnsiteOpsConfig",
      doctorLocationKey: string,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryMedicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      assignmentEffectiveDate?: string | null,
      createdAt: string,
      updatedAt: string,
      onsiteOpsConfigDoctorId?: string | null,
      onsiteOpsConfigLocationId?: string | null,
      onsiteOpsConfigMedicalAssistantId?: string | null,
      onsiteOpsConfigSecondaryMedicalAssistantId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOpsGlobalSettingsQueryVariables = {
  key: string,
};

export type GetOpsGlobalSettingsQuery = {
  getOpsGlobalSettings?:  {
    __typename: "OpsGlobalSettings",
    key: string,
    inPersonEvaluationPreVisitDurationDays?: number | null,
    supplementalPreVisitDurationDays?: number | null,
    depositionPreVisitDurationDays?: number | null,
    defaultGlobalOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalMA?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalScheduler?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalReportOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalPreVisitReviewer?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultGlobalBillingOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    appointmentTypeMAAssignments?:  Array< {
      __typename: "AppointmentTypeMAAssignment",
      appointmentType: AppointmentType,
      maWeights:  Array< {
        __typename: "AppointmentTypeMAWeight",
        medicalAssistantID: string,
        weightPercentage: number,
      } >,
    } | null > | null,
    maAssignmentCapacitySettings?:  {
      __typename: "MAAssignmentCapacitySettings",
      level1WeeklyPointBudget: number,
      level2WeeklyPointBudget: number,
      level3WeeklyPointBudget: number,
      level4WeeklyPointBudget: number,
      maxAppointmentsPerMAWeek: number,
      maxAppointmentsPerMADay?: number | null,
    } | null,
    bodyPartSpecialtiesMappings?:  Array< {
      __typename: "BodyPartSpecialtiesMapping",
      bodyPart: BodyPart,
      specialties: Array< SpecialtyType >,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    opsGlobalSettingsDefaultGlobalOnsiteOpsId?: string | null,
    opsGlobalSettingsDefaultGlobalMAId?: string | null,
    opsGlobalSettingsDefaultGlobalSchedulerId?: string | null,
    opsGlobalSettingsDefaultGlobalReportOpsId?: string | null,
    opsGlobalSettingsDefaultGlobalPreVisitReviewerId?: string | null,
    opsGlobalSettingsDefaultGlobalBillingOpsId?: string | null,
  } | null,
};

export type ListOpsGlobalSettingsQueryVariables = {
  key?: string | null,
  filter?: ModelOpsGlobalSettingsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListOpsGlobalSettingsQuery = {
  listOpsGlobalSettings?:  {
    __typename: "ModelOpsGlobalSettingsConnection",
    items:  Array< {
      __typename: "OpsGlobalSettings",
      key: string,
      inPersonEvaluationPreVisitDurationDays?: number | null,
      supplementalPreVisitDurationDays?: number | null,
      depositionPreVisitDurationDays?: number | null,
      defaultGlobalOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultGlobalMA?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultGlobalScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultGlobalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultGlobalPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultGlobalBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentTypeMAAssignments?:  Array< {
        __typename: "AppointmentTypeMAAssignment",
        appointmentType: AppointmentType,
        maWeights:  Array< {
          __typename: "AppointmentTypeMAWeight",
          medicalAssistantID: string,
          weightPercentage: number,
        } >,
      } | null > | null,
      maAssignmentCapacitySettings?:  {
        __typename: "MAAssignmentCapacitySettings",
        level1WeeklyPointBudget: number,
        level2WeeklyPointBudget: number,
        level3WeeklyPointBudget: number,
        level4WeeklyPointBudget: number,
        maxAppointmentsPerMAWeek: number,
        maxAppointmentsPerMADay?: number | null,
      } | null,
      bodyPartSpecialtiesMappings?:  Array< {
        __typename: "BodyPartSpecialtiesMapping",
        bodyPart: BodyPart,
        specialties: Array< SpecialtyType >,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
      opsGlobalSettingsDefaultGlobalOnsiteOpsId?: string | null,
      opsGlobalSettingsDefaultGlobalMAId?: string | null,
      opsGlobalSettingsDefaultGlobalSchedulerId?: string | null,
      opsGlobalSettingsDefaultGlobalReportOpsId?: string | null,
      opsGlobalSettingsDefaultGlobalPreVisitReviewerId?: string | null,
      opsGlobalSettingsDefaultGlobalBillingOpsId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSpecialtyCategoryQueryVariables = {
  id: string,
};

export type GetSpecialtyCategoryQuery = {
  getSpecialtyCategory?:  {
    __typename: "SpecialtyCategory",
    id: string,
    name: string,
    specialties?: Array< SpecialtyType > | null,
    fallbackMA?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    medicalAssistants?:  {
      __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
      items:  Array< {
        __typename: "MedicalAssistantSpecialtyCategory",
        id: string,
        medicalAssistantId: string,
        specialtyCategoryId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        specialtyCategory:  {
          __typename: "SpecialtyCategory",
          id: string,
          name: string,
          specialties?: Array< SpecialtyType > | null,
          createdAt: string,
          updatedAt: string,
          specialtyCategoryFallbackMAId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    specialtyCategoryFallbackMAId?: string | null,
  } | null,
};

export type ListSpecialtyCategoriesQueryVariables = {
  filter?: ModelSpecialtyCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSpecialtyCategoriesQuery = {
  listSpecialtyCategories?:  {
    __typename: "ModelSpecialtyCategoryConnection",
    items:  Array< {
      __typename: "SpecialtyCategory",
      id: string,
      name: string,
      specialties?: Array< SpecialtyType > | null,
      fallbackMA?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      medicalAssistants?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      specialtyCategoryFallbackMAId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCoverLetterRecapQueryVariables = {
  id: string,
};

export type GetCoverLetterRecapQuery = {
  getCoverLetterRecap?:  {
    __typename: "CoverLetterRecap",
    id: string,
    uploadedFileID: string,
    recapText?: string | null,
    status: CoverLetterRecapStatus,
    errorMessage?: string | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCoverLetterRecapsQueryVariables = {
  filter?: ModelCoverLetterRecapFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCoverLetterRecapsQuery = {
  listCoverLetterRecaps?:  {
    __typename: "ModelCoverLetterRecapConnection",
    items:  Array< {
      __typename: "CoverLetterRecap",
      id: string,
      uploadedFileID: string,
      recapText?: string | null,
      status: CoverLetterRecapStatus,
      errorMessage?: string | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CoverLetterRecapsByUploadedFileIDQueryVariables = {
  uploadedFileID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCoverLetterRecapFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CoverLetterRecapsByUploadedFileIDQuery = {
  coverLetterRecapsByUploadedFileID?:  {
    __typename: "ModelCoverLetterRecapConnection",
    items:  Array< {
      __typename: "CoverLetterRecap",
      id: string,
      uploadedFileID: string,
      recapText?: string | null,
      status: CoverLetterRecapStatus,
      errorMessage?: string | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetIntroParagraphQueryVariables = {
  id: string,
};

export type GetIntroParagraphQuery = {
  getIntroParagraph?:  {
    __typename: "IntroParagraph",
    id: string,
    appointmentRecordID: string,
    introParagraphText?: string | null,
    sourceRecaps?:  Array< {
      __typename: "CoverLetterRecapSnapshot",
      coverLetterRecapID: string,
      uploadedFileID: string,
      recapText: string,
      generatedAt?: string | null,
    } | null > | null,
    status: IntroParagraphStatus,
    errorMessage?: string | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListIntroParagraphsQueryVariables = {
  filter?: ModelIntroParagraphFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIntroParagraphsQuery = {
  listIntroParagraphs?:  {
    __typename: "ModelIntroParagraphConnection",
    items:  Array< {
      __typename: "IntroParagraph",
      id: string,
      appointmentRecordID: string,
      introParagraphText?: string | null,
      sourceRecaps?:  Array< {
        __typename: "CoverLetterRecapSnapshot",
        coverLetterRecapID: string,
        uploadedFileID: string,
        recapText: string,
        generatedAt?: string | null,
      } | null > | null,
      status: IntroParagraphStatus,
      errorMessage?: string | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type IntroParagraphsByAppointmentRecordIDQueryVariables = {
  appointmentRecordID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelIntroParagraphFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type IntroParagraphsByAppointmentRecordIDQuery = {
  introParagraphsByAppointmentRecordID?:  {
    __typename: "ModelIntroParagraphConnection",
    items:  Array< {
      __typename: "IntroParagraph",
      id: string,
      appointmentRecordID: string,
      introParagraphText?: string | null,
      sourceRecaps?:  Array< {
        __typename: "CoverLetterRecapSnapshot",
        coverLetterRecapID: string,
        uploadedFileID: string,
        recapText: string,
        generatedAt?: string | null,
      } | null > | null,
      status: IntroParagraphStatus,
      errorMessage?: string | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetIntroductionStatementQueryVariables = {
  id: string,
};

export type GetIntroductionStatementQuery = {
  getIntroductionStatement?:  {
    __typename: "IntroductionStatement",
    id: string,
    appointmentRecordID: string,
    kind: IntroductionStatementKind,
    text?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    selectedCoverLetterFileID?: string | null,
    selectionConfirmedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListIntroductionStatementsQueryVariables = {
  filter?: ModelIntroductionStatementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIntroductionStatementsQuery = {
  listIntroductionStatements?:  {
    __typename: "ModelIntroductionStatementConnection",
    items:  Array< {
      __typename: "IntroductionStatement",
      id: string,
      appointmentRecordID: string,
      kind: IntroductionStatementKind,
      text?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      selectedCoverLetterFileID?: string | null,
      selectionConfirmedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type IntroductionStatementsByAppointmentRecordIDQueryVariables = {
  appointmentRecordID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelIntroductionStatementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type IntroductionStatementsByAppointmentRecordIDQuery = {
  introductionStatementsByAppointmentRecordID?:  {
    __typename: "ModelIntroductionStatementConnection",
    items:  Array< {
      __typename: "IntroductionStatement",
      id: string,
      appointmentRecordID: string,
      kind: IntroductionStatementKind,
      text?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      selectedCoverLetterFileID?: string | null,
      selectionConfirmedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAssessmentQueryVariables = {
  id: string,
};

export type GetAssessmentQuery = {
  getAssessment?:  {
    __typename: "Assessment",
    id: string,
    injuries?:  Array< {
      __typename: "AssessmentInjury",
      injuryType?: InjuryType | null,
      dateOfInjury?: string | null,
      dateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      dateOfInjuryEnd?: string | null,
      dateOfInjuryEndFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      bodyParts?: Array< BodyPart | null > | null,
      causeOfInjury?: string | null,
      causedByWork?: AssessmentCausationOption | null,
      causedByWorkExplanation?: string | null,
    } | null > | null,
    discussedBodyParts?: Array< BodyPart | null > | null,
    bodyPartsNotDiscussedReason?: string | null,
    discussions?: string | null,
    diagnoses?:  Array< {
      __typename: "AssessmentDiagnosis",
      diagnosis?: string | null,
      icdCode?: string | null,
      evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
      evidence?: string | null,
    } | null > | null,
    bodyPartMMIStatus?:  {
      __typename: "AssessmentBodyPartMMIStatus",
      discussByBodyPart?: boolean | null,
      allBodyPartsMMI?:  {
        __typename: "AssessmentBodyPartEvaluation",
        mmi?: boolean | null,
        mmiReason?: string | null,
        expectedMMITimeRange?: AssessmentMmiTimeRange | null,
        expectedMMITimeRangeExplanation?: string | null,
        treatments?: Array< string | null > | null,
        treatmentsExplanation?: string | null,
        discussions?: string | null,
        impairmentRating?: string | null,
        impairmentRatingNotApplicable?: boolean | null,
        deferImpairmentRating?: boolean | null,
        deferImpairmentRatingReason?: string | null,
        apportionment?: string | null,
        apportionmentNotApplicable?: boolean | null,
        deferApportionment?: boolean | null,
        deferApportionmentReason?: string | null,
      } | null,
      bodyPartMMIStatuses?:  Array< {
        __typename: "AssessmentBodyPart",
        bodyPart?: BodyPart | null,
        evaluation?:  {
          __typename: "AssessmentBodyPartEvaluation",
          mmi?: boolean | null,
          mmiReason?: string | null,
          expectedMMITimeRange?: AssessmentMmiTimeRange | null,
          expectedMMITimeRangeExplanation?: string | null,
          treatments?: Array< string | null > | null,
          treatmentsExplanation?: string | null,
          discussions?: string | null,
          impairmentRating?: string | null,
          impairmentRatingNotApplicable?: boolean | null,
          deferImpairmentRating?: boolean | null,
          deferImpairmentRatingReason?: string | null,
          apportionment?: string | null,
          apportionmentNotApplicable?: boolean | null,
          deferApportionment?: boolean | null,
          deferApportionmentReason?: string | null,
        } | null,
      } | null > | null,
    } | null,
    workStatus?: string | null,
    markedAsDone?: boolean | null,
    discussDiagnosesFreeForm?: boolean | null,
    diagnosesFreeform?: string | null,
    discussCausationFreeForm?: boolean | null,
    causationFreeForm?: string | null,
    discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
    hasPatientReachedMMIFreeForm?: string | null,
    discussMMIByBodyPartFreeForm?: string | null,
    impairmentRatingByBodyPartFreeForm?: string | null,
    apportionmentByBodyPartFreeForm?: string | null,
    impairmentRatingOtherComments?: string | null,
    apportionmentOtherComments?: string | null,
    assessmentMode?: AssessmentMode | null,
    assessmentFreeForm?:  {
      __typename: "AssessmentFreeForm",
      injuries?:  Array< {
        __typename: "AssessmentInjury",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        dateOfInjuryEnd?: string | null,
        dateOfInjuryEndFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        bodyParts?: Array< BodyPart | null > | null,
        causeOfInjury?: string | null,
        causedByWork?: AssessmentCausationOption | null,
        causedByWorkExplanation?: string | null,
      } | null > | null,
      discussions?: string | null,
      diagnosesAndEvidence?: string | null,
      causation?: string | null,
      hasPatientReachedMMI?: string | null,
      discussMMIByBodyPart?: string | null,
      impairmentRatingByBodyPart?: string | null,
      apportionmentByBodyPart?: string | null,
      workStatus?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAssessmentsQueryVariables = {
  id?: string | null,
  filter?: ModelAssessmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAssessmentsQuery = {
  listAssessments?:  {
    __typename: "ModelAssessmentConnection",
    items:  Array< {
      __typename: "Assessment",
      id: string,
      injuries?:  Array< {
        __typename: "AssessmentInjury",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        dateOfInjuryEnd?: string | null,
        dateOfInjuryEndFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        bodyParts?: Array< BodyPart | null > | null,
        causeOfInjury?: string | null,
        causedByWork?: AssessmentCausationOption | null,
        causedByWorkExplanation?: string | null,
      } | null > | null,
      discussedBodyParts?: Array< BodyPart | null > | null,
      bodyPartsNotDiscussedReason?: string | null,
      discussions?: string | null,
      diagnoses?:  Array< {
        __typename: "AssessmentDiagnosis",
        diagnosis?: string | null,
        icdCode?: string | null,
        evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
        evidence?: string | null,
      } | null > | null,
      bodyPartMMIStatus?:  {
        __typename: "AssessmentBodyPartMMIStatus",
        discussByBodyPart?: boolean | null,
        allBodyPartsMMI?:  {
          __typename: "AssessmentBodyPartEvaluation",
          mmi?: boolean | null,
          mmiReason?: string | null,
          expectedMMITimeRange?: AssessmentMmiTimeRange | null,
          expectedMMITimeRangeExplanation?: string | null,
          treatments?: Array< string | null > | null,
          treatmentsExplanation?: string | null,
          discussions?: string | null,
          impairmentRating?: string | null,
          impairmentRatingNotApplicable?: boolean | null,
          deferImpairmentRating?: boolean | null,
          deferImpairmentRatingReason?: string | null,
          apportionment?: string | null,
          apportionmentNotApplicable?: boolean | null,
          deferApportionment?: boolean | null,
          deferApportionmentReason?: string | null,
        } | null,
        bodyPartMMIStatuses?:  Array< {
          __typename: "AssessmentBodyPart",
          bodyPart?: BodyPart | null,
        } | null > | null,
      } | null,
      workStatus?: string | null,
      markedAsDone?: boolean | null,
      discussDiagnosesFreeForm?: boolean | null,
      diagnosesFreeform?: string | null,
      discussCausationFreeForm?: boolean | null,
      causationFreeForm?: string | null,
      discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
      hasPatientReachedMMIFreeForm?: string | null,
      discussMMIByBodyPartFreeForm?: string | null,
      impairmentRatingByBodyPartFreeForm?: string | null,
      apportionmentByBodyPartFreeForm?: string | null,
      impairmentRatingOtherComments?: string | null,
      apportionmentOtherComments?: string | null,
      assessmentMode?: AssessmentMode | null,
      assessmentFreeForm?:  {
        __typename: "AssessmentFreeForm",
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussions?: string | null,
        diagnosesAndEvidence?: string | null,
        causation?: string | null,
        hasPatientReachedMMI?: string | null,
        discussMMIByBodyPart?: string | null,
        impairmentRatingByBodyPart?: string | null,
        apportionmentByBodyPart?: string | null,
        workStatus?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetValidationCheckQueryVariables = {
  id: string,
};

export type GetValidationCheckQuery = {
  getValidationCheck?:  {
    __typename: "ValidationCheck",
    id: string,
    validationID: string,
    checkType: string,
    inputResourceURIs: Array< string | null >,
    status: ValidationStatus,
    issues?:  {
      __typename: "ModelValidationIssueConnection",
      items:  Array< {
        __typename: "ValidationIssue",
        id: string,
        validationID: string,
        validationCheckID: string,
        title?: string | null,
        issue: string,
        status: ValidationStatus,
        resourceURI: string,
        issueGroup: string,
        issueType?: ValidationIssueType | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListValidationChecksQueryVariables = {
  id?: string | null,
  filter?: ModelValidationCheckFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListValidationChecksQuery = {
  listValidationChecks?:  {
    __typename: "ModelValidationCheckConnection",
    items:  Array< {
      __typename: "ValidationCheck",
      id: string,
      validationID: string,
      checkType: string,
      inputResourceURIs: Array< string | null >,
      status: ValidationStatus,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ValidationChecksByValidationIDQueryVariables = {
  validationID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelValidationCheckFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ValidationChecksByValidationIDQuery = {
  validationChecksByValidationID?:  {
    __typename: "ModelValidationCheckConnection",
    items:  Array< {
      __typename: "ValidationCheck",
      id: string,
      validationID: string,
      checkType: string,
      inputResourceURIs: Array< string | null >,
      status: ValidationStatus,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetValidationIssueQueryVariables = {
  id: string,
};

export type GetValidationIssueQuery = {
  getValidationIssue?:  {
    __typename: "ValidationIssue",
    id: string,
    validationID: string,
    validationCheckID: string,
    title?: string | null,
    issue: string,
    status: ValidationStatus,
    resourceURI: string,
    issueGroup: string,
    issueType?: ValidationIssueType | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListValidationIssuesQueryVariables = {
  id?: string | null,
  filter?: ModelValidationIssueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListValidationIssuesQuery = {
  listValidationIssues?:  {
    __typename: "ModelValidationIssueConnection",
    items:  Array< {
      __typename: "ValidationIssue",
      id: string,
      validationID: string,
      validationCheckID: string,
      title?: string | null,
      issue: string,
      status: ValidationStatus,
      resourceURI: string,
      issueGroup: string,
      issueType?: ValidationIssueType | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ValidationIssuesByValidationIDQueryVariables = {
  validationID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelValidationIssueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ValidationIssuesByValidationIDQuery = {
  validationIssuesByValidationID?:  {
    __typename: "ModelValidationIssueConnection",
    items:  Array< {
      __typename: "ValidationIssue",
      id: string,
      validationID: string,
      validationCheckID: string,
      title?: string | null,
      issue: string,
      status: ValidationStatus,
      resourceURI: string,
      issueGroup: string,
      issueType?: ValidationIssueType | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ValidationIssuesByValidationCheckIDQueryVariables = {
  validationCheckID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelValidationIssueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ValidationIssuesByValidationCheckIDQuery = {
  validationIssuesByValidationCheckID?:  {
    __typename: "ModelValidationIssueConnection",
    items:  Array< {
      __typename: "ValidationIssue",
      id: string,
      validationID: string,
      validationCheckID: string,
      title?: string | null,
      issue: string,
      status: ValidationStatus,
      resourceURI: string,
      issueGroup: string,
      issueType?: ValidationIssueType | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ValidationIssuesByResourceURIQueryVariables = {
  resourceURI: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelValidationIssueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ValidationIssuesByResourceURIQuery = {
  validationIssuesByResourceURI?:  {
    __typename: "ModelValidationIssueConnection",
    items:  Array< {
      __typename: "ValidationIssue",
      id: string,
      validationID: string,
      validationCheckID: string,
      title?: string | null,
      issue: string,
      status: ValidationStatus,
      resourceURI: string,
      issueGroup: string,
      issueType?: ValidationIssueType | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetValidationQueryVariables = {
  id: string,
};

export type GetValidationQuery = {
  getValidation?:  {
    __typename: "Validation",
    id: string,
    issueGroups: Array< string | null >,
    issues?:  {
      __typename: "ModelValidationIssueConnection",
      items:  Array< {
        __typename: "ValidationIssue",
        id: string,
        validationID: string,
        validationCheckID: string,
        title?: string | null,
        issue: string,
        status: ValidationStatus,
        resourceURI: string,
        issueGroup: string,
        issueType?: ValidationIssueType | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListValidationsQueryVariables = {
  id?: string | null,
  filter?: ModelValidationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListValidationsQuery = {
  listValidations?:  {
    __typename: "ModelValidationConnection",
    items:  Array< {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetWorkflowAuditEntryQueryVariables = {
  id: string,
};

export type GetWorkflowAuditEntryQuery = {
  getWorkflowAuditEntry?:  {
    __typename: "WorkflowAuditEntry",
    id: string,
    workflowAuditID: string,
    message: string,
    actorType?: UserGroup | null,
    actorID?: string | null,
    entryType?: string | null,
    attachments:  Array< {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } >,
    relatedActionIDs?: Array< string > | null,
    payload?: string | null,
    correlationID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListWorkflowAuditEntriesQueryVariables = {
  id?: string | null,
  filter?: ModelWorkflowAuditEntryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListWorkflowAuditEntriesQuery = {
  listWorkflowAuditEntries?:  {
    __typename: "ModelWorkflowAuditEntryConnection",
    items:  Array< {
      __typename: "WorkflowAuditEntry",
      id: string,
      workflowAuditID: string,
      message: string,
      actorType?: UserGroup | null,
      actorID?: string | null,
      entryType?: string | null,
      attachments:  Array< {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } >,
      relatedActionIDs?: Array< string > | null,
      payload?: string | null,
      correlationID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type WorkflowAuditEntriesByWorkflowAuditIDQueryVariables = {
  workflowAuditID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelWorkflowAuditEntryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type WorkflowAuditEntriesByWorkflowAuditIDQuery = {
  workflowAuditEntriesByWorkflowAuditID?:  {
    __typename: "ModelWorkflowAuditEntryConnection",
    items:  Array< {
      __typename: "WorkflowAuditEntry",
      id: string,
      workflowAuditID: string,
      message: string,
      actorType?: UserGroup | null,
      actorID?: string | null,
      entryType?: string | null,
      attachments:  Array< {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } >,
      relatedActionIDs?: Array< string > | null,
      payload?: string | null,
      correlationID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetWorkflowAuditQueryVariables = {
  id: string,
};

export type GetWorkflowAuditQuery = {
  getWorkflowAudit?:  {
    __typename: "WorkflowAudit",
    id: string,
    workflowType: string,
    entityID: string,
    entityType: string,
    appointmentID?: string | null,
    entries?:  {
      __typename: "ModelWorkflowAuditEntryConnection",
      items:  Array< {
        __typename: "WorkflowAuditEntry",
        id: string,
        workflowAuditID: string,
        message: string,
        actorType?: UserGroup | null,
        actorID?: string | null,
        entryType?: string | null,
        attachments:  Array< {
          __typename: "S3Blob",
          bucket: string,
          key: string,
        } >,
        relatedActionIDs?: Array< string > | null,
        payload?: string | null,
        correlationID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListWorkflowAuditsQueryVariables = {
  id?: string | null,
  filter?: ModelWorkflowAuditFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListWorkflowAuditsQuery = {
  listWorkflowAudits?:  {
    __typename: "ModelWorkflowAuditConnection",
    items:  Array< {
      __typename: "WorkflowAudit",
      id: string,
      workflowType: string,
      entityID: string,
      entityType: string,
      appointmentID?: string | null,
      entries?:  {
        __typename: "ModelWorkflowAuditEntryConnection",
        items:  Array< {
          __typename: "WorkflowAuditEntry",
          id: string,
          workflowAuditID: string,
          message: string,
          actorType?: UserGroup | null,
          actorID?: string | null,
          entryType?: string | null,
          relatedActionIDs?: Array< string > | null,
          payload?: string | null,
          correlationID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type WorkflowAuditsByWorkflowTypeAndEntityTypeAndEntityIDQueryVariables = {
  workflowType: string,
  entityTypeEntityID?: ModelWorkflowAuditByWorkflowTypeCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelWorkflowAuditFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type WorkflowAuditsByWorkflowTypeAndEntityTypeAndEntityIDQuery = {
  workflowAuditsByWorkflowTypeAndEntityTypeAndEntityID?:  {
    __typename: "ModelWorkflowAuditConnection",
    items:  Array< {
      __typename: "WorkflowAudit",
      id: string,
      workflowType: string,
      entityID: string,
      entityType: string,
      appointmentID?: string | null,
      entries?:  {
        __typename: "ModelWorkflowAuditEntryConnection",
        items:  Array< {
          __typename: "WorkflowAuditEntry",
          id: string,
          workflowAuditID: string,
          message: string,
          actorType?: UserGroup | null,
          actorID?: string | null,
          entryType?: string | null,
          relatedActionIDs?: Array< string > | null,
          payload?: string | null,
          correlationID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type WorkflowAuditsByEntityIDAndEntityTypeQueryVariables = {
  entityID: string,
  entityType?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelWorkflowAuditFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type WorkflowAuditsByEntityIDAndEntityTypeQuery = {
  workflowAuditsByEntityIDAndEntityType?:  {
    __typename: "ModelWorkflowAuditConnection",
    items:  Array< {
      __typename: "WorkflowAudit",
      id: string,
      workflowType: string,
      entityID: string,
      entityType: string,
      appointmentID?: string | null,
      entries?:  {
        __typename: "ModelWorkflowAuditEntryConnection",
        items:  Array< {
          __typename: "WorkflowAuditEntry",
          id: string,
          workflowAuditID: string,
          message: string,
          actorType?: UserGroup | null,
          actorID?: string | null,
          entryType?: string | null,
          relatedActionIDs?: Array< string > | null,
          payload?: string | null,
          correlationID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type WorkflowAuditsByAppointmentIDQueryVariables = {
  appointmentID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelWorkflowAuditFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type WorkflowAuditsByAppointmentIDQuery = {
  workflowAuditsByAppointmentID?:  {
    __typename: "ModelWorkflowAuditConnection",
    items:  Array< {
      __typename: "WorkflowAudit",
      id: string,
      workflowType: string,
      entityID: string,
      entityType: string,
      appointmentID?: string | null,
      entries?:  {
        __typename: "ModelWorkflowAuditEntryConnection",
        items:  Array< {
          __typename: "WorkflowAuditEntry",
          id: string,
          workflowAuditID: string,
          message: string,
          actorType?: UserGroup | null,
          actorID?: string | null,
          entryType?: string | null,
          relatedActionIDs?: Array< string > | null,
          payload?: string | null,
          correlationID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetWorkflowAuditActionQueryVariables = {
  id: string,
};

export type GetWorkflowAuditActionQuery = {
  getWorkflowAuditAction?:  {
    __typename: "WorkflowAuditAction",
    id: string,
    workflowAuditID: string,
    appointmentID?: string | null,
    actionType: string,
    status: WorkflowAuditActionStatus,
    payload: string,
    rationale?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListWorkflowAuditActionsQueryVariables = {
  id?: string | null,
  filter?: ModelWorkflowAuditActionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListWorkflowAuditActionsQuery = {
  listWorkflowAuditActions?:  {
    __typename: "ModelWorkflowAuditActionConnection",
    items:  Array< {
      __typename: "WorkflowAuditAction",
      id: string,
      workflowAuditID: string,
      appointmentID?: string | null,
      actionType: string,
      status: WorkflowAuditActionStatus,
      payload: string,
      rationale?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type WorkflowAuditActionsByWorkflowAuditIDQueryVariables = {
  workflowAuditID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelWorkflowAuditActionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type WorkflowAuditActionsByWorkflowAuditIDQuery = {
  workflowAuditActionsByWorkflowAuditID?:  {
    __typename: "ModelWorkflowAuditActionConnection",
    items:  Array< {
      __typename: "WorkflowAuditAction",
      id: string,
      workflowAuditID: string,
      appointmentID?: string | null,
      actionType: string,
      status: WorkflowAuditActionStatus,
      payload: string,
      rationale?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type WorkflowAuditActionsByAppointmentIDQueryVariables = {
  appointmentID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelWorkflowAuditActionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type WorkflowAuditActionsByAppointmentIDQuery = {
  workflowAuditActionsByAppointmentID?:  {
    __typename: "ModelWorkflowAuditActionConnection",
    items:  Array< {
      __typename: "WorkflowAuditAction",
      id: string,
      workflowAuditID: string,
      appointmentID?: string | null,
      actionType: string,
      status: WorkflowAuditActionStatus,
      payload: string,
      rationale?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFormDataDraftQueryVariables = {
  id: string,
  timestamp: string,
};

export type GetFormDataDraftQuery = {
  getFormDataDraft?:  {
    __typename: "FormDataDraft",
    id: string,
    timestamp: string,
    formType: string,
    appointmentId: string,
    data: string,
    ttl?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFormDataDraftsQueryVariables = {
  id?: string | null,
  timestamp?: ModelStringKeyConditionInput | null,
  filter?: ModelFormDataDraftFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFormDataDraftsQuery = {
  listFormDataDrafts?:  {
    __typename: "ModelFormDataDraftConnection",
    items:  Array< {
      __typename: "FormDataDraft",
      id: string,
      timestamp: string,
      formType: string,
      appointmentId: string,
      data: string,
      ttl?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FormDataDraftsByAppointmentIdAndTimestampQueryVariables = {
  appointmentId: string,
  timestamp?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFormDataDraftFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FormDataDraftsByAppointmentIdAndTimestampQuery = {
  formDataDraftsByAppointmentIdAndTimestamp?:  {
    __typename: "ModelFormDataDraftConnection",
    items:  Array< {
      __typename: "FormDataDraft",
      id: string,
      timestamp: string,
      formType: string,
      appointmentId: string,
      data: string,
      ttl?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAuditLogQueryVariables = {
  id: string,
  timestamp: string,
};

export type GetAuditLogQuery = {
  getAuditLog?:  {
    __typename: "AuditLog",
    id: string,
    timestamp: string,
    tableName: string,
    recordId: string,
    action: string,
    ttl?: number | null,
    oldImage?: string | null,
    newImage?: string | null,
    changedFields?: Array< string | null > | null,
    eventID?: string | null,
    eventSource?: string | null,
    approximateCreationDateTime?: number | null,
    modifiedBy?: string | null,
    impersonatedBy?: string | null,
    impersonationSessionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAuditLogsQueryVariables = {
  id?: string | null,
  timestamp?: ModelStringKeyConditionInput | null,
  filter?: ModelAuditLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAuditLogsQuery = {
  listAuditLogs?:  {
    __typename: "ModelAuditLogConnection",
    items:  Array< {
      __typename: "AuditLog",
      id: string,
      timestamp: string,
      tableName: string,
      recordId: string,
      action: string,
      ttl?: number | null,
      oldImage?: string | null,
      newImage?: string | null,
      changedFields?: Array< string | null > | null,
      eventID?: string | null,
      eventSource?: string | null,
      approximateCreationDateTime?: number | null,
      modifiedBy?: string | null,
      impersonatedBy?: string | null,
      impersonationSessionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AuditLogsByTableNameAndTimestampQueryVariables = {
  tableName: string,
  timestamp?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAuditLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AuditLogsByTableNameAndTimestampQuery = {
  auditLogsByTableNameAndTimestamp?:  {
    __typename: "ModelAuditLogConnection",
    items:  Array< {
      __typename: "AuditLog",
      id: string,
      timestamp: string,
      tableName: string,
      recordId: string,
      action: string,
      ttl?: number | null,
      oldImage?: string | null,
      newImage?: string | null,
      changedFields?: Array< string | null > | null,
      eventID?: string | null,
      eventSource?: string | null,
      approximateCreationDateTime?: number | null,
      modifiedBy?: string | null,
      impersonatedBy?: string | null,
      impersonationSessionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetHistoryValidationQueryVariables = {
  id: string,
};

export type GetHistoryValidationQuery = {
  getHistoryValidation?:  {
    __typename: "HistoryValidation",
    id: string,
    appointmentRecordID: string,
    status: HistoryValidationStatus,
    groups:  Array< {
      __typename: "HistoryValidationGroup",
      id: string,
      title: string,
      status: HistoryValidationGroupStatus,
      issues:  Array< {
        __typename: "HistoryValidationIssue",
        id: string,
        title: string,
        description?: string | null,
        patientInfoSection?: PatientInfoSection | null,
        issueType?: ValidationIssueType | null,
      } | null >,
    } | null >,
    validatedAt?: string | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListHistoryValidationsQueryVariables = {
  id?: string | null,
  filter?: ModelHistoryValidationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListHistoryValidationsQuery = {
  listHistoryValidations?:  {
    __typename: "ModelHistoryValidationConnection",
    items:  Array< {
      __typename: "HistoryValidation",
      id: string,
      appointmentRecordID: string,
      status: HistoryValidationStatus,
      groups:  Array< {
        __typename: "HistoryValidationGroup",
        id: string,
        title: string,
        status: HistoryValidationGroupStatus,
        issues:  Array< {
          __typename: "HistoryValidationIssue",
          id: string,
          title: string,
          description?: string | null,
          patientInfoSection?: PatientInfoSection | null,
          issueType?: ValidationIssueType | null,
        } | null >,
      } | null >,
      validatedAt?: string | null,
      errorMessage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type HistoryValidationsByAppointmentRecordIDQueryVariables = {
  appointmentRecordID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHistoryValidationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type HistoryValidationsByAppointmentRecordIDQuery = {
  historyValidationsByAppointmentRecordID?:  {
    __typename: "ModelHistoryValidationConnection",
    items:  Array< {
      __typename: "HistoryValidation",
      id: string,
      appointmentRecordID: string,
      status: HistoryValidationStatus,
      groups:  Array< {
        __typename: "HistoryValidationGroup",
        id: string,
        title: string,
        status: HistoryValidationGroupStatus,
        issues:  Array< {
          __typename: "HistoryValidationIssue",
          id: string,
          title: string,
          description?: string | null,
          patientInfoSection?: PatientInfoSection | null,
          issueType?: ValidationIssueType | null,
        } | null >,
      } | null >,
      validatedAt?: string | null,
      errorMessage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFieldTemplateQueryVariables = {
  id: string,
  version: number,
};

export type GetFieldTemplateQuery = {
  getFieldTemplate?:  {
    __typename: "FieldTemplate",
    id: string,
    version: number,
    templateType: FieldTemplateType,
    specialty?: SpecialtyType | null,
    doctorId?: string | null,
    latestMarker?: string | null,
    adlFieldSectionMappings?:  Array< {
      __typename: "ADLFieldSectionMapping",
      ADLFieldSectionID: string,
      ADLFieldIDs: Array< string >,
    } | null > | null,
    medicalHistoryFieldIDs?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    lastUpdatedBy?: string | null,
    changeDescription?: string | null,
  } | null,
};

export type ListFieldTemplatesQueryVariables = {
  id?: string | null,
  version?: ModelIntKeyConditionInput | null,
  filter?: ModelFieldTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFieldTemplatesQuery = {
  listFieldTemplates?:  {
    __typename: "ModelFieldTemplateConnection",
    items:  Array< {
      __typename: "FieldTemplate",
      id: string,
      version: number,
      templateType: FieldTemplateType,
      specialty?: SpecialtyType | null,
      doctorId?: string | null,
      latestMarker?: string | null,
      adlFieldSectionMappings?:  Array< {
        __typename: "ADLFieldSectionMapping",
        ADLFieldSectionID: string,
        ADLFieldIDs: Array< string >,
      } | null > | null,
      medicalHistoryFieldIDs?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      lastUpdatedBy?: string | null,
      changeDescription?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FieldTemplatesByTemplateTypeAndVersionQueryVariables = {
  templateType: FieldTemplateType,
  version?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFieldTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FieldTemplatesByTemplateTypeAndVersionQuery = {
  fieldTemplatesByTemplateTypeAndVersion?:  {
    __typename: "ModelFieldTemplateConnection",
    items:  Array< {
      __typename: "FieldTemplate",
      id: string,
      version: number,
      templateType: FieldTemplateType,
      specialty?: SpecialtyType | null,
      doctorId?: string | null,
      latestMarker?: string | null,
      adlFieldSectionMappings?:  Array< {
        __typename: "ADLFieldSectionMapping",
        ADLFieldSectionID: string,
        ADLFieldIDs: Array< string >,
      } | null > | null,
      medicalHistoryFieldIDs?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      lastUpdatedBy?: string | null,
      changeDescription?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FieldTemplatesBySpecialtyAndVersionQueryVariables = {
  specialty: SpecialtyType,
  version?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFieldTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FieldTemplatesBySpecialtyAndVersionQuery = {
  fieldTemplatesBySpecialtyAndVersion?:  {
    __typename: "ModelFieldTemplateConnection",
    items:  Array< {
      __typename: "FieldTemplate",
      id: string,
      version: number,
      templateType: FieldTemplateType,
      specialty?: SpecialtyType | null,
      doctorId?: string | null,
      latestMarker?: string | null,
      adlFieldSectionMappings?:  Array< {
        __typename: "ADLFieldSectionMapping",
        ADLFieldSectionID: string,
        ADLFieldIDs: Array< string >,
      } | null > | null,
      medicalHistoryFieldIDs?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      lastUpdatedBy?: string | null,
      changeDescription?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FieldTemplatesByDoctorIdAndVersionQueryVariables = {
  doctorId: string,
  version?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFieldTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FieldTemplatesByDoctorIdAndVersionQuery = {
  fieldTemplatesByDoctorIdAndVersion?:  {
    __typename: "ModelFieldTemplateConnection",
    items:  Array< {
      __typename: "FieldTemplate",
      id: string,
      version: number,
      templateType: FieldTemplateType,
      specialty?: SpecialtyType | null,
      doctorId?: string | null,
      latestMarker?: string | null,
      adlFieldSectionMappings?:  Array< {
        __typename: "ADLFieldSectionMapping",
        ADLFieldSectionID: string,
        ADLFieldIDs: Array< string >,
      } | null > | null,
      medicalHistoryFieldIDs?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      lastUpdatedBy?: string | null,
      changeDescription?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FieldTemplatesByLatestMarkerQueryVariables = {
  latestMarker: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFieldTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FieldTemplatesByLatestMarkerQuery = {
  fieldTemplatesByLatestMarker?:  {
    __typename: "ModelFieldTemplateConnection",
    items:  Array< {
      __typename: "FieldTemplate",
      id: string,
      version: number,
      templateType: FieldTemplateType,
      specialty?: SpecialtyType | null,
      doctorId?: string | null,
      latestMarker?: string | null,
      adlFieldSectionMappings?:  Array< {
        __typename: "ADLFieldSectionMapping",
        ADLFieldSectionID: string,
        ADLFieldIDs: Array< string >,
      } | null > | null,
      medicalHistoryFieldIDs?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      lastUpdatedBy?: string | null,
      changeDescription?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPhysicalEvalTemplateQueryVariables = {
  id: string,
  version: number,
};

export type GetPhysicalEvalTemplateQuery = {
  getPhysicalEvalTemplate?:  {
    __typename: "PhysicalEvalTemplate",
    id: string,
    version: number,
    templateType: PhysicalEvalTemplateType,
    specialtyCategoryId: string,
    doctorId?: string | null,
    latestMarker?: string | null,
    exams?:  Array< {
      __typename: "PhysicalExam",
      examID: string,
      name: string,
      bodyParts: Array< BodyPart >,
      instructions?: string | null,
      sections?:  Array< {
        __typename: "PhysicalExamSection",
        sectionID: string,
        name: string,
        fieldType: PhysicalExamFieldType,
        config?:  {
          __typename: "PhysicalExamSectionConfig",
          minValue?: number | null,
          maxValue?: number | null,
          increment?: number | null,
          allowPlusMinus?: boolean | null,
          allowPlus?: boolean | null,
          unit?: PhysicalExamUnit | null,
          freeformInputCount?: number | null,
          laterality?: boolean | null,
          hasNote?: boolean | null,
          hasDefault?: boolean | null,
          hasOtherFindings?: boolean | null,
          renderStyle?: PhysicalExamRenderStyle | null,
        } | null,
        questions?:  Array< {
          __typename: "PhysicalExamQuestion",
          questionID: string,
          label: string,
          defaultValue?: string | null,
          defaultValueLeft?: string | null,
          defaultValueRight?: string | null,
          phrasing?: PhysicalExamPhrasing | null,
          positiveText?: string | null,
          negativeText?: string | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    lastUpdatedBy?: string | null,
    changeDescription?: string | null,
  } | null,
};

export type ListPhysicalEvalTemplatesQueryVariables = {
  id?: string | null,
  version?: ModelIntKeyConditionInput | null,
  filter?: ModelPhysicalEvalTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPhysicalEvalTemplatesQuery = {
  listPhysicalEvalTemplates?:  {
    __typename: "ModelPhysicalEvalTemplateConnection",
    items:  Array< {
      __typename: "PhysicalEvalTemplate",
      id: string,
      version: number,
      templateType: PhysicalEvalTemplateType,
      specialtyCategoryId: string,
      doctorId?: string | null,
      latestMarker?: string | null,
      exams?:  Array< {
        __typename: "PhysicalExam",
        examID: string,
        name: string,
        bodyParts: Array< BodyPart >,
        instructions?: string | null,
        sections?:  Array< {
          __typename: "PhysicalExamSection",
          sectionID: string,
          name: string,
          fieldType: PhysicalExamFieldType,
        } | null > | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      lastUpdatedBy?: string | null,
      changeDescription?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PhysicalEvalTemplatesByTemplateTypeAndVersionQueryVariables = {
  templateType: PhysicalEvalTemplateType,
  version?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPhysicalEvalTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PhysicalEvalTemplatesByTemplateTypeAndVersionQuery = {
  physicalEvalTemplatesByTemplateTypeAndVersion?:  {
    __typename: "ModelPhysicalEvalTemplateConnection",
    items:  Array< {
      __typename: "PhysicalEvalTemplate",
      id: string,
      version: number,
      templateType: PhysicalEvalTemplateType,
      specialtyCategoryId: string,
      doctorId?: string | null,
      latestMarker?: string | null,
      exams?:  Array< {
        __typename: "PhysicalExam",
        examID: string,
        name: string,
        bodyParts: Array< BodyPart >,
        instructions?: string | null,
        sections?:  Array< {
          __typename: "PhysicalExamSection",
          sectionID: string,
          name: string,
          fieldType: PhysicalExamFieldType,
        } | null > | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      lastUpdatedBy?: string | null,
      changeDescription?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PhysicalEvalTemplatesBySpecialtyCategoryIdAndVersionQueryVariables = {
  specialtyCategoryId: string,
  version?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPhysicalEvalTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PhysicalEvalTemplatesBySpecialtyCategoryIdAndVersionQuery = {
  physicalEvalTemplatesBySpecialtyCategoryIdAndVersion?:  {
    __typename: "ModelPhysicalEvalTemplateConnection",
    items:  Array< {
      __typename: "PhysicalEvalTemplate",
      id: string,
      version: number,
      templateType: PhysicalEvalTemplateType,
      specialtyCategoryId: string,
      doctorId?: string | null,
      latestMarker?: string | null,
      exams?:  Array< {
        __typename: "PhysicalExam",
        examID: string,
        name: string,
        bodyParts: Array< BodyPart >,
        instructions?: string | null,
        sections?:  Array< {
          __typename: "PhysicalExamSection",
          sectionID: string,
          name: string,
          fieldType: PhysicalExamFieldType,
        } | null > | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      lastUpdatedBy?: string | null,
      changeDescription?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PhysicalEvalTemplatesByDoctorIdAndVersionQueryVariables = {
  doctorId: string,
  version?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPhysicalEvalTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PhysicalEvalTemplatesByDoctorIdAndVersionQuery = {
  physicalEvalTemplatesByDoctorIdAndVersion?:  {
    __typename: "ModelPhysicalEvalTemplateConnection",
    items:  Array< {
      __typename: "PhysicalEvalTemplate",
      id: string,
      version: number,
      templateType: PhysicalEvalTemplateType,
      specialtyCategoryId: string,
      doctorId?: string | null,
      latestMarker?: string | null,
      exams?:  Array< {
        __typename: "PhysicalExam",
        examID: string,
        name: string,
        bodyParts: Array< BodyPart >,
        instructions?: string | null,
        sections?:  Array< {
          __typename: "PhysicalExamSection",
          sectionID: string,
          name: string,
          fieldType: PhysicalExamFieldType,
        } | null > | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      lastUpdatedBy?: string | null,
      changeDescription?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PhysicalEvalTemplatesByLatestMarkerQueryVariables = {
  latestMarker: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPhysicalEvalTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PhysicalEvalTemplatesByLatestMarkerQuery = {
  physicalEvalTemplatesByLatestMarker?:  {
    __typename: "ModelPhysicalEvalTemplateConnection",
    items:  Array< {
      __typename: "PhysicalEvalTemplate",
      id: string,
      version: number,
      templateType: PhysicalEvalTemplateType,
      specialtyCategoryId: string,
      doctorId?: string | null,
      latestMarker?: string | null,
      exams?:  Array< {
        __typename: "PhysicalExam",
        examID: string,
        name: string,
        bodyParts: Array< BodyPart >,
        instructions?: string | null,
        sections?:  Array< {
          __typename: "PhysicalExamSection",
          sectionID: string,
          name: string,
          fieldType: PhysicalExamFieldType,
        } | null > | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      lastUpdatedBy?: string | null,
      changeDescription?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetZendeskTicketQueryVariables = {
  id: string,
};

export type GetZendeskTicketQuery = {
  getZendeskTicket?:  {
    __typename: "ZendeskTicket",
    id: string,
    ticketID: number,
    appointmentRecordID: string,
    recipientParty: InquiringParty,
    isPrimary: boolean,
    isTextTicket?: boolean | null,
    claimNumber: string,
    version: string,
    lastSyncedAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListZendeskTicketsQueryVariables = {
  id?: string | null,
  filter?: ModelZendeskTicketFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListZendeskTicketsQuery = {
  listZendeskTickets?:  {
    __typename: "ModelZendeskTicketConnection",
    items:  Array< {
      __typename: "ZendeskTicket",
      id: string,
      ticketID: number,
      appointmentRecordID: string,
      recipientParty: InquiringParty,
      isPrimary: boolean,
      isTextTicket?: boolean | null,
      claimNumber: string,
      version: string,
      lastSyncedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ZendeskTicketsByAppointmentRecordIDQueryVariables = {
  appointmentRecordID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelZendeskTicketFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ZendeskTicketsByAppointmentRecordIDQuery = {
  zendeskTicketsByAppointmentRecordID?:  {
    __typename: "ModelZendeskTicketConnection",
    items:  Array< {
      __typename: "ZendeskTicket",
      id: string,
      ticketID: number,
      appointmentRecordID: string,
      recipientParty: InquiringParty,
      isPrimary: boolean,
      isTextTicket?: boolean | null,
      claimNumber: string,
      version: string,
      lastSyncedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetScheduledCommunicationQueryVariables = {
  id: string,
};

export type GetScheduledCommunicationQuery = {
  getScheduledCommunication?:  {
    __typename: "ScheduledCommunication",
    id: string,
    appointmentRecordID: string,
    communicationType: CommunicationType,
    targetParty: InquiringParty,
    scheduledDate: string,
    status: CommunicationStatus,
    templateParams?: string | null,
    sentAt?: string | null,
    zendeskTicketID?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListScheduledCommunicationsQueryVariables = {
  id?: string | null,
  filter?: ModelScheduledCommunicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListScheduledCommunicationsQuery = {
  listScheduledCommunications?:  {
    __typename: "ModelScheduledCommunicationConnection",
    items:  Array< {
      __typename: "ScheduledCommunication",
      id: string,
      appointmentRecordID: string,
      communicationType: CommunicationType,
      targetParty: InquiringParty,
      scheduledDate: string,
      status: CommunicationStatus,
      templateParams?: string | null,
      sentAt?: string | null,
      zendeskTicketID?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ScheduledCommunicationsByAppointmentRecordIDQueryVariables = {
  appointmentRecordID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledCommunicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledCommunicationsByAppointmentRecordIDQuery = {
  scheduledCommunicationsByAppointmentRecordID?:  {
    __typename: "ModelScheduledCommunicationConnection",
    items:  Array< {
      __typename: "ScheduledCommunication",
      id: string,
      appointmentRecordID: string,
      communicationType: CommunicationType,
      targetParty: InquiringParty,
      scheduledDate: string,
      status: CommunicationStatus,
      templateParams?: string | null,
      sentAt?: string | null,
      zendeskTicketID?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ScheduledCommunicationsByStatusAndScheduledDateQueryVariables = {
  status: CommunicationStatus,
  scheduledDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledCommunicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledCommunicationsByStatusAndScheduledDateQuery = {
  scheduledCommunicationsByStatusAndScheduledDate?:  {
    __typename: "ModelScheduledCommunicationConnection",
    items:  Array< {
      __typename: "ScheduledCommunication",
      id: string,
      appointmentRecordID: string,
      communicationType: CommunicationType,
      targetParty: InquiringParty,
      scheduledDate: string,
      status: CommunicationStatus,
      templateParams?: string | null,
      sentAt?: string | null,
      zendeskTicketID?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMedicalRecordPageImageTagsQueryVariables = {
  documentID: string,
  pageNumber: number,
};

export type GetMedicalRecordPageImageTagsQuery = {
  getMedicalRecordPageImageTags?:  {
    __typename: "MedicalRecordPageImageTags",
    documentID: string,
    pageNumber: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    isHandWritten?: boolean | null,
    lowQualityPage?: boolean | null,
  } | null,
};

export type ListMedicalRecordPageImageTagsQueryVariables = {
  documentID?: string | null,
  pageNumber?: ModelIntKeyConditionInput | null,
  filter?: ModelMedicalRecordPageImageTagsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListMedicalRecordPageImageTagsQuery = {
  listMedicalRecordPageImageTags?:  {
    __typename: "ModelMedicalRecordPageImageTagsConnection",
    items:  Array< {
      __typename: "MedicalRecordPageImageTags",
      documentID: string,
      pageNumber: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      isHandWritten?: boolean | null,
      lowQualityPage?: boolean | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMedicalRecordSegmentRawTextTagsQueryVariables = {
  documentID: string,
  startPageNumber: number,
};

export type GetMedicalRecordSegmentRawTextTagsQuery = {
  getMedicalRecordSegmentRawTextTags?:  {
    __typename: "MedicalRecordSegmentRawTextTags",
    documentID: string,
    startPageNumber: number,
    endPageNumber: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    isWrongPatient?: boolean | null,
    wrongPatientReasoning?: string | null,
    extractedPatientName?: string | null,
    extractedPatientDob?: string | null,
    extractedPatientSex?: Sex | null,
    wrongPatientPossibility?: WrongPatientPossibility | null,
    doctorName?: string | null,
    doctorNameDetails?: Array< string | null > | null,
    xrayDetails?: string | null,
    mriDetails?: string | null,
    emgDetails?: string | null,
    ctDetails?: string | null,
  } | null,
};

export type ListMedicalRecordSegmentRawTextTagsQueryVariables = {
  documentID?: string | null,
  startPageNumber?: ModelIntKeyConditionInput | null,
  filter?: ModelMedicalRecordSegmentRawTextTagsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListMedicalRecordSegmentRawTextTagsQuery = {
  listMedicalRecordSegmentRawTextTags?:  {
    __typename: "ModelMedicalRecordSegmentRawTextTagsConnection",
    items:  Array< {
      __typename: "MedicalRecordSegmentRawTextTags",
      documentID: string,
      startPageNumber: number,
      endPageNumber: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      isWrongPatient?: boolean | null,
      wrongPatientReasoning?: string | null,
      extractedPatientName?: string | null,
      extractedPatientDob?: string | null,
      extractedPatientSex?: Sex | null,
      wrongPatientPossibility?: WrongPatientPossibility | null,
      doctorName?: string | null,
      doctorNameDetails?: Array< string | null > | null,
      xrayDetails?: string | null,
      mriDetails?: string | null,
      emgDetails?: string | null,
      ctDetails?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAppointmentEventQueryVariables = {
  id: string,
};

export type GetAppointmentEventQuery = {
  getAppointmentEvent?:  {
    __typename: "AppointmentEvent",
    id: string,
    appointmentRecordID: string,
    entity?: string | null,
    entityID?: string | null,
    action?: string | null,
    actorType?: UserGroup | null,
    actorID?: string | null,
    timestamp?: string | null,
    properties?: string | null,
    source?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAppointmentEventsQueryVariables = {
  id?: string | null,
  filter?: ModelAppointmentEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAppointmentEventsQuery = {
  listAppointmentEvents?:  {
    __typename: "ModelAppointmentEventConnection",
    items:  Array< {
      __typename: "AppointmentEvent",
      id: string,
      appointmentRecordID: string,
      entity?: string | null,
      entityID?: string | null,
      action?: string | null,
      actorType?: UserGroup | null,
      actorID?: string | null,
      timestamp?: string | null,
      properties?: string | null,
      source?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentEventsByAppointmentRecordIDQueryVariables = {
  appointmentRecordID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentEventsByAppointmentRecordIDQuery = {
  appointmentEventsByAppointmentRecordID?:  {
    __typename: "ModelAppointmentEventConnection",
    items:  Array< {
      __typename: "AppointmentEvent",
      id: string,
      appointmentRecordID: string,
      entity?: string | null,
      entityID?: string | null,
      action?: string | null,
      actorType?: UserGroup | null,
      actorID?: string | null,
      timestamp?: string | null,
      properties?: string | null,
      source?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentEventsByEntityAndEntityIDQueryVariables = {
  entity: string,
  entityID?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentEventsByEntityAndEntityIDQuery = {
  appointmentEventsByEntityAndEntityID?:  {
    __typename: "ModelAppointmentEventConnection",
    items:  Array< {
      __typename: "AppointmentEvent",
      id: string,
      appointmentRecordID: string,
      entity?: string | null,
      entityID?: string | null,
      action?: string | null,
      actorType?: UserGroup | null,
      actorID?: string | null,
      timestamp?: string | null,
      properties?: string | null,
      source?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAppointmentNotificationQueryVariables = {
  id: string,
};

export type GetAppointmentNotificationQuery = {
  getAppointmentNotification?:  {
    __typename: "AppointmentNotification",
    id: string,
    appointmentRecordID: string,
    entityType?: string | null,
    entityID?: string | null,
    notificationType: string,
    channel: NotificationChannel,
    recipientType: UserGroup,
    recipientID: string,
    recipientName?: string | null,
    title: string,
    body: string,
    status: string,
    readAt?: string | null,
    ttl?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAppointmentNotificationsQueryVariables = {
  id?: string | null,
  filter?: ModelAppointmentNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAppointmentNotificationsQuery = {
  listAppointmentNotifications?:  {
    __typename: "ModelAppointmentNotificationConnection",
    items:  Array< {
      __typename: "AppointmentNotification",
      id: string,
      appointmentRecordID: string,
      entityType?: string | null,
      entityID?: string | null,
      notificationType: string,
      channel: NotificationChannel,
      recipientType: UserGroup,
      recipientID: string,
      recipientName?: string | null,
      title: string,
      body: string,
      status: string,
      readAt?: string | null,
      ttl?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentNotificationsByAppointmentRecordIDQueryVariables = {
  appointmentRecordID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentNotificationsByAppointmentRecordIDQuery = {
  appointmentNotificationsByAppointmentRecordID?:  {
    __typename: "ModelAppointmentNotificationConnection",
    items:  Array< {
      __typename: "AppointmentNotification",
      id: string,
      appointmentRecordID: string,
      entityType?: string | null,
      entityID?: string | null,
      notificationType: string,
      channel: NotificationChannel,
      recipientType: UserGroup,
      recipientID: string,
      recipientName?: string | null,
      title: string,
      body: string,
      status: string,
      readAt?: string | null,
      ttl?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentNotificationsByRecipientAndStatusQueryVariables = {
  recipientID: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentNotificationsByRecipientAndStatusQuery = {
  appointmentNotificationsByRecipientAndStatus?:  {
    __typename: "ModelAppointmentNotificationConnection",
    items:  Array< {
      __typename: "AppointmentNotification",
      id: string,
      appointmentRecordID: string,
      entityType?: string | null,
      entityID?: string | null,
      notificationType: string,
      channel: NotificationChannel,
      recipientType: UserGroup,
      recipientID: string,
      recipientName?: string | null,
      title: string,
      body: string,
      status: string,
      readAt?: string | null,
      ttl?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEmailNotificationQueueQueryVariables = {
  id: string,
};

export type GetEmailNotificationQueueQuery = {
  getEmailNotificationQueue?:  {
    __typename: "EmailNotificationQueue",
    id: string,
    appointmentRecordID: string,
    notificationType: string,
    recipientID: string,
    status: EmailNotificationStatus,
    emailDeliveryID?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListEmailNotificationQueuesQueryVariables = {
  id?: string | null,
  filter?: ModelEmailNotificationQueueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEmailNotificationQueuesQuery = {
  listEmailNotificationQueues?:  {
    __typename: "ModelEmailNotificationQueueConnection",
    items:  Array< {
      __typename: "EmailNotificationQueue",
      id: string,
      appointmentRecordID: string,
      notificationType: string,
      recipientID: string,
      status: EmailNotificationStatus,
      emailDeliveryID?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EmailNotificationQueuesByAppointmentRecordIDQueryVariables = {
  appointmentRecordID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEmailNotificationQueueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EmailNotificationQueuesByAppointmentRecordIDQuery = {
  emailNotificationQueuesByAppointmentRecordID?:  {
    __typename: "ModelEmailNotificationQueueConnection",
    items:  Array< {
      __typename: "EmailNotificationQueue",
      id: string,
      appointmentRecordID: string,
      notificationType: string,
      recipientID: string,
      status: EmailNotificationStatus,
      emailDeliveryID?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EmailNotificationsByRecipientAndStatusQueryVariables = {
  recipientID: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEmailNotificationQueueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EmailNotificationsByRecipientAndStatusQuery = {
  emailNotificationsByRecipientAndStatus?:  {
    __typename: "ModelEmailNotificationQueueConnection",
    items:  Array< {
      __typename: "EmailNotificationQueue",
      id: string,
      appointmentRecordID: string,
      notificationType: string,
      recipientID: string,
      status: EmailNotificationStatus,
      emailDeliveryID?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EmailNotificationQueuesByEmailDeliveryIDQueryVariables = {
  emailDeliveryID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEmailNotificationQueueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EmailNotificationQueuesByEmailDeliveryIDQuery = {
  emailNotificationQueuesByEmailDeliveryID?:  {
    __typename: "ModelEmailNotificationQueueConnection",
    items:  Array< {
      __typename: "EmailNotificationQueue",
      id: string,
      appointmentRecordID: string,
      notificationType: string,
      recipientID: string,
      status: EmailNotificationStatus,
      emailDeliveryID?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEmailDeliveryQueryVariables = {
  id: string,
};

export type GetEmailDeliveryQuery = {
  getEmailDelivery?:  {
    __typename: "EmailDelivery",
    id: string,
    emailType: string,
    recipientID: string,
    recipientEmail: string,
    subject: string,
    body: string,
    htmlBody?: string | null,
    status: EmailDeliveryStatus,
    sentAt?: string | null,
    failureReason?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListEmailDeliveriesQueryVariables = {
  id?: string | null,
  filter?: ModelEmailDeliveryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEmailDeliveriesQuery = {
  listEmailDeliveries?:  {
    __typename: "ModelEmailDeliveryConnection",
    items:  Array< {
      __typename: "EmailDelivery",
      id: string,
      emailType: string,
      recipientID: string,
      recipientEmail: string,
      subject: string,
      body: string,
      htmlBody?: string | null,
      status: EmailDeliveryStatus,
      sentAt?: string | null,
      failureReason?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EmailDeliveriesByEmailTypeAndStatusQueryVariables = {
  emailType: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEmailDeliveryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EmailDeliveriesByEmailTypeAndStatusQuery = {
  emailDeliveriesByEmailTypeAndStatus?:  {
    __typename: "ModelEmailDeliveryConnection",
    items:  Array< {
      __typename: "EmailDelivery",
      id: string,
      emailType: string,
      recipientID: string,
      recipientEmail: string,
      subject: string,
      body: string,
      htmlBody?: string | null,
      status: EmailDeliveryStatus,
      sentAt?: string | null,
      failureReason?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EmailDeliveriesByRecipientIDQueryVariables = {
  recipientID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEmailDeliveryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EmailDeliveriesByRecipientIDQuery = {
  emailDeliveriesByRecipientID?:  {
    __typename: "ModelEmailDeliveryConnection",
    items:  Array< {
      __typename: "EmailDelivery",
      id: string,
      emailType: string,
      recipientID: string,
      recipientEmail: string,
      subject: string,
      body: string,
      htmlBody?: string | null,
      status: EmailDeliveryStatus,
      sentAt?: string | null,
      failureReason?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetChatbotMessageQueryVariables = {
  userId: string,
  conversationIdTimestamp: string,
};

export type GetChatbotMessageQuery = {
  getChatbotMessage?:  {
    __typename: "ChatbotMessage",
    userId: string,
    conversationIdTimestamp: string,
    messageId: string,
    conversationId: string,
    role: ChatbotMessageRole,
    content: string,
    suggestedUserPrompt?: string | null,
    createdAt: string,
    llmInput?: string | null,
    inputTokens?: number | null,
    outputTokens?: number | null,
    reasoningTokens?: number | null,
    cachedTokens?: number | null,
    totalTokens?: number | null,
    toolsCalled?: Array< string | null > | null,
    toolsSucceeded?: Array< string | null > | null,
    toolsFailed?: Array< string | null > | null,
    ttftMs?: number | null,
    total_latency_ms?: number | null,
    userPaused?: boolean | null,
    agentTurns?: number | null,
    attachments?:  Array< {
      __typename: "ChatbotAttachment",
      filename: string,
      contentType: string,
      sizeBytes: number,
      s3Bucket?: string | null,
      s3Key?: string | null,
      slackUrl?: string | null,
      source?: string | null,
    } | null > | null,
    dataBlocks?: string | null,
    updatedAt: string,
  } | null,
};

export type ListChatbotMessagesQueryVariables = {
  userId?: string | null,
  conversationIdTimestamp?: ModelStringKeyConditionInput | null,
  filter?: ModelChatbotMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListChatbotMessagesQuery = {
  listChatbotMessages?:  {
    __typename: "ModelChatbotMessageConnection",
    items:  Array< {
      __typename: "ChatbotMessage",
      userId: string,
      conversationIdTimestamp: string,
      messageId: string,
      conversationId: string,
      role: ChatbotMessageRole,
      content: string,
      suggestedUserPrompt?: string | null,
      createdAt: string,
      llmInput?: string | null,
      inputTokens?: number | null,
      outputTokens?: number | null,
      reasoningTokens?: number | null,
      cachedTokens?: number | null,
      totalTokens?: number | null,
      toolsCalled?: Array< string | null > | null,
      toolsSucceeded?: Array< string | null > | null,
      toolsFailed?: Array< string | null > | null,
      ttftMs?: number | null,
      total_latency_ms?: number | null,
      userPaused?: boolean | null,
      agentTurns?: number | null,
      attachments?:  Array< {
        __typename: "ChatbotAttachment",
        filename: string,
        contentType: string,
        sizeBytes: number,
        s3Bucket?: string | null,
        s3Key?: string | null,
        slackUrl?: string | null,
        source?: string | null,
      } | null > | null,
      dataBlocks?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ChatbotMessagesByConversationIdQueryVariables = {
  conversationId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelChatbotMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ChatbotMessagesByConversationIdQuery = {
  chatbotMessagesByConversationId?:  {
    __typename: "ModelChatbotMessageConnection",
    items:  Array< {
      __typename: "ChatbotMessage",
      userId: string,
      conversationIdTimestamp: string,
      messageId: string,
      conversationId: string,
      role: ChatbotMessageRole,
      content: string,
      suggestedUserPrompt?: string | null,
      createdAt: string,
      llmInput?: string | null,
      inputTokens?: number | null,
      outputTokens?: number | null,
      reasoningTokens?: number | null,
      cachedTokens?: number | null,
      totalTokens?: number | null,
      toolsCalled?: Array< string | null > | null,
      toolsSucceeded?: Array< string | null > | null,
      toolsFailed?: Array< string | null > | null,
      ttftMs?: number | null,
      total_latency_ms?: number | null,
      userPaused?: boolean | null,
      agentTurns?: number | null,
      attachments?:  Array< {
        __typename: "ChatbotAttachment",
        filename: string,
        contentType: string,
        sizeBytes: number,
        s3Bucket?: string | null,
        s3Key?: string | null,
        slackUrl?: string | null,
        source?: string | null,
      } | null > | null,
      dataBlocks?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetChatbotConversationQueryVariables = {
  userId: string,
  conversationId: string,
};

export type GetChatbotConversationQuery = {
  getChatbotConversation?:  {
    __typename: "ChatbotConversation",
    userId: string,
    conversationId: string,
    createdAt: string,
    updatedAt: string,
    name?: string | null,
    archived?: boolean | null,
    pausedStreaming?: boolean | null,
    modelConversationId?: string | null,
    claudeSessionId?: string | null,
    routineId?: string | null,
    routineRunId?: string | null,
  } | null,
};

export type ListChatbotConversationsQueryVariables = {
  userId?: string | null,
  conversationId?: ModelStringKeyConditionInput | null,
  filter?: ModelChatbotConversationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListChatbotConversationsQuery = {
  listChatbotConversations?:  {
    __typename: "ModelChatbotConversationConnection",
    items:  Array< {
      __typename: "ChatbotConversation",
      userId: string,
      conversationId: string,
      createdAt: string,
      updatedAt: string,
      name?: string | null,
      archived?: boolean | null,
      pausedStreaming?: boolean | null,
      modelConversationId?: string | null,
      claudeSessionId?: string | null,
      routineId?: string | null,
      routineRunId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ChatbotConversationsByUserUpdatedAtQueryVariables = {
  userId: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelChatbotConversationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ChatbotConversationsByUserUpdatedAtQuery = {
  chatbotConversationsByUserUpdatedAt?:  {
    __typename: "ModelChatbotConversationConnection",
    items:  Array< {
      __typename: "ChatbotConversation",
      userId: string,
      conversationId: string,
      createdAt: string,
      updatedAt: string,
      name?: string | null,
      archived?: boolean | null,
      pausedStreaming?: boolean | null,
      modelConversationId?: string | null,
      claudeSessionId?: string | null,
      routineId?: string | null,
      routineRunId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetChatbotMonitoringQueryVariables = {
  userId: string,
};

export type GetChatbotMonitoringQuery = {
  getChatbotMonitoring?:  {
    __typename: "ChatbotMonitoring",
    userId: string,
    totalTokens: number,
    lastWeekTokens: number,
    totalConversations?: number | null,
    totalToolsCalled?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListChatbotMonitoringsQueryVariables = {
  userId?: string | null,
  filter?: ModelChatbotMonitoringFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListChatbotMonitoringsQuery = {
  listChatbotMonitorings?:  {
    __typename: "ModelChatbotMonitoringConnection",
    items:  Array< {
      __typename: "ChatbotMonitoring",
      userId: string,
      totalTokens: number,
      lastWeekTokens: number,
      totalConversations?: number | null,
      totalToolsCalled?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSlackAgentInvocationQueryVariables = {
  slackUserEmail: string,
  timestamp: string,
};

export type GetSlackAgentInvocationQuery = {
  getSlackAgentInvocation?:  {
    __typename: "SlackAgentInvocation",
    slackUserEmail: string,
    timestamp: string,
    channel: string,
    threadTs?: string | null,
    eventId?: string | null,
    slackUserId?: string | null,
    slackUserName?: string | null,
    userMessage: string,
    assistantResponse?: string | null,
    inputTokens?: number | null,
    outputTokens?: number | null,
    reasoningTokens?: number | null,
    cachedTokens?: number | null,
    totalTokens?: number | null,
    toolsCalled?: Array< string | null > | null,
    toolsSucceeded?: Array< string | null > | null,
    toolsFailed?: Array< string | null > | null,
    ttftMs?: number | null,
    totalLatencyMs?: number | null,
    agentTurns?: number | null,
    status?: string | null,
    errorMessage?: string | null,
    ttl?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSlackAgentInvocationsQueryVariables = {
  slackUserEmail?: string | null,
  timestamp?: ModelStringKeyConditionInput | null,
  filter?: ModelSlackAgentInvocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSlackAgentInvocationsQuery = {
  listSlackAgentInvocations?:  {
    __typename: "ModelSlackAgentInvocationConnection",
    items:  Array< {
      __typename: "SlackAgentInvocation",
      slackUserEmail: string,
      timestamp: string,
      channel: string,
      threadTs?: string | null,
      eventId?: string | null,
      slackUserId?: string | null,
      slackUserName?: string | null,
      userMessage: string,
      assistantResponse?: string | null,
      inputTokens?: number | null,
      outputTokens?: number | null,
      reasoningTokens?: number | null,
      cachedTokens?: number | null,
      totalTokens?: number | null,
      toolsCalled?: Array< string | null > | null,
      toolsSucceeded?: Array< string | null > | null,
      toolsFailed?: Array< string | null > | null,
      ttftMs?: number | null,
      totalLatencyMs?: number | null,
      agentTurns?: number | null,
      status?: string | null,
      errorMessage?: string | null,
      ttl?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SlackAgentInvocationsByChannelQueryVariables = {
  channel: string,
  timestamp?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSlackAgentInvocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SlackAgentInvocationsByChannelQuery = {
  slackAgentInvocationsByChannel?:  {
    __typename: "ModelSlackAgentInvocationConnection",
    items:  Array< {
      __typename: "SlackAgentInvocation",
      slackUserEmail: string,
      timestamp: string,
      channel: string,
      threadTs?: string | null,
      eventId?: string | null,
      slackUserId?: string | null,
      slackUserName?: string | null,
      userMessage: string,
      assistantResponse?: string | null,
      inputTokens?: number | null,
      outputTokens?: number | null,
      reasoningTokens?: number | null,
      cachedTokens?: number | null,
      totalTokens?: number | null,
      toolsCalled?: Array< string | null > | null,
      toolsSucceeded?: Array< string | null > | null,
      toolsFailed?: Array< string | null > | null,
      ttftMs?: number | null,
      totalLatencyMs?: number | null,
      agentTurns?: number | null,
      status?: string | null,
      errorMessage?: string | null,
      ttl?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPromptExecutionQueryVariables = {
  id: string,
};

export type GetPromptExecutionQuery = {
  getPromptExecution?:  {
    __typename: "PromptExecution",
    id: string,
    promptId: string,
    attachments?:  Array< {
      __typename: "PromptExecutionAttachment",
      blob:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      caption?: string | null,
    } | null > | null,
    input:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    output:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    toolCalls?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    reasoningSummary?: string | null,
    executedAt: string,
    appointmentID?: string | null,
    entityType?: string | null,
    entityId?: string | null,
    promptHash: string,
    apiHash?: string | null,
    modelName: string,
    modelConfig?: string | null,
    correlationID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPromptExecutionsQueryVariables = {
  id?: string | null,
  filter?: ModelPromptExecutionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPromptExecutionsQuery = {
  listPromptExecutions?:  {
    __typename: "ModelPromptExecutionConnection",
    items:  Array< {
      __typename: "PromptExecution",
      id: string,
      promptId: string,
      attachments?:  Array< {
        __typename: "PromptExecutionAttachment",
        blob:  {
          __typename: "S3Blob",
          bucket: string,
          key: string,
        },
        caption?: string | null,
      } | null > | null,
      input:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      output:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      toolCalls?:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } | null,
      reasoningSummary?: string | null,
      executedAt: string,
      appointmentID?: string | null,
      entityType?: string | null,
      entityId?: string | null,
      promptHash: string,
      apiHash?: string | null,
      modelName: string,
      modelConfig?: string | null,
      correlationID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PromptExecutionsByPromptIdQueryVariables = {
  promptId: string,
  executedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPromptExecutionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PromptExecutionsByPromptIdQuery = {
  promptExecutionsByPromptId?:  {
    __typename: "ModelPromptExecutionConnection",
    items:  Array< {
      __typename: "PromptExecution",
      id: string,
      promptId: string,
      attachments?:  Array< {
        __typename: "PromptExecutionAttachment",
        blob:  {
          __typename: "S3Blob",
          bucket: string,
          key: string,
        },
        caption?: string | null,
      } | null > | null,
      input:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      output:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      toolCalls?:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } | null,
      reasoningSummary?: string | null,
      executedAt: string,
      appointmentID?: string | null,
      entityType?: string | null,
      entityId?: string | null,
      promptHash: string,
      apiHash?: string | null,
      modelName: string,
      modelConfig?: string | null,
      correlationID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PromptExecutionsByAppointmentQueryVariables = {
  appointmentID: string,
  executedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPromptExecutionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PromptExecutionsByAppointmentQuery = {
  promptExecutionsByAppointment?:  {
    __typename: "ModelPromptExecutionConnection",
    items:  Array< {
      __typename: "PromptExecution",
      id: string,
      promptId: string,
      attachments?:  Array< {
        __typename: "PromptExecutionAttachment",
        blob:  {
          __typename: "S3Blob",
          bucket: string,
          key: string,
        },
        caption?: string | null,
      } | null > | null,
      input:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      output:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      toolCalls?:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } | null,
      reasoningSummary?: string | null,
      executedAt: string,
      appointmentID?: string | null,
      entityType?: string | null,
      entityId?: string | null,
      promptHash: string,
      apiHash?: string | null,
      modelName: string,
      modelConfig?: string | null,
      correlationID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PromptExecutionsByCorrelationIDQueryVariables = {
  correlationID: string,
  executedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPromptExecutionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PromptExecutionsByCorrelationIDQuery = {
  promptExecutionsByCorrelationID?:  {
    __typename: "ModelPromptExecutionConnection",
    items:  Array< {
      __typename: "PromptExecution",
      id: string,
      promptId: string,
      attachments?:  Array< {
        __typename: "PromptExecutionAttachment",
        blob:  {
          __typename: "S3Blob",
          bucket: string,
          key: string,
        },
        caption?: string | null,
      } | null > | null,
      input:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      output:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      toolCalls?:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } | null,
      reasoningSummary?: string | null,
      executedAt: string,
      appointmentID?: string | null,
      entityType?: string | null,
      entityId?: string | null,
      promptHash: string,
      apiHash?: string | null,
      modelName: string,
      modelConfig?: string | null,
      correlationID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAppointmentEntityCorrelationQueryVariables = {
  id: string,
};

export type GetAppointmentEntityCorrelationQuery = {
  getAppointmentEntityCorrelation?:  {
    __typename: "AppointmentEntityCorrelation",
    id: string,
    appointmentID: string,
    entityType?: string | null,
    entityID?: string | null,
    properties?: string | null,
    correlationID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAppointmentEntityCorrelationsQueryVariables = {
  id?: string | null,
  filter?: ModelAppointmentEntityCorrelationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAppointmentEntityCorrelationsQuery = {
  listAppointmentEntityCorrelations?:  {
    __typename: "ModelAppointmentEntityCorrelationConnection",
    items:  Array< {
      __typename: "AppointmentEntityCorrelation",
      id: string,
      appointmentID: string,
      entityType?: string | null,
      entityID?: string | null,
      properties?: string | null,
      correlationID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EntityCorrelationsByAppointmentQueryVariables = {
  appointmentID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentEntityCorrelationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EntityCorrelationsByAppointmentQuery = {
  entityCorrelationsByAppointment?:  {
    __typename: "ModelAppointmentEntityCorrelationConnection",
    items:  Array< {
      __typename: "AppointmentEntityCorrelation",
      id: string,
      appointmentID: string,
      entityType?: string | null,
      entityID?: string | null,
      properties?: string | null,
      correlationID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EntityCorrelationsByCorrelationIDQueryVariables = {
  correlationID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentEntityCorrelationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EntityCorrelationsByCorrelationIDQuery = {
  entityCorrelationsByCorrelationID?:  {
    __typename: "ModelAppointmentEntityCorrelationConnection",
    items:  Array< {
      __typename: "AppointmentEntityCorrelation",
      id: string,
      appointmentID: string,
      entityType?: string | null,
      entityID?: string | null,
      properties?: string | null,
      correlationID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPromptFeedbackQueryVariables = {
  id: string,
};

export type GetPromptFeedbackQuery = {
  getPromptFeedback?:  {
    __typename: "PromptFeedback",
    id: string,
    promptId: string,
    promptExecutionId?: string | null,
    feedback: string,
    feedbackSource: PromptFeedbackSource,
    actorType?: UserGroup | null,
    actorID?: string | null,
    status?: FeedbackStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPromptFeedbacksQueryVariables = {
  id?: string | null,
  filter?: ModelPromptFeedbackFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPromptFeedbacksQuery = {
  listPromptFeedbacks?:  {
    __typename: "ModelPromptFeedbackConnection",
    items:  Array< {
      __typename: "PromptFeedback",
      id: string,
      promptId: string,
      promptExecutionId?: string | null,
      feedback: string,
      feedbackSource: PromptFeedbackSource,
      actorType?: UserGroup | null,
      actorID?: string | null,
      status?: FeedbackStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PromptFeedbackByPromptIdQueryVariables = {
  promptId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPromptFeedbackFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PromptFeedbackByPromptIdQuery = {
  promptFeedbackByPromptId?:  {
    __typename: "ModelPromptFeedbackConnection",
    items:  Array< {
      __typename: "PromptFeedback",
      id: string,
      promptId: string,
      promptExecutionId?: string | null,
      feedback: string,
      feedbackSource: PromptFeedbackSource,
      actorType?: UserGroup | null,
      actorID?: string | null,
      status?: FeedbackStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPromptOfflineEvalCaseQueryVariables = {
  id: string,
};

export type GetPromptOfflineEvalCaseQuery = {
  getPromptOfflineEvalCase?:  {
    __typename: "PromptOfflineEvalCase",
    id: string,
    promptId: string,
    sourcePromptExecutionId?: string | null,
    apiHash: string,
    attachments?:  Array< {
      __typename: "PromptExecutionAttachment",
      blob:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      caption?: string | null,
    } | null > | null,
    input:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    output:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    },
    toolCalls?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    description?: string | null,
    verified?: boolean | null,
    tags?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPromptOfflineEvalCasesQueryVariables = {
  id?: string | null,
  filter?: ModelPromptOfflineEvalCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPromptOfflineEvalCasesQuery = {
  listPromptOfflineEvalCases?:  {
    __typename: "ModelPromptOfflineEvalCaseConnection",
    items:  Array< {
      __typename: "PromptOfflineEvalCase",
      id: string,
      promptId: string,
      sourcePromptExecutionId?: string | null,
      apiHash: string,
      attachments?:  Array< {
        __typename: "PromptExecutionAttachment",
        blob:  {
          __typename: "S3Blob",
          bucket: string,
          key: string,
        },
        caption?: string | null,
      } | null > | null,
      input:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      output:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      toolCalls?:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } | null,
      description?: string | null,
      verified?: boolean | null,
      tags?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OfflineEvalCasesByPromptIdAndApiHashQueryVariables = {
  promptId: string,
  apiHash?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPromptOfflineEvalCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OfflineEvalCasesByPromptIdAndApiHashQuery = {
  offlineEvalCasesByPromptIdAndApiHash?:  {
    __typename: "ModelPromptOfflineEvalCaseConnection",
    items:  Array< {
      __typename: "PromptOfflineEvalCase",
      id: string,
      promptId: string,
      sourcePromptExecutionId?: string | null,
      apiHash: string,
      attachments?:  Array< {
        __typename: "PromptExecutionAttachment",
        blob:  {
          __typename: "S3Blob",
          bucket: string,
          key: string,
        },
        caption?: string | null,
      } | null > | null,
      input:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      output:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      },
      toolCalls?:  {
        __typename: "S3Blob",
        bucket: string,
        key: string,
      } | null,
      description?: string | null,
      verified?: boolean | null,
      tags?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPromptExecutionCounterQueryVariables = {
  id: string,
};

export type GetPromptExecutionCounterQuery = {
  getPromptExecutionCounter?:  {
    __typename: "PromptExecutionCounter",
    id: string,
    execCount: number,
    imageCount: number,
    totalBytes: number,
    ttl: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPromptExecutionCountersQueryVariables = {
  id?: string | null,
  filter?: ModelPromptExecutionCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPromptExecutionCountersQuery = {
  listPromptExecutionCounters?:  {
    __typename: "ModelPromptExecutionCounterConnection",
    items:  Array< {
      __typename: "PromptExecutionCounter",
      id: string,
      execCount: number,
      imageCount: number,
      totalBytes: number,
      ttl: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSkillQueryVariables = {
  id: string,
};

export type GetSkillQuery = {
  getSkill?:  {
    __typename: "Skill",
    id: string,
    name: string,
    description: string,
    body: string,
    scope: SkillScope,
    ownerUserId: string,
    roles?: Array< UserGroup > | null,
    inputs?:  Array< {
      __typename: "SkillInput",
      name: string,
      description?: string | null,
      required: boolean,
    } > | null,
    visibility: SkillVisibility,
    version: number,
    archivedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSkillsQueryVariables = {
  filter?: ModelSkillFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSkillsQuery = {
  listSkills?:  {
    __typename: "ModelSkillConnection",
    items:  Array< {
      __typename: "Skill",
      id: string,
      name: string,
      description: string,
      body: string,
      scope: SkillScope,
      ownerUserId: string,
      roles?: Array< UserGroup > | null,
      inputs?:  Array< {
        __typename: "SkillInput",
        name: string,
        description?: string | null,
        required: boolean,
      } > | null,
      visibility: SkillVisibility,
      version: number,
      archivedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SkillsByNameQueryVariables = {
  name: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSkillFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SkillsByNameQuery = {
  skillsByName?:  {
    __typename: "ModelSkillConnection",
    items:  Array< {
      __typename: "Skill",
      id: string,
      name: string,
      description: string,
      body: string,
      scope: SkillScope,
      ownerUserId: string,
      roles?: Array< UserGroup > | null,
      inputs?:  Array< {
        __typename: "SkillInput",
        name: string,
        description?: string | null,
        required: boolean,
      } > | null,
      visibility: SkillVisibility,
      version: number,
      archivedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRoutineQueryVariables = {
  id: string,
};

export type GetRoutineQuery = {
  getRoutine?:  {
    __typename: "Routine",
    id: string,
    scope: RoutineScope,
    name: string,
    description?: string | null,
    promptBody: string,
    model: string,
    reasoningEffort: string,
    enableWebSearch: boolean,
    maxAgentTurns?: number | null,
    conversationMode: RoutineConversationMode,
    schedule:  {
      __typename: "RoutineSchedule",
      frequency: RoutineFrequency,
      intervalHours?: number | null,
      timeOfDay?: string | null,
      weekdays?: Array< number > | null,
      runAt?: string | null,
    },
    timezone: string,
    enabled: boolean,
    notifyOwner: RoutineNotify,
    slackChannel?: string | null,
    ownerUserId: string,
    createdAt: string,
    createdVia: RoutineOrigin,
    version: number,
    archivedAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListRoutinesQueryVariables = {
  filter?: ModelRoutineFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRoutinesQuery = {
  listRoutines?:  {
    __typename: "ModelRoutineConnection",
    items:  Array< {
      __typename: "Routine",
      id: string,
      scope: RoutineScope,
      name: string,
      description?: string | null,
      promptBody: string,
      model: string,
      reasoningEffort: string,
      enableWebSearch: boolean,
      maxAgentTurns?: number | null,
      conversationMode: RoutineConversationMode,
      schedule:  {
        __typename: "RoutineSchedule",
        frequency: RoutineFrequency,
        intervalHours?: number | null,
        timeOfDay?: string | null,
        weekdays?: Array< number > | null,
        runAt?: string | null,
      },
      timezone: string,
      enabled: boolean,
      notifyOwner: RoutineNotify,
      slackChannel?: string | null,
      ownerUserId: string,
      createdAt: string,
      createdVia: RoutineOrigin,
      version: number,
      archivedAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RoutinesByScopeQueryVariables = {
  scope: RoutineScope,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRoutineFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RoutinesByScopeQuery = {
  routinesByScope?:  {
    __typename: "ModelRoutineConnection",
    items:  Array< {
      __typename: "Routine",
      id: string,
      scope: RoutineScope,
      name: string,
      description?: string | null,
      promptBody: string,
      model: string,
      reasoningEffort: string,
      enableWebSearch: boolean,
      maxAgentTurns?: number | null,
      conversationMode: RoutineConversationMode,
      schedule:  {
        __typename: "RoutineSchedule",
        frequency: RoutineFrequency,
        intervalHours?: number | null,
        timeOfDay?: string | null,
        weekdays?: Array< number > | null,
        runAt?: string | null,
      },
      timezone: string,
      enabled: boolean,
      notifyOwner: RoutineNotify,
      slackChannel?: string | null,
      ownerUserId: string,
      createdAt: string,
      createdVia: RoutineOrigin,
      version: number,
      archivedAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RoutinesByOwnerQueryVariables = {
  ownerUserId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRoutineFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RoutinesByOwnerQuery = {
  routinesByOwner?:  {
    __typename: "ModelRoutineConnection",
    items:  Array< {
      __typename: "Routine",
      id: string,
      scope: RoutineScope,
      name: string,
      description?: string | null,
      promptBody: string,
      model: string,
      reasoningEffort: string,
      enableWebSearch: boolean,
      maxAgentTurns?: number | null,
      conversationMode: RoutineConversationMode,
      schedule:  {
        __typename: "RoutineSchedule",
        frequency: RoutineFrequency,
        intervalHours?: number | null,
        timeOfDay?: string | null,
        weekdays?: Array< number > | null,
        runAt?: string | null,
      },
      timezone: string,
      enabled: boolean,
      notifyOwner: RoutineNotify,
      slackChannel?: string | null,
      ownerUserId: string,
      createdAt: string,
      createdVia: RoutineOrigin,
      version: number,
      archivedAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRoutineStateQueryVariables = {
  id: string,
};

export type GetRoutineStateQuery = {
  getRoutineState?:  {
    __typename: "RoutineState",
    id: string,
    scope: RoutineScope,
    ownerUserId: string,
    definitionVersion: number,
    schedulePartition?: string | null,
    nextRunAt?: string | null,
    currentConversationId?: string | null,
    activeRunId?: string | null,
    lastRunId?: string | null,
    consecutiveFailures: number,
    endedReason?: RoutineEndedReason | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRoutineStatesQueryVariables = {
  filter?: ModelRoutineStateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRoutineStatesQuery = {
  listRoutineStates?:  {
    __typename: "ModelRoutineStateConnection",
    items:  Array< {
      __typename: "RoutineState",
      id: string,
      scope: RoutineScope,
      ownerUserId: string,
      definitionVersion: number,
      schedulePartition?: string | null,
      nextRunAt?: string | null,
      currentConversationId?: string | null,
      activeRunId?: string | null,
      lastRunId?: string | null,
      consecutiveFailures: number,
      endedReason?: RoutineEndedReason | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RoutineStatesByScheduleQueryVariables = {
  schedulePartition: string,
  nextRunAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRoutineStateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RoutineStatesByScheduleQuery = {
  routineStatesBySchedule?:  {
    __typename: "ModelRoutineStateConnection",
    items:  Array< {
      __typename: "RoutineState",
      id: string,
      scope: RoutineScope,
      ownerUserId: string,
      definitionVersion: number,
      schedulePartition?: string | null,
      nextRunAt?: string | null,
      currentConversationId?: string | null,
      activeRunId?: string | null,
      lastRunId?: string | null,
      consecutiveFailures: number,
      endedReason?: RoutineEndedReason | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRoutineRunQueryVariables = {
  id: string,
};

export type GetRoutineRunQuery = {
  getRoutineRun?:  {
    __typename: "RoutineRun",
    id: string,
    scope: RoutineScope,
    routineId: string,
    routineVersion: number,
    createdAt: string,
    definitionSnapshot: string,
    status: RoutineRunStatus,
    trigger: RoutineTrigger,
    triggeredByUserId?: string | null,
    extraContext?: string | null,
    scheduledFor?: string | null,
    startedAt?: string | null,
    finishedAt?: string | null,
    durationMs?: number | null,
    processingStage?: string | null,
    nextProcessingAt?: string | null,
    dispatchAttempts: number,
    lastDispatchedAt?: string | null,
    executionToken?: string | null,
    executionDeadlineAt?: string | null,
    conversationOwnerUserId: string,
    conversationId?: string | null,
    previousConversationId?: string | null,
    userMessageId?: string | null,
    assistantMessageId?: string | null,
    outcome?: RoutineOutcome | null,
    headline?: string | null,
    summary?: string | null,
    totalTokens?: number | null,
    agentTurns?: number | null,
    toolsCalled?: Array< string | null > | null,
    toolsFailed?: Array< string | null > | null,
    correlationId?: string | null,
    errorMessage?: string | null,
    ownerDelivery?:  {
      __typename: "RoutineDelivery",
      status: RoutineDeliveryStatus,
      target?: string | null,
      claimToken?: string | null,
      claimExpiresAt?: string | null,
      attemptedAt?: string | null,
      finishedAt?: string | null,
      messageId?: string | null,
      errorMessage?: string | null,
    } | null,
    channelDelivery?:  {
      __typename: "RoutineDelivery",
      status: RoutineDeliveryStatus,
      target?: string | null,
      claimToken?: string | null,
      claimExpiresAt?: string | null,
      attemptedAt?: string | null,
      finishedAt?: string | null,
      messageId?: string | null,
      errorMessage?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type ListRoutineRunsQueryVariables = {
  filter?: ModelRoutineRunFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRoutineRunsQuery = {
  listRoutineRuns?:  {
    __typename: "ModelRoutineRunConnection",
    items:  Array< {
      __typename: "RoutineRun",
      id: string,
      scope: RoutineScope,
      routineId: string,
      routineVersion: number,
      createdAt: string,
      definitionSnapshot: string,
      status: RoutineRunStatus,
      trigger: RoutineTrigger,
      triggeredByUserId?: string | null,
      extraContext?: string | null,
      scheduledFor?: string | null,
      startedAt?: string | null,
      finishedAt?: string | null,
      durationMs?: number | null,
      processingStage?: string | null,
      nextProcessingAt?: string | null,
      dispatchAttempts: number,
      lastDispatchedAt?: string | null,
      executionToken?: string | null,
      executionDeadlineAt?: string | null,
      conversationOwnerUserId: string,
      conversationId?: string | null,
      previousConversationId?: string | null,
      userMessageId?: string | null,
      assistantMessageId?: string | null,
      outcome?: RoutineOutcome | null,
      headline?: string | null,
      summary?: string | null,
      totalTokens?: number | null,
      agentTurns?: number | null,
      toolsCalled?: Array< string | null > | null,
      toolsFailed?: Array< string | null > | null,
      correlationId?: string | null,
      errorMessage?: string | null,
      ownerDelivery?:  {
        __typename: "RoutineDelivery",
        status: RoutineDeliveryStatus,
        target?: string | null,
        claimToken?: string | null,
        claimExpiresAt?: string | null,
        attemptedAt?: string | null,
        finishedAt?: string | null,
        messageId?: string | null,
        errorMessage?: string | null,
      } | null,
      channelDelivery?:  {
        __typename: "RoutineDelivery",
        status: RoutineDeliveryStatus,
        target?: string | null,
        claimToken?: string | null,
        claimExpiresAt?: string | null,
        attemptedAt?: string | null,
        finishedAt?: string | null,
        messageId?: string | null,
        errorMessage?: string | null,
      } | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RoutineRunsByRoutineQueryVariables = {
  routineId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRoutineRunFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RoutineRunsByRoutineQuery = {
  routineRunsByRoutine?:  {
    __typename: "ModelRoutineRunConnection",
    items:  Array< {
      __typename: "RoutineRun",
      id: string,
      scope: RoutineScope,
      routineId: string,
      routineVersion: number,
      createdAt: string,
      definitionSnapshot: string,
      status: RoutineRunStatus,
      trigger: RoutineTrigger,
      triggeredByUserId?: string | null,
      extraContext?: string | null,
      scheduledFor?: string | null,
      startedAt?: string | null,
      finishedAt?: string | null,
      durationMs?: number | null,
      processingStage?: string | null,
      nextProcessingAt?: string | null,
      dispatchAttempts: number,
      lastDispatchedAt?: string | null,
      executionToken?: string | null,
      executionDeadlineAt?: string | null,
      conversationOwnerUserId: string,
      conversationId?: string | null,
      previousConversationId?: string | null,
      userMessageId?: string | null,
      assistantMessageId?: string | null,
      outcome?: RoutineOutcome | null,
      headline?: string | null,
      summary?: string | null,
      totalTokens?: number | null,
      agentTurns?: number | null,
      toolsCalled?: Array< string | null > | null,
      toolsFailed?: Array< string | null > | null,
      correlationId?: string | null,
      errorMessage?: string | null,
      ownerDelivery?:  {
        __typename: "RoutineDelivery",
        status: RoutineDeliveryStatus,
        target?: string | null,
        claimToken?: string | null,
        claimExpiresAt?: string | null,
        attemptedAt?: string | null,
        finishedAt?: string | null,
        messageId?: string | null,
        errorMessage?: string | null,
      } | null,
      channelDelivery?:  {
        __typename: "RoutineDelivery",
        status: RoutineDeliveryStatus,
        target?: string | null,
        claimToken?: string | null,
        claimExpiresAt?: string | null,
        attemptedAt?: string | null,
        finishedAt?: string | null,
        messageId?: string | null,
        errorMessage?: string | null,
      } | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RoutineRunsByWorkQueryVariables = {
  processingStage: string,
  nextProcessingAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRoutineRunFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RoutineRunsByWorkQuery = {
  routineRunsByWork?:  {
    __typename: "ModelRoutineRunConnection",
    items:  Array< {
      __typename: "RoutineRun",
      id: string,
      scope: RoutineScope,
      routineId: string,
      routineVersion: number,
      createdAt: string,
      definitionSnapshot: string,
      status: RoutineRunStatus,
      trigger: RoutineTrigger,
      triggeredByUserId?: string | null,
      extraContext?: string | null,
      scheduledFor?: string | null,
      startedAt?: string | null,
      finishedAt?: string | null,
      durationMs?: number | null,
      processingStage?: string | null,
      nextProcessingAt?: string | null,
      dispatchAttempts: number,
      lastDispatchedAt?: string | null,
      executionToken?: string | null,
      executionDeadlineAt?: string | null,
      conversationOwnerUserId: string,
      conversationId?: string | null,
      previousConversationId?: string | null,
      userMessageId?: string | null,
      assistantMessageId?: string | null,
      outcome?: RoutineOutcome | null,
      headline?: string | null,
      summary?: string | null,
      totalTokens?: number | null,
      agentTurns?: number | null,
      toolsCalled?: Array< string | null > | null,
      toolsFailed?: Array< string | null > | null,
      correlationId?: string | null,
      errorMessage?: string | null,
      ownerDelivery?:  {
        __typename: "RoutineDelivery",
        status: RoutineDeliveryStatus,
        target?: string | null,
        claimToken?: string | null,
        claimExpiresAt?: string | null,
        attemptedAt?: string | null,
        finishedAt?: string | null,
        messageId?: string | null,
        errorMessage?: string | null,
      } | null,
      channelDelivery?:  {
        __typename: "RoutineDelivery",
        status: RoutineDeliveryStatus,
        target?: string | null,
        claimToken?: string | null,
        claimExpiresAt?: string | null,
        attemptedAt?: string | null,
        finishedAt?: string | null,
        messageId?: string | null,
        errorMessage?: string | null,
      } | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDoctorSupportingMAQueryVariables = {
  id: string,
};

export type GetDoctorSupportingMAQuery = {
  getDoctorSupportingMA?:  {
    __typename: "DoctorSupportingMA",
    id: string,
    medicalAssistantId: string,
    doctorId: string,
    medicalAssistant:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    },
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type ListDoctorSupportingMASQueryVariables = {
  filter?: ModelDoctorSupportingMAFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDoctorSupportingMASQuery = {
  listDoctorSupportingMAS?:  {
    __typename: "ModelDoctorSupportingMAConnection",
    items:  Array< {
      __typename: "DoctorSupportingMA",
      id: string,
      medicalAssistantId: string,
      doctorId: string,
      medicalAssistant:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      },
      doctor:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      },
      createdAt: string,
      updatedAt: string,
      ownerCognitoId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DoctorSupportingMASByMedicalAssistantIdQueryVariables = {
  medicalAssistantId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDoctorSupportingMAFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DoctorSupportingMASByMedicalAssistantIdQuery = {
  doctorSupportingMASByMedicalAssistantId?:  {
    __typename: "ModelDoctorSupportingMAConnection",
    items:  Array< {
      __typename: "DoctorSupportingMA",
      id: string,
      medicalAssistantId: string,
      doctorId: string,
      medicalAssistant:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      },
      doctor:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      },
      createdAt: string,
      updatedAt: string,
      ownerCognitoId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DoctorSupportingMASByDoctorIdQueryVariables = {
  doctorId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDoctorSupportingMAFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DoctorSupportingMASByDoctorIdQuery = {
  doctorSupportingMASByDoctorId?:  {
    __typename: "ModelDoctorSupportingMAConnection",
    items:  Array< {
      __typename: "DoctorSupportingMA",
      id: string,
      medicalAssistantId: string,
      doctorId: string,
      medicalAssistant:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      },
      doctor:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      },
      createdAt: string,
      updatedAt: string,
      ownerCognitoId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMedicalAssistantSpecialtyCategoryQueryVariables = {
  id: string,
};

export type GetMedicalAssistantSpecialtyCategoryQuery = {
  getMedicalAssistantSpecialtyCategory?:  {
    __typename: "MedicalAssistantSpecialtyCategory",
    id: string,
    medicalAssistantId: string,
    specialtyCategoryId: string,
    medicalAssistant:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    },
    specialtyCategory:  {
      __typename: "SpecialtyCategory",
      id: string,
      name: string,
      specialties?: Array< SpecialtyType > | null,
      fallbackMA?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      medicalAssistants?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      specialtyCategoryFallbackMAId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMedicalAssistantSpecialtyCategoriesQueryVariables = {
  filter?: ModelMedicalAssistantSpecialtyCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMedicalAssistantSpecialtyCategoriesQuery = {
  listMedicalAssistantSpecialtyCategories?:  {
    __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
    items:  Array< {
      __typename: "MedicalAssistantSpecialtyCategory",
      id: string,
      medicalAssistantId: string,
      specialtyCategoryId: string,
      medicalAssistant:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      },
      specialtyCategory:  {
        __typename: "SpecialtyCategory",
        id: string,
        name: string,
        specialties?: Array< SpecialtyType > | null,
        fallbackMA?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        medicalAssistants?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        specialtyCategoryFallbackMAId?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MedicalAssistantSpecialtyCategoriesByMedicalAssistantIdQueryVariables = {
  medicalAssistantId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMedicalAssistantSpecialtyCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MedicalAssistantSpecialtyCategoriesByMedicalAssistantIdQuery = {
  medicalAssistantSpecialtyCategoriesByMedicalAssistantId?:  {
    __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
    items:  Array< {
      __typename: "MedicalAssistantSpecialtyCategory",
      id: string,
      medicalAssistantId: string,
      specialtyCategoryId: string,
      medicalAssistant:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      },
      specialtyCategory:  {
        __typename: "SpecialtyCategory",
        id: string,
        name: string,
        specialties?: Array< SpecialtyType > | null,
        fallbackMA?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        medicalAssistants?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        specialtyCategoryFallbackMAId?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MedicalAssistantSpecialtyCategoriesBySpecialtyCategoryIdQueryVariables = {
  specialtyCategoryId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMedicalAssistantSpecialtyCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MedicalAssistantSpecialtyCategoriesBySpecialtyCategoryIdQuery = {
  medicalAssistantSpecialtyCategoriesBySpecialtyCategoryId?:  {
    __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
    items:  Array< {
      __typename: "MedicalAssistantSpecialtyCategory",
      id: string,
      medicalAssistantId: string,
      specialtyCategoryId: string,
      medicalAssistant:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      },
      specialtyCategory:  {
        __typename: "SpecialtyCategory",
        id: string,
        name: string,
        specialties?: Array< SpecialtyType > | null,
        fallbackMA?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        medicalAssistants?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        specialtyCategoryFallbackMAId?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserAppointmentFilterPresetQueryVariables = {
  id: string,
};

export type GetUserAppointmentFilterPresetQuery = {
  getUserAppointmentFilterPreset?:  {
    __typename: "UserAppointmentFilterPreset",
    id: string,
    userId: string,
    appointmentFilterPresetId: string,
    user:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    },
    appointmentFilterPreset:  {
      __typename: "AppointmentFilterPreset",
      id: string,
      name: string,
      filters:  Array< {
        __typename: "FilterEntry",
        type: FilterType,
        values: Array< string >,
      } >,
      appliesTo: UserGroup,
      view?: AppointmentsView | null,
      users?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserAppointmentFilterPresetsQueryVariables = {
  filter?: ModelUserAppointmentFilterPresetFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserAppointmentFilterPresetsQuery = {
  listUserAppointmentFilterPresets?:  {
    __typename: "ModelUserAppointmentFilterPresetConnection",
    items:  Array< {
      __typename: "UserAppointmentFilterPreset",
      id: string,
      userId: string,
      appointmentFilterPresetId: string,
      user:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      },
      appointmentFilterPreset:  {
        __typename: "AppointmentFilterPreset",
        id: string,
        name: string,
        filters:  Array< {
          __typename: "FilterEntry",
          type: FilterType,
          values: Array< string >,
        } >,
        appliesTo: UserGroup,
        view?: AppointmentsView | null,
        users?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserAppointmentFilterPresetsByUserIdQueryVariables = {
  userId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserAppointmentFilterPresetFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserAppointmentFilterPresetsByUserIdQuery = {
  userAppointmentFilterPresetsByUserId?:  {
    __typename: "ModelUserAppointmentFilterPresetConnection",
    items:  Array< {
      __typename: "UserAppointmentFilterPreset",
      id: string,
      userId: string,
      appointmentFilterPresetId: string,
      user:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      },
      appointmentFilterPreset:  {
        __typename: "AppointmentFilterPreset",
        id: string,
        name: string,
        filters:  Array< {
          __typename: "FilterEntry",
          type: FilterType,
          values: Array< string >,
        } >,
        appliesTo: UserGroup,
        view?: AppointmentsView | null,
        users?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserAppointmentFilterPresetsByAppointmentFilterPresetIdQueryVariables = {
  appointmentFilterPresetId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserAppointmentFilterPresetFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserAppointmentFilterPresetsByAppointmentFilterPresetIdQuery = {
  userAppointmentFilterPresetsByAppointmentFilterPresetId?:  {
    __typename: "ModelUserAppointmentFilterPresetConnection",
    items:  Array< {
      __typename: "UserAppointmentFilterPreset",
      id: string,
      userId: string,
      appointmentFilterPresetId: string,
      user:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      },
      appointmentFilterPreset:  {
        __typename: "AppointmentFilterPreset",
        id: string,
        name: string,
        filters:  Array< {
          __typename: "FilterEntry",
          type: FilterType,
          values: Array< string >,
        } >,
        appliesTo: UserGroup,
        view?: AppointmentsView | null,
        users?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAppointmentRecordPatientCaseQueryVariables = {
  id: string,
};

export type GetAppointmentRecordPatientCaseQuery = {
  getAppointmentRecordPatientCase?:  {
    __typename: "AppointmentRecordPatientCase",
    id: string,
    appointmentRecordId: string,
    patientCaseId: string,
    appointmentRecord:  {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    },
    patientCase:  {
      __typename: "PatientCase",
      id: string,
      patientID: string,
      patient?:  {
        __typename: "Patient",
        id: string,
        name?: string | null,
        dateOfBirth?: string | null,
        SSN?: string | null,
        language?: Language | null,
        dominantHand?: DominantHand | null,
        cases?:  {
          __typename: "ModelPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        occupation?: string | null,
        sex?: Sex | null,
        weightLb?: number | null,
        height?:  {
          __typename: "Height",
          feet?: number | null,
          inches?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      claimNumber: string,
      qmePanelNumber?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      injuryInfo?:  {
        __typename: "InjuryInfo",
        injuryType?: InjuryType | null,
        injuredBodyParts?: Array< BodyPart | null > | null,
        claimedBodyParts?: Array< BodyPart | null > | null,
        description?: string | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        startDateOfInjury?: string | null,
        startDateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
      } | null,
      workersCompInsurance?:  {
        __typename: "WorkersCompInsuranceInfo",
        insuranceCarrier?: string | null,
        adjuster?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      insuranceCarrierID?: string | null,
      insuranceCarrier?:  {
        __typename: "InsuranceCarrier",
        id: string,
        name: string,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierAddressID?: string | null,
      insuranceCarrierAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierFaxNumberID?: string | null,
      insuranceCarrierFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierPhoneNumberID?: string | null,
      insuranceCarrierPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      applicantAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyLawFirmID?: string | null,
      applicantAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyAddressID?: string | null,
      applicantAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyFaxNumberID?: string | null,
      applicantAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyPhoneNumberID?: string | null,
      applicantAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      defenseAttorneyLawFirmID?: string | null,
      defenseAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyAddressID?: string | null,
      defenseAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyFaxNumberID?: string | null,
      defenseAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyPhoneNumberID?: string | null,
      defenseAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nurseCaseManager?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      ccPerson?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyCcEmails?: Array< string | null > | null,
      defenseAttorneyCcEmails?: Array< string | null > | null,
      adjusterCcEmails?: Array< string | null > | null,
      scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
      employmentAtInjury?:  {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null,
      WCAB?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    doctorOwnerCognitoId?: string | null,
    assistantCognitoIds?: string | null,
  } | null,
};

export type ListAppointmentRecordPatientCasesQueryVariables = {
  filter?: ModelAppointmentRecordPatientCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAppointmentRecordPatientCasesQuery = {
  listAppointmentRecordPatientCases?:  {
    __typename: "ModelAppointmentRecordPatientCaseConnection",
    items:  Array< {
      __typename: "AppointmentRecordPatientCase",
      id: string,
      appointmentRecordId: string,
      patientCaseId: string,
      appointmentRecord:  {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      },
      patientCase:  {
        __typename: "PatientCase",
        id: string,
        patientID: string,
        patient?:  {
          __typename: "Patient",
          id: string,
          name?: string | null,
          dateOfBirth?: string | null,
          SSN?: string | null,
          language?: Language | null,
          dominantHand?: DominantHand | null,
          occupation?: string | null,
          sex?: Sex | null,
          weightLb?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        claimNumber: string,
        qmePanelNumber?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        injuryInfo?:  {
          __typename: "InjuryInfo",
          injuryType?: InjuryType | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          claimedBodyParts?: Array< BodyPart | null > | null,
          description?: string | null,
          dateOfInjury?: string | null,
          startDateOfInjury?: string | null,
        } | null,
        workersCompInsurance?:  {
          __typename: "WorkersCompInsuranceInfo",
          insuranceCarrier?: string | null,
          adjuster?: string | null,
        } | null,
        insuranceCarrierID?: string | null,
        insuranceCarrier?:  {
          __typename: "InsuranceCarrier",
          id: string,
          name: string,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierAddressID?: string | null,
        insuranceCarrierAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierFaxNumberID?: string | null,
        insuranceCarrierFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierPhoneNumberID?: string | null,
        insuranceCarrierPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        applicantAttorney?:  {
          __typename: "AttorneyInfo",
          name?: string | null,
          lawFirmName?: string | null,
        } | null,
        applicantAttorneyLawFirmID?: string | null,
        applicantAttorneyLawFirm?:  {
          __typename: "LawFirm",
          id: string,
          name: string,
          type: LawFirmType,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyAddressID?: string | null,
        applicantAttorneyAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyFaxNumberID?: string | null,
        applicantAttorneyFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyPhoneNumberID?: string | null,
        applicantAttorneyPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorney?:  {
          __typename: "AttorneyInfo",
          name?: string | null,
          lawFirmName?: string | null,
        } | null,
        defenseAttorneyLawFirmID?: string | null,
        defenseAttorneyLawFirm?:  {
          __typename: "LawFirm",
          id: string,
          name: string,
          type: LawFirmType,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyAddressID?: string | null,
        defenseAttorneyAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyFaxNumberID?: string | null,
        defenseAttorneyFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyPhoneNumberID?: string | null,
        defenseAttorneyPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nurseCaseManager?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        ccPerson?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        applicantAttorneyCcEmails?: Array< string | null > | null,
        defenseAttorneyCcEmails?: Array< string | null > | null,
        adjusterCcEmails?: Array< string | null > | null,
        scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
        employmentAtInjury?:  {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null,
        WCAB?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentRecordPatientCasesByAppointmentRecordIdQueryVariables = {
  appointmentRecordId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentRecordPatientCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentRecordPatientCasesByAppointmentRecordIdQuery = {
  appointmentRecordPatientCasesByAppointmentRecordId?:  {
    __typename: "ModelAppointmentRecordPatientCaseConnection",
    items:  Array< {
      __typename: "AppointmentRecordPatientCase",
      id: string,
      appointmentRecordId: string,
      patientCaseId: string,
      appointmentRecord:  {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      },
      patientCase:  {
        __typename: "PatientCase",
        id: string,
        patientID: string,
        patient?:  {
          __typename: "Patient",
          id: string,
          name?: string | null,
          dateOfBirth?: string | null,
          SSN?: string | null,
          language?: Language | null,
          dominantHand?: DominantHand | null,
          occupation?: string | null,
          sex?: Sex | null,
          weightLb?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        claimNumber: string,
        qmePanelNumber?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        injuryInfo?:  {
          __typename: "InjuryInfo",
          injuryType?: InjuryType | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          claimedBodyParts?: Array< BodyPart | null > | null,
          description?: string | null,
          dateOfInjury?: string | null,
          startDateOfInjury?: string | null,
        } | null,
        workersCompInsurance?:  {
          __typename: "WorkersCompInsuranceInfo",
          insuranceCarrier?: string | null,
          adjuster?: string | null,
        } | null,
        insuranceCarrierID?: string | null,
        insuranceCarrier?:  {
          __typename: "InsuranceCarrier",
          id: string,
          name: string,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierAddressID?: string | null,
        insuranceCarrierAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierFaxNumberID?: string | null,
        insuranceCarrierFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierPhoneNumberID?: string | null,
        insuranceCarrierPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        applicantAttorney?:  {
          __typename: "AttorneyInfo",
          name?: string | null,
          lawFirmName?: string | null,
        } | null,
        applicantAttorneyLawFirmID?: string | null,
        applicantAttorneyLawFirm?:  {
          __typename: "LawFirm",
          id: string,
          name: string,
          type: LawFirmType,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyAddressID?: string | null,
        applicantAttorneyAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyFaxNumberID?: string | null,
        applicantAttorneyFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyPhoneNumberID?: string | null,
        applicantAttorneyPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorney?:  {
          __typename: "AttorneyInfo",
          name?: string | null,
          lawFirmName?: string | null,
        } | null,
        defenseAttorneyLawFirmID?: string | null,
        defenseAttorneyLawFirm?:  {
          __typename: "LawFirm",
          id: string,
          name: string,
          type: LawFirmType,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyAddressID?: string | null,
        defenseAttorneyAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyFaxNumberID?: string | null,
        defenseAttorneyFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyPhoneNumberID?: string | null,
        defenseAttorneyPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nurseCaseManager?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        ccPerson?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        applicantAttorneyCcEmails?: Array< string | null > | null,
        defenseAttorneyCcEmails?: Array< string | null > | null,
        adjusterCcEmails?: Array< string | null > | null,
        scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
        employmentAtInjury?:  {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null,
        WCAB?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppointmentRecordPatientCasesByPatientCaseIdQueryVariables = {
  patientCaseId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAppointmentRecordPatientCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AppointmentRecordPatientCasesByPatientCaseIdQuery = {
  appointmentRecordPatientCasesByPatientCaseId?:  {
    __typename: "ModelAppointmentRecordPatientCaseConnection",
    items:  Array< {
      __typename: "AppointmentRecordPatientCase",
      id: string,
      appointmentRecordId: string,
      patientCaseId: string,
      appointmentRecord:  {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      },
      patientCase:  {
        __typename: "PatientCase",
        id: string,
        patientID: string,
        patient?:  {
          __typename: "Patient",
          id: string,
          name?: string | null,
          dateOfBirth?: string | null,
          SSN?: string | null,
          language?: Language | null,
          dominantHand?: DominantHand | null,
          occupation?: string | null,
          sex?: Sex | null,
          weightLb?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        claimNumber: string,
        qmePanelNumber?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        injuryInfo?:  {
          __typename: "InjuryInfo",
          injuryType?: InjuryType | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          claimedBodyParts?: Array< BodyPart | null > | null,
          description?: string | null,
          dateOfInjury?: string | null,
          startDateOfInjury?: string | null,
        } | null,
        workersCompInsurance?:  {
          __typename: "WorkersCompInsuranceInfo",
          insuranceCarrier?: string | null,
          adjuster?: string | null,
        } | null,
        insuranceCarrierID?: string | null,
        insuranceCarrier?:  {
          __typename: "InsuranceCarrier",
          id: string,
          name: string,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierAddressID?: string | null,
        insuranceCarrierAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierFaxNumberID?: string | null,
        insuranceCarrierFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        insuranceCarrierPhoneNumberID?: string | null,
        insuranceCarrierPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        applicantAttorney?:  {
          __typename: "AttorneyInfo",
          name?: string | null,
          lawFirmName?: string | null,
        } | null,
        applicantAttorneyLawFirmID?: string | null,
        applicantAttorneyLawFirm?:  {
          __typename: "LawFirm",
          id: string,
          name: string,
          type: LawFirmType,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyAddressID?: string | null,
        applicantAttorneyAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyFaxNumberID?: string | null,
        applicantAttorneyFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        applicantAttorneyPhoneNumberID?: string | null,
        applicantAttorneyPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorney?:  {
          __typename: "AttorneyInfo",
          name?: string | null,
          lawFirmName?: string | null,
        } | null,
        defenseAttorneyLawFirmID?: string | null,
        defenseAttorneyLawFirm?:  {
          __typename: "LawFirm",
          id: string,
          name: string,
          type: LawFirmType,
          defaultAddressID?: string | null,
          defaultFaxNumberID?: string | null,
          defaultPhoneNumberID?: string | null,
          defaultEmail?: string | null,
          supportedDomains?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyAddressID?: string | null,
        defenseAttorneyAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyFaxNumberID?: string | null,
        defenseAttorneyFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        defenseAttorneyPhoneNumberID?: string | null,
        defenseAttorneyPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nurseCaseManager?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        ccPerson?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        applicantAttorneyCcEmails?: Array< string | null > | null,
        defenseAttorneyCcEmails?: Array< string | null > | null,
        adjusterCcEmails?: Array< string | null > | null,
        scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
        employmentAtInjury?:  {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null,
        WCAB?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDoctorLocationQueryVariables = {
  id: string,
};

export type GetDoctorLocationQuery = {
  getDoctorLocation?:  {
    __typename: "DoctorLocation",
    id: string,
    doctorId: string,
    locationId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    location:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type ListDoctorLocationsQueryVariables = {
  filter?: ModelDoctorLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDoctorLocationsQuery = {
  listDoctorLocations?:  {
    __typename: "ModelDoctorLocationConnection",
    items:  Array< {
      __typename: "DoctorLocation",
      id: string,
      doctorId: string,
      locationId: string,
      doctor:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      },
      location:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      },
      createdAt: string,
      updatedAt: string,
      ownerCognitoId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DoctorLocationsByDoctorIdQueryVariables = {
  doctorId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDoctorLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DoctorLocationsByDoctorIdQuery = {
  doctorLocationsByDoctorId?:  {
    __typename: "ModelDoctorLocationConnection",
    items:  Array< {
      __typename: "DoctorLocation",
      id: string,
      doctorId: string,
      locationId: string,
      doctor:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      },
      location:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      },
      createdAt: string,
      updatedAt: string,
      ownerCognitoId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DoctorLocationsByLocationIdQueryVariables = {
  locationId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDoctorLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DoctorLocationsByLocationIdQuery = {
  doctorLocationsByLocationId?:  {
    __typename: "ModelDoctorLocationConnection",
    items:  Array< {
      __typename: "DoctorLocation",
      id: string,
      doctorId: string,
      locationId: string,
      doctor:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      },
      location:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      },
      createdAt: string,
      updatedAt: string,
      ownerCognitoId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDoctorCaseSummaryFieldQueryVariables = {
  id: string,
};

export type GetDoctorCaseSummaryFieldQuery = {
  getDoctorCaseSummaryField?:  {
    __typename: "DoctorCaseSummaryField",
    id: string,
    doctorId: string,
    caseSummaryFieldId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    caseSummaryField:  {
      __typename: "CaseSummaryField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      summaryPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type ListDoctorCaseSummaryFieldsQueryVariables = {
  filter?: ModelDoctorCaseSummaryFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDoctorCaseSummaryFieldsQuery = {
  listDoctorCaseSummaryFields?:  {
    __typename: "ModelDoctorCaseSummaryFieldConnection",
    items:  Array< {
      __typename: "DoctorCaseSummaryField",
      id: string,
      doctorId: string,
      caseSummaryFieldId: string,
      doctor:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      },
      caseSummaryField:  {
        __typename: "CaseSummaryField",
        id: string,
        name: string,
        default: boolean,
        description?: string | null,
        summaryPrompt?: string | null,
        doctors?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
      ownerCognitoId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DoctorCaseSummaryFieldsByDoctorIdQueryVariables = {
  doctorId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDoctorCaseSummaryFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DoctorCaseSummaryFieldsByDoctorIdQuery = {
  doctorCaseSummaryFieldsByDoctorId?:  {
    __typename: "ModelDoctorCaseSummaryFieldConnection",
    items:  Array< {
      __typename: "DoctorCaseSummaryField",
      id: string,
      doctorId: string,
      caseSummaryFieldId: string,
      doctor:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      },
      caseSummaryField:  {
        __typename: "CaseSummaryField",
        id: string,
        name: string,
        default: boolean,
        description?: string | null,
        summaryPrompt?: string | null,
        doctors?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
      ownerCognitoId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DoctorCaseSummaryFieldsByCaseSummaryFieldIdQueryVariables = {
  caseSummaryFieldId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDoctorCaseSummaryFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DoctorCaseSummaryFieldsByCaseSummaryFieldIdQuery = {
  doctorCaseSummaryFieldsByCaseSummaryFieldId?:  {
    __typename: "ModelDoctorCaseSummaryFieldConnection",
    items:  Array< {
      __typename: "DoctorCaseSummaryField",
      id: string,
      doctorId: string,
      caseSummaryFieldId: string,
      doctor:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      },
      caseSummaryField:  {
        __typename: "CaseSummaryField",
        id: string,
        name: string,
        default: boolean,
        description?: string | null,
        summaryPrompt?: string | null,
        doctors?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
      ownerCognitoId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDoctorBriefingFieldQueryVariables = {
  id: string,
};

export type GetDoctorBriefingFieldQuery = {
  getDoctorBriefingField?:  {
    __typename: "DoctorBriefingField",
    id: string,
    doctorId: string,
    briefingFieldId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    briefingField:  {
      __typename: "BriefingField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      briefingPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingRecordTypeID: string,
      recordType:  {
        __typename: "BriefingRecordType",
        id: string,
        name: string,
        recordType: RecordType,
        description?: string | null,
        default: boolean,
        classificationPrompt?: string | null,
        recordBasePrompt?: string | null,
        briefingFields?:  {
          __typename: "ModelBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type ListDoctorBriefingFieldsQueryVariables = {
  filter?: ModelDoctorBriefingFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDoctorBriefingFieldsQuery = {
  listDoctorBriefingFields?:  {
    __typename: "ModelDoctorBriefingFieldConnection",
    items:  Array< {
      __typename: "DoctorBriefingField",
      id: string,
      doctorId: string,
      briefingFieldId: string,
      doctor:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      },
      briefingField:  {
        __typename: "BriefingField",
        id: string,
        name: string,
        default: boolean,
        description?: string | null,
        briefingPrompt?: string | null,
        doctors?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingRecordTypeID: string,
        recordType:  {
          __typename: "BriefingRecordType",
          id: string,
          name: string,
          recordType: RecordType,
          description?: string | null,
          default: boolean,
          classificationPrompt?: string | null,
          recordBasePrompt?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
      ownerCognitoId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DoctorBriefingFieldsByDoctorIdQueryVariables = {
  doctorId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDoctorBriefingFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DoctorBriefingFieldsByDoctorIdQuery = {
  doctorBriefingFieldsByDoctorId?:  {
    __typename: "ModelDoctorBriefingFieldConnection",
    items:  Array< {
      __typename: "DoctorBriefingField",
      id: string,
      doctorId: string,
      briefingFieldId: string,
      doctor:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      },
      briefingField:  {
        __typename: "BriefingField",
        id: string,
        name: string,
        default: boolean,
        description?: string | null,
        briefingPrompt?: string | null,
        doctors?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingRecordTypeID: string,
        recordType:  {
          __typename: "BriefingRecordType",
          id: string,
          name: string,
          recordType: RecordType,
          description?: string | null,
          default: boolean,
          classificationPrompt?: string | null,
          recordBasePrompt?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
      ownerCognitoId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DoctorBriefingFieldsByBriefingFieldIdQueryVariables = {
  briefingFieldId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDoctorBriefingFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DoctorBriefingFieldsByBriefingFieldIdQuery = {
  doctorBriefingFieldsByBriefingFieldId?:  {
    __typename: "ModelDoctorBriefingFieldConnection",
    items:  Array< {
      __typename: "DoctorBriefingField",
      id: string,
      doctorId: string,
      briefingFieldId: string,
      doctor:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      },
      briefingField:  {
        __typename: "BriefingField",
        id: string,
        name: string,
        default: boolean,
        description?: string | null,
        briefingPrompt?: string | null,
        doctors?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingRecordTypeID: string,
        recordType:  {
          __typename: "BriefingRecordType",
          id: string,
          name: string,
          recordType: RecordType,
          description?: string | null,
          default: boolean,
          classificationPrompt?: string | null,
          recordBasePrompt?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
      ownerCognitoId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchAppointmentsQueryVariables = {
  input: AppointmentSearchInput,
};

export type SearchAppointmentsQuery = {
  searchAppointments?:  {
    __typename: "AppointmentSearchConnection",
    items:  Array< {
      __typename: "AppointmentSearchResult",
      id: string,
      patient_name?: string | null,
      primary_claim_number?: string | null,
      other_claim_numbers?: Array< string | null > | null,
      doctor_name?: string | null,
      location?: string | null,
      doctor_id?: string | null,
      date?: string | null,
      time?: string | null,
      language?: string | null,
      appt_type?: string | null,
      is_prod?: boolean | null,
    } | null >,
    total?: number | null,
    nextToken?: string | null,
  } | null,
};

export type OnCreateAppointmentFileReferenceSubscriptionVariables = {
  filter?: ModelSubscriptionAppointmentFileReferenceFilterInput | null,
};

export type OnCreateAppointmentFileReferenceSubscription = {
  onCreateAppointmentFileReference?:  {
    __typename: "AppointmentFileReference",
    id: string,
    appointmentID: string,
    uploadedFileID: string,
    status?: AppointmentFileReferenceStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAppointmentFileReferenceSubscriptionVariables = {
  filter?: ModelSubscriptionAppointmentFileReferenceFilterInput | null,
};

export type OnUpdateAppointmentFileReferenceSubscription = {
  onUpdateAppointmentFileReference?:  {
    __typename: "AppointmentFileReference",
    id: string,
    appointmentID: string,
    uploadedFileID: string,
    status?: AppointmentFileReferenceStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAppointmentFileReferenceSubscriptionVariables = {
  filter?: ModelSubscriptionAppointmentFileReferenceFilterInput | null,
};

export type OnDeleteAppointmentFileReferenceSubscription = {
  onDeleteAppointmentFileReference?:  {
    __typename: "AppointmentFileReference",
    id: string,
    appointmentID: string,
    uploadedFileID: string,
    status?: AppointmentFileReferenceStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUploadedFileSubscriptionVariables = {
  filter?: ModelSubscriptionUploadedFileFilterInput | null,
};

export type OnCreateUploadedFileSubscription = {
  onCreateUploadedFile?:  {
    __typename: "UploadedFile",
    id: string,
    key?: string | null,
    fileName?: string | null,
    type?: FileType | null,
    provider?: FileProvider | null,
    uploadedBy?: string | null,
    uploadedAt?: string | null,
    fileSizeBytes?: number | null,
    fileSet?:  {
      __typename: "UploadedFileSet",
      id: string,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      uploadedFiles?:  {
        __typename: "ModelUploadedFileConnection",
        items:  Array< {
          __typename: "UploadedFile",
          id: string,
          key?: string | null,
          fileName?: string | null,
          type?: FileType | null,
          provider?: FileProvider | null,
          uploadedBy?: string | null,
          uploadedAt?: string | null,
          fileSizeBytes?: number | null,
          fileSetID?: string | null,
          sourceAppointmentID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fileSetID?: string | null,
    sourceAppointmentID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUploadedFileSubscriptionVariables = {
  filter?: ModelSubscriptionUploadedFileFilterInput | null,
};

export type OnUpdateUploadedFileSubscription = {
  onUpdateUploadedFile?:  {
    __typename: "UploadedFile",
    id: string,
    key?: string | null,
    fileName?: string | null,
    type?: FileType | null,
    provider?: FileProvider | null,
    uploadedBy?: string | null,
    uploadedAt?: string | null,
    fileSizeBytes?: number | null,
    fileSet?:  {
      __typename: "UploadedFileSet",
      id: string,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      uploadedFiles?:  {
        __typename: "ModelUploadedFileConnection",
        items:  Array< {
          __typename: "UploadedFile",
          id: string,
          key?: string | null,
          fileName?: string | null,
          type?: FileType | null,
          provider?: FileProvider | null,
          uploadedBy?: string | null,
          uploadedAt?: string | null,
          fileSizeBytes?: number | null,
          fileSetID?: string | null,
          sourceAppointmentID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fileSetID?: string | null,
    sourceAppointmentID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUploadedFileSubscriptionVariables = {
  filter?: ModelSubscriptionUploadedFileFilterInput | null,
};

export type OnDeleteUploadedFileSubscription = {
  onDeleteUploadedFile?:  {
    __typename: "UploadedFile",
    id: string,
    key?: string | null,
    fileName?: string | null,
    type?: FileType | null,
    provider?: FileProvider | null,
    uploadedBy?: string | null,
    uploadedAt?: string | null,
    fileSizeBytes?: number | null,
    fileSet?:  {
      __typename: "UploadedFileSet",
      id: string,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      uploadedFiles?:  {
        __typename: "ModelUploadedFileConnection",
        items:  Array< {
          __typename: "UploadedFile",
          id: string,
          key?: string | null,
          fileName?: string | null,
          type?: FileType | null,
          provider?: FileProvider | null,
          uploadedBy?: string | null,
          uploadedAt?: string | null,
          fileSizeBytes?: number | null,
          fileSetID?: string | null,
          sourceAppointmentID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fileSetID?: string | null,
    sourceAppointmentID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionDocumentFilterInput | null,
};

export type OnCreateDocumentSubscription = {
  onCreateDocument?:  {
    __typename: "Document",
    id: string,
    uploadedFileID: string,
    providerTag?: string | null,
    pageCount: number,
    executionArn: string,
    recordBriefingId?: string | null,
    segmentSplits?: Array< number | null > | null,
    segmentIntervals?:  Array< {
      __typename: "SegmentInterval",
      startPageNumber: number,
      endPageNumber: number,
      startLineNumber?: number | null,
      endLineNumber?: number | null,
      confidence?: number | null,
      confidenceReasoning?: string | null,
      edited?: boolean | null,
      needsReSummary?: boolean | null,
    } | null > | null,
    segmentIntervalRows?:  {
      __typename: "ModelDocumentSegmentIntervalConnection",
      items:  Array< {
        __typename: "DocumentSegmentInterval",
        id: string,
        documentID: string,
        startPageNumber: number,
        endPageNumber: number,
        startLineNumber?: number | null,
        endLineNumber?: number | null,
        confidence?: number | null,
        confidenceReasoning?: string | null,
        edited?: boolean | null,
        needsReSummary?: boolean | null,
        archived?: boolean | null,
        parentIntervals?: Array< string > | null,
        lastEditAction?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    pages?:  {
      __typename: "ModelDocumentPageConnection",
      items:  Array< {
        __typename: "DocumentPage",
        id: string,
        documentID: string,
        pageNumber: number,
        imageS3Key?: string | null,
        text?: string | null,
        isBlank?: boolean | null,
        citations?:  {
          __typename: "ModelCitationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    preview?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    hasUnresolvedSplits?: boolean | null,
    videoDurationSeconds?: number | null,
    ingestionSteps?:  {
      __typename: "ModelDocumentIngestionStepConnection",
      items:  Array< {
        __typename: "DocumentIngestionStep",
        id: string,
        documentID: string,
        name: string,
        status: IngestionStepStatus,
        startedAt: string,
        endedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mrrValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    documentMrrValidationId?: string | null,
  } | null,
};

export type OnUpdateDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionDocumentFilterInput | null,
};

export type OnUpdateDocumentSubscription = {
  onUpdateDocument?:  {
    __typename: "Document",
    id: string,
    uploadedFileID: string,
    providerTag?: string | null,
    pageCount: number,
    executionArn: string,
    recordBriefingId?: string | null,
    segmentSplits?: Array< number | null > | null,
    segmentIntervals?:  Array< {
      __typename: "SegmentInterval",
      startPageNumber: number,
      endPageNumber: number,
      startLineNumber?: number | null,
      endLineNumber?: number | null,
      confidence?: number | null,
      confidenceReasoning?: string | null,
      edited?: boolean | null,
      needsReSummary?: boolean | null,
    } | null > | null,
    segmentIntervalRows?:  {
      __typename: "ModelDocumentSegmentIntervalConnection",
      items:  Array< {
        __typename: "DocumentSegmentInterval",
        id: string,
        documentID: string,
        startPageNumber: number,
        endPageNumber: number,
        startLineNumber?: number | null,
        endLineNumber?: number | null,
        confidence?: number | null,
        confidenceReasoning?: string | null,
        edited?: boolean | null,
        needsReSummary?: boolean | null,
        archived?: boolean | null,
        parentIntervals?: Array< string > | null,
        lastEditAction?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    pages?:  {
      __typename: "ModelDocumentPageConnection",
      items:  Array< {
        __typename: "DocumentPage",
        id: string,
        documentID: string,
        pageNumber: number,
        imageS3Key?: string | null,
        text?: string | null,
        isBlank?: boolean | null,
        citations?:  {
          __typename: "ModelCitationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    preview?:  {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } | null,
    hasUnresolvedSplits?: boolean | null,
    videoDurationSeconds?: number | null,
    ingestionSteps?:  {
      __typename: "ModelDocumentIngestionStepConnection",
      items:  Array< {
        __typename: "DocumentIngestionStep",
        id: string,
        documentID: string,
        name: string,
        status: IngestionStepStatus,
        startedAt: string,
        endedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mrrValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    documentMrrValidationId?: string | null,
  } | null,
};

export type OnCreateOperationStatusSubscriptionVariables = {
  filter?: ModelSubscriptionOperationStatusFilterInput | null,
};

export type OnCreateOperationStatusSubscription = {
  onCreateOperationStatus?:  {
    __typename: "OperationStatus",
    id: string,
    scope: string,
    operation: string,
    name: string,
    status: OperationState,
    startedAt: string,
    heartbeatAt?: string | null,
    endedAt?: string | null,
    attempt?: number | null,
    errorMessage?: string | null,
    correlationId?: string | null,
    metadata?: string | null,
    expiresAt?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateOperationStatusSubscriptionVariables = {
  filter?: ModelSubscriptionOperationStatusFilterInput | null,
};

export type OnUpdateOperationStatusSubscription = {
  onUpdateOperationStatus?:  {
    __typename: "OperationStatus",
    id: string,
    scope: string,
    operation: string,
    name: string,
    status: OperationState,
    startedAt: string,
    heartbeatAt?: string | null,
    endedAt?: string | null,
    attempt?: number | null,
    errorMessage?: string | null,
    correlationId?: string | null,
    metadata?: string | null,
    expiresAt?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateDocumentPageSubscriptionVariables = {
  filter?: ModelSubscriptionDocumentPageFilterInput | null,
};

export type OnCreateDocumentPageSubscription = {
  onCreateDocumentPage?:  {
    __typename: "DocumentPage",
    id: string,
    documentID: string,
    pageNumber: number,
    imageS3Key?: string | null,
    text?: string | null,
    isBlank?: boolean | null,
    citations?:  {
      __typename: "ModelCitationConnection",
      items:  Array< {
        __typename: "Citation",
        id: string,
        documentPageID: string,
        documentID: string,
        pageNumber: number,
        blockIndex: number,
        text: string,
        bbox:  {
          __typename: "BoundingBox",
          yMin: number,
          xMin: number,
          yMax: number,
          xMax: number,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateDocumentPageSubscriptionVariables = {
  filter?: ModelSubscriptionDocumentPageFilterInput | null,
};

export type OnUpdateDocumentPageSubscription = {
  onUpdateDocumentPage?:  {
    __typename: "DocumentPage",
    id: string,
    documentID: string,
    pageNumber: number,
    imageS3Key?: string | null,
    text?: string | null,
    isBlank?: boolean | null,
    citations?:  {
      __typename: "ModelCitationConnection",
      items:  Array< {
        __typename: "Citation",
        id: string,
        documentPageID: string,
        documentID: string,
        pageNumber: number,
        blockIndex: number,
        text: string,
        bbox:  {
          __typename: "BoundingBox",
          yMin: number,
          xMin: number,
          yMax: number,
          xMax: number,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateNotesSubscriptionVariables = {
  filter?: ModelSubscriptionNotesFilterInput | null,
};

export type OnCreateNotesSubscription = {
  onCreateNotes?:  {
    __typename: "Notes",
    id: string,
    content?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    type?: NotesType | null,
    timeStamp?: number | null,
    appointmentrecordID: string,
    createdAt: string,
    updatedAt: string,
    notesAuthorId?: string | null,
  } | null,
};

export type OnUpdateNotesSubscriptionVariables = {
  filter?: ModelSubscriptionNotesFilterInput | null,
};

export type OnUpdateNotesSubscription = {
  onUpdateNotes?:  {
    __typename: "Notes",
    id: string,
    content?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    type?: NotesType | null,
    timeStamp?: number | null,
    appointmentrecordID: string,
    createdAt: string,
    updatedAt: string,
    notesAuthorId?: string | null,
  } | null,
};

export type OnUpdateHuddleNoteSubscriptionVariables = {
  filter?: ModelSubscriptionHuddleNoteFilterInput | null,
};

export type OnUpdateHuddleNoteSubscription = {
  onUpdateHuddleNote?:  {
    __typename: "HuddleNote",
    id: string,
    appointmentRecordID: string,
    contentMarkdown?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    cognitoUserId: string,
    avatarUrl?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    doctor?:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null,
    assistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    appointmentFilterPreset?:  {
      __typename: "ModelUserAppointmentFilterPresetConnection",
      items:  Array< {
        __typename: "UserAppointmentFilterPreset",
        id: string,
        userId: string,
        appointmentFilterPresetId: string,
        user:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        },
        appointmentFilterPreset:  {
          __typename: "AppointmentFilterPreset",
          id: string,
          name: string,
          appliesTo: UserGroup,
          view?: AppointmentsView | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    onboardingDismissals?:  Array< {
      __typename: "OnboardingDismissal",
      itemId: string,
      dismissedAt: string,
    } | null > | null,
    settings?:  {
      __typename: "UserSettings",
      opsChecklistDefaultExpanded?: boolean | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    userDoctorId?: string | null,
    userAssistantId?: string | null,
  } | null,
};

export type OnCreateCaseRecordSubscriptionVariables = {
  filter?: ModelSubscriptionCaseRecordFilterInput | null,
};

export type OnCreateCaseRecordSubscription = {
  onCreateCaseRecord?:  {
    __typename: "CaseRecord",
    id: string,
    state?: CaseState | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCaseRecordSubscriptionVariables = {
  filter?: ModelSubscriptionCaseRecordFilterInput | null,
};

export type OnUpdateCaseRecordSubscription = {
  onUpdateCaseRecord?:  {
    __typename: "CaseRecord",
    id: string,
    state?: CaseState | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCaseRecordSubscriptionVariables = {
  filter?: ModelSubscriptionCaseRecordFilterInput | null,
};

export type OnDeleteCaseRecordSubscription = {
  onDeleteCaseRecord?:  {
    __typename: "CaseRecord",
    id: string,
    state?: CaseState | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAppointmentRecordSubscriptionVariables = {
  filter?: ModelSubscriptionAppointmentRecordFilterInput | null,
  doctorOwnerCognitoId?: string | null,
};

export type OnUpdateAppointmentRecordSubscription = {
  onUpdateAppointmentRecord?:  {
    __typename: "AppointmentRecord",
    id: string,
    doctorOwnerCognitoId?: string | null,
    assistantCognitoIds?: Array< string > | null,
    globalPartitionKey: string,
    originalAppointmentID: string,
    supplementalAppointmentIDs?: Array< string | null > | null,
    supplementalSourceAppointmentIDs?: Array< string | null > | null,
    depositionAppointmentIDs?: Array< string | null > | null,
    depositionSourceAppointmentIDs?: Array< string | null > | null,
    rescheduledFromAppointmentID?: string | null,
    rescheduledToAppointmentID?: string | null,
    date?: string | null,
    yearMonth?: string | null,
    doctorYearMonth?: string | null,
    time?: string | null,
    bookedInFlexibleTime?: boolean | null,
    inquiryDate: string,
    inquiryYearMonth: string,
    type?: AppointmentType | null,
    doctorID?: string | null,
    doctor?:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    } | null,
    locationID?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    } | null,
    visitForm?: string | null,
    jotformSubmissions?:  Array< {
      __typename: "JotformSubmission",
      id: string,
      receivedAt: string,
      populatedAt?: string | null,
    } | null > | null,
    historyTranscriptPopulations?:  Array< {
      __typename: "HistoryTranscriptPopulation",
      uploadedFileID: string,
      populatedAt: string,
    } | null > | null,
    active?: boolean | null,
    durationMinutes?: number | null,
    reportDue?: string | null,
    reportSubmitted?: string | null,
    status?: AppointmentStatus | null,
    reportStatus?: ReportStatus | null,
    paymentStatus?: PaymentStatus | null,
    billingStatus?: BillingStatus | null,
    difficultyLevel?: number | null,
    scheduler?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    medicalAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    schedulingAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    onSiteOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    reportOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    billingOp?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    preVisitReviewer?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    inquirerInfo?:  {
      __typename: "InquirerInfo",
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      inquiringParty?: InquiringParty | null,
      name?: string | null,
      inquiryDate?: string | null,
      notification_110_required?: boolean | null,
    } | null,
    notes?:  {
      __typename: "ModelNotesConnection",
      items:  Array< {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    huddleNote?:  {
      __typename: "HuddleNote",
      id: string,
      appointmentRecordID: string,
      contentMarkdown?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    patientCases?:  {
      __typename: "ModelAppointmentRecordPatientCaseConnection",
      items:  Array< {
        __typename: "AppointmentRecordPatientCase",
        id: string,
        appointmentRecordId: string,
        patientCaseId: string,
        appointmentRecord:  {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        },
        patientCase:  {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    employments?:  Array< {
      __typename: "EmploymentRecord",
      employerName?: string | null,
      jobTitle?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      dateOfHire?: string | null,
      dateOfHireFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      hoursPerWeek?: string | null,
      jobDuties?: string | null,
      dateOfTermination?: string | null,
      dateOfTerminationFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
      stillWorkingHere?: boolean | null,
      type?: EmploymentType | null,
      currentWorkRestrictions?: string | null,
      workStatus?: string | null,
      departureReason?: string | null,
    } | null > | null,
    employmentGaps?:  Array< {
      __typename: "EmploymentGapRecord",
      type?: EmploymentGapType | null,
      startDate?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      endDate?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
    } | null > | null,
    patientDescribedInjuries?: Array< BodyPart | null > | null,
    uploadedFilesSet?:  {
      __typename: "UploadedFileSet",
      id: string,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      uploadedFiles?:  {
        __typename: "ModelUploadedFileConnection",
        items:  Array< {
          __typename: "UploadedFile",
          id: string,
          key?: string | null,
          fileName?: string | null,
          type?: FileType | null,
          provider?: FileProvider | null,
          uploadedBy?: string | null,
          uploadedAt?: string | null,
          fileSizeBytes?: number | null,
          fileSetID?: string | null,
          sourceAppointmentID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploadedFilesSetID?: string | null,
    referredBy?: string | null,
    s3FileKey?: string | null,
    medicalRecordsReceived?: boolean | null,
    medicalRecordsBriefingFileID?: string | null,
    medicalRecordsBriefingExecutionArn?: string | null,
    medicalRecordsTotalPagesProcessed?: number | null,
    reportGenerationFileID?: string | null,
    reportGenerationExecutionArn?: string | null,
    reportGenerationGeneratedAt?: string | null,
    historyOfInjuryFileID?: string | null,
    historyOfInjuryGeneratedAt?: string | null,
    evaluationFileID?: string | null,
    assessmentFileID?: string | null,
    depositionPreparationFileID?: string | null,
    documentStatus?:  {
      __typename: "DocumentStatus",
      evaluationPublished?: boolean | null,
      assessmentPublished?: boolean | null,
      historyInProgress?: boolean | null,
      historyPublished?: boolean | null,
      historyCleaned?: boolean | null,
      reportPublished?: boolean | null,
      briefingInProgress?: boolean | null,
      briefingPublished?: boolean | null,
      briefingCleaned?: boolean | null,
    } | null,
    cancellationReason?: CancellationReason | null,
    cancellationRequestedBy?: ParticipantType | null,
    cancellationRequestedInternally?: boolean | null,
    cancellationNote?: string | null,
    cancellationDate?: string | null,
    inquiryClosingReason?: InquiryClosingReason | null,
    inquiryClosingNote?: string | null,
    inquiryClosingDate?: string | null,
    noShowReason?: NoShowReason | null,
    noShowNote?: string | null,
    reschedulingReason?: ReschedulingReason | null,
    reschedulingOthersReason?: string | null,
    reschedulingRequestedBy?: ParticipantType | null,
    reschedulingRequestedInternally?: boolean | null,
    reschedulingNote?: string | null,
    reschedulingDate?: string | null,
    interpreter?:  {
      __typename: "InterpreterInfo",
      certificateId?: string | null,
      name?: string | null,
      companyName?: string | null,
      phoneNumber?: string | null,
      phoneExtension?: string | null,
      note?: string | null,
      confirmed?: boolean | null,
    } | null,
    historyOfInjuryNotes?:  {
      __typename: "Notes",
      id: string,
      content?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      type?: NotesType | null,
      timeStamp?: number | null,
      appointmentrecordID: string,
      createdAt: string,
      updatedAt: string,
      notesAuthorId?: string | null,
    } | null,
    currentComplaintNotes?:  {
      __typename: "Notes",
      id: string,
      content?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      type?: NotesType | null,
      timeStamp?: number | null,
      appointmentrecordID: string,
      createdAt: string,
      updatedAt: string,
      notesAuthorId?: string | null,
    } | null,
    historyCallDate?: string | null,
    historyCallTime?: string | null,
    historyCallAssistant?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    historyCallCompleted?: boolean | null,
    historyCallCompletedWithoutRecords?: boolean | null,
    historyCallCompletedOnSite?: boolean | null,
    historyCallNoShow?: boolean | null,
    historyCallCalendarEventID?: string | null,
    historyCallCalendarLink?: string | null,
    billingInfo?:  {
      __typename: "BillingInfo",
      diagnosisMappings?:  Array< {
        __typename: "DiagnosisMapping",
        code?: string | null,
        pointer?: string | null,
        description?: string | null,
      } | null > | null,
      serviceDetails?:  Array< {
        __typename: "ServiceDetail",
        dateOfStart?: string | null,
        dateOfEnd?: string | null,
        place?: number | null,
        emergencyIndicator?: boolean | null,
        serviceType?: ServiceType | null,
        modifiers?: Array< ServiceModifier | null > | null,
        diagnosisPointers?: Array< string | null > | null,
        chargedAmount?: number | null,
        quantity?: number | null,
        amountPaid?: number | null,
        renderingProviderId?: string | null,
      } | null > | null,
      totalCharge?: number | null,
      amountPaid?: number | null,
      billingCounter?: number | null,
      billedDate?: string | null,
      paidDate?: string | null,
      correctionDate?: string | null,
    } | null,
    caseInfo?:  {
      __typename: "CaseInfo",
      confirmationEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
      recordsFollowupEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
      attendanceEmailStatuses?:  {
        __typename: "ParticipantEmailStatuses",
        patient?: boolean | null,
        adjuster?: boolean | null,
        applicantAttorney?: boolean | null,
        defenseAttorney?: boolean | null,
        patientSentAt?: string | null,
        adjusterSentAt?: string | null,
        applicantAttorneySentAt?: string | null,
        defenseAttorneySentAt?: string | null,
      } | null,
    } | null,
    isProd?: boolean | null,
    isDemo?: boolean | null,
    primaryPatientCaseID?: string | null,
    calendarEventID?: string | null,
    reportConfiguration?:  {
      __typename: "ReportConfiguration",
      history?: ReportSource | null,
      physicalExamination?: ReportSource | null,
      assessment?: ReportSource | null,
    } | null,
    workflowExecutions?:  {
      __typename: "ModelWorkflowExecutionConnection",
      items:  Array< {
        __typename: "WorkflowExecution",
        executionArn: string,
        appointmentRecordID: string,
        type?: WorkflowExecutionType | null,
        status?: WorkflowExecutionStatus | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    historyOfInjuryInsights?:  {
      __typename: "HistoryOfInjuryInsights",
      id: string,
      appointmentRecordID: string,
      mechanismOfInjury?: string | null,
      employerJobDescription?: string | null,
      injuryCausations?:  Array< {
        __typename: "InjuryCausationInfo",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryEnd?: string | null,
        bodyParts?: Array< BodyPart | null > | null,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
      } | null > | null,
      currentSymptoms?:  Array< {
        __typename: "Symptom",
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      priorSymptomsBeforeCurrentInjury?:  Array< {
        __typename: "Symptom",
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      previousSurgeries?:  Array< {
        __typename: "SurgeryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        type?: string | null,
      } | null > | null,
      previousWorkInjuries?:  Array< {
        __typename: "InjuryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      previousInjuries?:  Array< {
        __typename: "InjuryHistoryInfo",
        date?: string | null,
        bodyParts?: Array< string | null > | null,
        description?: string | null,
      } | null > | null,
      injuryEmploymentStatus?: string | null,
      currentWorkRestrictionsFromPatient?: string | null,
      activitiesOfDailyLiving?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reviewOfMedicalRecordsInsights?:  {
      __typename: "ReviewOfMedicalRecordsInsights",
      id: string,
      appointmentRecordID: string,
      latestDiagnosis?:  Array< {
        __typename: "BodyPartDiagnosis",
        bodyPart?: string | null,
        date?: string | null,
        descriptions?: Array< string | null > | null,
      } | null > | null,
      diagnosticStudies?:  Array< {
        __typename: "DiagnosticStudy",
        date?: string | null,
        typeOfStudy?: DiagnosticStudyType | null,
        bodyPart?: string | null,
        impression?: string | null,
        source?: DiagnosticStudySource | null,
      } | null > | null,
      treatments?:  Array< {
        __typename: "TreatmentWrapper",
        discreteTreatment?:  {
          __typename: "DiscreteTreatment",
          date?: string | null,
          treatmentType?: DiscreteTreatmentType | null,
          bodyPart?: string | null,
          description?: string | null,
        } | null,
        recurringTreatment?:  {
          __typename: "RecurringTreatment",
          year?: string | null,
          treatmentType?: RecurringTreatmentType | null,
          frequency?: string | null,
          description?: string | null,
        } | null,
      } | null > | null,
      currentWorkRestrictionsFromMedicalRecords?: string | null,
      previousReports?:  Array< {
        __typename: "PreviousReport",
        date?: string | null,
        reportType?: string | null,
        reportContent?: string | null,
      } | null > | null,
      durableMedicalEquipment?:  Array< {
        __typename: "DurableMedicalEquipment",
        startDate?: string | null,
        endDate?: string | null,
        bodyParts?: Array< string | null > | null,
        equipmentType?: string | null,
        description?: string | null,
      } | null > | null,
      derivedFromDocumentInsightIDs?: Array< string | null > | null,
      derivedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    physicalExamInsights?:  {
      __typename: "PhysicalExamInsights",
      id: string,
      appointmentRecordID: string,
      physicalExaminationInfo?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    pastInjuryMatrix?:  {
      __typename: "PastInjuryMatrix",
      id: string,
      appointmentRecordID: string,
      preExistingConditions: Array< string >,
      familyHistory: Array< string >,
      injuryMatrix:  Array< {
        __typename: "InjuryMatrixEntry",
        date: string,
        bodyPart: BodyPart,
        status: InjuryStatus,
      } >,
      createdAt: string,
      updatedAt: string,
    } | null,
    briefing?:  {
      __typename: "RecordBriefing",
      id: string,
      logicalBriefingID: string,
      segmentMappings?:  {
        __typename: "ModelRecordBriefingSegmentMappingConnection",
        items:  Array< {
          __typename: "RecordBriefingSegmentMapping",
          id: string,
          briefingID: string,
          logicalSegmentID: string,
          publishedSegmentID?: string | null,
          draftSegmentID?: string | null,
          markedForDeletion?: boolean | null,
          markedForCreation?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      googleDocExportLink?: string | null,
      googleDocExportedAt?: string | null,
      suggestionGeneration?:  {
        __typename: "SuggestionGenerationJob",
        status?: SuggestionGenerationStatus | null,
        jobId?: string | null,
        startedAt?: string | null,
        completedAt?: string | null,
        error?: string | null,
      } | null,
      editingPresence?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    introParagraph?:  {
      __typename: "IntroParagraph",
      id: string,
      appointmentRecordID: string,
      introParagraphText?: string | null,
      sourceRecaps?:  Array< {
        __typename: "CoverLetterRecapSnapshot",
        coverLetterRecapID: string,
        uploadedFileID: string,
        recapText: string,
        generatedAt?: string | null,
      } | null > | null,
      status: IntroParagraphStatus,
      errorMessage?: string | null,
      generatedAt?: string | null,
      lastEditedAt?: string | null,
      lastEditedBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    impairmentRatingResults?:  Array< {
      __typename: "ImpairmentRatingResult",
      ts?: number | null,
      bodyParts?: Array< string | null > | null,
      enabledStrictRating?: boolean | null,
      enabledPainRating?: boolean | null,
      enabledAG?: boolean | null,
      enabledStrengthRating?: boolean | null,
      enabledDBE?: boolean | null,
      autoMode?: boolean | null,
      result?: string | null,
      resultFeedback?:  {
        __typename: "ImpairmentRatingResultFeedback",
        exists?: boolean | null,
        isGood?: boolean | null,
        notes?: string | null,
      } | null,
    } | null > | null,
    defenseAttorneyPagesDeclaration?: number | null,
    applicantAttorneyPagesDeclaration?: number | null,
    fieldTemplateRef?:  {
      __typename: "FieldTemplateRef",
      id: string,
      version: number,
    } | null,
    dataFieldValuesMappings?:  Array< {
      __typename: "DataFieldValueMapping",
      dataFieldID?: string | null,
      value?: string | null,
    } | null > | null,
    physicalEvalTemplateRef?:  {
      __typename: "FieldTemplateRef",
      id: string,
      version: number,
    } | null,
    physicalExamValues?:  Array< {
      __typename: "PhysicalExamValue",
      sectionID: string,
      questionID: string,
      side?: PhysicalExamSide | null,
      value?: string | null,
      note?: string | null,
      excluded?: boolean | null,
    } | null > | null,
    physicalExamOtherFindings?:  Array< {
      __typename: "PhysicalExamOtherFinding",
      sectionID: string,
      text?: string | null,
    } | null > | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      injuries?:  Array< {
        __typename: "AssessmentInjury",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        dateOfInjuryEnd?: string | null,
        dateOfInjuryEndFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        bodyParts?: Array< BodyPart | null > | null,
        causeOfInjury?: string | null,
        causedByWork?: AssessmentCausationOption | null,
        causedByWorkExplanation?: string | null,
      } | null > | null,
      discussedBodyParts?: Array< BodyPart | null > | null,
      bodyPartsNotDiscussedReason?: string | null,
      discussions?: string | null,
      diagnoses?:  Array< {
        __typename: "AssessmentDiagnosis",
        diagnosis?: string | null,
        icdCode?: string | null,
        evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
        evidence?: string | null,
      } | null > | null,
      bodyPartMMIStatus?:  {
        __typename: "AssessmentBodyPartMMIStatus",
        discussByBodyPart?: boolean | null,
        allBodyPartsMMI?:  {
          __typename: "AssessmentBodyPartEvaluation",
          mmi?: boolean | null,
          mmiReason?: string | null,
          expectedMMITimeRange?: AssessmentMmiTimeRange | null,
          expectedMMITimeRangeExplanation?: string | null,
          treatments?: Array< string | null > | null,
          treatmentsExplanation?: string | null,
          discussions?: string | null,
          impairmentRating?: string | null,
          impairmentRatingNotApplicable?: boolean | null,
          deferImpairmentRating?: boolean | null,
          deferImpairmentRatingReason?: string | null,
          apportionment?: string | null,
          apportionmentNotApplicable?: boolean | null,
          deferApportionment?: boolean | null,
          deferApportionmentReason?: string | null,
        } | null,
        bodyPartMMIStatuses?:  Array< {
          __typename: "AssessmentBodyPart",
          bodyPart?: BodyPart | null,
        } | null > | null,
      } | null,
      workStatus?: string | null,
      markedAsDone?: boolean | null,
      discussDiagnosesFreeForm?: boolean | null,
      diagnosesFreeform?: string | null,
      discussCausationFreeForm?: boolean | null,
      causationFreeForm?: string | null,
      discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
      hasPatientReachedMMIFreeForm?: string | null,
      discussMMIByBodyPartFreeForm?: string | null,
      impairmentRatingByBodyPartFreeForm?: string | null,
      apportionmentByBodyPartFreeForm?: string | null,
      impairmentRatingOtherComments?: string | null,
      apportionmentOtherComments?: string | null,
      assessmentMode?: AssessmentMode | null,
      assessmentFreeForm?:  {
        __typename: "AssessmentFreeForm",
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussions?: string | null,
        diagnosesAndEvidence?: string | null,
        causation?: string | null,
        hasPatientReachedMMI?: string | null,
        discussMMIByBodyPart?: string | null,
        impairmentRatingByBodyPart?: string | null,
        apportionmentByBodyPart?: string | null,
        workStatus?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    opinionRecap?:  {
      __typename: "OpinionRecap",
      id: string,
      appointmentRecordID: string,
      causation?: string | null,
      diagnosis?: string | null,
      mmiFutureMedicalTreatment?: string | null,
      impairmentRating?: string | null,
      apportionment?: string | null,
      workStatus?: string | null,
      sourceReportFileID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
    featureFlags?:  Array< {
      __typename: "AppointmentFeatureConfig",
      featureFlagKey: string,
      enabled: boolean,
    } | null > | null,
    opsChecklist?:  {
      __typename: "OpsChecklist",
      panel?: OpsChecklistItemStatus | null,
      contact_info?: OpsChecklistItemStatus | null,
      all_parties?: OpsChecklistItemStatus | null,
      notice_110?: OpsChecklistItemStatus | null,
      cover_letter?: OpsChecklistItemStatus | null,
      record_review?: OpsChecklistItemStatus | null,
      history_call?: OpsChecklistItemStatus | null,
      history_of_injury?: OpsChecklistItemStatus | null,
      interpreter_info?: OpsChecklistItemStatus | null,
      jotform?: OpsChecklistItemStatus | null,
      deu_100?: OpsChecklistItemStatus | null,
      final_report?: OpsChecklistItemStatus | null,
    } | null,
    panelUnavailable?: boolean | null,
    panelSpecialty?: SpecialtyType | null,
    defenseAttorneyNotPresent?: boolean | null,
    applicantAttorneyNotPresent?: boolean | null,
    contactUnavailability?:  {
      __typename: "ParticipantContactUnavailability",
      patient?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      adjuster?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      applicantAttorney?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
      defenseAttorney?:  {
        __typename: "ContactUnavailability",
        emailUnavailable?: boolean | null,
        phoneUnavailable?: boolean | null,
      } | null,
    } | null,
    historyValidation?:  {
      __typename: "HistoryValidation",
      id: string,
      appointmentRecordID: string,
      status: HistoryValidationStatus,
      groups:  Array< {
        __typename: "HistoryValidationGroup",
        id: string,
        title: string,
        status: HistoryValidationGroupStatus,
        issues:  Array< {
          __typename: "HistoryValidationIssue",
          id: string,
          title: string,
          description?: string | null,
          patientInfoSection?: PatientInfoSection | null,
          issueType?: ValidationIssueType | null,
        } | null >,
      } | null >,
      validatedAt?: string | null,
      errorMessage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    patientHistoryValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    videoCallLink?: string | null,
    additionalTimeslots?:  Array< {
      __typename: "AdditionalTimeslot",
      date: string,
      time: string,
      locationID?: string | null,
    } | null > | null,
    mrrValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    historyMrrCrossValidation?:  {
      __typename: "Validation",
      id: string,
      issueGroups: Array< string | null >,
      issues?:  {
        __typename: "ModelValidationIssueConnection",
        items:  Array< {
          __typename: "ValidationIssue",
          id: string,
          validationID: string,
          validationCheckID: string,
          title?: string | null,
          issue: string,
          status: ValidationStatus,
          resourceURI: string,
          issueGroup: string,
          issueType?: ValidationIssueType | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseID?: string | null,
    briefingModelVersion?: BriefingModelVersion | null,
    briefingGdocExportLink?: string | null,
    briefingGdocExportedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    appointmentRecordMedicalAssistantId?: string | null,
    appointmentRecordSchedulingAssistantId?: string | null,
    appointmentRecordOnSiteOpId?: string | null,
    appointmentRecordReportOpId?: string | null,
    appointmentRecordBillingOpId?: string | null,
    appointmentRecordPreVisitReviewerId?: string | null,
    appointmentRecordHuddleNoteId?: string | null,
    appointmentRecordHistoryOfInjuryNotesId?: string | null,
    appointmentRecordCurrentComplaintNotesId?: string | null,
    appointmentRecordHistoryCallAssistantId?: string | null,
    appointmentRecordHistoryOfInjuryInsightsId?: string | null,
    appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
    appointmentRecordPhysicalExamInsightsId?: string | null,
    appointmentRecordPastInjuryMatrixId?: string | null,
    appointmentRecordBriefingId?: string | null,
    appointmentRecordIntroParagraphId?: string | null,
    appointmentRecordAssessmentId?: string | null,
    appointmentRecordAssessmentValidationId?: string | null,
    appointmentRecordOpinionRecapId?: string | null,
    appointmentRecordHistoryValidationId?: string | null,
    appointmentRecordPatientHistoryValidationId?: string | null,
    appointmentRecordMrrValidationId?: string | null,
    appointmentRecordHistoryMrrCrossValidationId?: string | null,
  } | null,
};

export type OnCreatePatientCaseSubscriptionVariables = {
  filter?: ModelSubscriptionPatientCaseFilterInput | null,
};

export type OnCreatePatientCaseSubscription = {
  onCreatePatientCase?:  {
    __typename: "PatientCase",
    id: string,
    patientID: string,
    patient?:  {
      __typename: "Patient",
      id: string,
      name?: string | null,
      dateOfBirth?: string | null,
      SSN?: string | null,
      language?: Language | null,
      dominantHand?: DominantHand | null,
      cases?:  {
        __typename: "ModelPatientCaseConnection",
        items:  Array< {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      occupation?: string | null,
      sex?: Sex | null,
      weightLb?: number | null,
      height?:  {
        __typename: "Height",
        feet?: number | null,
        inches?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    claimNumber: string,
    qmePanelNumber?: string | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    injuryInfo?:  {
      __typename: "InjuryInfo",
      injuryType?: InjuryType | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      claimedBodyParts?: Array< BodyPart | null > | null,
      description?: string | null,
      dateOfInjury?: string | null,
      dateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      startDateOfInjury?: string | null,
      startDateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
    } | null,
    workersCompInsurance?:  {
      __typename: "WorkersCompInsuranceInfo",
      insuranceCarrier?: string | null,
      adjuster?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    insuranceCarrierID?: string | null,
    insuranceCarrier?:  {
      __typename: "InsuranceCarrier",
      id: string,
      name: string,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierAddressID?: string | null,
    insuranceCarrierAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierFaxNumberID?: string | null,
    insuranceCarrierFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierPhoneNumberID?: string | null,
    insuranceCarrierPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordPatientCaseConnection",
      items:  Array< {
        __typename: "AppointmentRecordPatientCase",
        id: string,
        appointmentRecordId: string,
        patientCaseId: string,
        appointmentRecord:  {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        },
        patientCase:  {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    applicantAttorney?:  {
      __typename: "AttorneyInfo",
      name?: string | null,
      lawFirmName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    applicantAttorneyLawFirmID?: string | null,
    applicantAttorneyLawFirm?:  {
      __typename: "LawFirm",
      id: string,
      name: string,
      type: LawFirmType,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyAddressID?: string | null,
    applicantAttorneyAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyFaxNumberID?: string | null,
    applicantAttorneyFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyPhoneNumberID?: string | null,
    applicantAttorneyPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorney?:  {
      __typename: "AttorneyInfo",
      name?: string | null,
      lawFirmName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    defenseAttorneyLawFirmID?: string | null,
    defenseAttorneyLawFirm?:  {
      __typename: "LawFirm",
      id: string,
      name: string,
      type: LawFirmType,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyAddressID?: string | null,
    defenseAttorneyAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyFaxNumberID?: string | null,
    defenseAttorneyFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyPhoneNumberID?: string | null,
    defenseAttorneyPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nurseCaseManager?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    ccPerson?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    applicantAttorneyCcEmails?: Array< string | null > | null,
    defenseAttorneyCcEmails?: Array< string | null > | null,
    adjusterCcEmails?: Array< string | null > | null,
    scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
    employmentAtInjury?:  {
      __typename: "EmploymentRecord",
      employerName?: string | null,
      jobTitle?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      dateOfHire?: string | null,
      dateOfHireFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      hoursPerWeek?: string | null,
      jobDuties?: string | null,
      dateOfTermination?: string | null,
      dateOfTerminationFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
      stillWorkingHere?: boolean | null,
      type?: EmploymentType | null,
      currentWorkRestrictions?: string | null,
      workStatus?: string | null,
      departureReason?: string | null,
    } | null,
    WCAB?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePatientCaseSubscriptionVariables = {
  filter?: ModelSubscriptionPatientCaseFilterInput | null,
};

export type OnUpdatePatientCaseSubscription = {
  onUpdatePatientCase?:  {
    __typename: "PatientCase",
    id: string,
    patientID: string,
    patient?:  {
      __typename: "Patient",
      id: string,
      name?: string | null,
      dateOfBirth?: string | null,
      SSN?: string | null,
      language?: Language | null,
      dominantHand?: DominantHand | null,
      cases?:  {
        __typename: "ModelPatientCaseConnection",
        items:  Array< {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      occupation?: string | null,
      sex?: Sex | null,
      weightLb?: number | null,
      height?:  {
        __typename: "Height",
        feet?: number | null,
        inches?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    claimNumber: string,
    qmePanelNumber?: string | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    injuryInfo?:  {
      __typename: "InjuryInfo",
      injuryType?: InjuryType | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      claimedBodyParts?: Array< BodyPart | null > | null,
      description?: string | null,
      dateOfInjury?: string | null,
      dateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      startDateOfInjury?: string | null,
      startDateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
    } | null,
    workersCompInsurance?:  {
      __typename: "WorkersCompInsuranceInfo",
      insuranceCarrier?: string | null,
      adjuster?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    insuranceCarrierID?: string | null,
    insuranceCarrier?:  {
      __typename: "InsuranceCarrier",
      id: string,
      name: string,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierAddressID?: string | null,
    insuranceCarrierAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierFaxNumberID?: string | null,
    insuranceCarrierFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    insuranceCarrierPhoneNumberID?: string | null,
    insuranceCarrierPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordPatientCaseConnection",
      items:  Array< {
        __typename: "AppointmentRecordPatientCase",
        id: string,
        appointmentRecordId: string,
        patientCaseId: string,
        appointmentRecord:  {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        },
        patientCase:  {
          __typename: "PatientCase",
          id: string,
          patientID: string,
          claimNumber: string,
          qmePanelNumber?: string | null,
          insuranceCarrierID?: string | null,
          insuranceCarrierAddressID?: string | null,
          insuranceCarrierFaxNumberID?: string | null,
          insuranceCarrierPhoneNumberID?: string | null,
          applicantAttorneyLawFirmID?: string | null,
          applicantAttorneyAddressID?: string | null,
          applicantAttorneyFaxNumberID?: string | null,
          applicantAttorneyPhoneNumberID?: string | null,
          defenseAttorneyLawFirmID?: string | null,
          defenseAttorneyAddressID?: string | null,
          defenseAttorneyFaxNumberID?: string | null,
          defenseAttorneyPhoneNumberID?: string | null,
          applicantAttorneyCcEmails?: Array< string | null > | null,
          defenseAttorneyCcEmails?: Array< string | null > | null,
          adjusterCcEmails?: Array< string | null > | null,
          scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
          WCAB?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    applicantAttorney?:  {
      __typename: "AttorneyInfo",
      name?: string | null,
      lawFirmName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    applicantAttorneyLawFirmID?: string | null,
    applicantAttorneyLawFirm?:  {
      __typename: "LawFirm",
      id: string,
      name: string,
      type: LawFirmType,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyAddressID?: string | null,
    applicantAttorneyAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyFaxNumberID?: string | null,
    applicantAttorneyFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    applicantAttorneyPhoneNumberID?: string | null,
    applicantAttorneyPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorney?:  {
      __typename: "AttorneyInfo",
      name?: string | null,
      lawFirmName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    defenseAttorneyLawFirmID?: string | null,
    defenseAttorneyLawFirm?:  {
      __typename: "LawFirm",
      id: string,
      name: string,
      type: LawFirmType,
      defaultAddressID?: string | null,
      defaultAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      addresses?:  {
        __typename: "ModelStoredAddressConnection",
        items:  Array< {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultFaxNumberID?: string | null,
      defaultFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      faxNumbers?:  {
        __typename: "ModelStoredFaxNumberConnection",
        items:  Array< {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultPhoneNumberID?: string | null,
      defaultPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      phoneNumbers?:  {
        __typename: "ModelStoredPhoneNumberConnection",
        items:  Array< {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultEmail?: string | null,
      supportedDomains?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyAddressID?: string | null,
    defenseAttorneyAddress?:  {
      __typename: "StoredAddress",
      id: string,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyFaxNumberID?: string | null,
    defenseAttorneyFaxNumber?:  {
      __typename: "StoredFaxNumber",
      id: string,
      faxNumber?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    defenseAttorneyPhoneNumberID?: string | null,
    defenseAttorneyPhoneNumber?:  {
      __typename: "StoredPhoneNumber",
      id: string,
      phoneNumber?: string | null,
      extension?: string | null,
      insuranceCarrierID?: string | null,
      lawFirmID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nurseCaseManager?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    ccPerson?:  {
      __typename: "ContactPersonInfo",
      name?: string | null,
      organizationName?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
    } | null,
    applicantAttorneyCcEmails?: Array< string | null > | null,
    defenseAttorneyCcEmails?: Array< string | null > | null,
    adjusterCcEmails?: Array< string | null > | null,
    scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
    employmentAtInjury?:  {
      __typename: "EmploymentRecord",
      employerName?: string | null,
      jobTitle?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      dateOfHire?: string | null,
      dateOfHireFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      hoursPerWeek?: string | null,
      jobDuties?: string | null,
      dateOfTermination?: string | null,
      dateOfTerminationFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      notes?: string | null,
      stillWorkingHere?: boolean | null,
      type?: EmploymentType | null,
      currentWorkRestrictions?: string | null,
      workStatus?: string | null,
      departureReason?: string | null,
    } | null,
    WCAB?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateDoctorSubscriptionVariables = {
  filter?: ModelSubscriptionDoctorFilterInput | null,
  ownerCognitoId?: string | null,
};

export type OnUpdateDoctorSubscription = {
  onUpdateDoctor?:  {
    __typename: "Doctor",
    id: string,
    ownerCognitoId?: string | null,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    name?: string | null,
    signatureName?: string | null,
    status?: DoctorStatus | null,
    ramped?: boolean | null,
    title?: string | null,
    titleExtension?: TitleExtension | null,
    contact?:  {
      __typename: "ContactInfo",
      phone?: string | null,
      phoneExtension?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      fax?: string | null,
      homePhoneNumber?: string | null,
    } | null,
    officePhone?: string | null,
    cellPhone?: string | null,
    clinicPhone?: string | null,
    workCity?: string | null,
    workState?: string | null,
    collectionRate?: number | null,
    licenseNumber?: string | null,
    licenseRenewalDate?: string | null,
    qmeLicense?:  {
      __typename: "QmeLicense",
      licenseNumber?: string | null,
      approvalDate?: string | null,
      renewalDate?: string | null,
    } | null,
    locations?:  {
      __typename: "ModelDoctorLocationConnection",
      items:  Array< {
        __typename: "DoctorLocation",
        id: string,
        doctorId: string,
        locationId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        location:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    specialties?: Array< SpecialtyType | null > | null,
    npi?: string | null,
    bankingInfo?:  {
      __typename: "BankingInfo",
      bankEntityName?: string | null,
      accountNumber?: string | null,
      routingNumber?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    availabilities?:  {
      __typename: "Availabilities",
      generalAvailabilities?:  Array< {
        __typename: "GeneralAvailability",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        recurrence?: RecurrenceType | null,
        dayOfWeek?: DayOfWeek | null,
        dayOfMonth?: number | null,
        weekOfMonth?: WeekOfMonth | null,
        monthInterval?: number | null,
        startTime?: string | null,
        endTime?: string | null,
        flexibleTimeBefore?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        flexibleTimeAfter?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        locationIDs?: Array< string | null > | null,
        isAllLocations?: boolean | null,
      } | null > | null,
      additionalAvailabilities?:  Array< {
        __typename: "AdditionalAvailability",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        flexibleTimeBefore?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        flexibleTimeAfter?:  {
          __typename: "FlexibleTimeWindow",
          startTime?: string | null,
          endTime?: string | null,
        } | null,
        locationIDs?: Array< string | null > | null,
        isAllLocations?: boolean | null,
      } | null > | null,
      blackoutDates?:  Array< {
        __typename: "BlackoutDate",
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
    } | null,
    availabilitiesNote?: string | null,
    emails?: Array< string | null > | null,
    profileImages?:  Array< {
      __typename: "DoctorProfileImage",
      type?: DoctorProfileImageType | null,
      name?: string | null,
      order?: number | null,
      s3Prefix?: string | null,
      widthInInches?: number | null,
      heightInInches?: number | null,
    } | null > | null,
    qmeReportConfigs?:  {
      __typename: "DoctorQMEReportConfigs",
      hasIntroTitle?: boolean | null,
      introTemplate?: string | null,
    } | null,
    physicalEvalConfigs?:  {
      __typename: "DoctorPhysicalEvalConfigs",
      templates?: Array< PhysicalEvalTemplateTag | null > | null,
    } | null,
    signatureDepartment?: string | null,
    profileAssetS3Prefix?: string | null,
    calendarPreference?:  {
      __typename: "CalendarPreference",
      mailingList?: Array< string | null > | null,
      showPatientFullName?: boolean | null,
      showPatientAddress?: boolean | null,
      showPatientDOB?: boolean | null,
      showPortalLink?: boolean | null,
    } | null,
    homeOffice?:  {
      __typename: "HomeOffice",
      county?: string | null,
      state?: string | null,
    } | null,
    reportFormatPreferences?:  {
      __typename: "ReportFormatPreferences",
      evaluationReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
      reEvaluationReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
      supplementalReport:  {
        __typename: "FormatPreferences",
        sections: Array< ReportSection >,
        assessmentSubSections: Array< ReportAssessmentSubSection >,
      },
    } | null,
    evaluationInputPreferences?:  {
      __typename: "EvaluationInputPreferences",
      evaluationReport:  {
        __typename: "ReportInputPreferences",
        history: ReportSource,
        physicalExamination: ReportSource,
        assessment: ReportSource,
      },
      reEvaluationReport:  {
        __typename: "ReportInputPreferences",
        history: ReportSource,
        physicalExamination: ReportSource,
        assessment: ReportSource,
      },
      supplementalReport:  {
        __typename: "SupplementalReportInputPreferences",
        assessment: ReportSource,
      },
    } | null,
    preferredAssessmentMode?: AssessmentMode | null,
    caseSummaryFields?:  {
      __typename: "ModelDoctorCaseSummaryFieldConnection",
      items:  Array< {
        __typename: "DoctorCaseSummaryField",
        id: string,
        doctorId: string,
        caseSummaryFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        caseSummaryField:  {
          __typename: "CaseSummaryField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          summaryPrompt?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    briefingFields?:  {
      __typename: "ModelDoctorBriefingFieldConnection",
      items:  Array< {
        __typename: "DoctorBriefingField",
        id: string,
        doctorId: string,
        briefingFieldId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        briefingField:  {
          __typename: "BriefingField",
          id: string,
          name: string,
          default: boolean,
          description?: string | null,
          briefingPrompt?: string | null,
          briefingRecordTypeID: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    } | null,
    isDemo?: boolean | null,
    fieldTemplateId?: string | null,
    templateFolderLink?: string | null,
    physicianPartner?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultPrimaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultSecondaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultScheduler?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultReportOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultPreVisitReviewer?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultBillingOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    defaultSupplementalReportOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    supplementalReportOpsAssignments?:  Array< {
      __typename: "SupplementalReportOpsAssignment",
      medicalAssistantID: string,
      weightPercentage: number,
    } | null > | null,
    supportingMAs?:  {
      __typename: "ModelDoctorSupportingMAConnection",
      items:  Array< {
        __typename: "DoctorSupportingMA",
        id: string,
        medicalAssistantId: string,
        doctorId: string,
        medicalAssistant:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        },
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultAppointmentDurationMinutes?:  {
      __typename: "DefaultAppointmentDurationMinutes",
      qme?: number | null,
      qmeReevaluation?: number | null,
      ime?: number | null,
      deposition?: number | null,
    } | null,
    defaultEarlyArrivalTimeMinutes?:  {
      __typename: "DefaultEarlyArrivalTimeMinutes",
      workersComp?: number | null,
      ime?: number | null,
      deposition?: number | null,
    } | null,
    assessmentTreatmentOptions?: Array< string | null > | null,
    dismissedProTips?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    doctorPhysicianPartnerId?: string | null,
    doctorDefaultPrimaryOnsiteOpsId?: string | null,
    doctorDefaultSecondaryOnsiteOpsId?: string | null,
    doctorDefaultSchedulerId?: string | null,
    doctorDefaultReportOpsId?: string | null,
    doctorDefaultPreVisitReviewerId?: string | null,
    doctorDefaultBillingOpsId?: string | null,
    doctorDefaultSupplementalReportOpsId?: string | null,
    doctorUserId?: string | null,
  } | null,
};

export type OnDeleteLocationSubscriptionVariables = {
  filter?: ModelSubscriptionLocationFilterInput | null,
};

export type OnDeleteLocationSubscription = {
  onDeleteLocation?:  {
    __typename: "Location",
    id: string,
    name?: string | null,
    abbreviation?: string | null,
    status?: LocationStatus | null,
    region?: Region | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      county?: string | null,
    } | null,
    indigoOfficePhoneNumber?: string | null,
    isWaitingArea?: boolean | null,
    additionalRoomsNumber?: number | null,
    landlordContactInfo?:  {
      __typename: "LocationLandlordContactInfo",
      name?: string | null,
      phone?: string | null,
      email?: string | null,
    } | null,
    calendarCcEmails?: Array< string | null > | null,
    isParkingFree?: boolean | null,
    parkingRate?: number | null,
    isFrontDoorLocked?: boolean | null,
    frontDoorCode?: string | null,
    backDoor?: BackDoorStatus | null,
    backDoorCode?: string | null,
    securityUnlockingProcess?: string | null,
    securityLockingProcess?: string | null,
    maleBathroomCode?: string | null,
    femaleBathroomCode?: string | null,
    wifiName?: string | null,
    wifiPassword?: string | null,
    defaultOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    secondaryOnsiteOps?:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    } | null,
    locationInstructionsForVisitor?: string | null,
    additionalNote?: string | null,
    doctors?:  {
      __typename: "ModelDoctorLocationConnection",
      items:  Array< {
        __typename: "DoctorLocation",
        id: string,
        doctorId: string,
        locationId: string,
        doctor:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        },
        location:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        ownerCognitoId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    appointments?:  {
      __typename: "ModelAppointmentRecordConnection",
      items:  Array< {
        __typename: "AppointmentRecord",
        id: string,
        doctorOwnerCognitoId?: string | null,
        assistantCognitoIds?: Array< string > | null,
        globalPartitionKey: string,
        originalAppointmentID: string,
        supplementalAppointmentIDs?: Array< string | null > | null,
        supplementalSourceAppointmentIDs?: Array< string | null > | null,
        depositionAppointmentIDs?: Array< string | null > | null,
        depositionSourceAppointmentIDs?: Array< string | null > | null,
        rescheduledFromAppointmentID?: string | null,
        rescheduledToAppointmentID?: string | null,
        date?: string | null,
        yearMonth?: string | null,
        doctorYearMonth?: string | null,
        time?: string | null,
        bookedInFlexibleTime?: boolean | null,
        inquiryDate: string,
        inquiryYearMonth: string,
        type?: AppointmentType | null,
        doctorID?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        locationID?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          name?: string | null,
          abbreviation?: string | null,
          status?: LocationStatus | null,
          region?: Region | null,
          indigoOfficePhoneNumber?: string | null,
          isWaitingArea?: boolean | null,
          additionalRoomsNumber?: number | null,
          calendarCcEmails?: Array< string | null > | null,
          isParkingFree?: boolean | null,
          parkingRate?: number | null,
          isFrontDoorLocked?: boolean | null,
          frontDoorCode?: string | null,
          backDoor?: BackDoorStatus | null,
          backDoorCode?: string | null,
          securityUnlockingProcess?: string | null,
          securityLockingProcess?: string | null,
          maleBathroomCode?: string | null,
          femaleBathroomCode?: string | null,
          wifiName?: string | null,
          wifiPassword?: string | null,
          locationInstructionsForVisitor?: string | null,
          additionalNote?: string | null,
          createdAt: string,
          updatedAt: string,
          locationDefaultOnsiteOpsId?: string | null,
          locationSecondaryOnsiteOpsId?: string | null,
        } | null,
        visitForm?: string | null,
        jotformSubmissions?:  Array< {
          __typename: "JotformSubmission",
          id: string,
          receivedAt: string,
          populatedAt?: string | null,
        } | null > | null,
        historyTranscriptPopulations?:  Array< {
          __typename: "HistoryTranscriptPopulation",
          uploadedFileID: string,
          populatedAt: string,
        } | null > | null,
        active?: boolean | null,
        durationMinutes?: number | null,
        reportDue?: string | null,
        reportSubmitted?: string | null,
        status?: AppointmentStatus | null,
        reportStatus?: ReportStatus | null,
        paymentStatus?: PaymentStatus | null,
        billingStatus?: BillingStatus | null,
        difficultyLevel?: number | null,
        scheduler?:  {
          __typename: "ContactPersonInfo",
          name?: string | null,
          organizationName?: string | null,
        } | null,
        medicalAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        schedulingAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        onSiteOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        reportOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        billingOp?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        preVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        inquirerInfo?:  {
          __typename: "InquirerInfo",
          inquiringParty?: InquiringParty | null,
          name?: string | null,
          inquiryDate?: string | null,
          notification_110_required?: boolean | null,
        } | null,
        notes?:  {
          __typename: "ModelNotesConnection",
          nextToken?: string | null,
        } | null,
        huddleNote?:  {
          __typename: "HuddleNote",
          id: string,
          appointmentRecordID: string,
          contentMarkdown?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientCases?:  {
          __typename: "ModelAppointmentRecordPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        employments?:  Array< {
          __typename: "EmploymentRecord",
          employerName?: string | null,
          jobTitle?: string | null,
          dateOfHire?: string | null,
          hoursPerWeek?: string | null,
          jobDuties?: string | null,
          dateOfTermination?: string | null,
          notes?: string | null,
          stillWorkingHere?: boolean | null,
          type?: EmploymentType | null,
          currentWorkRestrictions?: string | null,
          workStatus?: string | null,
          departureReason?: string | null,
        } | null > | null,
        employmentGaps?:  Array< {
          __typename: "EmploymentGapRecord",
          type?: EmploymentGapType | null,
          notes?: string | null,
        } | null > | null,
        patientDescribedInjuries?: Array< BodyPart | null > | null,
        uploadedFilesSet?:  {
          __typename: "UploadedFileSet",
          id: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        uploadedFilesSetID?: string | null,
        referredBy?: string | null,
        s3FileKey?: string | null,
        medicalRecordsReceived?: boolean | null,
        medicalRecordsBriefingFileID?: string | null,
        medicalRecordsBriefingExecutionArn?: string | null,
        medicalRecordsTotalPagesProcessed?: number | null,
        reportGenerationFileID?: string | null,
        reportGenerationExecutionArn?: string | null,
        reportGenerationGeneratedAt?: string | null,
        historyOfInjuryFileID?: string | null,
        historyOfInjuryGeneratedAt?: string | null,
        evaluationFileID?: string | null,
        assessmentFileID?: string | null,
        depositionPreparationFileID?: string | null,
        documentStatus?:  {
          __typename: "DocumentStatus",
          evaluationPublished?: boolean | null,
          assessmentPublished?: boolean | null,
          historyInProgress?: boolean | null,
          historyPublished?: boolean | null,
          historyCleaned?: boolean | null,
          reportPublished?: boolean | null,
          briefingInProgress?: boolean | null,
          briefingPublished?: boolean | null,
          briefingCleaned?: boolean | null,
        } | null,
        cancellationReason?: CancellationReason | null,
        cancellationRequestedBy?: ParticipantType | null,
        cancellationRequestedInternally?: boolean | null,
        cancellationNote?: string | null,
        cancellationDate?: string | null,
        inquiryClosingReason?: InquiryClosingReason | null,
        inquiryClosingNote?: string | null,
        inquiryClosingDate?: string | null,
        noShowReason?: NoShowReason | null,
        noShowNote?: string | null,
        reschedulingReason?: ReschedulingReason | null,
        reschedulingOthersReason?: string | null,
        reschedulingRequestedBy?: ParticipantType | null,
        reschedulingRequestedInternally?: boolean | null,
        reschedulingNote?: string | null,
        reschedulingDate?: string | null,
        interpreter?:  {
          __typename: "InterpreterInfo",
          certificateId?: string | null,
          name?: string | null,
          companyName?: string | null,
          phoneNumber?: string | null,
          phoneExtension?: string | null,
          note?: string | null,
          confirmed?: boolean | null,
        } | null,
        historyOfInjuryNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        currentComplaintNotes?:  {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null,
        historyCallDate?: string | null,
        historyCallTime?: string | null,
        historyCallAssistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        historyCallCompleted?: boolean | null,
        historyCallCompletedWithoutRecords?: boolean | null,
        historyCallCompletedOnSite?: boolean | null,
        historyCallNoShow?: boolean | null,
        historyCallCalendarEventID?: string | null,
        historyCallCalendarLink?: string | null,
        billingInfo?:  {
          __typename: "BillingInfo",
          totalCharge?: number | null,
          amountPaid?: number | null,
          billingCounter?: number | null,
          billedDate?: string | null,
          paidDate?: string | null,
          correctionDate?: string | null,
        } | null,
        caseInfo?:  {
          __typename: "CaseInfo",
        } | null,
        isProd?: boolean | null,
        isDemo?: boolean | null,
        primaryPatientCaseID?: string | null,
        calendarEventID?: string | null,
        reportConfiguration?:  {
          __typename: "ReportConfiguration",
          history?: ReportSource | null,
          physicalExamination?: ReportSource | null,
          assessment?: ReportSource | null,
        } | null,
        workflowExecutions?:  {
          __typename: "ModelWorkflowExecutionConnection",
          nextToken?: string | null,
        } | null,
        historyOfInjuryInsights?:  {
          __typename: "HistoryOfInjuryInsights",
          id: string,
          appointmentRecordID: string,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
          injuryEmploymentStatus?: string | null,
          currentWorkRestrictionsFromPatient?: string | null,
          activitiesOfDailyLiving?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reviewOfMedicalRecordsInsights?:  {
          __typename: "ReviewOfMedicalRecordsInsights",
          id: string,
          appointmentRecordID: string,
          currentWorkRestrictionsFromMedicalRecords?: string | null,
          derivedFromDocumentInsightIDs?: Array< string | null > | null,
          derivedAt?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        physicalExamInsights?:  {
          __typename: "PhysicalExamInsights",
          id: string,
          appointmentRecordID: string,
          physicalExaminationInfo?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        pastInjuryMatrix?:  {
          __typename: "PastInjuryMatrix",
          id: string,
          appointmentRecordID: string,
          preExistingConditions: Array< string >,
          familyHistory: Array< string >,
          createdAt: string,
          updatedAt: string,
        } | null,
        briefing?:  {
          __typename: "RecordBriefing",
          id: string,
          logicalBriefingID: string,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          googleDocExportLink?: string | null,
          googleDocExportedAt?: string | null,
          editingPresence?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        introParagraph?:  {
          __typename: "IntroParagraph",
          id: string,
          appointmentRecordID: string,
          introParagraphText?: string | null,
          status: IntroParagraphStatus,
          errorMessage?: string | null,
          generatedAt?: string | null,
          lastEditedAt?: string | null,
          lastEditedBy?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        impairmentRatingResults?:  Array< {
          __typename: "ImpairmentRatingResult",
          ts?: number | null,
          bodyParts?: Array< string | null > | null,
          enabledStrictRating?: boolean | null,
          enabledPainRating?: boolean | null,
          enabledAG?: boolean | null,
          enabledStrengthRating?: boolean | null,
          enabledDBE?: boolean | null,
          autoMode?: boolean | null,
          result?: string | null,
        } | null > | null,
        defenseAttorneyPagesDeclaration?: number | null,
        applicantAttorneyPagesDeclaration?: number | null,
        fieldTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        dataFieldValuesMappings?:  Array< {
          __typename: "DataFieldValueMapping",
          dataFieldID?: string | null,
          value?: string | null,
        } | null > | null,
        physicalEvalTemplateRef?:  {
          __typename: "FieldTemplateRef",
          id: string,
          version: number,
        } | null,
        physicalExamValues?:  Array< {
          __typename: "PhysicalExamValue",
          sectionID: string,
          questionID: string,
          side?: PhysicalExamSide | null,
          value?: string | null,
          note?: string | null,
          excluded?: boolean | null,
        } | null > | null,
        physicalExamOtherFindings?:  Array< {
          __typename: "PhysicalExamOtherFinding",
          sectionID: string,
          text?: string | null,
        } | null > | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          discussedBodyParts?: Array< BodyPart | null > | null,
          bodyPartsNotDiscussedReason?: string | null,
          discussions?: string | null,
          workStatus?: string | null,
          markedAsDone?: boolean | null,
          discussDiagnosesFreeForm?: boolean | null,
          diagnosesFreeform?: string | null,
          discussCausationFreeForm?: boolean | null,
          causationFreeForm?: string | null,
          discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
          hasPatientReachedMMIFreeForm?: string | null,
          discussMMIByBodyPartFreeForm?: string | null,
          impairmentRatingByBodyPartFreeForm?: string | null,
          apportionmentByBodyPartFreeForm?: string | null,
          impairmentRatingOtherComments?: string | null,
          apportionmentOtherComments?: string | null,
          assessmentMode?: AssessmentMode | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        opinionRecap?:  {
          __typename: "OpinionRecap",
          id: string,
          appointmentRecordID: string,
          causation?: string | null,
          diagnosis?: string | null,
          mmiFutureMedicalTreatment?: string | null,
          impairmentRating?: string | null,
          apportionment?: string | null,
          workStatus?: string | null,
          sourceReportFileID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
        featureFlags?:  Array< {
          __typename: "AppointmentFeatureConfig",
          featureFlagKey: string,
          enabled: boolean,
        } | null > | null,
        opsChecklist?:  {
          __typename: "OpsChecklist",
          panel?: OpsChecklistItemStatus | null,
          contact_info?: OpsChecklistItemStatus | null,
          all_parties?: OpsChecklistItemStatus | null,
          notice_110?: OpsChecklistItemStatus | null,
          cover_letter?: OpsChecklistItemStatus | null,
          record_review?: OpsChecklistItemStatus | null,
          history_call?: OpsChecklistItemStatus | null,
          history_of_injury?: OpsChecklistItemStatus | null,
          interpreter_info?: OpsChecklistItemStatus | null,
          jotform?: OpsChecklistItemStatus | null,
          deu_100?: OpsChecklistItemStatus | null,
          final_report?: OpsChecklistItemStatus | null,
        } | null,
        panelUnavailable?: boolean | null,
        panelSpecialty?: SpecialtyType | null,
        defenseAttorneyNotPresent?: boolean | null,
        applicantAttorneyNotPresent?: boolean | null,
        contactUnavailability?:  {
          __typename: "ParticipantContactUnavailability",
        } | null,
        historyValidation?:  {
          __typename: "HistoryValidation",
          id: string,
          appointmentRecordID: string,
          status: HistoryValidationStatus,
          validatedAt?: string | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        patientHistoryValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        videoCallLink?: string | null,
        additionalTimeslots?:  Array< {
          __typename: "AdditionalTimeslot",
          date: string,
          time: string,
          locationID?: string | null,
        } | null > | null,
        mrrValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        historyMrrCrossValidation?:  {
          __typename: "Validation",
          id: string,
          issueGroups: Array< string | null >,
          createdAt: string,
          updatedAt: string,
        } | null,
        caseID?: string | null,
        briefingModelVersion?: BriefingModelVersion | null,
        briefingGdocExportLink?: string | null,
        briefingGdocExportedAt?: string | null,
        createdAt: string,
        updatedAt: string,
        appointmentRecordMedicalAssistantId?: string | null,
        appointmentRecordSchedulingAssistantId?: string | null,
        appointmentRecordOnSiteOpId?: string | null,
        appointmentRecordReportOpId?: string | null,
        appointmentRecordBillingOpId?: string | null,
        appointmentRecordPreVisitReviewerId?: string | null,
        appointmentRecordHuddleNoteId?: string | null,
        appointmentRecordHistoryOfInjuryNotesId?: string | null,
        appointmentRecordCurrentComplaintNotesId?: string | null,
        appointmentRecordHistoryCallAssistantId?: string | null,
        appointmentRecordHistoryOfInjuryInsightsId?: string | null,
        appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
        appointmentRecordPhysicalExamInsightsId?: string | null,
        appointmentRecordPastInjuryMatrixId?: string | null,
        appointmentRecordBriefingId?: string | null,
        appointmentRecordIntroParagraphId?: string | null,
        appointmentRecordAssessmentId?: string | null,
        appointmentRecordAssessmentValidationId?: string | null,
        appointmentRecordOpinionRecapId?: string | null,
        appointmentRecordHistoryValidationId?: string | null,
        appointmentRecordPatientHistoryValidationId?: string | null,
        appointmentRecordMrrValidationId?: string | null,
        appointmentRecordHistoryMrrCrossValidationId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    locationDefaultOnsiteOpsId?: string | null,
    locationSecondaryOnsiteOpsId?: string | null,
  } | null,
};

export type OnCreateWorkflowExecutionSubscriptionVariables = {
  filter?: ModelSubscriptionWorkflowExecutionFilterInput | null,
};

export type OnCreateWorkflowExecutionSubscription = {
  onCreateWorkflowExecution?:  {
    __typename: "WorkflowExecution",
    executionArn: string,
    appointmentRecordID: string,
    type?: WorkflowExecutionType | null,
    status?: WorkflowExecutionStatus | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateWorkflowExecutionSubscriptionVariables = {
  filter?: ModelSubscriptionWorkflowExecutionFilterInput | null,
};

export type OnUpdateWorkflowExecutionSubscription = {
  onUpdateWorkflowExecution?:  {
    __typename: "WorkflowExecution",
    executionArn: string,
    appointmentRecordID: string,
    type?: WorkflowExecutionType | null,
    status?: WorkflowExecutionStatus | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteWorkflowExecutionSubscriptionVariables = {
  filter?: ModelSubscriptionWorkflowExecutionFilterInput | null,
};

export type OnDeleteWorkflowExecutionSubscription = {
  onDeleteWorkflowExecution?:  {
    __typename: "WorkflowExecution",
    executionArn: string,
    appointmentRecordID: string,
    type?: WorkflowExecutionType | null,
    status?: WorkflowExecutionStatus | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateHistoryOfInjuryInsightsSubscriptionVariables = {
  filter?: ModelSubscriptionHistoryOfInjuryInsightsFilterInput | null,
};

export type OnUpdateHistoryOfInjuryInsightsSubscription = {
  onUpdateHistoryOfInjuryInsights?:  {
    __typename: "HistoryOfInjuryInsights",
    id: string,
    appointmentRecordID: string,
    mechanismOfInjury?: string | null,
    employerJobDescription?: string | null,
    injuryCausations?:  Array< {
      __typename: "InjuryCausationInfo",
      injuryType?: InjuryType | null,
      dateOfInjury?: string | null,
      dateOfInjuryEnd?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      mechanismOfInjury?: string | null,
      employerJobDescription?: string | null,
    } | null > | null,
    currentSymptoms?:  Array< {
      __typename: "Symptom",
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    priorSymptomsBeforeCurrentInjury?:  Array< {
      __typename: "Symptom",
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    previousSurgeries?:  Array< {
      __typename: "SurgeryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      type?: string | null,
    } | null > | null,
    previousWorkInjuries?:  Array< {
      __typename: "InjuryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    previousInjuries?:  Array< {
      __typename: "InjuryHistoryInfo",
      date?: string | null,
      bodyParts?: Array< string | null > | null,
      description?: string | null,
    } | null > | null,
    injuryEmploymentStatus?: string | null,
    currentWorkRestrictionsFromPatient?: string | null,
    activitiesOfDailyLiving?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateReviewOfMedicalRecordsInsightsSubscriptionVariables = {
  filter?: ModelSubscriptionReviewOfMedicalRecordsInsightsFilterInput | null,
};

export type OnUpdateReviewOfMedicalRecordsInsightsSubscription = {
  onUpdateReviewOfMedicalRecordsInsights?:  {
    __typename: "ReviewOfMedicalRecordsInsights",
    id: string,
    appointmentRecordID: string,
    latestDiagnosis?:  Array< {
      __typename: "BodyPartDiagnosis",
      bodyPart?: string | null,
      date?: string | null,
      descriptions?: Array< string | null > | null,
    } | null > | null,
    diagnosticStudies?:  Array< {
      __typename: "DiagnosticStudy",
      date?: string | null,
      typeOfStudy?: DiagnosticStudyType | null,
      bodyPart?: string | null,
      impression?: string | null,
      source?: DiagnosticStudySource | null,
    } | null > | null,
    treatments?:  Array< {
      __typename: "TreatmentWrapper",
      discreteTreatment?:  {
        __typename: "DiscreteTreatment",
        date?: string | null,
        treatmentType?: DiscreteTreatmentType | null,
        bodyPart?: string | null,
        description?: string | null,
      } | null,
      recurringTreatment?:  {
        __typename: "RecurringTreatment",
        year?: string | null,
        treatmentType?: RecurringTreatmentType | null,
        frequency?: string | null,
        description?: string | null,
      } | null,
    } | null > | null,
    currentWorkRestrictionsFromMedicalRecords?: string | null,
    previousReports?:  Array< {
      __typename: "PreviousReport",
      date?: string | null,
      reportType?: string | null,
      reportContent?: string | null,
    } | null > | null,
    durableMedicalEquipment?:  Array< {
      __typename: "DurableMedicalEquipment",
      startDate?: string | null,
      endDate?: string | null,
      bodyParts?: Array< string | null > | null,
      equipmentType?: string | null,
      description?: string | null,
    } | null > | null,
    derivedFromDocumentInsightIDs?: Array< string | null > | null,
    derivedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateDocumentBriefingInsightsSubscriptionVariables = {
  filter?: ModelSubscriptionDocumentBriefingInsightsFilterInput | null,
};

export type OnCreateDocumentBriefingInsightsSubscription = {
  onCreateDocumentBriefingInsights?:  {
    __typename: "DocumentBriefingInsights",
    id: string,
    documentID: string,
    appointmentRecordID: string,
    latestDiagnosis?:  Array< {
      __typename: "BodyPartDiagnosis",
      bodyPart?: string | null,
      date?: string | null,
      descriptions?: Array< string | null > | null,
    } | null > | null,
    diagnosticStudies?:  Array< {
      __typename: "DiagnosticStudy",
      date?: string | null,
      typeOfStudy?: DiagnosticStudyType | null,
      bodyPart?: string | null,
      impression?: string | null,
      source?: DiagnosticStudySource | null,
    } | null > | null,
    treatments?:  Array< {
      __typename: "TreatmentWrapper",
      discreteTreatment?:  {
        __typename: "DiscreteTreatment",
        date?: string | null,
        treatmentType?: DiscreteTreatmentType | null,
        bodyPart?: string | null,
        description?: string | null,
      } | null,
      recurringTreatment?:  {
        __typename: "RecurringTreatment",
        year?: string | null,
        treatmentType?: RecurringTreatmentType | null,
        frequency?: string | null,
        description?: string | null,
      } | null,
    } | null > | null,
    currentWorkRestrictionsFromMedicalRecords?: string | null,
    previousReports?:  Array< {
      __typename: "PreviousReport",
      date?: string | null,
      reportType?: string | null,
      reportContent?: string | null,
    } | null > | null,
    durableMedicalEquipment?:  Array< {
      __typename: "DurableMedicalEquipment",
      startDate?: string | null,
      endDate?: string | null,
      bodyParts?: Array< string | null > | null,
      equipmentType?: string | null,
      description?: string | null,
    } | null > | null,
    sourceRecordBriefingID: string,
    generatedAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateDocumentBriefingInsightsSubscriptionVariables = {
  filter?: ModelSubscriptionDocumentBriefingInsightsFilterInput | null,
};

export type OnUpdateDocumentBriefingInsightsSubscription = {
  onUpdateDocumentBriefingInsights?:  {
    __typename: "DocumentBriefingInsights",
    id: string,
    documentID: string,
    appointmentRecordID: string,
    latestDiagnosis?:  Array< {
      __typename: "BodyPartDiagnosis",
      bodyPart?: string | null,
      date?: string | null,
      descriptions?: Array< string | null > | null,
    } | null > | null,
    diagnosticStudies?:  Array< {
      __typename: "DiagnosticStudy",
      date?: string | null,
      typeOfStudy?: DiagnosticStudyType | null,
      bodyPart?: string | null,
      impression?: string | null,
      source?: DiagnosticStudySource | null,
    } | null > | null,
    treatments?:  Array< {
      __typename: "TreatmentWrapper",
      discreteTreatment?:  {
        __typename: "DiscreteTreatment",
        date?: string | null,
        treatmentType?: DiscreteTreatmentType | null,
        bodyPart?: string | null,
        description?: string | null,
      } | null,
      recurringTreatment?:  {
        __typename: "RecurringTreatment",
        year?: string | null,
        treatmentType?: RecurringTreatmentType | null,
        frequency?: string | null,
        description?: string | null,
      } | null,
    } | null > | null,
    currentWorkRestrictionsFromMedicalRecords?: string | null,
    previousReports?:  Array< {
      __typename: "PreviousReport",
      date?: string | null,
      reportType?: string | null,
      reportContent?: string | null,
    } | null > | null,
    durableMedicalEquipment?:  Array< {
      __typename: "DurableMedicalEquipment",
      startDate?: string | null,
      endDate?: string | null,
      bodyParts?: Array< string | null > | null,
      equipmentType?: string | null,
      description?: string | null,
    } | null > | null,
    sourceRecordBriefingID: string,
    generatedAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePhysicalExamInsightsSubscriptionVariables = {
  filter?: ModelSubscriptionPhysicalExamInsightsFilterInput | null,
};

export type OnUpdatePhysicalExamInsightsSubscription = {
  onUpdatePhysicalExamInsights?:  {
    __typename: "PhysicalExamInsights",
    id: string,
    appointmentRecordID: string,
    physicalExaminationInfo?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAppointmentFilterPresetSubscriptionVariables = {
  filter?: ModelSubscriptionAppointmentFilterPresetFilterInput | null,
};

export type OnCreateAppointmentFilterPresetSubscription = {
  onCreateAppointmentFilterPreset?:  {
    __typename: "AppointmentFilterPreset",
    id: string,
    name: string,
    filters:  Array< {
      __typename: "FilterEntry",
      type: FilterType,
      values: Array< string >,
    } >,
    appliesTo: UserGroup,
    view?: AppointmentsView | null,
    users?:  {
      __typename: "ModelUserAppointmentFilterPresetConnection",
      items:  Array< {
        __typename: "UserAppointmentFilterPreset",
        id: string,
        userId: string,
        appointmentFilterPresetId: string,
        user:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        },
        appointmentFilterPreset:  {
          __typename: "AppointmentFilterPreset",
          id: string,
          name: string,
          appliesTo: UserGroup,
          view?: AppointmentsView | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAppointmentFilterPresetSubscriptionVariables = {
  filter?: ModelSubscriptionAppointmentFilterPresetFilterInput | null,
};

export type OnDeleteAppointmentFilterPresetSubscription = {
  onDeleteAppointmentFilterPreset?:  {
    __typename: "AppointmentFilterPreset",
    id: string,
    name: string,
    filters:  Array< {
      __typename: "FilterEntry",
      type: FilterType,
      values: Array< string >,
    } >,
    appliesTo: UserGroup,
    view?: AppointmentsView | null,
    users?:  {
      __typename: "ModelUserAppointmentFilterPresetConnection",
      items:  Array< {
        __typename: "UserAppointmentFilterPreset",
        id: string,
        userId: string,
        appointmentFilterPresetId: string,
        user:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        },
        appointmentFilterPreset:  {
          __typename: "AppointmentFilterPreset",
          id: string,
          name: string,
          appliesTo: UserGroup,
          view?: AppointmentsView | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateRecordBriefingSegmentSubscriptionVariables = {
  filter?: ModelSubscriptionRecordBriefingSegmentFilterInput | null,
};

export type OnCreateRecordBriefingSegmentSubscription = {
  onCreateRecordBriefingSegment?:  {
    __typename: "RecordBriefingSegment",
    id: string,
    logicalSegmentID: string,
    title?: string | null,
    text?: string | null,
    bodyParts?: Array< BodyPart | null > | null,
    injuredBodyParts?: Array< BodyPart | null > | null,
    editedBy?: string | null,
    pdfFileName: string,
    sourceTag?: string | null,
    segmentNumber?: number | null,
    sourcePdfS3Key: string,
    startPageNumber: number,
    endPageNumber: number,
    recordType: RecordType,
    extractedDate?: string | null,
    doctorName?: string | null,
    processingModel?: string | null,
    classificationConfidence?: number | null,
    hasDate?: boolean | null,
    potentialDuplicateID?: string | null,
    needsReview?: boolean | null,
    status?: SegmentStatus | null,
    documentID?: string | null,
    videoStartTime?: string | null,
    videoEndTime?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRecordBriefingSegmentSubscriptionVariables = {
  filter?: ModelSubscriptionRecordBriefingSegmentFilterInput | null,
};

export type OnUpdateRecordBriefingSegmentSubscription = {
  onUpdateRecordBriefingSegment?:  {
    __typename: "RecordBriefingSegment",
    id: string,
    logicalSegmentID: string,
    title?: string | null,
    text?: string | null,
    bodyParts?: Array< BodyPart | null > | null,
    injuredBodyParts?: Array< BodyPart | null > | null,
    editedBy?: string | null,
    pdfFileName: string,
    sourceTag?: string | null,
    segmentNumber?: number | null,
    sourcePdfS3Key: string,
    startPageNumber: number,
    endPageNumber: number,
    recordType: RecordType,
    extractedDate?: string | null,
    doctorName?: string | null,
    processingModel?: string | null,
    classificationConfidence?: number | null,
    hasDate?: boolean | null,
    potentialDuplicateID?: string | null,
    needsReview?: boolean | null,
    status?: SegmentStatus | null,
    documentID?: string | null,
    videoStartTime?: string | null,
    videoEndTime?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteRecordBriefingSegmentSubscriptionVariables = {
  filter?: ModelSubscriptionRecordBriefingSegmentFilterInput | null,
};

export type OnDeleteRecordBriefingSegmentSubscription = {
  onDeleteRecordBriefingSegment?:  {
    __typename: "RecordBriefingSegment",
    id: string,
    logicalSegmentID: string,
    title?: string | null,
    text?: string | null,
    bodyParts?: Array< BodyPart | null > | null,
    injuredBodyParts?: Array< BodyPart | null > | null,
    editedBy?: string | null,
    pdfFileName: string,
    sourceTag?: string | null,
    segmentNumber?: number | null,
    sourcePdfS3Key: string,
    startPageNumber: number,
    endPageNumber: number,
    recordType: RecordType,
    extractedDate?: string | null,
    doctorName?: string | null,
    processingModel?: string | null,
    classificationConfidence?: number | null,
    hasDate?: boolean | null,
    potentialDuplicateID?: string | null,
    needsReview?: boolean | null,
    status?: SegmentStatus | null,
    documentID?: string | null,
    videoStartTime?: string | null,
    videoEndTime?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRecordBriefingSegmentMappingSubscriptionVariables = {
  filter?: ModelSubscriptionRecordBriefingSegmentMappingFilterInput | null,
};

export type OnUpdateRecordBriefingSegmentMappingSubscription = {
  onUpdateRecordBriefingSegmentMapping?:  {
    __typename: "RecordBriefingSegmentMapping",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    publishedSegmentID?: string | null,
    draftSegmentID?: string | null,
    markedForDeletion?: boolean | null,
    markedForCreation?: boolean | null,
    publishedSegment?:  {
      __typename: "RecordBriefingSegment",
      id: string,
      logicalSegmentID: string,
      title?: string | null,
      text?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      editedBy?: string | null,
      pdfFileName: string,
      sourceTag?: string | null,
      segmentNumber?: number | null,
      sourcePdfS3Key: string,
      startPageNumber: number,
      endPageNumber: number,
      recordType: RecordType,
      extractedDate?: string | null,
      doctorName?: string | null,
      processingModel?: string | null,
      classificationConfidence?: number | null,
      hasDate?: boolean | null,
      potentialDuplicateID?: string | null,
      needsReview?: boolean | null,
      status?: SegmentStatus | null,
      documentID?: string | null,
      videoStartTime?: string | null,
      videoEndTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    draftSegment?:  {
      __typename: "RecordBriefingSegment",
      id: string,
      logicalSegmentID: string,
      title?: string | null,
      text?: string | null,
      bodyParts?: Array< BodyPart | null > | null,
      injuredBodyParts?: Array< BodyPart | null > | null,
      editedBy?: string | null,
      pdfFileName: string,
      sourceTag?: string | null,
      segmentNumber?: number | null,
      sourcePdfS3Key: string,
      startPageNumber: number,
      endPageNumber: number,
      recordType: RecordType,
      extractedDate?: string | null,
      doctorName?: string | null,
      processingModel?: string | null,
      classificationConfidence?: number | null,
      hasDate?: boolean | null,
      potentialDuplicateID?: string | null,
      needsReview?: boolean | null,
      status?: SegmentStatus | null,
      documentID?: string | null,
      videoStartTime?: string | null,
      videoEndTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRecordBriefingSubscriptionVariables = {
  filter?: ModelSubscriptionRecordBriefingFilterInput | null,
};

export type OnUpdateRecordBriefingSubscription = {
  onUpdateRecordBriefing?:  {
    __typename: "RecordBriefing",
    id: string,
    logicalBriefingID: string,
    segmentMappings?:  {
      __typename: "ModelRecordBriefingSegmentMappingConnection",
      items:  Array< {
        __typename: "RecordBriefingSegmentMapping",
        id: string,
        briefingID: string,
        logicalSegmentID: string,
        publishedSegmentID?: string | null,
        draftSegmentID?: string | null,
        markedForDeletion?: boolean | null,
        markedForCreation?: boolean | null,
        publishedSegment?:  {
          __typename: "RecordBriefingSegment",
          id: string,
          logicalSegmentID: string,
          title?: string | null,
          text?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          editedBy?: string | null,
          pdfFileName: string,
          sourceTag?: string | null,
          segmentNumber?: number | null,
          sourcePdfS3Key: string,
          startPageNumber: number,
          endPageNumber: number,
          recordType: RecordType,
          extractedDate?: string | null,
          doctorName?: string | null,
          processingModel?: string | null,
          classificationConfidence?: number | null,
          hasDate?: boolean | null,
          potentialDuplicateID?: string | null,
          needsReview?: boolean | null,
          status?: SegmentStatus | null,
          documentID?: string | null,
          videoStartTime?: string | null,
          videoEndTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        draftSegment?:  {
          __typename: "RecordBriefingSegment",
          id: string,
          logicalSegmentID: string,
          title?: string | null,
          text?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          injuredBodyParts?: Array< BodyPart | null > | null,
          editedBy?: string | null,
          pdfFileName: string,
          sourceTag?: string | null,
          segmentNumber?: number | null,
          sourcePdfS3Key: string,
          startPageNumber: number,
          endPageNumber: number,
          recordType: RecordType,
          extractedDate?: string | null,
          doctorName?: string | null,
          processingModel?: string | null,
          classificationConfidence?: number | null,
          hasDate?: boolean | null,
          potentialDuplicateID?: string | null,
          needsReview?: boolean | null,
          status?: SegmentStatus | null,
          documentID?: string | null,
          videoStartTime?: string | null,
          videoEndTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    googleDocExportLink?: string | null,
    googleDocExportedAt?: string | null,
    suggestionGeneration?:  {
      __typename: "SuggestionGenerationJob",
      status?: SuggestionGenerationStatus | null,
      jobId?: string | null,
      startedAt?: string | null,
      completedAt?: string | null,
      error?: string | null,
    } | null,
    editingPresence?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSummaryCitationSubscriptionVariables = {
  filter?: ModelSubscriptionSummaryCitationFilterInput | null,
};

export type OnUpdateSummaryCitationSubscription = {
  onUpdateSummaryCitation?:  {
    __typename: "SummaryCitation",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    summaryText: string,
    citationID: string,
    status: SummaryCitationStatus,
    removedBy?: string | null,
    removedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSummaryCitationSubscriptionVariables = {
  filter?: ModelSubscriptionSummaryCitationFilterInput | null,
};

export type OnDeleteSummaryCitationSubscription = {
  onDeleteSummaryCitation?:  {
    __typename: "SummaryCitation",
    id: string,
    briefingID: string,
    logicalSegmentID: string,
    summaryText: string,
    citationID: string,
    status: SummaryCitationStatus,
    removedBy?: string | null,
    removedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCoverLetterRecapSubscriptionVariables = {
  filter?: ModelSubscriptionCoverLetterRecapFilterInput | null,
};

export type OnCreateCoverLetterRecapSubscription = {
  onCreateCoverLetterRecap?:  {
    __typename: "CoverLetterRecap",
    id: string,
    uploadedFileID: string,
    recapText?: string | null,
    status: CoverLetterRecapStatus,
    errorMessage?: string | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCoverLetterRecapSubscriptionVariables = {
  filter?: ModelSubscriptionCoverLetterRecapFilterInput | null,
};

export type OnUpdateCoverLetterRecapSubscription = {
  onUpdateCoverLetterRecap?:  {
    __typename: "CoverLetterRecap",
    id: string,
    uploadedFileID: string,
    recapText?: string | null,
    status: CoverLetterRecapStatus,
    errorMessage?: string | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCoverLetterRecapSubscriptionVariables = {
  filter?: ModelSubscriptionCoverLetterRecapFilterInput | null,
};

export type OnDeleteCoverLetterRecapSubscription = {
  onDeleteCoverLetterRecap?:  {
    __typename: "CoverLetterRecap",
    id: string,
    uploadedFileID: string,
    recapText?: string | null,
    status: CoverLetterRecapStatus,
    errorMessage?: string | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateIntroParagraphSubscriptionVariables = {
  filter?: ModelSubscriptionIntroParagraphFilterInput | null,
};

export type OnCreateIntroParagraphSubscription = {
  onCreateIntroParagraph?:  {
    __typename: "IntroParagraph",
    id: string,
    appointmentRecordID: string,
    introParagraphText?: string | null,
    sourceRecaps?:  Array< {
      __typename: "CoverLetterRecapSnapshot",
      coverLetterRecapID: string,
      uploadedFileID: string,
      recapText: string,
      generatedAt?: string | null,
    } | null > | null,
    status: IntroParagraphStatus,
    errorMessage?: string | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateIntroParagraphSubscriptionVariables = {
  filter?: ModelSubscriptionIntroParagraphFilterInput | null,
};

export type OnUpdateIntroParagraphSubscription = {
  onUpdateIntroParagraph?:  {
    __typename: "IntroParagraph",
    id: string,
    appointmentRecordID: string,
    introParagraphText?: string | null,
    sourceRecaps?:  Array< {
      __typename: "CoverLetterRecapSnapshot",
      coverLetterRecapID: string,
      uploadedFileID: string,
      recapText: string,
      generatedAt?: string | null,
    } | null > | null,
    status: IntroParagraphStatus,
    errorMessage?: string | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteIntroParagraphSubscriptionVariables = {
  filter?: ModelSubscriptionIntroParagraphFilterInput | null,
};

export type OnDeleteIntroParagraphSubscription = {
  onDeleteIntroParagraph?:  {
    __typename: "IntroParagraph",
    id: string,
    appointmentRecordID: string,
    introParagraphText?: string | null,
    sourceRecaps?:  Array< {
      __typename: "CoverLetterRecapSnapshot",
      coverLetterRecapID: string,
      uploadedFileID: string,
      recapText: string,
      generatedAt?: string | null,
    } | null > | null,
    status: IntroParagraphStatus,
    errorMessage?: string | null,
    generatedAt?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateIntroductionStatementSubscriptionVariables = {
  filter?: ModelSubscriptionIntroductionStatementFilterInput | null,
};

export type OnCreateIntroductionStatementSubscription = {
  onCreateIntroductionStatement?:  {
    __typename: "IntroductionStatement",
    id: string,
    appointmentRecordID: string,
    kind: IntroductionStatementKind,
    text?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    selectedCoverLetterFileID?: string | null,
    selectionConfirmedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateIntroductionStatementSubscriptionVariables = {
  filter?: ModelSubscriptionIntroductionStatementFilterInput | null,
};

export type OnUpdateIntroductionStatementSubscription = {
  onUpdateIntroductionStatement?:  {
    __typename: "IntroductionStatement",
    id: string,
    appointmentRecordID: string,
    kind: IntroductionStatementKind,
    text?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    selectedCoverLetterFileID?: string | null,
    selectionConfirmedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteIntroductionStatementSubscriptionVariables = {
  filter?: ModelSubscriptionIntroductionStatementFilterInput | null,
};

export type OnDeleteIntroductionStatementSubscription = {
  onDeleteIntroductionStatement?:  {
    __typename: "IntroductionStatement",
    id: string,
    appointmentRecordID: string,
    kind: IntroductionStatementKind,
    text?: string | null,
    lastEditedAt?: string | null,
    lastEditedBy?: string | null,
    selectedCoverLetterFileID?: string | null,
    selectionConfirmedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAssessmentSubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentFilterInput | null,
};

export type OnUpdateAssessmentSubscription = {
  onUpdateAssessment?:  {
    __typename: "Assessment",
    id: string,
    injuries?:  Array< {
      __typename: "AssessmentInjury",
      injuryType?: InjuryType | null,
      dateOfInjury?: string | null,
      dateOfInjuryFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      dateOfInjuryEnd?: string | null,
      dateOfInjuryEndFlexible?:  {
        __typename: "FlexibleDate",
        value?: string | null,
        precision: DatePrecision,
      } | null,
      bodyParts?: Array< BodyPart | null > | null,
      causeOfInjury?: string | null,
      causedByWork?: AssessmentCausationOption | null,
      causedByWorkExplanation?: string | null,
    } | null > | null,
    discussedBodyParts?: Array< BodyPart | null > | null,
    bodyPartsNotDiscussedReason?: string | null,
    discussions?: string | null,
    diagnoses?:  Array< {
      __typename: "AssessmentDiagnosis",
      diagnosis?: string | null,
      icdCode?: string | null,
      evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
      evidence?: string | null,
    } | null > | null,
    bodyPartMMIStatus?:  {
      __typename: "AssessmentBodyPartMMIStatus",
      discussByBodyPart?: boolean | null,
      allBodyPartsMMI?:  {
        __typename: "AssessmentBodyPartEvaluation",
        mmi?: boolean | null,
        mmiReason?: string | null,
        expectedMMITimeRange?: AssessmentMmiTimeRange | null,
        expectedMMITimeRangeExplanation?: string | null,
        treatments?: Array< string | null > | null,
        treatmentsExplanation?: string | null,
        discussions?: string | null,
        impairmentRating?: string | null,
        impairmentRatingNotApplicable?: boolean | null,
        deferImpairmentRating?: boolean | null,
        deferImpairmentRatingReason?: string | null,
        apportionment?: string | null,
        apportionmentNotApplicable?: boolean | null,
        deferApportionment?: boolean | null,
        deferApportionmentReason?: string | null,
      } | null,
      bodyPartMMIStatuses?:  Array< {
        __typename: "AssessmentBodyPart",
        bodyPart?: BodyPart | null,
        evaluation?:  {
          __typename: "AssessmentBodyPartEvaluation",
          mmi?: boolean | null,
          mmiReason?: string | null,
          expectedMMITimeRange?: AssessmentMmiTimeRange | null,
          expectedMMITimeRangeExplanation?: string | null,
          treatments?: Array< string | null > | null,
          treatmentsExplanation?: string | null,
          discussions?: string | null,
          impairmentRating?: string | null,
          impairmentRatingNotApplicable?: boolean | null,
          deferImpairmentRating?: boolean | null,
          deferImpairmentRatingReason?: string | null,
          apportionment?: string | null,
          apportionmentNotApplicable?: boolean | null,
          deferApportionment?: boolean | null,
          deferApportionmentReason?: string | null,
        } | null,
      } | null > | null,
    } | null,
    workStatus?: string | null,
    markedAsDone?: boolean | null,
    discussDiagnosesFreeForm?: boolean | null,
    diagnosesFreeform?: string | null,
    discussCausationFreeForm?: boolean | null,
    causationFreeForm?: string | null,
    discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
    hasPatientReachedMMIFreeForm?: string | null,
    discussMMIByBodyPartFreeForm?: string | null,
    impairmentRatingByBodyPartFreeForm?: string | null,
    apportionmentByBodyPartFreeForm?: string | null,
    impairmentRatingOtherComments?: string | null,
    apportionmentOtherComments?: string | null,
    assessmentMode?: AssessmentMode | null,
    assessmentFreeForm?:  {
      __typename: "AssessmentFreeForm",
      injuries?:  Array< {
        __typename: "AssessmentInjury",
        injuryType?: InjuryType | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        dateOfInjuryEnd?: string | null,
        dateOfInjuryEndFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        bodyParts?: Array< BodyPart | null > | null,
        causeOfInjury?: string | null,
        causedByWork?: AssessmentCausationOption | null,
        causedByWorkExplanation?: string | null,
      } | null > | null,
      discussions?: string | null,
      diagnosesAndEvidence?: string | null,
      causation?: string | null,
      hasPatientReachedMMI?: string | null,
      discussMMIByBodyPart?: string | null,
      impairmentRatingByBodyPart?: string | null,
      apportionmentByBodyPart?: string | null,
      workStatus?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateValidationCheckSubscriptionVariables = {
  filter?: ModelSubscriptionValidationCheckFilterInput | null,
};

export type OnCreateValidationCheckSubscription = {
  onCreateValidationCheck?:  {
    __typename: "ValidationCheck",
    id: string,
    validationID: string,
    checkType: string,
    inputResourceURIs: Array< string | null >,
    status: ValidationStatus,
    issues?:  {
      __typename: "ModelValidationIssueConnection",
      items:  Array< {
        __typename: "ValidationIssue",
        id: string,
        validationID: string,
        validationCheckID: string,
        title?: string | null,
        issue: string,
        status: ValidationStatus,
        resourceURI: string,
        issueGroup: string,
        issueType?: ValidationIssueType | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateValidationCheckSubscriptionVariables = {
  filter?: ModelSubscriptionValidationCheckFilterInput | null,
};

export type OnUpdateValidationCheckSubscription = {
  onUpdateValidationCheck?:  {
    __typename: "ValidationCheck",
    id: string,
    validationID: string,
    checkType: string,
    inputResourceURIs: Array< string | null >,
    status: ValidationStatus,
    issues?:  {
      __typename: "ModelValidationIssueConnection",
      items:  Array< {
        __typename: "ValidationIssue",
        id: string,
        validationID: string,
        validationCheckID: string,
        title?: string | null,
        issue: string,
        status: ValidationStatus,
        resourceURI: string,
        issueGroup: string,
        issueType?: ValidationIssueType | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateValidationIssueSubscriptionVariables = {
  filter?: ModelSubscriptionValidationIssueFilterInput | null,
};

export type OnUpdateValidationIssueSubscription = {
  onUpdateValidationIssue?:  {
    __typename: "ValidationIssue",
    id: string,
    validationID: string,
    validationCheckID: string,
    title?: string | null,
    issue: string,
    status: ValidationStatus,
    resourceURI: string,
    issueGroup: string,
    issueType?: ValidationIssueType | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateWorkflowAuditEntrySubscriptionVariables = {
  filter?: ModelSubscriptionWorkflowAuditEntryFilterInput | null,
};

export type OnCreateWorkflowAuditEntrySubscription = {
  onCreateWorkflowAuditEntry?:  {
    __typename: "WorkflowAuditEntry",
    id: string,
    workflowAuditID: string,
    message: string,
    actorType?: UserGroup | null,
    actorID?: string | null,
    entryType?: string | null,
    attachments:  Array< {
      __typename: "S3Blob",
      bucket: string,
      key: string,
    } >,
    relatedActionIDs?: Array< string > | null,
    payload?: string | null,
    correlationID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateHistoryValidationSubscriptionVariables = {
  filter?: ModelSubscriptionHistoryValidationFilterInput | null,
};

export type OnCreateHistoryValidationSubscription = {
  onCreateHistoryValidation?:  {
    __typename: "HistoryValidation",
    id: string,
    appointmentRecordID: string,
    status: HistoryValidationStatus,
    groups:  Array< {
      __typename: "HistoryValidationGroup",
      id: string,
      title: string,
      status: HistoryValidationGroupStatus,
      issues:  Array< {
        __typename: "HistoryValidationIssue",
        id: string,
        title: string,
        description?: string | null,
        patientInfoSection?: PatientInfoSection | null,
        issueType?: ValidationIssueType | null,
      } | null >,
    } | null >,
    validatedAt?: string | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateHistoryValidationSubscriptionVariables = {
  filter?: ModelSubscriptionHistoryValidationFilterInput | null,
};

export type OnUpdateHistoryValidationSubscription = {
  onUpdateHistoryValidation?:  {
    __typename: "HistoryValidation",
    id: string,
    appointmentRecordID: string,
    status: HistoryValidationStatus,
    groups:  Array< {
      __typename: "HistoryValidationGroup",
      id: string,
      title: string,
      status: HistoryValidationGroupStatus,
      issues:  Array< {
        __typename: "HistoryValidationIssue",
        id: string,
        title: string,
        description?: string | null,
        patientInfoSection?: PatientInfoSection | null,
        issueType?: ValidationIssueType | null,
      } | null >,
    } | null >,
    validatedAt?: string | null,
    errorMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateZendeskTicketSubscriptionVariables = {
  filter?: ModelSubscriptionZendeskTicketFilterInput | null,
};

export type OnCreateZendeskTicketSubscription = {
  onCreateZendeskTicket?:  {
    __typename: "ZendeskTicket",
    id: string,
    ticketID: number,
    appointmentRecordID: string,
    recipientParty: InquiringParty,
    isPrimary: boolean,
    isTextTicket?: boolean | null,
    claimNumber: string,
    version: string,
    lastSyncedAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateZendeskTicketSubscriptionVariables = {
  filter?: ModelSubscriptionZendeskTicketFilterInput | null,
};

export type OnUpdateZendeskTicketSubscription = {
  onUpdateZendeskTicket?:  {
    __typename: "ZendeskTicket",
    id: string,
    ticketID: number,
    appointmentRecordID: string,
    recipientParty: InquiringParty,
    isPrimary: boolean,
    isTextTicket?: boolean | null,
    claimNumber: string,
    version: string,
    lastSyncedAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAppointmentNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionAppointmentNotificationFilterInput | null,
};

export type OnCreateAppointmentNotificationSubscription = {
  onCreateAppointmentNotification?:  {
    __typename: "AppointmentNotification",
    id: string,
    appointmentRecordID: string,
    entityType?: string | null,
    entityID?: string | null,
    notificationType: string,
    channel: NotificationChannel,
    recipientType: UserGroup,
    recipientID: string,
    recipientName?: string | null,
    title: string,
    body: string,
    status: string,
    readAt?: string | null,
    ttl?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAppointmentNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionAppointmentNotificationFilterInput | null,
};

export type OnUpdateAppointmentNotificationSubscription = {
  onUpdateAppointmentNotification?:  {
    __typename: "AppointmentNotification",
    id: string,
    appointmentRecordID: string,
    entityType?: string | null,
    entityID?: string | null,
    notificationType: string,
    channel: NotificationChannel,
    recipientType: UserGroup,
    recipientID: string,
    recipientName?: string | null,
    title: string,
    body: string,
    status: string,
    readAt?: string | null,
    ttl?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateSkillSubscriptionVariables = {
  filter?: ModelSubscriptionSkillFilterInput | null,
};

export type OnCreateSkillSubscription = {
  onCreateSkill?:  {
    __typename: "Skill",
    id: string,
    name: string,
    description: string,
    body: string,
    scope: SkillScope,
    ownerUserId: string,
    roles?: Array< UserGroup > | null,
    inputs?:  Array< {
      __typename: "SkillInput",
      name: string,
      description?: string | null,
      required: boolean,
    } > | null,
    visibility: SkillVisibility,
    version: number,
    archivedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSkillSubscriptionVariables = {
  filter?: ModelSubscriptionSkillFilterInput | null,
};

export type OnUpdateSkillSubscription = {
  onUpdateSkill?:  {
    __typename: "Skill",
    id: string,
    name: string,
    description: string,
    body: string,
    scope: SkillScope,
    ownerUserId: string,
    roles?: Array< UserGroup > | null,
    inputs?:  Array< {
      __typename: "SkillInput",
      name: string,
      description?: string | null,
      required: boolean,
    } > | null,
    visibility: SkillVisibility,
    version: number,
    archivedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSkillSubscriptionVariables = {
  filter?: ModelSubscriptionSkillFilterInput | null,
};

export type OnDeleteSkillSubscription = {
  onDeleteSkill?:  {
    __typename: "Skill",
    id: string,
    name: string,
    description: string,
    body: string,
    scope: SkillScope,
    ownerUserId: string,
    roles?: Array< UserGroup > | null,
    inputs?:  Array< {
      __typename: "SkillInput",
      name: string,
      description?: string | null,
      required: boolean,
    } > | null,
    visibility: SkillVisibility,
    version: number,
    archivedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRoutineSubscriptionVariables = {
  filter?: ModelSubscriptionRoutineFilterInput | null,
};

export type OnUpdateRoutineSubscription = {
  onUpdateRoutine?:  {
    __typename: "Routine",
    id: string,
    scope: RoutineScope,
    name: string,
    description?: string | null,
    promptBody: string,
    model: string,
    reasoningEffort: string,
    enableWebSearch: boolean,
    maxAgentTurns?: number | null,
    conversationMode: RoutineConversationMode,
    schedule:  {
      __typename: "RoutineSchedule",
      frequency: RoutineFrequency,
      intervalHours?: number | null,
      timeOfDay?: string | null,
      weekdays?: Array< number > | null,
      runAt?: string | null,
    },
    timezone: string,
    enabled: boolean,
    notifyOwner: RoutineNotify,
    slackChannel?: string | null,
    ownerUserId: string,
    createdAt: string,
    createdVia: RoutineOrigin,
    version: number,
    archivedAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateRoutineStateSubscriptionVariables = {
  filter?: ModelSubscriptionRoutineStateFilterInput | null,
};

export type OnUpdateRoutineStateSubscription = {
  onUpdateRoutineState?:  {
    __typename: "RoutineState",
    id: string,
    scope: RoutineScope,
    ownerUserId: string,
    definitionVersion: number,
    schedulePartition?: string | null,
    nextRunAt?: string | null,
    currentConversationId?: string | null,
    activeRunId?: string | null,
    lastRunId?: string | null,
    consecutiveFailures: number,
    endedReason?: RoutineEndedReason | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRoutineRunSubscriptionVariables = {
  filter?: ModelSubscriptionRoutineRunFilterInput | null,
};

export type OnUpdateRoutineRunSubscription = {
  onUpdateRoutineRun?:  {
    __typename: "RoutineRun",
    id: string,
    scope: RoutineScope,
    routineId: string,
    routineVersion: number,
    createdAt: string,
    definitionSnapshot: string,
    status: RoutineRunStatus,
    trigger: RoutineTrigger,
    triggeredByUserId?: string | null,
    extraContext?: string | null,
    scheduledFor?: string | null,
    startedAt?: string | null,
    finishedAt?: string | null,
    durationMs?: number | null,
    processingStage?: string | null,
    nextProcessingAt?: string | null,
    dispatchAttempts: number,
    lastDispatchedAt?: string | null,
    executionToken?: string | null,
    executionDeadlineAt?: string | null,
    conversationOwnerUserId: string,
    conversationId?: string | null,
    previousConversationId?: string | null,
    userMessageId?: string | null,
    assistantMessageId?: string | null,
    outcome?: RoutineOutcome | null,
    headline?: string | null,
    summary?: string | null,
    totalTokens?: number | null,
    agentTurns?: number | null,
    toolsCalled?: Array< string | null > | null,
    toolsFailed?: Array< string | null > | null,
    correlationId?: string | null,
    errorMessage?: string | null,
    ownerDelivery?:  {
      __typename: "RoutineDelivery",
      status: RoutineDeliveryStatus,
      target?: string | null,
      claimToken?: string | null,
      claimExpiresAt?: string | null,
      attemptedAt?: string | null,
      finishedAt?: string | null,
      messageId?: string | null,
      errorMessage?: string | null,
    } | null,
    channelDelivery?:  {
      __typename: "RoutineDelivery",
      status: RoutineDeliveryStatus,
      target?: string | null,
      claimToken?: string | null,
      claimExpiresAt?: string | null,
      attemptedAt?: string | null,
      finishedAt?: string | null,
      messageId?: string | null,
      errorMessage?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type OnCreateDoctorSupportingMASubscriptionVariables = {
  filter?: ModelSubscriptionDoctorSupportingMAFilterInput | null,
  ownerCognitoId?: string | null,
};

export type OnCreateDoctorSupportingMASubscription = {
  onCreateDoctorSupportingMA?:  {
    __typename: "DoctorSupportingMA",
    id: string,
    medicalAssistantId: string,
    doctorId: string,
    medicalAssistant:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    },
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type OnUpdateDoctorSupportingMASubscriptionVariables = {
  filter?: ModelSubscriptionDoctorSupportingMAFilterInput | null,
  ownerCognitoId?: string | null,
};

export type OnUpdateDoctorSupportingMASubscription = {
  onUpdateDoctorSupportingMA?:  {
    __typename: "DoctorSupportingMA",
    id: string,
    medicalAssistantId: string,
    doctorId: string,
    medicalAssistant:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    },
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type OnDeleteDoctorSupportingMASubscriptionVariables = {
  filter?: ModelSubscriptionDoctorSupportingMAFilterInput | null,
  ownerCognitoId?: string | null,
};

export type OnDeleteDoctorSupportingMASubscription = {
  onDeleteDoctorSupportingMA?:  {
    __typename: "DoctorSupportingMA",
    id: string,
    medicalAssistantId: string,
    doctorId: string,
    medicalAssistant:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    },
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type OnCreateMedicalAssistantSpecialtyCategorySubscriptionVariables = {
  filter?: ModelSubscriptionMedicalAssistantSpecialtyCategoryFilterInput | null,
};

export type OnCreateMedicalAssistantSpecialtyCategorySubscription = {
  onCreateMedicalAssistantSpecialtyCategory?:  {
    __typename: "MedicalAssistantSpecialtyCategory",
    id: string,
    medicalAssistantId: string,
    specialtyCategoryId: string,
    medicalAssistant:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    },
    specialtyCategory:  {
      __typename: "SpecialtyCategory",
      id: string,
      name: string,
      specialties?: Array< SpecialtyType > | null,
      fallbackMA?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      medicalAssistants?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      specialtyCategoryFallbackMAId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMedicalAssistantSpecialtyCategorySubscriptionVariables = {
  filter?: ModelSubscriptionMedicalAssistantSpecialtyCategoryFilterInput | null,
};

export type OnUpdateMedicalAssistantSpecialtyCategorySubscription = {
  onUpdateMedicalAssistantSpecialtyCategory?:  {
    __typename: "MedicalAssistantSpecialtyCategory",
    id: string,
    medicalAssistantId: string,
    specialtyCategoryId: string,
    medicalAssistant:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    },
    specialtyCategory:  {
      __typename: "SpecialtyCategory",
      id: string,
      name: string,
      specialties?: Array< SpecialtyType > | null,
      fallbackMA?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      medicalAssistants?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      specialtyCategoryFallbackMAId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMedicalAssistantSpecialtyCategorySubscriptionVariables = {
  filter?: ModelSubscriptionMedicalAssistantSpecialtyCategoryFilterInput | null,
};

export type OnDeleteMedicalAssistantSpecialtyCategorySubscription = {
  onDeleteMedicalAssistantSpecialtyCategory?:  {
    __typename: "MedicalAssistantSpecialtyCategory",
    id: string,
    medicalAssistantId: string,
    specialtyCategoryId: string,
    medicalAssistant:  {
      __typename: "MedicalAssistant",
      id: string,
      name?: string | null,
      email?: string | null,
      preVisitCallScheduleLink?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      enableCalendarNotify?: boolean | null,
      inactive?: boolean | null,
      languages?: Array< Language > | null,
      assignmentCriteria?:  {
        __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        languageWeights:  Array< {
          __typename: "LanguageWeight",
          language: Language,
          weight: number,
          doctorSpecialty?: SpecialtyType | null,
        } >,
      } | null,
      isDemo?: boolean | null,
      dismissedProTips?: Array< string | null > | null,
      phoneNumber?: string | null,
      joinedDate?: string | null,
      level?: number | null,
      capacityPercent?: number | null,
      supportedDoctors?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      supportedSpecialtyCategories?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilityExceptions?:  Array< {
        __typename: "AvailabilityException",
        type: AvailabilityExceptionType,
        during?:  {
          __typename: "DateRange",
          start?: string | null,
          end?: string | null,
        } | null,
        startTime?: string | null,
        endTime?: string | null,
        allDay?: boolean | null,
      } | null > | null,
      roles?: Array< OpsRole > | null,
      createdAt: string,
      updatedAt: string,
      medicalAssistantUserId?: string | null,
    },
    specialtyCategory:  {
      __typename: "SpecialtyCategory",
      id: string,
      name: string,
      specialties?: Array< SpecialtyType > | null,
      fallbackMA?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      medicalAssistants?:  {
        __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
        items:  Array< {
          __typename: "MedicalAssistantSpecialtyCategory",
          id: string,
          medicalAssistantId: string,
          specialtyCategoryId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      specialtyCategoryFallbackMAId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserAppointmentFilterPresetSubscriptionVariables = {
  filter?: ModelSubscriptionUserAppointmentFilterPresetFilterInput | null,
};

export type OnCreateUserAppointmentFilterPresetSubscription = {
  onCreateUserAppointmentFilterPreset?:  {
    __typename: "UserAppointmentFilterPreset",
    id: string,
    userId: string,
    appointmentFilterPresetId: string,
    user:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    },
    appointmentFilterPreset:  {
      __typename: "AppointmentFilterPreset",
      id: string,
      name: string,
      filters:  Array< {
        __typename: "FilterEntry",
        type: FilterType,
        values: Array< string >,
      } >,
      appliesTo: UserGroup,
      view?: AppointmentsView | null,
      users?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserAppointmentFilterPresetSubscriptionVariables = {
  filter?: ModelSubscriptionUserAppointmentFilterPresetFilterInput | null,
};

export type OnUpdateUserAppointmentFilterPresetSubscription = {
  onUpdateUserAppointmentFilterPreset?:  {
    __typename: "UserAppointmentFilterPreset",
    id: string,
    userId: string,
    appointmentFilterPresetId: string,
    user:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    },
    appointmentFilterPreset:  {
      __typename: "AppointmentFilterPreset",
      id: string,
      name: string,
      filters:  Array< {
        __typename: "FilterEntry",
        type: FilterType,
        values: Array< string >,
      } >,
      appliesTo: UserGroup,
      view?: AppointmentsView | null,
      users?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserAppointmentFilterPresetSubscriptionVariables = {
  filter?: ModelSubscriptionUserAppointmentFilterPresetFilterInput | null,
};

export type OnDeleteUserAppointmentFilterPresetSubscription = {
  onDeleteUserAppointmentFilterPreset?:  {
    __typename: "UserAppointmentFilterPreset",
    id: string,
    userId: string,
    appointmentFilterPresetId: string,
    user:  {
      __typename: "User",
      id: string,
      cognitoUserId: string,
      avatarUrl?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      assistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      appointmentFilterPreset?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      onboardingDismissals?:  Array< {
        __typename: "OnboardingDismissal",
        itemId: string,
        dismissedAt: string,
      } | null > | null,
      settings?:  {
        __typename: "UserSettings",
        opsChecklistDefaultExpanded?: boolean | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      userDoctorId?: string | null,
      userAssistantId?: string | null,
    },
    appointmentFilterPreset:  {
      __typename: "AppointmentFilterPreset",
      id: string,
      name: string,
      filters:  Array< {
        __typename: "FilterEntry",
        type: FilterType,
        values: Array< string >,
      } >,
      appliesTo: UserGroup,
      view?: AppointmentsView | null,
      users?:  {
        __typename: "ModelUserAppointmentFilterPresetConnection",
        items:  Array< {
          __typename: "UserAppointmentFilterPreset",
          id: string,
          userId: string,
          appointmentFilterPresetId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAppointmentRecordPatientCaseSubscriptionVariables = {
  filter?: ModelSubscriptionAppointmentRecordPatientCaseFilterInput | null,
  doctorOwnerCognitoId?: string | null,
  assistantCognitoIds?: string | null,
};

export type OnCreateAppointmentRecordPatientCaseSubscription = {
  onCreateAppointmentRecordPatientCase?:  {
    __typename: "AppointmentRecordPatientCase",
    id: string,
    appointmentRecordId: string,
    patientCaseId: string,
    appointmentRecord:  {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    },
    patientCase:  {
      __typename: "PatientCase",
      id: string,
      patientID: string,
      patient?:  {
        __typename: "Patient",
        id: string,
        name?: string | null,
        dateOfBirth?: string | null,
        SSN?: string | null,
        language?: Language | null,
        dominantHand?: DominantHand | null,
        cases?:  {
          __typename: "ModelPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        occupation?: string | null,
        sex?: Sex | null,
        weightLb?: number | null,
        height?:  {
          __typename: "Height",
          feet?: number | null,
          inches?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      claimNumber: string,
      qmePanelNumber?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      injuryInfo?:  {
        __typename: "InjuryInfo",
        injuryType?: InjuryType | null,
        injuredBodyParts?: Array< BodyPart | null > | null,
        claimedBodyParts?: Array< BodyPart | null > | null,
        description?: string | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        startDateOfInjury?: string | null,
        startDateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
      } | null,
      workersCompInsurance?:  {
        __typename: "WorkersCompInsuranceInfo",
        insuranceCarrier?: string | null,
        adjuster?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      insuranceCarrierID?: string | null,
      insuranceCarrier?:  {
        __typename: "InsuranceCarrier",
        id: string,
        name: string,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierAddressID?: string | null,
      insuranceCarrierAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierFaxNumberID?: string | null,
      insuranceCarrierFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierPhoneNumberID?: string | null,
      insuranceCarrierPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      applicantAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyLawFirmID?: string | null,
      applicantAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyAddressID?: string | null,
      applicantAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyFaxNumberID?: string | null,
      applicantAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyPhoneNumberID?: string | null,
      applicantAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      defenseAttorneyLawFirmID?: string | null,
      defenseAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyAddressID?: string | null,
      defenseAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyFaxNumberID?: string | null,
      defenseAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyPhoneNumberID?: string | null,
      defenseAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nurseCaseManager?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      ccPerson?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyCcEmails?: Array< string | null > | null,
      defenseAttorneyCcEmails?: Array< string | null > | null,
      adjusterCcEmails?: Array< string | null > | null,
      scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
      employmentAtInjury?:  {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null,
      WCAB?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    doctorOwnerCognitoId?: string | null,
    assistantCognitoIds?: string | null,
  } | null,
};

export type OnUpdateAppointmentRecordPatientCaseSubscriptionVariables = {
  filter?: ModelSubscriptionAppointmentRecordPatientCaseFilterInput | null,
  doctorOwnerCognitoId?: string | null,
  assistantCognitoIds?: string | null,
};

export type OnUpdateAppointmentRecordPatientCaseSubscription = {
  onUpdateAppointmentRecordPatientCase?:  {
    __typename: "AppointmentRecordPatientCase",
    id: string,
    appointmentRecordId: string,
    patientCaseId: string,
    appointmentRecord:  {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    },
    patientCase:  {
      __typename: "PatientCase",
      id: string,
      patientID: string,
      patient?:  {
        __typename: "Patient",
        id: string,
        name?: string | null,
        dateOfBirth?: string | null,
        SSN?: string | null,
        language?: Language | null,
        dominantHand?: DominantHand | null,
        cases?:  {
          __typename: "ModelPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        occupation?: string | null,
        sex?: Sex | null,
        weightLb?: number | null,
        height?:  {
          __typename: "Height",
          feet?: number | null,
          inches?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      claimNumber: string,
      qmePanelNumber?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      injuryInfo?:  {
        __typename: "InjuryInfo",
        injuryType?: InjuryType | null,
        injuredBodyParts?: Array< BodyPart | null > | null,
        claimedBodyParts?: Array< BodyPart | null > | null,
        description?: string | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        startDateOfInjury?: string | null,
        startDateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
      } | null,
      workersCompInsurance?:  {
        __typename: "WorkersCompInsuranceInfo",
        insuranceCarrier?: string | null,
        adjuster?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      insuranceCarrierID?: string | null,
      insuranceCarrier?:  {
        __typename: "InsuranceCarrier",
        id: string,
        name: string,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierAddressID?: string | null,
      insuranceCarrierAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierFaxNumberID?: string | null,
      insuranceCarrierFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierPhoneNumberID?: string | null,
      insuranceCarrierPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      applicantAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyLawFirmID?: string | null,
      applicantAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyAddressID?: string | null,
      applicantAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyFaxNumberID?: string | null,
      applicantAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyPhoneNumberID?: string | null,
      applicantAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      defenseAttorneyLawFirmID?: string | null,
      defenseAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyAddressID?: string | null,
      defenseAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyFaxNumberID?: string | null,
      defenseAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyPhoneNumberID?: string | null,
      defenseAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nurseCaseManager?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      ccPerson?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyCcEmails?: Array< string | null > | null,
      defenseAttorneyCcEmails?: Array< string | null > | null,
      adjusterCcEmails?: Array< string | null > | null,
      scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
      employmentAtInjury?:  {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null,
      WCAB?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    doctorOwnerCognitoId?: string | null,
    assistantCognitoIds?: string | null,
  } | null,
};

export type OnDeleteAppointmentRecordPatientCaseSubscriptionVariables = {
  filter?: ModelSubscriptionAppointmentRecordPatientCaseFilterInput | null,
  doctorOwnerCognitoId?: string | null,
  assistantCognitoIds?: string | null,
};

export type OnDeleteAppointmentRecordPatientCaseSubscription = {
  onDeleteAppointmentRecordPatientCase?:  {
    __typename: "AppointmentRecordPatientCase",
    id: string,
    appointmentRecordId: string,
    patientCaseId: string,
    appointmentRecord:  {
      __typename: "AppointmentRecord",
      id: string,
      doctorOwnerCognitoId?: string | null,
      assistantCognitoIds?: Array< string > | null,
      globalPartitionKey: string,
      originalAppointmentID: string,
      supplementalAppointmentIDs?: Array< string | null > | null,
      supplementalSourceAppointmentIDs?: Array< string | null > | null,
      depositionAppointmentIDs?: Array< string | null > | null,
      depositionSourceAppointmentIDs?: Array< string | null > | null,
      rescheduledFromAppointmentID?: string | null,
      rescheduledToAppointmentID?: string | null,
      date?: string | null,
      yearMonth?: string | null,
      doctorYearMonth?: string | null,
      time?: string | null,
      bookedInFlexibleTime?: boolean | null,
      inquiryDate: string,
      inquiryYearMonth: string,
      type?: AppointmentType | null,
      doctorID?: string | null,
      doctor?:  {
        __typename: "Doctor",
        id: string,
        ownerCognitoId?: string | null,
        firstName?: string | null,
        middleName?: string | null,
        lastName?: string | null,
        name?: string | null,
        signatureName?: string | null,
        status?: DoctorStatus | null,
        ramped?: boolean | null,
        title?: string | null,
        titleExtension?: TitleExtension | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        officePhone?: string | null,
        cellPhone?: string | null,
        clinicPhone?: string | null,
        workCity?: string | null,
        workState?: string | null,
        collectionRate?: number | null,
        licenseNumber?: string | null,
        licenseRenewalDate?: string | null,
        qmeLicense?:  {
          __typename: "QmeLicense",
          licenseNumber?: string | null,
          approvalDate?: string | null,
          renewalDate?: string | null,
        } | null,
        locations?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        specialties?: Array< SpecialtyType | null > | null,
        npi?: string | null,
        bankingInfo?:  {
          __typename: "BankingInfo",
          bankEntityName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        availabilities?:  {
          __typename: "Availabilities",
        } | null,
        availabilitiesNote?: string | null,
        emails?: Array< string | null > | null,
        profileImages?:  Array< {
          __typename: "DoctorProfileImage",
          type?: DoctorProfileImageType | null,
          name?: string | null,
          order?: number | null,
          s3Prefix?: string | null,
          widthInInches?: number | null,
          heightInInches?: number | null,
        } | null > | null,
        qmeReportConfigs?:  {
          __typename: "DoctorQMEReportConfigs",
          hasIntroTitle?: boolean | null,
          introTemplate?: string | null,
        } | null,
        physicalEvalConfigs?:  {
          __typename: "DoctorPhysicalEvalConfigs",
          templates?: Array< PhysicalEvalTemplateTag | null > | null,
        } | null,
        signatureDepartment?: string | null,
        profileAssetS3Prefix?: string | null,
        calendarPreference?:  {
          __typename: "CalendarPreference",
          mailingList?: Array< string | null > | null,
          showPatientFullName?: boolean | null,
          showPatientAddress?: boolean | null,
          showPatientDOB?: boolean | null,
          showPortalLink?: boolean | null,
        } | null,
        homeOffice?:  {
          __typename: "HomeOffice",
          county?: string | null,
          state?: string | null,
        } | null,
        reportFormatPreferences?:  {
          __typename: "ReportFormatPreferences",
        } | null,
        evaluationInputPreferences?:  {
          __typename: "EvaluationInputPreferences",
        } | null,
        preferredAssessmentMode?: AssessmentMode | null,
        caseSummaryFields?:  {
          __typename: "ModelDoctorCaseSummaryFieldConnection",
          nextToken?: string | null,
        } | null,
        briefingFields?:  {
          __typename: "ModelDoctorBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        isDemo?: boolean | null,
        fieldTemplateId?: string | null,
        templateFolderLink?: string | null,
        physicianPartner?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPrimaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSecondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultScheduler?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultPreVisitReviewer?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultBillingOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        defaultSupplementalReportOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        supplementalReportOpsAssignments?:  Array< {
          __typename: "SupplementalReportOpsAssignment",
          medicalAssistantID: string,
          weightPercentage: number,
        } | null > | null,
        supportingMAs?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        defaultAppointmentDurationMinutes?:  {
          __typename: "DefaultAppointmentDurationMinutes",
          qme?: number | null,
          qmeReevaluation?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        defaultEarlyArrivalTimeMinutes?:  {
          __typename: "DefaultEarlyArrivalTimeMinutes",
          workersComp?: number | null,
          ime?: number | null,
          deposition?: number | null,
        } | null,
        assessmentTreatmentOptions?: Array< string | null > | null,
        dismissedProTips?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        doctorPhysicianPartnerId?: string | null,
        doctorDefaultPrimaryOnsiteOpsId?: string | null,
        doctorDefaultSecondaryOnsiteOpsId?: string | null,
        doctorDefaultSchedulerId?: string | null,
        doctorDefaultReportOpsId?: string | null,
        doctorDefaultPreVisitReviewerId?: string | null,
        doctorDefaultBillingOpsId?: string | null,
        doctorDefaultSupplementalReportOpsId?: string | null,
        doctorUserId?: string | null,
      } | null,
      locationID?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name?: string | null,
        abbreviation?: string | null,
        status?: LocationStatus | null,
        region?: Region | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        indigoOfficePhoneNumber?: string | null,
        isWaitingArea?: boolean | null,
        additionalRoomsNumber?: number | null,
        landlordContactInfo?:  {
          __typename: "LocationLandlordContactInfo",
          name?: string | null,
          phone?: string | null,
          email?: string | null,
        } | null,
        calendarCcEmails?: Array< string | null > | null,
        isParkingFree?: boolean | null,
        parkingRate?: number | null,
        isFrontDoorLocked?: boolean | null,
        frontDoorCode?: string | null,
        backDoor?: BackDoorStatus | null,
        backDoorCode?: string | null,
        securityUnlockingProcess?: string | null,
        securityLockingProcess?: string | null,
        maleBathroomCode?: string | null,
        femaleBathroomCode?: string | null,
        wifiName?: string | null,
        wifiPassword?: string | null,
        defaultOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        secondaryOnsiteOps?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        locationInstructionsForVisitor?: string | null,
        additionalNote?: string | null,
        doctors?:  {
          __typename: "ModelDoctorLocationConnection",
          nextToken?: string | null,
        } | null,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        locationDefaultOnsiteOpsId?: string | null,
        locationSecondaryOnsiteOpsId?: string | null,
      } | null,
      visitForm?: string | null,
      jotformSubmissions?:  Array< {
        __typename: "JotformSubmission",
        id: string,
        receivedAt: string,
        populatedAt?: string | null,
      } | null > | null,
      historyTranscriptPopulations?:  Array< {
        __typename: "HistoryTranscriptPopulation",
        uploadedFileID: string,
        populatedAt: string,
      } | null > | null,
      active?: boolean | null,
      durationMinutes?: number | null,
      reportDue?: string | null,
      reportSubmitted?: string | null,
      status?: AppointmentStatus | null,
      reportStatus?: ReportStatus | null,
      paymentStatus?: PaymentStatus | null,
      billingStatus?: BillingStatus | null,
      difficultyLevel?: number | null,
      scheduler?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      medicalAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      schedulingAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      onSiteOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      reportOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      billingOp?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      preVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      inquirerInfo?:  {
        __typename: "InquirerInfo",
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        inquiringParty?: InquiringParty | null,
        name?: string | null,
        inquiryDate?: string | null,
        notification_110_required?: boolean | null,
      } | null,
      notes?:  {
        __typename: "ModelNotesConnection",
        items:  Array< {
          __typename: "Notes",
          id: string,
          content?: string | null,
          type?: NotesType | null,
          timeStamp?: number | null,
          appointmentrecordID: string,
          createdAt: string,
          updatedAt: string,
          notesAuthorId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      huddleNote?:  {
        __typename: "HuddleNote",
        id: string,
        appointmentRecordID: string,
        contentMarkdown?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientCases?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      employments?:  Array< {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null > | null,
      employmentGaps?:  Array< {
        __typename: "EmploymentGapRecord",
        type?: EmploymentGapType | null,
        startDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        endDate?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
      } | null > | null,
      patientDescribedInjuries?: Array< BodyPart | null > | null,
      uploadedFilesSet?:  {
        __typename: "UploadedFileSet",
        id: string,
        appointments?:  {
          __typename: "ModelAppointmentRecordConnection",
          nextToken?: string | null,
        } | null,
        uploadedFiles?:  {
          __typename: "ModelUploadedFileConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      uploadedFilesSetID?: string | null,
      referredBy?: string | null,
      s3FileKey?: string | null,
      medicalRecordsReceived?: boolean | null,
      medicalRecordsBriefingFileID?: string | null,
      medicalRecordsBriefingExecutionArn?: string | null,
      medicalRecordsTotalPagesProcessed?: number | null,
      reportGenerationFileID?: string | null,
      reportGenerationExecutionArn?: string | null,
      reportGenerationGeneratedAt?: string | null,
      historyOfInjuryFileID?: string | null,
      historyOfInjuryGeneratedAt?: string | null,
      evaluationFileID?: string | null,
      assessmentFileID?: string | null,
      depositionPreparationFileID?: string | null,
      documentStatus?:  {
        __typename: "DocumentStatus",
        evaluationPublished?: boolean | null,
        assessmentPublished?: boolean | null,
        historyInProgress?: boolean | null,
        historyPublished?: boolean | null,
        historyCleaned?: boolean | null,
        reportPublished?: boolean | null,
        briefingInProgress?: boolean | null,
        briefingPublished?: boolean | null,
        briefingCleaned?: boolean | null,
      } | null,
      cancellationReason?: CancellationReason | null,
      cancellationRequestedBy?: ParticipantType | null,
      cancellationRequestedInternally?: boolean | null,
      cancellationNote?: string | null,
      cancellationDate?: string | null,
      inquiryClosingReason?: InquiryClosingReason | null,
      inquiryClosingNote?: string | null,
      inquiryClosingDate?: string | null,
      noShowReason?: NoShowReason | null,
      noShowNote?: string | null,
      reschedulingReason?: ReschedulingReason | null,
      reschedulingOthersReason?: string | null,
      reschedulingRequestedBy?: ParticipantType | null,
      reschedulingRequestedInternally?: boolean | null,
      reschedulingNote?: string | null,
      reschedulingDate?: string | null,
      interpreter?:  {
        __typename: "InterpreterInfo",
        certificateId?: string | null,
        name?: string | null,
        companyName?: string | null,
        phoneNumber?: string | null,
        phoneExtension?: string | null,
        note?: string | null,
        confirmed?: boolean | null,
      } | null,
      historyOfInjuryNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      currentComplaintNotes?:  {
        __typename: "Notes",
        id: string,
        content?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        type?: NotesType | null,
        timeStamp?: number | null,
        appointmentrecordID: string,
        createdAt: string,
        updatedAt: string,
        notesAuthorId?: string | null,
      } | null,
      historyCallDate?: string | null,
      historyCallTime?: string | null,
      historyCallAssistant?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      historyCallCompleted?: boolean | null,
      historyCallCompletedWithoutRecords?: boolean | null,
      historyCallCompletedOnSite?: boolean | null,
      historyCallNoShow?: boolean | null,
      historyCallCalendarEventID?: string | null,
      historyCallCalendarLink?: string | null,
      billingInfo?:  {
        __typename: "BillingInfo",
        diagnosisMappings?:  Array< {
          __typename: "DiagnosisMapping",
          code?: string | null,
          pointer?: string | null,
          description?: string | null,
        } | null > | null,
        serviceDetails?:  Array< {
          __typename: "ServiceDetail",
          dateOfStart?: string | null,
          dateOfEnd?: string | null,
          place?: number | null,
          emergencyIndicator?: boolean | null,
          serviceType?: ServiceType | null,
          modifiers?: Array< ServiceModifier | null > | null,
          diagnosisPointers?: Array< string | null > | null,
          chargedAmount?: number | null,
          quantity?: number | null,
          amountPaid?: number | null,
          renderingProviderId?: string | null,
        } | null > | null,
        totalCharge?: number | null,
        amountPaid?: number | null,
        billingCounter?: number | null,
        billedDate?: string | null,
        paidDate?: string | null,
        correctionDate?: string | null,
      } | null,
      caseInfo?:  {
        __typename: "CaseInfo",
        confirmationEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        recordsFollowupEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
        attendanceEmailStatuses?:  {
          __typename: "ParticipantEmailStatuses",
          patient?: boolean | null,
          adjuster?: boolean | null,
          applicantAttorney?: boolean | null,
          defenseAttorney?: boolean | null,
          patientSentAt?: string | null,
          adjusterSentAt?: string | null,
          applicantAttorneySentAt?: string | null,
          defenseAttorneySentAt?: string | null,
        } | null,
      } | null,
      isProd?: boolean | null,
      isDemo?: boolean | null,
      primaryPatientCaseID?: string | null,
      calendarEventID?: string | null,
      reportConfiguration?:  {
        __typename: "ReportConfiguration",
        history?: ReportSource | null,
        physicalExamination?: ReportSource | null,
        assessment?: ReportSource | null,
      } | null,
      workflowExecutions?:  {
        __typename: "ModelWorkflowExecutionConnection",
        items:  Array< {
          __typename: "WorkflowExecution",
          executionArn: string,
          appointmentRecordID: string,
          type?: WorkflowExecutionType | null,
          status?: WorkflowExecutionStatus | null,
          errorMessage?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      historyOfInjuryInsights?:  {
        __typename: "HistoryOfInjuryInsights",
        id: string,
        appointmentRecordID: string,
        mechanismOfInjury?: string | null,
        employerJobDescription?: string | null,
        injuryCausations?:  Array< {
          __typename: "InjuryCausationInfo",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          mechanismOfInjury?: string | null,
          employerJobDescription?: string | null,
        } | null > | null,
        currentSymptoms?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        priorSymptomsBeforeCurrentInjury?:  Array< {
          __typename: "Symptom",
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousSurgeries?:  Array< {
          __typename: "SurgeryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          type?: string | null,
        } | null > | null,
        previousWorkInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        previousInjuries?:  Array< {
          __typename: "InjuryHistoryInfo",
          date?: string | null,
          bodyParts?: Array< string | null > | null,
          description?: string | null,
        } | null > | null,
        injuryEmploymentStatus?: string | null,
        currentWorkRestrictionsFromPatient?: string | null,
        activitiesOfDailyLiving?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reviewOfMedicalRecordsInsights?:  {
        __typename: "ReviewOfMedicalRecordsInsights",
        id: string,
        appointmentRecordID: string,
        latestDiagnosis?:  Array< {
          __typename: "BodyPartDiagnosis",
          bodyPart?: string | null,
          date?: string | null,
          descriptions?: Array< string | null > | null,
        } | null > | null,
        diagnosticStudies?:  Array< {
          __typename: "DiagnosticStudy",
          date?: string | null,
          typeOfStudy?: DiagnosticStudyType | null,
          bodyPart?: string | null,
          impression?: string | null,
          source?: DiagnosticStudySource | null,
        } | null > | null,
        treatments?:  Array< {
          __typename: "TreatmentWrapper",
        } | null > | null,
        currentWorkRestrictionsFromMedicalRecords?: string | null,
        previousReports?:  Array< {
          __typename: "PreviousReport",
          date?: string | null,
          reportType?: string | null,
          reportContent?: string | null,
        } | null > | null,
        durableMedicalEquipment?:  Array< {
          __typename: "DurableMedicalEquipment",
          startDate?: string | null,
          endDate?: string | null,
          bodyParts?: Array< string | null > | null,
          equipmentType?: string | null,
          description?: string | null,
        } | null > | null,
        derivedFromDocumentInsightIDs?: Array< string | null > | null,
        derivedAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      physicalExamInsights?:  {
        __typename: "PhysicalExamInsights",
        id: string,
        appointmentRecordID: string,
        physicalExaminationInfo?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pastInjuryMatrix?:  {
        __typename: "PastInjuryMatrix",
        id: string,
        appointmentRecordID: string,
        preExistingConditions: Array< string >,
        familyHistory: Array< string >,
        injuryMatrix:  Array< {
          __typename: "InjuryMatrixEntry",
          date: string,
          bodyPart: BodyPart,
          status: InjuryStatus,
        } >,
        createdAt: string,
        updatedAt: string,
      } | null,
      briefing?:  {
        __typename: "RecordBriefing",
        id: string,
        logicalBriefingID: string,
        segmentMappings?:  {
          __typename: "ModelRecordBriefingSegmentMappingConnection",
          nextToken?: string | null,
        } | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        googleDocExportLink?: string | null,
        googleDocExportedAt?: string | null,
        suggestionGeneration?:  {
          __typename: "SuggestionGenerationJob",
          status?: SuggestionGenerationStatus | null,
          jobId?: string | null,
          startedAt?: string | null,
          completedAt?: string | null,
          error?: string | null,
        } | null,
        editingPresence?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      introParagraph?:  {
        __typename: "IntroParagraph",
        id: string,
        appointmentRecordID: string,
        introParagraphText?: string | null,
        sourceRecaps?:  Array< {
          __typename: "CoverLetterRecapSnapshot",
          coverLetterRecapID: string,
          uploadedFileID: string,
          recapText: string,
          generatedAt?: string | null,
        } | null > | null,
        status: IntroParagraphStatus,
        errorMessage?: string | null,
        generatedAt?: string | null,
        lastEditedAt?: string | null,
        lastEditedBy?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      impairmentRatingResults?:  Array< {
        __typename: "ImpairmentRatingResult",
        ts?: number | null,
        bodyParts?: Array< string | null > | null,
        enabledStrictRating?: boolean | null,
        enabledPainRating?: boolean | null,
        enabledAG?: boolean | null,
        enabledStrengthRating?: boolean | null,
        enabledDBE?: boolean | null,
        autoMode?: boolean | null,
        result?: string | null,
        resultFeedback?:  {
          __typename: "ImpairmentRatingResultFeedback",
          exists?: boolean | null,
          isGood?: boolean | null,
          notes?: string | null,
        } | null,
      } | null > | null,
      defenseAttorneyPagesDeclaration?: number | null,
      applicantAttorneyPagesDeclaration?: number | null,
      fieldTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      dataFieldValuesMappings?:  Array< {
        __typename: "DataFieldValueMapping",
        dataFieldID?: string | null,
        value?: string | null,
      } | null > | null,
      physicalEvalTemplateRef?:  {
        __typename: "FieldTemplateRef",
        id: string,
        version: number,
      } | null,
      physicalExamValues?:  Array< {
        __typename: "PhysicalExamValue",
        sectionID: string,
        questionID: string,
        side?: PhysicalExamSide | null,
        value?: string | null,
        note?: string | null,
        excluded?: boolean | null,
      } | null > | null,
      physicalExamOtherFindings?:  Array< {
        __typename: "PhysicalExamOtherFinding",
        sectionID: string,
        text?: string | null,
      } | null > | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        injuries?:  Array< {
          __typename: "AssessmentInjury",
          injuryType?: InjuryType | null,
          dateOfInjury?: string | null,
          dateOfInjuryEnd?: string | null,
          bodyParts?: Array< BodyPart | null > | null,
          causeOfInjury?: string | null,
          causedByWork?: AssessmentCausationOption | null,
          causedByWorkExplanation?: string | null,
        } | null > | null,
        discussedBodyParts?: Array< BodyPart | null > | null,
        bodyPartsNotDiscussedReason?: string | null,
        discussions?: string | null,
        diagnoses?:  Array< {
          __typename: "AssessmentDiagnosis",
          diagnosis?: string | null,
          icdCode?: string | null,
          evidenceSources?: Array< AssessmentEvidenceSource | null > | null,
          evidence?: string | null,
        } | null > | null,
        bodyPartMMIStatus?:  {
          __typename: "AssessmentBodyPartMMIStatus",
          discussByBodyPart?: boolean | null,
        } | null,
        workStatus?: string | null,
        markedAsDone?: boolean | null,
        discussDiagnosesFreeForm?: boolean | null,
        diagnosesFreeform?: string | null,
        discussCausationFreeForm?: boolean | null,
        causationFreeForm?: string | null,
        discussMMIImpairmentRatingApportionmentFreeForm?: boolean | null,
        hasPatientReachedMMIFreeForm?: string | null,
        discussMMIByBodyPartFreeForm?: string | null,
        impairmentRatingByBodyPartFreeForm?: string | null,
        apportionmentByBodyPartFreeForm?: string | null,
        impairmentRatingOtherComments?: string | null,
        apportionmentOtherComments?: string | null,
        assessmentMode?: AssessmentMode | null,
        assessmentFreeForm?:  {
          __typename: "AssessmentFreeForm",
          discussions?: string | null,
          diagnosesAndEvidence?: string | null,
          causation?: string | null,
          hasPatientReachedMMI?: string | null,
          discussMMIByBodyPart?: string | null,
          impairmentRatingByBodyPart?: string | null,
          apportionmentByBodyPart?: string | null,
          workStatus?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      opinionRecap?:  {
        __typename: "OpinionRecap",
        id: string,
        appointmentRecordID: string,
        causation?: string | null,
        diagnosis?: string | null,
        mmiFutureMedicalTreatment?: string | null,
        impairmentRating?: string | null,
        apportionment?: string | null,
        workStatus?: string | null,
        sourceReportFileID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
      featureFlags?:  Array< {
        __typename: "AppointmentFeatureConfig",
        featureFlagKey: string,
        enabled: boolean,
      } | null > | null,
      opsChecklist?:  {
        __typename: "OpsChecklist",
        panel?: OpsChecklistItemStatus | null,
        contact_info?: OpsChecklistItemStatus | null,
        all_parties?: OpsChecklistItemStatus | null,
        notice_110?: OpsChecklistItemStatus | null,
        cover_letter?: OpsChecklistItemStatus | null,
        record_review?: OpsChecklistItemStatus | null,
        history_call?: OpsChecklistItemStatus | null,
        history_of_injury?: OpsChecklistItemStatus | null,
        interpreter_info?: OpsChecklistItemStatus | null,
        jotform?: OpsChecklistItemStatus | null,
        deu_100?: OpsChecklistItemStatus | null,
        final_report?: OpsChecklistItemStatus | null,
      } | null,
      panelUnavailable?: boolean | null,
      panelSpecialty?: SpecialtyType | null,
      defenseAttorneyNotPresent?: boolean | null,
      applicantAttorneyNotPresent?: boolean | null,
      contactUnavailability?:  {
        __typename: "ParticipantContactUnavailability",
        patient?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        adjuster?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        applicantAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
        defenseAttorney?:  {
          __typename: "ContactUnavailability",
          emailUnavailable?: boolean | null,
          phoneUnavailable?: boolean | null,
        } | null,
      } | null,
      historyValidation?:  {
        __typename: "HistoryValidation",
        id: string,
        appointmentRecordID: string,
        status: HistoryValidationStatus,
        groups:  Array< {
          __typename: "HistoryValidationGroup",
          id: string,
          title: string,
          status: HistoryValidationGroupStatus,
        } | null >,
        validatedAt?: string | null,
        errorMessage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      patientHistoryValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      videoCallLink?: string | null,
      additionalTimeslots?:  Array< {
        __typename: "AdditionalTimeslot",
        date: string,
        time: string,
        locationID?: string | null,
      } | null > | null,
      mrrValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      historyMrrCrossValidation?:  {
        __typename: "Validation",
        id: string,
        issueGroups: Array< string | null >,
        issues?:  {
          __typename: "ModelValidationIssueConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      caseID?: string | null,
      briefingModelVersion?: BriefingModelVersion | null,
      briefingGdocExportLink?: string | null,
      briefingGdocExportedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      appointmentRecordMedicalAssistantId?: string | null,
      appointmentRecordSchedulingAssistantId?: string | null,
      appointmentRecordOnSiteOpId?: string | null,
      appointmentRecordReportOpId?: string | null,
      appointmentRecordBillingOpId?: string | null,
      appointmentRecordPreVisitReviewerId?: string | null,
      appointmentRecordHuddleNoteId?: string | null,
      appointmentRecordHistoryOfInjuryNotesId?: string | null,
      appointmentRecordCurrentComplaintNotesId?: string | null,
      appointmentRecordHistoryCallAssistantId?: string | null,
      appointmentRecordHistoryOfInjuryInsightsId?: string | null,
      appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
      appointmentRecordPhysicalExamInsightsId?: string | null,
      appointmentRecordPastInjuryMatrixId?: string | null,
      appointmentRecordBriefingId?: string | null,
      appointmentRecordIntroParagraphId?: string | null,
      appointmentRecordAssessmentId?: string | null,
      appointmentRecordAssessmentValidationId?: string | null,
      appointmentRecordOpinionRecapId?: string | null,
      appointmentRecordHistoryValidationId?: string | null,
      appointmentRecordPatientHistoryValidationId?: string | null,
      appointmentRecordMrrValidationId?: string | null,
      appointmentRecordHistoryMrrCrossValidationId?: string | null,
    },
    patientCase:  {
      __typename: "PatientCase",
      id: string,
      patientID: string,
      patient?:  {
        __typename: "Patient",
        id: string,
        name?: string | null,
        dateOfBirth?: string | null,
        SSN?: string | null,
        language?: Language | null,
        dominantHand?: DominantHand | null,
        cases?:  {
          __typename: "ModelPatientCaseConnection",
          nextToken?: string | null,
        } | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        occupation?: string | null,
        sex?: Sex | null,
        weightLb?: number | null,
        height?:  {
          __typename: "Height",
          feet?: number | null,
          inches?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      claimNumber: string,
      qmePanelNumber?: string | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      injuryInfo?:  {
        __typename: "InjuryInfo",
        injuryType?: InjuryType | null,
        injuredBodyParts?: Array< BodyPart | null > | null,
        claimedBodyParts?: Array< BodyPart | null > | null,
        description?: string | null,
        dateOfInjury?: string | null,
        dateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        startDateOfInjury?: string | null,
        startDateOfInjuryFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
      } | null,
      workersCompInsurance?:  {
        __typename: "WorkersCompInsuranceInfo",
        insuranceCarrier?: string | null,
        adjuster?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      insuranceCarrierID?: string | null,
      insuranceCarrier?:  {
        __typename: "InsuranceCarrier",
        id: string,
        name: string,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierAddressID?: string | null,
      insuranceCarrierAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierFaxNumberID?: string | null,
      insuranceCarrierFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      insuranceCarrierPhoneNumberID?: string | null,
      insuranceCarrierPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordPatientCaseConnection",
        items:  Array< {
          __typename: "AppointmentRecordPatientCase",
          id: string,
          appointmentRecordId: string,
          patientCaseId: string,
          createdAt: string,
          updatedAt: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      applicantAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyLawFirmID?: string | null,
      applicantAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyAddressID?: string | null,
      applicantAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyFaxNumberID?: string | null,
      applicantAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      applicantAttorneyPhoneNumberID?: string | null,
      applicantAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorney?:  {
        __typename: "AttorneyInfo",
        name?: string | null,
        lawFirmName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      defenseAttorneyLawFirmID?: string | null,
      defenseAttorneyLawFirm?:  {
        __typename: "LawFirm",
        id: string,
        name: string,
        type: LawFirmType,
        defaultAddressID?: string | null,
        defaultAddress?:  {
          __typename: "StoredAddress",
          id: string,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        addresses?:  {
          __typename: "ModelStoredAddressConnection",
          nextToken?: string | null,
        } | null,
        defaultFaxNumberID?: string | null,
        defaultFaxNumber?:  {
          __typename: "StoredFaxNumber",
          id: string,
          faxNumber?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        faxNumbers?:  {
          __typename: "ModelStoredFaxNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultPhoneNumberID?: string | null,
        defaultPhoneNumber?:  {
          __typename: "StoredPhoneNumber",
          id: string,
          phoneNumber?: string | null,
          extension?: string | null,
          insuranceCarrierID?: string | null,
          lawFirmID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        phoneNumbers?:  {
          __typename: "ModelStoredPhoneNumberConnection",
          nextToken?: string | null,
        } | null,
        defaultEmail?: string | null,
        supportedDomains?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyAddressID?: string | null,
      defenseAttorneyAddress?:  {
        __typename: "StoredAddress",
        id: string,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyFaxNumberID?: string | null,
      defenseAttorneyFaxNumber?:  {
        __typename: "StoredFaxNumber",
        id: string,
        faxNumber?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      defenseAttorneyPhoneNumberID?: string | null,
      defenseAttorneyPhoneNumber?:  {
        __typename: "StoredPhoneNumber",
        id: string,
        phoneNumber?: string | null,
        extension?: string | null,
        insuranceCarrierID?: string | null,
        lawFirmID?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nurseCaseManager?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      ccPerson?:  {
        __typename: "ContactPersonInfo",
        name?: string | null,
        organizationName?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
      } | null,
      applicantAttorneyCcEmails?: Array< string | null > | null,
      defenseAttorneyCcEmails?: Array< string | null > | null,
      adjusterCcEmails?: Array< string | null > | null,
      scheduledCommsSuppressedParties?: Array< InquiringParty | null > | null,
      employmentAtInjury?:  {
        __typename: "EmploymentRecord",
        employerName?: string | null,
        jobTitle?: string | null,
        contact?:  {
          __typename: "ContactInfo",
          phone?: string | null,
          phoneExtension?: string | null,
          email?: string | null,
          fax?: string | null,
          homePhoneNumber?: string | null,
        } | null,
        dateOfHire?: string | null,
        dateOfHireFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        hoursPerWeek?: string | null,
        jobDuties?: string | null,
        dateOfTermination?: string | null,
        dateOfTerminationFlexible?:  {
          __typename: "FlexibleDate",
          value?: string | null,
          precision: DatePrecision,
        } | null,
        notes?: string | null,
        stillWorkingHere?: boolean | null,
        type?: EmploymentType | null,
        currentWorkRestrictions?: string | null,
        workStatus?: string | null,
        departureReason?: string | null,
      } | null,
      WCAB?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    doctorOwnerCognitoId?: string | null,
    assistantCognitoIds?: string | null,
  } | null,
};

export type OnCreateDoctorLocationSubscriptionVariables = {
  filter?: ModelSubscriptionDoctorLocationFilterInput | null,
  ownerCognitoId?: string | null,
};

export type OnCreateDoctorLocationSubscription = {
  onCreateDoctorLocation?:  {
    __typename: "DoctorLocation",
    id: string,
    doctorId: string,
    locationId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    location:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type OnUpdateDoctorLocationSubscriptionVariables = {
  filter?: ModelSubscriptionDoctorLocationFilterInput | null,
  ownerCognitoId?: string | null,
};

export type OnUpdateDoctorLocationSubscription = {
  onUpdateDoctorLocation?:  {
    __typename: "DoctorLocation",
    id: string,
    doctorId: string,
    locationId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    location:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type OnDeleteDoctorLocationSubscriptionVariables = {
  filter?: ModelSubscriptionDoctorLocationFilterInput | null,
  ownerCognitoId?: string | null,
};

export type OnDeleteDoctorLocationSubscription = {
  onDeleteDoctorLocation?:  {
    __typename: "DoctorLocation",
    id: string,
    doctorId: string,
    locationId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    location:  {
      __typename: "Location",
      id: string,
      name?: string | null,
      abbreviation?: string | null,
      status?: LocationStatus | null,
      region?: Region | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        county?: string | null,
      } | null,
      indigoOfficePhoneNumber?: string | null,
      isWaitingArea?: boolean | null,
      additionalRoomsNumber?: number | null,
      landlordContactInfo?:  {
        __typename: "LocationLandlordContactInfo",
        name?: string | null,
        phone?: string | null,
        email?: string | null,
      } | null,
      calendarCcEmails?: Array< string | null > | null,
      isParkingFree?: boolean | null,
      parkingRate?: number | null,
      isFrontDoorLocked?: boolean | null,
      frontDoorCode?: string | null,
      backDoor?: BackDoorStatus | null,
      backDoorCode?: string | null,
      securityUnlockingProcess?: string | null,
      securityLockingProcess?: string | null,
      maleBathroomCode?: string | null,
      femaleBathroomCode?: string | null,
      wifiName?: string | null,
      wifiPassword?: string | null,
      defaultOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      secondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      locationInstructionsForVisitor?: string | null,
      additionalNote?: string | null,
      doctors?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      locationDefaultOnsiteOpsId?: string | null,
      locationSecondaryOnsiteOpsId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type OnCreateDoctorCaseSummaryFieldSubscriptionVariables = {
  filter?: ModelSubscriptionDoctorCaseSummaryFieldFilterInput | null,
  ownerCognitoId?: string | null,
};

export type OnCreateDoctorCaseSummaryFieldSubscription = {
  onCreateDoctorCaseSummaryField?:  {
    __typename: "DoctorCaseSummaryField",
    id: string,
    doctorId: string,
    caseSummaryFieldId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    caseSummaryField:  {
      __typename: "CaseSummaryField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      summaryPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type OnUpdateDoctorCaseSummaryFieldSubscriptionVariables = {
  filter?: ModelSubscriptionDoctorCaseSummaryFieldFilterInput | null,
  ownerCognitoId?: string | null,
};

export type OnUpdateDoctorCaseSummaryFieldSubscription = {
  onUpdateDoctorCaseSummaryField?:  {
    __typename: "DoctorCaseSummaryField",
    id: string,
    doctorId: string,
    caseSummaryFieldId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    caseSummaryField:  {
      __typename: "CaseSummaryField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      summaryPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type OnDeleteDoctorCaseSummaryFieldSubscriptionVariables = {
  filter?: ModelSubscriptionDoctorCaseSummaryFieldFilterInput | null,
  ownerCognitoId?: string | null,
};

export type OnDeleteDoctorCaseSummaryFieldSubscription = {
  onDeleteDoctorCaseSummaryField?:  {
    __typename: "DoctorCaseSummaryField",
    id: string,
    doctorId: string,
    caseSummaryFieldId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    caseSummaryField:  {
      __typename: "CaseSummaryField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      summaryPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type OnCreateDoctorBriefingFieldSubscriptionVariables = {
  filter?: ModelSubscriptionDoctorBriefingFieldFilterInput | null,
  ownerCognitoId?: string | null,
};

export type OnCreateDoctorBriefingFieldSubscription = {
  onCreateDoctorBriefingField?:  {
    __typename: "DoctorBriefingField",
    id: string,
    doctorId: string,
    briefingFieldId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    briefingField:  {
      __typename: "BriefingField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      briefingPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingRecordTypeID: string,
      recordType:  {
        __typename: "BriefingRecordType",
        id: string,
        name: string,
        recordType: RecordType,
        description?: string | null,
        default: boolean,
        classificationPrompt?: string | null,
        recordBasePrompt?: string | null,
        briefingFields?:  {
          __typename: "ModelBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type OnUpdateDoctorBriefingFieldSubscriptionVariables = {
  filter?: ModelSubscriptionDoctorBriefingFieldFilterInput | null,
  ownerCognitoId?: string | null,
};

export type OnUpdateDoctorBriefingFieldSubscription = {
  onUpdateDoctorBriefingField?:  {
    __typename: "DoctorBriefingField",
    id: string,
    doctorId: string,
    briefingFieldId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    briefingField:  {
      __typename: "BriefingField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      briefingPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingRecordTypeID: string,
      recordType:  {
        __typename: "BriefingRecordType",
        id: string,
        name: string,
        recordType: RecordType,
        description?: string | null,
        default: boolean,
        classificationPrompt?: string | null,
        recordBasePrompt?: string | null,
        briefingFields?:  {
          __typename: "ModelBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};

export type OnDeleteDoctorBriefingFieldSubscriptionVariables = {
  filter?: ModelSubscriptionDoctorBriefingFieldFilterInput | null,
  ownerCognitoId?: string | null,
};

export type OnDeleteDoctorBriefingFieldSubscription = {
  onDeleteDoctorBriefingField?:  {
    __typename: "DoctorBriefingField",
    id: string,
    doctorId: string,
    briefingFieldId: string,
    doctor:  {
      __typename: "Doctor",
      id: string,
      ownerCognitoId?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      name?: string | null,
      signatureName?: string | null,
      status?: DoctorStatus | null,
      ramped?: boolean | null,
      title?: string | null,
      titleExtension?: TitleExtension | null,
      contact?:  {
        __typename: "ContactInfo",
        phone?: string | null,
        phoneExtension?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          county?: string | null,
        } | null,
        fax?: string | null,
        homePhoneNumber?: string | null,
      } | null,
      officePhone?: string | null,
      cellPhone?: string | null,
      clinicPhone?: string | null,
      workCity?: string | null,
      workState?: string | null,
      collectionRate?: number | null,
      licenseNumber?: string | null,
      licenseRenewalDate?: string | null,
      qmeLicense?:  {
        __typename: "QmeLicense",
        licenseNumber?: string | null,
        approvalDate?: string | null,
        renewalDate?: string | null,
      } | null,
      locations?:  {
        __typename: "ModelDoctorLocationConnection",
        items:  Array< {
          __typename: "DoctorLocation",
          id: string,
          doctorId: string,
          locationId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      specialties?: Array< SpecialtyType | null > | null,
      npi?: string | null,
      bankingInfo?:  {
        __typename: "BankingInfo",
        bankEntityName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      appointments?:  {
        __typename: "ModelAppointmentRecordConnection",
        items:  Array< {
          __typename: "AppointmentRecord",
          id: string,
          doctorOwnerCognitoId?: string | null,
          assistantCognitoIds?: Array< string > | null,
          globalPartitionKey: string,
          originalAppointmentID: string,
          supplementalAppointmentIDs?: Array< string | null > | null,
          supplementalSourceAppointmentIDs?: Array< string | null > | null,
          depositionAppointmentIDs?: Array< string | null > | null,
          depositionSourceAppointmentIDs?: Array< string | null > | null,
          rescheduledFromAppointmentID?: string | null,
          rescheduledToAppointmentID?: string | null,
          date?: string | null,
          yearMonth?: string | null,
          doctorYearMonth?: string | null,
          time?: string | null,
          bookedInFlexibleTime?: boolean | null,
          inquiryDate: string,
          inquiryYearMonth: string,
          type?: AppointmentType | null,
          doctorID?: string | null,
          locationID?: string | null,
          visitForm?: string | null,
          active?: boolean | null,
          durationMinutes?: number | null,
          reportDue?: string | null,
          reportSubmitted?: string | null,
          status?: AppointmentStatus | null,
          reportStatus?: ReportStatus | null,
          paymentStatus?: PaymentStatus | null,
          billingStatus?: BillingStatus | null,
          difficultyLevel?: number | null,
          patientDescribedInjuries?: Array< BodyPart | null > | null,
          uploadedFilesSetID?: string | null,
          referredBy?: string | null,
          s3FileKey?: string | null,
          medicalRecordsReceived?: boolean | null,
          medicalRecordsBriefingFileID?: string | null,
          medicalRecordsBriefingExecutionArn?: string | null,
          medicalRecordsTotalPagesProcessed?: number | null,
          reportGenerationFileID?: string | null,
          reportGenerationExecutionArn?: string | null,
          reportGenerationGeneratedAt?: string | null,
          historyOfInjuryFileID?: string | null,
          historyOfInjuryGeneratedAt?: string | null,
          evaluationFileID?: string | null,
          assessmentFileID?: string | null,
          depositionPreparationFileID?: string | null,
          cancellationReason?: CancellationReason | null,
          cancellationRequestedBy?: ParticipantType | null,
          cancellationRequestedInternally?: boolean | null,
          cancellationNote?: string | null,
          cancellationDate?: string | null,
          inquiryClosingReason?: InquiryClosingReason | null,
          inquiryClosingNote?: string | null,
          inquiryClosingDate?: string | null,
          noShowReason?: NoShowReason | null,
          noShowNote?: string | null,
          reschedulingReason?: ReschedulingReason | null,
          reschedulingOthersReason?: string | null,
          reschedulingRequestedBy?: ParticipantType | null,
          reschedulingRequestedInternally?: boolean | null,
          reschedulingNote?: string | null,
          reschedulingDate?: string | null,
          historyCallDate?: string | null,
          historyCallTime?: string | null,
          historyCallCompleted?: boolean | null,
          historyCallCompletedWithoutRecords?: boolean | null,
          historyCallCompletedOnSite?: boolean | null,
          historyCallNoShow?: boolean | null,
          historyCallCalendarEventID?: string | null,
          historyCallCalendarLink?: string | null,
          isProd?: boolean | null,
          isDemo?: boolean | null,
          primaryPatientCaseID?: string | null,
          calendarEventID?: string | null,
          defenseAttorneyPagesDeclaration?: number | null,
          applicantAttorneyPagesDeclaration?: number | null,
          tempUploadedIntakeFormS3Keys?: Array< string | null > | null,
          panelUnavailable?: boolean | null,
          panelSpecialty?: SpecialtyType | null,
          defenseAttorneyNotPresent?: boolean | null,
          applicantAttorneyNotPresent?: boolean | null,
          videoCallLink?: string | null,
          caseID?: string | null,
          briefingModelVersion?: BriefingModelVersion | null,
          briefingGdocExportLink?: string | null,
          briefingGdocExportedAt?: string | null,
          createdAt: string,
          updatedAt: string,
          appointmentRecordMedicalAssistantId?: string | null,
          appointmentRecordSchedulingAssistantId?: string | null,
          appointmentRecordOnSiteOpId?: string | null,
          appointmentRecordReportOpId?: string | null,
          appointmentRecordBillingOpId?: string | null,
          appointmentRecordPreVisitReviewerId?: string | null,
          appointmentRecordHuddleNoteId?: string | null,
          appointmentRecordHistoryOfInjuryNotesId?: string | null,
          appointmentRecordCurrentComplaintNotesId?: string | null,
          appointmentRecordHistoryCallAssistantId?: string | null,
          appointmentRecordHistoryOfInjuryInsightsId?: string | null,
          appointmentRecordReviewOfMedicalRecordsInsightsId?: string | null,
          appointmentRecordPhysicalExamInsightsId?: string | null,
          appointmentRecordPastInjuryMatrixId?: string | null,
          appointmentRecordBriefingId?: string | null,
          appointmentRecordIntroParagraphId?: string | null,
          appointmentRecordAssessmentId?: string | null,
          appointmentRecordAssessmentValidationId?: string | null,
          appointmentRecordOpinionRecapId?: string | null,
          appointmentRecordHistoryValidationId?: string | null,
          appointmentRecordPatientHistoryValidationId?: string | null,
          appointmentRecordMrrValidationId?: string | null,
          appointmentRecordHistoryMrrCrossValidationId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      availabilities?:  {
        __typename: "Availabilities",
        generalAvailabilities?:  Array< {
          __typename: "GeneralAvailability",
          recurrence?: RecurrenceType | null,
          dayOfWeek?: DayOfWeek | null,
          dayOfMonth?: number | null,
          weekOfMonth?: WeekOfMonth | null,
          monthInterval?: number | null,
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        additionalAvailabilities?:  Array< {
          __typename: "AdditionalAvailability",
          startTime?: string | null,
          endTime?: string | null,
          locationIDs?: Array< string | null > | null,
          isAllLocations?: boolean | null,
        } | null > | null,
        blackoutDates?:  Array< {
          __typename: "BlackoutDate",
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
      } | null,
      availabilitiesNote?: string | null,
      emails?: Array< string | null > | null,
      profileImages?:  Array< {
        __typename: "DoctorProfileImage",
        type?: DoctorProfileImageType | null,
        name?: string | null,
        order?: number | null,
        s3Prefix?: string | null,
        widthInInches?: number | null,
        heightInInches?: number | null,
      } | null > | null,
      qmeReportConfigs?:  {
        __typename: "DoctorQMEReportConfigs",
        hasIntroTitle?: boolean | null,
        introTemplate?: string | null,
      } | null,
      physicalEvalConfigs?:  {
        __typename: "DoctorPhysicalEvalConfigs",
        templates?: Array< PhysicalEvalTemplateTag | null > | null,
      } | null,
      signatureDepartment?: string | null,
      profileAssetS3Prefix?: string | null,
      calendarPreference?:  {
        __typename: "CalendarPreference",
        mailingList?: Array< string | null > | null,
        showPatientFullName?: boolean | null,
        showPatientAddress?: boolean | null,
        showPatientDOB?: boolean | null,
        showPortalLink?: boolean | null,
      } | null,
      homeOffice?:  {
        __typename: "HomeOffice",
        county?: string | null,
        state?: string | null,
      } | null,
      reportFormatPreferences?:  {
        __typename: "ReportFormatPreferences",
        evaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        reEvaluationReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
        supplementalReport:  {
          __typename: "FormatPreferences",
          sections: Array< ReportSection >,
          assessmentSubSections: Array< ReportAssessmentSubSection >,
        },
      } | null,
      evaluationInputPreferences?:  {
        __typename: "EvaluationInputPreferences",
        evaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        reEvaluationReport:  {
          __typename: "ReportInputPreferences",
          history: ReportSource,
          physicalExamination: ReportSource,
          assessment: ReportSource,
        },
        supplementalReport:  {
          __typename: "SupplementalReportInputPreferences",
          assessment: ReportSource,
        },
      } | null,
      preferredAssessmentMode?: AssessmentMode | null,
      caseSummaryFields?:  {
        __typename: "ModelDoctorCaseSummaryFieldConnection",
        items:  Array< {
          __typename: "DoctorCaseSummaryField",
          id: string,
          doctorId: string,
          caseSummaryFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingFields?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        cognitoUserId: string,
        avatarUrl?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        doctor?:  {
          __typename: "Doctor",
          id: string,
          ownerCognitoId?: string | null,
          firstName?: string | null,
          middleName?: string | null,
          lastName?: string | null,
          name?: string | null,
          signatureName?: string | null,
          status?: DoctorStatus | null,
          ramped?: boolean | null,
          title?: string | null,
          titleExtension?: TitleExtension | null,
          officePhone?: string | null,
          cellPhone?: string | null,
          clinicPhone?: string | null,
          workCity?: string | null,
          workState?: string | null,
          collectionRate?: number | null,
          licenseNumber?: string | null,
          licenseRenewalDate?: string | null,
          specialties?: Array< SpecialtyType | null > | null,
          npi?: string | null,
          availabilitiesNote?: string | null,
          emails?: Array< string | null > | null,
          signatureDepartment?: string | null,
          profileAssetS3Prefix?: string | null,
          preferredAssessmentMode?: AssessmentMode | null,
          isDemo?: boolean | null,
          fieldTemplateId?: string | null,
          templateFolderLink?: string | null,
          assessmentTreatmentOptions?: Array< string | null > | null,
          dismissedProTips?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          doctorPhysicianPartnerId?: string | null,
          doctorDefaultPrimaryOnsiteOpsId?: string | null,
          doctorDefaultSecondaryOnsiteOpsId?: string | null,
          doctorDefaultSchedulerId?: string | null,
          doctorDefaultReportOpsId?: string | null,
          doctorDefaultPreVisitReviewerId?: string | null,
          doctorDefaultBillingOpsId?: string | null,
          doctorDefaultSupplementalReportOpsId?: string | null,
          doctorUserId?: string | null,
        } | null,
        assistant?:  {
          __typename: "MedicalAssistant",
          id: string,
          name?: string | null,
          email?: string | null,
          preVisitCallScheduleLink?: string | null,
          enableCalendarNotify?: boolean | null,
          inactive?: boolean | null,
          languages?: Array< Language > | null,
          isDemo?: boolean | null,
          dismissedProTips?: Array< string | null > | null,
          phoneNumber?: string | null,
          joinedDate?: string | null,
          level?: number | null,
          capacityPercent?: number | null,
          roles?: Array< OpsRole > | null,
          createdAt: string,
          updatedAt: string,
          medicalAssistantUserId?: string | null,
        } | null,
        appointmentFilterPreset?:  {
          __typename: "ModelUserAppointmentFilterPresetConnection",
          nextToken?: string | null,
        } | null,
        onboardingDismissals?:  Array< {
          __typename: "OnboardingDismissal",
          itemId: string,
          dismissedAt: string,
        } | null > | null,
        settings?:  {
          __typename: "UserSettings",
          opsChecklistDefaultExpanded?: boolean | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        userDoctorId?: string | null,
        userAssistantId?: string | null,
      } | null,
      isDemo?: boolean | null,
      fieldTemplateId?: string | null,
      templateFolderLink?: string | null,
      physicianPartner?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPrimaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSecondaryOnsiteOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultScheduler?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultPreVisitReviewer?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultBillingOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      defaultSupplementalReportOps?:  {
        __typename: "MedicalAssistant",
        id: string,
        name?: string | null,
        email?: string | null,
        preVisitCallScheduleLink?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          cognitoUserId: string,
          avatarUrl?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          createdAt: string,
          updatedAt: string,
          userDoctorId?: string | null,
          userAssistantId?: string | null,
        } | null,
        enableCalendarNotify?: boolean | null,
        inactive?: boolean | null,
        languages?: Array< Language > | null,
        assignmentCriteria?:  {
          __typename: "MedicalAssistantAppointmentAssignmentCriteria",
        } | null,
        isDemo?: boolean | null,
        dismissedProTips?: Array< string | null > | null,
        phoneNumber?: string | null,
        joinedDate?: string | null,
        level?: number | null,
        capacityPercent?: number | null,
        supportedDoctors?:  {
          __typename: "ModelDoctorSupportingMAConnection",
          nextToken?: string | null,
        } | null,
        supportedSpecialtyCategories?:  {
          __typename: "ModelMedicalAssistantSpecialtyCategoryConnection",
          nextToken?: string | null,
        } | null,
        availabilityExceptions?:  Array< {
          __typename: "AvailabilityException",
          type: AvailabilityExceptionType,
          startTime?: string | null,
          endTime?: string | null,
          allDay?: boolean | null,
        } | null > | null,
        roles?: Array< OpsRole > | null,
        createdAt: string,
        updatedAt: string,
        medicalAssistantUserId?: string | null,
      } | null,
      supplementalReportOpsAssignments?:  Array< {
        __typename: "SupplementalReportOpsAssignment",
        medicalAssistantID: string,
        weightPercentage: number,
      } | null > | null,
      supportingMAs?:  {
        __typename: "ModelDoctorSupportingMAConnection",
        items:  Array< {
          __typename: "DoctorSupportingMA",
          id: string,
          medicalAssistantId: string,
          doctorId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultAppointmentDurationMinutes?:  {
        __typename: "DefaultAppointmentDurationMinutes",
        qme?: number | null,
        qmeReevaluation?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      defaultEarlyArrivalTimeMinutes?:  {
        __typename: "DefaultEarlyArrivalTimeMinutes",
        workersComp?: number | null,
        ime?: number | null,
        deposition?: number | null,
      } | null,
      assessmentTreatmentOptions?: Array< string | null > | null,
      dismissedProTips?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      doctorPhysicianPartnerId?: string | null,
      doctorDefaultPrimaryOnsiteOpsId?: string | null,
      doctorDefaultSecondaryOnsiteOpsId?: string | null,
      doctorDefaultSchedulerId?: string | null,
      doctorDefaultReportOpsId?: string | null,
      doctorDefaultPreVisitReviewerId?: string | null,
      doctorDefaultBillingOpsId?: string | null,
      doctorDefaultSupplementalReportOpsId?: string | null,
      doctorUserId?: string | null,
    },
    briefingField:  {
      __typename: "BriefingField",
      id: string,
      name: string,
      default: boolean,
      description?: string | null,
      briefingPrompt?: string | null,
      doctors?:  {
        __typename: "ModelDoctorBriefingFieldConnection",
        items:  Array< {
          __typename: "DoctorBriefingField",
          id: string,
          doctorId: string,
          briefingFieldId: string,
          createdAt: string,
          updatedAt: string,
          ownerCognitoId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      briefingRecordTypeID: string,
      recordType:  {
        __typename: "BriefingRecordType",
        id: string,
        name: string,
        recordType: RecordType,
        description?: string | null,
        default: boolean,
        classificationPrompt?: string | null,
        recordBasePrompt?: string | null,
        briefingFields?:  {
          __typename: "ModelBriefingFieldConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    ownerCognitoId?: string | null,
  } | null,
};
